//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));

/**
 * @author evelina agostini
 * created on 11.05.2017
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.auth', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('logout', {
          url: '/logout',
          controller: "LogoutController"
        });
  }



})();

(function () {
	'use strict';

	var app = angular
		.module('AmwayAdmin.contabilita', [
			'ui.router',

			'AmwayAdmin.contabilita.fatture',
			'AmwayAdmin.contabilita.fatture2',
			'AmwayAdmin.contabilita.fattdacontrollare',
			'AmwayAdmin.contabilita.fattdacontrollareEE',
			'AmwayAdmin.contabilita.codiciiva',
			'AmwayAdmin.contabilita.causali',
			'AmwayAdmin.contabilita.liste',
			'AmwayAdmin.contabilita.pianoconti',
			'AmwayAdmin.contabilita.movimenti',
			'AmwayAdmin.contabilita.autofatture',
			'AmwayAdmin.contabilita.conti',
			'AmwayAdmin.contabilita.partiteaperte',
			'AmwayAdmin.contabilita.bilancio',
			'AmwayAdmin.contabilita.liquidazioneiva',
			'AmwayAdmin.contabilita.liquidazioneivamens',
			'AmwayAdmin.contabilita.fattelettr',
			'AmwayAdmin.contabilita.certunica',
			'AmwayAdmin.contabilita.stamparegistri',
			'AmwayAdmin.contabilita.rateirisconti',
			'AmwayAdmin.contabilita.chiusuraannuale'




		]);



	app.run(function ($rootScope, $cookies, $state) {



	})



})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  var app = angular
    .module('AmwayAdmin.pages', [
      'ui.router',

      'AmwayAdmin.pages.utenti',
      'AmwayAdmin.pages.news',
      'AmwayAdmin.pages.eventi',
      'AmwayAdmin.pages.opens',
      'AmwayAdmin.pages.autori',
      'AmwayAdmin.pages.speaker',
      'AmwayAdmin.pages.leader',
      'AmwayAdmin.pages.prodotti',
      'AmwayAdmin.pages.coefficienti',
      'AmwayAdmin.pages.moduli',
      'AmwayAdmin.pages.categorie',
      'AmwayAdmin.pages.ordini',
      'AmwayAdmin.pages.venue',
      'AmwayAdmin.pages.configurazione',
      'AmwayAdmin.pages.listini',
      'AmwayAdmin.pages.magazzino',
      'AmwayAdmin.pages.ordini-wes',
      'AmwayAdmin.pages.ordini-wes-onsite',
      'AmwayAdmin.pages.spedizioni',
    'AmwayAdmin.pages.dashboards',
        'AmwayAdmin.pages.faq',
        'AmwayAdmin.pages.faqtype',
        'AmwayAdmin.pages.videotaxonomy',

        'AmwayAdmin.pages.videos'

  
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider) {
    $urlRouterProvider.otherwise('/dashboards/vendite');
  }


app.run( function($rootScope, $cookies, $state, $timeout, $window){





            if($cookies.getObject("AMWAYuserLogged")){
                $rootScope.userLogged =  $cookies.getObject("AMWAYuserLogged");


                return;
            }


            console.log('definisco $rootScope.acl');
         
})



})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'AmwayAdmin.theme.components',
      'AmwayAdmin.theme.inputs'
  ]);

})();

/**
 * @author evelina agostini
 * created on 11.05.2017
 */
(function () {
  'use strict';

    angular.module('AmwayAdmin.utils', ['cb.x2js', 'ngPrintBlank', 'ngSanitize']);

 


})();

/**
 * @author evelina agostini
 * created on 11.05.2017
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.services', []);

 


})();

(function () {
    'use strict';
  
    angular.module('AmwayAdmin.contabilita.autofatture', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
      $stateProvider
      .state('contabilita.autofatture', {
            url: '/autofatture',
            templateUrl: 'app/contabilita/autofatture/autofatture.html',
            title: 'Autofatture Incaricati',
            controller: 'AutofattureCtrl',
            sidebarMeta: {
              order: 10
            },
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          });
    } 
  
  })();
  
(function () {
    'use strict';
  
    angular.module('AmwayAdmin.contabilita.bilancio', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
      $stateProvider
      .state('contabilita.bilancio', {
            url: '/bilancio-verifica',
            templateUrl: 'app/contabilita/bilancio/stampa-bilancio.html',
            title: 'Stampa Bilancio',
            controller: 'BilancioCtrl',
            sidebarMeta: {
              order: 1
            },
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          });
    } 
  
  })();
(function () {
    'use strict';
  
    angular.module('AmwayAdmin.contabilita.causali', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
      $stateProvider
      .state('contabilita.causali', {
            url: '/causali',
            templateUrl: 'app/contabilita/causali/causali.html',
            title: 'Causali',
            sidebarMeta: {
              order: 0,
              icon: 'ion-cash'
            },
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          }).state('edit-causalecontabile', {
            url: '/edit-causalecontabile/:id',
            templateUrl: 'app/contabilita/codiciiva/edit-causalecontabile.html',
            title: 'Scheda Causale Contabile',
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
            //controller: "CausaleContabileCtrl"
          }).state('edit-causalemagazzino', {
            url: '/edit-causalemagazzino/:id',
            templateUrl: 'app/contabilita/codiciiva/edit-causalemagazzino.html',
            title: 'Scheda Causale Magazzino',
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
            //controller: "CausaleMagazzinoCtrl"
          });
    } 
  
  })();
  
(function () {
    'use strict';
  
    angular.module('AmwayAdmin.contabilita.certunica', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
      $stateProvider
      .state('contabilita.certunica', {
            url: '/certificazioneunica',
            templateUrl: 'app/contabilita/certificazioneUnica/certificazioneUnica.html',
            title: 'Certificazione unica',
            controller : 'CertificazioneUnicaCtrl',
            sidebarMeta: {
              order: 0,
              icon: 'ion-cash'
            },
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          });
    } 
  
  })();
  
(function () {
    'use strict';

    angular.module('AmwayAdmin.contabilita.chiusuraannuale', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('contabilita.chiusuraannuale', {
                url: '/chiusuraannuale',
                templateUrl: 'app/contabilita/chiusuraAnnuale/chiusuraAnnuale.html',
                title: 'Chiusura annuale',
                controller: 'ChiusuraAnnualeCtrl',
                sidebarMeta: {
                    order: 0,
                    icon: 'ion-cash'
                },
                params: {
                    authRoles: ['contabilita']
                },
                onEnter: function ($stateParams, $rootScope) {
                    $rootScope.acl($stateParams.authRoles);
                }
            });
    }

})();
(function () {
    'use strict';
  
    angular.module('AmwayAdmin.contabilita.codiciiva', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
      $stateProvider
      .state('contabilita.codiciiva', {
            url: '/codiciiva',
            templateUrl: 'app/contabilita/codiciiva/codiciiva.html',
            title: 'Codici Iva',
            sidebarMeta: {
              order: 0,
              icon: 'ion-cash'
            },
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          }).state('edit-codiceiva', {
            url: '/edit-codiceiva/:id',
            templateUrl: 'app/contabilita/codiciiva/edit-codiceiva.html',
            title: 'Scheda Codice Iva',
            controller: "CodiceIvaCtrl",
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          })
          .state('nuovo-codiceiva', {
            url: '/nuovo-codiceiva/',
            templateUrl: 'app/contabilita/codiciiva/edit-codiceiva.html',
            title: 'Scheda Codice Iva',
            controller: "CodiceIvaCtrl",
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          });
  
  
  
  
  
    }
  
  
  
  })();
  
(function () {
    'use strict';
  
    angular.module('AmwayAdmin.contabilita.conti', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
      $stateProvider
      .state('contabilita.conti', {
            url: '/conti',
            templateUrl: 'app/contabilita/conti/conti.html',
            title: 'Conti',
            sidebarMeta: {
              order: 0,
              icon: 'ion-cash'
            },
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          });
    } 
  
  })();
  
(function () {
    'use strict';
  
    angular.module('AmwayAdmin.contabilita.fattdacontrollare', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
      $stateProvider
      .state('contabilita.fattdacontrollare', {
            url: '/fatturedacontrollare',
            templateUrl: 'app/contabilita/fattDaControllare/fattDaControllare.html',
            title: 'Fatture da controllare',
            controller : 'FattDaControllareCtrl',
            sidebarMeta: {
              order: 0,
              icon: 'ion-cash'
            },
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          });
    } 
  
  })();
  
(function () {
    'use strict';
  
    angular.module('AmwayAdmin.contabilita.fattelettr', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
      $stateProvider
      .state('contabilita.fattelettr', {
            url: '/fattureelpassive',
            templateUrl: 'app/contabilita/fattElettr/fattElettr.html',
            title: 'Fatt el passive',
            controller : 'FattElettrCtrl',
            sidebarMeta: {
              order: 0,
              icon: 'ion-cash'
            },
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          });
    } 
  
  })();
  
(function () {
	'use strict';

	angular.module('AmwayAdmin.contabilita.fattdacontrollareEE', [])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
			.state('contabilita.fattdacontrollareEE', {
				url: '/fatturedacontrollareee',
				templateUrl: 'app/contabilita/fattDaControllareEE/fattDaControllareEE.html',
				title: 'Fatture estere',
				controller: 'FattDaControllareEECtrl',
				sidebarMeta: {
					order: 0,
					icon: 'ion-cash'
				},
				params: {
					authRoles: ['contabilita']
				},
				onEnter: function ($stateParams, $rootScope) {
					$rootScope.acl($stateParams.authRoles);
				}
			});
	}

})();

(function () {
  'use strict';

  angular.module('AmwayAdmin.contabilita.fatture', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
    .state('contabilita', {
      template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
      abstract: true,
      title: 'Contabilità',
      sidebarMeta: {
        icon: 'ion-cash',
        order: 1
      },
      params: {
        authRoles: ['contabilita']
      }
    })
    .state('contabilita.fatture', {
          url: '/fatture',
          templateUrl: 'app/contabilita/fatture/fatture.html',
          controller: "FattureListCtrl",
          title: 'Fatture',
          sidebarMeta: {
            order: 0,
            icon: 'ion-cash'
          },
          params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
    .state('edit-fattura', {
          url: '/edit-fattura/:id',
          templateUrl: 'app/contabilita/fatture/edit-fattura.html',
          title: 'Scheda Fattura',
          controller: "FatturaCtrl",
          params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
    })
    .state('view-fattura', {
          url: '/fatture/dettaglio/:ntsid',
          templateUrl: 'app/contabilita/fatture/view-fattura.html',
          title: 'Dettaglio Fattura',
          controller: "FatturaCtrl",
          params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
    });

  }



})();

(function () {
  'use strict';

  angular.module('AmwayAdmin.contabilita.fatture2', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
    .state('contabilita.fatture2', {
          url: '/fatture2',
          templateUrl: 'app/contabilita/fatture2/fatture2.html',
          controller: "Fatture2ListCtrl",
          title: 'Fatture Nuova Vista',
          sidebarMeta: {
            order: 0,
            icon: 'ion-cash'
          },
          params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });

  }



})();
(function () {
    'use strict';
  
    angular.module('AmwayAdmin.contabilita.liquidazioneivamens', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
      $stateProvider
      .state('contabilita.liquidazioneivamens', {
            url: '/liquidazioneivamensile',
            templateUrl: 'app/contabilita/liquidazioneIVAmensile/liquidazioneIVAmensile.html',
            title: 'Liq. IVA Mensile',
            controller: 'LiquidazioneIvaMensCtrl',
            sidebarMeta: {
              order: 0
            },
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          });
    } 
  
  })();
(function () {
    'use strict';
  
    angular.module('AmwayAdmin.contabilita.liquidazioneiva', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
      $stateProvider
      .state('contabilita.liquidazioneiva', {
            url: '/liquidazioneiva',
            templateUrl: 'app/contabilita/liquidazioneIVA/liquidazioneIVA.html',
            title: 'Liq. IVA Corrente',
            controller: 'LiquidazioneIvaCtrl',
            sidebarMeta: {
              order: 0
            },
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          });
    } 
  
  })();
(function () {
    'use strict';
  
    angular.module('AmwayAdmin.contabilita.liste', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
      $stateProvider
      .state('contabilita.liste', {
            url: '/liste',
            templateUrl: 'app/contabilita/liste/liste.html',
            title: 'Liste e tipologie',
            sidebarMeta: {
              order: 0,
              icon: 'ion-cash'
            },
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          });
    } 
  
  })();
  
(function() {
  'use strict';

  angular
    .module('AmwayAdmin.contabilita.movimenti', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {

    $stateProvider
      .state( 'contabilita.ricerca', {
        url: '/ricercamovimenti',
        templateUrl: 'app/contabilita/movimenti/ricerca.html',
        controller: 'RicercaCtrl',
        title: 'Ricerca Movimenti',
        sidebarMeta: { 
          order: 10, 
          icon: 'ion-search'
        },
        params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
      }).state( 'contabilita.new-movimento', {
        url: '/new-movimento',
        templateUrl: 'app/contabilita/movimenti/edit-movimento.html',
        controller: 'MovimentoCtrl',
        title: 'Nuovo Movimento',
        sidebarMeta: { 
          order: 11
        },
        params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
      }).state( 'contabilita.edit-movimento', {
        url: '/edit-movimento/:id',
        templateUrl: 'app/contabilita/movimenti/edit-movimento.html',
        controller: 'MovimentoCtrl',
        title: 'Scheda Movimento',
        params: {
        	ricerca: null,
        	fromUrl: null,
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
      }).state( 'contabilita.nota-credito', {
        url: '/nota-credito/:orderid',
        templateUrl: 'app/contabilita/movimenti/edit-movimento.html',
        controller: 'MovimentoCtrl',
        title: 'Scheda Movimento',
        params: {
        	ricerca: null,
        	fromUrl: null,
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
      }).state( 'contabilita.ricercaiva', {
        url: '/ricercamovimentiiva',
        templateUrl: 'app/contabilita/movimenti/ricercaiva.html',
        controller: 'RicercaIVACtrl',
        title: 'Ricerca Mov. IVA',
        sidebarMeta: { 
          order: 10, 
          icon: 'ion-search'
        },
        params: {
          	authRoles: ['contabilita'],
          	moviva: true
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
      });
  }


}());

(function () {
    'use strict';
  
    angular.module('AmwayAdmin.contabilita.partiteaperte', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
      $stateProvider
      .state('contabilita.partiteaperte', {
            url: '/partiteaperte',
            templateUrl: 'app/contabilita/partiteaperte/list/partiteapertelist.html',
            title: 'Partite Aperte',
            controller: 'PartiteaperteCtrl',
            sidebarMeta: {
              order: 0,
              icon: 'ion-cash'
            },
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          });
    } 
  
  })();
(function () {
    'use strict';
  
    angular.module('AmwayAdmin.contabilita.rateirisconti', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
      $stateProvider
      .state('contabilita.rateirisconti', {
            url: '/ratei-risconti',
            templateUrl: 'app/contabilita/ratei-risconti/ratei-risconti.html',
            title: 'Ratei e Risconti',
            controller: 'RateiRiscontiCtrl',
            sidebarMeta: {
              order: 1
            },
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          });
    } 
  
  })();
(function () {
    'use strict';
  
    angular.module('AmwayAdmin.contabilita.pianoconti', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
      $stateProvider
      .state('contabilita.pianoconti', {
            url: '/pianoconti',
            templateUrl: 'app/contabilita/pianoconti/list/pianoconti.html',
            title: 'Piano dei conti',
            sidebarMeta: {
              order: 0,
              icon: 'ion-cash'
            },
            controller : "PianocontiListCtrl",
            params: {
          		authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          })
      .state('contabilita.pianoconti-edit', {
            url: '/pianoconti/edit/:id',
            templateUrl: 'app/contabilita/pianoconti/new-edit/form-pianoconti.html',
            title: 'Piano dei conti',
            controller : "PianocontiCtrl",
            params: {
          		authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          });
    } 
  
  })();
  
(function () {
    'use strict';
  
    angular.module('AmwayAdmin.contabilita.stamparegistri', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
      $stateProvider
      .state('contabilita.stamparegistri', {
            url: '/stampa-registri',
            templateUrl: 'app/contabilita/stampa-registri/stampa-registri.html',
            title: 'Stampa Registri',
            controller: 'StampaRegistriCtrl',
            sidebarMeta: {
              order: 1
            },
            params: {
          	authRoles: ['contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          });
    } 
  
  })();
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.autori', ['ui.select', 'ngSanitize'])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('web.autori', {
          url: '/autori',
          templateUrl: 'app/pages/autori/autori.html',
          controller: "AutoriCtrl",
          title: 'Autori',
          sidebarMeta: {
            order: 3,
            icon: 'ion-ios-person'
          },
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('nuovo-autore', {
          url: '/nuovo-autore',
          templateUrl: 'app/pages/autori/autore.html',
          title: 'Crea Autore',
          controller: "AutoreCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('modifica-autore', {
          url: '/modifica-autore/:id',
          templateUrl: 'app/pages/autori/autore.html',
          title: 'Modifica Autore',
          controller: "AutoreCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.chart', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('chart', {
          url: '/chart',
          templateUrl: 'app/pages/chart/chart.html',
          controller: "ChartCtrl",
          title: 'Chart',
          sidebarMeta: {
          	order: 3
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });
  }



})();

(function() {

  'use strict';

  angular
    .module('AmwayAdmin.pages.configurazione', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {

    $stateProvider
      .state('impostazioni', {
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Configurazione',
          sidebarMeta: {
            order: 1, 
          	icon: 'ion-gear-b'
          }
        })
      .state( 'impostazioni.configurazione', {
        url: '/configurazione',
        templateUrl: 'app/pages/configurazione/configurazione.html',
        controller: 'ConfigurazioneCtrl',
        title: 'Parametri',
        sidebarMeta: { 
          order: 10, 
          icon: 'ion-gear-b' 
        }
      })
      .state('modifica-configurazione', {
        url: '/configurazione/modifica/:id',
        templateUrl: 'app/pages/configurazione/form-configurazione.html',
        title: 'Modifica configurazione',
        controller: 'ConfigurazioneModificaCtrl'
      })
      ;
  }


}());
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.categorie', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {

    $stateProvider
        .state('catalogo.categorie', {
          url: '/categorie',
          templateUrl: 'app/pages/categorie/categorie.html',
          controller: "CategorieListCtrl",
          title: 'Categorie',
          sidebarMeta: {
            order: 1,
            icon: 'ion-ios-briefcase'
          },
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('modifica-categoria', {
          url: '/modifica-categoria/:id',
          templateUrl: 'app/pages/categorie/categoria.html',
          title: 'Scheda Categoria',
          controller: "CategoriaCtrl",
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('nuova-categoria', {
          url: '/nuova-categoria',
          templateUrl: 'app/pages/categorie/nuova-categoria.html',
          title: 'Nuova Categoria',
          controller: "CategoriaCtrl",
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });


  }



})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.coefficienti', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('impostazioni.coefficienti', {
          url: '/coefficienti',
          templateUrl: 'app/pages/coefficienti/coefficienti.html',
          controller: "CoefficientiCtrl",
          title: 'Coefficienti',
          sidebarMeta: {
          	order: 0
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('modifica-coefficientset', {
          url: '/modifica-coefficientset/:id',
          templateUrl: 'app/pages/coefficienti/coefficiente.html',
          title: 'Modifica gruppo coefficienti',
          controller: "CoefficienteCtrl",
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('nuovo-coefficientset', {
          url: '/nuovo-coefficientset',
          templateUrl: 'app/pages/coefficienti/coefficiente.html',
          title: 'Nuovo gruppo coefficienti',
          controller: "CoefficienteCtrl",
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });

  }



})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard', {
          url: '/dashboard',
          templateUrl: 'app/pages/dashboard/dashboard.html',
          title: 'Dashboard',
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 5,
          },
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          }
        });
  }

})();

(function () {
    'use strict';

    angular.module('AmwayAdmin.pages.faq', ['ui.select', 'ngSanitize'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('web.faq', {
                url: '/faq',
                templateUrl: 'app/pages/faq/list/faq-list.html',
                controller: "FaqListCtrl",
                title: 'Faq',
                sidebarMeta: {
                    order: 0,
                    icon: 'ion-star'
                },
                params: {
                    authRoles: ['web']
                },
                onEnter: function ($stateParams, $rootScope) {
                    $rootScope.acl($stateParams.authRoles);
                }
            })
            .state('new-edit-faq', {
                url: '/new-edit-faq/:id',
                templateUrl: 'app/pages/faq/new-edit/new-edit-faq.html',
                title: 'Faq',
                controller: "NewEditFaqCtrl",
                params: {
                    authRoles: ['web']
                },
                onEnter: function ($stateParams, $rootScope) {
                    $rootScope.acl($stateParams.authRoles);
                }
            });
            
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.eventi', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('web.eventi', {
          url: '/eventi',
          templateUrl: 'app/pages/eventi/eventi.html',
          controller: "EventiListCtrl",
          title: 'Eventi',
          sidebarMeta: {
            order: 1,
            icon: 'ion-ios-calendar'
          },
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('modifica-evento', {
          url: '/modifica-evento/:id',
          templateUrl: 'app/pages/eventi/evento.html',
          title: 'Scheda Evento',
          controller: "EventoCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('nuovo-evento', {
          url: '/nuovo-evento',
          templateUrl: 'app/pages/eventi/evento.html',
          title: 'Scheda Evento',
          controller: "EventoCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('duplica-evento', {
          url: '/duplica-evento/:id',
          templateUrl: 'app/pages/eventi/evento.html',
          params: {
            duplicate: true,
            authRoles: ['web']
          },
          title: 'Duplica Evento',
          controller: "EventoCtrl",
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });
;





  }



})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('AmwayAdmin.pages.dashboards', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('dashboards', {
                template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                title: 'Dashboards',
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 0
                },
                params: {
                    authRoles: []
                },
                onEnter: function ($stateParams, $rootScope) {
                    $rootScope.acl($stateParams.authRoles);
                }
            })
            .state('dashboards.vendite', {
                url: '/dashboards/vendite',
                templateUrl: 'app/pages/dashboards/vendite/dashboardVendite.html',
                controller: "DashboardVenditeCtrl",
                title: 'Dashboard Vendite',
                sidebarMeta: {
                    order: 0,
                    icon: 'ion-ios-calendar'
                },
                params: {
                    authRoles: []
                },
                onEnter: function ($stateParams, $rootScope) {
                    $rootScope.acl($stateParams.authRoles);
                }
            }).state('dashboards.range', {
                url: '/dashboards/range',
                templateUrl: 'app/pages/dashboards/range/dashboardRange.html',
                controller: "DashboardRangeCtrl",
                title: 'Dashboard Range',
                sidebarMeta: {
                    order: 0,
                    icon: 'ion-ios-calendar'
                },
                params: {
                    authRoles: []
                },
                onEnter: function ($stateParams, $rootScope) {
                    $rootScope.acl($stateParams.authRoles);
                }
            }).state('dashboards.cep', {
                url: '/dashboards/cep',
                templateUrl: 'app/pages/dashboards/cep/dashboardCep.html',
                controller: "DashboardCepCtrl",
                title: 'Dashboard CEP',
                sidebarMeta: {
                    order: 0,
                    icon: 'ion-ios-calendar'
                },
                params: {
                    authRoles: []
                },
                onEnter: function ($stateParams, $rootScope) {
                    $rootScope.acl($stateParams.authRoles);
                }
            }).state('dashboards.events', {
                url: '/dashboards/events',
                templateUrl: 'app/pages/dashboards/events/dashboardEvents.html',
                controller: "DashboardEventsCtrl",
                title: 'Dashboard Eventi',
                sidebarMeta: {
                    order: 0,
                    icon: 'ion-ios-calendar'
                },
                params: {
                    authRoles: []
                },
                onEnter: function ($stateParams, $rootScope) {
                    $rootScope.acl($stateParams.authRoles);
                }
            })
            .state('dashboards.tracks', {
                url: '/dashboards/tracks',
                templateUrl: 'app/pages/dashboards/tracks/dashboardTracks.html',
                controller: "DashboardTracksCtrl",
                title: 'Tracks',
                sidebarMeta: {
                    order: 0,
                    icon: 'ion-ios-calendar'
                },
                params: {
                    authRoles: []
                },
                onEnter: function ($stateParams, $rootScope) {
                    $rootScope.acl($stateParams.authRoles);
                }
            })
            .state('dashboards.shares', {
                url: '/dashboards/shares',
                templateUrl: 'app/pages/dashboards/shares/dashboardShares.html',
                controller: "DashboardSharesCtrl",
                title: 'Shares',
                sidebarMeta: {
                    order: 0,
                    icon: 'ion-ios-calendar'
                },
                params: {
                    authRoles: []
                },
                onEnter: function ($stateParams, $rootScope) {
                    $rootScope.acl($stateParams.authRoles);
                }
            })
            .state('dashboards.newusers', {
                url: '/dashboards/nuovi-utenti',
                templateUrl: 'app/pages/dashboards/nuovi-utenti/dashboardNewUsers.html',
                controller: "DashboardNewUsersCtrl",
                title: 'Nuovi utenti',
                sidebarMeta: {
                    order: 0,
                    icon: 'ion-ios-calendar'
                },
                params: {
                    authRoles: []
                },
                onEnter: function ($stateParams, $rootScope) {
                    $rootScope.acl($stateParams.authRoles);
                }
            })
            .state('dashboards.users', {
                url: '/dashboards/utenti',
                templateUrl: 'app/pages/dashboards/utenti/dashboardUtenti.html',
                controller: "DashboardUtentiCtrl",
                title: 'Distribuzione utenti',
                sidebarMeta: {
                    order: 0,
                    icon: 'ion-ios-calendar'
                },
                params: {
                    authRoles: []
                },
                onEnter: function ($stateParams, $rootScope) {
                    $rootScope.acl($stateParams.authRoles);
                }
            })
            /*.state('dashboards.prova', {
                url: '/dashboards/prova',
                templateUrl: 'app/pages/dashboards/prova/prova.html',
                controller: "ProvaCtrl",
                title: 'Nuovi utenti',
                sidebarMeta: {
                    order: 0,
                    icon: 'ion-ios-calendar'
                },
                params: {
                    authRoles: []
                },
                onEnter: function ($stateParams, $rootScope) {
                    $rootScope.acl($stateParams.authRoles);
                }
            })*/;





    }



})();

(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.leader', ['ui.select', 'ngSanitize'])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('web.leaders', {
          url: '/leaders',
          templateUrl: 'app/pages/leaders/leaders.html',
          controller: "LeadersCtrl",
          title: 'Leaders',
          sidebarMeta: {
            order: 0,
            icon: 'ion-star'
          },
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('nuovo-leader', {
          url: '/nuovo-leader',
          templateUrl: 'app/pages/leaders/leader.html',
          title: 'Crea Leader',
          controller: "LeaderCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('modifica-leader', {
          url: '/modifica-leader/:id',
          templateUrl: 'app/pages/leaders/leader.html',
          title: 'Modifica Leader',
          controller: "LeaderCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });

  }

})();

(function () {
    'use strict';

    angular.module('AmwayAdmin.pages.faqtype', ['ui.select', 'ngSanitize'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('impostazioni.faqtype', {
                url: '/faq-type',
                templateUrl: 'app/pages/faqtype/faqtype-list/faqtype-list.html',
                controller: "FaqTypeListCtrl",
                title: 'Tipi Faq',
                sidebarMeta: {
                    order: 0,
                    icon: 'ion-star'
                },
                params: {
                    authRoles: ['web']
                },
                onEnter: function ($stateParams, $rootScope) {
                    $rootScope.acl($stateParams.authRoles);
                }
            })
           /* .state('new-edit-faq', {
                url: '/new-edit-faq/:id',
                templateUrl: 'app/pages/faq/new-edit/new-edit-faq.html',
                title: 'Faq',
                controller: "NewEditFaqCtrl",
                params: {
                    authRoles: ['web']
                },
                onEnter: function ($stateParams, $rootScope) {
                    $rootScope.acl($stateParams.authRoles);
                }
            })*/;
            
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.listini', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('catalogo.listini', {
          url: '/listini',
          templateUrl: 'app/pages/listini/listini.html',
          controller: "ListiniListCtrl",
          title: 'Listini',
          sidebarMeta: {
            order: 2,
            icon: 'ion-document-text'
          },
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('modifica-listino', {
          url: '/modifica-listino/:id',
          templateUrl: 'app/pages/listini/listino.html',
          title: 'Modifica Listino',
          controller: "ListinoCtrl",
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('nuovo-listino', {
          url: '/nuovo-listino',
          templateUrl: 'app/pages/listini/listino.html',
          title: 'Nuovo Listino',
          controller: "ListinoCtrl",
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });

  };



})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.magazzino', ['focus-if'])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {

    $stateProvider
        .state('shop.magazzino', {
          url: '/magazzino',
          templateUrl: 'app/pages/magazzino/magazzino.html',
         controller: "MagazzinoCtrl",
          title: 'Magazzino',
          sidebarMeta: {
            order: 0,
            icon: 'ion-document-text'
          },
          params: {
          	authRoles: ['magazziniere', 'web', 'contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });






  }



})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.news', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('web.news', {
          url: '/news',
          templateUrl: 'app/pages/news/newsList.html',
          controller: "NewsListCtrl",
          title: 'News',
          sidebarMeta: {
            order: 0,
            icon: 'ion-pin'
          },
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('modifica-news', {
          url: '/modifica-news/:id',
          templateUrl: 'app/pages/news/news.html',
          title: 'Modifica News',
          controller: "NewsCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('nuova-news', {
          url: '/nuova-news',
          templateUrl: 'app/pages/news/news.html',
          title: 'Nuova News',
          controller: "NewsCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('duplica-news', {
          url: '/duplica-news/:id',
          templateUrl: 'app/pages/news/news.html',
          params: {
            duplicate: true,
            authRoles: ['web']
          },
          title: 'Duplica News',
          controller: "NewsCtrl",
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });
;





  }



})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.ordini-wes', ['focus-if'])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {

    $stateProvider
        .state('ordini-wes', {
          url: '/ordini-wes',
          templateUrl: 'app/pages/ordini-wes/ordini-wes.html',
         controller: "OrdiniWesCtrl",
          title: 'Ordini Wes',
          sidebarMeta: {
            order: 10,
            icon: 'ion-document-text'
          },
          params: {
          	authRoles: ['magazziniere', 'web', 'contabilita', 'wes']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });






  }



})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.opens', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
    .state('web', {
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Web',
          sidebarMeta: {
            icon: 'ion-ios-world',
            order: 1
          },
          params: {
          	authRoles: ['web']
          }
        })
        .state('web.opens', {
          url: '/opens',
          templateUrl: 'app/pages/opens/opens.html',
          controller: "OpensListCtrl",
          title: 'Opens',
          sidebarMeta: {
            order: 0,
            icon: 'ion-ios-calendar'
          },
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('modifica-open', {
          url: '/modifica-open/:id',
          templateUrl: 'app/pages/opens/open.html',
          title: 'Modifica Open',
          controller: "OpenCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('nuovo-open', {
          url: '/nuovo-open',
          templateUrl: 'app/pages/opens/open.html',
          title: 'Nuovo Open',
          controller: "OpenCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('duplica-open', {
          url: '/duplica-open/:id',
          templateUrl: 'app/pages/opens/open.html',
          params: {
            duplicate: true,
            authRoles: ['web']
          },
          title: 'Duplica Open',
          controller: "OpenCtrl",
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });
;





  }



})();

(function () {

	'use strict';

	angular
		.module('AmwayAdmin.pages.ordini', [])
		.config(routeConfig);

	function routeConfig($stateProvider, $urlRouterProvider) {

		$stateProvider
			.state('shop', {
				template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Shop',
				sidebarMeta: {
					icon: 'ion-android-cart',
					order: 1
				},
				params: {
					authRoles: ['magazziniere', 'web', 'contabilita']
				}
			}).state('shop.ordini', {
				url: '/ordini',
				templateUrl: 'app/pages/ordini/ordini.html',
				controller: 'OrdiniCtrl',
				title: 'Ordini',
				sidebarMeta: {
					order: 9,
					icon: 'ion-android-cart'
				},
				params: {
					authRoles: ['magazziniere', 'web', 'contabilita']
				},
				onEnter: function ($stateParams, $rootScope) {
					$rootScope.acl($stateParams.authRoles);
				}
			})
			.state('ordine', {
				url: '/ordine/:id',
				templateUrl: 'app/pages/ordini/ordine.html',
				controller: 'OrdineCtrl',
				title: 'Ordine',
				params: {
					authRoles: ['magazziniere', 'web', 'contabilita']
				},
				onEnter: function ($stateParams, $rootScope) {
					$rootScope.acl($stateParams.authRoles);
				}
			})
			.state('ordineutente', {
				url: '/ordine/:id/utente',
				templateUrl: 'app/pages/ordini/ordine.html',
				controller: 'OrdineCtrl',
				title: 'Ordine utente',
				params: {
					authRoles: ['magazziniere', 'web', 'contabilita']
				},
				onEnter: function ($stateParams, $rootScope) {
					$rootScope.acl($stateParams.authRoles);
				}
			})
			;
	};

}());
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.moduli', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('web.moduli', {
          url: '/moduli',
          templateUrl: 'app/pages/moduli/moduli.html',
          controller: "ModuliListCtrl",
          title: 'Moduli',
          sidebarMeta: {
            order: 0,
            icon: 'ion-document-text'
          },
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('modifica-modulo', {
          url: '/modifica-modulo/:id',
          templateUrl: 'app/pages/moduli/modulo.html',
          title: 'Modifica Modulo',
          controller: "ModuloCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('nuovo-modulo', {
          url: '/nuovo-modulo',
          templateUrl: 'app/pages/moduli/modulo.html',
          title: 'Nuovo Modulo',
          controller: "ModuloCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('duplica-modulo', {
          url: '/duplica-modulo/:id',
          templateUrl: 'app/pages/moduli/modulo.html',
          params: {
            duplicate: true,
            authRoles: ['web']
          },
          title: 'Duplica Modulo',
          controller: "ModuloCtrl",
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });
;





  }



})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.ordini-wes-onsite', ['focus-if'])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {

    $stateProvider
        .state('ordini-wes-onsite', {
          url: '/ordini-wes-onsite',
          templateUrl: 'app/pages/ordini-wes-onsite/ordini-wes.html',
         controller: "OrdiniWesOnsiteCtrl",
          title: 'Ordini Wes Session',
          sidebarMeta: {
            order: 10,
            icon: 'ion-document-text'
          },
          params: {
          	authRoles: ['magazziniere', 'web', 'contabilita', 'wes']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });






  }



})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.spedizioni', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {

    $stateProvider
        .state('shop.spedizioni', {
          url: '/spedizioni',
          templateUrl: 'app/pages/ordini/ordini.html',
          controller: "OrdiniCtrl",
          title: 'Spedizioni',
          sidebarMeta: {
            order: 0,
            icon: 'ion-document-text'
          },
          params: {
          	authRoles: ['magazziniere', 'web', 'contabilita']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });






  }



})();

(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.speaker', ['ui.select', 'ngSanitize'])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('web.speakers', {
          url: '/speakers',
          templateUrl: 'app/pages/speakers/speakers.html',
          controller: "SpeakersCtrl",
          title: 'Speakers',
          sidebarMeta: {
            order: 4,
            icon: 'ion-mic-c'
          },
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('nuovo-speaker', {
          url: '/nuovo-speaker',
          templateUrl: 'app/pages/speakers/speaker.html',
          title: 'Crea Speaker',
          controller: "SpeakerCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('modifica-speaker', {
          url: '/modifica-speaker/:id',
          templateUrl: 'app/pages/speakers/speaker.html',
          title: 'Modifica Speaker',
          controller: "SpeakerCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.venue', ['ui.select', 'ngSanitize'])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('web.sedi', {
          url: '/sedi',
          templateUrl: 'app/pages/venue/list/venueList.html',
          controller: "VenueListCtrl",
          title: 'Sedi',
          sidebarMeta: {
            order: 5,
            icon: 'ion-home'
          },
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('nuova-sede', {
          url: '/nuova-sede',
          templateUrl: 'app/pages/venue/new-edit/venue-form.html',
          title: 'Crea sede',
          controller: "VenueCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('modifica-sede', {
          url: '/modifica-sede/:id',
          templateUrl: 'app/pages/venue/new-edit/venue-form.html',
          title: 'Modifica sede',
          controller: "VenueCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });





  }



})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.prodotti', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {

    $stateProvider
    .state('catalogo', {
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Catalogo',
          sidebarMeta: {
            icon: 'ion-cube',
            order: 1
          },
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('catalogo.prodotti', {
          url: '/prodotti',
          templateUrl: 'app/pages/prodotti/prodotti.html',
          controller: "ProdottiListCtrl",
          title: 'Prodotti',
          sidebarMeta: {
            order: 0,
            icon: 'ion-cube'
          },
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('scheda-prodotto', {
          url: '/scheda-prodotto/:id',
          templateUrl: 'app/pages/prodotti/scheda-prodotto.html',
          title: 'Scheda Prodotto',
          controller: "ProdottiListCtrl",
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('nuovo-prodotto', {
          url: '/nuovo-prodotto',
          templateUrl: 'app/pages/prodotti/nuovo-prodotto.html',
          title: 'Nuovo Prodotto',
          controller: "ProdottoCtrl",
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('modifica-prodotto', {
          url: '/modifica-prodotto/:id',
          templateUrl: 'app/pages/prodotti/modifica-prodotto.html',
          title: 'Modifica Prodotto',
          controller: "ProdottoCtrl",
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('duplica-prodotto', {
          url: '/duplica-prodotto/:id',
          templateUrl: 'app/pages/prodotti/nuovo-prodotto.html',
          title: 'Duplica Prodotto',
          controller: "ProdottoCtrl",
          params: {
          	duplicate: true,
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('stampa-magazzino', {
          url: '/stampa-magazzino',
          templateUrl: 'app/pages/prodotti/printMagazzino.html',
         controller: "PrintMagazzinoCtrl",
          title: 'Stampa Magazzino',
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });





  }



})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.utenti', ['ui.select', 'ngSanitize', 'AmwayAdmin.services'])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
      .state('anagrafica', {
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Anagrafica',
          sidebarMeta: {
            icon: 'ion-ios-people',
            order: 1,
          },
           params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          }
        })
        .state('anagrafica.fornitori', {
          url: '/fornitori',
          templateUrl: 'app/pages/utenti/fornitori.html',
          title: 'Fornitori',
         // controller: "UtenteCtrl",
         sidebarMeta: {
            order: 3,
            icon: 'ion-ios-people'
          },
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('nuovo-fornitore', {
          url: '/nuovo-fornitore/:idel',
          templateUrl: 'app/pages/utenti/edit-fornitore.html',
          title: 'Nuovo Fornitore',
          controller: "FornitoreCtrl",
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('edit-fornitore', {
          url: '/edit-fornitore/:id',
          templateUrl: 'app/pages/utenti/edit-fornitore.html',
          title: 'Modifica Fornitore',
          controller: "FornitoreCtrl",
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('anagrafica.utenti', {
          url: '/utenti',
          templateUrl: 'app/pages/utenti/utenti.html',
          controller: "UtentiListCtrl",
          title: 'Utenti',
          params: {
            all: true,
			authRoles: ['contabilita', 'magazziniere', 'web'],
			type : 'utenti'
          },
          sidebarMeta: {
            order: 0,
            icon: 'ion-ios-people'
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('contabilita.anagraficacontabilita', {
          url: '/anagraficacontabilita',
          templateUrl: 'app/pages/utenti/utenti.html',
          controller: "UtentiListCtrl",
          title: 'Anagrafica',
          sidebarMeta: {
            order: 0,
            icon: 'ion-ios-people'
          },
          params: {
              authRoles: ['contabilita'],
              type: 'utenti'
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('dettagli-utente', {
          url: '/dettagli-utente/:id',
          templateUrl: 'app/pages/utenti/dettagli-utente.html',
          title: 'Scheda Utente',
          controller: "UtenteCtrl",
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('nuovo-utente', {
          url: '/nuovo-utente',
          templateUrl: 'app/pages/utenti/nuovo-utente.html',
          title: 'Crea utente',
          controller: "UtenteCtrl",
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('modifica-utente', {
          url: '/modifica-utente/:id',
          templateUrl: 'app/pages/utenti/modifica-utente.html',
          title: 'Modifica Utente',
          controller: "UtenteCtrl",
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('anagrafica.utentisicurezza', {
          url: '/utentisicurezza/:type',
          templateUrl: 'app/pages/utenti/utenti.html',
          controller: "UtentiListCtrl",
          title: 'Utenti Sicurezza',
          params: {
            all: true,
			authRoles: ['contabilita', 'magazziniere', 'web'],
			type : 'sicurezza'
          },
          sidebarMeta: {
            order: 0,
            icon: 'ion-ios-people'
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        })
        .state('anagrafica.utentiblacklist', {
            url: '/utentiblacklist/:type',
            templateUrl: 'app/pages/utenti/utenti.html',
            controller: "UtentiListCtrl",
            title: 'Blacklist',
            params: {
                all: true,
                authRoles: ['contabilita', 'magazziniere', 'web'],
                type: 'blacklist'
            },
            sidebarMeta: {
                order: 0,
                icon: 'ion-ios-people'
            },
            onEnter: function ($stateParams, $rootScope) {
                $rootScope.acl($stateParams.authRoles);
            }
        })
        .state('livelli', {
          url: '/livelli',
          templateUrl: 'app/pages/utenti/livelli.html',
          title: 'Livelli',
          controller: "LivelliCtrl",
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}/*,
          sidebarMeta: {
            order: 0,
            icon: 'ion-android-funnel',
          }*/
        })
        .state('livelliUtente', {
          url: '/livelli-utente/:id',
          templateUrl: 'app/pages/utenti/livelli.html',
          title: 'Livelli',
          controller: "LivelliCtrl",
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
          
        })
        .state('bonus', {
          url: '/bonus-utente/:id',
          templateUrl: 'app/pages/utenti/bonus.html',
          title: 'Bonus',
          controller: "BonusCtrl",
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}/*,
          sidebarMeta: {
            order: 0,
            icon: 'ion-android-funnel',
          }*/
        })
        .state('profileBonus', {
          url: '/bonus-utente/:id/:month/:year',
          templateUrl: 'app/pages/utenti/bonus.html',
          controller: 'BonusCtrl',
          params: {
          	authRoles: ['contabilita', 'magazziniere', 'web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });





  }



})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.videos', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
    .state('web.videos', {
          url: '/videos',
          templateUrl: 'app/pages/video/videos.html',
          controller: "VideoListCtrl",
          title: 'Video',
          sidebarMeta: {
            order: 0,
            icon: 'ion-ios-calendar'
          },
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('modifica-video', {
          url: '/modifica-video/:id',
          templateUrl: 'app/pages/video/video.html',
          title: 'Modifica Video',
          controller: "VideoCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        }).state('nuovo-video', {
          url: '/nuovo-video',
          templateUrl: 'app/pages/video/video.html',
          title: 'Nuovo Video',
          controller: "VideoCtrl",
          params: {
          	authRoles: ['web']
          },
          onEnter: function($stateParams, $rootScope) {
				$rootScope.acl($stateParams.authRoles);
			}
        });
  }

})();

(function () {
    'use strict';

    angular.module('AmwayAdmin.pages.videotaxonomy', ['ui.select', 'ngSanitize'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('impostazioni.videotaxonomy', {
                url: '/videotaxonomy',
                templateUrl: 'app/pages/videotaxonomy/videotaxonomy-list/videotaxonomy-list.html',
                controller: "VideotaxonomyListCtrl",
                title: 'Categorie video',
                sidebarMeta: {
                    order: 0,
                    icon: 'ion-star'
                },
                params: {
                    authRoles: ['web']
                },
                onEnter: function ($stateParams, $rootScope) {
                    $rootScope.acl($stateParams.authRoles);
                }
            });
            
    }

})();
/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme.inputs', []);

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme.components', []);

})();

(function () {
  'use strict';

  angular.module('ngPrintBlank', [])
    .config(routeConfig);

  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('print', {
          url: '/print',
          templateUrl: 'app/utils/elprint/elprint.template.html',
          controller: "ElPrintCtrl"
        });
  }
})();

'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "domenica",
      "luned\u00ec",
      "marted\u00ec",
      "mercoled\u00ec",
      "gioved\u00ec",
      "venerd\u00ec",
      "sabato"
    ],
    "ERANAMES": [
      "a.C.",
      "d.C."
    ],
    "ERAS": [
      "a.C.",
      "d.C."
    ],
    "FIRSTDAYOFWEEK": 0,
    "MONTH": [
      "gennaio",
      "febbraio",
      "marzo",
      "aprile",
      "maggio",
      "giugno",
      "luglio",
      "agosto",
      "settembre",
      "ottobre",
      "novembre",
      "dicembre"
    ],
    "SHORTDAY": [
      "dom",
      "lun",
      "mar",
      "mer",
      "gio",
      "ven",
      "sab"
    ],
    "SHORTMONTH": [
      "gen",
      "feb",
      "mar",
      "apr",
      "mag",
      "giu",
      "lug",
      "ago",
      "set",
      "ott",
      "nov",
      "dic"
    ],
    "STANDALONEMONTH": [
      "Gennaio",
      "Febbraio",
      "Marzo",
      "Aprile",
      "Maggio",
      "Giugno",
      "Luglio",
      "Agosto",
      "Settembre",
      "Ottobre",
      "Novembre",
      "Dicembre"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE d MMMM y",
    "longDate": "d MMMM y",
    "medium": "dd MMM y HH:mm:ss",
    "mediumDate": "dd MMM y",
    "mediumTime": "HH:mm:ss",
    "short": "dd/MM/yy HH:mm",
    "shortDate": "dd/MM/yy",
    "shortTime": "HH:mm"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "\u20ac",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": ".",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "\u00a0\u00a4",
        "posPre": "",
        "posSuf": "\u00a0\u00a4"
      }
    ]
  },
  "id": "it-it",
  "localeID": "it_IT",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

'use strict';

var app=angular.module('AmwayAdmin', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ui-notification',
  'ngTouch',
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',

  'AmwayAdmin.pages',
  'AmwayAdmin.auth',
  'AmwayAdmin.utils',
  'AmwayAdmin.services',
  'AmwayAdmin.theme',
  'AmwayAdmin.contabilita',
  'ngCookies',
  'angular-md5',
  'ngResource',
  'angularTrix',
  'ngFileUpload',
  'cp.ngConfirm',
  "angucomplete-alt",
  'ui.select',
  '720kb.tooltips',
  'mp.datePicker',
  'mm.iban',
  'angularUtils.directives.dirPagination',
  'vesparny.fancyModal',
  'ngConstants',
  'daterangepicker',
  'ui.mask',
  'cb.x2js',
  'ngFileSaver',
  'ngSanitize'
  ]);


app.run( function($rootScope, $cookies, $state,ENV, $window,  $timeout){
  
  $rootScope.deploydate=ENV.date;   

  var landings = {
  	amministratore: '/#!/dashboards/vendite',
  	contabilita: '/#!/utenti',
  	magazziniere: '/#!/utenti',
  	web: '/#!/utenti',
  	wes: '/#!/ordini-wes'
  };
      
  $rootScope.acl = function(authRoles) {
    if ($rootScope.userLogged) {
    var roles = authRoles ? authRoles : [];
      roles.push('amministratore');
      if (roles.indexOf($rootScope.userLogged.ntsrole) == -1) {
        $window.open(landings[$rootScope.userLogged.ntsrole], '_self');
      }
    } else {
      $timeout(function() {
        $state.go('logout');
      });
    }
    }
})
angular.module("ngConstants", [])

.constant("ENV", {
	"api": "https://api.network21.it/NTSAPI/v1/",
	"type": "prod",
	"date": "2024-12-12T11:55:22.799Z"
})

;
(function ()
{
    'use strict';

    angular
        .module('AmwayAdmin.auth')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($scope,md5,$state,$rootScope,$cookies, LoginService)
    {

		$scope.loginData = {};

		$scope.login = function() {

			if($scope.loginData && $scope.loginData.password)
			LoginService.login($scope.loginData.email, md5.createHash($scope.loginData.password)).$promise.then(function(r) {

				if (r.ntsrole == 'amministratore' || r.ntsrole == 'magazziniere' || r.ntsrole == 'web' || r.ntsrole == 'contabilita' || r.ntsrole == 'wes') {
					$rootScope.userLogged = r;
					$cookies.putObject("AMWAYuserLogged", $rootScope.userLogged);
					$scope.message = '';
					$state.go("dashboards.vendite");

				} else {
					$scope.message = 'Accesso non consentito';
				}
			}, function(e) {
				console.log(e);
				$scope.message = e && e.data && e.data.msg ? e.data.msg : 'Errore login';
			});


		}
      

  }
})();

angular.module('AmwayAdmin.auth').factory('LoginService', function($resource, DataConnectorService) {

	var response = {};






	response.login= function(email, password) {
        return DataConnectorService
          .getResource('user/login')
          .post({username: email, password: password, env: 'back'});
      }


	return response;

});
(function ()
{
    'use strict';

    angular
        .module('AmwayAdmin.auth')
        .controller('LogoutController', LogoutController);

    /** @ngInject */
    function LogoutController($scope,md5,$state,$rootScope, $cookies, LoginService)
    {
        
    	console.log('LogoutController');
						
        	  $rootScope.userLogged = undefined;
        	  $cookies.remove('AMWAYuserLogged');
             $state.go("dashboards.vendite");
        

    }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('AmwayAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('AmwayAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
angular
	.module('AmwayAdmin.utils')
	.filter('abs', function () {
  		return function(val) {
    		return Math.abs(val);
  		}
	});
'use strict';

angular.module('AmwayAdmin.utils').directive('autoSlash',[function(){
            return {
                require : 'ngModel',
                link : function(scope, iElement, iAttribute, ngModelController){
                	console.log("dio down");
                    iElement.on('keydown',function(e){
                        var key = e.keyCode;
                        if(key === 8){ /* If backspace is pressed*/
                            if(this.value.length === 3 || this.value.length === 6){
                                /*if next char to be removed is /' remove last two characters from input value*/
                                this.value = this.value.substr(0, this.value.length-1);
                            }
                            /*remove last character*/
                            this.value = this.value.substr(0, this.value.length);
                        }
                        /*if key pressed is not number or input got date*/
                        else if( !((key > 47 && key < 58) || (key > 95 && key < 106)) 
                                    || this.value.length === 10){
                            e.preventDefault(); //no nothing
                        }
                    });

                    function autoSlash(veiwvalue){
                        if(veiwvalue.length === 2 || veiwvalue.length === 5){
                            veiwvalue += '/';
                        }
                        ngModelController.$setViewValue(veiwvalue);
                        ngModelController.$render(); //change DOM
                        if(veiwvalue.length === 10){
                            return veiwvalue;
                        }
                    }

                    ngModelController.$parsers.push(autoSlash);
                }
            };
        }]);
'use strict';

angular.module('AmwayAdmin.utils').directive("cf", function () {
	return {
		restrict: "A",
		require: "ngModel",
		link: function(scope, element, attr, mCtrl) {

			function controlloCF(cf)
			{
				var okchar, i, s, set1, set2, setpari, setdisp;

				if(!cf || cf == '') {
					mCtrl.$setValidity('cf',true);
					mCtrl.$setPristine(true);
					return cf;
				}
				if(cf.length != 16 ) {
					mCtrl.$setValidity('cf', false);
					return cf;
				}

				cf = cf.toUpperCase();

				okchar = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
				for( i = 0; i < 16; i++ ){
					if( okchar.indexOf( cf.charAt(i) ) == -1 ) {
						mCtrl.$setValidity('cf', false);
						return cf;
					}			
				}

				set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
				set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
				setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
				setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
				s = 0;
				for( i = 1; i <= 13; i += 2 )
					s += setpari.indexOf( set2.charAt( set1.indexOf( cf.charAt(i) )));
				for( i = 0; i <= 14; i += 2 )
					s += setdisp.indexOf( set2.charAt( set1.indexOf( cf.charAt(i) )));
				if( s%26 != cf.charCodeAt(15)-'A'.charCodeAt(0))
				{
					mCtrl.$setValidity('cf', false);
					return cf;
				}
				else
				{
					mCtrl.$setValidity('cf', true);
					return cf;
				}

				return cf;
			}
			mCtrl.$parsers.push(controlloCF);
		}
	};
});




angular.module('AmwayAdmin.utils').factory('ConstantsService', function(DataConnectorService, $http, FileSaver) {

var response={};

	response.getProvince = function(){
		var config={isArray: true};
		return DataConnectorService.getResource('province',{},config).get();
     
	}


	response.getComuni= function(id){
			var config={isArray: true};

		return DataConnectorService.getResource('comuni/filter/pid/:id/range/0/1000',{id: id}, config).get();
     
	}

	response.getProvinciaDaSigla= function(sigla){
			var config={isArray: true};
		return DataConnectorService.getResource('province/filter/sigla/:sigla/range/0/1',{sigla: sigla}, config).get();
	}


	response.getProvinciaDaDescr= function(desc){
		var config={isArray: true};
		return DataConnectorService.getResource('province/search',{}, config).post({search: desc});
	}



	response.getCountryDaDescr= function(desc){
		var config={isArray: true};
		return DataConnectorService.getResource('country/search',{}, config).post({search: desc});
     
	}


	response.getComuneDaDescr= function(desc){
		var config={isArray: true};
		return DataConnectorService.getResource('comuni/search',{}, config).post({search: desc});
     
	}

	response.getCountries = function () {
		var config = { isArray: true };
		return DataConnectorService.getResource('country', {}, config).get();

	}

	response.advancedExport = function(p, field){

			var baseUrl = DataConnectorService.getBaseUrl();
			var headers = DataConnectorService.getHeaders();
           return $http({
              url : baseUrl+field+'/advancedexport/0/100000',
              method : 'POST',
              data : p,
              headers : headers,
          responseType : 'arraybuffer'
          }).then(function(response) {
          	console.log(response);
               //TODO when WS success
              var file = new Blob([ response.data ], {
                  type : 'text/csv'
              });
              //trick to download store a file having its URL
              FileSaver.saveAs(file, field+"-export.csv");
          },function(error){
              //TODO when WS error
          });

        }


	

	return response;

});
// https://d3js.org/d3-hierarchy/ Version 1.1.5. Copyright 2017 Mike Bostock.
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
}(this, (function (exports) { 'use strict';

function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

var cluster = function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
};

function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

var node_count = function() {
  return this.eachAfter(count);
};

var node_each = function(callback) {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
};

var node_eachBefore = function(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
};

var node_eachAfter = function(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
};

var node_sum = function(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
};

var node_sort = function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
};

var node_path = function(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
};

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}

var node_ancestors = function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
};

var node_descendants = function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
};

var node_leaves = function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
};

var node_links = function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
};

function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: node_count,
  each: node_each,
  eachAfter: node_eachAfter,
  eachBefore: node_eachBefore,
  sum: node_sum,
  sort: node_sort,
  path: node_path,
  ancestors: node_ancestors,
  descendants: node_descendants,
  leaves: node_leaves,
  links: node_links,
  copy: node_copy
};

var slice = Array.prototype.slice;

function shuffle(array) {
  var m = array.length,
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}

var enclose = function(circles) {
  var i = 0, n = (circles = shuffle(slice.call(circles))).length, B = [], p, e;

  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;
    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
  }

  return e;
};

function extendBasis(B, p) {
  var i, j;

  if (enclosesWeakAll(p, B)) return [p];

  // If we get here then B must have at least one element.
  for (i = 0; i < B.length; ++i) {
    if (enclosesNot(p, B[i])
        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
      return [B[i], p];
    }
  }

  // If we get here then B must have at least two elements.
  for (i = 0; i < B.length - 1; ++i) {
    for (j = i + 1; j < B.length; ++j) {
      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
          && enclosesNot(encloseBasis2(B[i], p), B[j])
          && enclosesNot(encloseBasis2(B[j], p), B[i])
          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
        return [B[i], B[j], p];
      }
    }
  }

  // If we get here then something is very wrong.
  throw new Error;
}

function enclosesNot(a, b) {
  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}

function enclosesWeak(a, b) {
  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function enclosesWeakAll(a, B) {
  for (var i = 0; i < B.length; ++i) {
    if (!enclosesWeak(a, B[i])) {
      return false;
    }
  }
  return true;
}

function encloseBasis(B) {
  switch (B.length) {
    case 1: return encloseBasis1(B[0]);
    case 2: return encloseBasis2(B[0], B[1]);
    case 3: return encloseBasis3(B[0], B[1], B[2]);
  }
}

function encloseBasis1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function encloseBasis2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function encloseBasis3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = x1 - x2,
      a3 = x1 - x3,
      b2 = y1 - y2,
      b3 = y1 - y3,
      c2 = r2 - r1,
      c3 = r3 - r1,
      d1 = x1 * x1 + y1 * y1 - r1 * r1,
      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (r1 + xa * xb + ya * yb),
      C = xa * xa + ya * ya - r1 * r1,
      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
  return {
    x: x1 + xa + xb * r,
    y: y1 + ya + yb * r,
    r: r
  };
}

function place(a, b, c) {
  var ax = a.x,
      ay = a.y,
      da = b.r + c.r,
      db = a.r + c.r,
      dx = b.x - ax,
      dy = b.y - ay,
      dc = dx * dx + dy * dy;
  if (dc) {
    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
    c.x = ax + x * dx + y * dy;
    c.y = ay + x * dy - y * dx;
  } else {
    c.x = ax + db;
    c.y = ay;
  }
}

function intersects(a, b) {
  var dx = b.x - a.x,
      dy = b.y - a.y,
      dr = a.r + b.r;
  return dr * dr - 1e-6 > dx * dx + dy * dy;
}

function score(node) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab,
      dy = (a.y * b.r + b.y * a.r) / ab;
  return dx * dx + dy * dy;
}

function Node$1(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n, aa, ca, i, j, k, sj, sk;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node$1(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Compute the new closest circle pair to the centroid.
    aa = score(a);
    while ((c = c.next) !== b) {
      if ((ca = score(c)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

var siblings = function(circles) {
  packEnclose(circles);
  return circles;
};

function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}

function constantZero() {
  return 0;
}

var constant = function(x) {
  return function() {
    return x;
  };
};

function defaultRadius(d) {
  return Math.sqrt(d.value);
}

var index = function() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = constantZero;

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius))
          .eachAfter(packChildren(constantZero, 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = optional(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : constant(+x), pack) : padding;
  };

  return pack;
};

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = packEnclose(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}

var roundNode = function(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
};

var treemapDice = function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
};

var partition = function() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(roundNode);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
};

var keyPrefix = "$";
var preroot = {depth: -1};
var ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

var stratify = function() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new Node(d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = required(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = required(x), stratify) : parentId;
  };

  return stratify;
};

function defaultSeparation$1(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(Node.prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
var tree = function() {
  var separation = defaultSeparation$1,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
};

var treemapSlice = function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
};

var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

var squarify = ((function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
}))(phi);

var index$1 = function() {
  var tile = squarify,
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = constantZero,
      paddingTop = constantZero,
      paddingRight = constantZero,
      paddingBottom = constantZero,
      paddingLeft = constantZero;

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(roundNode);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = required(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant(+x), treemap) : paddingLeft;
  };

  return treemap;
};

var binary = function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
};

var sliceDice = function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
};

var resquarify = ((function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
}))(phi);

exports.cluster = cluster;
exports.hierarchy = hierarchy;
exports.pack = index;
exports.packSiblings = siblings;
exports.packEnclose = enclose;
exports.partition = partition;
exports.stratify = stratify;
exports.tree = tree;
exports.treemap = index$1;
exports.treemapBinary = binary;
exports.treemapDice = treemapDice;
exports.treemapSlice = treemapSlice;
exports.treemapSliceDice = sliceDice;
exports.treemapSquarify = squarify;
exports.treemapResquarify = resquarify;

Object.defineProperty(exports, '__esModule', { value: true });

})));

angular.module('AmwayAdmin.utils').factory('DataConnectorService', function($resource, $rootScope, ENV) {

		console.log(ENV.type);
	var response = {};
	var baseUrl = ENV.api;//"https://api.network21.it/NTSAPI/v1/";
	//var baseUrl = "https://apidev.network21.it/NTSAPI/v1/";

	var mediaBaseUrl = "https://nts-public.s3-accelerate.amazonaws.com/";
	var previewBaseUrl = ENV.type=='prod' ? "https://static.network21.it/" : "https://devstatic.network21.it/";


	headers = {
	  
	};

	response.getHeaders = function(){
	if ($rootScope.userLogged){
		headers.apitoken = $rootScope.userLogged.apitoken;
		headers['Content-Type']= 'application/json';

	}

	headers['x-nts-client'] = 'backoffice';
	return headers;
	}


	response.getBaseUrl = function(){
		return baseUrl;
	}

	response.getMediaBaseUrl = function(){
		return mediaBaseUrl;
	}

	response.getPreviewBaseUrl = function(){
		return previewBaseUrl;
	}

	response.getResource = function(url, params, config){
		if(!config){
			config={};
		}
		response.getHeaders();
		return $resource(baseUrl+url,params,
      		{
	  			post: {
		            method: 'POST',
		            headers: headers,
		            isArray: config.isArray

		         
		      },
		      get: {
		            method: 'GET',
		            headers: headers,
		            isArray: config.isArray
		         
		       },
		      put: {
		            method: 'PUT',
		            headers: headers
		       },
		      delete: {
		            method: 'DELETE',
		            headers: headers		         
		       }
		      
		});

	}




	return response;

});

angular.module('AmwayAdmin.utils').directive('date2str', function () {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (scope, element, attrs, ngModel) {

			// console.log(attrs);
			if (ngModel) { // Don't do anything unless we have a model

				ngModel.$parsers.push(function (value) {
					if (value) {
						if (attrs.forcetime == "midday") {
							value.setHours(12, value.getMinutes(), value.getSeconds(), 0);
						}

						if (attrs.forcetime == "down") {
							value.setHours(0, 0, 0, 0);
						}
						if (attrs.forcetime == "up") {
							value.setHours(23, 59, 59, 0);
						}


						var str = '' + (value.getTime() / 1000).toFixed(0);
						while (str.length < 10)
							str = '0' + str;
						return str;
					}
					else return value;
				});

				ngModel.$formatters.push(function (value) {
					if (value) {
						var intMillis = parseInt(value) * 1000;
						var date = new Date(intMillis);
						return date;
					}
					else return value;
				});

			}
		}
	};
});
angular.module('AmwayAdmin.utils').directive('float2int', function() {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope, element, attrs, ngModel) {
			// console.log(attrs);
			var decimals=2;
			if (attrs.decimals){
				decimals=attrs.decimals;
			}
			if (ngModel) { // Don't do anything unless we have a model

				//      ngModel.$parsers.push(function (value) {
				//      	if(value){

				// // allow insert decimal num as per Italian convention
				//      	value = value.replace(',', '.');
				//      	// end replace

				//        return parseInt(value*100);
				//      	}
				//      	else return value;
				//      });
				ngModel.$parsers.push(function(value) {
					if (value) {
						return parseInt(Math.round(parseFloat((value).replace(",", ".")) * Math.pow(10,decimals)));
					} else return value;
				});

				ngModel.$formatters.push(function(value) {
					if (value) {
						// OUTPUT decimal num as per Italian convention
						return parseFloat(value / Math.pow(10,decimals)).toFixed(decimals).replace('.', ',');
					} else return value;
				});
				//    ngModel.$formatters.push(function (value) {
				//    	if(value){
				//      return parseFloat(value/100).toFixed(2);
				// }
				//    	else return value;
				//    });

			}
		}
	};
});
angular.module('AmwayAdmin.utils').directive('d3Hierarchy', function () {
  return {
    scope: {
      d3Hierarchy: '=',
      width: '=?',
      height: '=?',
      depth: '=?'
    },
    restrict: 'AE',
    controller: function ($scope, $element, $location) {
      $scope.refresh = function () {

        var svg = $scope.svg, 
            g = svg.append('g'),
            yscale = 2.5,
            duration = 300;

        svg.call(
          d3.behavior.zoom()
            .translate([0, 0])
            .scale(1)
            .scaleExtent([1 / 2, 8])
            .on("zoom", function() {
              g.attr("transform", 'translate(' + d3.event.translate + ') scale(' + d3.event.scale + ')');
            })
        );

        var diagonal = d3.svg.diagonal()
          .projection(function(d) { return [d.y, d.x]; });

        var tree = d3.layout.tree()
          //.size([$scope.width || 800, $scope.height || 800])
          .size([1280, 1280])
          ;

        var root = d3.hierarchy($scope.d3Hierarchy);

        tree(root);

        root.x0 = 400;
        root.y0 = 0;

        // Uncomment to start with a collapsed tree

        /*function collapse(d) {
          if (d.children) {
            d._children = d.children;
            d._children.forEach(collapse);
            d.children = null;
          }
        }
        root.children.forEach(collapse)*/

        function click(d) {

          if (d.children) {
            d._children = d.children;
            d.children = null;
          } else {
            d.children = d._children;
            d._children = null;
          }
          update(d);
        }

        var i = 0;

        function update(source) {
          var nodes = tree.nodes(root),
              links = tree.links(nodes);

          nodes.forEach(function(d) { d.y = d.depth * 180; });

          var node = g
            .selectAll('.node')
            .data(nodes, function(d) { return d.id || (d.id = ++i) });

          var nodeEnter = node.enter().append("g")
              .attr("class", "node")
              .attr("transform", function(d) { return "translate(" + source.y0 + "," + source.x0 + ")"; })
              ;

          nodeEnter.append("circle")
              .attr("r", 1e-6)
              .style('cursor', 'pointer')
              .style("fill", function(d) { return d._children ? "lightsteelblue" : "#fff"; })
              .on("click", click);

          nodeEnter.append("text")
              .attr("x", function(d) { return d.children || d._children ? -10 : 10; })
              .attr("dy", ".35em")
              .attr("text-anchor", function(d) { return d.children || d._children ? "end" : "start"; })
              .style("fill-opacity", 1e-6)
              .style('cursor', 'pointer')
              //.append('a')
              //.attr('xlink:href', function(d) { console.log(d); return '#!/modifica-utente/' + d.data.id })
              .text(function(d) { return d.data.name; })
              .on('click', function(d) {
                $scope.$apply(function() {

                  $location.path('/modifica-utente/' + d.data.id);
                })
              })
              ;

          var nodeUpdate = node.transition()
              .duration(duration)
              .attr("transform", function(d) { return "translate(" + d.y + "," + d.x + ")"; });

          nodeUpdate.select("circle")
              .attr("r", 8)
              .style("fill", function(d) { return d._children ? "lightsteelblue" : "#fff"; });

          nodeUpdate.select("text")
              .style("fill-opacity", 1);

          var nodeExit = node.exit().transition()
              .duration(duration)
              .attr("transform", function(d) { return "translate(" + source.y + "," + source.x + ")"; })
              .remove();

          nodeExit.select("circle")
              .attr("r", 1e-6);

          nodeExit.select("text")
              .style("fill-opacity", 1e-6);

          var link = g.selectAll("path.link")
              .data(links, function(d) { return d.target.id; });

          link.enter().insert("path", "g")
              .attr("class", "link")
              .attr("d", function(d) {
                var o = {x: source.x0, y: source.y0};
                return diagonal({source: o, target: o});
              });

          link.transition()
              .duration(duration)
              .attr("d", diagonal);

          link.exit().transition()
              .duration(duration)
              .attr("d", function(d) {
                var o = {x: source.x, y: source.y};
                return diagonal({source: o, target: o});
              })
              .remove();

          nodes.forEach(function(d) {
            d.x0 = d.x;
            d.y0 = d.y;
          });

        }

        update(root);

      };

      $scope.$watch('d3Hierarchy', $scope.refresh);
    },
    link: function ($scope, $element) {
      $element.addClass('d3Hierarchy');

      function resize() {

        var bcr = $element[0].getBoundingClientRect(),
            width = bcr.width,
            height = width;

        $element.css('height', height + 'px');
        $scope.svg.attr('width', width).attr('height', height);
      }

      window.addEventListener('resize', resize);

      $scope.$on('$destroy', function() {
        window.removeEventListener('resize', resize);
      });

      $scope.svg = d3.select($element[0]).append("svg")
        //.attr('width', $scope.width || 1280)
        //.attr('height', $scope.height || 1280)
        .attr('viewBox', '-128 -128 1508 1508')
        .attr('xmlns:xlink', 'http://www.w3.org/1999/xlink');

      resize();
    }
  }
});

angular
	.module('AmwayAdmin.utils')
	.directive('myEnter', function() {
	    return function($scope, $element, $attrs) {
	        $element.bind("keydown keypress", function(event) {
	            if (event.which === 13) {
	                $scope.$apply(function() {
	                    $scope.$eval($attrs.myEnter);
	                });
	                event.preventDefault();
	            }
	        });
	    };
	});
angular.module('AmwayAdmin.utils').directive('object2id', function() {
  return { restrict: 'A',
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {

      if(ngModel) { // Don't do anything unless we have a model

        ngModel.$parsers.push(function (value) {
        	if(value && value.id){
          return value.id;
        	}
        	else return value;
        });

        ngModel.$formatters.push(function (value) {
        	return undefined;
        });

      }
    }
  };
});
angular.module('AmwayAdmin.utils').directive('sanitizeUrl', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel, $sce) {

            // console.log(attrs);
            if (ngModel) { // Don't do anything unless we have a model

                

                ngModel.$parsers.push(function (value, $sce) {
                    if (value) {
                        console.log('sce', $sce.trustAsHtml(value));
                        return $sce.trustAsHtml(value);
                    }
                    else return value;
                });

            }
        }
    };
});
angular
	.module('AmwayAdmin.utils')
	.directive("stResetSearch", function() {
         return {
                restrict: 'EA',
                require: '^stTable',
                link: function(scope, element, attrs, ctrl) {
                  return element.bind('click', function() {
                    return scope.$apply(function() {
                      var tableState;
                      tableState = ctrl.tableState();
                      tableState.search.predicateObject = {};
                      tableState.pagination.start = 0;
                      return ctrl.pipe();
                    });
                  });
                }
              };
    });
angular.module('AmwayAdmin.utils').factory('UploadService', function(DataConnectorService,Upload) {

var response={};


    // upload on file select or drop
    response.upload = function (file,id) {
    	console.log(file);
    	if (id==undefined){
    		id='';
    	}
        return upload(file, 'upload/media/'+id);
    };

    response.uploadFlyer = function (file) {
        console.log(file);
        return upload(file, 'upload/event/');
    };

    response.uploadCover = function (file) {
        console.log(file);
        return upload(file, 'upload/cover/');
    };

    response.uploadModule = function (file) {
        console.log(file);
        return upload(file, 'upload/module/');
    };


  response.uploadImage = function (file,id) {
      
      return upload(file, 'upload/img');
    };

    response.uploadOpen = function (file,id) {
      
      return upload(file, 'upload/open/');
    };


    function upload(file, url){
 			return Upload.upload({
            url: DataConnectorService.getBaseUrl()+url,
            data: {file: file},
            headers: DataConnectorService.getHeaders()
        });
    }

    



		response.getAllegati =function(entity, id){
				var config={isArray: true};

		return DataConnectorService.getResource('attach/:entity/:id',{entity: entity,id: id}, config).get();
  
		}

        response.postAllegati = function(infoAllegato){
            return DataConnectorService.getResource('attach').post(infoAllegato);
        }

        response.updateAllegato = function(infoAllegato){
            return DataConnectorService.getResource('attach/:id',{id : infoAllegato.id}).put(infoAllegato);
        }

        response.updateAllegatoRetroattivo = function(infoAllegato){
            return DataConnectorService.getResource('/attach/retroupdate',{}).post(infoAllegato);
        }

        response.unshareAllegato = function(allegato){
            return DataConnectorService.getResource('attach/unshare',{}).post(allegato);
		}
		
		response.retroshareAllegato = function (allegato) {
			return DataConnectorService.getResource('attach/retroshare', {}).post(allegato);
		}

	return response;

});
angular.module('AmwayAdmin.utils').factory('UtilsService', function($resource, x2js) {

    var response={};
    var cfservice='http://webservices.dotnethell.it//codicefiscale.asmx/';
    

        response.getBcityFromCF = function (cf){
            var codicecitta='';
            if(cf)
            codicecitta=cf.substring(11, 15);
            return $resource(cfservice+'NomeComune?CodiceComune=:codice', null, {'query': {method: 'GET', transformResponse: xmltojson}}).query({codice: codicecitta});
        }
        response.getBdateFromCF = function (cf) {
            var codicefiscale = cf;
            var tabellamesi = {
                "A" : 0,
                "B" : 1,
                "C" : 2,
                "D" : 3,
                "E" : 4,
                "H" : 5,
                "L" : 6,
                "M" : 7,
                "P" : 8,
                "R" : 9,
                "S" : 10,
                "T" : 11
            };
            var date;

            var datanascita = codicefiscale.replace(/^(?:\w{6})(\d{2})(\w)(\d{2}).+$/, function(data, aa, mm, gg) {
                
                var anno = parseInt(aa, 10);
                var secolo = (anno < 9)? '20':'19';
                anno = [secolo, aa].join('');
            
                var giorno = parseInt(gg, 10);
                if (giorno > 71 || ((31 < giorno) && (giorno < 41))) return 'giorno di nascita errato.';
            
                var sesso = (giorno > 31)? 'F' : 'M';
                if (sesso === 'F') giorno -= 40;
                
                var mese = mm.toUpperCase();
                if (tabellamesi[mese]) {
                mese = tabellamesi[mese]; 
            
                giorno, mese, anno

                date = new Date(anno, mese, giorno); 
                }
               
            });

            
            return date;
        };

        return response;
    
        function xmltojson(data)  {
            var json = x2js.xml_str2json( data );
            return json;
           }


    });
    
       

'use strict';

angular
  .module('AmwayAdmin.services')
  .factory('CardService', function(DataConnectorService) {

    return {

      getCards: function(uid) {

        return DataConnectorService
          .getResource('user/paymentmethods/:uid', { uid: uid }, { isArray: true })
          .get()
      },

      
      // DEPRECATA
      // addCard: function(uid, token) {
      //   return DataConnectorService
      //     .getResource('user/card/add')
      //     .post({ uid: uid, token: token });
      // },

      addCard: function(uid, method) {
        return DataConnectorService
          .getResource('user/paymentmethod/add')
          .post({ uid: uid, paymentmethod: method });
      },

      getPaymentIntent: function(uid){
        return DataConnectorService
          .getResource('user/:uid/paymentintent', { uid: uid })
          .get();
      },

      makeDefault: function(uid, card) {
        return DataConnectorService
          .getResource('user/:uid/paymentmethod/makedefault', { uid: uid }, { isArray: true })
          .post(card);
      },

      deleteCard: function(uid, card) {
        return DataConnectorService
          .getResource('user/:uid/paymentmethod/delete', { uid: uid }, { isArray: true })
          .post(card);
      }
    }

  });
'use strict';

angular
  .module('AmwayAdmin.services')
  .factory('CartService', function(DataConnectorService) {

    return {
      getCart: function(userid) {
        return DataConnectorService.getResource('ntsorder/user/cart/:id', { id: userid }).get();
      },
      emptyCart: function(cart) {
        return DataConnectorService.getResource('ntsorder/action/empty', { }).post(cart);
      },
      addProductToCart: function(userid, product) {
        return DataConnectorService.getResource('ntsorder/user/cart/:id/add', { id: userid }).post(product);
      },
      removeProductFromCart: function(itemid, ntsitem) {
        return DataConnectorService.getResource('ntsorder/user/cart/:id/remove', { id: itemid }).post(ntsitem);
      },
      updateCart: function(cart) {
        return DataConnectorService.getResource('ntsorder/:oid', { oid: cart.id }).put(cart);
      }
    };
  });

angular.module('AmwayAdmin.services').factory('CollectionService', function (DataConnectorService) {

	var response = {};

	response.getCollection = function (search, start, stop) {
		var config = { isArray: false };
		var s = _.clone(search);
		var entity = s.entity;
		delete s.entity;
		return DataConnectorService.getResource(':entity/gensearch/:start/:stop', { entity: entity, start: start, stop: stop }, config).post(s);

	};

	response.deleteItemInCollection = function (entity, itemid) {
		var config = { isArray: false };
		return DataConnectorService.getResource(':entity/:id', { entity: entity, id: itemid }, config).delete();

	};

	return response;

});

(function() {

  angular
    .module('AmwayAdmin.services')
    .factory('ConfigService', function(DataConnectorService) {

      return {

        getConf: function(id) {

          //
          // TODO 
          // Se id è falsy ritorna tutto il blocco. 
          // Accettabile o meglio separare la logica?
          //
          return (!!id? 
            DataConnectorService.getResource('conf/:id', { id: id }).get()
            :
            DataConnectorService.getResource('conf', {}, { isArray: true }).get()
          );
        },

        putConf: function(conf) {

          return DataConnectorService.getResource('conf/:id', { id: conf.id }).put(conf);
        }
      };

    });

}());
'use strict';

angular.module('AmwayAdmin.services').factory('ContabilitaService', function (DataConnectorService, $http, FileSaver) {

	var response = {};

	response.getTipiAnagrafica = function () {
		var config = { isArray: true };
		return DataConnectorService.getResource('tipoanagrafica', {}, config).get();

	};

	response.getConti = function () {
		var config = { isArray: true };
		return DataConnectorService.getResource('conto', {}, config).get();

	};

	response.getLiqIvaMensile = function (month, year) {
		var config = { isArray: false };
		return DataConnectorService.getResource('liquidazioneivamensile/liquidazioneiva/:month/:year', { month: month, year: year }, config).get();

	};

	response.salvaAcconto = function (liqivamensile) {
		console.log('liqivamensile', liqivamensile);
		var config = { isArray: false };
		return DataConnectorService.getResource('liquidazioneivamensile/acconto/save', {}, config).post(liqivamensile);

	};


	response.getClienti = function () {
		var config = { isArray: true };
		return DataConnectorService.getResource('user', {}, config).get();

	};

	response.getFornitori = function () {
		var config = { isArray: true };
		return DataConnectorService.getResource('fornitore', {}, config).get();

	};




	response.initMovimento = function () {
		var config = { isArray: false };
		return DataConnectorService.getResource('contabilita/init', {}, config).get();

	};


	response.getBonus = function (year, month) {
		var config = { isArray: true };
		return DataConnectorService.getResource('bonus/list/:year/:month', { year: year, month: month }, config).get();

	};

	response.updateBonus = function (bonus) {
		var config = { isArray: false };
		return DataConnectorService.getResource('bonus', {}, config).post(bonus);

	};




	response.contabilizzaBonus = function (bonus, date) {
		var config = { isArray: false };
		return DataConnectorService.getResource('bonus/contab/:bid/:date', { bid: bonus, date: date }, config).get();

	};




	response.getConto = function (id) {
		var config = { isArray: true };
		return DataConnectorService.getResource('conto/:id', { id: id }, { isArray: false }).get();

	};

	response.getContoByCodice = function (c) {
		var config = { isArray: true };
		return DataConnectorService.getResource('conto/codice/:c', { c: c }, { isArray: false }).get();

	};

	response.addConto = function (conto) {
		var config = { isArray: true };
		return DataConnectorService.getResource('conto', {}, {}).post(conto);

	};

	response.updateConto = function (conto) {
		var config = { isArray: true };
		return DataConnectorService.getResource('conto/:id', { id: conto.id }, {}).put(conto);

	};

	response.deleteConto = function (id) {
		var config = { isArray: true };
		return DataConnectorService.getResource('conto/:id', { id: id }, { isArray: false }).delete();

	};

	response.searchMastrino = function (search, start, stop) {
		var config = { isArray: false };
		return DataConnectorService.getResource('mastrino/filter/:start/:stop', { start: start, stop: stop }, config).post(search);

	};

	response.searchMastrinoIva = function (search, start, stop) {
		return DataConnectorService
			.getResource('mastrinoiva/advancedsearch/:start/:stop', { start: start, stop: stop }, { isArray: true })
			.post(search);
	};

	response.countMastrinoIva = function (search, start, stop) {
		return DataConnectorService
			.getResource('mastrinoiva/advancedcount', {}, { isArray: false })
			.post(search);
	};

	response.getTipiPagamento = function () {
		var config = { isArray: true };
		return DataConnectorService.getResource('tipopagamento', {}, config).get();

	};

	response.getCodiciIva = function () {
		var config = { isArray: true };
		return DataConnectorService.getResource('codiceiva', {}, config).get();

	};

	response.getCausali = function () {
		var config = { isArray: true };
		return DataConnectorService.getResource('causalecontabile', {}, config).get();

	};

	response.searchCustomers = function (searchterm) {
		var config = { isArray: true };
		var item = { term: searchterm };
		return DataConnectorService.getResource('user/freesearch/0/100', {}, config).post(item);
	};

	response.searchSuppliers = function (searchterm) {
		var config = { isArray: true };
		var item = { term: searchterm };
		return DataConnectorService.getResource('fornitore/freesearch/0/100', {}, config).post(item);
	};




	response.getSupplier = function (id) {
		var config = { isArray: false };
		return DataConnectorService.getResource('fornitore/:id', { id: id }, config).get();
	};


	response.getUtenteByConto = function (conto) {
		var config = { isArray: true };
		return DataConnectorService.getResource('user/filter/conto/:conto/range/0/100', { conto: conto }, config).get();
	};

	response.getFornitoreByConto = function (conto) {
		var config = { isArray: true };
		return DataConnectorService.getResource('fornitore/filter/codice/:conto/range/0/100', { conto: conto }, config).get();
	};


	response.searchAccounts = function (searchterm) {
		var config = { isArray: true };
		var item = { term: searchterm };
		return DataConnectorService.getResource('conto/freesearch/0/100', {}, config).post(item);
	};

	response.getMovimento = function (id) {
		var config = { isArray: false };
		return DataConnectorService.getResource('contabilita/movimento/:id', { id: id }, config).get();
	};

	response.createMovimento = function (movimento) {
		return DataConnectorService.getResource('contabilita/save', {}, {}).post(movimento);
	};

	response.updateMovimento = function (movimento) {
		return DataConnectorService.getResource('contabilita/movimento/:id', { id: movimento.header.ntsid }, {}).put(movimento);
	};

	response.deleteMovimento = function (movimento) {
		console.log('movimento', movimento);
		return DataConnectorService.getResource('contabilita/movimento/:id', { id: movimento.header.ntsid }, {}).delete();
	};

	response.getInvoices = function (conto, start, stop) {
		return DataConnectorService
			.getResource('fattura/filter/cliente/:conto/range/:start/:stop', { conto: conto, start: start, stop: stop }, { isArray: true })
			.get();
	}

	response.getInvoicesCount = function (obj) {
		return DataConnectorService
			.getResource('fattura/advancedcount', {}, { isArray: false })
			.post(obj);
	}

	response.getInvoicesAdvanced = function (obj, start, stop) {
		return DataConnectorService
			.getResource('fattura/advancedsearch/:start/:stop', { start: start, stop: stop }, { isArray: true })
			.post(obj);
	}

	response.getInvoicesPassiveDraft = function (obj, start, stop) {
		return DataConnectorService
			.getResource('passivedraft/advancedsearch/:start/:stop', { start: start, stop: stop }, { isArray: true })
			.post(obj);
	}

	response.getInvoicesPassiveDraftCount = function (obj, start, stop) {
		return DataConnectorService
			.getResource('passivedraft/advancedcount', {}, { isArray: false })
			.post(obj);
	}

	response.passiveDraftDelete = function (invoice) {
		return DataConnectorService
			.getResource('passivedraft/delete', {}, { isArray: false })
			.post(invoice);
	}

	response.getInvoicePassiveDraft = function (id) {
		return DataConnectorService
			.getResource('passivedraft/:id', { id: id }, { isArray: false })
			.get();
	}

	response.getElectronicInvoices = function (obj, start, stop) {
		return DataConnectorService
			.getResource('fattura/elettronica/search/:start/:stop', { start: start, stop: stop }, { isArray: true })
			.post(obj);
	}

	response.getElectronicInvoicesCount = function (obj) {
		return DataConnectorService
			.getResource('fattura/elettronica/count', {}, { isArray: false })
			.post(obj);
	}

	response.regenerateInvoice = function (obj) {
		return DataConnectorService
			.getResource('fattura/retry', {}, { isArray: false })
			.post(obj);
	}

	response.notifyInvoice = function (obj) {
		return DataConnectorService
			.getResource('fattura/notificatants', {}, { isArray: false })
			.post(obj);
	}

	// fatture estere https://gitlab.elbuild.com/nts/nts/-/issues/43
	response.getElectronicInvoicesEE = function (obj, start, stop) {
		return DataConnectorService
			.getResource('fatturaee/elettronica/search/:start/:stop', { start: start, stop: stop }, { isArray: true })
			.post(obj);
	}

	response.getElectronicInvoicesCountEE = function (obj) {
		return DataConnectorService
			.getResource('fatturaee/elettronica/count', {}, { isArray: false })
			.post(obj);
	}

	response.regenerateInvoiceEE = function (obj) {
		return DataConnectorService
			.getResource('fatturaee/retry', {}, { isArray: false })
			.post(obj);
	}
	//-> fatture estere




	response.getSelfInvoices = function (conto) {
		return DataConnectorService
			.getResource('selfinvoice/filter/cliente/:conto/range/0/25', { conto: conto }, { isArray: true })
			.get();
	}

	response.getSingleInvoice = function (ntsid) {
		return DataConnectorService
			.getResource('rigafattura/filter/idfattura/:ntsid/range/0/100', { ntsid: ntsid }, { isArray: true })
			.get();
	}


	response.getPartiteAperte = function (conto) {
		var config = { isArray: true };
		return DataConnectorService.getResource('contabilita/partiteaperte/:conto', { conto: conto }, config).get();

	};

	response.getPartiteAperteTipo = function (postObj) {
		var config = { isArray: true };
		return DataConnectorService.getResource('contabilita/aperte/:tipo/:start/:stop', { tipo: postObj.tipo, start: postObj.start, stop: postObj.stop }, config).get();

	};

	response.getBilancio = function (postObj) {
		var config = { isArray: true };
		return DataConnectorService.getResource('contabilita/bilancio/:start/:stop/:removezero/:sidetoside/:removesaldozero', { start: postObj.datefrom, stop: postObj.dateto, removezero: postObj.removezero, removesaldozero: postObj.removesaldozero, sidetoside: postObj.sidetoside }, config).get();
	};

	response.getBilancioC = function (postObj) {
		var config = { isArray: true };
		return DataConnectorService.getResource('contabilita/bilancioc/:start/:stop/:removezero/:removesaldozero', { start: postObj.datefrom, stop: postObj.dateto, removezero: postObj.removezero, removesaldozero: postObj.removesaldozero }, config).get();
	};

	response.getBilancioF = function (postObj) {
		var config = { isArray: true };
		return DataConnectorService.getResource('contabilita/bilanciof/:start/:stop/:removezero/:removesaldozero', { start: postObj.datefrom, stop: postObj.dateto, removezero: postObj.removezero, removesaldozero: postObj.removesaldozero }, config).get();
	};

	response.getSezione = function (sez, start, stop) {
		var config = { isArray: true };
		return DataConnectorService.getResource('liquidazioneivacheck/sezionale/:sez/:start/:stop', { sez: sez, start: start, stop: stop }, config).get();
	};

	response.getSezionali = function () {
		var config = { isArray: true };
		return DataConnectorService.getResource('sezionale', {}, config).get();
	};
	response.getSezionaliAdvanced = function (obj) {
		var config = { isArray: true };
		return DataConnectorService.getResource('sezionale/advancedsearch/0/100', {}, config).post(obj);
	};

	response.generateRegistroPdf = function (obj) {
		var baseUrl = DataConnectorService.getBaseUrl();
		var headers = DataConnectorService.getHeaders();
		return $http({
			url: baseUrl + 'generate/registro/pdf',
			method: 'POST',
			data: obj,
			headers: headers,
			responseType: 'arraybuffer'
		});
	};

	response.getLiquidazioneMensile = function (obj, start, stop) {
		var config = { isArray: true };
		return DataConnectorService.getResource('liquidazioneivamensile/advancedsearch/:start/:stop', { start: start, stop: stop }, config).post(obj)
	};

	response.getLiquidazioneMensileCount = function (obj) {
		return DataConnectorService
			.getResource('liquidazioneivamensile/advancedcount', {}, { isArray: false })
			.post(obj);
	}

	response.liqivamensMov = function (data) {
		return DataConnectorService.getResource('liquidazioneivamensile/contabilizza', {}, {}).post(data);
	}

	response.completeMovimento = function (type, request) {

		return DataConnectorService.getResource('contabilita/complete/:type', { type: type }, {}).post(request);
	}

	response.contabilizzaFattura = function (id, date, datedraft) {
		if (datedraft) {
			console.log('datedraft', datedraft);
			return DataConnectorService.getResource('passivedraft/:id/contabilizza/:date/:datedraft', { id: id, date: date, datedraft: datedraft }, { isArray: false }).get();
		}
		return DataConnectorService.getResource('passivedraft/:id/contabilizza', { id: id }, { isArray: false }).get();
	}

	// codici iva

	response.getSingleCodIva = function (id) {
		return DataConnectorService
			.getResource('codiceiva/:id', { id: id }, { isArray: false })
			.get();
	};

	response.createCodIva = function (codiceiva) {
		return DataConnectorService.getResource('codiceiva', {}, {}).post(codiceiva);
	};

	response.refundOrder = function (api, order) {
		if (!api) {
			api = 'ntsorder/action/refund';
		}
		console.log('refundOrder', order);
		return DataConnectorService.getResource(api, {}, {}).post(order);


	}

	response.getCertificazioneByYear = function (year) {
		var config = { isArray: true };
		return DataConnectorService.getResource('certificazioneunica/filter/year/:year/range/:start/:stop', { conto: conto }, config).get();
	};

	response.refreshCertificazioneByYear = function (anno) {
		var config = { isArray: true };
		return DataConnectorService.getResource('certificazioneunica/:anno/refresh', { anno: anno }, config).get();
	};

	response.getCertificazioneAdvanced = function (obj, start, stop) {
		return DataConnectorService
			.getResource('certificazioneunica/advancedsearch/:start/:stop', { start: start, stop: stop }, { isArray: true })
			.post(obj);
	}

	response.getCertificazioneAdvancedCount = function (obj) {
		return DataConnectorService
			.getResource('certificazioneunica/advancedcount', {}, { isArray: false })
			.post(obj);
	}

	response.certificazioneDelete = function (id) {
		var config = { isArray: true };
		return DataConnectorService.getResource('certificazioneunica/:id', { id: id }, { isArray: false }).delete();

	};

	response.certificazioneUpdate = function (row) {
		var config = { isArray: true };
		return DataConnectorService.getResource('certificazioneunica/:id', { id: row.id }, { isArray: false }).put(row);

	};





	response.notaCreditoOrder = function (ordine) {

		return DataConnectorService.getResource('ntsorder/:ordid/contab/ncv/', { ordid: ordine }, {}).get();


	}

	response.sendToSDI = function (id) {
		return DataConnectorService.getResource('bonus/:bonusid/invasdi', { bonusid: id }, {}).get();
	}

	response.chiudiFornitori = function (year) {
		var config = { isArray: false };
		return DataConnectorService.getResource('generate/closefornitori', {}, config).post(year);
	}

	response.chiudiClienti = function (year) {
		var config = { isArray: false };
		return DataConnectorService.getResource('generate/closeclienti', {}, config).post(year);
	}

	response.chiudiPatrimoniale = function (year) {
		var config = { isArray: false };
		return DataConnectorService.getResource('generate/closepatrimoniale', {}, config).post(year);
	}

	response.chiudiEconomici = function (obj) {
		var config = { isArray: false };
		return DataConnectorService.getResource('generate/closecosto', {}, config).post(obj);
	}

	response.aperturaProvvisorio = function (year) {
		var config = { isArray: false };
		return DataConnectorService.getResource('generate/aperturaprovvisorio', {}, config).post(year);
	}

	response.getLastPrint = function () {
		var config = { isArray: true };
		return DataConnectorService.getResource('generate/registro/maxdate', {}, config).get();
	}


	response.printGiornale = function (obj) {

		var baseUrl = DataConnectorService.getBaseUrl();
		var headers = DataConnectorService.getHeaders();
		return $http({
			url: baseUrl + 'generate/giornalebollato/pdf',
			method: 'POST',
			data: obj,
			headers: headers,
			responseType: 'arraybuffer'
		});
	}

	response.exportRateiRisconti = function (entity, year) {
		var baseUrl = DataConnectorService.getBaseUrl();
		var headers = DataConnectorService.getHeaders();
		return $http({
			url: baseUrl + '/contabilita/' + entity + '/export/' + year,
			method: 'GET',
			headers: headers,
			responseType: 'arraybuffer'
		});
	}

	response.creaRisconti = function (year, cdate) {
		var config = { isArray: false };
		return DataConnectorService.getResource('contabilita/crea/risconti/ticket/' + year + '/' + cdate, {}, config).get();
	}

	response.creaRateiRisconti = function (year) {
		var config = { isArray: false };
		return DataConnectorService.getResource('contabilita/crea/rateirisc/all/' + year, {}, config).get();
	}

	return response;

});

'use strict';

angular
    .module('AmwayAdmin.services')
    .factory('FaqService', function (DataConnectorService) {

        var response = {};

        var types = [
            'Problema tecnico',
            'Acquisto Biglietti',
            'Iscrizione',
            'Fatturazione e consegna contenuti digitali',
            'Promozione primo ordine',
            'Pagamento',
            'Acquisto biglietti',
            'N21 Mobile Italia',
            'CEP',
            'Media Sharing'
        ]

        response.getAll = function () {
            var config = { isArray: true };
            return DataConnectorService.getResource('faq', {}, config).get();
        };

        response.get = function (id) {
            var config = { isArray: false };
            return DataConnectorService.getResource('faq/:id', {id:id}, config).get();
        };

        response.post = function (item) {
            var config = { isArray: false };
            return DataConnectorService.getResource('faq', {}, config).post(item);
        };

        response.put = function (item) {
            var config = { isArray: false };
            return DataConnectorService.getResource('faq/:id', { id: item.id}, config).put(item);
        };

        response.getTypes = function () {
            var config = { isArray: true };
            return DataConnectorService.getResource('faqtype', { }, config).get();
        };

        response.newType = function (faqtype) {
            var config = { isArray: false };
            return DataConnectorService.getResource('faqtype', {}, config).post(faqtype);
        };

        response.updateType = function (faqtype) {
            var config = { isArray: false };
            return DataConnectorService.getResource('faqtype/:id', { id: faqtype.id}, config).put(faqtype);
        };

        response.deleteType = function (faqtype) {
            var config = { isArray: false };
            return DataConnectorService.getResource('faqtype/:id', { id: faqtype.id }, config).delete();
        };

        response.delete = function (id) {
            var config = { isArray: false };
            return DataConnectorService.getResource('faq/:id', { id: id }, config).delete();
        };





        return response;

    });
'use strict';

angular
  .module('AmwayAdmin.services')
  .factory('OrderService', function(DataConnectorService) {

    return {

      getUserOrders: function(uid) {

        return DataConnectorService
          .getResource('ntsorder/filter/uid/:uid/range/0/1000', { uid: uid }, { isArray: true })
          .get()
      },

      getUserOrdersAdv: function(searchobj, start, stop) {

        return DataConnectorService.getResource('ntsorder/advancedsearch/:start/:stop', { start: start, stop: stop }, { isArray: true }).post(searchobj);
      },

      getUserOrdersAdvCount: function(searchobj) {
        return DataConnectorService
          .getResource('ntsorder/advancedcount', {}, { isArray: false }).post(searchobj);
      }

    }

  });
'use strict';

angular.module('AmwayAdmin.services').factory('ProductService', function (DataConnectorService) {

  var response = {};

  response.getCategorie = function () {
    var config = { isArray: true };
    return DataConnectorService.getResource('taxonomy', {}, config).get();

  };

  response.getCategoria = function (id) {
    return DataConnectorService.getResource('taxonomy/:id', { id: id }).get();

  };

  response.resetCategorieCache = function (id) {
    var config = {
      isArray: true
    };
    return DataConnectorService.getResource('taxonomy/resetcache', {}, config).get();

  };

  response.eliminaCategoria = function (id) {
    return DataConnectorService.getResource('taxonomy/:id', { id: id }).delete();

  };

  response.eliminaEvento = function (id) {
    return DataConnectorService.getResource('event/:id', { id: id }).delete();

  };

  response.eliminaOpen = function (id) {
    return DataConnectorService.getResource('open/:id', { id: id }).delete();

  };


  response.eliminaProdotto = function (id) {
    return DataConnectorService.getResource('product/:id', { id: id }).delete();

  };



  response.creaCategoria = function (cat) {
    return DataConnectorService.getResource('taxonomy').post(cat);

  };

  response.aggiornaCategoria = function (cat) {
    return DataConnectorService.getResource('taxonomy/:id', cat.id).post(cat);

  };




  response.getProssimiEventi = function () {
    var config = { isArray: true };
    return DataConnectorService.getResource('event/upcoming', {}, config).get();

  };



  response.getEvento = function (id) {
    return DataConnectorService.getResource('event/:id', { id: id }).get();

  };

  response.getOpen = function (id) {
    return DataConnectorService.getResource('open/:id', { id: id }).get();

  };


  response.getEventi = function () {
    var config = {
      isArray: true
    };
    return DataConnectorService.getResource('event', {}, config).get();

  };

  response.getEventiAdv = function (searchobj, start, stop) {
    var config = {
      isArray: true
    };
    return DataConnectorService.getResource('event/advancedsearch/:start/:stop', { start: start, stop: stop }, config).post(searchobj);
  };

  response.getEventiAdvCount = function (searchobj) {
    var config = {
      isArray: false
    };
    return DataConnectorService.getResource('event/advancedcount', {}, config).post(searchobj);
  };


  response.getEventiFuturi = function () {
    var config = {
      isArray: true
    };
    return DataConnectorService.getResource('event/future', {}, config).get();

  }


  response.getOpens = function () {
    var config = {
      isArray: true
    };
    return DataConnectorService.getResource('open', {}, config).get();

  };




  response.creaEvento = function (product) {
    return DataConnectorService.getResource('event').post(product);

  };

  response.creaOpen = function (product) {
    return DataConnectorService.getResource('open').post(product);

  };


  response.getSpeakerEvento = function (event) {
    return DataConnectorService
      .getResource('eventspeaker/filter/eid/:eid/range/0/1000', { eid: event.id }, { isArray: true })
      .get();
  }



  response.aggiornaEvento = function (product) {
    return DataConnectorService.getResource('event/:id', {
      id: product.id
    }, {}).put(product);

  };

  response.aggiornaEvento = function (product) {
    return DataConnectorService.getResource('open/:id', {
      id: product.id
    }, {}).put(product);

  };




  response.getBigliettiEvento = function (id) {
    var config = { isArray: true };
    return DataConnectorService.getResource('event/tickets/:id', { id: id }, config).get();

  };

  response.getAll = function () {
    var config = { isArray: true };
    return DataConnectorService.getResource('product', {}, config).get();

  };



  response.creaProdotto = function (product) {
    return DataConnectorService.getResource('product').post(product);

  };

  response.aggiornaCategorieProdotto = function (pid, cats) {
    var config = { isArray: true };

    return DataConnectorService.getResource('taxonomyproduct/:id/batch', {}, config).post({ id: pid }, cats);

  };


  response.aggiornaProdotto = function (product) {
    return DataConnectorService.getResource('product/:id', {
      id: product.id
    }, {}).put(product);

  };



  response.getProdottiFeatured = function () {
    var config = { isArray: true };
    return DataConnectorService.getResource('product/featured', {}, config).get();

  };

  response.getProdottiCorrelati = function (id) {
    var config = { isArray: true };
    return DataConnectorService.getResource('product/related/:id', { id: id }, config).get();

  };

  response.getCategorieProdotto = function (id) {
    var config = { isArray: true };
    return DataConnectorService.getResource('product/taxonomies/:id', { id: id }, config).get();

  };


  response.getProdottiCategoria = function (id) {
    var config = { isArray: true };
    return DataConnectorService.getResource('product/taxonomy/:id', { id: id }, config).get();

  };



  response.getProdotto = function (id) {
    return DataConnectorService.getResource('product/:id', { id: id }).get();

  };

  response.getInventory = function (id) {
    return DataConnectorService.getResource('product/inventory/:id', { id: id }).get();

  };

  response.getAuthorProduct = function (prod) {
    return DataConnectorService
      .getResource('authorproduct/filter/pid/:pid/range/0/1000', { pid: prod.id }, { isArray: true })
      .get();
  }

  response.addAuthorProduct = function (product, author) {
    return DataConnectorService
      .getResource('authorproduct')
      .post({ pid: product.id, aid: author.id });
  }

  response.deleteAuthorProduct = function (ap) {
    return DataConnectorService
      .getResource('authorproduct/:id', { id: ap.id })
      .delete();
  }

  response.getProductPack = function (id) {
    var config = { isArray: true };
    return DataConnectorService
      .getResource('pack/filter/parent/:id/range/0/1000', { id: id }, config)
      .get();
  }

  response.getMovimentiMagazzino = function (id) {
    var config = { isArray: true };
    return DataConnectorService
      .getResource('inventorychange/filter/pid/:id/range/0/1000', { id: id }, config)
      .get();
  }

  response.addProductToPack = function (parent, product) {
    return DataConnectorService
      .getResource('pack')
      .post({ parent: parent.id, pid: product.id, type: product.type });
  }

  response.deleteProductPack = function (ap) {
    return DataConnectorService
      .getResource('pack/:id', { id: ap.id })
      .delete();
  }

  response.advancedSearch = function (searchobj, start, stop) {
    return DataConnectorService.getResource('product/advancedsearch/:start/:stop', { start: start, stop: stop }, { isArray: true }).post(searchobj);
  }

  response.saveTaxonomySort = function (list) {
    return DataConnectorService.getResource('taxonomyproduct/save/all', {}, { isArray: true }).post(list);
  }

  response.searchProducts = function (term) {
    return DataConnectorService
      .getResource('product/text/search', {}, { isArray: true }).post({ term: term });
  }


  response.isProductSellable = function (product) {
    var start = (product.sellfromdate) ? product.sellfromdate : 0;
    var stop = (product.selltodate) ? product.selltodate : 8640000000000000;
    var now = Math.ceil((new Date()).getTime()) / 1000;

    return start < now && now < stop;
  }

  response.searchProductByCategoria = function (searchobj) {
    return DataConnectorService.getResource('taxonomyproduct/advancedsearch/0/1000', {}, { isArray: true }).post(searchobj);
  }

  response.getCount = function (searchobj) {
    return DataConnectorService.getResource('product/advancedcount/').post(searchobj);

  }

  response.getProductRelated = function (searchobj, start, stop) {
    return DataConnectorService.getResource('prodrelated/advancedsearch/:start/:stop', { start: start, stop: stop }, { isArray: true }).post(searchobj);
  }

  response.getHeatmapData = function (id, start, stop) {
    return DataConnectorService.getResource('heatmap/product/:id/:start/:stop', { id: id, start: start, stop: stop }, { isArray: true }).get();
  }

  response.addProductRelated = function (product, related) {
    return DataConnectorService
      .getResource('prodrelated')
      .post({
        pid: product.id,
        relatedid: related.id
      });
  }

  response.deleteProductRelated = function (related) {
    return DataConnectorService
      .getResource('prodrelated/:id', {
        id: related.id
      })
      .delete();
  }



  response.giftProductSearch = function (filter) {
    var config = { isArray: true };
    return DataConnectorService.getResource('product/gift/search', {}, config).post({ term: filter, source: 'admin' });

  };

  response.giftProductSearchEvo = function (filter) {
    var config = { isArray: true };
    return DataConnectorService.getResource('product/gift/search/evo', {}, config).post({ term: filter, source: 'admin' });

  };

  response.assignGift = function (user, product) {
    var config = {};
    return DataConnectorService.getResource('user/assign/gift', {}, config).post({ userid: user, productid: product });

  };




  return response;

});

'use strict';

angular
    .module('AmwayAdmin.services')
    .factory('VideotaxonomyService', function (DataConnectorService) {

        var response = {};

        response.getAll = function () {
            var config = { isArray: true };
            return DataConnectorService.getResource('videotaxonomy', {}, config).get();
        };

        response.get = function (id) {
            var config = { isArray: false };
            return DataConnectorService.getResource('videotaxonomy/:id', {id:id}, config).get();
        };

        response.post = function (item) {
            var config = { isArray: false };
            return DataConnectorService.getResource('videotaxonomy', {}, config).post(item);
        };

        response.put = function (item) {
            var config = { isArray: false };
            return DataConnectorService.getResource('videotaxonomy/:id', { id: item.id}, config).put(item);
        };

        response.delete = function (item) {
            var config = { isArray: false };
            return DataConnectorService.getResource('videotaxonomy/:id', { id: item.id }, config).delete();
        };


        return response;

    });
(function() {

	'use strict';

	angular
	  .module('AmwayAdmin.contabilita.autofatture')
      .controller('AutofattureCtrl', AutofattureCtrl);

	/** @ngInject */
	function AutofattureCtrl($scope, $stateParams, DataConnectorService, ConfigService, ContabilitaService, Notification, $uibModal) {

        var now = moment();
        var tmpdate = moment();
        tmpdate.subtract(12,'month');

        $scope.loadingSDI = [];
       
        $scope.years={};
        $scope.years[tmpdate.get('year')]=[];
        $scope.contdate=parseInt((new Date).getTime()/1000);
        // console.log(tmpdate,  now, tmpdate.isBefore(now));
        var prec=moment(tmpdate);
        while(tmpdate.isBefore(now)){
            if(tmpdate.get('year')!=prec.get('year')){
                $scope.years[tmpdate.get('year')]=[];
            }
            var mese=tmpdate.locale('it').startOf("month").format('MMMM').toUpperCase();
           // console.log('mese',mese, tmpdate.get('year'));
			//console.log( $scope.years);
			var num = tmpdate.month() + 1;
			$scope.years[tmpdate.get('year')].push({month: mese, num: num});
			
            prec=moment(tmpdate);
           tmpdate.add(1,'M');
      
		}
		console.log('year', $scope.years);

        $scope.itemsPerPage = 25;

		$scope.apiurl = DataConnectorService.getBaseUrl();

        $scope.ricerca={year: now.get('year')+''};
		console.log('years', $scope.years);
        if($scope.years[$scope.ricerca.year].length>1)
        	$scope.ricerca.month= ($scope.years[$scope.ricerca.year].length-1)+'';
        else{
        	$scope.ricerca={year: (now.get('year')-1) + ''};
        	$scope.ricerca.month= ($scope.years[$scope.ricerca.year].length)+'';
		}
		

        $scope.cercaBonus=function(){

		console.log('year', $scope.ricerca);
                ContabilitaService.getBonus($scope.ricerca.year, $scope.ricerca.month).$promise.then(function(r){
                        $scope.bonus=r;
                },function(e){
                    Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
                })
        }


        $scope.cercaBonus();

 $scope.gestisciBonus = function(bonus){
console.log(bonus);
    var popup = $uibModal.open({
        animation: true,
        controller: GestisciBonusDialogController,
        templateUrl: 'app/contabilita/autofatture/gestiscibonus-dialog.html',
        resolve: {
            bonus: function () {
                return bonus;
            }
        }
    });


    popup.result.then(function(){
        Notification.success('Dati aggiornati');
    }, function() {
  // Cancel
  console.log('cancel');
});



}

$scope.getMovimentiAssociati = function(movimenti){
    if(movimenti)
    return movimenti.split('|');
    else return [];
}

	$scope.sendToSDI = function(bonus, index) {
		$scope.loadingSDI[index] = true;
		console.log('bonus', bonus);
		ContabilitaService.sendToSDI(bonus.id).$promise.then(function(r) {
			$scope.bonus[index] = r;
			bonus.idsdi = r.idsdi;
			$scope.loadingSDI[index] = false;
		},function(e){
          Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
        });
	};

}


    function GestisciBonusDialogController($scope,$uibModalInstance, UtentiService,Notification, ContabilitaService, bonus){

        console.log(bonus);
        if( bonus ){
          $scope.bonus = bonus;
  
 
          }
  
  
         $scope.cancel = function() {
          $uibModalInstance.dismiss();
        };
        $scope.answer = function(answer) {
          $uibModalInstance.close(answer);
        };
  
        $scope.salva = function(){
    
  
              ContabilitaService.updateBonus(bonus).$promise.then(function (r) {
  
                $scope.answer(r);
        }).catch( function(o){
          Notification.error('Si è verificato un errore '+(o.data && o.data.msg ? o.data.msg : ''));
          console.log(o);
        });
  
        }
      }

}());




/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('AmwayAdmin.contabilita.bilancio')
		.controller('BilancioCtrl', BilancioCtrl);

	/** @ngInject */
	function BilancioCtrl($scope, $stateParams, $state, ContabilitaService, $ngConfirm, Notification, $window, $q) {

		var datefrom, dateto;
		var promiseClienti, promiseFornitori;
		datefrom = dateto = new Date();

		datefrom.setFullYear(new Date().getFullYear() - 1);
		datefrom.setMonth(0);
		datefrom.setDate(1);
		datefrom.setHours(0, 0, 0, 0);
		datefrom = datefrom.getTime() / 1000;

		dateto.setFullYear(new Date().getFullYear() - 1);
		dateto.setMonth(11);
		dateto.setDate(31);
		dateto.setHours(23, 59, 59, 999);
		dateto = (dateto.getTime() / 1000).toFixed(0);

		$scope.activeTab = 'conti';
		$scope.showSideToSide = true; // mostra o nascondi checkbox contrapposto in base a tab

		$scope.flagSearch = {
			conti: false,
			clienti: false,
			fornitori: false
		};


		$scope.searchObj = {
			datefrom: datefrom,
			dateto: dateto,
			removezero: 1,
			removesaldozero: 0,
			sidetoside: 0
		};

		$scope.label = {
			A: 'Attività',
			P: 'Passività',
			C: 'Costi',
			R: 'Ricavi',
			O: 'Ordinari'
		};

		var resetSearch = angular.copy($scope.searchObj);

		$scope.loading = false;
		$scope.enablePrint = false;


		function setBilancioContrapposto(rows) {
			// ricostruisce a pezzi il bilancio in modo contrapposto separando le varie parti tra Stato Patrimoniale e Conto Economico, poi manipola i ratei e risconti
			$scope.attivita = _.filter(rows, function (r) { return r.gruppo === 'A'; });
			$scope.passivita = _.filter(rows, function (r) { return r.gruppo === 'P'; });
			$scope.costi = _.filter(rows, function (r) { return r.gruppo === 'C'; });
			$scope.ricavi = _.filter(rows, function (r) { return r.gruppo === 'R'; });
			$scope.altro = _.filter(rows, function (r) { return r.gruppo != 'A' && r.gruppo != 'P' && r.gruppo != 'C' && r.gruppo != 'R'; });

			injectConti('attivita'); // inject dei conti di crediti clienti ita e estero nella parte attività
			injectConti('passivita'); // inject dei conti di debiti fornitori ita e estero nella parte passività

			manipulateRateiRisconti();

			doTotals();
		}

		function manipulateRateiRisconti() {
			var rrAtt = ['600000', '610000', '610001', '620000', '620001'];
			var rrPass = ['610002', '620002'];

			var header = _.filter($scope.attivita, function (item) { return item.conto == rrAtt[0]; })[0];
			var ratei = _.filter($scope.attivita, function (item) { return item.conto == rrAtt[1]; })[0];
			var rateiAttivi = _.filter($scope.attivita, function (item) { return item.conto == rrAtt[2]; })[0];
			var rateiPassivi = _.filter($scope.passivita, function (item) { return item.conto == rrPass[0]; })[0];
			var risconti = _.filter($scope.attivita, function (item) { return item.conto == rrAtt[3]; })[0];
			var riscontiAttivi = _.filter($scope.attivita, function (item) { return item.conto == rrAtt[4]; })[0];
			var riscontiPassivi = _.filter($scope.passivita, function (item) { return item.conto == rrPass[1]; })[0];

			// remove from array general
			$scope.attivita = _.filter($scope.attivita, function (item) { return rrAtt.indexOf(item.conto) == -1; });
			$scope.passivita = _.filter($scope.passivita, function (item) { return rrPass.indexOf(item.conto) == -1; });

			// do the correct math
			// vars with H are level 1 accounts
			var rateiAttH = angular.copy(ratei);
			rateiAttH.saldo = (rateiAttH && rateiAttivi) ? rateiAttivi.saldo : 0;
			rateiAttH.gruppo = 'A';

			var rateiPassH = angular.copy(ratei);
			rateiPassH.saldo = (rateiPassH && rateiPassivi) ? rateiPassivi.saldo : 0;
			rateiPassH.gruppo = 'P';

			var riscontiAttH = angular.copy(risconti);
			riscontiAttH.saldo = (riscontiAttH && riscontiAttivi) ? riscontiAttivi.saldo : 0;
			riscontiAttH.gruppo = 'A';

			var riscontiPassH = angular.copy(risconti);
			riscontiPassH.saldo = (riscontiPassH && riscontiPassivi) ? riscontiPassivi.saldo : 0;
			riscontiPassH.gruppo = 'P';

			var headerAttH = angular.copy(header);
			headerAttH.saldo = (headerAttH && rateiAttH && riscontiAttH) ? rateiAttH.saldo + riscontiAttH.saldo : 0;
			headerAttH.gruppo = 'A';

			var headerPassH = angular.copy(header);
			headerPassH.saldo = (headerPassH && rateiPassH && riscontiPassH) ? rateiPassH.saldo + riscontiPassH.saldo : 0;
			headerPassH.gruppo = 'P';

			// rebuild arrays corrected
			var attivita = [headerAttH, rateiAttH, rateiAttivi, riscontiAttH, riscontiAttivi];
			var passivita = [headerPassH, rateiPassH, rateiPassivi, riscontiPassH, riscontiPassivi];
			attivita.forEach(function (item) { if (item) $scope.attivita.push(item) });
			passivita.forEach(function (item) { if (item) $scope.passivita.push(item) });
		}

		function doTotals() {
			var arrayLists = ['attivita', 'passivita', 'costi', 'ricavi', 'altro'];
			var descriptions = ['TOTALE ATTIVITÀ', 'TOTALE PASSIVITÀ', 'TOTALE COSTI', 'TOTALE RICAVI', 'TOTALE ALTRO'];
			var groups = ['totalA', 'totalP', 'totalC', 'totalR', 'totalOther'];
			var totals = {};
			totals.attivita = 0;
			totals.passivita = 0;
			totals.costi = 0;
			totals.ricavi = 0;
			totals.altro = 0;

			arrayLists.forEach(function (list, index) {
				var array = _.filter($scope[list], function (r) { return r && r.level === 0; });
				array.forEach(function (i) { totals[list] += i.saldo });
				addTotal(groups[index], descriptions[index], Math.abs(totals[list]));
			});

			esercizioUtilePerdita(Math.abs(totals.ricavi), Math.abs(totals.costi));
		}

		function addTotal(group, description, total) {
			$scope[group] = {
				descrizione: description,
				saldo: total
			};
		}

		function esercizioUtilePerdita(ricavi, costi) {
			$scope.utilePerdita = {};
			if (ricavi >= costi) {
				$scope.utilePerdita.descrizione = 'UTILE DI ESERCIZIO';
			} else {
				$scope.utilePerdita.descrizione = 'PERDITA DI ESERCIZIO';
			}
			$scope.utilePerdita.saldo = ricavi - costi;
		}

		function getBilancio(api) {
			$scope.bilancioRows = [];
			if (!api) {
				api = 'getBilancio';
			}
			$scope.loading = true;
			$scope.enablePrint = false;
			ContabilitaService[api]($scope.searchObj).$promise.then(function (r) {
				if ($scope.searchObj.sidetoside) {
					setBilancioContrapposto(r);
				} else {
					$scope.bilancioRows = r;
					injectConti('bilancioRows');
				}
				$scope.enablePrint = true;
				$scope.loading = false;
			}, function (e) {
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		function aggregaCliFor() {
			// clienti italia e clienti estero non vengono direttamente da API, ma vengono costruiti in aggregato in questa funzione prenderendo i dati dalle API delle tab Clienti e Fornitori, quindi iniettati nel bilancio in posizione corretta dopo il suo caricamento con getBilancio()
			$scope.loading = true;
			var entities = ['clienti', 'fornitori'];
			var ricerca = angular.copy($scope.searchObj);
			ricerca.removezero = 1;

			promiseClienti = ContabilitaService.getBilancioC(ricerca).$promise;
			promiseFornitori = ContabilitaService.getBilancioF(ricerca).$promise;

			$q.all([promiseClienti, promiseFornitori]).then(function (r) {
				var results = {};
				results.clienti = r[0];
				results.fornitori = r[1];

				entities.forEach(function (entity) {
					var sumTotal = 0;
					var sumEstero = 0;
					var sumIta = 0;
					results[entity].forEach(function (item) {
						if (item.saldo != 0) {
							sumTotal += item.saldo;
							if (item.estero == 1) sumEstero += item.saldo;
							if (item.estero == 0) sumIta += item.saldo;
						}
					});
					$scope[entity + 'Header'] = {
						apertura: 0,
						avere: 0,
						conto: (entity == "clienti" ? "103000" : "206000"),
						dare: 0,
						descrizione: (entity == "clienti" ? "CLIENTI" : "FORNITORI"),
						gruppo: (entity == "clienti" ? "A" : "P"),
						level: 1,
						saldo: sumTotal
					};
					$scope[entity + 'Italia'] = {
						apertura: 0,
						avere: 0,
						conto: (entity == "clienti" ? "103001" : "206001"),
						dare: 0,
						descrizione: (entity == "clienti" ? "CLIENTI ITALIA" : "FORNITORI ITALIA"),
						gruppo: (entity == "clienti" ? "A" : "P"),
						level: 2,
						saldo: sumIta
					};
					$scope[entity + 'Estero'] = {
						apertura: 0,
						avere: 0,
						conto: (entity == "clienti" ? "103002" : "206002"),
						dare: 0,
						descrizione: (entity == "clienti" ? "CLIENTI ESTERO" : "FORNITORI ESTERO"),
						gruppo: (entity == "clienti" ? "A" : "P"),
						level: 2,
						saldo: sumEstero
					};
				});
				getBilancio();
			}, function (e) {
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});



		}

		// function to inject clienti and fornitori in the correct position of the array
		function injectConti(array) {
			var indexClienti = _.findIndex($scope[array], function (o) { return o.conto == "100000" });

			if (indexClienti != -1) {
				// il saldo generale di 100000 già comprende il calcolo dei conti extra che si vanno a spostare quindi la somma del saldo viene fatta prima di andare a cercare gli extra 103XXX
				$scope[array][indexClienti].saldo += $scope.clientiHeader.saldo;

				// cerca altri conti clienti con codice 103000
				seekOtherCliFor(array, indexClienti, 'clienti', '103000'); // aggiunge in fondo ai clienti tutti gli altri conti dei clienti

				$scope[array].splice(indexClienti + 1, 0, $scope.clientiEstero);
				$scope[array].splice(indexClienti + 1, 0, $scope.clientiItalia);
				$scope[array].splice(indexClienti + 1, 0, $scope.clientiHeader);
			}

			var indexFornitori = _.findIndex($scope[array], function (o) { return o.conto == "200000" });

			if (indexFornitori != -1) {
				// il saldo generale di 200000 già comprende il calcolo dei conti extra che si vanno a spostare quindi la somma del saldo viene fatta prima di andare a cercare gli extra 206XXX
				$scope[array][indexFornitori].saldo += $scope.fornitoriHeader.saldo;

				// cerca altri conti fornitori con codice 206000
				seekOtherCliFor(array, indexFornitori, 'fornitori', '206000'); // aggiunge in fondo ai fornitori tutti gli altri conti dei fornitori

				$scope[array].splice(indexFornitori + 1, 0, $scope.fornitoriEstero);
				$scope[array].splice(indexFornitori + 1, 0, $scope.fornitoriItalia);
				$scope[array].splice(indexFornitori + 1, 0, $scope.fornitoriHeader);
			}
		}

		function seekOtherCliFor(array, index, entity, conto) {
			// crea array di extra conti 103000 e 206000 da aggregare nel bilancio assieme a ita/esteri
			var extraConti = $scope[array].filter(function (o) { return o.conto.startsWith(conto.substring(0, 3)); });
			if (extraConti.length) {
				extraConti.forEach(function (item) {
					// rimuove da array principale extra conti per poi reinserirli con gli altri accorpati
					var delIndex = _.findIndex($scope[array], function (o) { return o.conto == item.conto });
					$scope[array].splice(delIndex, 1);

					if (item.conto == conto) {
						$scope[entity + 'Header'].saldo += item.saldo;
					} else {
						$scope[array].splice(index + 1, 0, item);
					}

				});
			}
		}

		/**
		 * risposta
		 * private String attività;
		   private Integer apertura;
		   private Integer dare;
		   private Integer avere;
		   private Integer saldo;
		   private Integer level;
		   private String conto;
		   level == 0 (bold)
		   level == 1 indent -> 1
		   level == 2 indent -> 2
		 */

		// getBilancio();

		$scope.adSearch = function () {
			if (api == '') {
				aggregaCliFor();
			}
			else {
				if ($scope.searchObj.sidetoside == 1) {
					aggregaCliFor();
				} else {
					getBilancio(api);
				}
			}
		};

		$scope.reset = function () {
			$scope.searchObj = angular.copy(resetSearch);
			getBilancio();
		};

		$scope.print = function () {
			$window.print();
		};

		var api = '';
		$scope.onChangeTab = function (event) {

			var tab = event ? event.target.innerText : '';
			api = '';
			$scope.bilancioRows = [];
			switch (tab) {
				case 'Clienti':
					api = 'getBilancioC';
					break;
				case 'Fornitori':
					api = 'getBilancioF';
					break;
				case 'Conti':
				default:
					api = '';
					break;
			}
			if (api == '') {
				$scope.showSideToSide = true;
				$scope.searchObj.sidetoside = 0;
				// parte da qui al reload della pagina
				// aggregaCliFor();
			} else {
				$scope.showSideToSide = false;
				$scope.searchObj.sidetoside = 0;
				//  getBilancio(api);
			}

		};

	}
})();

(function () {
	'use strict';

	angular.module('AmwayAdmin.contabilita.certunica')
		.controller('CertificazioneUnicaCtrl', CertificazioneUnicaCtrl);

	/** @ngInject */
	function CertificazioneUnicaCtrl($scope, ContabilitaService, DataConnectorService, Notification, $ngConfirm, $state, $uibModal) {

		$scope.years = [];
		$scope.yearsGen = [];

		$scope.formFilter = {
			year: (new Date()).getFullYear() - 1,
			yearGen: (new Date()).getFullYear() - 1
		};

		$scope.filter = factorySearch();

		$scope.itemsTablePageSize = 25;

		$scope.apiurl = DataConnectorService.getBaseUrl();


		function setYears() {
			var current = (new Date()).getFullYear();
			for (var i = 4; i > 0; i--) {
				$scope.years.push(current--);
			}

			var currentGen = (new Date()).getFullYear() - 1;
			for (var i = 10; i > 0; i--) {
				$scope.yearsGen.push(currentGen--);
			}
		}

		setYears();

		function count() {
			ContabilitaService.getCertificazioneAdvancedCount($scope.filter).$promise.then(function (r) {
				$scope.totalInvoices = r.ct;
				$scope.pagesToDisplay = Math.ceil($scope.totalInvoices / $scope.invoicesTablePageSize);
				//$tableState.pagination.numberOfPages = $scope.pagesToDisplay;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		$scope.tableState = { pagination: {} };
		count();

		$scope.getRows = function (tableState) {
			$scope.tableState = tableState;
			$scope.tableStateInvoices = tableState;
			var pagination = tableState.pagination;

			var start = pagination.start || 0;
			var number = pagination.number || 10;
			var stop = start + number;
			var sort = { sortfield: tableState.sort.predicate, direction: tableState.sort.reverse ? 'desc' : 'asc' };


			ContabilitaService.getCertificazioneAdvanced($scope.filter, start, stop).$promise.then(function (r) {
				$scope.rows = r;
				tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalInvoices / number));//set the number of pages so the pagination can update

			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}


		$scope.delete = function (row) {
			$ngConfirm({
				title: 'Elimina',
				content: "Sei sicuro?",
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Conferma",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {
							ContabilitaService.certificazioneDelete(row).$promise.then(function (r) {
								Notification.success('Certificazione eliminata');
								$scope.getRows($scope.tableState);
							}, function (e) {
								console.log(e);
								Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
							});
						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});
		}


		function factorySearch() {
			var filter = {
				table: "certificazioneunica",
				simple: []
			};

			if ($scope.formFilter.year) {
				filter.simple.push({ 'field': 'year', filter: $scope.formFilter.year });
			}
			return filter;
		}


		$scope.applyFilter = function () {
			$scope.tableState.pagination.start = 0;
			$scope.filter = factorySearch();
			$scope.getRows($scope.tableState);
			count();
		}

		$scope.saveRow = function (row) {
			ContabilitaService.certificazioneUpdate(row).$promise.then(function (r) {
				Notification.success('Certificazione aggiornata');
				row = r;
				row.editing = false;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		$scope.edit = function (ev, item) {

			var popup = $uibModal.open({
				animation: true,
				controller: EditCertificazioneDialogCtrl,
				templateUrl: 'app/contabilita/certificazioneUnica/modifica-certificazione-dialog.html',
				resolve: {
					item: item
				},
				size: 'm'

			});


			popup.result.then(function (result) {
				$scope.getRows($scope.tableState);
			}, function () {
				// Cancel
				console.log('cancel');
			});
		}

		$scope.generaCertificazione = function () {
			ContabilitaService.refreshCertificazioneByYear($scope.formFilter.yearGen).$promise.then(function (r) {
				Notification.success('Certificazione per l\'anno ' + $scope.formFilter.yearGen + ' generata');
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

	}

	function EditCertificazioneDialogCtrl($scope, ContabilitaService, DataConnectorService, Notification, $ngConfirm, $state, $uibModalInstance, item) {

		$scope.item = angular.copy(item);

		$scope.cancel = function () {
			$uibModalInstance.dismiss();
		};

		$scope.answer = function (answer) {
			$uibModalInstance.close(undefined);
		};

		$scope.salva = function () {
			ContabilitaService.certificazioneUpdate($scope.item).$promise.then(function (r) {
				Notification.success('Certificazione aggiornata');
				$scope.answer();
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});

		}
	}

})();

(function () {
    'use strict';

    angular.module('AmwayAdmin.contabilita.chiusuraannuale')
        .controller('ChiusuraAnnualeCtrl', ChiusuraAnnualeCtrl);

    /** @ngInject */
    function ChiusuraAnnualeCtrl($scope, ContabilitaService, DataConnectorService, Notification, $ngConfirm, $state, $uibModal) {

        var today = new Date();
        $scope.years = [];

        $scope.selectedYears = {
            patrimoniale: today.getFullYear(),
            economici: today.getFullYear(),
            fornitori: today.getFullYear(),
            clienti: today.getFullYear(),
            bonus: today.getFullYear(),
        }

        $scope.loading = {
            patrimoniale: false,
            economici: false,
            fornitori: false,
            clienti: false,
            bonus: false,
        }

        for(var i=0; i<3; i++){
            $scope.years.push(today.getFullYear() - i);
        }

        $scope.chiudiFornitori = function (year) {
            var obj = { bchyear: year + 1};
            $scope.loading.fornitori = true;
            ContabilitaService.chiudiFornitori(obj).$promise.then(function (response) {
                Notification.success(response.msg);
                $scope.loading.fornitori = false;
            }, function (error) {
                Notification.error("Errore: "+ error.data.msg);
                $scope.loading.fornitori = false;
            });
        }

        $scope.chiudiPatrimoniale = function (year) {
            var obj = { bchyear: year + 1 };
            $scope.loading.patrimoniale = true;
            ContabilitaService.chiudiPatrimoniale(obj).$promise.then(function (response) {
                Notification.success(response.msg);
                $scope.loading.patrimoniale = false;
            }, function (error) {
                Notification.error("Errore: "+ error.data.msg);
                $scope.loading.patrimoniale = false;
            });
        }

        $scope.chiudiEconomici = function (year) {
            var range = getYearLimits(year);
            var obj = {
                fromdate: range.from,
                todate: range.to,
                anno: year,
                description: "Chiusura conti di costo anno " + year
            }
            $scope.loading.economici = true;
            ContabilitaService.chiudiEconomici(obj).$promise.then(function (response) {
                Notification.success(response.msg);
                $scope.loading.economici = false;
                console.log(response);
            }, function (error) {
                Notification.error("Errore: " + error.data.msg);
                $scope.loading.economici = false;
            });
        }

        $scope.chiudiClienti = function (year) {
            var obj = { bchyear: year + 1 };
            $scope.loading.clienti = true;
            ContabilitaService.chiudiClienti(obj).$promise.then(function (response) {
                Notification.success(response.msg);
                $scope.loading.clienti = false;
            }, function (error) {
                    Notification.error("Errore: " + error.data.msg);
                    $scope.loading.clienti = false;
            });
        }

        $scope.aperturaProvvisorio = function (year) {
            var obj = { bchyear: year + 1 };
            $scope.loading.bonus = true;
            ContabilitaService.aperturaProvvisorio(obj).$promise.then(function (response) {
                Notification.success(response.msg);
                $scope.loading.bonus = false;
            }, function (error) {
                Notification.error("Errore: " + error.data.msg); 
                $scope.loading.bonus = false;

            });
        }
        
        $scope.chiudi = function (funct, year) {
            $ngConfirm({
                title: 'Chiudi',
                content: "Sei sicuro?",
                scope: $scope,
                closeIcon: true,
                buttons: {
                    ok: {
                        text: "Conferma",
                        btnClass: 'btn-primary',
                        keys: ['enter'], 
                        action: function (scope) {
                            funct(year);
                        }
                    },
                    cancel: {
                        text: "Annulla",
                        btnClass: 'btn-default',
                        action: function (scope) {
                            return true;
                        }
                    }
                },
            });
        }

        function getYearLimits(year) {
            var date = new Date('' + year + '-01-01T00:00:00');
            var min, max;
            min = Math.ceil(date.getTime()/1000);
            date.setFullYear(year+1);
            date.setSeconds(date.getSeconds() - 1);
            max = Math.ceil(date.getTime()/1000);
            return {from: min, to : max};
        }

    }


})();

(function() {

	'use strict';

	angular
	  .module('AmwayAdmin.contabilita.codiciiva')
      .controller('CodiceIvaCtrl', CodiceIvaCtrl);

	/** @ngInject */
	function CodiceIvaCtrl($scope, $stateParams, ContabilitaService, Notification, $state) {

        if ($stateParams.id) {
        	loadCodiceIva($stateParams.id);
        }
        else{
            $scope.codiceiva = {};
        }

        function loadCodiceIva(id) {
        	// mettere api di recall del codice iva
        	ContabilitaService.getSingleCodIva(id).$promise.then(function(response) {
        		$scope.codiceiva = response;
        		console.log("$scope.codiceiva", $scope.codiceiva);
        	}, function(error) {
        	    console.log("Errore GET singolo Codice IVA", error);
        	});
        }

        $scope.salva = function() {
        	ContabilitaService.createCodIva($scope.codiceiva).$promise.then(function(response) {
        		if ($scope.codiceiva.id) {
        			Notification.success('Codice IVA modificato con successo');
        		} else {
        			Notification.success('Codice IVA creato con successo');
        		}
        		$state.go('contabilita.codiciiva');
        	}, function(error) {
        	    console.log("Errore, impossibile salvare Codice IVA", error);
        	});
        };
    }

})();


(function () {
  'use strict';

  angular.module('AmwayAdmin.contabilita.fatture')
      .controller('FattDaControllareCtrl', FattDaControllareCtrl);

  /** @ngInject */
  function FattDaControllareCtrl($scope,ContabilitaService,DataConnectorService, Notification,$ngConfirm) {

  		$scope.dateFilter = {
  			range: { startDate: 0, endDate: 0 }
  		};

  		$scope.baseurl = DataConnectorService.getPreviewBaseUrl();
		$scope.apiurl = DataConnectorService.getBaseUrl();

  		$scope.filter = {
  			showfail : 1,
  			showarning : 0
  		};

  		$scope.invoicesTablePageSize = 25;
  		var obj = {
				table : "fattura",
				simple : [{field : 'statosdi', filter : 'fail'}]
			}

      function countFatture(){
			ContabilitaService.getElectronicInvoicesCount($scope.filter).$promise.then(function(r) {
					$scope.totalInvoices = r.ct;
					console.log($scope.totalInvoices)
                    $scope.pagesToDisplay = Math.ceil($scope.totalInvoices/$scope.invoicesTablePageSize);
					console.log('conto', r);
			}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

        countFatture();
		$scope.tableState;
		$scope.getInvoicedPag = function(tableState){
			$scope.tableState = tableState;
		    $scope.tableStateInvoices=tableState;
		    var pagination = tableState.pagination;

		    var start = pagination.start || 0;     
		    var number = pagination.number || 10;  
		    var stop = start+number;
		    var sort = {sortfield: tableState.sort.predicate, direction:tableState.sort.reverse ? 'desc' : 'asc' };

            //set the number of pages so the pagination can update\
	    	ContabilitaService.getElectronicInvoices($scope.filter,start, stop).$promise.then(function(r) {
                    $scope.invoices = r;
                    tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalInvoices / number));
				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
            });
	    }
  	


	$scope.rigenera = function(fattura, index){
		$ngConfirm({
    	        title: 'Notifica SDI',
    	        content: "Vuoi ritentare notifica allo SDI?",
    	        scope: $scope,
    	        closeIcon: true,
    	        buttons: {
    	        // long hand button definition
    	        ok: {
    	            text: "Conferma",
    	            btnClass: 'btn-primary',
    	            keys: ['enter'], // will trigger when enter is pressed
    	            action: function (scope) {
    	                console.log("Elimina movimento", $scope.movimento);
    	                ContabilitaService.regenerateInvoice(fattura).$promise.then(function(r){
								if($scope.invoices && $scope.invoices.length>index){
									if(r){
									$scope.invoices[index] = r;
									Notification.success('Fattura rigenerata con successo');
									}
									else{
										Notification.warning('Fattura rigenerata. Dati non aggiornati.');	
									}
								}
								$scope.getInvoicedPag($scope.tableState);
						},function(e){
							console.log(e);
							Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
						});
    	            }
    	        },
    	        cancel: {
    	            text: "Annulla",
    	            btnClass: 'btn-default',
    	            action: function (scope) {
    	                return true;
    	            }
    	        }
    	    },
    	});
	}

	$scope.notify = function(fattura, index){
		$ngConfirm({
    	        title: 'Notifica SDI',
    	        content: "La notifica SDI è fallita, confermi di aver notificato l'utente esternamente?",
    	        scope: $scope,
    	        closeIcon: true,
    	        buttons: {
    	        // long hand button definition
    	        ok: {
    	            text: "Conferma",
    	            btnClass: 'btn-primary',
    	            keys: ['enter'], // will trigger when enter is pressed
    	            action: function (scope) {
    	                console.log("Elimina movimento", $scope.movimento);
    	                ContabilitaService.notifyInvoice(fattura).$promise.then(function(r){
							if($scope.invoices && $scope.invoices.length>index){
								
								if(r){
								$scope.invoices[index] = r;
								Notification.success('Fattura aggiornata con successo');
								}
								else{
									Notification.warning('Fattura rigenerata. Dati non aggiornati.');	
								}

							}
							$scope.getInvoicedPag($scope.tableState);
						},function(e){
							console.log(e);
							Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
						});
    	            }
    	        },
    	        cancel: {
    	            text: "Annulla",
    	            btnClass: 'btn-default',
    	            action: function (scope) {
    	                return true;
    	            }
    	        }
    	    },
    	});
	}

	$scope.$watch("dateFilter.range", function (newValue, oldValue) {
		if (newValue && newValue != oldValue) {
			$scope.filter.datefrom = $scope.dateFilter.range.startDate ? ($scope.dateFilter.range.startDate.valueOf()/1000).toFixed(0) : undefined;
			$scope.filter.dateto = $scope.dateFilter.range.endDate ? ($scope.dateFilter.range.endDate.valueOf()/1000).toFixed(0) : undefined;
		}
	});


	$scope.applyFilter = function (){

		$scope.tableState.pagination.start = 0;
		$scope.getInvoicedPag($scope.tableState);

	}

}
})();

(function () {
  'use strict';

  angular.module('AmwayAdmin.contabilita.fatture')
      .controller('FattElettrCtrl', FattElettrCtrl);

  /** @ngInject */
  function FattElettrCtrl($scope,ContabilitaService,DataConnectorService, Notification,$ngConfirm, $state) {

  		$scope.dateFilter = {
  			range : {}
  		};

  		$scope.baseurl = DataConnectorService.getPreviewBaseUrl();
		$scope.apiurl = DataConnectorService.getBaseUrl();

  		$scope.filter = {
  			table : "passivedraft",
			sortfield : 'id',
			direction : 'desc'
  		};

  		$scope.invoicesTablePageSize = 25;

  		var obj = {
				table : "passivedraft",
		}

  		function countFatture (){
			ContabilitaService.getInvoicesPassiveDraftCount($scope.filter).$promise.then(function(r) {
					$scope.totalInvoices = r.ct;
					$scope.pagesToDisplay = Math.ceil($scope.totalInvoices/$scope.invoicesTablePageSize);
					//$tableState.pagination.numberOfPages = $scope.pagesToDisplay;
					console.log('conto', r);
			}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		$scope.tableState = {pagination : {}};
		countFatture();

		$scope.getInvoicedPag = function(tableState){
			$scope.tableState = tableState;
		    $scope.tableStateInvoices=tableState;
		    var pagination = tableState.pagination;

		    var start = pagination.start || 0;     
		    var number = pagination.number || 10;  
		    var stop = start+number;
		    var sort = {sortfield: tableState.sort.predicate, direction:tableState.sort.reverse ? 'desc' : 'asc' };
		    
		   
	    	ContabilitaService.getInvoicesPassiveDraft($scope.filter,start, stop).$promise.then(function(r) {
					$scope.invoices = r.map(function(fatt) {
						if (fatt.rawdata) {
							var raw = JSON.parse(fatt.rawdata);
							if (raw && raw.dati && raw.dati.length && raw.dati[0].totale) {
								fatt.totaldoc = parseInt(raw.dati[0].totale);
							}
						}
						return fatt;
					});
					 tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalInvoices/number));//set the number of pages so the pagination can update

				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
	    }

	    $scope.creaFornitore = function(id){
	    	$state.go('nuovo-fornitore', {idel: id});
	    }

	 


	    $scope.delete = function(row){
			$ngConfirm({
	    	        title: 'Elimina',
	    	        content: "Sei sicuro?",
	    	        scope: $scope,
	    	        closeIcon: true,
	    	        buttons: {
	    	        // long hand button definition
	    	        ok: {
	    	            text: "Conferma",
	    	            btnClass: 'btn-primary',
	    	            keys: ['enter'], // will trigger when enter is pressed
	    	            action: function (scope) {
	    	                ContabilitaService.passiveDraftDelete(row).$promise.then(function(r){
								Notification.success('Fattura eliminata');
								$scope.getInvoicedPag($scope.tableState);
							},function(e){
								console.log(e);
								Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
							});
	    	            }
	    	        },
	    	        cancel: {
	    	            text: "Annulla",
	    	            btnClass: 'btn-default',
	    	            action: function (scope) {
	    	                return true;
	    	            }
	    	        }
	    	    },
	    	});
	    }
  	


	

	$scope.$watch("dateFilter.range", function (newValue, oldValue) {
		if (newValue && newValue != oldValue) {
			var datefrom = ($scope.dateFilter.range.startDate.valueOf()/1000).toFixed(0);
			var dateto = ($scope.dateFilter.range.endDate.valueOf()/1000).toFixed(0);
			$scope.filter.range = [{field : 'datafattura', start : datefrom, stop : dateto}]
		}
	});


	$scope.applyFilter = function (){

		$scope.tableState.pagination.start = 0;
		$scope.getInvoicedPag($scope.tableState);
		countFatture();


	}

}
})();

(function () {
	'use strict';

	angular.module('AmwayAdmin.contabilita.fatture')
		.controller('FattDaControllareEECtrl', FattDaControllareEECtrl);

	/** @ngInject */
	function FattDaControllareEECtrl($scope, ContabilitaService, DataConnectorService, Notification, $ngConfirm) {

		$scope.dateFilter = {
			range: { startDate: 0, endDate: 0 }
		};

		$scope.baseurl = DataConnectorService.getPreviewBaseUrl();
		$scope.apiurl = DataConnectorService.getBaseUrl();

		$scope.filter = {
			showfail: 1,
			showarning: 0
		};

		$scope.invoicesTablePageSize = 25;
		var obj = {
			table: "fattura",
			simple: [{ field: 'statosdi', filter: 'fail' }]
		}

		function countFatture() {
			ContabilitaService.getElectronicInvoicesCountEE($scope.filter).$promise.then(function (r) {
				$scope.totalInvoices = r.ct;
				console.log($scope.totalInvoices)
				$scope.pagesToDisplay = Math.ceil($scope.totalInvoices / $scope.invoicesTablePageSize);
				console.log('conto', r);
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		countFatture();
		$scope.tableState;
		$scope.getInvoicedPag = function (tableState) {
			$scope.tableState = tableState;
			$scope.tableStateInvoices = tableState;
			var pagination = tableState.pagination;

			var start = pagination.start || 0;
			var number = pagination.number || 10;
			var stop = start + number;
			var sort = { sortfield: tableState.sort.predicate, direction: tableState.sort.reverse ? 'desc' : 'asc' };

			//set the number of pages so the pagination can update\
			ContabilitaService.getElectronicInvoicesEE($scope.filter, start, stop).$promise.then(function (r) {
				$scope.invoices = r;
				tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalInvoices / number));
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}



		$scope.rigenera = function (fattura, index) {
			$ngConfirm({
				title: 'Notifica SDI',
				content: "Vuoi ritentare notifica allo SDI?",
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Conferma",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {
							console.log("Elimina movimento", $scope.movimento);
							ContabilitaService.regenerateInvoiceEE(fattura).$promise.then(function (r) {
								if ($scope.invoices && $scope.invoices.length > index) {
									if (r) {
										$scope.invoices[index] = r;
										Notification.success('Fattura rigenerata con successo');
									}
									else {
										Notification.warning('Fattura rigenerata. Dati non aggiornati.');
									}
								}
								$scope.getInvoicedPag($scope.tableState);
							}, function (e) {
								console.log(e);
								Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
							});
						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});
		}

		$scope.$watch("dateFilter.range", function (newValue, oldValue) {
			if (newValue && newValue != oldValue) {
				$scope.filter.datefrom = $scope.dateFilter.range.startDate ? ($scope.dateFilter.range.startDate.valueOf() / 1000).toFixed(0) : undefined;
				$scope.filter.dateto = $scope.dateFilter.range.endDate ? ($scope.dateFilter.range.endDate.valueOf() / 1000).toFixed(0) : undefined;
			}
		});


		$scope.applyFilter = function () {

			$scope.tableState.pagination.start = 0;
			$scope.getInvoicedPag($scope.tableState);

		}

	}
})();

(function () {
  'use strict';

  angular.module('AmwayAdmin.contabilita.fatture')
      .controller('FatturaCtrl', FatturaCtrl);

	function FatturaCtrl($scope, $state, $stateParams, ContabilitaService, Notification) {

		function loadSingleInvoice() {
			ContabilitaService.getSingleInvoice($stateParams.ntsid).$promise.then(function(r) {
				$scope.invoiceRows = r;
			}, function(e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		};

		loadSingleInvoice();
	}

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.contabilita.fatture')
      .controller('FattureListCtrl', FattureListCtrl);

  /** @ngInject */
  function FattureListCtrl() {
}


})();

(function () {
  'use strict';

  angular.module('AmwayAdmin.contabilita.fatture2')
      .controller('Fatture2ListCtrl', Fatture2ListCtrl);

  /** @ngInject */
  function Fatture2ListCtrl($scope,ContabilitaService, Notification, DataConnectorService, $ngConfirm,UtentiService, $state) {

  		$scope.dateFilter = {};
  		$scope.customer = {};

  		$scope.baseurl = DataConnectorService.getPreviewBaseUrl();
		$scope.apiurl = DataConnectorService.getBaseUrl();

  		$scope.filter = {
  			date : {},
  			customer : {},
  			id : ''
  		};


  		$scope.invoicesTablePageSize = 25;

  		var obj = {
				table : "fattura",
				range : [],
				simple : []
			}

  		function countFatture (){
			ContabilitaService.getInvoicesCount(obj).$promise.then(function(r) {
					$scope.totalInvoices = r.ct;
					console.log($scope.totalInvoices)
					$scope.pagesToDisplay = Math.ceil($scope.totalInvoices/$scope.invoicesTablePageSize);
					$scope.tableState.pagination.numberOfPages= $scope.pagesToDisplay;
					console.log('conto', $scope.pagesToDisplay);
			}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		

		$scope.tableState;
		$scope.getInvoicedPag = function(tableState){
			$scope.tableState = tableState;
		    $scope.tableStateInvoices=tableState;
		    var pagination = tableState.pagination;

		    var start = pagination.start || 0;     
		    var number = pagination.number || 10;  
		    var stop = start+number;
			obj.sortfield = tableState.sort.predicate;
			obj.direction =tableState.sort.reverse ? 'desc' : 'asc' ;
		    
		    tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalInvoices/number));//set the number of pages so the pagination can update
	    	ContabilitaService.getInvoicesAdvanced(obj,start, stop).$promise.then(function(r) {
					$scope.invoices = r;
					countFatture();
				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
	    }


		$scope.searchCustomers= function(term){
	        if(term && term!=''){
	            ContabilitaService.searchCustomers(term).$promise
	            .then(function(r) {
	              $scope.customers = r;        
	            });
	          }
	    }
	  	


		$scope.$watch("filter.date", function (newValue, oldValue) {
			if (newValue && newValue != oldValue) {
				var datefrom = ($scope.filter.date.startDate.valueOf()/1000).toFixed(0);
				var dateto = ($scope.filter.date.endDate.valueOf()/1000).toFixed(0);
				obj.range = [{field : 'datadoc', start : datefrom, stop: dateto}];
			}
		});

		$scope.$watch("filter.customer", function (newValue, oldValue) {
			if (newValue && newValue != oldValue && newValue.conto) {

				console.log("new",newValue);
				obj.simple = obj.simple.filter(function(filter){
					return(filter.field!="cliente");
				})
				obj.simple.push({field : 'cliente', filter:$scope.filter.customer.conto});
			}
		});

		$scope.$watch("filter.id", function (newValue, oldValue) {
			if (newValue && newValue != oldValue) {
				obj.simple = obj.simple.filter(function(filter){
					return(filter.field!="id");
				})
				obj.simple.push({field : 'id', filter:$scope.filter.id});
			}
		});

		$scope.rigenera = function(fattura, index){
		$ngConfirm({
    	        title: 'Notifica SDI',
    	        content: "Vuoi ritentare notifica allo SDI?",
    	        scope: $scope,
    	        closeIcon: true,
    	        buttons: {
    	        // long hand button definition
    	        ok: {
    	            text: "Conferma",
    	            btnClass: 'btn-primary',
    	            keys: ['enter'], // will trigger when enter is pressed
    	            action: function (scope) {
    	                console.log("Elimina movimento", $scope.movimento);
    	                ContabilitaService.regenerateInvoice(fattura).$promise.then(function(r){
								if($scope.invoices && $scope.invoices.length>index){
									if(r){
									$scope.invoices[index] = r;
									Notification.success('Fattura rigenerata con successo');
									}
									else{
										Notification.warning('Fattura rigenerata. Dati non aggiornati.');	
									}
								}
								$scope.getInvoicedPag($scope.tableState);
						},function(e){
							console.log(e);
							Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
						});
    	            }
    	        },
    	        cancel: {
    	            text: "Annulla",
    	            btnClass: 'btn-default',
    	            action: function (scope) {
    	                return true;
    	            }
    	        }
    	    },
    	});
	}

	$scope.notify = function(fattura, index){
		$ngConfirm({
    	        title: 'Notifica SDI',
    	        content: "La notifica SDI è fallita, confermi di aver notificato l'utente esternamente?",
    	        scope: $scope,
    	        closeIcon: true,
    	        buttons: {
    	        // long hand button definition
    	        ok: {
    	            text: "Conferma",
    	            btnClass: 'btn-primary',
    	            keys: ['enter'], // will trigger when enter is pressed
    	            action: function (scope) {
    	                console.log("Elimina movimento", $scope.movimento);
    	                ContabilitaService.notifyInvoice(fattura).$promise.then(function(r){
							if($scope.invoices && $scope.invoices.length>index){
								
								if(r){
								$scope.invoices[index] = r;
								Notification.success('Fattura aggiornata con successo');
								}
								else{
									Notification.warning('Fattura rigenerata. Dati non aggiornati.');	
								}

							}
							$scope.getInvoicedPag($scope.tableState);
						},function(e){
							console.log(e);
							Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
						});
    	            }
    	        },
    	        cancel: {
    	            text: "Annulla",
    	            btnClass: 'btn-default',
    	            action: function (scope) {
    	                return true;
    	            }
    	        }
    	    },
    	});
	}



		$scope.applyFilter = function (){
			$scope.tableState.pagination.start = 0;
			$scope.getInvoicedPag($scope.tableState);
		}

		$scope.resetFilters = function(){
			$scope.filter = {
	  			date : {},
	  			customer : {},
	  			id : ''
	  		};

	  		obj = {
					table : "fattura",
					range : [],
					simple : []
			}
			$scope.applyFilter();
		}

		$scope.goToUser = function(code){
			UtentiService.getUserByConto(code).$promise.then(function(user) {
						$state.go('modifica-utente', {
						    id: user[0].id //selectedItem and id is defined
						});
				}, function(e) {
						console.log(e);
						Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		var dictEsito = {};
			dictEsito['REJECTED']='red';
			dictEsito['TOCHECK']='red';
			dictEsito['NOT_DELIVERED']='orange';
			dictEsito['PENDING']='gray';

		$scope.getEsitoColor = function(esito){
			return dictEsito[esito];
		}

}
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('AmwayAdmin.contabilita.liquidazioneivamens')
		.controller('LiquidazioneIvaMensCtrl', LiquidazioneIvaMensCtrl);

	/** @ngInject */
	function LiquidazioneIvaMensCtrl($scope, $stateParams, $state, ContabilitaService, $ngConfirm, Notification, $window) {

		$scope.list = [];
		$scope.tablePageSize = 25;
		$scope.loading = false;

		$scope.filter = {
			table: "liquidazioneivamensile",
			sortfield: 'insdate',
			direction: 'desc'
		};

		// function getList() {
		// 	ContabilitaService.getLiquidazioneMensile().$promise.then(function (r) {
		// 		$scope.list = r;
		// 	}, function (e) {
		// 		Notification.error(e.data.msg);
		// 	});
		// }

		// getList();

		$scope.sendMov = function (row) {
			ContabilitaService.liqivamensMov(row).$promise.then(function (r) {
				getListPag();
			}, function (e) {
				Notification.error(e.data.msg);
			});
		};

		function countList() {
			ContabilitaService.getLiquidazioneMensileCount($scope.filter).$promise.then(function (r) {
				$scope.totalRows = r.ct;
				$scope.pagesToDisplay = Math.ceil($scope.totalRows / $scope.tablePageSize);
				//$tableState.pagination.numberOfPages = $scope.pagesToDisplay;
				console.log('conto', r);
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		$scope.tableState = { pagination: {} };
		countList();

		$scope.getListPag = function (tableState) {
			console.log('%c getListPag', 'color:#FFB86C');
			$scope.tableState = tableState;
			var pagination = tableState.pagination;

			var start = pagination.start || 0;
			var number = pagination.number || 10;
			var stop = start + number;
			var sort = { sortfield: tableState.sort.predicate, direction: tableState.sort.reverse ? 'desc' : 'asc' };


			ContabilitaService.getLiquidazioneMensile($scope.filter, start, stop).$promise.then(function (r) {
				$scope.list = r;
				//set the number of pages so the pagination can update
				tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalRows / number));
				$scope.loading = false;

			}, function (e) {
				console.log(e);
				$scope.loading = false;
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}
	}
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('AmwayAdmin.contabilita.liquidazioneiva')
		.controller('LiquidazioneIvaCtrl', LiquidazioneIvaCtrl);

	/** @ngInject */
	function LiquidazioneIvaCtrl($scope, $stateParams, $state, DataConnectorService, ContabilitaService, $ngConfirm, Notification, $window) {

		$scope.baseurl = DataConnectorService.getBaseUrl();

		$scope.monthMap = {
			0: 'Gennaio',
			1: 'Febbraio',
			2: 'Marzo',
			3: 'Aprile',
			4: 'Maggio',
			5: 'Giugno',
			6: 'Luglio',
			7: 'Agosto',
			8: 'Settembre',
			9: 'Ottobre',
			10: 'Novembre',
			11: 'Dicembre'
		}

		// set date di ricerca iniziale su mese precedente da inizio a fine
		var startdate = new Date();
		startdate.setMonth(startdate.getMonth() - 1);
		startdate.setDate(1);
		startdate.setHours(0, 0, 0, 0);

		var d = new Date();
		var enddate = new Date(d.getFullYear(), d.getMonth(), 0);
		enddate.setHours(23, 59, 59, 0);

		$scope.dates = {
			start: (startdate).getTime() / 1000,
			stop: (enddate).getTime() / 1000,
		};
		$scope.stopDatePDF = {};

		$scope.$watch("dates.stop", function (newValue, oldValue) {
			// manipola 23.59 dateto
			var dateto = new Date(newValue * 1000);
			dateto = dateto.setHours(23, 59, 59, 0);
			$scope.stopDatePDF = String(dateto / 1000);

		});


		var sections = ["C", "H", "T", "V", "A", "B", "D", "Z", "F"];
		$scope.sectionsList = {
			c: [],
			h: [],
			t: [],
			v: [],
			a: [],
			b: [],
			d: [],
			z: [],
			f: []

		};
		$scope.sectionsList = [];




		$scope.getSezioni = function (start, stop) {
			$scope.sectionsList = [];

			var dateto = new Date(stop * 1000);
			dateto = dateto.setHours(23, 59, 59, 0);
			stop = dateto / 1000;


			angular.forEach(sections, function (e) {
				ContabilitaService.getSezione(e, start, stop).$promise.then(function (r) {
					switch (e) {
						case "C": $scope.sectionsList.c = r; break;
						case "H": $scope.sectionsList.h = r; break;
						case "T": $scope.sectionsList.t = r; break;
						case "V": $scope.sectionsList.v = r; break;
						case "A": $scope.sectionsList.a = r; break;
						case "B": $scope.sectionsList.b = r; break;
						case "D": $scope.sectionsList.d = r; break;
						case "Z": $scope.sectionsList.z = r; break;
						case "F": $scope.sectionsList.f = r; break;
					}
					$scope.sectionsList[e] = r;
				});
			})
		}

		$scope.getSezioni($scope.dates.start, $scope.dates.stop);
		getLiqIvaMensile();

		function getLiqIvaMensile() {
			var liqdate = new Date($scope.dates.start * 1000);
			$scope.selectedmonth = liqdate.getMonth() + 1;
			$scope.selectedyear = liqdate.getFullYear();

			ContabilitaService.getLiqIvaMensile($scope.selectedmonth, $scope.selectedyear).$promise.then(function (r) {
				$scope.liqiva = r;

			});

		}

		$scope.search = function () {
			$scope.getSezioni($scope.dates.start, $scope.dates.stop);
			getLiqIvaMensile();

		}

		$scope.saveliqiva = function () {
			ContabilitaService.salvaAcconto($scope.liqiva).$promise.then(function (r) {
				$scope.liqiva = r;
				Notification.success("Acconto salvato");
			}, function (e) {
				Notification.error(e.msg);
			});
		}



		$scope.reset = function () {
			$scope.dates = {
				start: (startdate).getTime() / 1000,
				stop: (enddate).getTime() / 1000,
			};
			$scope.getSezioni($scope.dates.start, $scope.dates.stop);
		};

	}
})();

(function () {

	'use strict';

	angular
		.module('AmwayAdmin.contabilita.movimenti')
		.controller('MovimentoCtrl', MovimentoCtrl)
		.filter('filtroconti', filtroconti);

	/** @ngInject */
	function MovimentoCtrl($scope, $stateParams, DataConnectorService, ConfigService, ContabilitaService, Notification, $location, $ngConfirm, $state, $uibModal) {

		$scope.newMov = false;
		$scope.noMovIva = false;
		$scope.checkNgValues = false;
		$scope.movBloccati = 0;
		$scope.extraFieldsPerFattureEstere = {};
		$scope.generazioneAutomaticaBtn = false;
		$scope.headerNote = {
			value: '',
		};

		var causali = [
			'FAE',
			'FAEX',
			'FARC',
			'NCE',
			'NCEX',
			'NCRC',
		];

		var iddel = undefined;

		if ($stateParams.id) {
			loadMovimento($stateParams.id);
		}
		else if ($stateParams.orderid) {
			creaNotaCredito($stateParams.orderid);
		}
		else {
			$scope.movimento = { header: {}, movdett: [], movra: [], moviva: [], totaledare: 0, totaleavere: 0, scostamentodare: 0, scostamentoavere: 0, stato: 'draft' };
			$scope.dati = {};
			$scope.newMov = true;
			initMovimento();


		}

		if ($location.search().iddel && $location.search().iddel != '') {
			iddel = angular.copy($location.search().iddel);
			contabilizza($location.search().iddel);
		}




		$scope.editable = false;
		$scope.makeEditable = function () {
			$scope.editable = !$scope.editable;
			$scope.dati = {};
			console.log("$scope.editable", $scope.editable);

			$scope.bloccaMovimenti();
		};

		$scope.bloccaMovimenti = function () {
			// se mov bloccati > 0, bloccare i movimenti iva con flag paginaregistro > 0
			// bloccare tutte le righe di movdett con conto che comincia con 310.
			$scope.movimento.movdett.forEach(function (r) {
				var contolike = r.conto.substring(0, 3);
				if ($scope.movBloccati > 0 && contolike == '310') {
					r.movblocked = true;
				}
			});
			console.log('MOVDETT ARRAY', $scope.movBloccati, $scope.movimento.movdett);
		};

		$scope.deleteMovimento = function () {
			$ngConfirm({
				title: 'Elimina Movimento',
				content: "Sei sicuro di eliminare il movimento?",
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Conferma",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {
							// console.log("Elimina movimento", $scope.movimento);
							ContabilitaService.deleteMovimento($scope.movimento).$promise.then(function (r) {
								$state.go('contabilita.ricerca');
								Notification.success('Movimento cancellato con successo');
							}, function (e) {
								Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
							});
						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});


		};


		$scope.resetMovimento = function () {
			$scope.movimento = { header: {}, movdett: [], movra: [], moviva: [], totaledare: 0, totaleavere: 0, scostamentodare: 0, scostamentoavere: 0, stato: 'draft' };
			$scope.dati = {};
			initMovimento();
		}

		function initMovimento() {
			ContabilitaService.initMovimento().$promise.then(function (r) {
				$scope.initdata = r;
				$scope.movimento.header.nummov = $scope.initdata.nummov;

				$scope.movimento.header.causale = $scope.initdata.lastcausale;
				$scope.movimento.header.datamov = $scope.initdata.lastdatareg;

			}, function (e) {
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');

			})




		}

		if ($location.search().bonus && $location.search().bonus != '') {
			console.log("bonus", $location.search().bonus);
			var date = parseInt((new Date).getTime() / 1000);
			if ($location.search().date && $location.search().date != '') {

				date = $location.search().date;
			}

			ContabilitaService.contabilizzaBonus($location.search().bonus, date).$promise.then(function (r) {


				$scope.movimento = r;

			}, function (e) {
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');

			})
		}

		// return to search and keep criterias
		$scope.enableBackToSearchBtn = false;

		if ($stateParams.fromUrl == 'ricerca' || $stateParams.fromUrl == 'ricercaiva') {
			$scope.enableBackToSearchBtn = true;
		}

		$scope.backToSearch = function () {
			if ($stateParams.fromUrl == 'ricerca') {
				console.log('BACK TO RICERCA');
				var cliente = $stateParams.ricerca.cliente ? 'cliente=' + $stateParams.ricerca.cliente + '&' : '';
				var fornitore = $stateParams.ricerca.fornitoreId ? 'fornitore=' + $stateParams.ricerca.fornitoreId + '&' : '';
				var contofrom = $stateParams.ricerca.contofrom ? 'contofrom=' + $stateParams.ricerca.contofrom + '&' : '';
				var contoto = $stateParams.ricerca.contoto ? 'contoto=' + $stateParams.ricerca.contoto + '&' : '';
				var datefrom = $stateParams.ricerca.datefrom ? 'datefrom=' + $stateParams.ricerca.datefrom + '&' : '';
				var dateto = $stateParams.ricerca.dateto ? 'dateto=' + $stateParams.ricerca.dateto + '&' : '';

				$location.url('/ricercamovimenti?' + cliente + fornitore + contofrom + contoto + datefrom + dateto);
			} else if ($stateParams.fromUrl == 'ricercaiva') {
				console.log('BACK TO RICERCA IVA');
				var datefrom = $stateParams.ricerca.datefrom ? 'datefrom=' + $stateParams.ricerca.datefrom + '&' : '';
				var dateto = $stateParams.ricerca.dateto ? 'dateto=' + $stateParams.ricerca.dateto + '&' : '';

				$location.url('/ricercamovimentiiva?' + datefrom + dateto);
			}
		};
		// END - return to search and keep criterias



		$scope.nuovoRecord = function () {
			console.log('editable', $scope.editable);
			$scope.movimento.movdett.push({
				causale: $scope.movimento.causale, importo: 0, dare: 0, avere: 0, protocollo: ($scope.dati.selectedProtocollo ? $scope.dati.selectedProtocollo.protocollo : undefined),
				datacompda: $scope.movimento.header.datacompda, datacompa: $scope.movimento.header.datacompa
			});
		}


		$scope.nuovoRecordIva = function () {

			$scope.movimento.moviva.push({ idmov: $scope.movimento.header.ntsid });
		}


		$scope.nuovoRecordRa = function () {

			$scope.movimento.movra.push({ idmov: $scope.movimento.header.ntsid });
		}


		$scope.eliminaRecord = function (index) {

			$scope.movimento.movdett.splice(index, 1);
			$scope.calcolaTotali($scope.movimento);
		}

		$scope.initImporto = function (r) {
			r.avere = 0;
			r.dare = 0;
			if (r.segno == 'A')
				r.avere = r.importo;
			else r.dare = r.importo;
			$scope.caricaConto(r);
		}

		$scope.calcolaTotali = function (movimento, getconti, connected) {
			// controlla presenza di movimenti iva
			if (!connected) {
				var contoiva = 0;
				movimento.movdett.forEach(function (m) {
					if (m.conto === '310010' || m.conto === '310020') contoiva = contoiva + 1;
				});
				$scope.noMovIva = (contoiva == 0) ? true : false;
			}

			movimento.totaledare = 0;
			movimento.totaleavere = 0;
			movimento.movdett.forEach(function (r) {
				if (r.segno == 'A') {
					movimento.totaleavere = movimento.totaleavere + r.importo;

				}
				else {
					movimento.totaledare = movimento.totaledare + r.importo;
				}


			});

			movimento.ngimponibile = 0;
			movimento.ngimposta = 0;
			movimento.ngimpostanovent = 0;
			movimento.ngimpostavaluta = 0;
			movimento.moviva.forEach(function (r) {
				if ((movimento.header.causale !== 'FAE' && movimento.header.causale !== 'FARC' && movimento.header.causale !== 'NCE') ||
					(movimento.header.causale === 'FAE' && r.protocollo.startsWith('B')) ||
					(movimento.header.causale === 'NCE' && r.protocollo.startsWith('B')) ||
					(movimento.header.causale === 'FARC' && r.protocollo.startsWith('T'))) {
					movimento.ngimponibile = movimento.ngimponibile + r.imponibile;
					var movivacodice = r.codiceiva.toLowerCase();
					if (movivacodice != 'in22') {
						movimento.ngimposta = movimento.ngimposta + r.imposta;
						movimento.ngimpostanovent = movimento.ngimpostanovent + r.impostanovent;
						movimento.ngimpostavaluta = movimento.ngimpostavaluta + r.impostavaluta;
					}
				}
				if (r.paginaregistro !== null && r.paginaregistro > 0) {
					$scope.movBloccati++;
				}
			});

			// if (!connected && !$scope.newMov) {
			// 	if (Math.abs(movimento.ngimponibile) + Math.abs(movimento.ngimposta) != movimento.totaledare) {
			// 		$scope.checkNgValues = true;
			// 	} else {
			// 		$scope.checkNgValues = false;
			// 	}
			// }
		}



		$scope.setDare = function (r) {
			if (r.dare != undefined) {
				r.segno = 'D';
				r.importo = r.dare;
				r.avere = 0;
				r.impvaluta = r.cambio * r.dare;
				$scope.calcolaTotali($scope.movimento);
			}
		}

		$scope.setAvere = function (r) {
			if (r.avere != undefined) {
				r.segno = 'A';
				r.importo = r.avere;
				r.dare = 0;
				r.impvaluta = r.cambio * r.avere;
				$scope.calcolaTotali($scope.movimento);
			}
		}

		// ritorna true o false per abilitare o meno il salvataggio del movimento in base alle condizioni date
		$scope.checkSalvaMovimento = function () {
			if (!$scope.editable && !$scope.newMov) return;

			var causaliIVA = ['FTA', 'NCA', 'FAV', 'FAE', 'FARC', 'FTV', 'NVC', 'NCE'];
			var causaliIVACompensazione = ['FAE', 'FARC', 'NCE'];

			// controllo per TUTTE le causali
			if (!$scope.movimento.movdett || !$scope.movimento.movdett.length) return true;
			if ($scope.movimento.totaledare - $scope.movimento.totaleavere != 0) return true;

			console.log('%c 1° controllo SALVA MOVIMENTO', 'color:#8BE9FD');
			// controllo per sole causali FTA, NCA, FAV, FAE, FARC se ci sono movimenti IVA
			// FAE, FARC, FTA, NCA, FAV -> check su 310010
			// FTV, NCV -> check su 310020
			// NOTA1: fare controllo su numero assoluto
			// NOTA2: controllare dare o avere in base a cosa è != da 0
			if (causaliIVA.indexOf($scope.movimento.header.causale) >= 0 && !$scope.noMovIva) {
				console.log('%c 2° controllo SALVA MOVIMENTO', 'color:#FF79C6');

				var totaleIVA = 0;

				$scope.movimento.movdett.forEach(function (m) {
					console.log('emme', m);
					if (m.conto === '310010' || m.conto === '310020') {

						// su causali FAE e FARC l'IVA si compensa, pertanto conteggiare solo 1 delle due
						if (causaliIVACompensazione.indexOf($scope.movimento.header.causale) >= 0) {
							console.log('%c 3° controllo SALVA MOVIMENTO, IVA a compensazione', 'color:#FF2600');
							if (m.conto === '310010') totaleIVA += m.dare || m.avere;
						}
						// su causali != da FAE e FARC e NCE si sommano tutte le IVA (acquisti e vendite)
						else {
							console.log('%c 4° controllo SALVA MOVIMENTO', 'color:#FF2600');
							totaleIVA += m.dare || m.avere;
						}

					}
				});

				console.log('%c 5° controllo SALVA MOVIMENTO check match', 'color:#FFB86C', Math.abs(totaleIVA), Math.abs($scope.movimento.ngimposta));
				// se non c'è corrispondenza tra totale iva calcolato e quello calcolato dai movimenti iva "ngimposta", disabilita il pulsante di salvataggio
				if (Math.abs(totaleIVA) != Math.abs($scope.movimento.ngimposta)) return true;
			}
			// ng-disabled = false, ABILITA il salvataggio del movimento se tutti gli altri controlli vengono falliti
			return false;
		}



		getCausali();
		getTipiPagamento();


		//non dovrebbe più essere usata
		function creaNotaCredito(id) {
			ContabilitaService.notaCreditoOrder(id).$promise.then(function (r) {
				$scope.movimento = r;
				$scope.calcolaTotali($scope.movimento, true);
			}, function (e) {
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			})
		}


		function loadMovimento(id) {
			ContabilitaService.getMovimento(id).$promise.then(function (r) {
				$scope.movimento = r;
				$scope.calcolaTotali($scope.movimento, true);
				if ($scope.movimento.connected) {
					$scope.calcolaTotali($scope.movimento.connected, true, true);
				}
				if ($scope.movimento.header.note) $scope.headerNote.value = angular.copy($scope.movimento.header.note);
			}, function (e) {
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			})
		}

		$scope.generazioneAutomatica = function () {

			if (!$scope.movimento.header.datamov || !$scope.movimento.header.datadoc) {
				Notification.warning('Seleziona prima le date');
				return;
			}

			if (!$scope.movimento.header.numdoc && causali.indexOf($scope.movimento.header.causale) >= 0) {
				Notification.warning('Inserisci prima un Numero Documento');
				return;
			}

			if ($scope.generazioneAutomaticaBtn) {


				var popup = $uibModal.open({
					animation: true,
					controller: GenerazioneAutomaticaDialogController,
					templateUrl: 'app/contabilita/movimenti/generazioneautomatica-dialog.html',
					size: 'lg',
					windowClass: 'xl-modal-window',
					resolve: {
						movimento: function () {
							return $scope.movimento
						}
					}
				});


				popup.result.then(function (r) {
					$scope.movimento = r;
					$scope.calcolaTotali($scope.movimento);
					if ($scope.movimento.connected) {
						$scope.calcolaTotali($scope.movimento.connected, false, true);
					}

					// salvo i campi extra per le fatture estere 
					// https://gitlab.elbuild.com/nts/nts/-/issues/43
					$scope.extraFieldsPerFattureEstere = {
						fatturaee: r.fatturaee,
						righefatturaee: r.righefatturaee,
					};
					// console.log('%c noMovIva', 'color:#FFB86C', $scope.noMovIva);
					// console.log('%c checkNgValues', 'color:#FFB86C', $scope.checkNgValues);
					// console.log('%c MOVIMENTO', 'color:#FFB86C', $scope.movimento);
				}, function () {
					// Cancel
					console.log('cancel');
				});


			}
		}

		function contabilizza(id) {
			var datedraft = '';
			var date = '';
			if ($location.search().datedraft && $location.search().datedraft != '') {
				datedraft = $location.search().datedraft;
				date = $location.search().date;
			}

			ContabilitaService.contabilizzaFattura(id, date, datedraft).$promise.then(function (result) {
				console.log('%c result', 'color:#FFB86C', result);
				$scope.movimento = result;
				$scope.calcolaTotali($scope.movimento);
				if ($scope.movimento.connected) $scope.calcolaTotali($scope.movimento.connected, false, true);
			}, function (error) {
				console.log(error.data.msg);
			});
		}

		function checkConti() {
			return _.some($scope.movimento.movdett, function (item) {
				console.log(!item.conto);
				return !item.conto;
			})


		}


		$scope.salva = function () {
			$scope.movimento.movdett = $scope.movimento.movdett.map(function (item) {
				item.impvaluta = parseInt(item.impvaluta);
				return item;
			});

			if ($scope.headerNote && $scope.headerNote.value) $scope.movimento.header.note = angular.copy($scope.headerNote.value);
			console.log('%c movimento', 'color:#FFB86C', $scope.movimento);

			if (checkConti()) {
				Notification.error('Inserisci il conto per tutte le righe');

			}
			else {
				$ngConfirm({
					title: 'Crea Movimento',
					content: "Sei sicuro di salvare il movimento?",
					scope: $scope,
					closeIcon: true,
					buttons: {
						// long hand button definition
						ok: {
							text: "Conferma",
							btnClass: 'btn-primary',
							keys: ['enter'], // will trigger when enter is pressed
							action: function (scope) {
								$scope.movimento.fatturaee = $scope.extraFieldsPerFattureEstere.fatturaee || $scope.movimento.fatturaee;
								$scope.movimento.righefatturaee = $scope.extraFieldsPerFattureEstere.righefatturaee || $scope.movimento.righefatturaee;

								if (!$scope.movimento.header.id) {
									if (iddel) $scope.movimento.passivedraftid = parseInt(iddel);
									ContabilitaService.createMovimento($scope.movimento).$promise.then(function (r) {
										$scope.movimento = r;
										$state.go('contabilita.edit-movimento', { id: r.header.ntsid });
										Notification.success('Movimento salvato');
									}, function (e) {
										Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
									})
								}
								else {
									ContabilitaService.updateMovimento($scope.movimento).$promise.then(function (r) {
										$scope.movimento = r;
										$state.go('contabilita.edit-movimento', { id: r.header.ntsid });
										Notification.success('Movimento aggiornato');
										$scope.editable = false;
									}, function (e) {
										Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
									})
								}
							}
						},
						cancel: {
							text: "Annulla",
							btnClass: 'btn-default',
							action: function (scope) {
								return true;
							}
						}
					},
				});
			}
		}



		function getCausali() {
			ContabilitaService.getCausali().$promise.then(function (r) {
				$scope.causali = r;
				$scope.protocolli = _.uniq($scope.causali, function (c) { return c.protocollo; });
			}, function (e) {
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			})
		}



		function getTipiPagamento() {
			ContabilitaService.getTipiPagamento().$promise.then(function (r) {
				$scope.tipipagamento = r;
			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}



		$scope.searchAccounts = function (searchterm) {
			ContabilitaService.searchAccounts(searchterm).$promise.then(function (response) {
				$scope.accounts = response;
			});
		};

		$scope.searchSuppliers = function (searchterm) {
			ContabilitaService.searchSuppliers(searchterm).$promise.then(function (response) {
				$scope.suppliers = response;
			});
		};

		$scope.searchCustomers = function (searchterm) {
			ContabilitaService.searchCustomers(searchterm).$promise.then(function (response) {
				$scope.customers = response;
			});
		};

		$scope.aggiornaConto = function (r) {
			console.log('aggiornaconto', r);
			if (r.selectedconto)
				r.conto = r.selectedconto.codice || r.selectedconto.conto;
			var riga = r;
			ContabilitaService.getPartiteAperte(r.conto).$promise.then(function (p) {
				console.log("partite aggiornaconto", p);
				riga.partite = p;
			});


		}

		$scope.caricaConto = function (r) {
			if (!r.selectedconto && r.conto) {
				if (r.conto.startsWith('C')) {
					ContabilitaService.getUtenteByConto(r.conto).$promise.then(function (re) {
						if (re && re.length && re[0].conto || re[0].codice)
							r.selectedconto = re[0];
						// console.log(r.conto, 'contocliente', r.selectedconto);
						r.filtra = 'clienti';
					});
				}
				else
					if (r.conto.startsWith('F')) {
						ContabilitaService.getFornitoreByConto(r.conto).$promise.then(function (re) {
							if (re && re.length && re[0].conto || re[0].codice)
								r.selectedconto = re[0];
							// console.log(r);
							// console.log(r.conto,'contofornitore', r.selectedconto);
							r.filtra = 'fornitori';
						});
					}
					else {
						ContabilitaService.getContoByCodice(r.conto).$promise.then(function (re) {
							if (re && re.conto || re.codice)
								r.selectedconto = re;
							// console.log(r.conto,  r.selectedconto);
						});
					}
			}
		}

		function hideShowGenerazioneAutomatica() {
			var listCausaliGenerazioneAutomatica = [
				'FAE',
				'FAEX',
				'FARC',
				'FAV',
				'FTA',
				'FTV',
				'INCA',
				'NCA',
				'NCE',
				'NCEX',
				'NCRC',
				'NCV',
				'PAGA',
				'PAGB',
			];

			$scope.generazioneAutomaticaBtn = listCausaliGenerazioneAutomatica.indexOf($scope.movimento.header.causale) >= 0;
		}

		$scope.$watch("dati.selectedCausale", function (newValue, oldValue) {
			// console.log("dati.selectedCausale",newValue, oldValue);
			if (newValue && newValue != oldValue) {
				$scope.movimento.header.causale = $scope.dati.selectedCausale.codice;
				$scope.dati.selectedProtocollo = $scope.dati.selectedCausale;
			}
			hideShowGenerazioneAutomatica();
		});

		$scope.$watch("dati.selectedProtocollo", function (newValue, oldValue) {

			if (newValue && newValue != oldValue) {
				$scope.movimento.movdett.forEach(function (t) { t.protocollo = newValue.protocollo; });
			}
		});




		$scope.$watch("dati.selectedTipopag", function (newValue, oldValue) {

			if (newValue && newValue != oldValue) {
				$scope.movimento.header.codicepag = $scope.dati.selectedTipopag.codice;
			}
		});


		$scope.$watch("movimento.header.datacompda", function (newValue, oldValue) {
			if (newValue && newValue != oldValue) {
				aggiornaDataRighe('datacompda', newValue);
			}
		});

		$scope.$watch("movimento.header.datacompa", function (newValue, oldValue) {
			if (newValue && newValue != oldValue) {
				aggiornaDataRighe('datacompa', newValue);
			}
		});


		function aggiornaDataRighe(data, value) {
			$scope.movimento.movdett.forEach(function (r) {
				r[data] = value;
			})
		}




		$scope.aggiornaRigaPartita = function (riga) {
			// console.log('aggiornarigapartita', riga);
			if (riga && riga.selectedpartita) {
				riga.partita = riga.selectedpartita.partita;
				if (riga.conto && riga.conto.startsWith('C')) {
					riga.avere = riga.selectedpartita.dare || riga.selectedpartita.avere;
					$scope.setAvere(riga);
				}
				else {
					riga.dare = riga.selectedpartita.dare || riga.selectedpartita.avere;
					$scope.setDare(riga);
				}


			}
		}


	}


	function filtroconti() {
		return function (items, tipo) {
			// console.log('filtroconti', tipo);
			if (tipo == undefined)
				return items;

			var newItems = [];
			for (var i = 0; i < items.length; i++) {
				// console.log(items[i], items[i].tipo, tipo);
				if (items[i].tipo == tipo) {
					newItems.push(items[i]);
				}
			};

			return newItems;
		}
	}

	function GenerazioneAutomaticaDialogController($scope, $uibModalInstance, UtentiService, Notification, ContabilitaService, movimento) {

		$scope.showTDSDISelect = false;

		if (movimento) {
			$scope.movimento = movimento;
		}

		$scope.request = {};
		$scope.datirequest = {};

		if ($scope.movimento.header.causale == 'NCV') {

			$scope.request.ncvsave = 1;
			$scope.request.savenow = 0;
			$scope.request.ncvspese = '0';
		}

		if ($scope.movimento.header.causale == 'PAGA' || $scope.movimento.header.causale == 'PAGB') {
			$scope.request.spesepagamento = 0;
		}

		// $scope.request.note = $scope.movimento.header.note;

		$scope.$watch("datirequest.selectedFornitore", function (newValue, oldValue) {
			// console.log('datirequest.selectedFornitore');
			if (newValue && newValue != oldValue) {
				$scope.request.fornitore = $scope.datirequest.selectedFornitore.codice;
				if ($scope.movimento.header.causale == 'PAGA' || $scope.movimento.header.causale == 'PAGB') {
					getPartiteAperte($scope.request.fornitore);
				}
				if ($scope.movimento.header.causale == 'FTA' || $scope.movimento.header.causale == 'NCA' || $scope.movimento.header.causale == 'FAV') {
					$scope.request.nonsoggra = 0;
				}
			}
		});

		$scope.$watch("datirequest.selectedCliente", function (newValue, oldValue) {

			if (newValue && newValue != oldValue) {
				$scope.request.cliente = $scope.datirequest.selectedCliente.id;
				if ($scope.movimento.header.causale == 'INCA') {
					$scope.request.contobanca = $scope.datirequest.selectedCliente.conto;
					getPartiteAperte($scope.request.contobanca);
				}

			}
		});


		$scope.$watch("datirequest.selectedConto", function (newValue, oldValue) {

			if (newValue && newValue != oldValue) {
				$scope.request.contobanca = $scope.datirequest.selectedConto.codice;
			}
		});


		function getPartiteAperte(conto) {
			// console.log('getPartiteAperte');
			ContabilitaService.getPartiteAperte(conto).$promise.then(function (p) {
				// console.log("partite", p);
				$scope.partite = p;
			});
		}
		$scope.searchFornitore = function (term) {
			if (term && term != '') {
				ContabilitaService.searchSuppliers(term).$promise
					.then(function (r) {
						$scope.fornitori = r;
					});
			}
		}


		$scope.searchCliente = function (term) {
			if (term && term != '') {
				ContabilitaService.searchCustomers(term).$promise
					.then(function (r) {
						$scope.clienti = r;
					});
			}
		}

		$scope.searchAccounts = function (searchterm) {
			ContabilitaService.searchAccounts(searchterm).$promise.then(function (response) {
				$scope.accounts = response;
			});
		};

		$scope.aggiornaRighePaga = function (riga) {
			// console.log('aggiornaRigaPaga', riga);
			if (riga) {
				aggiornaRigaPaga(riga);
			}
			else if ($scope.request.lines) {
				$scope.request.lines.forEach(function (r) {
					aggiornaRigaPaga(r);
				});
			}

		}


		function aggiornaRigaPaga(riga) {
			if (riga && riga.selectedpartita) {
				riga.partita = riga.selectedpartita.partita;
				riga.importo = riga.selectedpartita.avere - riga.selectedpartita.dare;
				riga.note = 'Pagamento partita ' + riga.selectedpartita.partita;
				if ($scope.datirequest.selectedConto && $scope.datirequest.selectedConto.codice)
					riga.note = riga.note + ' da conto ' + $scope.datirequest.selectedConto.codice;
			}
		}

		$scope.nuovaLine = function () {
			if ($scope.request.lines == undefined) {
				$scope.request.lines = [];

				if ($scope.movimento.header.causale == 'FTV' || $scope.movimento.header.causale == 'NCV' || $scope.movimento.header.causale == 'FTA' || $scope.movimento.header.causale == 'NCA' || $scope.movimento.header.causale == 'FAV' || $scope.movimento.header.causale == 'FARC' || $scope.movimento.header.causale == 'FAE' || $scope.movimento.header.causale == 'FAEX' || $scope.movimento.header.causale == 'NCE' || $scope.movimento.header.causale == 'NCEX' || $scope.movimento.header.causale == 'NCRC')
					getCodiciIva();


			}
			var codiceiva;
			if ($scope.movimento.header.causale == 'FTV' || $scope.movimento.header.causale == 'NCV' || $scope.movimento.header.causale == 'FTA' || $scope.movimento.header.causale == 'NCA' || $scope.movimento.header.causale == 'FAV' || $scope.movimento.header.causale == 'FARC' || $scope.movimento.header.causale == 'FAE' || $scope.movimento.header.causale == 'FAEX' || $scope.movimento.header.causale == 'NCE' || $scope.movimento.header.causale == 'NCEX' || $scope.movimento.header.causale == 'NCRC') {
				if ($scope.datirequest.selectedFornitore) {
					codiceiva = $scope.datirequest.selectedFornitore.codiceiva
				}

				if ($scope.datirequest.selectedCliente) {
					codiceiva = $scope.datirequest.selectedCliente.codiceiva
				}
			}

			$scope.request.lines.push({ codiceiva: codiceiva, importo: null });
		}



		function getCodiciIva() {
			ContabilitaService.getCodiciIva().$promise.then(function (r) {
				$scope.codiciiva = r;
			}, function (e) {
				console.log(e);
			});
		}





		$scope.eliminaLine = function (index) {

			$scope.request.lines.splice(index, 1);
		}




		$scope.cancel = function () {
			$scope.request = {};
			$uibModalInstance.dismiss();
		};
		$scope.answer = function (answer) {
			$uibModalInstance.close(answer);
		};

		$scope.salva = function () {

			var type = $scope.movimento.header.causale.toLowerCase();
			if (type == 'fta' || type == 'nca' || type == 'fav' || type == 'fae' || type == 'faex' || type == 'ftv' || type == 'ncv' || type == 'farc' || type == 'nce' || type == 'ncex' || type == 'ncrc') {
				$scope.request.numdoc = $scope.movimento.header.numdoc;
			}

			$scope.request.datamov = $scope.movimento.header.datamov;
			$scope.request.datacomda = $scope.movimento.header.datacompda;
			$scope.request.datacoma = $scope.movimento.header.datacompa;
			$scope.request.datadoc = $scope.movimento.header.datadoc;

			ContabilitaService.completeMovimento(type, $scope.request).$promise.then(function (r) {
				$scope.movimento = r;
				$scope.movimento.header.note = '';
				$scope.request = {};
				$scope.answer(r);

			}, function (e) {
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		};

		$scope.setTdsdi = function () {
			var causali = [
				'FAE',
				'FAEX',
				'FARC',
				'NCE',
				'NCEX',
				'NCRC',
			];

			if (causali.indexOf($scope.movimento.header.causale) >= 0) {
				$scope.request.tdsdi = $scope.datirequest.selectedFornitore.tdsdi;
				$scope.showTDSDISelect = true;
			} else {
				$scope.showTDSDISelect = false;
			}
		}

	}

}());


(function () {

	'use strict';

	angular
		.module('AmwayAdmin.contabilita.movimenti')
		.controller('RicercaCtrl', RicercaCtrl);

	/** @ngInject */
	function RicercaCtrl($scope, $location, $window, $stateParams, $state, DataConnectorService, ConfigService, ContabilitaService, UtentiService, Notification, ElPrintService, ConstantsService) {

		var inizio = moment().startOf('year').valueOf() / 1000;
		$scope.fairicerca = false;
		$scope.ricerca = {
			dateto: parseInt((new Date).getTime() / 1000),
			datefrom: inizio
		};
		$scope.resetRicerca = angular.copy($scope.ricerca);

		getCodiciIva();

		if ($window.localStorage.getItem("nummov")) {
			$scope.ricerca.nummov = $window.localStorage.getItem("nummov")
		}

		if ($window.localStorage.getItem("partita")) {
			$scope.ricerca.partita = $window.localStorage.getItem("partita")
		}

		if ($window.localStorage.getItem("causale")) {
			$scope.ricerca.causale = $window.localStorage.getItem("causale")
		}

		if ($window.localStorage.getItem("codiceiva")) {
			$scope.ricerca.codiceiva = $window.localStorage.getItem("codiceiva")
		}

		if ($window.localStorage.getItem("resetprog")) {
			$scope.ricerca.resetprog = $window.localStorage.getItem("resetprog")
		}

		if ($window.localStorage.getItem("noinca")) {
			$scope.ricerca.noinca = $window.localStorage.getItem("noinca")
		}


		if ($window.localStorage.getItem("dateFrom")) {
			$scope.ricerca.datefrom = $window.localStorage.getItem("dateFrom")
		}

		if ($window.localStorage.getItem("dateTo")) {
			$scope.ricerca.dateto = $window.localStorage.getItem("dateTo")
		}

		$scope.enablePrint = false;

		if ($location.search().cliente !== undefined) {
			var cliente = $location.search().cliente;

			$scope.ricerca.cliente = cliente;
			ContabilitaService.getUtenteByConto(cliente).$promise.then(function (r) {
				console.log('cliente', r);
				if (r && r.length) {
					$scope.dati.selectedCustomer = r[0];
				}
			});
			$scope.fairicerca = true;
		}

		if ($location.search().fornitore !== undefined) {
			var fornitore = $location.search().fornitore;

			if (fornitore.charAt(0) == 'F') {
				ContabilitaService.getFornitoreByConto(fornitore).$promise.then(function (r) {
					$scope.dati.selectedSupplier = r[0];
					$scope.ricerca.fornitore = r[0].id;
				});
			} else {
				$scope.ricerca.fornitore = parseInt(fornitore);
				ContabilitaService.getSupplier(fornitore).$promise.then(function (r) {
					console.log('fornitore', r);
					$scope.dati.selectedSupplier = r;
				});
			}

			$scope.fairicerca = true;
		}


		if ($location.search().contofrom !== undefined) {
			var contofrom = $location.search().contofrom;
			ContabilitaService.getContoByCodice(contofrom).$promise.then(function (r) {
				$scope.dati.selectedAccountFrom = r;
			});
			$scope.fairicerca = true;
		}


		if ($location.search().contoto !== undefined) {
			var contoto = $location.search().contoto;
			$scope.ricerca.contoto = contoto;
			ContabilitaService.getContoByCodice(contoto).$promise.then(function (r) {
				$scope.dati.selectedAccountTo = r;
			});

			$scope.fairicerca = true;
		}

		if ($location.search().datefrom !== undefined) {
			$scope.ricerca.datefrom = $location.search().datefrom;
			$scope.fairicerca = true;
		}
		if ($location.search().dateto !== undefined) {
			$scope.ricerca.dateto = $location.search().dateto;
			$scope.fairicerca = true;
		}


		$scope.popUpDate1 = false;
		$scope.popUpDate2 = false;

		// ui-select
		$scope.dati = {};

		$scope.searchCustomers = function (searchterm) {
			ContabilitaService.searchCustomers(searchterm).$promise.then(function (response) {
				$scope.customers = response;
			});
		};

		$scope.searchSuppliers = function (searchterm) {
			ContabilitaService.searchSuppliers(searchterm).$promise.then(function (response) {
				$scope.suppliers = response;
			});
		};

		$scope.searchAccounts = function (searchterm) {
			ContabilitaService.searchAccounts(searchterm).$promise.then(function (response) {
				$scope.accounts = response;
			});
		};
		// END ui-select



		function getCodiciIva() {
			ContabilitaService.getCodiciIva().$promise.then(function (r) {
				$scope.codiciiva = r;
			}, function (e) {
				console.log(e);
			});
		}



		function createSaldi() {
			angular.forEach($scope.items.data, function (row, key) {
					if (key == 0) {
						if (row.segno == 'D') {
							$scope.items.data[key].saldo = $scope.items.saldoprec + row.importo;
						} else if (row.segno == 'A') {
							$scope.items.data[key].saldo = $scope.items.saldoprec - row.importo;
						}
					} else if (key > 0) {
						if (Math.sign($scope.items.data[key - 1].saldo) < 0) { // saldo elemento precedente negativo
							if (row.segno == 'D') {
								$scope.items.data[key].saldo = row.importo + $scope.items.data[key - 1].saldo;
							} else if (row.segno == 'A') {
								$scope.items.data[key].saldo = $scope.items.data[key - 1].saldo + -row.importo;
							}
						} else {
							if (row.segno == 'D') {
								$scope.items.data[key].saldo = $scope.items.data[key - 1].saldo + row.importo;
							} else if (row.segno == 'A') {
								$scope.items.data[key].saldo = $scope.items.data[key - 1].saldo - row.importo;
							}
						}
					}
			});
		}

		$scope.applyDateTo = function () {
			// manipola 23.59 dateto
			var dateto = new Date($scope.ricerca.dateto * 1000);
			dateto = dateto.setHours(23, 59, 59);
			$scope.ricerca.dateto = String(dateto / 1000);
		};

		$scope.applySearch = function (start, stop) {

			console.log("Dati selezionati", $scope.dati);

			// ui-select -> search object
			if ($scope.dati.selectedCustomer != undefined) $scope.ricerca.cliente = $scope.dati.selectedCustomer.conto;
			if ($scope.dati.selectedSupplier != undefined) $scope.ricerca.fornitore = $scope.dati.selectedSupplier.codice;
			if ($scope.dati.selectedSupplier != undefined) $scope.ricerca.fornitoreId = $scope.dati.selectedSupplier.id;
			if ($scope.dati.selectedAccountFrom != undefined) $scope.ricerca.contofrom = $scope.dati.selectedAccountFrom.codice;
			if ($scope.dati.selectedAccountTo != undefined) $scope.ricerca.contoto = $scope.dati.selectedAccountTo.codice;
			if ($scope.ricerca.partita == '') $scope.ricerca.partita = undefined;

			console.log($scope.ricerca.datefrom);

			$window.localStorage.setItem("dateFrom", $scope.ricerca.datefrom);
			$window.localStorage.setItem("dateTo", $scope.ricerca.dateto);
			if ($scope.ricerca.nummov) {
				$window.localStorage.setItem("nummov", $scope.ricerca.nummov);
			} else {
				$window.localStorage.removeItem("nummov");
			}

			if ($scope.ricerca.partita) {
				$window.localStorage.setItem("partita", $scope.ricerca.partita);
			} else {
				$window.localStorage.removeItem("partita");
			}

			if ($scope.ricerca.causale) {
				$window.localStorage.setItem("causale", $scope.ricerca.causale);
			} else {
				$window.localStorage.removeItem("causale");
			}

			if ($scope.ricerca.codiceiva) {
				$window.localStorage.setItem("codiceiva", $scope.ricerca.codiceiva);
			} else {
				$window.localStorage.removeItem("codiceiva");
			}

			if ($scope.ricerca.resetprog) {
				$window.localStorage.setItem("resetprog", $scope.ricerca.resetprog);
			} else {
				$window.localStorage.removeItem("resetprog");
			}

			if ($scope.ricerca.noinca) {
				$window.localStorage.setItem("noinca", $scope.ricerca.noinca);
			} else {
				$window.localStorage.removeItem("noinca");
			}


			console.log("ricerca", $window.localStorage.getItem("dateFrom"));

			return ContabilitaService.searchMastrino($scope.ricerca, start, stop).$promise.then(function (r) {
				$scope.items = r;
				// $scope.items.data = $scope.items.data.map(function(item) {
				// 	item.datamov = '' + item.datamov - 3600;
				// 	item.datadoc = '' + item.datadoc - 3600;
				// 	return item;
				// });
				console.log('$scope.items', $scope.items);
				createSaldi();
				$scope.loading = false;
				return r;
			}, function (e) {
				console.log(e);
				if (e.data) {
					$scope.error = e.data.msg;
				} else {
					Notification.error('Si è verificato un errore');
				}
				$scope.loading = false;
			});
		};



		$scope.loadMovimenti = function (tableState) {

			console.log('loadmovimenti', tableState);
			$scope.tableState = tableState;
			if ($scope.fairicerca) {
				$scope.loading = true;
				var pagination = tableState.pagination;


				var start = pagination.start || 0; // This is NOT the page number, but the index of item in the list that you want to use to display the table.
				var number = pagination.number || 10; // Number of entries showed per page.
				var stop = start + number;




				$scope.applySearch(start, stop).then(function (r) {
					console.log("movimenti", r);
					if (r && r.ct) tableState.pagination.numberOfPages = parseInt(Math.ceil(r.ct / number)); //set the number of pages so the pagination can update

					$scope.enablePrint = true;
				});
			}
		}

		$scope.editMovimento = function (ntsid) {
			// ui-sref="contabilita.edit-movimento" href="#!/edit-movimento/{{item.ntsid}}" 


			console.log("$scope.ricerca", $scope.ricerca);

			$state.go('contabilita.edit-movimento', {
				id: ntsid,
				ricerca: $scope.ricerca,
				fromUrl: 'ricerca'
			});
		};

		$scope.emptySearch = function () {
			console.log('empty search');
			$scope.ricerca = angular.copy($scope.resetRicerca);
			$scope.dati = {};
			$window.localStorage.removeItem('dateFrom');
			$window.localStorage.removeItem('dateTo');
			$window.localStorage.removeItem('nummov');
			$window.localStorage.removeItem('partita');
			$window.localStorage.removeItem('causale');

			$state.go('contabilita.ricerca', {}, {
				notify: false
			});

		};

		$scope.print = function () {

			var post = angular.copy($scope.ricerca);
			post.extra = {
				customerName: $scope.dati.selectedCustomer != undefined ? $scope.dati.selectedCustomer.denominazione : undefined,
				supplierName: $scope.dati.selectedSupplier != undefined ? $scope.dati.selectedSupplier.nome : undefined,
				contoFromName: $scope.dati.selectedAccountFrom != undefined ? $scope.dati.selectedAccountFrom.descrizione : undefined,
				contoToName: $scope.dati.selectedAccountTo != undefined ? $scope.dati.selectedAccountTo.descrizione : undefined
			};

			var table = ['Data reg.', 'Num. reg.', 'Data doc.', 'Num fatt.', 'Prot.', '# Prot', 'Partita', 'Causale', 'Note', 'Dare', 'Avere', 'Saldo'];
			var onlyPrint = ['datamov', 'nummov', 'datadoc', 'numdoc', 'protocollo', 'numprotocollo', 'partita', 'causale', 'note', 'dare', 'avere', 'saldo', 'detnote'];
			var types = ['date', 'number', 'date', 'string', 'string', 'number', 'string', 'string', 'longtext', 'price', 'price', 'balance'];

			if ((!$scope.ricerca.fornitore && !$scope.ricerca.cliente) && ($scope.ricerca.contofrom && $scope.ricerca.contoto)) {
				table.splice(3, 4);
				onlyPrint.splice(3, 4);
				types.splice(3, 4);
			}
			console.log('FABRIZIO', table, onlyPrint, types);

			var localStorage = {
				api: 'mastrino/filter/0/1000000',
				subject: 'Movimenti',
				table: table,
				onlyPrint: onlyPrint,
				types: types,
				post: post,
				balance: true,
				dare_avere: true
			};

			// save to localStorage
			ElPrintService.setData('print', JSON.stringify(localStorage));

			// send to print page
			$window.open($state.href('print'), '_blank');
		};

		$scope.cerca = function () {
			$scope.fairicerca = true;
			$scope.loadMovimenti($scope.tableState);
		}
		if ($scope.fairicerca && $scope.tableState) {

			$scope.tableState.start = 0;
			$scope.loadMovimenti($scope.tableState);
		}

		$scope.advancedExport = function () {
			var ricerca = {
				table: 'mastrino',
				simple: [],
				range: []
			};

			var conto = '';

			if ($scope.ricerca.datefrom && $scope.ricerca.dateto) {
				ricerca.range.push({
					field: 'datamov',
					start: $scope.ricerca.datefrom,
					stop: $scope.ricerca.dateto
				});
			}
			if ($scope.ricerca.contofrom && $scope.ricerca.contoto) {
				if ($scope.ricerca.contofrom == $scope.ricerca.contofrom) {
					conto = $scope.ricerca.contofrom;
				} else if ($scope.ricerca.contofrom && $scope.ricerca.contoto && !$scope.ricerca.fornitore && !$scope.ricerca.cliente) {
					ricerca.range.push({
						field: 'conto',
						start: $scope.ricerca.datefrom,
						stop: $scope.ricerca.dateto
					});
				}
			}
			if ($scope.ricerca.fornitore) {
				conto = $scope.ricerca.fornitore;
			}
			if ($scope.ricerca.cliente) {
				conto = $scope.ricerca.cliente;
			}
			if (($scope.ricerca.contofrom && $scope.ricerca.contoto) || $scope.ricerca.fornitore || $scope.ricerca.cliente) {
				if (conto) {
					ricerca.simple.push({
						field: 'conto',
						filter: conto
					});
				}
			}
			if ($scope.ricerca.causale) {
				ricerca.simple.push({
					field: 'causale',
					filter: $scope.ricerca.causale
				});
			}
			if ($scope.ricerca.partita) {
				ricerca.simple.push({
					field: 'partita',
					filter: $scope.ricerca.partita
				});
			}
			if ($scope.ricerca.nummov) {
				ricerca.simple.push({
					field: 'nummov',
					filter: $scope.ricerca.nummov
				});
			}

			ConstantsService.advancedExport(ricerca, 'mastrino');
		}

	}

}());
(function () {

	'use strict';

	angular
		.module('AmwayAdmin.contabilita.movimenti')
		.controller('RicercaIVACtrl', RicercaIVACtrl);

	/** @ngInject */
	function RicercaIVACtrl($scope, $location, $window, $stateParams, $state, ConfigService, ContabilitaService, Notification, ElPrintService, ConstantsService) {

		var inizio = moment().startOf('year').valueOf() / 1000;
		$scope.fairicerca = false;
		$scope.ricerca = {
			dateto: parseInt((new Date).getTime() / 1000),
			datefrom: inizio
		};
		$scope.resetRicerca = angular.copy($scope.ricerca);

		getCodiciIva();

		if ($window.localStorage.getItem("causale")) {
			$scope.ricerca.causale = $window.localStorage.getItem("causale")
		}

		if ($window.localStorage.getItem("codiceiva")) {
			$scope.ricerca.codiceiva = $window.localStorage.getItem("codiceiva")
		}

		if ($window.localStorage.getItem("dateFrom")) {
			$scope.ricerca.datefrom = $window.localStorage.getItem("dateFrom")
		}

		if ($window.localStorage.getItem("dateTo")) {
			$scope.ricerca.dateto = $window.localStorage.getItem("dateTo")
		}

		$scope.enablePrint = false;

		if ($location.search().datefrom !== undefined) {
			$scope.ricerca.datefrom = $location.search().datefrom;
			$scope.fairicerca = true;
		}
		if ($location.search().dateto !== undefined) {
			$scope.ricerca.dateto = $location.search().dateto;
			$scope.fairicerca = true;
		}


		$scope.popUpDate1 = false;
		$scope.popUpDate2 = false;

		function getCodiciIva() {
			ContabilitaService.getCodiciIva().$promise.then(function (r) {
				$scope.codiciiva = r;
			}, function (e) {
				console.log(e);
			});
		}



		function createSaldi() {
			angular.forEach($scope.items.data, function (row, key) {
				if (key == 0) {
					if (row.segno == 'D') {
						$scope.items.data[key].saldo = $scope.items.saldoprec + row.importo;
					} else if (row.segno == 'A') {
						$scope.items.data[key].saldo = $scope.items.saldoprec - row.importo;
					}
				} else if (key > 0) {
					if (Math.sign($scope.items.data[key - 1].saldo) < 0) { // saldo elemento precedente negativo
						if (row.segno == 'D') {
							$scope.items.data[key].saldo = row.importo + $scope.items.data[key - 1].saldo;
						} else if (row.segno == 'A') {
							$scope.items.data[key].saldo = $scope.items.data[key - 1].saldo + -row.importo;
						}
					} else {
						if (row.segno == 'D') {
							$scope.items.data[key].saldo = $scope.items.data[key - 1].saldo + row.importo;
						} else if (row.segno == 'A') {
							$scope.items.data[key].saldo = $scope.items.data[key - 1].saldo - row.importo;
						}
					}
				}
			});
		}

		$scope.applyDateTo = function () {
			// manipola 23.59 dateto
			var dateto = new Date($scope.ricerca.dateto * 1000);
			dateto = dateto.setHours(23, 59, 59);
			$scope.ricerca.dateto = String(dateto / 1000);
		};



		$scope.applySearch = function (start, stop) {

			console.log("Dati selezionati", $scope.dati);

			var ricerca = {
				table: 'mastrinoiva',
				simple: [],
				range: [],
				sortfield: "concat(date_format(from_unixtime(datamov),'%Y%m%d'), nummov, protocollo)",
				direction: 'asc'
			};

			if ($scope.ricerca.datefrom && $scope.ricerca.dateto) {
				$window.localStorage.setItem("dateFrom", $scope.ricerca.datefrom);
				$window.localStorage.setItem("dateTo", $scope.ricerca.dateto);

				ricerca.range.push({ field: 'datamov', start: $scope.ricerca.datefrom, stop: $scope.ricerca.dateto });
			}

			if ($scope.ricerca.causale) {
				$window.localStorage.setItem("causale", $scope.ricerca.causale);
				ricerca.simple.push({ field: 'causale', filter: $scope.ricerca.causale });
			}
			else {
				$window.localStorage.removeItem("causale");
			}

			if ($scope.ricerca.codiceiva) {
				$window.localStorage.setItem("codiceiva", $scope.ricerca.codiceiva);
				ricerca.simple.push({ field: 'codiceiva', filter: $scope.ricerca.codiceiva });
			}
			else {
				$window.localStorage.removeItem("codiceiva");
			}

			console.log("ricerca", $window.localStorage.getItem("dateFrom"));

			return ContabilitaService.searchMastrinoIva(ricerca, start, stop).$promise.then(function (r) {
				return ContabilitaService.countMastrinoIva(ricerca).$promise.then(function (res) {
					$scope.loading = false;
					return {
						ct: res.ct,
						data: r
					};
				}, function (e) {
					console.log(e);
					if (e.data) {
						$scope.error = e.data.msg;
					}
					else { Notification.error('Si è verificato un errore'); }
					$scope.loading = false;
				});
			}, function (e) {
				console.log(e);
				if (e.data) {
					$scope.error = e.data.msg;
				}
				else { Notification.error('Si è verificato un errore'); }
				$scope.loading = false;
			});
		};

		$scope.loadMovimenti = function (tableState) {

			console.log('loadmovimenti', tableState);
			$scope.tableState = tableState;
			if ($scope.fairicerca) {
				$scope.loading = true;
				var pagination = tableState.pagination;


				var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
				var number = pagination.number || 10;  // Number of entries showed per page.
				var stop = start + number;




				$scope.applySearch(start, stop).then(function (r) {
					console.log("movimenti", r);
					$scope.items = {
						data: r.data,
						ct: r.ct
					};
					// createSaldi();
					tableState.pagination.numberOfPages = parseInt(Math.ceil(r.ct / number));//set the number of pages so the pagination can update

					$scope.enablePrint = true;
				});
			}
		}

		$scope.editMovimento = function (ntsid) {
			// ui-sref="contabilita.edit-movimento" href="#!/edit-movimento/{{item.ntsid}}" 


			console.log("$scope.ricerca", $scope.ricerca);

			$state.go('contabilita.edit-movimento', {
				id: ntsid,
				ricerca: $scope.ricerca,
				fromUrl: 'ricercaiva'
			});
		};

		$scope.emptySearch = function () {
			console.log('empty search');
			$scope.ricerca = angular.copy($scope.resetRicerca);
			$scope.dati = {};
			$window.localStorage.removeItem('dateFrom');
			$window.localStorage.removeItem('dateTo');
			$window.localStorage.removeItem('codiceiva');
			$window.localStorage.removeItem('causale');

			$state.go('contabilita.ricerca', {}, { notify: false });

		};

		$scope.print = function () {

			var post = angular.copy($scope.ricerca);
			post.extra = {
				customerName: $scope.dati.selectedCustomer != undefined ? $scope.dati.selectedCustomer.denominazione : undefined,
				supplierName: $scope.dati.selectedSupplier != undefined ? $scope.dati.selectedSupplier.nome : undefined,
				contoFromName: $scope.dati.selectedAccountFrom != undefined ? $scope.dati.selectedAccountFrom.descrizione : undefined,
				contoToName: $scope.dati.selectedAccountTo != undefined ? $scope.dati.selectedAccountTo.descrizione : undefined
			};

			var localStorage = {
				api: 'mastrino/filter/0/1000000',
				subject: 'Movimenti',
				table: ['Data reg.', 'Data doc.', 'Prot.', '# Prot', 'Partita', 'Causale', 'Note', 'Dare', 'Avere', 'Saldo'],
				onlyPrint: ['datamov', 'datadoc', 'protocollo', 'numprotocollo', 'partita', 'causale', 'note', 'dare', 'avere', 'saldo'],
				types: ['date', 'date', 'string', 'number', 'string', 'string', 'longtext', 'price', 'price', 'balance'],
				post: post,
				balance: true,
				dare_avere: true
			};

			// save to localStorage
			ElPrintService.setData('print', JSON.stringify(localStorage));

			// send to print page
			$window.open($state.href('print'), '_blank');
		};

		$scope.cerca = function () {
			$scope.fairicerca = true;
			$scope.loadMovimenti($scope.tableState);
		}
		if ($scope.fairicerca && $scope.tableState) {

			$scope.tableState.start = 0;
			$scope.loadMovimenti($scope.tableState);
		}

		$scope.advancedExport = function () {
			$scope.applyDateTo();
			var ricerca = {
				table: 'mastrinoiva',
				simple: [],
				range: []
			};

			if ($scope.ricerca.datefrom && $scope.ricerca.dateto) {
				ricerca.range.push({ field: 'datamov', start: $scope.ricerca.datefrom, stop: $scope.ricerca.dateto });
			}
			if ($scope.ricerca.causale) {
				ricerca.simple.push({ field: 'causale', filter: $scope.ricerca.causale });
			}

			if ($scope.ricerca.codiceiva) {
				ricerca.simple.push({ field: 'codiceiva', filter: $scope.ricerca.codiceiva });
			}
			ConstantsService.advancedExport(ricerca, 'mastrinoiva');
		}

	}

}());
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
	'use strict';

	angular.module('AmwayAdmin.contabilita.bilancio')
		.controller('RateiRiscontiCtrl', RateiRiscontiCtrl);

	/** @ngInject */
	function RateiRiscontiCtrl($scope, $stateParams, $state, ContabilitaService, $ngConfirm, Notification, $window, $q, $timeout, FileSaver) {

		$scope.years = [];
		$scope.periods = {
			export: undefined,
			create: undefined,
			createOthers: undefined,
			date: undefined
		};
		$scope.loading = {
			riscontiticket: false,
			risconti: false,
			ratei: false,
			crrisc: false,
			crratrisc: false
		};

		function setYears(){
  			var current = (new Date()).getFullYear();
  			for(var i = 7; i>0; i--){
  				$scope.years.push(current--);
  			}
  		}

  		setYears();

  		$scope.export = function(entity) {
  			$scope.loading[entity] = true;
  			var filename = entity + '_' + $scope.periods.export + '.csv';
  			ContabilitaService.exportRateiRisconti(entity, $scope.periods.export).then(function(response) {
				var file = new Blob([response.data], {
					type: 'application/csv'
				});
				//trick to download store a file having its URL
				FileSaver.saveAs(file, filename);
				$scope.loading[entity] = false;
			}, function(error) {
				$scope.loading[entity] = false;
			});
  		}

  		$scope.genRisconti = function() {
  			$scope.loading.crrisc = true;
  			ContabilitaService.creaRisconti($scope.periods.create, $scope.periods.date).$promise.then(function(response) {
  				Notification.success('Generazione effettuata');
				$scope.loading.crrisc = false;
			}, function(e) {
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				$scope.loading.crrisc = false;
			});
  		}

  		$scope.genRateiRisconti = function() {
  			$scope.loading.crratrisc = true;
  			ContabilitaService.creaRateiRisconti($scope.periods.createOthers).$promise.then(function(response) {
  				Notification.success('Generazione effettuata');
				$scope.loading.crratrisc = false;
			}, function(e) {
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				$scope.loading.crratrisc = false;
			});
  		}

	}
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('AmwayAdmin.contabilita.bilancio')
		.controller('StampaRegistriCtrl', StampaRegistriCtrl);

	/** @ngInject */
	function StampaRegistriCtrl($scope, $stateParams, $state, ContabilitaService, $ngConfirm, Notification, $window, $q, $timeout, FileSaver) {

		$scope.sezionali = [];
		$scope.loadingRegistro = false;

		var date = new Date();

		$scope.registro = {
			sezionale: 'A',
			prospettoliquidazione: 0,
			prova: 1,
			printenddate: parseInt(new Date(date.getFullYear(), date.getMonth() + 1, 0).getTime() / 1000),
		};


		// da modificare payload di chiamata una volta finito coi registri
		$scope.giornale = {
			startdate: parseInt(new Date(date.getFullYear(), date.getMonth(), 1).getTime() / 1000),
			stopdate: parseInt(new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59).getTime() / 1000),
			prova: 1
		};
		// APPUNTI FABRIZIO TEMPORANEI
		// pagefrom deve venire da API con ultima pagina stampata + 1 del giornale bollato (quindi giorno successivo)
		// printfrom deve venire da API con ultima data stampata + 1 del giornale bollato (quindi giorno successivo)

		function getSezionali() {
			var obj = {
				table: 'sezionale',
				simple: [{
					field: 'stampa',
					filter: 1
				}],
				sortfield: "sezionale",
				direction: "asc",
			};
			ContabilitaService.getSezionaliAdvanced(obj).$promise.then(function (data) {
				$scope.sezionali = data.map(function (sezionale) {
					sezionale.selected = false;
					return sezionale;
				}, function (e) {
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});

				loadLastDates();
				console.log('%c SEZIONALI', 'color:#FF79C6', $scope.sezionali);
			})
		}

		getSezionali();

		function setDate(date, type) {
			var newdate = new Date(date * 1000);
			if (type == 'start') {
				newdate.setHours(0, 0, 0, 0);
				return Number(newdate.getTime() / 1000);
			} else if (type == 'stop') {
				newdate.setHours(23, 59, 59);
				return Math.round(Number(newdate.getTime() / 1000));
			}
		}

		$scope.stampaRegistri = function () {
			$scope.loadingRegistro = true;
			var index = $scope.sezionali.map(function (s) {
				return s.sezionale;
			}).indexOf($scope.registro.sezionale);
			$scope.registro.startdate = setDate(Number($scope.sezionali[index].datainizio), 'start');
			$scope.registro.stopdate = setDate(Number($scope.sezionali[index].datafine), 'stop');
			// richiedi registro e salva PDF
			var filename = 'registro_iva_sez_' + $scope.registro.sezionale + '.pdf';
			ContabilitaService.generateRegistroPdf($scope.registro, filename)
				.then(function (response) {

					var file = new Blob([response.data], {
						type: 'application/pdf'
					});
					//trick to download store a file having its URL
					FileSaver.saveAs(file, filename);
					$scope.loadingRegistro = false;
				}, function (error) {
					$scope.loadingRegistro = false;
				});
		};

		function loadLastDates() {
			ContabilitaService.getLastPrint().$promise.then(function (data) {
				angular.forEach(data, function (d) {
					var sezi = $scope.sezionali.filter(function (sez) {
						return sez.sezionale == d.sezionale
					})[0]
					sezi.datainizio = d.lastdate;
					sezi.datafine = d.lastdate;
				})

			}, function (e) {
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		$scope.stampaGiornale = function () {
			$scope.loadinggiornale = true;
			ContabilitaService.printGiornale($scope.giornale)
				.then(function (response) {

					var file = new Blob([response.data], {
						type: 'application/pdf'
					});
					//trick to download store a file having its URL
					var filename = 'giornalebollato' + $scope.giornale.datefrom + '.pdf'
					FileSaver.saveAs(file, filename);
					$scope.loadinggiornale = false;
				}, function (e) {
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
					$scope.loadinggiornale = false;
				});
		};

		$scope.selectAll = function (event) {
			$scope.sezionali = $scope.sezionali.map(function (sezionale) {
				sezionale.selected = event;
				return sezionale;
			});
		};

		$scope.selectSezionale = function (sezionale) {
			sezionale.selected = !sezionale.selected;
		};

		$scope.checkStampaProvvisoria = function () {
			if ($scope.registro.sezionale !== 'V') {
				$scope.registro.prospettoliquidazione = 0;
			}
		};

	}
})();
(function() {
  'use strict';

  angular.module('AmwayAdmin.pages.autori')
    .controller('AutoreCtrl', AutoreCtrl);

  /** @ngInject */
  function AutoreCtrl($scope, $location, $state, AutoriService, Notification,UploadService, DataConnectorService) {


$scope.baseurl= DataConnectorService.getPreviewBaseUrl();

    if(!!$state.params.id)
      AutoriService
        .getAutore($state.params.id)
        .$promise
        .then(function(r) {
          console.log(r);
          $scope.autore = r;

        }, function(e) {
          console.log(e);
          Notification.error('Si è verificato un errore');
          //TODO gestire errore
        });
    else
      $scope.autore = {};

    $scope.salva = function() {
      if(!!$state.params.id)
        AutoriService
          .updateAutore($scope.autore)
          .$promise
          .then(function(r) {
            console.log(r);
            $scope.autore = r;
            Notification.success('Salvato');

          }, function(e) {
            console.log(e);
            Notification.error('Si è verificato un errore');
            //TODO gestire errore
          });
      else
        AutoriService
          .createAutore($scope.autore)
          .$promise
          .then(function(r) {
            console.log(r);
            $scope.autore = r;
            Notification.success('Salvato');
            $location.path('/modifica-autore/' + r.id);

          }, function(e) {
            console.log(e);
            Notification.error('Si è verificato un errore');
            //TODO gestire errore
          });
    }

    $scope.elimina = function() {
      AutoriService
        .deleteAutore($scope.autore)
        .$promise
        .then(function(r) {
          Notification.success('Autore eliminato')
          $state.go('catalogo.autori');
        });
    }



    $scope.immagine = { };
    $scope.uploadImmagine = function () {


      if ($scope.immagine && $scope.immagine.file && $scope.autore && $scope.autore.id) {
        UploadService.uploadImage($scope.immagine.file).then(function (resp) {

          Notification.success('Immagine caricata');
          console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
          $scope.autore.profilepic = resp.data.path;
          $scope.salva.apply();
        }, function (resp) {

          Notification.success('Si è verificato un errore');
          console.log('Error status: ' + resp.status);
        }, function (evt) {
          
          var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
          console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
        }).catch(function (e) {
          
          Notification.error('Si è verificato un errore');
          console.log(e);
        });
      }
      else {
        $scope.salva.apply();
      }

    };
  }

})();
angular.module('AmwayAdmin.pages.autori').factory('AutoriService', function (DataConnectorService) {

	return {
    getAutori: function() {
      return DataConnectorService
        .getResource('author', {}, { isArray: true })
        .get();
    },
    getAutore: function(id) {
      return DataConnectorService
        .getResource('author/:id', { id: id })
        .get();
    },
    updateAutore: function(aut) {
      return DataConnectorService
        .getResource('author/:id', { id: aut.id })
        .put(aut);
    },
    createAutore: function(aut) {
      return DataConnectorService
        .getResource('author')
        .post(aut);
    },
    deleteAutore: function(aut) {
      return DataConnectorService
        .getResource('author/:id', { id: aut.id })
        .delete();
    },
  };

	/*response.getAll = function () {
		var config = { isArray: true };
		return DataConnectorService.getResource('user', {}, config).get();

	}


	response.getUtente = function (id) {

		return DataConnectorService.getResource('user/:id', { id: id }).get();

	}

	response.getFigliUtente = function (id) {
		var config = { isArray: true };
		return DataConnectorService.getResource('user/subtree/:id', { id: id }, config).get();

	}

	response.getAlberoUtente = function (id) {
		return DataConnectorService.getResource('user/compact/fulltree/:id', { id: id }).get();

	}


	response.creaUtente = function (user) {
		return DataConnectorService.getResource('user').post(user);

	}


	response.aggiornaUtente = function (user) {
		return DataConnectorService.getResource('user/:id', { id: user.id }, {}).put(user);

	}

	response.getIncaricati = function () {
		var config = { isArray: true };
		return DataConnectorService.getResource('user/filter/ntsrole/incaricato/range/0/10000', {}, config).get();

	}

	return response;*/

});
(function() {
  'use strict';

  angular.module('AmwayAdmin.pages.autori')
    .controller('AutoriCtrl', AutoriCtrl);

  /** @ngInject */
  function AutoriCtrl($scope, AutoriService, Notification) {


    $scope.loading = true;

    AutoriService
      .getAutori()
      .$promise
      .then(function(r) {
        console.log(r);
        $scope.autori = r;
        $scope.loading = false;

      }, function(e) {
        console.log(e);
        Notification.error('Si è verificato un errore');
        //TODO gestire errore
      });

    $scope.autoriTablePageSize = 15;

  }


})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('AmwayAdmin.pages.chart')
        .controller('ChartCtrl', ChartCtrl);

	/** @ngInject */
    function ChartCtrl($scope, baConfig, colorHelper, baUtil, $timeout) {

        var coll = document.getElementsByClassName("collapsible");
        var i;

        for (i = 0; i < coll.length; i++) {
            coll[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var content = this.nextElementSibling;
                if (content.style.display === "block") {
                    content.style.display = "none";
                } else {
                    content.style.display = "block";
                }
            });
        }
    }

})();
(function() {

	'use strict';

	angular
	  .module('AmwayAdmin.pages.configurazione')
	  .controller('ConfigurazioneCtrl', ConfigurazioneCtrl);

	/** @ngInject */
	function ConfigurazioneCtrl($scope, DataConnectorService, ConfigService,  Notification) {

		$scope.baseURL = DataConnectorService.getPreviewBaseUrl();

		ConfigService.getConf().$promise.then(function(conf) {

			$scope.configItems = conf;
		})

		$scope.deleteItem = function(item) {
           Notification.success('Elemento eliminato');	

			alert('Deleting item ' + item.id);
		}
	}

}());
(function() {

	'use strict';

	angular
	  .module('AmwayAdmin.pages.configurazione')
	  .controller('ConfigurazioneModificaCtrl', ConfigurazioneModificaCtrl);

	/** @ngInject */
	function ConfigurazioneModificaCtrl($scope, $location, $stateParams, DataConnectorService, ConfigService, Notification) {

    $scope.baseURL = DataConnectorService.getPreviewBaseUrl();

    ConfigService.getConf($stateParams.id).$promise.then(function(conf) {

      $scope.item = conf;
    });

		$scope.saveConfig = function() {

      ConfigService.putConf($scope.item).$promise.then(function(out) {
         Notification.success('Salvato'); 
        //
        // TODO gestire eccezioni
        //
        console.log(out);
        $location.path('/configurazione');
      });
		}
	}

}());
(function() {
	'use strict';

	angular.module('AmwayAdmin.pages.categorie')
		.controller('CategoriaCtrl', CategoriaCtrl);

	/** @ngInject */
	function CategoriaCtrl($scope, $state, $stateParams, $q, md5, DataConnectorService, UploadService, ProductService, ConstantsService, Notification) {


		$scope.baseurl = DataConnectorService.getPreviewBaseUrl();

		$scope.showSellable = {
			value: false
		};

		function loadCategoria() {
			if ($stateParams.id) {
				ProductService.getCategoria($stateParams.id).$promise.then(function(r) {
					$scope.categoria = r;

				}, function(e) {
					console.log(e);
					//TODO gestire errore
				});
			} else {
				$scope.categoria = {};
			}
		}

		$scope.editSort = function(item) {
			$scope.sortTemp = item.sort;
		}

		loadCategoria();

		function loadTaxonomyproduct() {
			if ($stateParams.id) {
				var search = {
					table: 'taxonomyproduct',
					simple: [{
						field: 'tid',
						filter: $stateParams.id
					}],
					sortfield: 'sort',
					direction: 'asc'
				}
				ProductService.searchProductByCategoria(search).$promise.then(function(r) {
					$scope.taxonomyproducts = [];
					if (!$scope.showSellable.value) {
						angular.forEach(r, function(item) {
							if (item.product && item.product.status == 'ok' && ProductService.isProductSellable(item.product)) {
								$scope.taxonomyproducts.push(item);
							}
						})
					} else {
						$scope.taxonomyproducts = r;
					}
					console.log('veve', $scope.taxonomyproducts);
				}, function(e) {
					Notification.error(e.msg)
				});
			} else {
				$scope.categoria = {};
			}
		}


		loadTaxonomyproduct();

		$scope.$watch("showSellable.value", function(newValue, oldValue) {
			if (newValue != undefined && newValue !== oldValue) {
				loadTaxonomyproduct();
			}
		});



		$scope.immagine = {};
		$scope.uploadImmagine = function() {
			console.log($scope.immagine.file);
			if ($scope.immagine && $scope.immagine.file && $scope.categoria && $scope.categoria.id) {
				UploadService.uploadImage($scope.immagine.file).then(function(resp) {
					console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);

					Notification.success('Immagine caricata');
					$scope.categoria.img = resp.data.path;
					$scope.salva.apply();
				}, function(resp) {
					console.log('Error status: ' + resp.status);
					Notification.error('Errore nel caricamento');
				}, function(evt) {
					var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				}).catch(function(e) {
					console.log(e);
				});
			} else {
				$scope.salva.apply();
			}

		};


		$scope.saveSort = function() {
			ProductService.saveTaxonomySort($scope.taxonomyproducts).$promise.then(function(r) {
				$scope.taxonomyproducts = r;
				Notification.success('Ordinamento salvato');
			}, function(e) {
				Notification.error('Si è verificato un errore');
				console.log(e);
				//TODO gestire errore
			});
		}


		$scope.salva = function() {

			if ($scope.categoria.sectionstr === 'bsm') {
				$scope.categoria.section = 0;
			} else if ($scope.categoria.sectionstr === 'cep') {
				$scope.categoria.section = 1;
			} else if ($scope.categoria.sectionstr === 'ticket') {
				$scope.categoria.section = 2;
			}

			if ($scope.categoria.id) {
				ProductService.aggiornaCategoria($scope.categoria).$promise.then(function(r) {
					loadCategoria();
					Notification.success('Categoria salvata');
				}, function(e) {
					Notification.error('Si è verificato un errore');
					console.log(e);
					//TODO gestire errore
				});
			} else {
					console.log('$scope.categoria', $scope.categoria);
				ProductService.creaCategoria($scope.categoria).$promise.then(function(r) {
					$state.go('catalogo.categorie');
				}, function(e) {
					console.log(e);
					//TODO gestire errore
				});
			}
		}

	}

})();
/**
* @author v.lugovsky
* created on 16.12.2015
*/
(function() {
	'use strict';
	
	angular.module('AmwayAdmin.pages.eventi')
	.controller('CategorieListCtrl', CategorieListCtrl);
	
	/** @ngInject */
	function CategorieListCtrl($scope,$ngConfirm,  ProductService, DataConnectorService, Notification) {
		
		
		$scope.baseurl= DataConnectorService.getPreviewBaseUrl();
		
		$scope.loading = true;
		function loadCategorie(){
			ProductService.getCategorie().$promise.then(function(r) {				
				$scope.categorie = r;
				$scope.loading = false;
			}, function(e) {
				console.log(e);
			});
		}
		
		loadCategorie();
		$scope.categorieTablePageSize = 10;
		
		
		
		
		
		$scope.eliminaCategoria = function(cat){
			$ngConfirm({
				title: 'Elimina Categoria',
				content: 'Sei sicuro di eliminare la categoria '+cat.name+'?',
				scope: $scope,
				closeIcon: true,
				buttons: {   
					// long hand button definition
					ok: { 
						text: "Elimina",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function(scope){
							console.log('elimina');
							ProductService.eliminaCategoria(cat.id).$promise.then(function(r) {
								Notification.success('Elemento eliminato'); 				
								loadCategorie();
							}, function(e) {
								console.log(e);
							});
							
						}
					},
					cancel: { 
						text: "Annulla",
						btnClass: 'btn-default',
						action: function(scope){
							return true;
						}
					}
				},
			});
		}
		
		$scope.resetCache = function () {
			ProductService.resetCategorieCache().$promise.then(function(r) {				
				Notification.success('Cache resettata');
			}, function(e) {
				console.log(e);
			});
		}
	}
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('AmwayAdmin.pages.coefficienti')
		.controller('CoefficienteCtrl', CoefficienteCtrl);

	/** @ngInject */
	function CoefficienteCtrl($scope, $state, $stateParams, CoefficientiService, DataConnectorService, Notification) {

		$scope.parent = {validFrom: '', validTo: ''};
		$scope.childCoefficient = {
			type: '',
			min: 0,
			bonus: 0
		};

		function loadChildCoefficient(id) {
			CoefficientiService.getAllFromSet(id).$promise.then(function(response) {
				$scope.coefficientiChildren = response;
				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		function loadCoefficientSet() {

			if ($stateParams.id) {
				CoefficientiService.getCoefficientSet($stateParams.id).$promise.then(function (r) {
					$scope.coefficientset = r;

					if ($scope.coefficientset.validfrom) {
						$scope.parent.validFrom = new Date($scope.coefficientset.validfrom * 1000);
					}

					if ($scope.coefficientset.validto) {
						$scope.parent.validTo = new Date($scope.coefficientset.validto * 1000);
					}

					loadChildCoefficient($scope.coefficientset.id);


				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
			else {
				$scope.coefficientset = {};
			}
		}

		loadCoefficientSet();

		$scope.salvaCoefficientSet = function () {

			if ($scope.parent.validFrom) {
				var inizio = moment($scope.parent.validFrom);
				$scope.coefficientset.validfrom = parseInt(inizio.toDate().getTime() / 1000);
			}

			if ($scope.parent.validTo) {
				var fine = moment($scope.parent.validTo);
				$scope.coefficientset.validto = parseInt(fine.toDate().getTime() / 1000);
			}

			// update or create based on $state ref
			if ($state.current.name == 'modifica-coefficientset') {
				CoefficientiService.aggiornaCoefficientSet($scope.coefficientset).$promise.then(function(r) {
					Notification.success('Gruppo coefficienti modificato e salvato');
					$state.go('coefficienti');
				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			} else {
				CoefficientiService.creaCoefficientSet($scope.coefficientset).$promise.then(function(r) {
					Notification.success('Gruppo coefficienti creato e salvato');
					$state.go('coefficienti');
				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}

		};

		$scope.newChildCoefficient = false;
		$scope.showAddChildCoefficient = function(value) {
			$scope.newChildCoefficient = value;
		};

		$scope.editChildCoefficient = function(coefficient) {
			$scope.childCoefficient = {
				id: coefficient.id,
				type: coefficient.type,
				min: coefficient.min,
				bonus: coefficient.bonus,
				sid: coefficient.sid
			};
			$scope.showAddChildCoefficient(true);
		};

		$scope.salvaChildCoefficient = function() {

			if ($scope.childCoefficient.sid) {
				// sid exists -> PUT
				CoefficientiService.aggiornaCoefficient($scope.childCoefficient).$promise.then(function(response) {
					Notification.success('Coefficiente modificato con successo');
					$scope.showAddChildCoefficient(false);
					$scope.childCoefficient = {
						type: '',
						min: 0,
						bonus: 0,
					};
					loadChildCoefficient($stateParams.id);
				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			} else {
				// sid doesn't exist -> POST
				$scope.childCoefficient.sid = $stateParams.id;
				CoefficientiService.creaCoefficient($scope.childCoefficient).$promise.then(function(response) {
					Notification.success('Coefficiente creato e salvato');
					$scope.showAddChildCoefficient(false);
					$scope.childCoefficient = {
						type: '',
						min: 0,
						bonus: 0
					};
					loadChildCoefficient($stateParams.id);
				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
		};

		$scope.deleteChildCoefficient = function(id) {
			CoefficientiService.eliminaCoefficient(id).$promise.then(function(response) {
				Notification.success('Coefficiente eliminato');
				loadChildCoefficient($stateParams.id);
			}, function(e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		};

	}

})();
angular.module('AmwayAdmin.pages.coefficienti').factory('CoefficientiService', function(DataConnectorService) {

	var response = {};

	// API for coefficientset
	response.getAll = function() {
		var config = { isArray: true };
		return DataConnectorService.getResource('coefficientset/valid', {}, config).get();
	}

	response.getCoefficientSet = function(id) {
		return DataConnectorService.getResource('coefficientset/:id', { id: id }).get();
	}

	response.creaCoefficientSet = function(coefficientset) {
		return DataConnectorService.getResource('coefficientset').post(coefficientset);
	}

	response.aggiornaCoefficientSet = function(coefficientset) {
		return DataConnectorService.getResource('coefficientset/:id', { id: coefficientset.id }).put(coefficientset);
	}

	response.eliminaCoefficientSet = function(id) {
		return DataConnectorService.getResource('coefficientset/:id', { id: id }).delete();
	}

	// API for coefficient
	response.getAllFromSet = function(sid) {
		var config = { isArray: true };
		return DataConnectorService.getResource('coefficient/filter/sid/:sid/range/0/1000', { sid: sid }, config).get();
	}

	response.getCoefficient = function(id) {
		return DataConnectorService.getResource('coefficient/:id', { id: id }).get();
	}

	response.creaCoefficient = function(coefficient) {
		return DataConnectorService.getResource('coefficient').post(coefficient);
	}

	response.aggiornaCoefficient = function(coefficient) {
		return DataConnectorService.getResource('coefficient/:id', { id: coefficient.id }).put(coefficient);
	}

	response.eliminaCoefficient = function(id) {
		return DataConnectorService.getResource('coefficient/:id', { id: id }).delete();
	}

	return response;

});

(function() {
    'use strict';

    angular.module('AmwayAdmin.pages.coefficienti')
        .controller('CoefficientiCtrl', CoefficientiCtrl);

    /** @ngInject */
    function CoefficientiCtrl($scope, $ngConfirm, CoefficientiService, DataConnectorService, Notification) {

        $scope.overlapCounter = 0;
        $scope.loading = true;

        function loadCoefficienti() {

            CoefficientiService.getAll().$promise.then(function(r) {
                $scope.coefficienti = r;
                console.log(r);
                $scope.loading = false;

                angular.forEach($scope.coefficienti, function(value, key){
                    var from = value.validfrom * 1000;
                    var to = value.validto * 1000;
                    if (from <= Date.now() && to >= Date.now()) {
                        $scope.overlapCounter++;
                    }
                });

            }, function(e) {
                console.log(e);
            });
        }

        loadCoefficienti();

        $scope.coefficientiTablePageSize = 10;

        // todo eliminare tutti i coefficienti collegati
        $scope.eliminaCoefficienti = function(coefficientset) {
            $ngConfirm({
                title: 'Elimina gruppo coefficienti',
                content: 'Sei sicuro di eliminare il gruppo coefficienti "' + coefficientset.name + '"?',
                scope: $scope,
                closeIcon: true,
                buttons: {
                    // long hand button definition
                    ok: {
                        text: "Elimina",
                        btnClass: 'btn-primary',
                        keys: ['enter'], // will trigger when enter is pressed
                        action: function(scope) {
                            CoefficientiService.eliminaCoefficientSet(coefficientset.id).$promise.then(function(r) {
                                Notification.success('Gruppo coefficienti eliminato');
                                loadCoefficienti();
                            }, function(e) {
                                console.log(e);
                            });

                        }
                    },
                    cancel: {
                        text: "Annulla",
                        btnClass: 'btn-default',
                        action: function(scope) {
                            return true;
                        }
                    }
                },
            });
        }


    }

})();
angular.module('AmwayAdmin.pages.eventi').factory('EventiService', function (DataConnectorService) {

	var response = {};

	response.getAll = function () {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('event', {}, config).get();

	}




	response.getEvento = function (id) {

		return DataConnectorService.getResource('event/:id', {
			id: id
		}).get();

	}

	response.searchEvents = function (searchterm) {
		var config = { isArray: true };
		var searchObj = {
			table: "event",
			sortfield: "name",
			direction: "asc",
			like: [{
				field: 'name',
				term: searchterm
			}],
			simple: [],
			range: []
		};
		return DataConnectorService.getResource('event/advancedsearch/0/1000000', {}, config).post(searchObj);
	};



	response.getPartecipantiEvento = function (evento) {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('pnr/filter/eid/:id/range/0/1000', {
			id: evento.id
		}, config).get();

	}

	response.getAnomalieEvento = function (id) {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('pnr/event/:id/anomalies', {
			id: id
		}, config).get();

	}

	response.searchEventAccess = function (postObj) {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('eventaccess/advancedsearch/0/10000', {
		}, config).post(postObj);
	}

	response.searchViolation = function (postObj) {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('violation/advancedsearch/0/10000', {
		}, config).post(postObj);
	}



	response.getUserEvents = function (id) {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('event/filter/eid/:id/range/0/1000', {
			id: evento.id
		}, config).get();

	}

	response.getFutureEvents = function () {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('event/future', {
		}, config).get();

	}

	response.getStatisticheEvento = function (eid) {
		var config = {
			isArray: false
		};
		return DataConnectorService.getResource('event/stats/:eid', {
			eid: eid
		}, config).get();

	}

	response.getPartecipantiAdSearch = function (postObj, start, stop) {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('pnr/advancedsearch/:start/:stop', {
			start: start, stop: stop
		}, config).post(postObj);

	}

	response.getPartecipantiCount = function (postObj) {
		var config = {
			isArray: false
		};
		return DataConnectorService.getResource('pnr/advancedcount', {
		}, config).post(postObj);

	}


	response.creaEvento = function (product) {
		return DataConnectorService.getResource('event').post(product);

	}


	response.aggiornaEvento = function (product) {
		return DataConnectorService.getResource('event/:id', {
			id: product.id
		}, {}).put(product);

	}

	response.getSpeakerEvento = function (event) {
		return DataConnectorService
			.getResource('eventspeaker/filter/eid/:eid/range/0/1000', { eid: event.id }, { isArray: true })
			.get();
	}

	response.addSpeakerEvento = function (event, speaker) {
		return DataConnectorService
			.getResource('eventspeaker')
			.post({ eid: event.id, sid: speaker.id });
	}

	response.deleteSpeakerEvento = function (es) {
		return DataConnectorService
			.getResource('eventspeaker/:id', { id: es.id })
			.delete();
	}

	response.burnPNR = function (pnr) {
		return DataConnectorService
			.getResource('pnr/burn')
			.post(pnr);
	}

	response.getNotification = function (eid) {
		return DataConnectorService
			.getResource('eventpush/filter/eid/:eid/range/0/1000', { eid: eid }, { isArray: true })
			.get();
	}


	response.sendNotification = function (push) {
		return DataConnectorService
			.getResource('eventpush/')
			.post(push);
	}

	response.deleteNotification = function (id) {
		return DataConnectorService
			.getResource('eventpush/:id', { id: id })
			.delete();
	}

	response.migrateTickets = function (event) {
		return DataConnectorService
			.getResource('event/migrate', {})
			.post(event);
	}

	response.savePNR = function (pnr) {
		return DataConnectorService
			.getResource('pnr')
			.post(pnr);
	}

	response.getHeatmapData = function (id, start, stop) {
		return DataConnectorService.getResource('heatmap/event/:id/:start/:stop', { id: id, start: start, stop: stop }, { isArray: true }).get();
	}




	return response;

});
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('AmwayAdmin.pages.eventi')
		.controller('EventiListCtrl', EventiListCtrl);

	/** @ngInject */
	function EventiListCtrl($scope, $ngConfirm, EventiService, ProductService, DataConnectorService, Notification) {

		$scope.baseurl = DataConnectorService.getPreviewBaseUrl();

		var eventfilter = {
			table: "event",
			sortfield: "startdate",
			direction: 'desc'
		};

		$scope.eventiTablePageSize = 10;
		countEvents();

		function loadEventi(start, stop) {
			ProductService.getEventiAdv(eventfilter, start, stop).$promise.then(function (r) {
				$scope.eventi = r;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		$scope.getEvents = function (tableState) {

			$scope.tableStateEvents = tableState;
			var pagination = tableState.pagination;

			var start = pagination.start || 0; // This is NOT the page number, but the index of item in the list that you want to use to display the table.
			var number = pagination.number || 10; // Number of entries showed per page.
			var stop = start + number;
			var sort = {
				sortfield: tableState.sort.predicate,
				direction: tableState.sort.reverse ? 'desc' : 'asc'
			};
			tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalEventNotifications / number));

			loadEventi(start, stop);
		}

		function countEvents() {
			ProductService.getEventiAdvCount(eventfilter).$promise.then(function (r) {
				$scope.totalEventNotifications = r.ct;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		$scope.eliminaEvento = function (ev) {
			$ngConfirm({
				title: 'Elimina Evento',
				content: 'Sei sicuro di eliminare l\'evento ' + ev.name + '?',
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Elimina",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {
							console.log(ProductService);
							ProductService.eliminaEvento(ev.id).$promise.then(function (r) {
								Notification.success('Elemento eliminato');
								loadEventi(0, 10);
							}, function (e) {
								console.log(e);
							});

						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});
		}

		$scope.bloccaSblocca = function (evento, block) {
			var msg1 = !block ? 'sbloccare' : 'bloccare';
			var msg2 = !block ? 'di nuovo possibili' : 'sospesi';
			var btn = !block ? 'Sblocca' : 'Blocca';

			$ngConfirm({
				title: 'Blocca Evento',
				content: 'Sei sicuro di ' + msg1 + ' l\'evento "' + evento.name + '"? Gli accessi digitali saranno ' + msg2 + '.',
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: btn,
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {
							var newEvento = angular.copy(evento);
							newEvento.status = block ? 'closed' : 'open';

							EventiService.aggiornaEvento(newEvento).$promise.then(function (r) {
								loadEventi(0, 10);
								Notification.success('Evento salvato');
							}, function (e) {
								console.log(e);
								Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
							});
						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});
		}
	}

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('AmwayAdmin.pages.eventi')
		.controller('EventoCtrl', EventoCtrl)
		.controller('EventAccessCtrl', EventAccessCtrl);

	/** @ngInject */
	function EventoCtrl($scope, $state, $stateParams, $document, $timeout, EventiService, VenueService, SpeakerService, ConstantsService, DataConnectorService, UploadService, Notification, $ngConfirm, $uibModal, $sce) {

		$scope.baseurl = DataConnectorService.getPreviewBaseUrl();
		$scope.venues = [];
		$scope.selectedVenue = {};
		$scope.oggi = new Date();
		$scope.pushNotification = {
			eid: $stateParams.id,
		};

		$scope.searchPnrObj = {};

		var start = 0;
		var stop = 15;
		$scope.itemsPerPage = 15;
		var map, heatmap;

		$scope.searchPnrObj = {
			table: "pnr",
			sortfield: "issuedate",
			direction: "desc",
			like: [],
			simple: []
		};

		$scope.searchPnrObj.simple = [{ field: "eid", filter: $stateParams.id }];

		function loadNotifications() {
			EventiService.getNotification($stateParams.id).$promise.then(function (r) {
				$scope.notifications = r;
				console.log("notifiche", $scope.notifications);
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});

		}

		function loadEventAnomalies() {
			EventiService
				.getAnomalieEvento($stateParams.id)
				.$promise
				.then(function (r) {
					$scope.anomalies = r;

				}, function (err) {
					Notification.error("Si è verificato un errore");
					console.log(err);
				});

		}
		if ($stateParams.id) {
			loadEventAnomalies();
			loadNotifications();
		}

		function loadViolation() {
			var search = {
				table: 'violation',
				sortfield: 'insdate',
				direction: 'desc',
				simple: [{ field: 'eid', filter: $stateParams.id }]
			}
			EventiService
				.searchViolation(search)
				.$promise
				.then(function (r) {
					$scope.violations = r;

				}, function (err) {
					Notification.error("Si è verificato un errore");
					console.log(err);
				});

		}

		loadViolation();

		$scope.sendNotification = function () {
			console.log("push", $scope.pushNotification);
			EventiService.sendNotification($scope.pushNotification).$promise.then(function (r) {
				Notification.success("Notifica inviata");
				loadNotifications();
				console.log("ok", r);
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});

		}

		$scope.viewEventAccess = function (id) {
			var modalInstance = $uibModal.open({
				templateUrl: 'app/pages/eventi/event-access-modal.html',
				controller: 'EventAccessCtrl',
				size: 'sm',// a controller for modal instance
				resolve: {
					eventid: function () {
						return id;
					}
				} // data passed to the controller
			}).result.then(function (data) {
				//do logic
			}, function () {
				// action on popup dismissal.
			});
		}



		$scope.deleteNotification = function (id) {
			$ngConfirm({
				title: 'Attenzione',
				content: 'Sei sicuro di voler eliminare la notifica selezionata?',
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Conferma",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {

							EventiService.deleteNotification(id).$promise.then(function (response) {

								Notification.success("Notifica eliminata");
								loadNotifications();
							}, function (error) {
								console.log("Errore Annulla PNR", error);
								Notification.error("Si è verificato un errore");
							});

						}
					},
					cancel: {
						text: "No, ci ho ripensato",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});
		}

		$scope.migrateTickets = function () {
			$ngConfirm({
				title: 'Attenzione',
				content: "Sei sicuro di voler migrare " + $scope.totalItems + " ticket? L'operazioe portebbe richiedere fino a 90 secondi",
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Conferma",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {
							$scope.migratingTickets = true;
							EventiService.migrateTickets($scope.evento).$promise.then(function (r) {
								Notification.success("Migrazione effettuata");
								$scope.migratingTickets = false;
							}, function (e) {
								$scope.migratingTickets = false;
								Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
							});

						}
					},
					cancel: {
						text: "No, ci ho ripensato",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});
		}

		function loadEvento() {

			if ($stateParams.id) {
				EventiService.getEvento($stateParams.id).$promise.then(function (r) {
					$scope.evento = r;
					console.log(r);

					getPnrCount();
					getPnrRange(start, stop);

					if ($scope.evento.startdate) {
						$scope.evento.iniziodate = new Date($scope.evento.startdate * 1000);
						$scope.evento.iniziotime = $scope.evento.iniziodate;
					}

					if ($scope.evento.enddate) {
						$scope.evento.finedate = new Date($scope.evento.enddate * 1000);
						$scope.evento.finetime = $scope.evento.finedate;
					}

					$scope.heatmapRange = {
						start: 0,
						stop: $scope.evento.enddate
					}

					// getProvincia();
					// getComune();
					loadEventHeatmap();
					loadEventSpeakers($scope.evento);
					//loadPartecipanti($scope.evento);

					if ($stateParams.duplicate) {
						delete $scope.evento.id;
					}

				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
			else {
				$scope.evento = {};
			}
		}

		loadEvento();
		getVenues();
		if ($stateParams.id) {
			getStats();
		}

		$scope.refreshHeatmap = function () {
			loadEventHeatmap();
		}

		function loadEventHeatmap() {
			EventiService.getHeatmapData($scope.evento.id, $scope.heatmapRange.start, $scope.heatmapRange.stop).$promise.then(function (result) {
				var struct = getHeatmapStruct(result);
				$scope.bounds = struct.bounds;

				if (!map) {
					drawMap(struct);
				}
				else {
					setValues(struct.data);
					$scope.fitBounds();
				}

			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		function getHeatmapStruct(data) {
			var struct = {
				data: []
			};

			if (data.length > 0) {
				struct.bounds = new google.maps.LatLngBounds();
				angular.forEach(data, function (item) {
					var loc = new google.maps.LatLng(item.lat, item.lng);
					struct.data.push({ location: loc, weight: item.weight });
					struct.bounds.extend(loc);
				});
			}
			else {
				var rome = { lat: 41.90, lng: 12.49 };
				struct.center = rome;
			}
			return struct;
		}

		function drawMap(struct) {

			map = new google.maps.Map($document[0].getElementById('map'), {
				mapTypeId: 'satellite',

			});

			if (struct.data.length <= 0) {
				map.setCenter(new google.maps.LatLng(struct.center.lat, struct.center.lng));
				map.setZoom(6);
			}
			else {
				setValues(struct.data);
			}
		}

		function setValues(data) {
			if (!!heatmap && !!heatmap.setMap)
				heatmap.setMap(null);
			heatmap = new google.maps.visualization.HeatmapLayer({
				data: data
			});
			heatmap.setMap(map);


		}


		$scope.fitBounds = function () {
			$timeout(function () {
				if ($scope.bounds)
					map.fitBounds($scope.bounds);
				else {
					var rome = { lat: 41.90, lng: 12.49 };
					map.setCenter(new google.maps.LatLng(rome.lat, rome.lng));
					map.setZoom(6);
				}
			}, 100);
		}

		function getStats() {
			EventiService.getStatisticheEvento($stateParams.id).$promise.then(function (r) {
				$scope.stats = r;
				console.log("stats", r);
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		function getVenues() {
			VenueService.getAll().$promise.then(function (r) {
				$scope.venues = r;

			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}



		$scope.searchVenues = function (str) {


			var search = {
				search: str
			}
			VenueService.search(search).$promise.then(function (r) {
				$scope.venues = r;
				console.log(r);

			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});



		}

		function loadSpeakers() {
			SpeakerService
				.getSpeakers()
				.$promise
				.then(function (r) {
					$scope.speakers = r;
				});
		}

		loadSpeakers();

		function loadEventSpeakers(ev) {

			EventiService
				.getSpeakerEvento(ev)
				.$promise
				.then(function (r) {
					$scope.eventspeakers = r;
					console.log(r);

				}, function (err) {
					Notification.error("Si è verificato un errore");
					console.log(err);
				});

		}



		$scope.pnrFilter = {
			pnr: "",
			name: "",
			invitedby: ""
		}

		function resetPnrSearch() {
			start = 0;
			stop = 15;
			getPnrRange(start, stop);
		}

		$scope.$watch("pnrFilter.pnr", function (newValue, oldValue) {
			if ($scope.evento && $scope.evento.id) {
				if ($scope.pnrFilter.pnr.length == 12) {
					$scope.searchPnrObj.simple = $scope.searchPnrObj.simple.filter(function (ss) { return ss.field !== 'pnr' });
					$scope.searchPnrObj.simple.push({ field: "pnr", filter: $scope.pnrFilter.pnr });
					start = 0;
					stop = 15;
					getPnrRange(start, stop);
				}

				if ($scope.pnrFilter.pnr.length == 0) {
					$scope.searchPnrObj.simple = $scope.searchPnrObj.simple.filter(function (ss) { return ss.field !== 'pnr' });
					resetPnrSearch();
				}
			}
		});

		$scope.$watch("pnrFilter.name", function (newValue, oldValue) {
			if ($scope.evento && $scope.evento.id) {
				if ($scope.pnrFilter.name.length) {
					$scope.searchPnrObj.like = $scope.searchPnrObj.like.filter(function (ss) { return ss.field !== 'guestname' });
					$scope.searchPnrObj.like.push({ field: "guestname", term: $scope.pnrFilter.name });
					start = 0;
					stop = 15;
					getPnrRange(start, stop);
				} else {
					$scope.searchPnrObj.like = $scope.searchPnrObj.like.filter(function (ss) { return ss.field !== 'guestname' });
					resetPnrSearch();
				}
			}
		});


		$scope.$watch("pnrFilter.invitedby", function (newValue, oldValue) {
			if ($scope.evento && $scope.evento.id) {
				if ($scope.pnrFilter.invitedby.length) {
					$scope.searchPnrObj.like = $scope.searchPnrObj.like.filter(function (ss) { return ss.field !== 'invitedby' });
					$scope.searchPnrObj.like.push({ field: "invitedby", term: $scope.pnrFilter.invitedby });
					start = 0;
					stop = 15;
					getPnrRange(start, stop);
				} else {
					$scope.searchPnrObj.like = $scope.searchPnrObj.like.filter(function (ss) { return ss.field !== 'invitedby' });
					resetPnrSearch();
				}
			}
		});


		function getPnrRange(start, stop) {
			$scope.loading = true;
			EventiService.getPartecipantiAdSearch($scope.searchPnrObj, start, stop).$promise.then(function (r) {
				$scope.partecipanti = r;
				$scope.loading = false;
				$scope.hasAttended = 0;


			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		function getPnrCount() {
			EventiService.getPartecipantiCount($scope.searchPnrObj).$promise.then(function (r) {
				$scope.totalItems = r.ct;
				console.log("total", $scope.totalItems);
			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		$scope.getPnrData = function (newPageNumber, oldPageNumber) {
			var start;
			var stop;
			start = (newPageNumber - 1) * $scope.itemsPerPage;
			stop = start + $scope.itemsPerPage;
			getPnrRange(start, stop);
		}


		function loadPartecipanti(ev) {

			EventiService
				.getPartecipantiEvento(ev)
				.$promise
				.then(function (r) {
					$scope.partecipanti = r;
					$scope.hasAttended = 0;
					angular.forEach($scope.partecipanti, function (value, key) {
						if (value.seen > 0) $scope.hasAttended++;
						value.editable = false;
					});

				}, function (err) {
					Notification.error("Si è verificato un errore");
					console.log(err);
				});

		}

		$scope.editGuestName = function (p) {
			console.log('edit guest name', p);
			EventiService
				.savePNR(p)
				.$promise
				.then(function (r) {

					Notification.success("Nome ospite salvato con successo.");

				}, function (err) {
					Notification.error("Si è verificato un errore");
					console.log(err);
				});

		};

		$scope.burnPNR = function (pnr) {

			$ngConfirm({
				title: 'Attenzione',
				content: 'Sei sicuro di voler annullare il PNR? La procedura è irreversibile.',
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Conferma",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {

							EventiService.burnPNR(pnr).$promise.then(function (response) {
								console.log("Annulla PNR", response);
								Notification.success("PNR annullato correttamente");
								loadEvento();
							}, function (error) {
								console.log("Errore Annulla PNR", error);
								Notification.error("Si è verificato un errore");
							});

						}
					},
					cancel: {
						text: "No, ci ho ripensato",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});

		};

		$scope.salva = function () {

			if ($scope.evento.iniziodate && $scope.evento.iniziotime) {
				var iniziotime = moment($scope.evento.iniziotime);
				var inizio = moment($scope.evento.iniziodate).hours(iniziotime.hours()).minute(iniziotime.minutes());
				$scope.evento.startdate = parseInt(inizio.toDate().getTime() / 1000);
			}
			if ($scope.evento.finedate && $scope.evento.finetime) {
				var finetime = moment($scope.evento.finetime);
				var fine = moment($scope.evento.finedate).hours(finetime.hours()).minute(finetime.minutes());
				$scope.evento.enddate = parseInt(fine.toDate().getTime() / 1000);
			}


			if ($scope.selectedVenue.r) {
				$scope.evento.vid = $scope.selectedVenue.r.originalObject.id;
				$scope.evento.venue = $scope.selectedVenue.r.originalObject;
			}

			if ($scope.evento.id) {
				EventiService.aggiornaEvento($scope.evento).$promise.then(function (r) {
					loadEvento();
					Notification.success('Salvato');

				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
			else {
				EventiService.creaEvento($scope.evento).$promise.then(function (r) {
					Notification.success('Evento salvato');
					$state.go('modifica-evento', { id: r.id });
				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
		}




		$scope.immagine = {};
		$scope.uploadImmagine = function () {
			console.log($scope.immagine.file);
			if ($scope.immagine && $scope.immagine.file && $scope.evento && $scope.evento.id) {
				UploadService.uploadImage($scope.immagine.file).then(function (resp) {
					console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					$scope.evento.img = resp.data.path;
					$scope.salva.apply();
				}, function (resp) {
					console.log('Error status: ' + resp.status);
				}, function (evt) {
					var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				}).catch(function (e) {
					console.log(e);
				});
			}
		};

		$scope.f = {};
		$scope.uploadFile = function (file, errFiles) {

			$scope.f = file;

			if (file && $scope.evento && $scope.evento.id) {
				UploadService.uploadFlyer(file).then(function (resp) {
					Notification.success('File caricato');
					console.log('Success ' + resp.config.data.file.name + ' uploaded. Response: ' + resp.data);
					$scope.evento.flyer = resp.data.path;
					// $scope.prodotto.img=resp.data.path;
					$scope.salva.apply();
				}, function (resp) {
					console.log('Error status: ' + resp.status);
				}, function (evt) {
					console.log(evt);
					$scope.f.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
				}).catch(function (e) {
					console.log(e);
				});
			}

		};

		$scope.aggiungiSpeakerEvento = function (sp) {
			EventiService
				.addSpeakerEvento($scope.evento, sp)
				.$promise
				.then(function (r) {
					console.log(r);
					loadEventSpeakers($scope.evento);
				});
		}
		$scope.eliminaSpeakerEvento = function (sp) {
			EventiService
				.deleteSpeakerEvento(sp)
				.$promise
				.then(function () {
					loadEventSpeakers($scope.evento);
				});
		}

		$scope.bloccaSblocca = function (block) {
			var msg1 = !block ? 'sbloccare' : 'bloccare';
			var msg2 = !block ? 'di nuovo possibili' : 'sospesi';
			var btn = !block ? 'Sblocca' : 'Blocca';

			$ngConfirm({
				title: 'Blocca Evento',
				content: 'Sei sicuro di ' + msg1 + ' l\'evento "' + $scope.evento.name + '"? Gli accessi digitali saranno ' + msg2 + '.',
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: btn,
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {
							var newEvento = angular.copy($scope.evento);
							newEvento.status = block ? 'closed' : 'open';

							EventiService.aggiornaEvento(newEvento).$promise.then(function (r) {
								loadEvento();
								Notification.success('Evento salvato');
							}, function (e) {
								console.log(e);
								Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
							});
						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});
		}
	}

	function EventAccessCtrl($scope, eventid, $uibModalInstance, EventiService, Notification) {

		var search = {
			table: 'eventaccess',
			simple: [{ field: 'pnrid', 'filter': eventid }]
		}


		function loadEventAccess() {
			EventiService.searchEventAccess(search).$promise.then(function (results) {
				$scope.eventAccesses = results;
			}, function (error) {
				Notification.error(error.msg);
			})
		}

		loadEventAccess();
	}

})();

angular.module('AmwayAdmin.pages.dashboards').factory('DashboardsService', function (DataConnectorService) {

    var response = {};

    var colors = [
        "#ae90e2", "#bde052", "#14a9ad", "#5d1d0c", "#f2510e", "#28fcfd", "#3d6751", "#0f5997",
        "#406df9", "#521250", "#0f5997", "#20f6ba", "#4cf09d", "#de73c2", "#0d5ac1",
        "#76fc1b", "#63b598", "#ce7d78", "#ea9e70", "#a48a9e", "#c6e1e8", "#648177", 
        "#f205e6", "#1c0365", "#14a9ad", "#4ca2f9", "#a4e43f", "#d298e2", "#6119d0",
        "#d2737d", "#c0a43c", "#f2510e", "#651be6", "#79806e", "#61da5e", "#cd2f00",
        "#9348af", "#01ac53", "#c5a4fb", "#996635", "#b11573", "#4bb473", "#75d89e",
        "#2f3f94", "#2f7b99", "#da967d", "#34891f", "#b0d87b", "#ca4751", "#7e50a8",
        "#c4d647", "#e0eeb8", "#11dec1", "#289812", "#566ca0", "#ffdbe1", "#2f1179",
        "#935b6d", "#916988", "#513d98", "#aead3a", "#9e6d71", "#4b5bdc", "#0cd36d",
        "#250662", "#cb5bea", "#228916", "#ac3e1b", "#df514a", "#539397", "#880977",
        "#f697c1", "#ba96ce", "#679c9d", "#c6c42c", "#5d2c52", "#48b41b", "#e1cf3b",
        "#5be4f0", "#57c4d8", "#a4d17a", "#225b8", "#be608b", "#96b00c", "#088baf",
        "#f158bf", "#e145ba", "#ee91e3", "#05d371", "#5426e0", "#4834d0", "#802234",
        "#6749e8", "#0971f0", "#8fb413", "#b2b4f0", "#c3c89d", "#c9a941", "#41d158",
        "#fb21a3", "#51aed9", "#5bb32d", "#807fb", "#21538e", "#89d534", "#d36647",
        "#7fb411", "#0023b8", "#3b8c2a", "#986b53", "#f50422", "#983f7a", "#ea24a3",
        "#79352c", "#521250", "#c79ed2", "#d6dd92", "#e33e52", "#b2be57", "#fa06ec",
        "#1bb699", "#6b2e5f", "#64820f", "#1c271", "#21538e", "#89d534", "#d36647",
        "#7fb411", "#0023b8", "#3b8c2a", "#986b53", "#f50422", "#983f7a", "#ea24a3",
        "#79352c", "#521250", "#c79ed2", "#d6dd92", "#e33e52", "#b2be57", "#fa06ec",
        "#1bb699", "#6b2e5f", "#64820f", "#1c271", "#9cb64a", "#996c48", "#9ab9b7",
        "#06e052", "#e3a481", "#0eb621", "#fc458e", "#b2db15", "#aa226d", "#792ed8",
        "#73872a", "#520d3a", "#cefcb8", "#a5b3d9", "#7d1d85", "#c4fd57", "#f1ae16",
        "#8fe22a", "#ef6e3c", "#243eeb", "#1dc18", "#dd93fd", "#3f8473", "#e7dbce",
        "#421f79", "#7a3d93", "#635f6d", "#93f2d7", "#9b5c2a", "#15b9ee", "#0f5997",
        "#409188", "#911e20", "#1350ce", "#10e5b1", "#fff4d7", "#cb2582", "#ce00be",
        "#32d5d6", "#17232", "#608572", "#c79bc2", "#00f87c", "#77772a", "#6995ba",
        "#fc6b57", "#f07815", "#8fd883", "#060e27", "#96e591", "#21d52e", "#d00043",
        "#b47162", "#1ec227", "#4f0f6f", "#1d1d58", "#947002", "#bde052", "#e08c56",
        "#28fcfd", "#bb09b", "#36486a", "#d02e29", "#1ae6db", "#3e464c", "#a84a8f",
        "#911e7e", "#3f16d9", "#0f525f", "#ac7c0a", "#b4c086", "#c9d730", "#30cc49",
        "#3d6751", "#fb4c03", "#640fc1", "#62c03e", "#d3493a", "#88aa0b", "#406df9",
        "#615af0", "#4be47", "#2a3434", "#4a543f", "#79bca0", "#a8b8d4", "#00efd4",
        "#7ad236", "#7260d8", "#1deaa7", "#06f43a", "#823c59", "#e3d94c", "#dc1c06",
        "#f53b2a", "#b46238", "#2dfff6", "#a82b89", "#1a8011", "#436a9f", "#1a806a",
        "#4cf09d", "#c188a2", "#67eb4b", "#b308d3", "#fc7e41", "#af3101", "#ff065",
        "#71b1f4", "#a2f8a5", "#e23dd0", "#d3486d", "#00f7f9", "#474893", "#3cec35",
        "#1c65cb", "#5d1d0c", "#2d7d2a", "#ff3420", "#5cdd87", "#a259a4", "#e4ac44",
        "#1bede6", "#8798a4", "#d7790f", "#b2c24f", "#de73c2", "#d70a9c", "#25b67",
        "#88e9b8", "#c2b0e2", "#86e98f", "#ae90e2", "#1a806b", "#436a9e", "#0ec0ff",
        "#f812b3", "#b17fc9", "#8d6c2f", "#d3277a", "#2ca1ae", "#9685eb", "#8a96c6",
        "#dba2e6", "#76fc1b", "#608fa4", "#20f6ba", "#07d7f6", "#dce77a", "#77ecca"]

    /*var colors = [
        "#ae90e2", "#bde052", "#14a9ad", "#5d1d0c", "#f2510e", "#28fcfd", "#3d6751", "#0f5997",
         "#406df9", "#521250", "#0f5997", "#20f6ba", "#4cf09d", "#de73c2",
        "#76fc1b" ];*/
   

    var default_colors = [
                'orange', 'cyan', 'red', 'blue', 'gray', 'purple', 'pink', 'green','yellow',
                'brown','black', 'coral', 'lime', 'crimson', 'salmon', 'slateblue'];



    response.getEvento = function (id) {

        return DataConnectorService.getResource('event/stats/:id', {
            id: id
        }).get();

    }

    response.getProductsDetail = function (month, year) {
        var config = {
            isArray: true
        };
        return DataConnectorService.getResource('stat/product/detail/:year/:month', {
            month: month,
            year: year
        }, config).get();
    }

    response.getTypesDetail = function (month, year) {
        var config = {
            isArray: true
        };
        return DataConnectorService.getResource('stat/type/detail/:year/:month', {
            month: month,
            year: year
        }, config).get();
    }

    response.getProductsDetailRange = function (from, to) {
        var config = {
            isArray: true
        };
        return DataConnectorService.getResource('stat/product/detail/range/:from/:to', {
            from: from,
            to: to
        }, config).get();
    }

    response.getTypesDetailRange = function (from, to) {
        var config = {
            isArray: true
        };
        return DataConnectorService.getResource('stat/type/detail/range/:from/:to', {
            from: from,
            to: to
        }, config).get();
    }

    response.getProductBarchart = function (id) {
        var config = {
            isArray: true
        };
        return DataConnectorService.getResource('stat/product/:id/barchart', {id: id}, config).get();
    }

    response.getTypeBarchart = function () {
        var config = {
            isArray: true
        };
        return DataConnectorService.getResource('stat/type/barchart', {
        }, config).get();
    }

    response.getTopSellRange = function (start, stop, pagestart, pagestop) {
        var config = {
            isArray: true
        };
        return DataConnectorService.getResource('stat/topsell/:start/:stop/:pagestart/:pagestop', {
            start : start,
            stop : stop,
            pagestart: pagestart,
            pagestop: pagestop
        }, config).get();
    }

    response.getCepBarchart = function (type) {
        var config = {
            isArray: true
        };
        return DataConnectorService.getResource('stat/cep/:type/barchart', {
            type: type
        }, config).get();
    }

    response.getCepDetails = function (type, year, month) {
        var config = {
            isArray: false
        };
        return DataConnectorService.getResource('stat/cep/detail/:type/:year/:month', {
            type: type,
            year: year,
            month: month
        }, config).get();
    }

    response.getEventsBarchart = function (type, venue) {
        var config = {
            isArray: true
        };
        return DataConnectorService.getResource('stat/event/:type/:venue/barchart', {
            type: type,
            venue: venue,
        }, config).get();
    }

    response.getColor = function (index) {
        return colors[index];
    }

    response.getDefaultColor = function (index) {
        return default_colors[index];
    }


    response.getRandomColor = function() {
        return colors[Math.floor(Math.random() * 280)];
    }

    response.getDefaultRandomColor = function () {
        return default_colors[Math.floor(Math.random() * 11)];
    }

    response.getTracks = function () {
        var config = {
            isArray: true
        };
        return DataConnectorService.getResource('stat/tracks', {}, config).get();
    }

    response.getLastUpdate = function () {
        var config = {
            isArray: true
        };
        return DataConnectorService.getResource('statupdate', {}, config).get();
    }

    response.getShareTracks = function () {
        var config = {
            isArray: false
        };
        return DataConnectorService.getResource('stat/share/tracks', {}, config).get();
    }

    response.getShareTops = function () {
        var config = {
            isArray: false
        };
        return DataConnectorService.getResource('stat/share/top', {}, config).get();
    }

    response.postShareBarChart = function(postObj) {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('stat/share/barchart', {}, config).post(postObj);
	}

	response.getEventTops = function (id) {
        var config = {
            isArray: false
        };
        return DataConnectorService.getResource('stat/event/:id/additional', { id: id }, config).get();
    }

    response.getSingleEventBarchart = function (id, price, start, stop) {
        if(!start) start = 0;
        if (!stop) stop = 2147483647;
        var config = {
            isArray: true
        };
        return DataConnectorService.getResource('stat/event/:id/barchart/:price/range/:start/:stop', 
        { 
            id: id,
            price:price,
            start: start,
            stop: stop
         }, config).get();
    }

    response.countSellers = function (start, stop) {
        var config = {
            isArray: false
        };
        return DataConnectorService.getResource('stat/topsell/:start/:stop/count', {start:start, stop:stop}, config).get();
    }

    response.getUserHeatmapData = function (start, stop) {
        var config = {
            isArray: true
        };
        return DataConnectorService.getResource('heatmap/user/:start/:stop', { start: start, stop: stop }, config).get();
    }

    response.getRevenueHeatmapData = function (start, stop) {
        var config = {
            isArray: true
        };
        return DataConnectorService.getResource('heatmap/userrevenue/:start/:stop', { start: start, stop: stop }, config).get();
    }

    return response;

});
angular.module('AmwayAdmin.pages.leader').factory('LeaderService', function (DataConnectorService) {

	return {
    getLeaders: function() {
      return DataConnectorService
        .getResource('leader', {}, { isArray: true })
        .get();
    },
    getLeader: function(id) {
      return DataConnectorService
        .getResource('leader/:id', { id: id })
        .get();
    },
    updateLeader: function(sp) {
      return DataConnectorService
        .getResource('leader/:id', { id: sp.id })
        .put(sp);
    },
    createLeader: function(sp) {
      return DataConnectorService
        .getResource('leader')
        .post(sp);
    },
    deleteLeader: function(id) {
      return DataConnectorService
        .getResource('leader/:id', { id: id })
        .delete();
    },
  };

});
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.leader')
    .controller('LeaderCtrl', LeaderCtrl);

  /** @ngInject */
  function LeaderCtrl($scope, $state, $location, LeaderService, UploadService, Notification, DataConnectorService) {


$scope.baseurl= DataConnectorService.getPreviewBaseUrl();


    if(!!$state.params.id)
      LeaderService
        .getLeader($state.params.id)
        .$promise
        .then(function (r) {
          console.log(r);
          $scope.leader = r;

        }, function (e) {
          console.log(e);
          Notification.error('Si è verificato un errore');
          //TODO gestire errore
        });
    else
      $scope.leader = {};

    $scope.salva = function () {
      if(!!$state.params.id)
        LeaderService
          .updateLeader($scope.leader)
          .$promise
          .then(function (r) {
            console.log(r);
            Notification.success('Salvato');
            $scope.leader = r;

          }, function (e) {
            console.log(e);
            Notification.error('Si è verificato un errore');
            //TODO gestire errore
          });
      else
        LeaderService
          .createLeader($scope.leader)
          .$promise
          .then(function (r) {
            console.log(r);
            Notification.success('Salvato');
            $scope.leader = r;
            $location.path('/modifica-leader/' + r.id);

          }, function (e) {
            console.log(e);
            Notification.error('Si è verificato un errore');
            //TODO gestire errore
          });
    }

    $scope.elimina = function() {
      LeaderService
        .deleteLeader($scope.leader)
        .$promise
        .then(function(r) {
          Notification.success('Leader eliminato')
          $state.go('leaders');
        });
    }

    $scope.immagine = {};
    $scope.uploadImmagine = function (whichPic) {
      var curimmagine = $scope.immagine[whichPic];
      console.log('curimmagine',curimmagine);
      if (curimmagine.file && $scope.leader.id) {
        UploadService.uploadImage(curimmagine.file).then(function (resp) {

          Notification.success('Immagine caricata');
          console.log('Success ' + resp.config.data.file.name + ' uploaded. Response: ' + resp.data);

          switch (whichPic) {
            case 'profilepic':
              $scope.leader.profilepic = resp.data.path;
              break;
            case 'familypic':
              $scope.leader.familypic = resp.data.path;
              break;
            case 'lifestyle':
              $scope.leader.lifestyle = resp.data.path;
              break;
            case 'otherpic':
              $scope.leader.otherpic = resp.data.path;
              break;
            default:
              $scope.leader.profilepic = resp.data.path;
          }

          $scope.salva.apply();
        }, function (resp) {

          Notification.success('Si è verificato un errore');
          console.log('Error status: ' + resp.status);
        }, function (evt) {
          
          $scope.immagine[whichPic].progress = parseInt(100.0 * evt.loaded / evt.total);
          console.log('progress: ' + $scope.immagine[whichPic].progress + '% ' + evt.config.data.file.name);
        }).catch(function (e) {
          
          Notification.error('Si è verificato un errore');
          console.log(e);
        });
      }
      else {
        $scope.salva.apply();
      }

    };

  }


})();
(function() {
  'use strict';

  angular.module('AmwayAdmin.pages.leader')
    .controller('LeadersCtrl', LeadersCtrl);

  /** @ngInject */
  function LeadersCtrl($scope, LeaderService, Notification, $ngConfirm) {

    $scope.loading = true;

    function loadleaders(){
      LeaderService
        .getLeaders()
        .$promise
        .then(function(r) {
          console.log(r);
          $scope.leaders = r;
          $scope.loading = false;

        }, function(e) {
          console.log(e);
          Notification.error('Si è verificato un errore');
          //TODO gestire errore
        });
    }

    loadleaders();

    $scope.leadersTablePageSize = 15;

    $scope.elimina = function (id){
      $ngConfirm({
        title: 'Elimina Leader',
        content: "Sei sicuro di eliminare il leader selezionato?",
        scope: $scope,
        closeIcon: true,
        buttons: {
                    // long hand button definition
                    ok: {
                      text: "Elimina",
                      btnClass: 'btn-primary',
                        keys: ['enter'], // will trigger when enter is pressed
                        action: function (scope) {
                          LeaderService.deleteLeader(id).$promise.then(function(r) {
                            Notification.success('Leader eliminato');
                            loadleaders();
                          }, function(e) {
                            console.log(e);
                            Notification.error('Si è verificato un errore');
                                //TODO gestire errore
                              });
                        }
                      },
                      cancel: {
                        text: "Annulla",
                        btnClass: 'btn-default',
                        action: function (scope) {
                          return true;
                        }
                      }
                    },
                  });
      
    }

  }


})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
		'use strict';

		angular.module('AmwayAdmin.pages.listini')
			.controller('ListiniListCtrl', ListiniListCtrl);

		/** @ngInject */
		function ListiniListCtrl($scope, $ngConfirm, ListiniService, ProductService, DataConnectorService, Notification) {

    $scope.baseurl = DataConnectorService.getPreviewBaseUrl();
    $scope.loading = true;

    function loadListini(){

			ListiniService.getAll().$promise.then(function(r) {
				$scope.listini = r;
                console.log(r);
                $scope.loading = false;

			}, function(e) {
				console.log(e);
			});
		}

			loadListini();

			$scope.moduliTablePageSize = 10;



				$scope.eliminaListino = function(ev){
                    console.log(ev);
			$ngConfirm({
        title: 'Elimina Listino',
        content: 'Sei sicuro di eliminare il listino ' + ev.name + '?',
        scope: $scope,
        closeIcon: true,
        buttons: {   
            // long hand button definition
            ok: { 
                text: "Elimina",
                btnClass: 'btn-primary',
                keys: ['enter'], // will trigger when enter is pressed
                action: function(scope){
                	//console.log(ProductService);
                     ListinieService.eliminaListino(ev.id).$promise.then(function(r) {	
                            Notification.success('Listino eliminato');
    						loadListini();
    					}, function(e) {
    						console.log(e);
    					});

                }
            },
            cancel: { 
                text: "Annulla",
                btnClass: 'btn-default',
                action: function(scope){
                	return true;
                }
            }
        },
    });
		}


		}
	
})();

angular.module('AmwayAdmin.pages.listini').factory('ListiniService', function(DataConnectorService) {

	var response = {};

	response.getAll = function() {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('pricing', {}, config).get();
	}

	response.getListino = function(id) {
		return DataConnectorService.getResource('pricing/:id', {
			id: id
		}).get();
	}



	response.aggiornaListino = function(listino) {
		return DataConnectorService.getResource('pricing').post(listino);
	}

	response.eliminaListino = function(id) {
		return DataConnectorService.getResource('pricing/:id', { id: id }).delete();
	}


	response.aggiungiProdotto = function(productpricing) {
		return DataConnectorService.getResource('productpricing').post(productpricing);
	}

	response.getProdottiAssociati = function(id) {
		return DataConnectorService.getResource('productpricing/filter/pricingid/:id/range/0/100', {id: id}, {isArray: true}).get();
	}

	response.aggiungiProdotti = function(prodotti) {
		return DataConnectorService.getResource('productpricing/batch').post({products: prodotti});
	}

		response.rimuoviProdotto = function(productpricing) {
		return DataConnectorService.getResource('productpricing').delete();
	
		}
	return response;

});

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('AmwayAdmin.pages.listini')
		.controller('ListinoCtrl', ListinoCtrl);

	/** @ngInject */
	function ListinoCtrl($scope, $state, $stateParams, $q, md5, ModuleService, UploadService, DataConnectorService,UtentiService,ProductService, EventiService, ListiniService,Notification) {

		// $scope.baseurl = DataConnectorService.getPreviewBaseUrl();


		$scope.date={};

		function loadListino() {

			if ($stateParams.id) {
				ListiniService.getListino($stateParams.id).$promise.then(function (r) {
					$scope.listino = r;
					console.log(r);

				
					if($stateParams.duplicate) {
						delete $scope.listino.id;
					}
					else{        loadProdotti();
						getProdottiAssociati();
}

getEvento();
getIncaricato();

				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
			else {
				$scope.listino = {};
			}
		}

		loadListino();


		function getIncaricati() {
			UtentiService.getIncaricati().$promise.then(function (r) {
				$scope.incaricati = r;
			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		

function getEventi(){
	ProductService.getEventiFuturi().$promise.then(function (r) {
			$scope.eventi = r;

		}, function (e) {
			console.log(e);
			Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
		});
}

function loadProdotti() {
            ProductService.getAll().$promise.then(function (r) {
                $scope.prodotti = r;
            }, function (e) {
                console.log(e);
            });
        }


        function getProdottiAssociati() {
            ListiniService.getProdottiAssociati($stateParams.id).$promise.then(function (r) {
                $scope.prodottiAssociati = _.indexBy(r, 'productid');
                console.log($scope.prodottiAssociati);
            }, function (e) {
                console.log(e);
            });
        }


function getEvento(){
	if($scope.listino.eid){
	EventiService.getEvento($scope.listino.eid).$promise.then(function (r) {
					$scope.date.selectedEvent = r;
				});
}
}


function getIncaricato(){
	if($scope.listino.root){
	UtentiService.getUtente($scope.listino.root).$promise.then(function (r) {
					$scope.date.selectedIncaricato = r;
				});
}
}

getIncaricati();

getEventi();


$scope.rimuoviIncaricato =function(){
		$scope.date.selectedIncaricato=undefined;
		$scope.listino.root=undefined;
};

$scope.rimuoviEvento =function(){
		$scope.date.selectedEvent=undefined;
		$scope.listino.eid=undefined;
};
		$scope.salva = function () {

			$scope.listino.entity = 'pricing';

			var insDate = moment(new Date());
			

			ListiniService.aggiornaListino($scope.listino).$promise.then(salvaProdotti).then(function(){
			    Notification.success('Listino salvato');
			    					loadListino();
			    						$state.go('modifica-listino',{id:r.id});
			    				}).catch(function (e) {
		      
		      Notification.error('Si è verificato un errore');
		      console.log(e);
		    });;
		};

$scope.date.prodottichanged=false;
		function salvaProdotti(){
			console.log($scope.date.prodottichanged);

			if($scope.date.prodottichanged){
			var prodottipricing=[];
			 _.each($scope.prodotti, function (c) { 
			 	console.log(c);
			 	if( c.checked){
			 		var productpric={pricingid: $scope.listino.id, productid: c.id, price: c.lprice};
						prodottipricing.push(productpric);
									 		//ListiniService.aggiungiProdotto(productpric);for testing purpose

			 	} 
			 });


			 return ListiniService.aggiungiProdotti(prodottipricing).$promise;
			}
			else return $q.when([1]);
		}
	}

})();

'use strict';

angular.module('AmwayAdmin.pages.magazzino').factory('MagazzinoService', function(DataConnectorService) {

	var response = {};

	response.getProduct = function(sku) {
		var config = {
			isArray: false
		};
		return DataConnectorService.getResource('product/sku/:sku', {
			sku: sku
		}, config).get();

	};

	response.getCausali = function() {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('causalemagazzino', {}, config).get();
	};

	response.saveLoad = function(newLoad) {
		return DataConnectorService
			.getResource('inventorychange')
			.post(newLoad);
	};

	response.getShipTasks = function(status) {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('shiptask/filter/status/:status/range/0/100', { status: status }, config).get();
	};

	response.deleteShipTask = function(id) {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('shiptask/:id', { id: id }, config).delete();
	};

	response.getAddressCheck = function(task) {
		var config = {
			isArray: true
		};
		return DataConnectorService
			.getResource('shiptask/checkaddress', {}, config)
			.post(task);
	};

	response.saveTask = function(task) {
		return DataConnectorService
			.getResource('shiptask/add')
			.post(task);
	};

	response.saveShiptask = function(task) {
		return DataConnectorService
			.getResource('shiptask')
			.post(task);
	};

	response.fixAddressTask = function(address, id) {
		return DataConnectorService
			.getResource('shiptask/:id/fix', {id:id})
			.post(address);
	};

	response.deleteParcel = function(task) {
		return DataConnectorService
			.getResource('shiptask/deleteparcel')
			.post(task);
	};

	response.closeShipTasks = function(tasksList) {
		var config = {
			isArray: true
		};
		return DataConnectorService
			.getResource('shiptask/close', {}, config)
			.post(tasksList);
	};

	return response;

});
(function() {

		'use strict';

		angular
			.module('AmwayAdmin.pages.magazzino')
			.controller('MagazzinoCtrl', MagazzinoCtrl);

		/** @ngInject */
		function MagazzinoCtrl($rootScope, $scope, MagazzinoService, $uibModal, $log, Notification, DataConnectorService, $ngConfirm) {

			$scope.previewBaseUrl = DataConnectorService.getPreviewBaseUrl();
			$rootScope.modalF = true;
			var product = {};
			var causali = [];
			var addressList = [];
			$scope.sku = '';
			$scope.inputLoad = false;
			$scope.loading = true;
			$scope.tasksP = [];
			$scope.tasksA = [];
			$scope.tasksG = [];

			function getProduct(sku) {
				return MagazzinoService.getProduct(sku);
			}

			function getCausali() {
				return MagazzinoService.getCausali();
			}

			function getShipTasks(status) {
				MagazzinoService.getShipTasks(status).$promise.then(function(response) {

					if (status == 'tobeprocessed') {
						$scope.tasksP = [];
						angular.forEach(response, function(value, key) {
							value.enableManage = false;
							if (!value.order.digitalonly) {
								$scope.tasksP.push(value);
							}
						});

					} else if (status == 'added') {
						$scope.tasksA = [];
						angular.forEach(response, function(value, key) {
							if (!value.order.digitalonly) {
								$scope.tasksA.push(value);
							}
						});

					} else if (status == 'closed') {
						$scope.tasksG = [];
						angular.forEach(response, function(value, key) {
							if (!value.order.digitalonly) {
								$scope.tasksG.push(value);
							}
						});
					}

					$scope.loading = false;
				}, function(error) {
					console.log("Errore", error);
					Notification.error('Impossibile recuperare i dati');
				});
			}

			$scope.deleteShipTask = function(id, ev) {
				$ngConfirm({
					title: 'Attenzione!',
					content: "Sei sicuro di voler eliminare l'elemento selezionato?",
					scope: $scope,
					closeIcon: true,
					buttons: {
						// long hand button definition
						ok: {
							text: "Conferma",
							btnClass: 'btn-success btn-lg',
							keys: ['enter'], // will trigger when enter is pressed
							action: function(scope) {
								MagazzinoService.deleteShipTask(id).$promise.then(function(response) {
									getShipTasks('tobeprocessed');
									getShipTasks('added');
									getShipTasks('closed');
									Notification.success('Shiptask eliminato');
								}, function(error) {
									Notification.error(error.data.msg)
								});
							}
						},
						cancel: {
							text: "Annulla",
							btnClass: 'btn-danger btn-lg',
							action: function(scope) {
								return true;
							}
						}
					},
				});
			}

			function enableManageButton(task) {
				angular.forEach($scope.tasksP, function(value, key) {
					if (task.id == value.id) {
						value.enableManage = true;
					}
				})
			}

			getShipTasks('tobeprocessed');
			getShipTasks('added');
			getShipTasks('closed');

			$scope.open = function() {

				if ($scope.sku != null) {

					var p = getProduct($scope.sku).$promise.then(function(response) {
						return response;
					}, function(error) {
						console.log(error.data.code, error.data.msg);
						Notification.error(error.data.msg);
					});

					var c = getCausali().$promise.then(function(response) {
						return response;
					}, function(error) {
						console.log(error.data.code, error.data.msg);
						Notification.error(error.data.msg);
					});

					if (p && c) {
						var modalInstance = $uibModal.open({
							animation: true,
							templateUrl: 'app/pages/magazzino/modalProduct.html',
							controller: 'ModalProductCtrl',
							controllerAs: '$ctrl',
							resolve: {
								product: function() {
									return p;
								},
								causali: function() {
									return c;
								},
								selectedCausale: function() {
									return $scope.selectedCausale;
								}
							}
						});

						modalInstance.result.then(function(dati) {
							$scope.selectedCausale = dati.selectedCausale;
							MagazzinoService.saveLoad(dati.newLoad).$promise.then(function(response) {
								console.log("Carico salvato", response);
								Notification.success('Carico salvato');
								$scope.sku = null;
								getShipTasks('tobeprocessed');
								getShipTasks('added');
								getShipTasks('closed');
							}, function(error) {
								Notification.error('Impossibile salvare il carico, prego riprovare');
								$scope.sku = null;
								getShipTasks('tobeprocessed');
								getShipTasks('added');
								getShipTasks('closed');
							});
						}, function() {
							$log.info('Modal dismissed at: ' + new Date());
							$scope.sku = null;
							getShipTasks('tobeprocessed');
							getShipTasks('added');
							getShipTasks('closed');
						});
					}
				}
			};

			$scope.startLoad = function() {
				$scope.inputLoad = true;
			};

			$scope.endLoad = function() {
				$scope.inputLoad = false;
				$scope.selectedCausale = null;
			};

			// shiptask
			$scope.checkAddress = function(task) {
				console.log("Check Address of task:", task);

				MagazzinoService.getAddressCheck(task).$promise.then(function(response) {
							addressList = response;

							if (addressList && addressList.length && addressList[0] && addressList[0].match != true) {
								var modalInstance = $uibModal.open({
									animation: true,
									templateUrl: 'app/pages/magazzino/modalAddress.html',
									controller: 'ModalAddressCtrl',
									controllerAs: '$ctrl',
									resolve: {
										addressList: function() {
											return addressList;
										}
									}
								});

								modalInstance.result.then(function(address) {
									var idTask = task.id;
									MagazzinoService.fixAddressTask(address, idTask).$promise.then(function(response) {

										// è stato selezionato l'indirizzo di spedizione, procedo al salvataggio dello shiptask
										MagazzinoService.saveTask(task).$promise.then(function(response) {
											console.log("Shipment task salvato", response);
											Notification.success('Ordine gestito correttamente');
											enableManageButton(task);
										}, function(error) {
											console.log("Errore salvataggio shiptask", error);
											Notification.error('Impossibile controllare l\'indirizzo');
											getShipTasks('tobeprocessed');
											getShipTasks('added');
											getShipTasks('closed');
										});


									}, function(error) {
										Notification.error('Impossibile aggiustare l\'indirizzo');
										console.log("Impossibile fix Indirizzo", error);
										getShipTasks('tobeprocessed');
										getShipTasks('added');
										getShipTasks('closed');
									});

								}, function() {
									// chiusura Modale per click su Annulla/Dismiss
									$log.info('Modal dismissed at: ' + new Date());
									getShipTasks('tobeprocessed');
									getShipTasks('added');
									getShipTasks('closed');
								});

						} else if (addressList && addressList.length && addressList[0] && addressList[0].match == true) {
							// return singolo indirizzo nell'array con valore match == true, nessun fix necessario
							Notification.success('Indirizzo corretto');
							enableManageButton(task);
						}

					},
					function(error) {
						console.log("Errore GET lista indirizzi su singolo TASK", error);
						Notification.error('Impossibile recuperare i dati');
					});


		};

		$scope.manageOrder = function(task) {

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'app/pages/magazzino/modalShipment.html',
				controller: 'ModalShipmentCtrl',
				controllerAs: '$ctrl',
				resolve: {
					task: function() {
						return task;
					}
				}
			});

			modalInstance.result.then(function(task) {
				MagazzinoService.saveTask(task).$promise.then(function(response) {
					console.log("Shipment task salvato", response);
					Notification.success('Ordine gestito correttamente');
					$scope.sku = null;
					$scope.loading = true;
					getShipTasks('tobeprocessed');
					getShipTasks('added');
				}, function(error) {
					Notification.error('Impossibile salvare, prego riprovare');
					$scope.sku = null;
					$scope.loading = true;
					getShipTasks('tobeprocessed');
					getShipTasks('added');
					getShipTasks('closed');
				});
			}, function() {
				$log.info('Modal dismissed at: ' + new Date());
				$scope.sku = null;
				$scope.loading = true;
				getShipTasks('tobeprocessed');
				getShipTasks('added');
				getShipTasks('closed');
			});
		};

		function closeWorkingDay() {
			MagazzinoService.closeShipTasks($scope.tasksA).$promise.then(function(response) {
				console.log("GLS Completato", response);
				Notification.success('Inoltro al corriere completato');
				$scope.loading = true;
				getShipTasks('tobeprocessed');
				getShipTasks('added');
				getShipTasks('closed');
			}, function(error) {
				Notification.error('Impossibile chiudere le spedizioni, contattare l\'assistenza tecnica');
				console.log("GLS Errore", error);
				$scope.loading = true;
				getShipTasks('tobeprocessed');
				getShipTasks('added');
				getShipTasks('closed');
			});
		}

		$scope.closeShipments = function() {
			$ngConfirm({
				title: 'Attenzione!',
				content: "Sei sicuro di voler chiudere le spedizioni del giorno?",
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Conferma",
						btnClass: 'btn-success btn-lg',
						keys: ['enter'], // will trigger when enter is pressed
						action: function(scope) {
							closeWorkingDay();
						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-danger btn-lg',
						action: function(scope) {
							return true;
						}
					}
				},
			});
		};

		$scope.deleteParcel = function(task) {
			MagazzinoService.deleteParcel(task).$promise.then(function(response) {
				console.log("GLS delete parcel OK", response);
				Notification.success('Spedizione annullata');
				$scope.loading = true;
				getShipTasks('tobeprocessed');
				getShipTasks('added');
				getShipTasks('closed');

			}, function(error) {
				Notification.error('Impossibile annullare la spedizione, riprovare più tardi.');
				console.log("Errore POST delete Parcel GLS", error);
				$scope.loading = true;
				getShipTasks('tobeprocessed');
				getShipTasks('added');
				getShipTasks('closed');
			});
		};

		$scope.editAddress = function(task) {

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'app/pages/magazzino/modalEditAddress.html',
				controller: 'ModalAddressEditCtrl',
				controllerAs: '$ctrl',
				resolve: {
					task: function() {
						return task;
					}
				}
			});


			modalInstance.result.then(function(address) {
				task.glsaddress = address.glsaddress;
				task.glsprovince = address.glsprovince;
				task.glssigla = address.glssigla;
				task.glszip = address.glszip;
				task.glsloc = address.glsloc;
				task.glsshipto = address.glsshipto;

				MagazzinoService.saveShiptask(task).$promise.then(function(response) {
					console.log("Shipment task salvato", response);
					Notification.success('Ordine gestito correttamente');
					$scope.sku = null;
					$scope.loading = true;
					getShipTasks('tobeprocessed');
					getShipTasks('added');
				}, function(error) {
					Notification.error('Impossibile salvare, prego riprovare');
					$scope.sku = null;
					$scope.loading = true;
					getShipTasks('tobeprocessed');
					getShipTasks('added');
					getShipTasks('closed');
				});

			}, function() {
				// on dismiss modal
				$log.info('Modal dismissed at: ' + new Date());
				$scope.sku = null;
				$scope.loading = true;
				getShipTasks('tobeprocessed');
				getShipTasks('added');
				getShipTasks('closed');

			});
		};

	}
}());
(function() {

	'use strict';

	angular
		.module('AmwayAdmin.pages.magazzino')
		 		.controller('ModalAddressCtrl', ModalAddressCtrl);
 
 	/** @ngInject */
	function ModalAddressCtrl($scope, $uibModalInstance, addressList) {
 
 		var $ctrl = this;
			
		$ctrl.addressList = addressList;
 
		$ctrl.ok = function(address) {
			$uibModalInstance.close(address);
		}

		$ctrl.cancel = function() {
			$uibModalInstance.dismiss('cancel');
		};
	}
}());
(function() {

	'use strict';

	angular
		.module('AmwayAdmin.pages.magazzino')
		.controller('ModalAddressEditCtrl', ModalAddressEditCtrl);

	/** @ngInject */
	function ModalAddressEditCtrl($scope, $uibModalInstance, ConstantsService, task) {

		var $ctrl = this;

		$ctrl.provinces = ConstantsService.getProvince();
		$ctrl.dati = {
			selectedProvince: {
				descrizione: task.glsprovince ? task.glsprovince : task.order.province,
				sigla: task.glssigla ? task.glssigla : ''
			}
		};
		$ctrl.address = {
			glsaddress: task.glsaddress ? task.glsaddress : task.order.address,
			glszip: task.glszip ? task.glszip : task.order.zipcode,
			glsloc: task.glsloc ? task.glsloc : task.order.city,
			glsshipto: task.glsshipto ? task.glsshipto : task.order.shipto
		};

		$scope.$watch(angular.bind($ctrl, function() {
			return $ctrl.dati.selectedProvince;
		}), function(newValue, oldValue) {
			$ctrl.address.glsprovince = $ctrl.dati.selectedProvince.descrizione;
			$ctrl.address.glssigla = $ctrl.dati.selectedProvince.sigla;
		});
			
		$ctrl.save = function() {
			$uibModalInstance.close($ctrl.address);
		};

		$ctrl.cancel = function() {
			$uibModalInstance.dismiss('cancel');
		};
	}
}());
(function() {

	'use strict';

	angular
		.module('AmwayAdmin.pages.magazzino')
		.controller('ModalProductCtrl', ModalProductCtrl);

	/** @ngInject */
	function ModalProductCtrl($uibModalInstance, product, causali, selectedCausale) {

		var $ctrl = this;
		
		$ctrl.product = product;
		$ctrl.causali = causali;
		$ctrl.selectedCausale = selectedCausale ? selectedCausale : {};
		$ctrl.newLoad = {};

		$ctrl.disableButton = function() {
			if (angular.equals($ctrl.selectedCausale, {}) || angular.equals($ctrl.newLoad, {}) || $ctrl.newLoad.invchange == null) {
				return true;
			} else {
				return false;
			}
		};

		$ctrl.ok = function() {

			$ctrl.newLoad.pid = $ctrl.product.id;
			$ctrl.newLoad.causale = $ctrl.selectedCausale.codice;
			var dati = {
				newLoad: $ctrl.newLoad,
				selectedCausale: $ctrl.selectedCausale
			};
			$uibModalInstance.close(dati);
		};

		$ctrl.cancel = function() {
			$uibModalInstance.dismiss('cancel');
		};

	}
}());
(function() {

	'use strict';

	angular
		.module('AmwayAdmin.pages.magazzino')
		.controller('ModalShipmentCtrl', ModalShipmentCtrl);

	/** @ngInject */
	function ModalShipmentCtrl($scope, $uibModalInstance, task, DataConnectorService) {

		var $ctrl = this;
			
		$ctrl.baseurl = DataConnectorService.getPreviewBaseUrl();
		$ctrl.focusLoad = true;
		$ctrl.sku = '';
		$ctrl.task = task;

		function transformItems(items) {
			var itemsList = items.filter(function(item) {
				return (item.type != 'dpack' && item.type != 'audio' && item.type != 'ticket' && item.type != 'credit' && item.qty > 0)
			});

			angular.forEach(itemsList, function(value, key) {
				value.x = 0;
			});

			return itemsList;
		}

		$ctrl.items = transformItems($ctrl.task.order.items);
		$ctrl.enableSave = $ctrl.items.length;

		$ctrl.detectInput = function() {
			$ctrl.focusLoad = false;
			angular.forEach($ctrl.items, function(value, key) {
				if (value.product.sku == $ctrl.sku) {
					if (value.x != value.qty) {
						value.x++;
						if (value.x == value.qty) $ctrl.enableSave--;
					}
				}
			});
			$ctrl.sku = '';
			$ctrl.focusLoad = true;
		};

		/* persistent focus on hidden field */
		$scope.$watch(angular.bind($ctrl, function() {
			return $ctrl.focusLoad;
		}), function() {
				$ctrl.focusLoad = true;
		});

		/* end persistent focus on hidden field */

		$ctrl.ok = function() {
			$uibModalInstance.close($ctrl.task);
		};

		$ctrl.cancel = function() {
			$uibModalInstance.dismiss('cancel');
		};
	}
}());
angular.module('AmwayAdmin.pages.news').factory('NewsService', function(DataConnectorService) {

	var response = {};

	response.getAll = function() {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('news', {}, config).get();
	}

	response.getNews = function(id) {
		return DataConnectorService.getResource('news/:id', {
			id: id
		}).get();
	}

	response.creaNews = function(news) {
		console.log('news', news);
		return DataConnectorService.getResource('news').post(news);
	}

	response.aggiornaNews = function(news) {
		return DataConnectorService.getResource('news/:id', { id: news.id }).put(news);
	}

	response.eliminaNews = function(id) {
		return DataConnectorService.getResource('news/:id', { id: id }).delete();
	}

	return response;

});

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('AmwayAdmin.pages.news')
		.controller('NewsCtrl', NewsCtrl);

	/** @ngInject */
	function NewsCtrl($scope, $state, $stateParams, NewsService, DataConnectorService, Notification) {

		$scope.parent = {newsDate: ''};

		function loadNews() {

			if ($stateParams.id) {
				NewsService.getNews($stateParams.id).$promise.then(function (r) {
					$scope.news = r;
					console.log(r);

					if ($scope.news.newsdate) {
						$scope.parent.newsDate = new Date($scope.news.newsdate * 1000);
					}

					if($stateParams.duplicate) {
						delete $scope.news.id;
					}

				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
			else {
				$scope.news = {};
			}
		}

		loadNews();

		$scope.salva = function () {

			if ($scope.parent.newsDate) {
				var inizio = moment($scope.parent.newsDate);
				$scope.news.newsdate = parseInt(inizio.toDate().getTime() / 1000);
			}

			if ($state.current.name == 'modifica-news') {
				NewsService.aggiornaNews($scope.news).$promise.then(function(r) {
					Notification.success('News modificata e salvata');
					$state.go('news');
				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			} else {
				NewsService.creaNews($scope.news).$promise.then(function(r) {
					Notification.success('News aggiunta e salvata');
					$state.go('news');
				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}

			
		};

	}

})();
(function() {
    'use strict';

    angular.module('AmwayAdmin.pages.news')
        .controller('NewsListCtrl', NewsListCtrl);

    /** @ngInject */
    function NewsListCtrl($scope, $ngConfirm, NewsService, DataConnectorService, Notification) {

        $scope.loading = true;
        function loadNews() {

            NewsService.getAll().$promise.then(function(r) {
                $scope.news = r;
                console.log(r);
                $scope.loading = false;

            }, function(e) {
                console.log(e);
            });
        }

        loadNews();

        $scope.newsTablePageSize = 10;

        $scope.showNewsBody = function(news) {
            $ngConfirm({
                title: news.title,
                content: news.body,
                scope: $scope,
                closeIcon: true,
                buttons: {
                    cancel: {
                        text: "Chiudi",
                        btnClass: 'btn-default',
                        action: function(scope) {
                            return true;
                        }
                    }
                },
            });
        };

        $scope.eliminaNews = function(news) {
            $ngConfirm({
                title: 'Elimina News',
                content: 'Sei sicuro di eliminare la news "' + news.title + '"?',
                scope: $scope,
                closeIcon: true,
                buttons: {
                    // long hand button definition
                    ok: {
                        text: "Elimina",
                        btnClass: 'btn-primary',
                        keys: ['enter'], // will trigger when enter is pressed
                        action: function(scope) {
                            NewsService.eliminaNews(news.id).$promise.then(function(r) {
                                Notification.success('News eliminata');
                                loadNews();
                            }, function(e) {
                                console.log(e);
                            });

                        }
                    },
                    cancel: {
                        text: "Annulla",
                        btnClass: 'btn-default',
                        action: function(scope) {
                            return true;
                        }
                    }
                },
            });
        }


    }

})();
'use strict';

angular.module('AmwayAdmin.pages.ordini-wes').factory('OrdiniWesService', function(DataConnectorService) {

	var response = {};

	response.confirmOrder = function(wesOrder) {
		return DataConnectorService
			.getResource('ntsorder/confirm/wes')
			.post(wesOrder);
	};

	return response;

});
(function() {

	'use strict';

	angular
	  .module('AmwayAdmin.pages.ordini-wes')
      .controller('OrdiniWesCtrl', OrdiniWesCtrl);

	/** @ngInject */
	function OrdiniWesCtrl($rootScope, $scope, MagazzinoService, $state, CardService, OrdiniWesService, ContabilitaService, $log, Notification, DataConnectorService, $ngConfirm) {

		$scope.previewBaseUrl = DataConnectorService.getPreviewBaseUrl();
		$scope.sku = {};
		$scope.inputLoad = false;
		$scope.customers = [];
		$scope.creditCards = [];
		$scope.showMessageCC = false;
		$scope.dati = {};
		$scope.cliente = {};
		$scope.order = [];
		$scope.postOrder = {};
		$scope.totalWesOrder = 0;
		$scope.loading = false;

		function getCreditCards() {
			if ($scope.cliente.id) {
				CardService.getCards($scope.cliente.id).$promise.then(function(r) {
					$scope.creditCards = r;
					$scope.showMessageCC = true;
					console.log(r);
				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
		}

		function updateTotal() {
			$scope.totalWesOrder = 0;
			if ($scope.order.length > 0) {
				angular.forEach($scope.order, function(value, key) {
					$scope.totalWesOrder += value.wesprice*value.qty;
				});	
			} else {
				$scope.totalWesOrder = 0;
			}
			console.log('Aggiorno totale');
		}

		$scope.searchCustomers = function(searchterm) {
			ContabilitaService.searchCustomers(searchterm).$promise.then(function(response) {
				$scope.customers = response;
			});
		};
		
		$scope.emptySearch = function() {
			console.log('empty search');
			$scope.dati.selectedCustomer = {};
			$scope.order = [];
			$scope.postOrder = {};
			$scope.creditCards = [];
			$scope.sku = {};
			$scope.showMessageCC = false;
			$scope.customers = [];
			$scope.confirmedOrder = undefined;
			$scope.loading = false;
			$scope.totalWesOrder = 0;
		};

		$scope.cerca = function (){
			// seleziona il cliente
			if ($scope.dati.selectedCustomer != undefined) $scope.cliente = $scope.dati.selectedCustomer;
			console.log('Cliente', $scope.cliente);
			getCreditCards();
		};

		$scope.addProductToOrder = function() {
			$scope.inputLoad = false;
			if ($scope.sku.entity != '') {
				// controlla se già in array e aggiunge a qtà
				var pos = $scope.order.map(function(o) { return o.sku; }).indexOf($scope.sku.entity);
				if (pos >= 0) {
					// trovato
					$scope.order[pos].qty++;
					updateTotal();
					$scope.sku = {};
					$scope.inputLoad = true;
				} else {
					MagazzinoService.getProduct($scope.sku.entity).$promise.then(function(response) {
						console.log('Product', response);
						
						if (response.wesprice != undefined && response.wesprice != null && response.wesprice != 0 && response.wesstock > 0) {
							response.qty = 1;
							$scope.order.push(response);
						} else {
							Notification.error("Prodotto non vendibile al WES");
						}

						updateTotal();

						$scope.sku = {};
						$scope.inputLoad = true;

					}, function(error) {
						console.log(error.data.code, error.data.msg);
						Notification.error(error.data.msg);
						$scope.sku = {};
						$scope.inputLoad = true;
					});
				}
			}
		};

		$scope.removeFromOrder = function(product) {
			$scope.order = $scope.order.filter(function(item) {
				return item.sku != product.sku;
			});
			console.log('Ordine', $scope.order);
			updateTotal();
		};

		$scope.checkQty = function(product) {
			if (product.qty == 0) $scope.removeFromOrder(product);
		};

		$scope.updateTotal = function() {
			updateTotal();
		}

		$scope.$watch("dati.selectedCustomer", function(newValue, oldValue) {
		    if (newValue != oldValue)
		        $scope.cliente = {};
		    	$scope.creditCards = [];
		    	$scope.showMessageCC = false;
		    	$scope.order = [];
		    	$scope.postOrder = {};
		});

		$scope.confirmOrder = function() {
			$scope.loading = true;
			$scope.postOrder.uid = $scope.cliente.id;
			$scope.postOrder.products = $scope.order;

			OrdiniWesService.confirmOrder($scope.postOrder).$promise.then(function(response) {
				console.log('Ordine inserito', response);
				$scope.confirmedOrder = response;
				$scope.loading = false;
			}, function(error) {
				console.log(error.data.code, error.data.msg);
				Notification.error(error.data.msg);
				$scope.sku = {};
				$scope.inputLoad = true;
				$scope.loading = false;
			});
		};


	}
}());




angular.module('AmwayAdmin.pages.opens').factory('OpensService', function(DataConnectorService) {

	var response = {};

	response.getAll = function() {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('open', {}, config).get();

	}


	response.getOpen = function(id) {

		return DataConnectorService.getResource('open/:id', {
			id: id
		}).get();

	}


	response.creaOpen = function(product) {
		return DataConnectorService.getResource('open').post(product);

	}


	response.aggiornaOpen = function(product) {
		return DataConnectorService.getResource('open/:id', {
			id: product.id
		}, {}).put(product);

	}

	// response.getSpeakerOpen = function(open) {
	// 	return DataConnectorService
	// 			.getResource('eventspeaker/filter/eid/:eid/range/0/1000', { eid: open.id }, { isArray: true })
	// 			.get();
	// }

	// response.addSpeakerOpen = function(open, speaker) {
	// 	return DataConnectorService
	// 		.getResource('eventspeaker')
	// 		.post({ eid: open.id, sid: speaker.id });
	// }

	// response.deleteSpeakerOpen = function(es) {
	// 	return DataConnectorService
	// 		.getResource('eventspeaker/:id', { id: es.id })
	// 		.delete();
	// }


	return response;

});

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('AmwayAdmin.pages.opens')
		.controller('OpenCtrl', OpenCtrl);

	/** @ngInject */
	function OpenCtrl($scope, $state, $stateParams, md5, OpensService, VenueService, ConstantsService, DataConnectorService, Notification, UploadService) {

		$scope.baseurl = DataConnectorService.getPreviewBaseUrl();
		$scope.venues = [];
		$scope.selectedVenue = {};
		$scope.parent = { openDate: '' };
		var today = new Date();
		$scope.parent.openDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 21, 30, 0);

		$scope.opentypes = [
			{ label: 'Dal vivo', value: 'live' },
			{ label: 'Online', value: 'online' }];
		function loadOpen() {

			if ($stateParams.id) {
				OpensService.getOpen($stateParams.id).$promise.then(function (r) {
					$scope.open = r;
					// console.log(r);

					if ($scope.open.opendate) {
						$scope.parent.openDate = new Date($scope.open.opendate * 1000);
					}

					if ($stateParams.duplicate) {
						delete $scope.open.id;
					}

				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
			else {
				$scope.open = {};
			}
		}

		loadOpen();
		getVenues();

		function getVenues() {
			VenueService.getAll().$promise.then(function (r) {
				$scope.venues = r;
				// console.log(r);

			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}



		$scope.searchVenues = function (str) {


			var search = {
				search: str
			}
			VenueService.search(search).$promise.then(function (r) {
				$scope.venues = r;
				console.log(r);

			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});



		}

		$scope.salva = function () {

			if ($scope.parent.openDate) {
				var inizio = moment($scope.parent.openDate);
				$scope.open.opendate = parseInt(inizio.toDate().getTime() / 1000);
			}

			if ($scope.selectedVenue.r) {
				$scope.open.vid = $scope.selectedVenue.r.originalObject.id;
				$scope.open.venue = $scope.selectedVenue.r.originalObject;
			}

			if ($scope.open.id) {
				if ($scope.open.opentype !== 'live') {
					$scope.open.vid = undefined;
					$scope.open.venue = undefined;
				}
				OpensService.aggiornaOpen($scope.open).$promise.then(function (r) {
					loadOpen();
					Notification.success('Salvato');
				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
			else {
				OpensService.creaOpen($scope.open).$promise.then(function (r) {
					Notification.success('Open salvato');
					$state.go('web.opens', { id: r.id });
				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
		}


		$scope.immagine = {};
		$scope.progressPercentage = 0;
		$scope.uploadImmagine = function () {
			if ($scope.immagine && $scope.immagine.file && $scope.open && $scope.open.id) {
				UploadService.uploadOpen($scope.immagine.file).then(function (resp) {

					Notification.success('Volantino caricato');
					console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					$scope.open.flyer = resp.data.path;
					$scope.salva.apply();
				}, function (resp) {
					Notification.success('Si è verificato un errore');
					console.log('Error status: ' + resp.status);
				}, function (evt) {
					$scope.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					// console.log('progress: ' + $scope.progressPercentage + '% ' + evt.config.data.file.name);
				}).catch(function (e) {
					console.log(e);
				});
			}
			else {
				$scope.salva.apply();
			}
		};
	}

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
	'use strict';

	angular.module('AmwayAdmin.pages.opens')
		.controller('OpensListCtrl', OpensListCtrl);

	/** @ngInject */
	function OpensListCtrl($scope, $ngConfirm, OpensService, ProductService, DataConnectorService, Notification) {

		$scope.baseurl = DataConnectorService.getPreviewBaseUrl();

		function loadOpens() {

			ProductService.getOpens().$promise.then(function(r) {
				$scope.opens = r;
				console.log(r);

			}, function(e) {
				console.log(e);
			});
		}

		$scope.itemsPerPage = 10;


		loadOpens();

		$scope.opensTablePageSize = 10;

		$scope.eliminaOpen = function(ev) {
			$ngConfirm({
				title: 'Elimina Open',
				content: 'Sei sicuro di eliminare l\'open ' + ev.name + '?',
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Elimina",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function(scope) {
							//console.log(ProductService);
							ProductService.eliminaOpen(ev.id).$promise.then(function(r) {
								Notification.success('Elemento eliminato');
								loadOpens();
							}, function(e) {
								console.log(e);
							});

						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function(scope) {
							return true;
						}
					}
				},
			});
		}
	}

})();
(function () {

	'use strict';

	angular
		.module('AmwayAdmin.pages.ordini')
		.controller('OrdineCtrl', OrdineCtrl);

	/** @ngInject */
	function OrdineCtrl($scope, $stateParams, $state, $ngConfirm, DataConnectorService, CartService, ContabilitaService, Notification, $location, $fancyModal) {

		$scope.isPartialRefund = false;
		$scope.isOrdineUtente = $state.current.name === 'ordineutente' ? true : false;

		$scope.viewGuests = function (guestsJSON) {
			$scope.guests = JSON.parse(guestsJSON);
			$fancyModal.open({
				templateUrl: 'app/pages/ordini/guestsTemplate.html',
				controller: 'OrdineCtrl',
				scope: $scope

			});

			console.log("modale");
		}

		function loadOrder() {
			DataConnectorService.getResource('ntsorder/:id', { id: $stateParams.id }).get().$promise.then(function (order) {
				$scope.order = order;

				console.log("ordine", order);
				angular.forEach($scope.order.items, function (item) {
					//item.guestsList = JSON.parse(item.guests);
				});
				$scope.order.partialrefund = $scope.order.total + $scope.order.shipment;
			});
		}

		$scope.status = {};
		$scope.status.isFirstOpen = true;
		loadOrder();
		$scope.refund = function (param) {
			var api;

			switch (param) {
				case 'magazzino':
					api = 'ntsorder/action/inventoryreset';
					break;
				case 'stripe':
					api = 'ntsorder/action/striperefund';
					break;
				default:
					api = undefined;
					break;
			}

			var order = $scope.order;

			$ngConfirm({
				title: 'Sei sicuro di rimborsare l\'ordine? ',
				content: "Questo provocherà l'emissione di una nota di credito, il refund totale su stripe, il ricalcolo dei segni vitali e l'eliminazione dei contenuti digitali dall'app utente. Questa azione non è reversibile.",
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Rimborsa",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {
							ContabilitaService.refundOrder(api, order).$promise.then(function () {
								Notification.success('Rimborso effettuato correttamente.');
								loadOrder();
							}, function (e) {
								console.log(e);
								Notification.error((e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore'));
							});
						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			})


		}

		$scope.partialRefund = function () {
			$scope.isPartialRefund = !$scope.isPartialRefund;
			var itemsToRefund = {
				data: []
			};
			if (!$scope.isPartialRefund) {
				angular.forEach($scope.order.items, function (item) {
					if (item.checked) itemsToRefund.data.push(item);
				})

				DataConnectorService.getResource('ntsorder/partialrefund', {}).post(itemsToRefund).$promise.then(function (response) {
					Notification.success('Rimborso effettuato correttamente.');
				});
			}
		}

		$scope.checkUncheck = function (item) {
			item.checked = !item.checked;
		}


		$scope.notaCredito = function () {
			var api;
			var order = $scope.order;

			$ngConfirm({
				title: 'Sei sicuro di creare una nota di credito per l\'ordine? ',
				content: "Procedi per navigare verso l'interfaccia di creazione della nota di credito",
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Crea Nota di Credito",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {
							$state.go('contabilita.nota-credito', { orderid: order.id })
						},
						cancel: {
							text: "Annulla",
							btnClass: 'btn-default',
							action: function (scope) {
								return true;
							}
						}
					},
				}
			})


		}


	}


}());
(function() {

  'use strict';

  angular
    .module('AmwayAdmin.pages.ordini')
    .controller('OrdiniCtrl', OrdiniCtrl);

  /** @ngInject */
  function OrdiniCtrl($scope, $state, DataConnectorService, CartService, Notification) {

  	$scope.momodate = {};
  	$scope.momodate.date = (new Date().getTime()/1000).toFixed(0);

  	var date = parseInt((new Date).getTime()/1000);
  	var countItems;
  	var postObj = {};

  	$scope.isShipment = $state.current.name == 'shop.spedizioni' ? true : false;

  	$scope.ordiniTablePageSize = 25;

  	$scope.fairicerca = false;

  	if (!$scope.isShipment) {
  		$scope.filter = {
  		  dateStart: date - 7776000,
  		  dateEnd: date,
  		  totalMin: null,
  		  totalMax: null,
  		  userName: null,
  		  status: null
  		};
  	} else {
  		$scope.filter = {
  		  dateStart: date - 7776000,
  		  dateEnd: date,
  		  term: null
  		};
  	}

    
    $scope.orders = [];

    $scope.loading = false;

    $scope.applySearch = function(start, stop) {

    if ($scope.filter.dateStart) {
    	$scope.filter.dateStart = new Date($scope.filter.dateStart * 1000);
	    $scope.filter.dateStart = $scope.filter.dateStart.setHours(0, 0, 0);
	    $scope.filter.dateStart = String($scope.filter.dateStart/1000);
    }

      $scope.loading = true;
      postObj = {
        start: $scope.filter.dateStart ? $scope.filter.dateStart : 1483225200,
        stop: $scope.filter.dateEnd ? $scope.filter.dateEnd : date,
        status: $scope.filter.status ? $scope.filter.status : null,
        uname: $scope.filter.userName ? $scope.filter.userName : undefined,
        pricefrom: $scope.filter.totalMin ? $scope.filter.totalMin * 100 : undefined,
        priceto: $scope.filter.totalMax ? $scope.filter.totalMax * 100 : undefined
      };

      return DataConnectorService
        .getResource('ntsorder/admin/search/:start/:stop', { start: start, stop: stop }, { isArray: true }).post(postObj).$promise.then(function(orders) {
          console.log("Orders", orders);
          $scope.orders = orders;
          return orders;
        }, function(e) {
        	$scope.loading = false;
        	Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
        })

    };

    $scope.applySearchSped = function(start, stop) {
      $scope.loading = true;
      postObj = {
        start: $scope.filter.dateStart ? String($scope.filter.dateStart) : String(1483228800),
        stop: $scope.filter.dateEnd ? String($scope.filter.dateEnd) : String(date),
        term: $scope.filter.term ? String($scope.filter.term) : undefined
      };

      console.log("postObj", postObj);
      return DataConnectorService
        .getResource('ntsorder/admin/shipment/:start/:stop', { start: start, stop: stop }, { isArray: true }).post(postObj).$promise.then(function(shipments) {
         console.log("Shipments", shipments);
         $scope.orders = shipments;
          return shipments;
        }, function(e) {
        	console.log("errore return shipments", e);
        	$scope.loading = false;
        	Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
        })

    };

    	function getCount(param, searchobj) {
			return DataConnectorService
				.getResource('ntsorder/admin/:param/count', {param: param}, {isArray: false}).post(searchobj).$promise.then(function(response) {
					$scope.loading = false;
					console.log("COUNT", response);
					return response;
				}, function(e) {
					console.log("error count", e);
					$scope.loading = false;
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
    	}

		$scope.loadMovimenti = function(tableState) {
			console.log('tableState', tableState);
			$scope.tableState = tableState;
			if ($scope.fairicerca) {
				$scope.loading = true;
				var pagination = tableState.pagination;
				var start = pagination.start || 0; // This is NOT the page number, but the index of item in the list that you want to use to display the table.
				var number = pagination.number || 10; // Number of entries showed per page.
				var stop = start + number;

				if (!$scope.isShipment) {
					$scope.applySearch(start, stop).then(function(r) {
						getCount('search', postObj).then(function(r) {
							tableState.pagination.numberOfPages = parseInt(Math.ceil(r.ct / number));
						});
						 //set the number of pages so the pagination can update
					});
				} else {
					$scope.applySearchSped(start, stop).then(function(r) {
						getCount('shipment', postObj).then(function(r) {
							tableState.pagination.numberOfPages = parseInt(Math.ceil(r.ct / number));
						});
					});
				}
				
			}
		};

		$scope.cerca = function() {
			console.log($scope.momodate);
			$scope.fairicerca = true;
			$scope.loadMovimenti($scope.tableState);
		};
		// 	if ($scope.fairicerca && $scope.tableState) {

		// 		$scope.tableState.start = 0;
		// 		$scope.loadMovimenti($scope.tableState);
		// };


	      /** 
       * TODO non sono sicurissimo sulla compatibilità di 
       * Object.keys e [].reduce, ma di sicuro su Chrome va 
       */
      // DataConnectorService
      //   .getResource(
      //     'ntsorder/admin/search',
      //     {},
      //     { isArray: true }
      //   )
      //   .post(Object.keys(postObj).reduce(function(o, i) {
      //     if(!!postObj[i])
      //       o[i] = postObj[i];

      //     return o;
      //   }, {}))
      //   .$promise.then(function(orders) {
      //     console.log(orders);
      //     $scope.orders = orders;
      //     $scope.loading = false;
      //   })

    /** TODO refactor in amway-core? */
    // DataConnectorService
    //   .getResource('ntsorder', {}, { isArray: true })
    //   .get()
    //   .$promise.then(function(orders) {
    //     console.log(orders);
    //     $scope.orders = orders;
    //     $scope.loading = false;
    //   });

  }

}());
angular.module('AmwayAdmin.pages.moduli').factory('ModuleService', function(DataConnectorService) {

	var response = {};

	response.getAll = function() {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('attach/filter/entity/module/range/0/1000', {id: 'eid'}, config).get();
	}

	response.getModulo = function(id) {
		return DataConnectorService.getResource('attach/:id', {
			id: id
		}).get();
	}

	response.creaModulo = function(module) {
		return DataConnectorService.getResource('attach').post(module);
	}

	response.eliminaModulo = function(id) {
		return DataConnectorService.getResource('attach/:id', { id: id }).delete();
	}

	return response;

});

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
		'use strict';

		angular.module('AmwayAdmin.pages.moduli')
			.controller('ModuliListCtrl', ModuliListCtrl);

		/** @ngInject */
		function ModuliListCtrl($scope, $ngConfirm, ModuleService, ProductService, DataConnectorService, Notification) {

    $scope.baseurl = DataConnectorService.getPreviewBaseUrl();
    $scope.loading = true;
			function loadModuli() {

				ModuleService.getAll().$promise.then(function(r) {
					$scope.moduli = r;
					console.log("Moduli", r);
                    $scope.loading = false;

				}, function(e) {
					console.log(e);
				});
			}

			loadModuli();
			
			$scope.moduliTablePageSize = 10;



				$scope.eliminaModulo = function(ev){
                    console.log(ev);
			$ngConfirm({
        title: 'Elimina Modulo',
        content: 'Sei sicuro di eliminare il modulo ' + ev.filename + '?',
        scope: $scope,
        closeIcon: true,
        buttons: {   
            // long hand button definition
            ok: { 
                text: "Elimina",
                btnClass: 'btn-primary',
                keys: ['enter'], // will trigger when enter is pressed
                action: function(scope){
                	//console.log(ProductService);
                     ModuleService.eliminaModulo(ev.id).$promise.then(function(r) {	
                            Notification.success('Modulo eliminato');
    						loadModuli();
    					}, function(e) {
    						console.log(e);
    					});

                }
            },
            cancel: { 
                text: "Annulla",
                btnClass: 'btn-default',
                action: function(scope){
                	return true;
                }
            }
        },
    });
		}


		}
	
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('AmwayAdmin.pages.moduli')
		.controller('ModuloCtrl', ModuloCtrl);

	/** @ngInject */
	function ModuloCtrl($scope, $state, $stateParams, md5, ModuleService, UploadService, DataConnectorService, Notification) {

		// $scope.baseurl = DataConnectorService.getPreviewBaseUrl();

		function loadModulo() {

			if ($stateParams.id) {
				ModuleService.getModulo($stateParams.id).$promise.then(function (r) {
					$scope.modulo = r;
					console.log(r);

					if ($scope.modulo.insdate) {
						$scope.modulo.insdate = new Date($scope.modulo.insdate * 1000);
					}

					if($stateParams.duplicate) {
						delete $scope.modulo.id;
					}

				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
			else {
				$scope.modulo = {};
			}
		}

		loadModulo();

		$scope.salva = function () {

			$scope.modulo.entity = 'module';
			$scope.modulo.eid = 0;

			var insDate = moment(new Date());
			$scope.modulo.insdate = parseInt(insDate.toDate().getTime() / 1000);

			ModuleService.creaModulo($scope.modulo).$promise.then(function (r) {
				console.log("r", r);
			    Notification.success('Modulo aggiunto e salvato');
          		// $state.go('modifica-modulo',{id:r.id});
          		$state.go('web.moduli');
				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
		};

		$scope.f = {};
		$scope.uploadFile = function (file, errFiles) {

			$scope.f = file;

			if (file) {
				UploadService.uploadModule(file).then(function (resp) {
					Notification.success('File caricato');
					console.log('Success ' + resp.config.data.file.name + ' uploaded. Response: ' + resp.data);
					console.log(resp.data);
					$scope.modulo.awsurl = resp.data.url;
					// $scope.prodotto.img=resp.data.path;
					// $scope.salva.apply();
				}, function (resp) {
					console.log('Error status: ' + resp.status);
				}, function (evt) {
					console.log(evt);
					$scope.f.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
				}).catch(function (e) {
					console.log(e);
				});
			}

		};
	}

})();

'use strict';

angular.module('AmwayAdmin.pages.ordini-wes-onsite').factory('OrdiniWesOnsiteService', function(DataConnectorService) {

	var response = {};




	response.getIntent = function(wesOrder) {
		return DataConnectorService
			.getResource('ntsorder/paymentwes/intent')
			.post(wesOrder);
	};

	response.confirmOrder = function(wesOrder) {
		return DataConnectorService
			.getResource('ntsorder/confirm/wes')
			.post(wesOrder);
	};

	return response;

});
(function() {

	'use strict';

	angular
	  .module('AmwayAdmin.pages.ordini-wes')
      .controller('OrdiniWesOnsiteCtrl', OrdiniWesOnsiteCtrl);

	/** @ngInject */
	function OrdiniWesOnsiteCtrl($rootScope, $scope, MagazzinoService, $state, CardService, OrdiniWesOnsiteService, ContabilitaService, $log, Notification, DataConnectorService, $ngConfirm, ENV) {

		var pkey = 'pk_test_PFKr8jE44pUJz3p9QPxnysQu';

		if(ENV.type=='prod'){
		  pkey= 'pk_live_5x5E9eNQjYglF1SVwvFU3Ah2';
		}
		// console.log('stripekey',pkey);
	
		   var  stripe    = Stripe(pkey);


		$scope.previewBaseUrl = DataConnectorService.getPreviewBaseUrl();
		$scope.sku = {};
		$scope.inputLoad = false;
		$scope.customers = [];
		$scope.creditCards = [];
		$scope.showMessageCC = false;
		$scope.dati = {};
		$scope.cliente = {};
		$scope.order = [];
		$scope.postOrder = {};
		$scope.totalWesOrder = 0;
		$scope.loading = false;

		function getCreditCards() {
			if ($scope.cliente.id) {
				CardService.getCards($scope.cliente.id).$promise.then(function(r) {
					$scope.creditCards = r;
					$scope.showMessageCC = true;
					console.log(r);
				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
		}

		function updateTotal() {
			$scope.totalWesOrder = 0;
			if ($scope.order.length > 0) {
				angular.forEach($scope.order, function(value, key) {
					$scope.totalWesOrder += value.wesprice*value.qty;
				});	
			} else {
				$scope.totalWesOrder = 0;
			}
			console.log('Aggiorno totale');
		}

		$scope.searchCustomers = function(searchterm) {
			ContabilitaService.searchCustomers(searchterm).$promise.then(function(response) {
				$scope.customers = response;
			});
		};
		
		$scope.emptySearch = function() {
			console.log('empty search');
			$scope.dati.selectedCustomer = {};
			$scope.order = [];
			$scope.postOrder = {};
			$scope.creditCards = [];
			$scope.sku = {};
			$scope.showMessageCC = false;
			$scope.customers = [];
			$scope.confirmedOrder = undefined;
			$scope.loading = false;
			$scope.totalWesOrder = 0;
		};

		$scope.cerca = function (){
			// seleziona il cliente
			if ($scope.dati.selectedCustomer != undefined) $scope.cliente = $scope.dati.selectedCustomer;
			console.log('Cliente', $scope.cliente);
			getCreditCards();
		};

		$scope.addProductToOrder = function() {
			$scope.inputLoad = false;
			if ($scope.sku.entity != '') {
				// controlla se già in array e aggiunge a qtà
				var pos = $scope.order.map(function(o) { return o.sku; }).indexOf($scope.sku.entity);
				if (pos >= 0) {
					// trovato
					$scope.order[pos].qty++;
					updateTotal();
					$scope.sku = {};
					$scope.inputLoad = true;
				} else {
					MagazzinoService.getProduct($scope.sku.entity).$promise.then(function(response) {
						console.log('Product', response);
						
						if (response.wesprice != undefined && response.wesprice != null && response.wesprice != 0 && response.wesstock > 0) {
							response.qty = 1;
							$scope.order.push(response);
						} else {
							Notification.error("Prodotto non vendibile al WES");
						}

						updateTotal();

						$scope.sku = {};
						$scope.inputLoad = true;

					}, function(error) {
						console.log(error.data.code, error.data.msg);
						Notification.error(error.data.msg);
						$scope.sku = {};
						$scope.inputLoad = true;
					});
				}
			}
		};

		$scope.removeFromOrder = function(product) {
			$scope.order = $scope.order.filter(function(item) {
				return item.sku != product.sku;
			});
			console.log('Ordine', $scope.order);
			updateTotal();
		};

		$scope.checkQty = function(product) {
			if (product.qty == 0) $scope.removeFromOrder(product);
		};

		$scope.updateTotal = function() {
			updateTotal();
		}

		$scope.$watch("dati.selectedCustomer", function(newValue, oldValue) {
		    if (newValue != oldValue)
		        $scope.cliente = {};
		    	$scope.creditCards = [];
		    	$scope.showMessageCC = false;
		    	$scope.order = [];
		    	$scope.postOrder = {};
		});

		
			

		$scope.confirmOrder = function() {
			$scope.loading = true;
			$scope.postOrder.uid = $scope.cliente.id;
			$scope.postOrder.products = $scope.order;


			


			OrdiniWesOnsiteService.getIntent($scope.postOrder).$promise.then(function(order) {
				console.log('Intent', order);
				var orderid;
				if (order && order.clientsecret) {
					orderid = order.orderid;
					stripe.handleCardPayment(
					  order.clientsecret,
					  {
						payment_method: order.paymenthmethod
					  }
					).then(function (result){
					  if (result.error) {
						$scope.loading = false;
						  Notification.error(result.error);
						} else if (result.paymentIntent.status == 'succeeded') {
							
							$scope.confirmedOrderid = orderid
							$scope.loading = false;
							$scope.$apply();
					  }
					})
				  }
				
			}, function(error) {
				console.log(error.data.code, error.data.msg);
				Notification.error(error.data.msg);
				$scope.sku = {};
				$scope.inputLoad = true;
				$scope.loading = false;
			});
		};


	}
}());




angular.module('AmwayAdmin.pages.speaker').factory('SpeakerService', function (DataConnectorService) {

	return {
    getSpeakers: function() {
      return DataConnectorService
        .getResource('speaker', {}, { isArray: true })
        .get();
    },
    getSpeaker: function(id) {
      return DataConnectorService
        .getResource('speaker/:id', { id: id })
        .get();
    },
    updateSpeaker: function(sp) {
      return DataConnectorService
        .getResource('speaker/:id', { id: sp.id })
        .put(sp);
    },
    createSpeaker: function(sp) {
      return DataConnectorService
        .getResource('speaker')
        .post(sp);
    },
    deleteSpeaker: function(sp) {
      return DataConnectorService
        .getResource('speaker/:id', { id: sp.id })
        .delete();
    },
  };

});
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.autori')
    .controller('SpeakerCtrl', SpeakerCtrl);

  /** @ngInject */
  function SpeakerCtrl($scope, $state, $location, SpeakerService, UploadService, Notification, DataConnectorService) {


$scope.baseurl= DataConnectorService.getPreviewBaseUrl();


    if(!!$state.params.id)
      SpeakerService
        .getSpeaker($state.params.id)
        .$promise
        .then(function (r) {
          console.log(r);
          $scope.speaker = r;

        }, function (e) {
          console.log(e);
          Notification.error('Si è verificato un errore');
          //TODO gestire errore
        });
    else
      $scope.speaker = {};

    $scope.salva = function () {
      if(!!$state.params.id)
        SpeakerService
          .updateSpeaker($scope.speaker)
          .$promise
          .then(function (r) {
            console.log(r);
            Notification.success('Salvato');
            $scope.speaker = r;

          }, function (e) {
            console.log(e);
            Notification.error('Si è verificato un errore');
            //TODO gestire errore
          });
      else
        SpeakerService
          .createSpeaker($scope.speaker)
          .$promise
          .then(function (r) {
            console.log(r);
            Notification.success('Salvato');
            $scope.speaker = r;
            $location.path('/modifica-speaker/' + r.id);

          }, function (e) {
            console.log(e);
            Notification.error('Si è verificato un errore');
            //TODO gestire errore
          });
    }

    $scope.elimina = function() {
      SpeakerService
        .deleteSpeaker($scope.speaker)
        .$promise
        .then(function(r) {
          Notification.success('Speaker eliminato')
          $state.go('speakers');
        });
    }

    $scope.immagine = { };
    $scope.uploadImmagine = function () {

      console.log($scope.immagine.file);

      if ($scope.immagine && $scope.immagine.file && $scope.speaker && $scope.speaker.id) {
        UploadService.uploadImage($scope.immagine.file).then(function (resp) {

          Notification.success('Immagine caricata');
          console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
          $scope.speaker.profilepic = resp.data.path;
          $scope.salva.apply();
        }, function (resp) {

          Notification.success('Si è verificato un errore');
          console.log('Error status: ' + resp.status);
        }, function (evt) {
          
          var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
          console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
        }).catch(function (e) {
          
          Notification.error('Si è verificato un errore');
          console.log(e);
        });
      }
      else {
        $scope.salva.apply();
      }

    };

  }


})();
(function() {
  'use strict';

  angular.module('AmwayAdmin.pages.autori')
    .controller('SpeakersCtrl', SpeakersCtrl);

  /** @ngInject */
  function SpeakersCtrl($scope, SpeakerService, Notification) {

    $scope.loading = true;
    SpeakerService
      .getSpeakers()
      .$promise
      .then(function(r) {
        console.log(r);
        $scope.speakers = r;
        $scope.loading = false;

      }, function(e) {
        console.log(e);
        Notification.error('Si è verificato un errore');
        //TODO gestire errore
      });

    $scope.speakersTablePageSize = 15;

  }


})();
angular.module('AmwayAdmin.pages.venue').factory('VenueService', function (DataConnectorService) {

	return {
    getAll: function() {
      return DataConnectorService
        .getResource('venue', {}, { isArray: true })
        .get();
    },
    getItem: function(id) {
      return DataConnectorService
        .getResource('venue/:id', { id: id })
        .get();
    },
    updateItem: function(item) {
      return DataConnectorService
        .getResource('venue/:id', { id: item.id })
        .put(item);
    },
    createItem: function(item) {
      return DataConnectorService
        .getResource('venue')
        .post(item);
    },
    deleteItem: function(id) {
      return DataConnectorService
        .getResource('venue/:id', { id: id })
        .delete();
    }, 
    search: function(search) {
      return DataConnectorService
        .getResource('venue/search',{}, { isArray: true })
        .post(search);
    },
     getHeatmapData: function (id, start, stop) {
            return DataConnectorService.getResource('heatmap/venue/:id/:start/:stop', { id: id, start: start, stop: stop }, { isArray: true }).get();
    }
  };

	/*response.getAll = function () {
		var config = { isArray: true };
		return DataConnectorService.getResource('user', {}, config).get();

	}


	response.getUtente = function (id) {

		return DataConnectorService.getResource('user/:id', { id: id }).get();

	}

	response.getFigliUtente = function (id) {
		var config = { isArray: true };
		return DataConnectorService.getResource('user/subtree/:id', { id: id }, config).get();

	}

	response.getAlberoUtente = function (id) {
		return DataConnectorService.getResource('user/compact/fulltree/:id', { id: id }).get();

	}


	response.creaUtente = function (user) {
		return DataConnectorService.getResource('user').post(user);

	}


	response.aggiornaUtente = function (user) {
		return DataConnectorService.getResource('user/:id', { id: user.id }, {}).put(user);

	}

	response.getIncaricati = function () {
		var config = { isArray: true };
		return DataConnectorService.getResource('user/filter/ntsrole/incaricato/range/0/10000', {}, config).get();

	}

	return response;*/

});
(function() {

	'use strict';

	angular
		.module('AmwayAdmin.pages.prodotti')
		.controller('PrintMagazzinoCtrl', PrintMagazzinoCtrl);

	/** @ngInject */
	function PrintMagazzinoCtrl($scope, ProductService, $window) {

		$scope.loading = true;

        function init() {
        	ProductService.getAll().$promise.then(function (r) {
        	    $scope.printProducts = r.filter(function(item) {
        	    	if (item.type == 'cd' || item.type == 'book' || item.type == 'dvd' || item.type == 'mpack' || item.type == 'item') {
        	    		return item;
        	    	}
        	    });
        	    $scope.loading = false;
        	}, function (e) {
        	    console.log(e);
        	});
        }

        init();

        $scope.print = function() {
        	$window.print();
        };

	}
}());
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('AmwayAdmin.pages.prodotti')
        .controller('ProdottiListCtrl', ProdottiListCtrl);



    /** @ngInject */
    function ProdottiListCtrl($scope, $ngConfirm, ProductService, DataConnectorService, Notification) {
        $scope.baseurl = DataConnectorService.getPreviewBaseUrl();


        $scope.searchObj = {
          table : "product",
          sortfield : "id",
          direction : "desc",
          simple: [],
          like : []
        }

        $scope.filter = {};

        var start = 0;
        var stop = 15;
        $scope.itemsPerPage = 15;
     //   getCount();
      //  getRange(start,stop);

        $scope.loading = true;


        function loadProdotti() {
            ProductService.getAll().$promise.then(function (r) {
                $scope.prodotti = r;
                $scope.loading = false;
            }, function (e) {
                console.log(e);
            });
        }

		function statusSimple() {
			var index = $scope.searchObj.simple.map(function(s) {
				return s.field;
			}).indexOf('status');

			if (index > -1) {
				// esiste già il filtro, va aggiornato
				if ($scope.filter.status && $scope.filter.status != 'all') {
					$scope.searchObj.simple[index].filter = $scope.filter.status;
				} else if ($scope.filter.status && $scope.filter.status == 'all') {
					$scope.searchObj.simple.splice(index, 1);
				}
			} else {
				// il filtro status non esiste, va aggiunto solo se != 'all'
				if ($scope.filter.status && $scope.filter.status != 'all')
					$scope.searchObj.simple.push({
						field: "status",
						filter: $scope.filter.status
					});
			}
		}

        function getRange(start,stop, sort){

            if(sort){
                $scope.searchObj.sortfield = sort.sortfield;
                $scope.searchObj.direction = sort.direction;
                }

             statusSimple();


           $scope.loadingpage = true;
            ProductService.advancedSearch($scope.searchObj,start,stop).$promise.then(function(r) {
              console.log("advanced", r);
              $scope.products = r;
               $scope.loadingpage = false;

            }, function(e) {
              console.log(e);
              //TODO gestire errore
            });
        }

        function getCount (){
          return ProductService.getCount($scope.searchObj,start,stop).$promise.then(function(r) {
              $scope.totalItems = r.ct;
              console.log($scope.totalItems);
            }, function(e) {
              console.log(e);
              //TODO gestire errore
            });
        }

        $scope.getData = function(tableState){
		    $scope.tableState=tableState;


		    var pagination = tableState.pagination;

		    var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
		    var number = pagination.number || 10;  // Number of entries showed per page.
		    var stop = start+number;
		    var sort = {sortfield: tableState.sort.predicate, direction:tableState.sort.reverse ? 'desc' : 'asc' };
		   
		   
		  	/*getCount().then(function(){
		    tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalItems/number));//set the number of pages so the pagination can update
		   	}) */
		   	getRange(start, stop, sort);

			ProductService.getCount($scope.searchObj,start,stop).$promise.then(function(r) {
		          $scope.totalItems = r.ct;
      		      tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalItems/number));//set the number of pages so the pagination can update

		          console.log("ciao",$scope.totalItems);
			});

          
        }

        function fixSearch (){
          if($scope.filter.name)
            $scope.searchObj.like.push({field : "name", term : $scope.filter.name});
          if($scope.filter.type)
            $scope.searchObj.like.push({field : "type", term : $scope.filter.type});
          if($scope.filter.sku)
            $scope.searchObj.like.push({field : "sku", term : $scope.filter.sku});
          if($scope.filter.author)
            $scope.searchObj.like.push({field : "author", term : $scope.filter.author});

	        statusSimple();
	    }

         $scope.applySearch = function (){

          $scope.searchObj.like = [];

          fixSearch();
          

          if($scope.tableState){
            $scope.tableState.pagination.start  =0;
            $scope.getData($scope.tableState);
          }

          if($scope.tableState){
            $scope.tableState.pagination.start  =0;
            $scope.getData($scope.tableState);
          }
          //getRange(0,15);
         }

        loadProdotti();
        $scope.prodottiTablePageSize = 10;

        $scope.eliminaProdotto = function (pr) {
            $ngConfirm({
                title: 'Elimina Prodotto',
                content: 'Sei sicuro di eliminare il prodotto ' + pr.name + '?',
                scope: $scope,
                closeIcon: true,
                buttons: {
                    // long hand button definition
                    ok: {
                        text: "Elimina",
                        btnClass: 'btn-primary',
                        keys: ['enter'], // will trigger when enter is pressed
                        action: function (scope) {
                            console.log('elimina');
                            ProductService.eliminaProdotto(pr.id).$promise.then(function (r) {
                                Notification.success('Elemento eliminato'); 
                                getRange(0,15);
                            }, function (e) {
                                console.log(e);
                            });

                        }
                    },
                    cancel: {
                        text: "Annulla",
                        btnClass: 'btn-default',
                        action: function (scope) {
                            return true;
                        }
                    }
                },
            });
        }


    }

})();

(function () {
	'use strict';

	angular.module('AmwayAdmin.pages.prodotti')
		.controller('ProdottoCtrl', ProdottoCtrl);

	/** @ngInject */
    function ProdottoCtrl($scope, $state, $stateParams, $q, $timeout, DataConnectorService, UploadService, ProductService, AutoriService, ConstantsService, UtentiService, Notification, ContabilitaService, ConfigService, $ngConfirm, $document) {

		$scope.loadRefill = false;
		$scope.loadUnshare = false;
		$scope.prodottiOmaggio = [];
        $scope.selectedRelated = {};
		var map, heatmap;
		$scope.retroshare = {
			checked : 1
		};

        /*var defaultDate = new Date();
        var datefrom = new Date();
        datefrom.setMonth(defaultDate.getMonth());
        datefrom.setDate(1);
        var dateto = new Date();
        dateto.setMonth(defaultDate.getMonth() + 1);
        dateto.setDate(0);
        $scope.heatmapRange = {
            start: Math.floor(datefrom.getTime() / 1000),
            stop: Math.ceil(dateto.getTime() / 1000),
        }*/

		ConfigService.getConf().$promise.then(function(response) {
			for (var i = 0; i < response.length; i++) {
				if (response[i].ckey == 'alert.stock') {
					$scope.minStock = parseInt(response[i].cval);
					$scope.loadRefill = true;
					break;
				}
			}
		}, function(error) {
			console.log("Impossibile recuperare configurazioni", error);
		});
		

		$scope.baseurl = DataConnectorService.getPreviewBaseUrl();

		$scope.vats=[{value: 22, label: '22'},
		{value: 10, label: '10'},
		{value: 4, label: '4'},
		{value: 0, label: 'ESENTE'}];

		$scope.dati={promo: 0};


		function loadProdotto() {
			if ($stateParams.id) {
				ProductService.getProdotto($stateParams.id).$promise.then(function (r) {

					$scope.prodotto = r;

					$scope.hasUploadFileTabs = r.id === 146 || r.id === 147;

					if ($scope.prodotto.sellfromdate) {
						$scope.prodotto.sellfromdateS = new Date($scope.prodotto.sellfromdate * 1000);
					}
					if ($scope.prodotto.selltodate) {
						$scope.prodotto.selltodateS = new Date($scope.prodotto.selltodate * 1000);
					}
					if ($scope.prodotto.promofromdate) {
						$scope.prodotto.promofromdateS = new Date($scope.prodotto.promofromdate * 1000);
					}
					if ($scope.prodotto.promotodate) {
						$scope.prodotto.promotodateS = new Date($scope.prodotto.promotodate * 1000);
					}
					if ($scope.prodotto.secpromo) $scope.prodotto.promo2 = 1;
					if ($scope.prodotto.secpromotodate) {
						$scope.prodotto.secpromotodate = new Date($scope.prodotto.secpromotodate * 1000);
					}
					if ($scope.prodotto.giftfrom) {
						$scope.prodotto.giftfromS = new Date($scope.prodotto.giftfrom * 1000);
					}
					if ($scope.prodotto.giftto) {
						$scope.prodotto.gifttoS = new Date($scope.prodotto.giftto * 1000);
					}

					if ($scope.prodotto.eid) {
						ProductService.getEvento($scope.prodotto.eid).$promise.then(function (r) {
							$scope.prodotto.selectedEvent = r;
						});
					}

					if ($scope.prodotto.giftid) {
						ProductService.getProdotto($scope.prodotto.giftid).$promise.then(function (r) {
							$scope.prodotto.selectedGiftProduct = r;
						});
					}

					if ($scope.prodotto.downline) {
						UtentiService.getUtente($scope.prodotto.downline).$promise.then(function (r) {
							$scope.prodotto.selectedDownline = r;
						});
					}

					if ($scope.prodotto.prerequisite) {
						ProductService.getProdotto($scope.prodotto.prerequisite).$promise.then(function (r) {
							$scope.prodotto.selectedPrerequisite = r;
						});
					}


                    $scope.heatmapRange = {
                        start: $scope.prodotto.sellfromdate,
                        stop: Math.ceil(new Date()/1000)
                    }

					getCategorieProdotto();
					getAllegatiProdotto();
					controllaCategorie();
					getMovimentiMagazzino();
					loadAuthorProduct($scope.prodotto);
                    loadRelatedProducts();
                    loadProductHeatmap();

					if($scope.prodotto.type=='mpack' || $scope.prodotto.type=='xpack'){
						loadPackProducts();
						loadProducts();
						$scope.pack={};

					}
					if($stateParams.duplicate)
						delete $scope.prodotto.id;


						JsBarcode("#barcode", $scope.prodotto.sku);

					console.log('FABRIZIO', $scope.prodotto);
				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
			else {
				$scope.prodotto = { vat: 22, sellfromdateS: new Date() };
			}
		}

		loadProdotto();

		ProductService.getEventiFuturi().$promise.then(function (r) {
			$scope.eventi = r;

		}, function (e) {
			console.log(e);
			Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
		});

		ProductService.getAll().$promise.then(function (r) {
			// prodotti per omaggio tranne il prodotto corrente
			$scope.prodottiOmaggio = r.filter(function (product) {
				return (product.id != $stateParams.id) && (product.status == 'ok');
			});

		}, function (e) {
			console.log(e);
			Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
		});

		function getMovimentiMagazzino (){
			ProductService.getMovimentiMagazzino($scope.prodotto.id).$promise.then(function (r) {
				$scope.mmagazzino = r;
				// console.log(r);
	
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
        }

        $scope.refreshHeatmap = function () {
            loadProductHeatmap();
        }
        
        function loadProductHeatmap() {
             ProductService.getHeatmapData($scope.prodotto.id, $scope.heatmapRange.start, $scope.heatmapRange.stop ).$promise.then(function (result) {
                 var struct = getHeatmapStruct(result);
                 $scope.bounds = struct.bounds;

                 if(!map) {
                    drawMap(struct);
                 }
                 else {
                     setValues(struct.data);
                     $scope.fitBounds();
                 }

            }, function (e) {
                console.log(e);
                Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
            });
        }

        function getHeatmapStruct (data) {
            var struct = {
                data: []
            };

            if (data.length>0) {
                struct.bounds = new google.maps.LatLngBounds();
                angular.forEach(data, function (item) {
                    var loc = new google.maps.LatLng(item.lat, item.lng);
                    struct.data.push({ location: loc, weight: item.weight });
                    struct.bounds.extend(loc);
                });
            }
            else {
                var rome = { lat: 41.90, lng: 12.49 };
                struct.center = rome;
            }
            return struct;
        }

        function drawMap(struct) {

            
             map = new google.maps.Map($document[0].getElementById('map'), {
                mapTypeId: 'satellite',
            });

            if (struct.data.length <= 0) {
                map.setCenter(new google.maps.LatLng(struct.center.lat, struct.center.lng));
                map.setZoom(6);
            }
            else{
                setValues(struct.data);
                $scope.fitBounds();
            }
        }

        function setValues(data) {
            if (!!heatmap && !!heatmap.setMap)
                heatmap.setMap(null);
            heatmap = new google.maps.visualization.HeatmapLayer({
                data: data
            });
            heatmap.setMap(map);
            
            
        }

        $scope.fitBounds = function() {
            $timeout(function () {
                if ($scope.bounds)
                    map.fitBounds($scope.bounds);
                else {
                    var rome = { lat: 41.90, lng: 12.49 };
                    map.setCenter(new google.maps.LatLng(rome.lat, rome.lng));
                    map.setZoom(6);
                }
            }, 100);
        }

		function loadAuthorProduct(prodotto) {
			ProductService
				.getAuthorProduct(prodotto)
				.$promise
				.then(function(r) {
					$scope.authorproduct = r;
					console.log(r);

				}, function(err) {
					Notification.error("Si è verificato un errore");
					console.log(err);
				});


		}

		function loadAuthors() {
			AutoriService
				.getAutori()
				.$promise
				.then(function(r) {
					$scope.authors = r;
				});
		}

		loadAuthors();


		function loadRelatedProducts() {
			$scope.loadingrelated = true;
			var search = {
				table: 'prodrelated',
				sortfield: "id",
				direction: "asc",
				like: [],
				simple: [{ field: 'pid', filter: $scope.prodotto.id }],
				range: []
			};
			ProductService
				.getProductRelated(search, 0, 10000)
				.$promise
				.then(function(r) {
					$scope.relatedproducts = r;
					$scope.loadingrelated = false;
					console.log(r);
				}, function(err) {
					Notification.error("Si è verificato un errore");
					console.log(err);
				});
		}

				function loadPackProducts() {
			ProductService
				.getProductPack($scope.prodotto.id)
				.$promise
				.then(function(r) {
					$scope.packproducts = r;
					console.log(r);

				}, function(err) {
					Notification.error("Si è verificato un errore");
					console.log(err);
				});


		}

		function loadProducts() {
			 ProductService.getAll().$promise.then(function (r) {
								$scope.products = r;
						}, function (e) {
								console.log(e);
						});
		}

		getCodiciIva();
		getConti();
	
		function getCodiciIva (){
			ContabilitaService.getCodiciIva().$promise.then(function (r) {
					$scope.codiciiva = r;
				}, function (e) {
					console.log(e);
					//TODO gestire errore
				});
		}

		function getConti (){
			ContabilitaService.getConti().$promise.then(function (r) {
					$scope.conti = r;
				}, function (e) {
					console.log(e);
					//TODO gestire errore
				});
		}


		var promiseCategorieProdotto;
		var promiseCategorie;

		promiseCategorie = ProductService.getCategorie().$promise;

		promiseCategorie.then(function (r) {
			$scope.categorie = r;
		}, function (e) {
			console.log(e);
			Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');


		});



		function getCategorieProdotto() {
			promiseCategorieProdotto = ProductService.getCategorieProdotto($scope.prodotto.id).$promise;

			promiseCategorieProdotto.then(function (r) {
				$scope.categorieProdotto = r;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}



		function getAllegatiProdotto() {
			UploadService.getAllegati('product', $scope.prodotto.id).$promise.then(function (r) {
				$scope.allegati = r;

				if ($scope.hasUploadFileTabs) {
					$scope.allegatiFuture = $scope.allegati.filter(function (attach) {
						return !attach.awsurl;
					}).sort(function (a, b) { return a.validfrom - b.validfrom });
					$scope.allegatiPast = $scope.allegati.filter(function (attach) {
						return attach.awsurl;
					}).sort(function (a, b) { return b.validfrom - a.validfrom });
				}

				// console.log(r);
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}


		function controllaCategorie() {
			$q.all([promiseCategorieProdotto, promiseCategorie]).then(function (data) {

				_.each($scope.categorie, function (c) {
					c.pid = $scope.prodotto.id;
					c.tid = c.id;
					if (_.some($scope.categorieProdotto, function (v) {
						if (v.id == c.id) return true;
					}))
						c.checked = true;
				});


			});
		}

		$scope.salvaCategorie = function () {
			var cats = _.filter($scope.categorie, function (c) { return c.checked; });
			ProductService.aggiornaCategorieProdotto($scope.prodotto.id, cats).$promise.then(function (r) {
				Notification.success('Categorie prodotto aggiornate');

			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');

			});
		}

		$scope.immagine = {};
		$scope.uploadImmagine = function () {
			if ($scope.immagine && $scope.immagine.file && $scope.prodotto && $scope.prodotto.id) {
				UploadService.uploadImage($scope.immagine.file).then(function (resp) {

					Notification.success('Immagine caricata');
					console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					$scope.prodotto.img = resp.data.path;
					$scope.salva.apply();
				}, function (resp) {
					Notification.success('Si è verificato un errore');
					console.log('Error status: ' + resp.status);
				}, function (evt) {
					var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				}).catch(function (e) {
					console.log(e);
				});
			}
			else {
				$scope.salva.apply();
			}

		};

		$scope.f = {};
		$scope.dpackInfo = [];
		$scope.uploadFile = function (f, id, allegato) {
			if (f && id) {
				$scope.f[id] = f; // questo serve per gestire evt e il progresso upload
				UploadService.upload(f, id).then(function (resp) {
					Notification.success('File caricato');
					$scope.dpackInfo[id] = resp.data;
					allegato.filename = resp.data.filename;
					allegato.awsurl = resp.data.url;
					if ($scope.prodotto.type == 'audio' && allegato) $scope.updateAttach(allegato);
				}, function (resp) {
					console.log('Error status: ' + resp.status);
				}, function (evt) {
					console.log(evt);
					$scope.f[id].progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
				}).catch(function (e) {
					console.log(e);
				});
			}
			else {
				// $scope.salva.apply();
			}

		};
		
		$scope.uploadCover = function (f, id, attach) {
			if (f && id) {
				$scope.f[id] = f; // questo serve per gestire evt e il progresso upload
				UploadService.uploadCover(f).then(function (resp) {
					Notification.success('File caricato');
					console.log('Success ' + resp.config.data.file.name + ' uploaded. Response: ' + resp.data);
					console.log(resp.data);
					
					attach.coverimg = resp.data.url;
					$scope.updateAttach(attach);
				}, function (resp) {
					console.log('Error status: ' + resp.status);
				}, function (evt) {
					console.log(evt);
					$scope.f[id].progressCover = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
				}).catch(function (e) {
					console.log(e);
				});
			}
			else {
				// $scope.salva.apply();
			}

		};

		$scope.fileData = {};
		$scope.addDpackAuthorTitle = function(allegato) {
			console.log("allegato", allegato);

			// passaggio dati oggetto attach regolare
			allegato.moddate = allegato.insdate;
			if ($scope.dpackInfo[allegato.id] != undefined) {
				allegato.awsurl = $scope.dpackInfo[allegato.id].url;
				allegato.extension = $scope.dpackInfo[allegato.id].filename.slice(-4);
				allegato.filename = $scope.dpackInfo[allegato.id].filename;
				allegato.insdate = $scope.dpackInfo[allegato.id].filename.substr($scope.dpackInfo[allegato.id].filename.lastIndexOf("_")+1, 10);
			} else {
				//allegato.awsurl = allegato.extension = allegato.filename = allegato.insdate = null;
			}
			// allegato.name e allegato.id vengono dal frontend
			// campi aggiuntivi da agganciare ad attach
			if ($scope.fileData[allegato.id] != undefined) {
				allegato.aid = $scope.fileData[allegato.id].selectedAuthor.id;
				allegato.author = $scope.fileData[allegato.id].selectedAuthor.fname + ' ' + $scope.fileData[allegato.id].selectedAuthor.lname;
			}
			// allegato.title = $scope.fileData[allegato.id].title;
			// console.log(allegato);
			UploadService.postAllegati(allegato).$promise.then(function(r) {
				Notification.success('Informazioni aggiuntive salvate');
				console.log(r);
				getAllegatiProdotto();
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		};

		$scope.$watch('prodotto.selectedEvent', function(n, o) {
			if(n && n!=o){
				console.log(n)
					$scope.prodotto.title=n.name;
			}
		});


		$scope.updateAttach = function(attach){
			attach.retroupdate = $scope.retroshare.checked;
			UploadService.updateAllegato(attach).$promise.then(function(r) {
				Notification.success('Allegato aggiornato');
				$scope.retroshare.checked = 1;
				attach = r;
				console.log(r);
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		$scope.updateAttachRetroattivo = function(attach){
			UploadService.updateAllegatoRetroattivo(attach).$promise.then(function(r) {
				Notification.success('Allegato aggiornato');
				attach = r;
				console.log(r);
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		$scope.retroshareAttach = function (attach) {
			$ngConfirm({
				title: 'Retroshare allegato',
				content: "Sei sicuro di voler eseguire l'operazione?",
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Conferma",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {
							$scope.loadRetroshare = true;
							UploadService.retroshareAllegato(attach).$promise.then(function (r) {
								Notification.success('Allegato retroshared');
								console.log(r);
								getAllegatiProdotto();
								$scope.loadRetroshare = false;
							}, function (e) {
								console.log(e);
								Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
							});
						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});
		}

		$scope.unshareAttach = function(attach) {
			console.log("attach", attach);
			$ngConfirm({
				title: 'Unshare allegato',
				content: "Sei sicuro di voler eseguire l'operazione?",
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Conferma",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function(scope) {
							$scope.loadUnshare = true;
							UploadService.unshareAllegato(attach).$promise.then(function(r) {
								Notification.success('Allegato unshared');
								console.log(r);
								getAllegatiProdotto();
								$scope.loadUnshare = false;
							}, function(e) {
								console.log(e);
								Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
							});
						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function(scope) {
							return true;
						}
					}
				},
			});
		}

		$scope.deletePromo2 = function() {
			$scope.prodotto.secpromotodate = undefined;
			$scope.prodotto.secpromo = undefined;
		}

		$scope.salva = function () {
			console.log($scope.prodotto, 'promo',$scope.promo);

			if ($scope.prodotto.selectedEvent) {
				$scope.prodotto.eid = $scope.prodotto.selectedEvent.id;
			}

			if ($scope.prodotto.selectedGiftProduct) {
				$scope.prodotto.giftid = $scope.prodotto.selectedGiftProduct.id;
			} else {
				$scope.prodotto.giftid = null;
			}
			if ($scope.prodotto.selectedDownline) {
				$scope.prodotto.downline = $scope.prodotto.selectedDownline.id;
			} else {
				$scope.prodotto.downline = null;
			}
			if ($scope.prodotto.selectedPrerequisite) {
				$scope.prodotto.prerequisite = $scope.prodotto.selectedPrerequisite.id;
			} else {
				$scope.prodotto.prerequisite = null;
			}
			// modificare in modo che prenda l'ora da input
			if ($scope.prodotto.sellfromdateS) {
				$scope.prodotto.sellfromdate = parseInt($scope.prodotto.sellfromdateS.getTime() / 1000);
			}
			// modificare in modo che prenda l'ora da input
			if ($scope.prodotto.selltodateS) {
				$scope.prodotto.selltodate = parseInt($scope.prodotto.selltodateS.getTime() / 1000);
			}
			if ($scope.prodotto.promofromdateS) {
				$scope.prodotto.promofromdate = parseInt($scope.prodotto.promofromdateS.getTime() / 1000);
			}
			if ($scope.prodotto.promotodateS) {
				$scope.prodotto.promotodate = parseInt($scope.prodotto.promotodateS.getTime() / 1000);
			}
			if (!$scope.prodotto.promo2) {
				$scope.deletePromo2();
			} else {
				if ($scope.prodotto.secpromotodate) {
					$scope.prodotto.secpromotodate = parseInt($scope.prodotto.secpromotodate.getTime() / 1000);
				}
			}
			if ($scope.prodotto.giftfromS) {
				$scope.prodotto.giftfrom = parseInt($scope.prodotto.giftfromS.getTime() / 1000);
			} else {
				$scope.prodotto.giftfrom = null;
			}
			if ($scope.prodotto.gifttoS) {
				$scope.prodotto.giftto = parseInt($scope.prodotto.gifttoS.getTime() / 1000);
			} else {
				$scope.prodotto.giftto = null;
			}

			if ($scope.prodotto.needdisclaimer === 0 && $scope.prodotto.disclaimer != "") {
				// azzera il disclaimer se si seleziona la checkbox e si riempie la textarea, ma poi si cambia idea e si leva la spunta
				$scope.prodotto.disclaimer = '';
			}
			if ($scope.prodotto.needdisclaimerapp === 0 && $scope.prodotto.disclaimerapp != "") {
				// azzera il disclaimer se si seleziona la checkbox e si riempie la textarea, ma poi si cambia idea e si leva la spunta
				$scope.prodotto.disclaimerapp = '';
			}
			if ($scope.prodotto.type == 'file') {
				$scope.prodotto.files = 1;
			}

			// console.log('PRODOTTO POST', $scope.prodotto);

			if ($scope.prodotto.id) {
				ProductService.aggiornaProdotto($scope.prodotto).$promise.then(function (r) {
					loadProdotto();

					Notification.success('Prodotto salvato');
				}, function (e) {
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
					console.log(e);
				});
			}
			else {
				if ($scope.prodotto.needdisclaimer === 0 && $scope.prodotto.disclaimer != "") {
					$scope.prodotto.disclaimer = '';
				}
				if ($scope.prodotto.needdisclaimerapp === 0 && $scope.prodotto.disclaimerapp != "") {
					$scope.prodotto.disclaimerapp = '';
				}
				ProductService.creaProdotto($scope.prodotto).$promise.then(function (r) {
					Notification.success('Prodotto salvato');
					$state.go('modifica-prodotto',{id:r.id});
				}, function (e) {
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
					console.log(e);
				});
			}
		}

		$scope.aggiungiAutoreProdotto = function(aut) {
			if(aut){
			ProductService
				.addAuthorProduct($scope.prodotto, aut)
				.$promise
				.then(function(r) {
					console.log(r);
					loadAuthorProduct($scope.prodotto);
				});
			}
		}
		$scope.eliminaAutoreProdotto = function(sp) {
			ProductService
				.deleteAuthorProduct(sp)
				.$promise
				.then(function() {
					loadAuthorProduct($scope.prodotto);
				});
		}

		$scope.aggiungiProdottoPack = function(aut) {
		 if(aut){
			ProductService
				.addProductToPack($scope.prodotto, aut)
				.$promise
				.then(function(r) {
					console.log(r);
					loadPackProducts($scope.prodotto);
				});
			}
		}


		$scope.eliminaProdottoPack = function(sp) {
			ProductService
				.deleteProductPack(sp)
				.$promise
				.then(function() {
					loadPackProducts($scope.prodotto);
				});
		}

		$scope.searchProductRelatedPool = function(searchterm) {
			var search = {
				table: 'product',
				sortfield: "name",
				direction: "asc",
				like: [{ field: 'name', term: searchterm }],
				simple: [{ field: 'status', filter: 'ok'}],
				range: []
			};
			ProductService.advancedSearch(search, 0, 1000000).$promise.then(function (r) {
					$scope.productsrelatedpool = r;
				}, function (e) {
						console.log(e);
				});
		};

		$scope.aggiungiProdottoRelated = function(related) {
			if(related){
				ProductService
					.addProductRelated($scope.prodotto, related)
					.$promise
					.then(function(r) {
						console.log(r);
						loadRelatedProducts();
				});
			}
		}

		$scope.eliminaProdottoRelated = function(related) {
			ProductService
				.deleteProductRelated(related)
				.$promise
				.then(function() {
					loadRelatedProducts();
				});
		}

		$scope.resetOmaggio = function() {
			$scope.prodotto.giftid = undefined;
			$scope.prodotto.giftfromS = undefined;
			$scope.prodotto.gifttoS = undefined;
			$scope.prodotto.giftfrom = undefined;
			$scope.prodotto.giftto = undefined;
			$scope.prodotto.selectedGiftProduct = undefined;
			$scope.salva();
		}

		$scope.searchIncaricato=function(term) {
			UtentiService.cercaIncaricati(term).$promise.then(function (r) {
				$scope.incaricati = r;
			}, function (e) {
				console.log(e);
			});
		}

		var giftFilter = {
			table : "gift",
			simple : [{field : 'productid', filter : $stateParams.id}],
			direction : 'desc',
			sortfield : 'id'
		}

		$scope.giftTablePageSize = 25;

		$scope.getGift = function(tableState){
		    $scope.tableStateGift=tableState;
		    var pagination = tableState.pagination;

		    var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
		    var number = pagination.number || 10;  // Number of entries showed per page.
		    var stop = start+number;
		    var sort = {sortfield: tableState.sort.predicate, direction:tableState.sort.reverse ? 'desc' : 'asc' };
		    tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalGifts/number));//set the number of pages so the pagination can update
	    	UtentiService.giftAdvancedSearch(giftFilter, start, stop).$promise.then(function(r) {
					$scope.gifts = r;
				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
	    }

		function countGift (){
			UtentiService.giftAdvancedCount(giftFilter).$promise.then(function(r) {
				$scope.totalGifts = r.ct;
				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
        }

		countGift();

	}

})();

(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.utenti')
      .controller('BonusCtrl', BonusCtrl);

function BonusCtrl($rootScope, $scope, UtentiService, $state, $stateParams, $location) {

		// datepicker
		$scope.options = {
		    datepickerMode: 'month',
		    minMode: 'month',
		    maxMode: 'year',
		    showWeeks: false
		 };
		
		if (!$stateParams.month && !$stateParams.year) {
			$scope.datePicker = new Date();
			var month = new Date().getMonth() + 1;
			var year = new Date().getFullYear();
		}
		else {
			$scope.datePicker = new Date($stateParams.year, $stateParams.month - 1, 1);
			var month = $stateParams.month;
			var year = $stateParams.year;
			console.log($scope.datePicker, month, year);
		}
		

		$scope.loading = true;
		function loadBonus(uid, month, year) {
			$scope.curDate = { month: month, year: year };

			UtentiService
				.getBonus(uid, month, year)
				.$promise
				.then(function(r) {
					console.log(r);
					$scope.bonus = r;
					$scope.loading = false;

					$state.current.title = "Segni vitali";
					$state.go('profileBonus', {id: uid, month: month, year: year}, {notify: false}) 
				});
		}

		function loadLastBonus(id, last) {

			UtentiService
				.getLastBonus(id, last)
				.$promise
				.then(function(r) {
					console.log('loadLastBonus', r);

					$scope.bonus = r;
				});

		}


			if ($stateParams.id) {

				loadBonus($stateParams.id, month, year);

			} else {
				$state.go('utenti');
			}

			$scope.$watch('datePicker', function() {
				if ($scope.datePicker !== undefined)
					console.log('cambio mese');
					loadBonus($stateParams.id, $scope.datePicker.getMonth()+1, $scope.datePicker.getFullYear());
			});


			$scope.totalRebate = function(bonus) {
				if (!bonus) return '';
				return bonus.groupcdbonus + bonus.groupbbsbonus + bonus.groupwesbonus;
			};

			$scope.rebateDue = function(bonus) {
				if (!bonus) return '';
				return bonus.cdbonus + bonus.bbsbonus + bonus.wesbonus;
			};

			$scope.goToBonus = function(bonus, m, y) {
				console.log('Go to bonus', bonus, m || bonus.month, y)
				var id = bonus.uid || bonus.id;
				if (!!m)
					$location.path('bonus-utente/' + id + '/' + m + '/' + y);
				else
					$location.path('bonus-utente/' + id + '/' + bonus.month + '/' + bonus.year);
			};
	}
})();
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.utenti')
      .controller('CardCtrl', CardCtrl);

function CardCtrl($rootScope, $scope, UtentiService, CardService,$state, $stateParams, $location, $q, Notification, ENV) {
		// STRIPE
		var pkey = 'pk_test_PFKr8jE44pUJz3p9QPxnysQu';

		if(ENV.type=='prod'){
		  pkey= 'pk_live_5x5E9eNQjYglF1SVwvFU3Ah2';
		}



		   var stripe    = Stripe(pkey),
		    elements  = stripe.elements();

		$scope.stripe = stripe;
		$scope.card = elements.create('card');

		

		
		// END STRIPE


if ($stateParams.id) {
			UtentiService.getUtente($stateParams.id).$promise.then(function (r) {

				$scope.hasStripeID = (!!r.stripeid);
					$scope.stripeID = r.stripeid;

					$scope.user=r;
					getCreditCards();
			});
		}

	$scope.newCard = {};

			getCreditCards();

		function getCreditCards() {
			if ($scope.user) {
				CardService.getCards($scope.user.id).$promise.then(function(r) {
					$scope.creditCards = r;
				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
			
		}


$scope.addNewcard=false;
		$scope.processToken = function(token) {
			if(token){
		      $scope.card.clear();
		
		      return CardService
		        .addCard($scope.user.id, token)
		        .$promise.then(function(result) {
					$scope.addNewcard=false;
		          getCreditCards();
		        }, function(err){
		        	$scope.addNewcard=false;
             Notification.error('Errore nell\'inserimento della carta. ' + (err && err.data ? err.data.msg : ''));

          });
		      console.log('Token', token);
		  }
		  else{
		  	$scope.addNewcard=false;
		  	 return $q.when(false);
		  }
		    }
		

		$scope.deleteCard = function(card) {
			if(confirm('Questa azione non può essere annullata. Procedere?')) {

				CardService.deleteCard($scope.user.id, card).$promise.then(function(cards) {
						
					$scope.creditCards = $scope.creditCards.filter(function(item) {
						return item.card != card.card;
					})


					}, function(err) {
						Notification.error('Errore nella eliminazione della carta. ' + (err && err.data ? err.data.msg : ''));
					});
			}
		}

		$scope.makeDefault = function(card) {
			$scope.loadingCarte=true;
			CardService
				.makeDefault($scope.user.id, card)
				.$promise.then(function(cards) {

					$scope.creditCards = cards;
						$scope.loadingCarte=false;
				});
		}


}		
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
	'use strict';

	angular.module('AmwayAdmin.pages.utenti')
		.controller('FornitoreCtrl', FornitoreCtrl);

	/** @ngInject */
	function FornitoreCtrl($scope, $stateParams, FornitoriService, ConstantsService, ContabilitaService, Notification, $state, $q) {

		$scope.dati = {};


		if ($stateParams.id) {
			loadFornitore($stateParams.id);
		} else {
			$scope.fornitore = {};
		}

		if($stateParams.idel){
			$scope.fornitore = {};
			loadFornitoreInfo($stateParams.idel);
		}

		function loadFornitore(id) {
			// mettere api di recall del codice iva
			FornitoriService.getFornitore(id).$promise.then(function(response) {
				$scope.fornitore = response;
				getCountry();
				getProvincia();
				getComune();
				getCodiciPag();
				getCodiciIva();
				getTipiAnagrafica();
				$scope.dati.selectedContoCosto = getConto($scope.fornitore.contocosto);
				$scope.dati.selectedContoColl = getConto($scope.fornitore.contocoll);

			}, function(error) {
				console.log("Errore GET singolo Fornitore", error);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		function loadFornitoreInfo(id){
			ContabilitaService.getInvoicePassiveDraft(id).$promise.then(function(invoice) {
				var fornInfo = JSON.parse(invoice.rawdata).mittente;
				console.log(fornInfo);
				$scope.fornitore.nome = fornInfo.denominazione;
				$scope.fornitore.cf = fornInfo.cf;
				$scope.fornitore.partitaiva = fornInfo.piva;
				$scope.fornitore.indirizzo = fornInfo.indirizzo;
				$scope.fornitore.cap = fornInfo.cap;
				if(fornInfo.nazione == 'IT'){
					$scope.dati.selectedNazione = {name : 'Italia'}
					if(fornInfo.provincia){
						ConstantsService.getProvince().$promise.then(function(province) {
							var pid = province.map(function(provincia){
								return provincia.sigla;
							}).indexOf(fornInfo.provincia);
							$scope.dati.selectedProvince = province[pid];
						});
					}
					if(fornInfo.comune){
						$scope.dati.selectedCity = {descrizione : fornInfo.comune}
					}
				}
				else if(fornInfo.nazione){
					ConstantsService.getCountries().$promise.then(function(countries) {
						var cid = countries.map(function(country){
							return country.sigla;
						}).indexOf(fornInfo.nazione);
						$scope.dati.selectedNazione = countries[cid];
					});
					$scope.fornitore.localita = fornInfo.comune;
				}


			}, function(e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		

		function getCountries() {
			ConstantsService.getCountries().$promise.then(function(r) {
				$scope.countries = r;
			}, function(e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		function getProvinces() {
			ConstantsService.getProvince().$promise.then(function(r) {
				$scope.province = r;
			}, function(e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		function getComuni(provinciaId) {
			ConstantsService.getComuni(provinciaId).$promise.then(function(r) {
				angular.forEach(r, function(item) {
					delete item.provincia;
				});
				$scope.comuni = r;
			}, function(e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		function getComuniResfis(provinciaId) {
			ConstantsService.getComuni(provinciaId).$promise.then(function(r) {
				angular.forEach(r, function(item) {
					delete item.provincia;
				});
				$scope.comuniResfis = r;
			}, function(e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		function getCodiciPag() {
			ContabilitaService.getTipiPagamento().$promise.then(function(response) {
				$scope.codiciPag = response;
				if ($scope.fornitore && $scope.fornitore.id) {
					for (var i = 0; i < response.length; i++) {
						if ($scope.fornitore.codicepag == response[i].codice) {
							$scope.dati.selectedCodicePagamento = response[i];
							break;
						}
					}
				}
			}, function(e) {
				console.log(e);
			});
		}
		function getCodiciIva() {
			ContabilitaService.getCodiciIva().$promise.then(function(response) {
				$scope.codiciIva = response;
				if ($scope.fornitore && $scope.fornitore.id) {
					for (var i = 0; i < response.length; i++) {
						if ($scope.fornitore.codiceiva == response[i].codice) {
							$scope.dati.selectedCodIva = response[i];
							break;
						}
					}
				}
			}, function(e) {
				console.log(e);
			});
		}
		function getTipiAnagrafica() {
			ContabilitaService.getTipiAnagrafica().$promise.then(function(r) {
				$scope.tipiAnagrafica = r;
				$scope.tipiAnagrafica = $scope.tipiAnagrafica.filter(function(value) {
					return value.descrizione.includes('FORNITOR');
				});
				if ($scope.fornitore && $scope.fornitore.id) {
					for (var i = 0; i < $scope.tipiAnagrafica.length; i++) {
						if ($scope.fornitore.tipo == $scope.tipiAnagrafica[i].codice) {
							$scope.dati.selectedTipo = $scope.tipiAnagrafica[i];
							break;
						}
					}
				}
			}, function(e) {
				console.log(e);
			});
		}

		$scope.$watch('dati.selectedProvince', function(newValue, oldValue) {
			if (newValue && newValue != oldValue) {
				getComuni($scope.dati.selectedProvince.id);
			}
		});


		$scope.$watch('dati.selectedProvinceResfis', function(newValue, oldValue) {
			if (newValue && newValue != oldValue) {
				getComuniResfis($scope.dati.selectedProvinceResfis.id);
			}
		});

		getCountries();
		getProvinces();
		getCodiciPag();
		getCodiciIva();
		getTipiAnagrafica();

		// single GET for edit Fornitore
		function getCountry() {
			if ($scope.fornitore.country) {
				ConstantsService.getCountryDaDescr($scope.fornitore.country).$promise.then(function(r) {
					if (r && r.length)
						$scope.dati.selectedNazione = r[0];
				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
		}

		function getProvincia() {
			if ($scope.fornitore.provincia && $scope.fornitore.country == 'Italia') {
				ConstantsService.getProvinciaDaSigla($scope.fornitore.provincia).$promise.then(function(r) {
					if (r && r.length)
						$scope.dati.selectedProvince = r[0];
				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
			if ($scope.fornitore.provnascita) {
				ConstantsService.getProvinciaDaSigla($scope.fornitore.provnascita).$promise.then(function(r) {
					if (r && r.length)
						$scope.dati.selectedProvinceNascita = r[0];
				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
			if ($scope.fornitore.resfisprovincia) {
				ConstantsService.getProvinciaDaSigla($scope.fornitore.resfisprovincia).$promise.then(function(r) {
					if (r && r.length)
						$scope.dati.selectedProvinceResfis = r[0];
				}, function(e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
			
		}

		function getComune() {
			if ($scope.fornitore.localita && $scope.fornitore.country == 'Italia') {
				ConstantsService.getComuneDaDescr($scope.fornitore.localita).$promise.then(function(r) {
					if (r && r.length)
						$scope.dati.selectedCity = r[0];
				}, function(e) {
					console.log(e);
				});
			}
			if ($scope.fornitore.resfiscomune && $scope.fornitore.country == 'Italia') {
				ConstantsService.getComuneDaDescr($scope.fornitore.resfiscomune).$promise.then(function(r) {
					if (r && r.length)
						$scope.dati.selectedCityResfis = r[0];
				}, function(e) {
					console.log(e);
				});
			}
		}

		function getConto(conto) {
			if (conto) {
				return ContabilitaService.getContoByCodice(conto);
			}
		}

		// $scope

		$scope.searchAccounts = function(searchterm) {
			ContabilitaService.searchAccounts(searchterm).$promise.then(function(response) {
				$scope.accounts = response;
			}, function(error) {
				console.log("POST di ricerca conti fallita", error);
			});
		};


		$scope.salva = function() {
			// prepara dati di ui-select e datepicker
			
			$scope.fornitore.codvaluta = parseInt($scope.fornitore.codvaluta); 

			if ($scope.dati.selectedNazione) {
				$scope.fornitore.country = $scope.dati.selectedNazione.name;
				$scope.fornitore.coutrycode = $scope.dati.selectedNazione.sigla;
			}
			if ($scope.dati.selectedProvince && $scope.fornitore.country == 'Italia') {
				$scope.fornitore.provincia = $scope.dati.selectedProvince.sigla;
			}
			if ($scope.dati.selectedProvinceResfis && $scope.fornitore.country == 'Italia') {
				$scope.fornitore.resfisprovincia = $scope.dati.selectedProvinceResfis.sigla;
			}
			if ($scope.dati.selectedCity && $scope.fornitore.country == 'Italia') {
				$scope.fornitore.localita = $scope.dati.selectedCity.descrizione;
			}
			if ($scope.dati.selectedCityResfis && $scope.fornitore.country == 'Italia') {
				$scope.fornitore.resfiscomune = $scope.dati.selectedCityResfis.descrizione;
			}
			if ($scope.dati.selectedProvinceNascita) {
				$scope.fornitore.provnascita = $scope.dati.selectedProvinceNascita.sigla;
			}
			if ($scope.dati.selectedTipo) {
				$scope.fornitore.tipo = $scope.dati.selectedTipo.codice;
			}
			if ($scope.dati.selectedCodIva) {
				$scope.fornitore.codiceiva = $scope.dati.selectedCodIva.codice;
			}
			if ($scope.dati.selectedCodicePagamento) {
				$scope.fornitore.codicepag = $scope.dati.selectedCodicePagamento.codice;
			}
			if ($scope.dati.selectedContoCosto) {
				$scope.fornitore.contocosto = $scope.dati.selectedContoCosto.codice;
			}
			if ($scope.dati.selectedContoColl) {
				$scope.fornitore.contocoll = $scope.dati.selectedContoColl.codice;
			}

			FornitoriService.postFornitore($scope.fornitore).$promise.then(function(response) {
				if ($scope.fornitore.id) {
					Notification.success('Fornitore modificato con successo');
				} else {
					Notification.success('Fornitore creato con successo');
				}
				$state.go('anagrafica.fornitori');
			}, function(error) {
				console.log("Errore, impossibile salvare FORNITORE", error);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		};

		$scope.invalidCF = undefined;
		$scope.checkCFValidity = function() {
			var element = angular.element(document).find('#cf');
			if (element.hasClass('ng-invalid-cf')) {
				$scope.invalidCF = true;
			} else {
				$scope.invalidCF = false;
			}
		};
	}

})();
angular.module('AmwayAdmin.pages.utenti').factory('FornitoriService', function(DataConnectorService) {

	var response = {};

	response.getFornitore = function(id) {
		return DataConnectorService.getResource('fornitore/:id', {
			id: id
		}).get();
	}

	response.postFornitore = function(fornitore) {
		return DataConnectorService.getResource('fornitore').post(fornitore);
	}

	return response;

});
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.utenti')
      .controller('LivelliCtrl', LivelliCtrl);

  /** @ngInject */
  function LivelliCtrl($scope, UtentiService, $stateParams) {

    if ($stateParams.id){
      UtentiService.getAlberoUtente($stateParams.id).$promise.then(function(r){
         console.log(r);
         $scope.chart = r;

       }, function(e){
         console.log(e);
      //TODO gestire errore
      });
    }
    else{
     
    }


 $scope.chart1 = 
  {
   "name": "flare",
   "children": [
    {
     "name": "analytics",
     "classed": "danger",
     "color": "#FF0000",
     "children": [
      {
       "name": "cluster",
       "children": [
        {"name": "AgglomerativeCluster", "size": 3938},
        {"name": "CommunityStructure", "size": 3812},
        {"name": "HierarchicalCluster", "size": 6714},
        {"name": "MergeEdge", "size": 743}
       ]
      }
      ]
    }
    ]
  };

  $scope.chart2 = 
  {
   "name": "flare",
   "children": [
    {
     "name": "analytics",
     "classed": "danger",
     "color": "#FF0000",
     "children": [
      {
       "name": "cluster",
       "children": [
        {"name": "AgglomerativeCluster", "size": 3938},
        {"name": "CommunityStructure", "size": 3812},
        {"name": "HierarchicalCluster", "size": 6714},
        {"name": "MergeEdge", "size": 743}
       ]
      },
      {
       "name": "graph",
       "children": [
        {"name": "BetweennessCentrality", "size": 3534},
        {"name": "LinkDistance", "size": 5731},
        {"name": "MaxFlowMinCut", "size": 7840},
        {"name": "ShortestPaths", "size": 5914},
        {"name": "SpanningTree", "size": 3416}
       ]
      },
      {
       "name": "optimization",
       "children": [
        {"name": "AspectRatioBanker", "size": 7074}
       ]
      }
     ]
    },
    {
     "name": "animate",
     "children": [
      {"name": "Easing", "size": 17010},
      {"name": "FunctionSequence", "size": 5842},
      {
       "name": "interpolate",
       "children": [
        {"name": "ArrayInterpolator", "size": 1983},
        {"name": "ColorInterpolator", "size": 2047},
        {"name": "DateInterpolator", "size": 1375},
        {"name": "Interpolator", "size": 8746},
        {"name": "MatrixInterpolator", "size": 2202},
        {"name": "NumberInterpolator", "size": 1382},
        {"name": "ObjectInterpolator", "size": 1629},
        {"name": "PointInterpolator", "size": 1675},
        {"name": "RectangleInterpolator", "size": 2042}
       ]
      },
      {"name": "ISchedulable", "size": 1041},
      {"name": "Parallel", "size": 5176},
      {"name": "Pause", "size": 449},
      {"name": "Scheduler", "size": 5593},
      {"name": "Sequence", "size": 5534},
      {"name": "Transition", "size": 9201},
      {"name": "Transitioner", "size": 19975},
      {"name": "TransitionEvent", "size": 1116},
      {"name": "Tween", "size": 6006}
     ]
    },
    {
     "name": "data",
     "children": [
      {
       "name": "converters",
       "children": [
        {"name": "Converters", "size": 721},
        {"name": "DelimitedTextConverter", "size": 4294},
        {"name": "GraphMLConverter", "size": 9800},
        {"name": "IDataConverter", "size": 1314},
        {"name": "JSONConverter", "size": 2220}
       ]
      },
      {"name": "DataField", "size": 1759},
      {"name": "DataSchema", "size": 2165},
      {"name": "DataSet", "size": 586},
      {"name": "DataSource", "size": 3331},
      {"name": "DataTable", "size": 772},
      {"name": "DataUtil", "size": 3322}
     ]
    },
    {
     "name": "display",
     "children": [
      {"name": "DirtySprite", "size": 8833},
      {"name": "LineSprite", "size": 1732},
      {"name": "RectSprite", "size": 3623},
      {"name": "TextSprite", "size": 10066}
     ]
    },
    {
     "name": "flex",
     "children": [
      {"name": "FlareVis", "size": 4116}
     ]
    },
    {
     "name": "physics",
     "children": [
      {"name": "DragForce", "size": 1082},
      {"name": "GravityForce", "size": 1336},
      {"name": "IForce", "size": 319},
      {"name": "NBodyForce", "size": 10498},
      {"name": "Particle", "size": 2822},
      {"name": "Simulation", "size": 9983},
      {"name": "Spring", "size": 2213},
      {"name": "SpringForce", "size": 1681}
     ]
    },
    {
     "name": "query",
     "children": [
      {"name": "AggregateExpression", "size": 1616},
      {"name": "And", "size": 1027},
      {"name": "Arithmetic", "size": 3891},
      {"name": "Average", "size": 891},
      {"name": "BinaryExpression", "size": 2893},
      {"name": "Comparison", "size": 5103},
      {"name": "CompositeExpression", "size": 3677},
      {"name": "Count", "size": 781},
      {"name": "DateUtil", "size": 4141},
      {"name": "Distinct", "size": 933},
      {"name": "Expression", "size": 5130},
      {"name": "ExpressionIterator", "size": 3617},
      {"name": "Fn", "size": 3240},
      {"name": "If", "size": 2732},
      {"name": "IsA", "size": 2039},
      {"name": "Literal", "size": 1214},
      {"name": "Match", "size": 3748},
      {"name": "Maximum", "size": 843},
      {
       "name": "methods",
       "children": [
        {"name": "add", "size": 593},
        {"name": "and", "size": 330},
        {"name": "average", "size": 287},
        {"name": "count", "size": 277},
        {"name": "distinct", "size": 292},
        {"name": "div", "size": 595},
        {"name": "eq", "size": 594},
        {"name": "fn", "size": 460},
        {"name": "gt", "size": 603},
        {"name": "gte", "size": 625},
        {"name": "iff", "size": 748},
        {"name": "isa", "size": 461},
        {"name": "lt", "size": 597},
        {"name": "lte", "size": 619},
        {"name": "max", "size": 283},
        {"name": "min", "size": 283},
        {"name": "mod", "size": 591},
        {"name": "mul", "size": 603},
        {"name": "neq", "size": 599},
        {"name": "not", "size": 386},
        {"name": "or", "size": 323},
        {"name": "orderby", "size": 307},
        {"name": "range", "size": 772},
        {"name": "select", "size": 296},
        {"name": "stddev", "size": 363},
        {"name": "sub", "size": 600},
        {"name": "sum", "size": 280},
        {"name": "update", "size": 307},
        {"name": "variance", "size": 335},
        {"name": "where", "size": 299},
        {"name": "xor", "size": 354},
        {"name": "_", "size": 264}
       ]
      },
      {"name": "Minimum", "size": 843},
      {"name": "Not", "size": 1554},
      {"name": "Or", "size": 970},
      {"name": "Query", "size": 13896},
      {"name": "Range", "size": 1594},
      {"name": "StringUtil", "size": 4130},
      {"name": "Sum", "size": 791},
      {"name": "Variable", "size": 1124},
      {"name": "Variance", "size": 1876},
      {"name": "Xor", "size": 1101}
     ]
    },
    {
     "name": "scale",
     "children": [
      {"name": "IScaleMap", "size": 2105},
      {"name": "LinearScale", "size": 1316},
      {"name": "LogScale", "size": 3151},
      {"name": "OrdinalScale", "size": 3770},
      {"name": "QuantileScale", "size": 2435},
      {"name": "QuantitativeScale", "size": 4839},
      {"name": "RootScale", "size": 1756},
      {"name": "Scale", "size": 4268},
      {"name": "ScaleType", "size": 1821},
      {"name": "TimeScale", "size": 5833}
     ]
    },
    {
     "name": "util",
     "children": [
      {"name": "Arrays", "size": 8258},
      {"name": "Colors", "size": 10001},
      {"name": "Dates", "size": 8217},
      {"name": "Displays", "size": 12555},
      {"name": "Filter", "size": 2324},
      {"name": "Geometry", "size": 10993},
      {
       "name": "heap",
       "children": [
        {"name": "FibonacciHeap", "size": 9354},
        {"name": "HeapNode", "size": 1233}
       ]
      },
      {"name": "IEvaluable", "size": 335},
      {"name": "IPredicate", "size": 383},
      {"name": "IValueProxy", "size": 874},
      {
       "name": "math",
       "children": [
        {"name": "DenseMatrix", "size": 3165},
        {"name": "IMatrix", "size": 2815},
        {"name": "SparseMatrix", "size": 3366}
       ]
      },
      {"name": "Maths", "size": 17705},
      {"name": "Orientation", "size": 1486},
      {
       "name": "palette",
       "children": [
        {"name": "ColorPalette", "size": 6367},
        {"name": "Palette", "size": 1229},
        {"name": "ShapePalette", "size": 2059},
        {"name": "SizePalette", "size": 2291}
       ]
      },
      {"name": "Property", "size": 5559},
      {"name": "Shapes", "size": 19118},
      {"name": "Sort", "size": 6887},
      {"name": "Stats", "size": 6557},
      {"name": "Strings", "size": 22026}
     ]
    },
    {
     "name": "vis",
     "children": [
      {
       "name": "axis",
       "children": [
        {"name": "Axes", "size": 1302},
        {"name": "Axis", "size": 24593},
        {"name": "AxisGridLine", "size": 652},
        {"name": "AxisLabel", "size": 636},
        {"name": "CartesianAxes", "size": 6703}
       ]
      },
      {
       "name": "controls",
       "children": [
        {"name": "AnchorControl", "size": 2138},
        {"name": "ClickControl", "size": 3824},
        {"name": "Control", "size": 1353},
        {"name": "ControlList", "size": 4665},
        {"name": "DragControl", "size": 2649},
        {"name": "ExpandControl", "size": 2832},
        {"name": "HoverControl", "size": 4896},
        {"name": "IControl", "size": 763},
        {"name": "PanZoomControl", "size": 5222},
        {"name": "SelectionControl", "size": 7862},
        {"name": "TooltipControl", "size": 8435}
       ]
      },
      {
       "name": "data",
       "children": [
        {"name": "Data", "size": 20544},
        {"name": "DataList", "size": 19788},
        {"name": "DataSprite", "size": 10349},
        {"name": "EdgeSprite", "size": 3301},
        {"name": "NodeSprite", "size": 19382},
        {
         "name": "render",
         "children": [
    {"name": "ArrowType", "size": 698},
    {"name": "EdgeRenderer", "size": 5569},
    {"name": "IRenderer", "size": 353},
    {"name": "ShapeRenderer", "size": 2247}
         ]
        },
        {"name": "ScaleBinding", "size": 11275},
        {"name": "Tree", "size": 7147},
        {"name": "TreeBuilder", "size": 9930}
       ]
      },
      {
       "name": "events",
       "children": [
        {"name": "DataEvent", "size": 2313},
        {"name": "SelectionEvent", "size": 1880},
        {"name": "TooltipEvent", "size": 1701},
        {"name": "VisualizationEvent", "size": 1117}
       ]
      },
      {
       "name": "legend",
       "children": [
        {"name": "Legend", "size": 20859},
        {"name": "LegendItem", "size": 4614},
        {"name": "LegendRange", "size": 10530}
       ]
      },
      {
       "name": "operator",
       "children": [
        {
         "name": "distortion",
         "children": [
    {"name": "BifocalDistortion", "size": 4461},
    {"name": "Distortion", "size": 6314},
    {"name": "FisheyeDistortion", "size": 3444}
         ]
        },
        {
         "name": "encoder",
         "children": [
    {"name": "ColorEncoder", "size": 3179},
    {"name": "Encoder", "size": 4060},
    {"name": "PropertyEncoder", "size": 4138},
    {"name": "ShapeEncoder", "size": 1690},
    {"name": "SizeEncoder", "size": 1830}
         ]
        },
        {
         "name": "filter",
         "children": [
    {"name": "FisheyeTreeFilter", "size": 5219},
    {"name": "GraphDistanceFilter", "size": 3165},
    {"name": "VisibilityFilter", "size": 3509}
         ]
        },
        {"name": "IOperator", "size": 1286},
        {
         "name": "label",
         "children": [
    {"name": "Labeler", "size": 9956},
    {"name": "RadialLabeler", "size": 3899},
    {"name": "StackedAreaLabeler", "size": 3202}
         ]
        },
        {
         "name": "layout",
         "children": [
    {"name": "AxisLayout", "size": 6725},
    {"name": "BundledEdgeRouter", "size": 3727},
    {"name": "CircleLayout", "size": 9317},
    {"name": "CirclePackingLayout", "size": 12003},
    {"name": "DendrogramLayout", "size": 4853},
    {"name": "ForceDirectedLayout", "size": 8411},
    {"name": "IcicleTreeLayout", "size": 4864},
    {"name": "IndentedTreeLayout", "size": 3174},
    {"name": "Layout", "size": 7881},
    {"name": "NodeLinkTreeLayout", "size": 12870},
    {"name": "PieLayout", "size": 2728},
    {"name": "RadialTreeLayout", "size": 12348},
    {"name": "RandomLayout", "size": 870},
    {"name": "StackedAreaLayout", "size": 9121},
    {"name": "TreeMapLayout", "size": 9191}
         ]
        },
        {"name": "Operator", "size": 2490},
        {"name": "OperatorList", "size": 5248},
        {"name": "OperatorSequence", "size": 4190},
        {"name": "OperatorSwitch", "size": 2581},
        {"name": "SortOperator", "size": 2023}
       ]
      },
      {"name": "Visualization", "size": 16540}
     ]
    }
   ]
  };


}


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('AmwayAdmin.pages.utenti')
		.controller('UtenteCtrl', UtenteCtrl);

	/** @ngInject */
	function UtenteCtrl($scope, $state, $rootScope, $stateParams, md5, UtentiService, ConstantsService, Notification, $ngConfirm, $uibModal, UploadService, DataConnectorService, ContabilitaService, UtilsService, OrderService, EventiService, ProductService, $timeout, $q, $location) {

		var url = $location.url();
		$scope.activeTab = url.includes('#ordini') ? 3 : 0;

		$scope.baseurl = DataConnectorService.getPreviewBaseUrl();
		$scope.mediabaseurl = DataConnectorService.getMediaBaseUrl();
		$scope.apiurl = DataConnectorService.getBaseUrl();
		$scope.newAddress = {};
		$scope.addressFormShow = false;
		$scope.newCreditCard = {};
		$scope.cardFormShow = false;
		$scope.notification = {
			choice: "now"
		};
		$scope.itemsperpage = 10;
		$scope.filters = {
			orderStatusFilter: 'payment_ok'
		};

		$scope.selectedomaggio = {};

		var hmap, heatmap;

		function fixGapBdate() {
			$scope.utente.bdate = '' + (parseInt($scope.utente.bdate) + 7200);
		}


		$scope.enableAdmin = function () {
			if ($rootScope.userLogged.id == 1) {
				return true;
			} else {
				return false;
			}
		};

		if ($stateParams.id) {
			UtentiService.getUtente($stateParams.id).$promise.then(function (r) {
				console.log("utente", r);

				$scope.utente = r;
				fixGapBdate();
				if (!$scope.utente.country) {
					$scope.utente.country = 'Italia';
				}
				if ($scope.utente.country == 'Italia') {
					getComune();
					getProvincia();
					getCountry();
				}
				if ($scope.utente.parent) {
					UtentiService.getUtente($scope.utente.parent).$promise.then(function (r) {
						$scope.utente.selectedParent = r;
						console.log("sponsor", r);
					});

				}

				if ($scope.utente.ntsrole == "sicurezza") {

					getFutureEvents();
				}



				$scope.drawMap(1);
				getUserEvents();
				getAddress();
				getDevices();
				getCreditCards();
				getCEP();
				getCEPLog();
				getRenewal();
				countFatture();
				getCreditTransactions();
				getShares();
				getViolations();

			}, function (e) {
				console.log(e);

				//TODO gestire errore
			});
		}
		else {
			$scope.utente = { country: 'Italia' };
		}

		$scope.searchCustomers = function (term) {
			if (term && term != '') {
				ContabilitaService.searchCustomers(term).$promise
					.then(function (r) {
						$scope.customers = r.filter(function (item) {
							return item.status == 'ok';
						});

					});
			}
		}

		$scope.drawMap = function (index) {
			console.log('index', index);
			var myLatLng = { lat: $scope.utente.lat, lng: $scope.utente.lng };
			if (document.getElementById('map')) {
				var map = new google.maps.Map(document.getElementById('map'), {
					zoom: 15,
					center: myLatLng
				});

				var marker = new google.maps.Marker({
					position: myLatLng,
					map: map,
					title: $scope.utente.fname + ' ' + $scope.utente
				});
			}
		}



		$scope.migrateToUser = {};

		$scope.migrate = function () {
			$ngConfirm({
				title: 'Attenzione',
				content: 'Sei sicuro di voler migrare i dati di <b>' + $scope.utente.denominazione + '</b> su <b>' + $scope.migrateToUser.selected.denominazione + '</b>',
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Migra",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {
							var postobj = {
								from: $scope.utente.id,
								to: $scope.migrateToUser.selected.id
							}
							UtentiService.migrate(postobj).$promise.then(function (result) {
								Notification.success('Migrazione effettuata con successo');
							}, function (o) {
								Notification.error('Si è verificato un errore ' + (o.data && o.data.msg ? o.data.msg : ''));
							})
						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});
		}

		$scope.deleteOffline = function () {
			$ngConfirm({
				title: 'Attenzione',
				content: "Sei sicuro di voler cancellare i contenuti offline dell'utente al prossimo login?",
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Procedi",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {

							UtentiService.deleteOffline($scope.utente).$promise.then(function (result) {
								Notification.success('Cancellazione contenuti offline avvenuta con successo');
							}, function (o) {
								Notification.error('Si è verificato un errore ' + (o.data && o.data.msg ? o.data.msg : ''));
							})
						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});
		}

		$scope.deleteNote = function (note) {
			$ngConfirm({
				title: 'Attenzione',
				content: "Sei sicuro di voler eliminare questa nota?",
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Procedi",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {

							UtentiService.deleteNote(note).$promise.then(function (result) {
								Notification.success('Nota eliminata');
								$scope.getNotePag($scope.tableStateNote);
							}, function (o) {
								Notification.error('Si è verificato un errore ' + (o.data && o.data.msg ? o.data.msg : ''));
							})
						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});
		}


		$scope.resetImei = function (share) {
			UtentiService.resetImei(share).$promise.then(function (r) {
				getShares();
			}).catch(function (o) {
				Notification.error('Si è verificato un errore ' + (o.data && o.data.msg ? o.data.msg : ''));
				console.log(o);
			});
		};

		$scope.addToBlacklist = function () {
			$ngConfirm({
				title: 'Attenzione',
				content: 'Sei sicuro di voler aggiungere questo utente alla Blacklist?',
				scope: $scope,
				closeIcon: false,
				columnClass: 'col-md-6 col-md-offset-3 col-xs-12',
				buttons: {
					// long hand button definition
					ok: {
						text: "Conferma",
						btnClass: 'btn-primary',
						keys: ['enter'],
						action: function (scope) {
							UtentiService
								.addToBlacklist($scope.utente)
								.$promise
								.then(function (r) {
									$scope.utente = r;
									Notification.success('Utente aggiunto alla blacklist')
								}, function (error) {
									Notification.error(error);
								});
						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});
		}

		$scope.allowResignup = function () {
			$ngConfirm({
				title: 'Attenzione',
				content: 'Sei sicuro di voler permettere a questo utente di reiscriversi?',
				scope: $scope,
				closeIcon: false,
				columnClass: 'col-md-6 col-md-offset-3 col-xs-12',
				buttons: {
					// long hand button definition
					ok: {
						text: "Conferma",
						btnClass: 'btn-primary',
						keys: ['enter'],
						action: function (scope) {
							UtentiService
								.allowNewSignup($scope.utente)
								.$promise
								.then(function (r) {
									$scope.utente = r;
									Notification.success('Operazione effettuata')
								}, function (error) {
									Notification.error(error);
								});
						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});
		}

		$scope.removeFromBlacklist = function () {
			$ngConfirm({
				title: 'Attenzione',
				content: 'Sei sicuro di voler rimuovere questo utente alla Blacklist?',
				scope: $scope,
				closeIcon: false,
				columnClass: 'col-md-6 col-md-offset-3 col-xs-12',
				buttons: {
					// long hand button definition
					ok: {
						text: "Conferma",
						btnClass: 'btn-primary',
						keys: ['enter'],
						action: function (scope) {
							UtentiService
								.removeFromBlacklist($scope.utente)
								.$promise
								.then(function (r) {
									$scope.utente = r;
									Notification.success('Utente rimosso alla blacklist')
								}, function (error) {
									Notification.error(error);
								});
						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});
		}

		getCountries();


		function getCountries() {
			ConstantsService.getCountries().$promise.then(function (r) {
				$scope.countries = r;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		function getCountry() {
			if ($scope.utente.nazionenascita) {
				ConstantsService.getCountryDaDescr($scope.utente.nazionenascita).$promise.then(function (r) {
					if (r && r.length)
						$scope.utente.selectedPaeseNascita = r[0];
				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
		}

		function getViolations() {
			var search = {
				table: 'violation',
				sortfield: 'insdate',
				direction: 'desc',
				simple: [{ field: 'uid', filter: $stateParams.id }]
			}
			EventiService
				.searchViolation(search)
				.$promise
				.then(function (r) {
					$scope.violations = r;

				}, function (err) {
					Notification.error("Si è verificato un errore");
					console.log(err);
				});
		}

		function getUserEvents() {
			UtentiService.getUserEvents($scope.utente.id).$promise.then(function (r) {
				$scope.userEvents = r;
				getFutureEvents();
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		function getCreditTransactions() {
			UtentiService.getCreditTransactions($scope.utente.id).$promise.then(function (r) {
				$scope.credits = r;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		function getShares() {
			UtentiService.getShare($scope.utente.id).$promise.then(function (r) {
				$scope.shares = r;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		function getFutureEvents() {
			EventiService.getFutureEvents().$promise.then(function (r) {
				$scope.futureEvents = r;
				angular.forEach($scope.userEvents, function (assoc) {
					angular.forEach($scope.futureEvents, function (event) {
						if (assoc.eid == event.id) {
							event.removeID = assoc.id;
						}
					})
				})
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		$scope.associa = function (item) {
			UtentiService.createUserEvent({ eid: item.id, uid: $scope.utente.id }).$promise.then(function (r) {
				getUserEvents();
				Notification.success('Evento associato');

			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		$scope.dissocia = function (item) {
			UtentiService.deleteUserEvents(item.removeID).$promise.then(function (r) {
				getUserEvents();
				Notification.success('Evento dissociato');
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		$scope.notification = {};

		$scope.viewEventAccess = function (id) {
			var modalInstance = $uibModal.open({
				templateUrl: 'app/pages/eventi/event-access-modal.html',
				controller: 'EventAccessCtrl',
				size: 'sm',// a controller for modal instance
				resolve: {
					eventid: function () {
						return id;
					}
				} // data passed to the controller
			}).result.then(function (data) {
				//do logic
			}, function () {
				// action on popup dismissal.
			});
		}

		$scope.openNoteDialog = function (note) {
			var modalInstance = $uibModal.open({
				templateUrl: 'app/pages/utenti/note-dialog.html',
				controller: NoteDialogController,
				size: 'lg',// a controller for modal instance
				resolve: {
					note: function () {
						return note;
					}
				} // data passed to the controller
			}).result.then(function (notes) {
				if (notes.id) {
					UtentiService.updateNote(notes).$promise.then(function (r) {
						Notification.success('Nota aggiornata');
						$scope.getNotePag($scope.tableStateNote);
					}, function (e) {
						console.log(e);
						Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
					});
				}
				else {
					notes.uid = $scope.utente.id;
					UtentiService.saveNote(notes).$promise.then(function (r) {
						$scope.getNotePag($scope.tableStateNote);
						Notification.success('Nota creata');

					}, function (e) {
						console.log(e);
						Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
					});
				}
			}, function () {
				// action on popup dismissal.
			});
		}

		$scope.pushNotification = function () {
			$scope.notification.uid = $scope.utente.id;
			UtentiService.pushNotification($scope.notification).$promise.then(function (r) {
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		$scope.removeScheduleDate = function () {
			delete $scope.notification.scheduldate;
		}


		$scope.closeVat = function (ev) {

			var popup = $uibModal.open({
				animation: true,
				controller: CloseVatDialogController,
				templateUrl: 'app/pages/utenti/closeVarDialog.html',
				resolve: {
				},
				size: 'm'

			});


			popup.result.then(function (result) {
				if (result) {
					$scope.utente.vatcloseddate = result;
					UtentiService.vatClose($scope.utente).$promise.then(function (r) {
						console.log('utente', r);
						Notification.success("Partita iva chiusa con successo");
					}, function (e) {
						console.log(e);
						$scope.utente.vatcloseddate = undefined;
						Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
					});
				}
			}, function () {
				// Cancel
				console.log('cancel');
			});
		}

		$scope.showPrivatoDialog = function (ev) {
			if ($scope.utente.privateuser == 1) {
				var popup = $uibModal.open({
					animation: true,
					controller: UtentePrivatoDialogController,
					templateUrl: 'app/pages/utenti/utentePrivatoDialog.html',
					resolve: {
					},
					size: 'm'

				});


				popup.result.then(function (result) {
					if (result) {
						$scope.utente.privateuserdate = result;
						UtentiService.aggiornaUtente($scope.utente).$promise.then(function (r) {
							Notification.success('Utente salvato');
							//$state.go('utenti');
						}, function (e) {
							console.log(e);
							Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
						});
					}
				}, function () {
					// Cancel
					console.log('cancel');
				});
			}
		}




		function getProvincia() {
			if ($scope.utente.province) {
				ConstantsService.getProvinciaDaSigla($scope.utente.province).$promise.then(function (r) {
					if (r && r.length)
						$scope.utente.selectedProvince = r[0];
				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}

			if ($scope.utente.provnascita) {
				ConstantsService.getProvinciaDaSigla($scope.utente.provnascita).$promise.then(function (r) {
					if (r && r.length)
						$scope.utente.selectedProvinciaNascita = r[0];
				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
		}


		function getComune() {
			if ($scope.utente.city) {
				ConstantsService.getComuneDaDescr($scope.utente.city).$promise.then(function (r) {
					if (r && r.length)
						$scope.utente.selectedCity = r[0];
				}, function (e) {
					console.log(e);
					//TODO gestire errore
				});
			}
		}


		function getProvince() {
			ConstantsService.getProvince().$promise.then(function (r) {
				$scope.province = r;
			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		getProvince();

		function getComuni(provincia) {
			if (provincia)
				ConstantsService.getComuni(provincia).$promise.then(function (r) {
					$scope.comuni = r;
				}, function (e) {
					console.log(e);
					//TODO gestire errore
				});
		}


		getTipiAnagrafica();
		getTipiPagamento();
		getCodiciIva();
		getConti();

		function getTipiAnagrafica() {
			ContabilitaService.getTipiAnagrafica().$promise.then(function (r) {
				$scope.tipianagrafica = r;
			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		function getTipiPagamento() {
			ContabilitaService.getTipiPagamento().$promise.then(function (r) {
				$scope.tipipagamento = r;
			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		function getCodiciIva() {
			ContabilitaService.getCodiciIva().$promise.then(function (r) {
				$scope.codiciiva = r;
			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		function getConti() {
			ContabilitaService.getConti().$promise.then(function (r) {
				$scope.conti = r;
			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}


		$scope.searchIncaricato = function (term) {
			UtentiService.cercaIncaricati(term).$promise.then(function (r) {
				$scope.incaricati = r;
			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}



		function getAddress() {
			if ($scope.utente) {
				UtentiService.getUserAddress($scope.utente).$promise.then(function (r) {
					$scope.addressList = r;
				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}

		}


		function getDevices() {
			if ($scope.utente) {
				UtentiService.getDevices($scope.utente.id).$promise.then(function (r) {
					$scope.devices = r;
					console.log(r);
				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}

		}

		function getCreditCards() {
			if ($scope.utente) {
				UtentiService.getCreditCards($scope.utente.id).$promise.then(function (r) {
					$scope.creditCards = r;
					console.log(r);
				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}

		}

		$scope.invoicesTablePageSize = 10;


		$scope.getInvoicedPag = function (tableState) {
			$scope.tableStateInvoices = tableState;
			var pagination = tableState.pagination;

			var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
			var number = pagination.number || 10;  // Number of entries showed per page.
			var stop = start + number;
			var sort = { sortfield: tableState.sort.predicate, direction: tableState.sort.reverse ? 'desc' : 'asc' };
			tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalInvoices / number));//set the number of pages so the pagination can update
			ContabilitaService.getInvoices($scope.utente.conto, start, stop).$promise.then(function (r) {
				$scope.invoices = r;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		function countFatture() {
			var obj = {
				table: "fattura",
				simple: [{ field: 'cliente', filter: $scope.utente.conto }]
			}

			ContabilitaService.getInvoicesCount(obj).$promise.then(function (r) {
				$scope.totalInvoices = r.ct;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		var pushFilter = {
			table: "push",
			simple: [{ field: 'uid', filter: $stateParams.id }],
			direction: 'desc'
		}

		$scope.pushTablePageSize = 10;
		countPush();

		$scope.getPushPag = function (tableState) {
			$scope.tableStatePush = tableState;
			var pagination = tableState.pagination;

			var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
			var number = pagination.number || 10;  // Number of entries showed per page.
			var stop = start + number;
			var sort = { sortfield: tableState.sort.predicate, direction: tableState.sort.reverse ? 'desc' : 'asc' };
			tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalPushNotifications / number));//set the number of pages so the pagination can update
			UtentiService.getPushAdvanced(pushFilter, start, stop).$promise.then(function (r) {
				$scope.pushNotifications = r;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		function countPush() {
			UtentiService.getPushCount(pushFilter).$promise.then(function (r) {
				$scope.totalPushNotifications = r.ct;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}


		var giftFilter = {
			table: "gift",
			simple: [{ field: 'userid', filter: $stateParams.id }],
			direction: 'desc',
			sortfield: 'id'
		}

		$scope.giftTablePageSize = 25;

		$scope.getGift = function (tableState) {
			$scope.tableStateGift = tableState;
			var pagination = tableState.pagination;

			var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
			var number = pagination.number || 10;  // Number of entries showed per page.
			var stop = start + number;
			var sort = { sortfield: tableState.sort.predicate, direction: tableState.sort.reverse ? 'desc' : 'asc' };
			tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalGifts / number));//set the number of pages so the pagination can update
			UtentiService.giftAdvancedSearch(giftFilter, start, stop).$promise.then(function (r) {
				$scope.gifts = r;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		function countGift() {
			UtentiService.giftAdvancedCount(giftFilter).$promise.then(function (r) {
				$scope.totalGifts = r.ct;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		countGift();


		var notefilter = {
			table: "note",
			simple: [{ field: 'uid', filter: $stateParams.id }],
			direction: 'desc'
		}

		$scope.noteTablePageSize = 10;
		countNote();

		$scope.getNotePag = function (tableState) {
			$scope.tableStateNote = tableState;
			var pagination = tableState.pagination;

			var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
			var number = pagination.number || 10;  // Number of entries showed per page.
			var stop = start + number;
			var sort = { sortfield: tableState.sort.predicate, direction: tableState.sort.reverse ? 'desc' : 'asc' };
			tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalNoteNotifications / number));//set the number of pages so the pagination can update
			UtentiService.getNoteAdvanced(notefilter, start, stop).$promise.then(function (r) {
				$scope.notes = r;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		function countNote() {
			UtentiService.getNoteCount(notefilter).$promise.then(function (r) {
				$scope.totalNoteNotifications = r.ct;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}




		var orderfilter = {
			table: "ntsorder",
			simple: [
				{ field: 'uid', filter: $stateParams.id },
				{ field: 'status', filter: $scope.filters.orderStatusFilter },
			],
			sortfield: "purchasedate",
			direction: 'desc'
		};

		$scope.onChangeOrderStatusFilter = function (value) {
			var statusFilterIndex = _.findIndex(orderfilter.simple, function (s) { return s.field == "status" });
			if (statusFilterIndex >= 0) orderfilter.simple.splice(statusFilterIndex, 1);
			if ($scope.filters.orderStatusFilter) orderfilter.simple.push({ field: 'status', filter: $scope.filters.orderStatusFilter });
			$scope.getOrders($scope.tableStateOrders);
		}

		$scope.orderTablePageSize = 50;
		$scope.totalOrderNotifications = 0;
		$scope.tableStateOrders = {};

		$scope.getOrders = function (tableState) {

			$scope.tableStateOrders = tableState;

			var pagination = tableState.pagination;

			var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
			var number = pagination.number || 10;  // Number of entries showed per page.
			var stop = start + number;
			var sort = { sortfield: tableState.sort.predicate, direction: tableState.sort.reverse ? 'desc' : 'asc' };

			var promiseOrders = OrderService.getUserOrdersAdv(orderfilter, start, stop).$promise;
			var promiseOrdersCount = OrderService.getUserOrdersAdvCount(orderfilter).$promise;

			$q.all([promiseOrders, promiseOrdersCount]).then(function (r) {
				$scope.orders = r[0];
				$scope.totalOrderNotifications = r[1].ct;
				// paginazione sballa se totalOrderNotifications è NaN
				tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalOrderNotifications / number));
			}, function (e) {
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}


		function getCEPLog() {
			$scope.loadingLog = true;
			var searchObj = {
				table: 'subscription',
				sortfield: 'id',
				direction: 'desc',
				simple: [{ field: 'uid', filter: $scope.utente.id }]
			}

			UtentiService.subscriptionAdvanced(searchObj).$promise.then(function (r) {
				$scope.cepLogs = r;
				$scope.loadingLog = false;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}


		function getCEP() {
			$scope.loadingcep = true;
			UtentiService.getCEP($scope.utente.id).$promise.then(function (r) {
				$scope.activeceps = r;
				$scope.loadingcep = false;
				$scope.showcep = r.length > 0;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		function getRenewal() {
			UtentiService.getRenewal($scope.utente.id).$promise.then(function (r) {
				$scope.renewals = r;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		$scope.disdettaCep = function (cep) {
			$ngConfirm({
				title: 'Attenzione',
				content: 'Cliccando sul pulsante CONFERMA renderai effettiva la disdetta dell’abbonamento CEP a partire dal mese successivo. Potrai in ogni momento riattivare il programma CEP andando nell’apposita sezione del sito. Network TwentyOne si augura che tu possa aver tratto dei benefici da questo straordinario programma di formazione',
				scope: $scope,
				closeIcon: false,
				columnClass: 'col-md-6 col-md-offset-3 col-xs-12',
				buttons: {
					// long hand button definition
					ok: {
						text: "Conferma",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {
							$scope.loadingcep = true;
							UtentiService
								.cancelCep(cep)
								.$promise
								.then(function (r) {
									$scope.activeceps = r;
									$scope.loadingcep = false;
									getCEP();
									getCEPLog();
								}, function (error) {
									console.log("Errore disdetta CEP", error);
								});
						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});
		}

		$scope.updateFromCF = function (doit) {
			if (doit) {
				$ngConfirm({
					title: 'Attenzione',
					content: 'Vuoi aggiornare i dati automaticamente dal codice fiscale inserito?',
					scope: $scope,
					closeIcon: true,
					buttons: {
						// long hand button definition
						ok: {
							text: "Aggiorna",
							btnClass: 'btn-primary',
							keys: ['enter'], // will trigger when enter is pressed
							action: function (scope) {

								if ($scope.utente.cf) {
									var date = UtilsService.getBdateFromCF($scope.utente.cf);
									if (date) {
										$scope.utente.bdate = parseInt(date.getTime() / 1000);
										fixGapBdate();
									}
									UtilsService.getBcityFromCF($scope.utente.cf).$promise.then(function (r) {
										if (r && r.string.__text) {
											$scope.utente.luogonascita = r.string.__text;
										}
									});
								}
							}
						},
						cancel: {
							text: "Annulla",
							btnClass: 'btn-default',
							action: function (scope) {
								return true;
							}
						}
					},
				});
			}
		}

		$scope.invalidCF = undefined;
		$scope.checkCFValidity = function (params) {
			var element = angular.element(document).find('#cf');

			if (element.hasClass('ng-invalid-cf')) {
				$scope.invalidCF = true;
			} else {
				$scope.invalidCF = false;
				$scope.updateFromCF(params);
			}
		};

		$scope.deviceCheck = function (imei) {
			if (imei) {
				if (imei.includes('-')) {
					return 'android';
				}
				return 'apple';
			}
		}


		$scope.$watch("utente.selectedProvince", function (newValue, oldValue) {

			if (newValue && newValue != oldValue) {
				$scope.utente.province = $scope.utente.selectedProvince.sigla;
				getComuni($scope.utente.selectedProvince.id);
			}
		});

		$scope.$watch("utente.country", function (newValue, oldValue) {

			if (newValue && newValue != oldValue && oldValue) {
				$scope.utente.selectedProvince = {};
				$scope.utente.selectedCity = {};
				$scope.utente.luogonascita = ''
				$scope.utente.cf = undefined;
				$scope.utente.address = undefined;
				$scope.utente.streetno = undefined;
				$scope.utente.zipcode = undefined;
				$scope.utente.zipcode = undefined;
				$scope.utente.province = undefined;
				$scope.utente.city = undefined;
			}
		});


		$scope.resendActivationLink = function () {
			UtentiService.resendActivation($scope.utente).$promise.then(function (response) {
				console.log("Resend Activation", response);
				Notification.success('Email con link di attivazione inviata correttamente');
			}, function (error) {
				console.log("ERROR resend activation", error);
				Notification.error('Errore invio email');
			});
		};



		$scope.salva = function () {

			if ($scope.utente.passwordC) {
				$scope.utente.password = md5.createHash($scope.utente.passwordC);
				$scope.utente.passwordC = undefined;
				$scope.utente.ripetiPassword = undefined;
			}
			if ($scope.utente.selectedCity !== undefined && $scope.utente.selectedCity.descrizione !== undefined) { $scope.utente.city = $scope.utente.selectedCity.descrizione; }
			if ($scope.utente.selectedParent) {
				$scope.utente.parent = $scope.utente.selectedParent.id;
			}
			if ($scope.utente.selectedPaeseNascita) {
				$scope.utente.nazionenascita = $scope.utente.selectedPaeseNascita.name;
			}
			if ($scope.utente.selectedProvinciaNascita && $scope.utente.nazionenascita == 'Italia') {
				$scope.utente.provnascita = $scope.utente.selectedProvinciaNascita.sigla;
			} else {
				$scope.utente.provnascita = '';
			}

			if ($scope.utente.id) {
				console.log($scope.utente);
				UtentiService.aggiornaUtente($scope.utente).$promise.then(function (r) {
					Notification.success('Utente salvato');
					//$state.go('utenti');
				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
			else {
				console.log("$scope.utente", $scope.utente);
				UtentiService.creaUtente($scope.utente).$promise.then(function (r) {
					Notification.success('Utente creato');

					$state.go('modifica-utente', { id: r.id });
				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
		}

		var dictEsito = {};
		dictEsito['REJECTED'] = 'red';
		dictEsito['TOCHECK'] = 'red';
		dictEsito['NOT_DELIVERED'] = 'orange';
		dictEsito['PENDING'] = 'gray';

		$scope.getEsitoColor = function (esito) {
			return dictEsito[esito];
		}

		$scope.leggiNote = function (item, index) {
			$ngConfirm({
				title: 'Note',
				content: item.note,
				scope: $scope,
				closeIcon: true
			});
		}

		$scope.editingAddress = {};

		$scope.modificaIndirizzo = function (address) {
			$scope.editingAddress = address;
			console.log(address.id);
		}

		$scope.salvaIndirizzo = function () {
			UtentiService.modificaIndirizzo($scope.editingAddress).$promise.then(function (r) {
				Notification.success('Indirizzo aggiornato');
				getAddress();
				$scope.editingAddress = {};
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		$scope.eliminaIndirizzo = function (item, index) {

			$ngConfirm({
				title: 'Elimina Indirizzo Spedizione',
				content: 'Sei sicuro di eliminare l\'indirizzo di spedizione <br><b>"' + item.address + '"</b>?',
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Elimina",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {

							UtentiService.eliminaIndirizzo(item).$promise.then(function (r) {
								Notification.success('Indirizzo eliminato');
								getAddress();
							}, function (e) {
								console.log(e);
								Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
							});

						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});
		}

		$scope.eliminaCarta = function (id) {

		}


		$scope.promuoviUtente = function (ev, conf) {

			var popup = $uibModal.open({
				animation: true,
				controller: PromuoviDialogController,
				templateUrl: 'app/pages/utenti/promuovi-dialog.html',
				resolve: {
					utente: function () {
						return $scope.utente;
					}
				}
			});


			popup.result.then(function () {
				loadConf();
			}, function () {
				// Cancel
				console.log('cancel');
			});



		}



		$scope.openTracksDialog = function (ev, shareid) {

			var popup = $uibModal.open({
				animation: true,
				controller: TracksDialogController,
				templateUrl: 'app/pages/utenti/tracks-dialog.html',
				size: "lg",
				resolve: {
					shareid: function () {
						return shareid;
					}
				}
			});


			popup.result.then(function () {
				loadConf();
			}, function () {
				// Cancel
				console.log('cancel');
			});



		}



		$scope.eliminaUtente = function () {

			if (!confirm("Eliminare utente?")) return;

			$scope.utente.status = 'deleted';

			UtentiService.aggiornaUtente($scope.utente).$promise.then(function (r) {
				Notification.success('Utente eliminato');
				$scope.utente = r;
				fixGapBdate();
			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		$scope.bursUtente = function () {

			if (!confirm("Sei sicuro di voler eliminare definitivamente questo utente?")) return;

			$scope.utente.status = 'deleted';

			UtentiService.delete($scope.utente.id).$promise.then(function (r) {
				Notification.success('Utente eliminato definitivamente');
				$scope.utente = r;
				fixGapBdate();
			}, function (e) {
				Notification.error(e.data.msg);
				//TODO gestire errore
			});
		}

		$scope.sospendiUtente = function () {

			if (!confirm("Sospendere utente?")) return;

			$scope.utente.status = 'suspended';

			UtentiService.aggiornaUtente($scope.utente).$promise.then(function (r) {
				Notification.success('Utente sospeso');
				$scope.utente = r;
				fixGapBdate();
			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		$scope.bannaUtente = function () {

			if (!confirm("Espellere utente?")) return;

			$scope.utente.status = 'banned';

			UtentiService.aggiornaUtente($scope.utente).$promise.then(function (r) {
				Notification.success('Utente espulso');
				$scope.utente = r;
				fixGapBdate();
			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		$scope.okUtente = function () {

			if (!confirm("Ripristinare stato utente?")) return;

			$scope.utente.status = 'ok';

			UtentiService.aggiornaUtente($scope.utente).$promise.then(function (r) {
				$scope.utente = r;
				fixGapBdate();
			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		};

		$scope.immagine = {};
		$scope.uploadImmagine = function () {


			if ($scope.immagine && $scope.immagine.file && $scope.utente && $scope.utente.id) {
				UploadService.uploadImage($scope.immagine.file).then(function (resp) {

					Notification.success('Immagine caricata');
					console.log('Success ' + resp.config.data.file.name + ' uploaded. Response: ' + resp.data);
					$scope.utente.profilepic = resp.data.path;
					$scope.salva.apply();
				}, function (resp) {

					Notification.success('Si è verificato un errore');
					console.log('Error status: ' + resp.status);
				}, function (evt) {

					var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				}).catch(function (e) {

					Notification.error('Si è verificato un errore');
					console.log(e);
				});
			}
			else {
				$scope.salva.apply();
			}

		};

		$scope.$watch("newAddress.selectedProvince", function (newValue, oldValue) {

			if (newValue && newValue != oldValue) {
				$scope.newAddress.province = $scope.newAddress.selectedProvince.descrizione;
				$scope.newAddress.selectedCity = {};
				getComuni($scope.newAddress.selectedProvince.id);
			}
		});


		$scope.addressFormShow = false;
		$scope.addAddress = function () {

			if ($scope.newAddress.selectedCity) {
				$scope.newAddress.city = $scope.newAddress.selectedCity.descrizione;
			}
			if ($scope.newAddress.province) {
				$scope.newAddress.province = $scope.newAddress.selectedProvince.descrizione;
			}
			$scope.newAddress.uid = $scope.utente.id;
			UtentiService.addAddress($scope.newAddress).$promise.then(function (r) {
				$scope.newAddress = {};
				getAddress();
				$scope.addressFormShow = false;
			});

		}

		$scope.addCreditCard = function () {
			console.log($scope.newCreditCard);
			/*
			UtentiService.addCreditCard($scope.newCreditCard).$promise.then(function (r) {
				$scope.newCreditCard = {};
				getCreditCards();

			  });*/

		}

		$scope.openCreditGiftDialog = function (ev) {

			var popup = $uibModal.open({
				animation: true,
				controller: GiftDialogController,
				templateUrl: 'app/pages/utenti/credit-dialog.html',
				resolve: {
					utente: function () {
						return $scope.utente;
					}
				},
				size: 'lg'

			});


			popup.result.then(function () {
				loadConf();
			}, function () {
				// Cancel
				console.log('cancel');
			});



		}



		$scope.searchProductPool = function (searchterm) {
			ProductService.giftProductSearchEvo(searchterm).$promise.then(function (r) {
				$scope.productspool = r;
			}, function (e) {
				console.log(e);
			});
		};


		$scope.inviaomaggio = function (pr) {
			if (pr) {
				$ngConfirm({
					title: 'Invio omaggio',
					content: "Confermi l\'invio del prodotto omaggio all\'utente?",
					scope: $scope,
					closeIcon: true,
					buttons: {
						// long hand button definition
						ok: {
							text: "Conferma",
							btnClass: 'btn-primary',
							keys: ['enter'], // will trigger when enter is pressed
							action: function (scope) {
								console.log('omaggio', pr);
								ProductService
									.assignGift($scope.utente.id, $scope.selectedomaggio.product.id)
									.$promise
									.then(function (r) {
										Notification.success('Omaggio inviato con successo');
										$scope.selectedomaggio = {};
									}, function (err) {
										Notification.error(err.data && err.data.msg ? err.data.msg : "Si è verificato un errore");
										console.log(err);
									});
							}
						},
						cancel: {
							text: "Annulla",
							btnClass: 'btn-default',
							action: function (scope) {
								return true;
							}
						}
					},
				});


			}
		}



	}


	function PromuoviDialogController($scope, $uibModalInstance, UtentiService, Notification, utente) {

		if (utente) {
			$scope.utente = utente;

			UtentiService.getSiblings($scope.utente.parent).$promise.then(function (r) {
				console.log(r)
				$scope.siblings = r;

			});

		}


		$scope.cancel = function () {
			$uibModalInstance.dismiss();
		};
		$scope.answer = function (answer) {
			$uibModalInstance.close(answer);
		};

		$scope.salva = function () {
			var figli = _.filter($scope.siblings, function (c) { return c.checked; });

			UtentiService.promuoviUtente($scope.utente, figli).$promise.then(function (r) {
				Notification.success('Utente promosso');

				$scope.answer(r);
			}).catch(function (o) {
				Notification.error('Si è verificato un errore ' + (o.data && o.data.msg ? o.data.msg : ''));
				console.log(o);
			});

		}
	}

	function GiftDialogController($scope, $uibModalInstance, UtentiService, Notification, utente) {


		$scope.gift = {
			expiry: ((new Date()).getTime() / 1000).toFixed(0)
		};
		if (utente) {
			$scope.gift.uid = utente.id;


		}




		$scope.cancel = function () {
			$uibModalInstance.dismiss();
		};
		$scope.answer = function (answer) {
			$uibModalInstance.close(answer);
		};

		$scope.salva = function () {

			UtentiService.giveCredits($scope.gift).$promise.then(function (r) {
				Notification.success('Crediti regalati');
				$scope.answer(r);
			}).catch(function (o) {
				Notification.error('Si è verificato un errore ' + (o.data && o.data.msg ? o.data.msg : ''));
				console.log(o);
			});

		}
	}

	function TracksDialogController($scope, $uibModalInstance, UtentiService, Notification, shareid) {


		function loadTracks() {
			UtentiService.getTracks(shareid).$promise.then(function (r) {
				$scope.tracks = r;
			}).catch(function (o) {
				Notification.error('Si è verificato un errore ' + (o.data && o.data.msg ? o.data.msg : ''));
				console.log(o);
			});
		}

		loadTracks();





		$scope.cancel = function () {
			$uibModalInstance.dismiss();
		};
		$scope.answer = function (answer) {
			$uibModalInstance.close(answer);
		};

		$scope.salva = function () {


		}
	}

	function CloseVatDialogController($scope, $uibModalInstance) {

		$scope.date = {};

		$scope.cancel = function () {
			$uibModalInstance.dismiss();
		};

		$scope.answer = function (answer) {
			$uibModalInstance.close(undefined);
		};

		$scope.salva = function () {

			$uibModalInstance.close($scope.date);
		}
	}

	function UtentePrivatoDialogController($scope, $uibModalInstance) {

		$scope.date = {};

		$scope.cancel = function () {
			$uibModalInstance.dismiss();
		};
		$scope.answer = function (answer) {
			$uibModalInstance.close(undefined);
		};

		$scope.salva = function () {

			$uibModalInstance.close($scope.date);
		}
	}

	function NoteDialogController($scope, $uibModalInstance, note) {

		$scope.note = note;

		$scope.cancel = function () {
			$uibModalInstance.dismiss();
		};
		$scope.answer = function (answer) {
			$uibModalInstance.close(undefined);
		};

		$scope.salva = function () {
			console.log($scope.note);
			$uibModalInstance.close($scope.note);
		}
	}

})();

angular.module('AmwayAdmin.pages.utenti').factory('UtentiService', function (DataConnectorService) {

	var response = {};

	response.getAll = function () {
		var config = { isArray: true };
		return DataConnectorService.getResource('user', {}, config).get();

	}


	response.getUtente = function (id) {

		return DataConnectorService.getResource('user/:id', { id: id }).get();

	}

	response.delete = function (id) {

		return DataConnectorService.getResource('user/full/:id', { id: id }).delete();

	}

	response.getFigliUtente = function (id) {
		var config = { isArray: true };
		return DataConnectorService.getResource('user/subtree/:id', { id: id }, config).get();

	}

	response.getAlberoUtente = function (id) {
		return DataConnectorService.getResource('user/compact/fulltree/:id', { id: id }).get();

    }

    response.addToBlacklist = function (user) {
        var config = { isArray: false };
        return DataConnectorService.getResource('user/blacklist/add', {}, config).post(user);

    }

    response.allowNewSignup = function (user) {
        var config = { isArray: false };
        return DataConnectorService.getResource('user/allow/newsignup', {}, config).post(user);

    }

    response.removeFromBlacklist = function (user) {
        var config = { isArray: false };
        return DataConnectorService.getResource('user/blacklist/remove', {}, config).post(user);

    }


	response.creaUtente = function (user) {
		return DataConnectorService.getResource('user').post(user);

	}


	response.aggiornaUtente = function (user) {
		return DataConnectorService.getResource('user/:id', { id: user.id }, {}).put(user);

	}

	response.modificaIndirizzo = function (address) {
		return DataConnectorService.getResource('address/:id', { id: address.id }, {}).put(address);

	}

	response.eliminaIndirizzo = function (address) {
		return DataConnectorService.getResource('address/:id', { id: address.id }, {}).delete();

	}

	response.getIncaricati = function () {
		var config = { isArray: true };
		return DataConnectorService.getResource('user/filter/ntsrole/incaricato/range/0/10', {}, config).get();

	}




	response.cercaIncaricati = function (term) {
		var config = { isArray: true };
		return DataConnectorService.getResource('user/freesearch/incaricato/0/50', {}, config).post({term: term});

	}

	response.getCountries = function () {
		var config = { isArray: true };
		return DataConnectorService.getResource('country', {}, config).get();

	}

	response.getUserByConto = function(conto) {
		return DataConnectorService
				.getResource('user/filter/conto/:conto/range/0/1', { conto: conto }, { isArray: true })
				.get();
	}

	response.getUserAddress = function(user) {
		return DataConnectorService
				.getResource('address/filter/uid/:uid/range/0/100', { uid: user.id }, { isArray: true })
				.get();
	}



	response.getBonus = function(id, month, year) {
	  return DataConnectorService
	    .getResource('user/bonus/treedetails/:uid/:month/:year', { uid: id, month: month, year: year }, { isArray: true })
	    .get();
	}

	response.getLastBonus = function(id, last) {
	  return DataConnectorService
	    .getResource('user/bonus/:uid/last/:last', { uid: id, last: last }, { isArray: true })
	    .get();

	}

	response.getSiblings = function(parent){
			return DataConnectorService
				.getResource('user/siblings/:uid', { uid: parent }, { isArray: true })
				.get();
	}

	

	response.getDevices = function(uid){
			return DataConnectorService
				.getResource('device/filter/uid/:id/range/0/100', { id: uid }, { isArray: true })
				.get();
	}

	response.promuoviUtente = function (user,figli) {
		return DataConnectorService.getResource('user/promote').post({user: user, children: figli});

	}

	response.addAddress = function (address) {
		return DataConnectorService.getResource('address').post(address);

	}

	response.advancedSearch = function (searchobj, start, stop) {
		return DataConnectorService.getResource('user/advancedsearch/:start/:stop',{start : start, stop : stop},{ isArray: true }).post(searchobj);

    }

	response.giftAdvancedSearch = function (searchobj, start, stop) {
		return DataConnectorService.getResource('gift/advancedsearch/:start/:stop',{start : start, stop : stop},{ isArray: true }).post(searchobj);
    }

	response.giftAdvancedCount = function (searchobj) {
		return DataConnectorService.getResource('gift/advancedcount',{},{ isArray: false }).post(searchobj);
    }
    
    response.subscriptionAdvanced = function (searchobj) {
        return DataConnectorService.getResource('subscription/advancedsearch/0/20', {}, { isArray: true }).post(searchobj);

    }

	response.getPushAdvanced = function (searchobj, start, stop) {
		return DataConnectorService.getResource('push/advancedsearch/:start/:stop',{start : start, stop : stop},{ isArray: true }).post(searchobj);

    }
    
    response.getNoteAdvanced = function (searchobj, start, stop) {
        return DataConnectorService.getResource('note/advancedsearch/:start/:stop', { start: start, stop: stop }, { isArray: true }).post(searchobj);

    }

	response.getPushCount = function (searchobj) {
		return DataConnectorService.getResource('push/advancedcount',{},{ isArray: false }).post(searchobj);

    }
    response.getNoteCount = function (searchobj) {
        return DataConnectorService.getResource('note/advancedcount', {}, { isArray: false }).post(searchobj);

    }

	response.genericSearch = function (searchobj, start, stop) {
		return DataConnectorService.getResource('user/freesearch/:start/:stop',{start : start, stop : stop},{ isArray: true }).post(searchobj);

	}


	response.getFreeSearchCount = function (searchobj) {
		return DataConnectorService.getResource('user/freesearchcount',{},{ isArray: false }).post(searchobj);

	}

	response.getCount = function (searchobj) {
		return DataConnectorService.getResource('user/advancedcount/').post(searchobj);

	}

	response.getCreditCards = function (id) {
		return DataConnectorService.getResource('user/cards/:id',{id:id},{ isArray: true }).get();

	}

	response.addCreditCard = function (card) {
		return DataConnectorService.getResource('user/cards/').post(card);

	}


	response.deleteCreditCard = function (id) {
		return DataConnectorService.getResource('user/cards/:id',{id : id}).delete();

	}


	response.saveNote = function (note) {
		return DataConnectorService.getResource('note/',{}).post(note);

    }

    response.updateNote = function (note) {
        return DataConnectorService.getResource('note/:id', {id: note.id}).put(note);

    }

    response.deleteNote = function (note) {
        return DataConnectorService.getResource('note/:id', { id: note.id }).delete();

    }
    
    response.sendNotification = function (uid, notification) {
        return DataConnectorService.getResource('user/:uid/push', { uid: uid }).post(notification);

    }

	response.broadcastNotification = function (notification) {
		return DataConnectorService.getResource('user/batch/push',{}).post(notification);

	}

	response.resendActivation = function(user) {
		return DataConnectorService.getResource('user/resendactivation', {}).post(user);

	}

	response.getCEP = function(id) {
		var config = { isArray: true };
		return DataConnectorService.getResource('subscription/lastalladmin/:id', {id : id},config).get();

	}

    response.cancelCep = function (subscription) {
	    return DataConnectorService.getResource('subscription/cancel', { }, {isArray: true}).post(subscription);

  	}

  	response.getRenewal = function(uid) {
		var config = { isArray: true };
		return DataConnectorService.getResource('renewal/filter/uid/:uid/range/0/1000', {uid : uid},config).get();

	}

	response.getUserEvents = function(uid) {
		var config = { isArray: true };
		return DataConnectorService.getResource('usertoevent/filter/uid/:uid/range/0/1000', {uid : uid},config).get();

	}

	response.createUserEvent = function(obj) {
		var config = { isArray: false };
		return DataConnectorService.getResource('usertoevent/', {},config).post(obj);

	}

	response.deleteUserEvents = function(id) {
		var config = { isArray: false };
		return DataConnectorService.getResource('usertoevent/:id', {id : id},config).delete();

	}

	response.getCreditTransactions = function(uid) {
		var config = { isArray: true };
		return DataConnectorService.getResource('credittransaction/filter/uid/:uid/range/0/100', {uid : uid},config).get();

	}

	response.giveCredits = function(postObj) {
		var config = { isArray: false };
		return DataConnectorService.getResource('credittransaction', {},config).post(postObj);

	}

	response.getShare = function(uid) {
		var config = { isArray: true };
		return DataConnectorService.getResource('share/filter/uid/:uid/range/0/1000', {uid : uid},config).get();

	}

	response.getTracks = function(shareid) {
		var config = { isArray: true };
		return DataConnectorService.getResource('share/:shareid/tracks', {shareid : shareid},config).get();

	}
	


	response.resetImei = function(share) {
		var config = { isArray: false };
		return DataConnectorService.getResource('share/reset', {},config).post(share);

    }

    response.migrate = function (obj) {
        var config = { isArray: false };
        return DataConnectorService.getResource('user/migrate',  {}, config).post(obj);

    }

    response.deleteOffline = function (obj) {
        var config = { isArray: false };
        return DataConnectorService.getResource('user/deleteoffline', {}, config).post(obj);

    }
    
    response.getHeatmapData = function (id, start, stop) {
        return DataConnectorService.getResource('heatmap/user/:id/:start/:stop', { id: id, start: start, stop: stop }, { isArray: true }).get();
    }

	response.pushNotification = function (notification) {
		return DataConnectorService.getResource('push').post(notification);

	}

	response.vatClose = function (user) {
		return DataConnectorService.getResource('user/vatclose').post(user);

	}

	return response;

});

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('AmwayAdmin.pages.utenti')
		.controller('UtentiListCtrl', UtentiListCtrl);

	/** @ngInject */
	function UtentiListCtrl($scope, $rootScope, UtentiService, $ngConfirm, Notification, $fancyModal, $state, $stateParams, ConstantsService) {

		$scope.type = $stateParams.type;

		$scope.visible = $state.params.all ? 1 : 0;

		$scope.underPaging = false;

		$scope.datePicker = { range: { startDate: null, endDate: null } };

		$scope.sponsor = {};

		$scope.dropped = false;


		if ($scope.type == "sicurezza") {

			$scope.searchObj = {
				table: "user",
				sortfield: "insdate",
				direction: "desc",
				like: [],
				simple: [{ field: 'visible', filter: $scope.visible }, { field: 'ntsrole', filter: "sicurezza" }],
				range: []
				//range : [{field : "insdate", start : 1325458799 , stop:((new Date()).getTime()/1000).toFixed(0)}]
			}
		}
		else if ($scope.type == "blacklist") {
			$scope.searchObj = {
				table: "user",
				sortfield: "insdate",
				direction: "desc",
				like: [],
				simple: [{ field: 'blacklist', filter: 1 }],
				range: []
				//range : [{field : "insdate", start : 1325458799 , stop:((new Date()).getTime()/1000).toFixed(0)}]
			}
		}
		else {
			$scope.searchObj = {
				table: "user",
				sortfield: "insdate",
				direction: "desc",
				like: [],
				simple: [{ field: 'visible', filter: $scope.visible }],
				range: []
				//range : [{field : "insdate", start : 1325458799 , stop:((new Date()).getTime()/1000).toFixed(0)}]
			}
		}

		$scope.notification = {
			msg: "",
			choice: "now",
			uids: []
		};

		$scope.genericObj = {};

		$scope.isGenericSearch = {
			bool: false
		};


		$scope.filter = {};

		var start = 0;
		var stop = 15;
		$scope.itemsPerPage = 15;
		getCount($scope.searchObj);
		//getRange (start,stop);

		$scope.loading = false;


		$scope.advancedExport = function () {
			ConstantsService.advancedExport($scope.searchObj, 'user');
		}

		function getCountries() {
			ConstantsService.getCountries().$promise.then(function (r) {
				$scope.countries = r;
			}, function (e) {
				console.log(e);
				Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
			});
		}

		getCountries();

		function getProvince() {
			ConstantsService.getProvince().$promise.then(function (r) {
				$scope.provinces = r;
			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		getProvince();

		function getRange(start, stop, sort) {
			if (sort) {
				$scope.searchObj.sortfield = sort.sortfield;
				$scope.searchObj.direction = sort.direction;
			}
			$scope.loadingpage = true;
			UtentiService.advancedSearch($scope.searchObj, start, stop).$promise.then(function (r) {
				$scope.displayedUsers = r;
				$scope.loadingpage = false;
			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}


		function loadUsers() {
			UtentiService.getAll().$promise.then(function (r) {
				$scope.utenti = r;

			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		$scope.utentiTablePageSize = 15;
		//  loadUsers();


		$scope.totalItems = 2;

		function getCount(search) {
			return UtentiService.getCount(search, start, stop).$promise.then(function (r) {
				$scope.totalItems = r.ct;

			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		$scope.searchIncaricato = function (term) {
			UtentiService.cercaIncaricati(term).$promise.then(function (r) {
				$scope.incaricati = r;
			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}



		function getFreeSearchCount(search) {
			return UtentiService.getFreeSearchCount(search, start, stop).$promise.then(function (r) {
				$scope.totalItems = r.ct;

			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		$scope.genericSearch = function (start, stop, sort) {

			$scope.loadingpage = true;
			if (sort) {
				$scope.genericObj.sortfield = sort.sortfield;
				$scope.genericObj.direction = sort.direction;
			}

			UtentiService.genericSearch($scope.genericObj, start, stop).$promise.then(function (r) {
				$scope.displayedUsers = r;
				$scope.loadingpage = false;
			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		$scope.search = function () {
			$scope.isGenericSearch.bool = true;
			if ($scope.tableState) {
				$scope.tableState.pagination.start = 0;
				$scope.getData($scope.tableState);
			}
		}

		$scope.getData = function (tableState) {
			$scope.tableState = tableState;


			var pagination = tableState.pagination;

			var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
			var number = pagination.number || 10;  // Number of entries showed per page.
			var stop = start + number;
			var sort = { sortfield: tableState.sort.predicate, direction: tableState.sort.reverse ? 'desc' : 'asc' };
			tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalItems / number));//set the number of pages so the pagination can update


			if (!$scope.isGenericSearch.bool) {
				getRange(start, stop, sort);
				//getCount($scope.searchObj);
				getCount($scope.searchObj).then(function () {
					tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalItems / number));//set the number of pages so the pagination can update

				});

			}
			else {
				$scope.genericSearch(start, stop, sort);
				getFreeSearchCount($scope.genericObj).then(function () {
					tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalItems / number));//set the number of pages so the pagination can update

				});
			}
		}

		function fixSearch() {
			$scope.searchObj.like = [];
			if ($scope.filter.fname)
				$scope.searchObj.like.push({ field: "fname", term: $scope.filter.fname });
			if ($scope.filter.lname)
				$scope.searchObj.like.push({ field: "lname", term: $scope.filter.lname });
			if ($scope.filter.email)
				$scope.searchObj.like.push({ field: "email", term: $scope.filter.email });
			if ($scope.filter.ntsrole)
				$scope.searchObj.like.push({ field: "ntsrole", term: $scope.filter.ntsrole });
			if ($scope.filter.cf)
				$scope.searchObj.like.push({ field: "cf", term: $scope.filter.cf });
			if ($scope.filter.vat)
				$scope.searchObj.like.push({ field: "vat", term: $scope.filter.vat });

			$scope.searchObj.simple = [];
			if ($scope.filter.code) $scope.searchObj.simple.push({ field: "code", filter: $scope.filter.code });
			if ($scope.filter.ntscode) $scope.searchObj.simple.push({ field: "code", filter: $scope.filter.ntscode });
			if ($scope.filter.province) $scope.searchObj.simple.push({ field: "province", filter: $scope.filter.province });
			if ($scope.filter.country) $scope.searchObj.simple.push({ field: "country", filter: $scope.filter.country });
			if ($scope.filter.pec) $scope.searchObj.simple.push({ field: "pec", filter: $scope.filter.pec });
			if ($scope.filter.cf) $scope.searchObj.simple.push({ field: "cf", filter: $scope.filter.cf });
			if ($scope.filter.amwayref) $scope.searchObj.simple.push({ field: "amwayref", filter: $scope.filter.amwayref });
			if ($scope.filter.level) $scope.searchObj.simple.push({ field: "level", filter: $scope.filter.level });
			if ($scope.sponsor.selectedParent) $scope.searchObj.simple.push({ field: "parent", filter: $scope.sponsor.selectedParent.id });
			if ($scope.filter.amwaylevel)
				$scope.searchObj.simple.push({ field: "amwaylevel", filter: $scope.filter.amwaylevel });

			console.log('%c $scope.filter.tcaccepted', 'color:#FFB86C', $scope.filter.tcaccepted);
			if ($scope.filter.tcaccepted) {
				$scope.searchObj.simple.push({ field: "tcaccepted", filter: 1 });
			}

			$scope.searchObj.range = [];
			if ($scope.datePicker.range.startDate && $scope.datePicker.range.endDate) {
				$scope.searchObj.range.push({ field: "insdate", start: ($scope.datePicker.range.startDate._d.getTime() / 1000).toFixed(0), stop: ($scope.datePicker.range.endDate._d.getTime() / 1000).toFixed(0) });
			}
			else if ($scope.datePicker.range.startDate) {
				$scope.searchObj.range.push({ field: "insdate", start: ($scope.datePicker.range.startDate._d.getTime() / 1000).toFixed(0) });;
			}
			else if ($scope.datePicker.range.endDate) {
				$scope.searchObj.range.push({ field: "insdate", stop: ($scope.datePicker.range.endDate._d.getTime() / 1000).toFixed(0) });
			}


		}


		$scope.closeAdvSearch = function () {
			var dropdown = document.querySelector('.advancedsearch');
			dropdown.classList.remove("open");
			var button = document.querySelector('.dropdown-toggle');
			button.setAttribute("aria-expanded", false)
		}

		$scope.applySearch = function () {
			$scope.searchObj = {
				table: "user",
				sortfield: "insdate",
				direction: "desc",
				like: [],
				// simple : [{field: 'visible', filter: $scope.visible}],
				simple: [],
				range: []
				// range : [{field : "insdate", start : 1325458799 , stop:((new Date()).getTime()/1000).toFixed(0)}]
			}
			fixSearch();
			$scope.closeAdvSearch();
			// getCount($scope.searchObj);
			if ($scope.tableState) {
				$scope.tableState.pagination.start = 0;
				$scope.getData($scope.tableState);
			}
		}


		$scope.$watch("filter.country", function (newValue, oldValue) {

			if (newValue && newValue != oldValue) {
				delete $scope.filter.province;
			}
		});



		$scope.delete = function (id) {

			$ngConfirm({
				title: 'Elimina Utente',
				content: "Sei sicuro di eliminare l'utente selezionato?",
				scope: $scope,
				closeIcon: true,
				buttons: {
					// long hand button definition
					ok: {
						text: "Elimina",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function (scope) {
							UtentiService.delete(id).$promise.then(function (r) {
								$scope.utenti = r;
								Notification.success('Utente Eliminato');
								loadUsers();
							}, function (e) {
								console.log(e);
								//TODO gestire errore
							});
						}
					},
					cancel: {
						text: "Annulla",
						btnClass: 'btn-default',
						action: function (scope) {
							return true;
						}
					}
				},
			});
		}

		$scope.pushNotification = function () {
			for (var i = 0; i < $scope.users.length; i++) {
				$scope.notification.uids.push($scope.users[i].id);
			}
			if ($scope.notification.dateformat)
				$scope.notification.date = getDateMillis($scope.notification.dateformat);
			UtentiService.broadcastNotification($scope.notification).$promise.then(function (r) {

			}, function (e) {
				console.log(e);
				//TODO gestire errore
			});
		}

		function getDateMillis(strdate) {
			var dateObject = new Date(strdate);
			return dateObject.getTime() / 1000;
		}

		$scope.openModal = function () {
			$fancyModal.open({ templateUrl: '/app/pages/utenti/notification.html', controller: 'UtentiListCtrl' });
		}

		$scope.getRowColor = function (status) {
			if (status == "ok")
				return;
			if (status == "suspended" || status == "banned")
				return "orange";
			if (status == "deleted")
				return "#FF0000";
		}

		$scope.hidePaging = function () {
			$scope.underPaging = !$scope.underPaging;
		}
	}
})();
angular.module('AmwayAdmin.pages.videos').factory('VideosService', function(DataConnectorService) {

	var response = {};

	response.getAll = function() {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('video', {}, config).get();

	}

	response.getTaxonomies = function() {
		var config = {
			isArray: true
		};
		return DataConnectorService.getResource('videotaxonomy', {}, config).get();

	}


	response.getVideo = function(id) {

		return DataConnectorService.getResource('video/:id', {
			id: id
		}).get();

	}


	response.creaVideo = function(product) {
		return DataConnectorService.getResource('video').post(product);

	}


	response.aggiornaVideo = function(product) {
		return DataConnectorService.getResource('video/:id', {
			id: product.id
		}, {}).put(product);

	}

	response.eliminaVideo = function(videoid) {
		return DataConnectorService.getResource('video/:videoid', {
			videoid: videoid
		}, {}).delete();

	}



	return response;

});

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('AmwayAdmin.pages.videos')
		.controller('VideoCtrl', VideoCtrl);

	/** @ngInject */
	function VideoCtrl($scope, $state, $stateParams, md5, VideosService, VenueService, ConstantsService, DataConnectorService, Notification) {

		$scope.baseurl = DataConnectorService.getPreviewBaseUrl();
		
		function loadVideo() {

			if ($stateParams.id) {
				VideosService.getVideo($stateParams.id).$promise.then(function (r) {
					$scope.video = r;
					console.log(r);
				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
			else {
				$scope.video = {};
			}
		}

		function loadTaxonomies() {

				VideosService.getTaxonomies().$promise.then(function (r) {
					$scope.taxonomies = r;
					console.log(r);
				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
		}

		loadTaxonomies();
		loadVideo();

		$scope.salva = function () {

			if ($scope.video.id) {
				VideosService.aggiornaVideo($scope.video).$promise.then(function (r) {
					loadVideo();
					Notification.success('Salvato');

				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
			else {
				VideosService.creaVideo($scope.video).$promise.then(function (r) {
					    Notification.success('Video salvato');
          				$state.go('modifica-video',{id:r.id});
				}, function (e) {
					console.log(e);
					Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
				});
			}
		}
	}

})();

/**
* @author v.lugovsky
* created on 16.12.2015
*/
(function() {
	'use strict';
	
	angular.module('AmwayAdmin.pages.opens')
	.controller('VideoListCtrl', VideoListCtrl);
	
	/** @ngInject */
	function VideoListCtrl($scope, $ngConfirm, VideosService, ProductService, DataConnectorService, Notification) {
		
		$scope.baseurl= DataConnectorService.getPreviewBaseUrl();
		function loadVideos(){
			VideosService.getAll().$promise.then(function(r) {				
				$scope.videos = r;
				console.log(r);
			}, function(e) {
				console.log(e);
			});
		}

		$scope.itemsPerPage = 10;
		
		loadVideos();
		
		$scope.videosTablePageSize = 10;
		
		$scope.eliminaVideo = function(ev){
			$ngConfirm({
				title: 'Elimina Video',
				content: 'Sei sicuro di eliminare il video '+ev.title+'?',
				scope: $scope,
				closeIcon: true,
				buttons: {   
					// long hand button definition
					ok: { 
						text: "Elimina",
						btnClass: 'btn-primary',
						keys: ['enter'], // will trigger when enter is pressed
						action: function(scope){
							//console.log(ProductService);
							VideosService.eliminaVideo(ev.id).$promise.then(function(r) {	
								Notification.success('Elemento eliminato');			
								loadVideos();
							}, function(e) {
								console.log(e);
							});
							
						}
					},
					cancel: { 
						text: "Annulla",
						btnClass: 'btn-default',
						action: function(scope){
							return true;
						}
					}
				},
			});
		}	
	}
	
})();

/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('AmwayAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
(function () {
	'use strict';

	angular.module('ngPrintBlank')
		.controller('ElPrintCtrl', ElPrintCtrl);

	/** @ngInject */
	function ElPrintCtrl($scope, $filter, $window, ElPrintService) {
		
		$scope.dataset = [];
		$scope.loading = false;

		function addSearchField(conto) {
			conto.codice = conto.codice.substring(0,1) + ' ' + conto.codice.substring(1,3) + ' ' + conto.codice.substring(3);
		}

		if (JSON.parse(ElPrintService.getData('print')) == null) {
			$window.close();
		} else {
			var data = JSON.parse(ElPrintService.getData('print'));	
			console.log("LocalStorage", data);
		}

		var types = data.types;

		$scope.subject = data.subject;
		$scope.tableHeaders = data.table;
		$scope.align = data.align;
		$scope.title = data.post || data.extra || {};

		if ($scope.title.contofrom) $scope.contofrom = ' (' + $scope.title.contofrom + ')';
		if ($scope.title.contoto) $scope.contoto = ' (' + $scope.title.contoto + ')';
		
		var params = {
			api: data.api,
			post: data.post || {},
			isArray: data.isArray || false
		};

		if (data.post != undefined) {
			$scope.loading = true;

			ElPrintService.getCollectionByPost(params).$promise.then(function(response) {
				if (data.onlyPrint) {
					$scope.dataset = response.data.map(function(object) {
						if (data.dare_avere) {
							// edit object
							object.dare = object.segno == 'D' ? object.importo : '';
                            object.avere = object.segno == 'A' ? object.importo : '';
                            
						}

						Object.keys(object).forEach(function(property) {
							if (data.onlyPrint.indexOf(property) > -1
								&& object['ordinamento'] && object['protocollo']
								&& property == 'numprotocollo') {
								
								var splitted = object['ordinamento'].split(object['protocollo']);
								object.numprotocollo = splitted[splitted.length - 1];
							}

							if (data.dare_avere) {
								if (data.onlyPrint.indexOf(property) == -1 && property != 'segno' && property != 'importo') {
									delete object[property];
								}
							} else {
								if (data.onlyPrint.indexOf(property) == -1) {
									delete object[property];
								}
							}
						});
                        if (!object.note || object.note=="" && object.detnote){ 
                            object.note = object.detnote;
                        }
						return object;
					});
					$scope.onlyPrint = data.onlyPrint;
				} else {
					$scope.dataset = response.data;
				}

				if (data.balance == true) {
                    $scope.saldoIniziale = response.saldoprec;
                    createSaldi(response.saldoprec);
                }

				$scope.loading = false;
			}, function(error) {
				console.log("Errore get dati stampa", error);
			});

		} else {
			console.log('partenza');
			$scope.loading = true;
			ElPrintService.getCollectionByGet(params).$promise.then(function(response) {
				if (data.onlyPrint.length > 0) {
					$scope.dataset = response.map(function(object) {
						if (data.dare_avere) {
							// edit object
							object.dare = object.segno == 'D' ? object.importo : '';
							object.avere = object.segno == 'A' ? object.importo : '';
						}
						if (data.addsrc) {
							addSearchField(object);
						}

						Object.keys(object).forEach(function(property) {
							if (data.dare_avere) {
								if (data.onlyPrint.indexOf(property) == -1 && property != 'segno' && property != 'importo') {
									delete object[property];
								}
							} else {
								if (data.onlyPrint.indexOf(property) == -1) {
									delete object[property];
								}
							}
						});

						return object;
					});

					$scope.onlyPrint = data.onlyPrint;
				} else {
					$scope.dataset = response.data;
				}

				if (data.balance == true) {
					createSaldi();
				}
				$scope.loading = false;

			}, function(error) {
				console.log("Errore get dati stampa", error);
			});
		}

		function createSaldi(startValue) {
			angular.forEach($scope.dataset, function(row, key) {
				if (key == 0) {
					if (row.segno == 'D') {
                        $scope.dataset[key].saldo = startValue + row.importo;
					} else if (row.segno == 'A') {
                        $scope.dataset[key].saldo = startValue - row.importo;
					}
				} else if (key > 0) {
					if (Math.sign($scope.dataset[key-1].saldo) < 0) { // saldo elemento precedente negativo
						if (row.segno == 'D') {
							$scope.dataset[key].saldo = row.importo + $scope.dataset[key-1].saldo;
						} else if (row.segno == 'A') {
							$scope.dataset[key].saldo = $scope.dataset[key-1].saldo + -row.importo;
						}
					} else {
						if (row.segno == 'D') {
							$scope.dataset[key].saldo = $scope.dataset[key-1].saldo + row.importo;
						} else if (row.segno == 'A') {
							$scope.dataset[key].saldo = $scope.dataset[key-1].saldo - row.importo;
						}
					}
				}
			});
		}

		function destroyLocalStorage() {
			ElPrintService.deleteData('print');
			console.log('Cleaning LocalStorage...');
		}

		$scope.displayValue = function(value, index) {
			switch (types[index]) {
				case 'date':
					return value ? $filter('date')(value*1000, 'dd/MM/yy') : '';
				case 'string':
					return value ? value : '';
				case 'longtext':
					// return value ? (value.length > 20 ? ($filter('limitTo')(value, 20) + '...') : value) : '';
					return value ? value : '';
				case 'number':
					return value ? value : '';
				case 'boolean':
					return value == 1 ? 'S' : '-';
				case 'price':
					return (value) ? $filter('number')(value/100, 2) : '';
				case 'balance':
					return (value || value == 0) ? $filter('number')(value/100, 2) : '';
				default:
					return value ? value : '';
			}

		};

		$scope.doPrint = function() {
			$window.print();
			destroyLocalStorage();
		};

	}

})();

angular
	.module('ngPrintBlank')
	.factory('ElPrintService', function($window, DataConnectorService) {

	var response = {};

	// elprint localStorage calls
	response.setData = function(name, value) {
		return $window.localStorage && $window.localStorage.setItem(name, value);
	};
	response.getData = function(name) {
		return $window.localStorage && $window.localStorage.getItem(name);	
	};
	response.deleteData = function(name) {
		return $window.localStorage && $window.localStorage.removeItem(name);
	};

	// elprint data calls before print
	response.getCollectionByPost = function(params) {
		var api = params.api;
		var search = params.post;
		config = { isArray: params.isArray || false };
		return DataConnectorService.getResource(api, {}, config).post(search);
	};

	response.getCollectionByGet = function(params) {
		console.log('params', params);
		var api = params.api;
		config = { isArray: params.isArray || false };
		return DataConnectorService.getResource(api, {}, config).get();
	};


	return response;

});
    
       

angular.module('AmwayAdmin.utils').directive('eltable', function ( CollectionService, DataConnectorService, Notification) {
  return {
    scope: {
      entity: '@', 
      edit: '=',
      remove: '=',
      extralinks: '='
    },
    replace: true,
    restrict: 'AE',
    templateUrl: 'app/utils/eltable/eltable.template.html',
   /* link: function (scope, element, attrs, ngModel) { {
     

   },*/
   
  controller: function ($scope, $element, $attrs) {
  
      $scope.baseurl= DataConnectorService.getPreviewBaseUrl();

    //console.log('link');
    $scope.searchobj={entity: $scope.entity};
    //console.log('searchobj',$scope.searchobj);

    $scope.loadCollection = function(tableState){
      // console.log('loadCollection',tableState);
      $scope.tableState=tableState;
      $scope.loading=true;
      var pagination = tableState.pagination;
      

      var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
              var number = pagination.number || 10;  // Number of entries showed per page.
              var stop = start+number;

              
 angular.extend($scope.searchobj, createFilters(tableState.search));

if(tableState.sort && tableState.sort.predicate){
  $scope.searchobj.sortfield=tableState.sort.predicate;
  $scope.searchobj.direction=tableState.sort.reverse ? 'ASC' : 'DESC';
}

      CollectionService.getCollection($scope.searchobj, start, stop).$promise.then(function(r) {
        //console.log(r);
        $scope.collection = r.body;
        if($scope.collection && $scope.collection.length){
                tableState.pagination.numberOfPages = parseInt(Math.ceil(r.totcount/number));//set the number of pages so the pagination can update

          createHeaders(r);
          $scope.loading=false;
        }

      }, function(e) {
        console.log(e);
        //TODO gestire errore
      });
    }

    $scope.createUivalue = function(item, head, index){
      
     
      if(head.type=='object'){
  
        item['ui'+head.key] = {uivalue:[]};
        var tmpobject;
        _.each(head.keys, function(k){
          if(k && k.includes('.')){
        objects =k.split('.');
        if(objects && objects.length){
          tmpobject=$scope.collection[index][objects[0]];            
        }
        for(var j=1; j<objects.length; j++){
          if(tmpobject){
          tmpobject=tmpobject[objects[j]]
          }
        }
        if(tmpobject){
        item['ui'+head.key].uivalue.push(tmpobject);
        }
        }
        else{
          item['ui'+head.key].uivalue.push(item[head.key]);
        }
        });
      }
      
     
    };

    $scope.deleteEntity = function(entity, itemid) {
    	CollectionService.deleteItemInCollection(entity, itemid).$promise.then(function(response) {
    	    console.log(entity + " rimosso correttamente", response);
    	    Notification.success(entity + ' rimosso correttamente');
    	    $scope.loadCollection($scope.tableState);
    	}, function(error) {
    	    console.log("Errore DELETE " + entity, error);
    	    Notification.error('Impossibile cancellare ' + entity);
    	});
    };

    function createHeaders(item){
      $scope.headers=[];
      angular.forEach(item.header, function(value, key){
        var objects, tmpobject;
        if(value.list && value.key!='id'){
            value.keys=value.key.split(',');       
          $scope.headers.push(value);
        }
      });
    }
    

    function createFilters(tablefilters ){

          var filters={like: [], range: [], simple: []};
          if(tablefilters && tablefilters.predicateObject){
          _.each(tablefilters.predicateObject, function(item, key){
              filters.like.push({field: key, term: item});
          });
          }
          return filters;
    }
   
 }
}







});

angular
  .module('AmwayAdmin.utils')
  .directive('amwayPagination', function () {
    return {
      restrict: 'A',
      controller: function($scope, $element, $location) {
        $scope.lastPagesIndex = function() { return $scope.pages.length - 1 };
      }
    }
  });
angular
  .module('AmwayAdmin.utils')
  .directive('amwayPaginationServerSide', function () {
    return {
      restrict: 'E',
      scope: {
        pageSize: '=',
        elements: '='
      },
      templateUrl: 'app/utils/pagination/paginationSize.template.html',
      controller: function($scope, $element, $location) {

      	
        $scope.sizes = [ 10, 25, 50, 100 ];

        $scope.strSize = function(d) {
          return ($scope.elements &&  d);
        }

        $scope.setPagination = function(d) {
          $scope.pageSize = d;
        }

      }
    }
  });
angular
  .module('AmwayAdmin.utils')
  .directive('amwayPaginationSize', function () {
    return {
      restrict: 'E',
      scope: {
        pageSize: '=',
        elements: '='
      },
      templateUrl: 'app/utils/pagination/paginationSize.template.html',
      controller: function($scope, $element, $location) {

        $scope.sizes = [ 10, 25, 50 ];
        $scope.$watch('elements', function() {
          if($scope.elements)
            $scope.sizes = [ 10, 25, 50, 100];
        });

        $scope.strSize = function(d) {
          return ($scope.elements && d);
        }

        $scope.setPagination = function(d) {
        	console.log(d);
          $scope.pageSize = d;
        }

      }
    }
  });
'use strict';

angular
  .module('AmwayAdmin.utils')
  .directive('stripeForm', function(Notification, CardService) {

    return {
      restrict: 'A',
      templateUrl: 'app/utils/stripe/stripe-form.html',
      scope: {
        card: '=stripeForm',
        stripe: '=stripeInstance',
        user: '=stripeUser',
        callback: '&stripeTokenCallback'
      },
      link: function(scope, elem, attrs) {
        var card = scope.card;

        card.mount(elem[0].querySelector('.card-element'));

        card.addEventListener('change', function(evt) {

          scope.stripeError = evt.error? evt.error.message : '';
        });

        scope.loading=true;

			function getNewIntent() {
				CardService.getPaymentIntent(scope.user)
					.$promise.then(function(result) {
						if (result && result.clientsecret) {
							scope.intent = result.clientsecret;
							scope.loading = false;
						}
					});
			}

			getNewIntent();

			scope.submitStripeForm = function() {
				scope.loading = true;
				scope.errormessage = '';
				scope.stripe.handleCardSetup(scope.intent, card).then(function(result) {

					if (result.error) {
						console.log(result.error);
						scope.errormessage = result.error.message;
						scope.loading = false;
						scope.$apply();
						return;
					}
					console.log(result);

					scope.callback({
						token: result.setupIntent.payment_method
					}).then(function() {
						scope.loading = false;
						getNewIntent();
					});
				}, function(err) {
					Notification.error('Errore nell\'inserimento della carta. ' + (err && err.data ? err.data.msg : ''));

				});
			};

        scope.cancelStripeForm =function(){
          scope.callback().then(function(){
             scope.loading=false;
          });
        }
      }
    };
  });
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('AmwayAdmin.contabilita.partiteaperte')
        .controller('PartiteaperteCtrl', PartiteaperteCtrl);

    /** @ngInject */
    function PartiteaperteCtrl($scope, $stateParams, $state, ContabilitaService, $ngConfirm, Notification, ElPrintService, $window) {

        console.log("partiteaperte");
        var startdate;
        var enddate;
    
       
        var postObj ;

        function reset(){
             startdate= (new Date(new Date().getFullYear() -1, 0, 1)).getTime();  // 1/1/annoprecedente
             console.log('startdate', startdate);
         enddate = new Date().getTime() +24*60*60*1000 ;
         console.log('enddate', enddate);
        $scope.partiteaperteTablePageSize = 10;
        $scope.datePicker = {range:{startDate: new Date(startdate), endDate: new Date(enddate)}};
         postObj = {
            tipo : "F",
            start : startdate, //01/01/2012
            stop: ((new Date()).getTime()/1000).toFixed(0)
        };

        }

        reset();
        $scope.loading = false;
        $scope.enablePrint = false;
        $scope.itemsPerPage = 10;


        $scope.searchObj = {tipo : "F"};
        function getPartite (){
            ContabilitaService.getPartiteAperteTipo(postObj).$promise.then(function(r) {	
                $scope.partiteaperte = r;
                console.log("contabilita",r);
                $scope.enablePrint = true;
                $scope.loading = false;
            }, function(e) {
                console.log(e);
            });
        }

        getPartite();

        $scope.adSearch = function (){
        	$scope.loading = true;
        	$scope.enablePrint = false;
            postObj.tipo = $scope.searchObj.tipo;
            if(($scope.datePicker.range.startDate))
                postObj.start = (new Date($scope.datePicker.range.startDate).getTime()/1000).toFixed(0);
            if(($scope.datePicker.range.endDate))
                postObj.stop = (new Date($scope.datePicker.range.endDate).getTime()/1000).toFixed(0);
			
            getPartite();

        };

        $scope.reset = function(){
             reset();
            getPartite();
        };

        $scope.print = function() {

        	var post = angular.copy(postObj);

        	var localStorage = {
        		api: 'contabilita/aperte/'+postObj.tipo+'/'+postObj.start+'/'+postObj.stop,
        		subject: 'Partite Aperte',
        		table: ['Codice', 'Nome', 'Partita', 'Num. fatt.', 'Data fatt.', 'Dare', 'Avere'],
        		onlyPrint: ['conto', 'partnome', 'partita', 'numfatt', 'datafatt', 'dare', 'avere'],
        		types: ['string', 'string','string', 'string', 'date', 'price', 'price'],
        		isArray: true,
        		extra: {
        			datefrom: postObj.start,
        			dateto: postObj.stop
        		}
        	};

        	// save to localStorage
        	ElPrintService.setData('print', JSON.stringify(localStorage));

        	// send to print page
        	$window.open($state.href('print'), '_blank');
        };

    }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
		'use strict';

		angular.module('AmwayAdmin.contabilita.pianoconti')
			.controller('PianocontiListCtrl', PianocontiListCtrl);

		/** @ngInject */
		function PianocontiListCtrl($scope, ContabilitaService, $ngConfirm, Notification, ElPrintService, $window, $state) {
			$scope.enablePrint = false;
             $scope.displayedConti = {};
             $scope.loading = true;
			function loadConti(){
				ContabilitaService.getConti().$promise.then(function(r) {				
					$scope.conti = r;
					console.log(r);
                    $scope.loading = false;
                    $scope.enablePrint = true;
					addSearchField();
				}, function(e) {
					console.log(e);
				});
			}

			loadConti();

			function addSearchField() {
				angular.forEach($scope.conti, function(conto, key) {
					conto.mastrosrc = conto.codice.substring(0,1);
					conto.contosrc = conto.codice.substring(1,3);
					conto.sottocontosrc = conto.codice.substring(3);
				});
			}



            $scope.applyChange = function (tableState){
                $scope.tableState = tableState;
                return true;
                //return (index + 1) + ($scope.currentPage - 1) * $scope.pageSize;
            }

            $scope.getState = function (){
                console.log($scope.tableState);
                return true;
                //return (index + 1) + ($scope.currentPage - 1) * $scope.pageSize;
            }


			$scope.delete = function(id){
				$ngConfirm({
					title: 'Elimina Conto',
					content: "Sei sicuro di eliminare il conto selezionato?",
					scope: $scope,
					closeIcon: true,
					buttons: {
                    // long hand button definition
                    ok: {
                    	text: "Elimina",
                    	btnClass: 'btn-primary',
                        keys: ['enter'], // will trigger when enter is pressed
                        action: function (scope) {
                        	ContabilitaService.deleteConto(id).$promise.then(function(r) {
                        		loadConti();
                        		Notification.success('Conto eliminato');
                        	}, function(e) {
                        		console.log(e);
                                 Notification.error(e.data.msg);
                                });
                        }
                    },
                    cancel: {
                    	text: "Annulla",
                    	btnClass: 'btn-default',
                    	action: function (scope) {
                    		return true;
                    	}
                    }
                },
            });
			}

			$scope.print = function() {

				var localStorage = {
					api: 'conto',
					subject: 'Piano dei conti',
					table: ['Codice', 'Descrizione', 'Gruppo', 'D.Conto', 'D.S.Conto', 'Analisi'],
					onlyPrint: ['codice', 'descrizione', 'gruppo', 'dettconto', 'detsconto', 'analisi'],
					align: ['center', 'left', 'center'],
					types: ['string', 'string', 'string', 'boolean', 'boolean', 'boolean'],
					isArray: true,
					addsrc: true
				};

				// save to localStorage
				ElPrintService.setData('print', JSON.stringify(localStorage));

				// send to print page
				$window.open($state.href('print'), '_blank');
			};

		}
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('AmwayAdmin.contabilita.pianoconti')
		.controller('PianocontiCtrl', PianocontiCtrl);

	/** @ngInject */
	function PianocontiCtrl($scope, $stateParams, $state, ContabilitaService, $ngConfirm, Notification) {


		function loadConto(id) {
			ContabilitaService.getConto(id).$promise.then(function (r) {
				$scope.conto = r;
				$scope.setTipo();
			}, function (e) {
				console.log(e);
			});
		}

		if ($stateParams.id)
			loadConto($stateParams.id);
		else {
			$scope.conto = {};
		}

		$scope.setTipo = function () {
			if (!$scope.conto.tipo) $scope.conto.tipo = $scope.conto.gruppo;
		};

		$scope.salva = function () {
			if ($scope.conto.id) {
				ContabilitaService.updateConto($scope.conto).$promise.then(function (r) {
					$scope.conto = r;
					Notification.success("Conto aggiornato");
					$state.go('contabilita.pianoconti');
				}, function (e) {
					console.log(e);
				});
			}
			else {
				ContabilitaService.addConto($scope.conto).$promise.then(function (r) {
					$scope.conto = r;
					Notification.success("Conto creato");
					$state.go('contabilita.pianoconti');
				}, function (e) {
					console.log(e);
				});
			}
		}

	}
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .controller('BlurFeedCtrl', BlurFeedCtrl);

  /** @ngInject */
  function BlurFeedCtrl($scope) {
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/pages/dashboard/blurFeed/blurFeed.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .service('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .controller('DashboardLineChartCtrl', DashboardLineChartCtrl);

  /** @ngInject */
  function DashboardLineChartCtrl(baConfig, layoutPaths, baUtil) {
    var layoutColors = baConfig.colors;
    var graphColor = baConfig.theme.blur ? '#000000' : layoutColors.primary;
    var chartData = [
      { date: new Date(2012, 11), value: 0, value0: 0 },
      { date: new Date(2013, 0), value: 15000, value0: 19000},
      { date: new Date(2013, 1), value: 30000, value0: 20000},

      { date: new Date(2013, 2), value: 25000, value0: 22000},
      { date: new Date(2013, 3), value: 21000, value0: 25000},
      { date: new Date(2013, 4), value: 24000, value0: 29000},
      { date: new Date(2013, 5), value: 31000, value0: 26000},
      { date: new Date(2013, 6), value: 40000, value0: 25000},
      { date: new Date(2013, 7), value: 37000, value0: 20000},
      { date: new Date(2013, 8), value: 18000, value0: 22000},
      { date: new Date(2013, 9), value: 5000, value0: 26000},
      { date: new Date(2013, 10), value: 40000, value0: 30000},
      { date: new Date(2013, 11), value: 20000, value0: 25000},
      { date: new Date(2014, 0), value: 5000, value0: 13000},

      { date: new Date(2014, 1), value: 3000, value0: 13000},
      { date: new Date(2014, 2), value: 1800, value0: 13000},
      { date: new Date(2014, 3), value: 10400, value0: 13000},
      { date: new Date(2014, 4), value: 25500, value0: 13000},
      { date: new Date(2014, 5), value: 2100, value0: 13000},
      { date: new Date(2014, 6), value: 6500, value0: 13000},
      { date: new Date(2014, 7), value: 1100, value0: 13000},
      { date: new Date(2014, 8), value: 17200, value0: 13000},
      { date: new Date(2014, 9), value: 26900, value0: 13000},
      { date: new Date(2014, 10), value: 14100, value0: 13000},
      { date: new Date(2014, 11), value: 35300, value0: 13000},
      { date: new Date(2015, 0), value: 54800, value0: 13000},
      { date: new Date(2015, 1), value: 49800, value0: 13000}
    ];

    var chart = AmCharts.makeChart('amchart', {
      type: 'serial',
      theme: 'blur',
      marginTop: 15,
      marginRight: 15,
      dataProvider: chartData,
      categoryField: 'date',
      categoryAxis: {
        parseDates: true,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText
      },
      valueAxes: [
        {
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }
      ],
      graphs: [
        {
          id: 'g0',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.3),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value0',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        },
        {
          id: 'g1',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.5),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        }
      ],
      chartCursor: {
        categoryBalloonDateFormat: 'MM YYYY',
        categoryBalloonColor: '#4285F4',
        categoryBalloonAlpha: 0.7,
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5
      },
      dataDateFormat: 'MM YYYY',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      zoomOutButton: {
        backgroundColor: '#fff',
        backgroundAlpha: 0
      },
      zoomOutText: '',
      pathToImages: layoutPaths.images.amChart
    });

    function zoomChart() {
      chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    }

    chart.addListener('rendered', zoomChart);
    zoomChart();
    if (chart.zoomChart) {
      chart.zoomChart();
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .directive('dashboardLineChart', dashboardLineChart);

  /** @ngInject */
  function dashboardLineChart() {
    return {
      restrict: 'E',
      controller: 'DashboardLineChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardLineChart/dashboardLineChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

  /** @ngInject */
  function DashboardCalendarCtrl(baConfig) {
    var dashboardColors = baConfig.colors.dashboard;
    var $element = $('#calendar').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      defaultDate: '2016-03-08',
      selectable: true,
      selectHelper: true,
      select: function (start, end) {
        var title = prompt('Event Title:');
        var eventData;
        if (title) {
          eventData = {
            title: title,
            start: start,
            end: end
          };
          $element.fullCalendar('renderEvent', eventData, true); // stick? = true
        }
        $element.fullCalendar('unselect');
      },
      editable: true,
      eventLimit: true, // allow "more" link when too many events
      events: [
        {
          title: 'All Day Event',
          start: '2016-03-01',
          color: dashboardColors.silverTree
        },
        {
          title: 'Long Event',
          start: '2016-03-07',
          end: '2016-03-10',
          color: dashboardColors.blueStone
        },
        {
          title: 'Dinner',
          start: '2016-03-14T20:00:00',
          color: dashboardColors.surfieGreen
        },
        {
          title: 'Birthday Party',
          start: '2016-04-01T07:00:00',
          color: dashboardColors.gossipDark
        }
      ]
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .directive('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl',
      templateUrl: 'app/pages/dashboard/dashboardCalendar/dashboardCalendar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl(baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var map = AmCharts.makeChart('amChartMap', {
      type: 'map',
      theme: 'blur',
      zoomControl: { zoomControlEnabled: false, panControlEnabled: false },

      dataProvider: {
        map: 'worldLow',
        zoomLevel: 3.5,
        zoomLongitude: 10,
        zoomLatitude: 52,
        areas: [
          { title: 'Austria', id: 'AT', color: layoutColors.primary, customData: '1 244', groupId: '1'},
          { title: 'Ireland', id: 'IE', color: layoutColors.primary, customData: '1 342', groupId: '1'},
          { title: 'Denmark', id: 'DK', color: layoutColors.primary, customData: '1 973', groupId: '1'},
          { title: 'Finland', id: 'FI', color: layoutColors.primary, customData: '1 573', groupId: '1'},
          { title: 'Sweden', id: 'SE', color: layoutColors.primary, customData: '1 084', groupId: '1'},
          { title: 'Great Britain', id: 'GB', color: layoutColors.primary, customData: '1 452', groupId: '1'},
          { title: 'Italy', id: 'IT', color: layoutColors.primary, customData: '1 321', groupId: '1'},
          { title: 'France', id: 'FR', color: layoutColors.primary, customData: '1 112', groupId: '1'},
          { title: 'Spain', id: 'ES', color: layoutColors.primary, customData: '1 865', groupId: '1'},
          { title: 'Greece', id: 'GR', color: layoutColors.primary, customData: '1 453', groupId: '1'},
          { title: 'Germany', id: 'DE', color: layoutColors.primary, customData: '1 957', groupId: '1'},
          { title: 'Belgium', id: 'BE', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Luxembourg', id: 'LU', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Netherlands', id: 'NL', color: layoutColors.primary, customData: '1 213', groupId: '1'},
          { title: 'Portugal', id: 'PT', color: layoutColors.primary, customData: '1 291', groupId: '1'},
          { title: 'Lithuania', id: 'LT', color: layoutColors.successLight, customData: '567', groupId: '2'},
          { title: 'Latvia', id: 'LV', color: layoutColors.successLight, customData: '589', groupId: '2'},
          { title: 'Czech Republic ', id: 'CZ', color: layoutColors.successLight, customData: '785', groupId: '2'},
          { title: 'Slovakia', id: 'SK', color: layoutColors.successLight, customData: '965', groupId: '2'},
          { title: 'Estonia', id: 'EE', color: layoutColors.successLight, customData: '685', groupId: '2'},
          { title: 'Hungary', id: 'HU', color: layoutColors.successLight, customData: '854', groupId: '2'},
          { title: 'Cyprus', id: 'CY', color: layoutColors.successLight, customData: '754', groupId: '2'},
          { title: 'Malta', id: 'MT', color: layoutColors.successLight, customData: '867', groupId: '2'},
          { title: 'Poland', id: 'PL', color: layoutColors.successLight, customData: '759', groupId: '2'},
          { title: 'Romania', id: 'RO', color: layoutColors.success, customData: '302', groupId: '3'},
          { title: 'Bulgaria', id: 'BG', color: layoutColors.success, customData: '102', groupId: '3'},
          { title: 'Slovenia', id: 'SI', color: layoutColors.danger, customData: '23', groupId: '4'},
          { title: 'Croatia', id: 'HR', color: layoutColors.danger, customData: '96', groupId: '4'}
        ]
      },

      areasSettings: {
        rollOverOutlineColor: layoutColors.border,
        rollOverColor: layoutColors.primaryDark,
        alpha: 0.8,
        unlistedAreasAlpha: 0.2,
        unlistedAreasColor: layoutColors.defaultText,
        balloonText: '[[title]]: [[customData]] users'
      },


      legend: {
        width: '100%',
        marginRight: 27,
        marginLeft: 27,
        equalWidths: false,
        backgroundAlpha: 0.3,
        backgroundColor: layoutColors.border,
        borderColor: layoutColors.border,
        borderAlpha: 1,
        top: 362,
        left: 0,
        horizontalGap: 10,
        data: [
          {
            title: 'over 1 000 users',
            color: layoutColors.primary
          },
          {
            title: '500 - 1 000 users',
            color: layoutColors.successLight
          },
          {
            title: '100 - 500 users',
            color: layoutColors.success
          },
          {
            title: '0 - 100 users',
            color: layoutColors.danger
          }
        ]
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/pages/dashboard/dashboardMap/dashboardMap.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

  /** @ngInject */
  function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil) {
    var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    $scope.charts = [{
      color: pieColor,
      description: 'New Visits',
      stats: '57,820',
      icon: 'person',
    }, {
      color: pieColor,
      description: 'Purchases',
      stats: '$ 89,745',
      icon: 'money',
    }, {
      color: pieColor,
      description: 'Active Users',
      stats: '178,391',
      icon: 'face',
    }, {
      color: pieColor,
      description: 'Returned',
      stats: '32,592',
      icon: 'refresh',
    }
    ];

    function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }

    function loadPieCharts() {
      $('.chart').each(function () {
        var chart = $(this);
        chart.easyPieChart({
          easing: 'easeOutBounce',
          onStep: function (from, to, percent) {
            $(this.el).find('.percent').text(Math.round(percent));
          },
          barColor: chart.attr('rel'),
          trackColor: 'rgba(0,0,0,0)',
          size: 84,
          scaleLength: 0,
          animation: 2000,
          lineWidth: 9,
          lineCap: 'round',
        });
      });

      $('.refresh-data').on('click', function () {
        updatePieCharts();
      });
    }

    function updatePieCharts() {
      $('.pie-charts .chart').each(function(index, chart) {
        $(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
      });
    }

    $timeout(function () {
      loadPieCharts();
      updatePieCharts();
    }, 1000);
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .controller('DashboardTodoCtrl', DashboardTodoCtrl);

  /** @ngInject */
  function DashboardTodoCtrl($scope, baConfig) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    var colors = [];
    for (var key in dashboardColors) {
      colors.push(dashboardColors[key]);
    }

    function getRandomColor() {
      var i = Math.floor(Math.random() * (colors.length - 1));
      return colors[i];
    }

    $scope.todoList = [
      { text: 'Check me out' },
      { text: 'Lorem ipsum dolor sit amet, possit denique oportere at his, etiam corpora deseruisse te pro' },
      { text: 'Ex has semper alterum, expetenda dignissim' },
      { text: 'Vim an eius ocurreret abhorreant, id nam aeque persius ornatus.' },
      { text: 'Simul erroribus ad usu' },
      { text: 'Ei cum solet appareat, ex est graeci mediocritatem' },
      { text: 'Get in touch with akveo team' },
      { text: 'Write email to business cat' },
      { text: 'Have fun with blur admin' },
      { text: 'What do you think?' },
    ];

    $scope.todoList.forEach(function(item) {
      item.color = getRandomColor();
    });

    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if (clickPlus || event.which === 13) {
        $scope.todoList.unshift({
          text: $scope.newTodoText,
          color: getRandomColor(),
        });
        $scope.newTodoText = '';
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .directive('dashboardTodo', dashboardTodo);

  /** @ngInject */
  function dashboardTodo() {
    return {
      restrict: 'EA',
      controller: 'DashboardTodoCtrl',
      templateUrl: 'app/pages/dashboard/dashboardTodo/dashboardTodo.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .directive('popularApp', popularApp);

  /** @ngInject */
  function popularApp() {
    return {
      restrict: 'E',
      templateUrl: 'app/pages/dashboard/popularApp/popularApp.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper) {

      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      $scope.doughnutData = {
          labels: [
              'Other',
              'Search engines',
              'Referral Traffic',
              'Direct Traffic',
              'Ad Campaigns'
          ],
          datasets: [
              {
                  data: [2000, 1500, 1000, 1200, 400],
                  backgroundColor: [
                      dashboardColors.white,
                      dashboardColors.blueStone,
                      dashboardColors.surfieGreen,
                      dashboardColors.silverTree,
                      dashboardColors.gossip

                  ],
                  hoverBackgroundColor: [
                      colorHelper.shade(dashboardColors.white, 15),
                      colorHelper.shade(dashboardColors.blueStone, 15),
                      colorHelper.shade(dashboardColors.surfieGreen, 15),
                      colorHelper.shade(dashboardColors.silverTree, 15),
                      colorHelper.shade(dashboardColors.gossip, 15)
                  ],
                  percentage: [87, 22, 70, 38, 17]
              }]
      };

      var ctx = document.getElementById('chart-area').getContext('2d');
      window.myDoughnut = new Chart(ctx, {
          type: 'doughnut',
          data: $scope.doughnutData,
          options: {
              cutoutPercentage: 64,
              responsive: true,
              elements: {
                  arc: {
                      borderWidth: 0
                  }
              }
          }
      });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/dashboard/trafficChart/trafficChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.dashboard')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/pages/dashboard/weather/weather.html'
    };
  }
})();
(function () {
    'use strict';

    angular.module('AmwayAdmin.pages.faq')
        .controller('FaqListCtrl', FaqListCtrl);

    /** @ngInject */
    function FaqListCtrl($scope, $ngConfirm, FaqService, Notification, DataConnectorService) {


        $scope.baseurl = DataConnectorService.getPreviewBaseUrl();
        $scope.faqs = [];
        $scope.faqTablePageSize = 10;
        //$scope.types = FaqService.getTypes();
        loadFaqs();
        loadFaqTypes();

        function loadFaqTypes() {
            FaqService.getTypes().$promise.then(function (r) {
                $scope.types = r;
                console.log('r', r);
            }, function (e) {
                console.log(e);
                Notification.error('Si è verificato un errore');
            });
        }

        function loadFaqs () {
            FaqService.getAll().$promise.then(function (r) {
                    $scope.faqs = r;
                    console.log('r', r);
            }, function (e) {
                console.log(e);
                Notification.error('Si è verificato un errore');
            });
        }

        $scope.delete = function (row) {
            $ngConfirm({
                title: 'Elimina',
                content: "Sei sicuro?",
                scope: $scope,
                closeIcon: true,
                buttons: {
                    // long hand button definition
                    ok: {
                        text: "Conferma",
                        btnClass: 'btn-primary',
                        keys: ['enter'], // will trigger when enter is pressed
                        action: function (scope) {
                            FaqService.delete(row.id).$promise.then(function (r) {
                                Notification.success('Faq eliminata');
                                loadFaqs();
                            }, function (e) {
                                console.log(e);
                                Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
                            });
                        }
                    },
                    cancel: {
                        text: "Annulla",
                        btnClass: 'btn-default',
                        action: function (scope) {
                            return true;
                        }
                    }
                },
            });
        }
    }


})();
(function () {
    'use strict';

    angular.module('AmwayAdmin.pages.faq')
        .controller('NewEditFaqCtrl', NewEditFaqCtrl);

    /** @ngInject */
    function NewEditFaqCtrl($scope, $stateParams, FaqService, Notification, DataConnectorService) {


        $scope.baseurl = DataConnectorService.getPreviewBaseUrl();
        $scope.faq = {};
        $scope.types = FaqService.getTypes();

        if($stateParams.id){
            loadFaqs();
        }

        function loadFaqs() {
            FaqService.get($stateParams.id).$promise.then(function (r) {
                $scope.faq = r;
            }, function (e) {
                console.log(e);
                Notification.error('Si è verificato un errore');
            });
        }

        $scope.submit = function() {
            if(!$scope.faq.id){
                FaqService.post($scope.faq).$promise.then(function (r) {
                    $scope.faq = r;
                    Notification.success('Faq salvata');
                }, function (e) {
                    console.log(e);
                    Notification.error('Si è verificato un errore');
                });
            }
            else {
                FaqService.put($scope.faq).$promise.then(function (r) {
                    $scope.faq = r;
                    Notification.success('Faq aggiornata');
                }, function (e) {
                    console.log(e);
                    Notification.error('Si è verificato un errore');
                });
            }
        }
        
    }


})();
(function () {
    'use strict';

    angular.module('AmwayAdmin.pages.dashboards')
        .controller('DashboardCepCtrl', DashboardCepCtrl);

    /** @ngInject */
    function DashboardCepCtrl($scope, $ngConfirm, DashboardsService, baConfig, colorHelper) {

        $scope.transparent = baConfig.theme.blur;
        $scope.years = [];
        var thisYear = (new Date()).getFullYear();
        for (var year = thisYear; year >= thisYear - 10; year--) {
            $scope.years.push(year);
        }
        $scope.months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        var cepbar, cepPie;
        $scope.cepType = 'pro';
        $scope.cepTypes = {
            'pro' : 'CEP Pro',
            'base': 'CEP Base',
            'all': 'Tutti',
        }

        var today = new Date();
        var defaultDate = new Date();
        defaultDate.setMonth(today.getMonth() - 1);
        $scope.cepPieConf = {
            type : 'pro',
            year: defaultDate.getFullYear(),
            month: defaultDate.getMonth() + 1
        }

        $scope.loading = true;

        var coll = document.getElementsByClassName("collapsible");
        var i;

        for (i = 0; i < coll.length; i++) {
            coll[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var content = this.nextElementSibling;
                if (content.style.display === "block") {
                    content.style.display = "none";
                } else {
                    content.style.display = "block";
                }
            });
        }

        loadCepBar();
        loadCepPie();
        getLastUpdate('cep');


        function getLastUpdate(current) {
            DashboardsService.getLastUpdate().$promise.then(function (result) {
                $scope.lastUpdate = result.filter(function (item) {
                    return item.statype == current;
                })[0].lastupdate;

            }, function (e) {
                console.log(e);
            });
        }

        function loadCepBar() {
            $scope.loading = true;
            DashboardsService.getCepBarchart($scope.cepType).$promise.then(function (result) {
                $scope.cepBarChartStruct = setUpBarStruct(result);
                $scope.loading = false;
                cepbar = drawBar($scope.cepBarChartStruct, 'cep-bar');
            }, function (e) {
                console.log(e);
            });
        }

        function loadCepPie() {
            $scope.loading = true;
            DashboardsService.getCepDetails($scope.cepPieConf.type, $scope.cepPieConf.year, $scope.cepPieConf.month).$promise.then(function (result) {
                $scope.cepPieStruct = setUpStaticCepPieStruct(result);
                $scope.loading = false;
                cepPie = drawPie($scope.cepPieStruct, 'cep-pie');
            }, function (e) {
                console.log(e);
            });
        }

        function setUpBarStruct(stats) {
            var labels = [];
            var datasets = [];
            var cIndex = 0;
            angular.forEach(stats, function (row) {
                labels.push($scope.cepTypes[$scope.cepType] + ' ' + row.month + '/' + row.year);
                angular.forEach(row.values, function (value) {
                    var index = inData(value.key, datasets);
                    if (index == -1) {
                        datasets.push({
                            label: value.key,
                            backgroundColor: DashboardsService.getDefaultColor(cIndex),
                            borderColor: "red",
                            borderWidth: 1,
                            data: [value.val]
                        });
                        cIndex++;
                    }
                    else {
                        datasets[index].data.push(value.val);
                    }
                });
            });

            var barCharData = {
                labels: labels,
                datasets: datasets
            }

            return barCharData;
        }

        function setUpStaticCepPieStruct(obj) {
            var labels = ['Ascolto tra 0% e 25%', 'Ascolto tra 25% e 50%', 'Ascolto tra 50% e 75%', 'Ascolto tra 75% e 100%', 'Non ascoltate'];
            $scope.totPercentListened = (obj.listened / obj.tracks) * 100;
            var datas = [
               // obj.signup,
              //  obj.tracks,
                obj.listened - obj.over25,
                obj.over25 - obj.over50,
                obj.over50 - obj.over75,
                obj.over75,
                obj.tracks - obj.listened
            ];
            var bgColors = [];
            var hvBgColors = [];
            for(var i = 0; i < datas.length; i++){
                var color = DashboardsService.getColor(i);
                bgColors.push(color);
                hvBgColors.push(colorHelper.shade(color, 15));
            }

            var percentages = [
                ((obj.listened - obj.over25)/obj.tracks * 100).toFixed(2),
                ((obj.over25 - obj.over50) / obj.tracks * 100).toFixed(2),
                ((obj.over50 - obj.over75) / obj.tracks * 100).toFixed(2),
                (obj.over75 / obj.tracks * 100).toFixed(2),
                ((obj.tracks - obj.listened) / obj.tracks * 100).toFixed(2)
            ];
            
            $scope.total = obj.tracks;
            $scope.signup = obj.total;

            var struct = {
                labels: labels,
                datasets: [
                    {
                        data: datas,
                        backgroundColor: bgColors,
                        hoverBackgroundColor: hvBgColors,
                        percentage: percentages
                    }]
            }
            return struct;
        }

        function drawBar(chartStruct, tag) {

            var chartOptions = {
                responsive: true,
                title: {
                    display: true,
                    text: "Cep"
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },
                legend: {
                    display: true,
                    position: 'bottom'
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            //console.log('data', data);
                            var label = chartStruct.datasets[tooltipItem.datasetIndex].label + ": ";
                            var value = '' +  tooltipItem.yLabel;
                            value = value.replace('.', ',');
                            value = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                            return (label + value);
                        }
                    }
                }
            }

            var ctx = document.getElementById(tag).getContext('2d');
            return new Chart(ctx, {
                type: "bar",
                data: chartStruct,
                options: chartOptions
            });


        }

        function drawPie(chartStruct, tag) {
            var ctx = document.getElementById(tag).getContext('2d');
            return new Chart(ctx, {
                type: 'doughnut',
                data: chartStruct,
                options: {
                    cutoutPercentage: 64,
                    responsive: true,
                    elements: {
                        arc: {
                            borderWidth: 0
                        }
                    },
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItem, data) {
                                var label = data.labels[tooltipItem.index] + ': '
                                var value = 0;
                                var value = data.datasets[0].data[tooltipItem.index].toFixed(2).replace('.', ',');
                                value = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                                return (label + value);
                            }
                        },
                        responsive: true
                    }
                }
            });
        }

        function inData(key, datas) {
            for (var i = 0; i < datas.length; i++) {
                if (datas[i].label == key)
                    return i;
            }
            return -1;
        }

        $scope.$watch("cepType", function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                cepbar.destroy();
                loadCepBar();
            }
        });

        $scope.refresh = function () {

            cepPie.destroy();
            loadCepPie();
        }
        

    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('AmwayAdmin.pages.dashboards')
        .controller('DashboardEventsCtrl', DashboardEventsCtrl);

    /** @ngInject */
    function DashboardEventsCtrl($scope, $rootScope, $state, $stateParams, DashboardsService, EventiService, ProductService) {

        $scope.eventType = 'wes';
        $scope.eventVenue = {value: 'all'};

        $scope.events = [];
        $scope.additionalEventData = {};
        $scope.selected = {
            price : 0
        };
        $scope.loadingAdditional = true;

        var eventbarFatturato, eventbarNotFatturato, singleEventbar;

        loadEventBar();
        getLastUpdate('event');

        var coll = document.getElementsByClassName("collapsible");
        var i;

        for (i = 0; i < coll.length; i++) {
            coll[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var content = this.nextElementSibling;
                if (content.style.display === "block") {
                    content.style.display = "none";
                } else {
                    content.style.display = "block";
                }
            });
        }

        function getLastUpdate(current) {
            DashboardsService.getLastUpdate().$promise.then(function (result) {
                $scope.lastUpdate = result.filter(function (item) {
                    return item.statype == current;
                })[0].lastupdate;

            }, function (e) {
                console.log(e);
            });
        }

        function loadEventBar() {
            $scope.loading = true;
            DashboardsService.getEventsBarchart($scope.eventType, $scope.eventVenue.value).$promise.then(function (result) {
                $scope.eventBarFatturatoStruct = setUpBarStruct(result, true);
                $scope.eventBarNotFatturatoStruct = setUpBarStruct(result, false);
                $scope.loading = false;
                eventbarFatturato = drawBar($scope.eventBarFatturatoStruct, 'event-bar-fatturato', 'Fatturato / Eventi');
                eventbarNotFatturato = drawBar($scope.eventBarNotFatturatoStruct, 'event-bar-notfatturto', 'Presenze / Eventi');
                
            }, function (e) {
                console.log(e);
            });
        }

        function loadSingleEventBar(id) {
            $scope.loading = true;
            DashboardsService.getSingleEventBarchart(id, $scope.selected.price, $scope.selected.startdate, $scope.selected.stopdate).$promise.then(function (result) {
                $scope.singleEventBarFatturatoStruct = setUpBarStruct(result, false);
                singleEventbar = drawBarAndComulative($scope.singleEventBarFatturatoStruct, 'single-event-comulative', 'Fatturato');
            }, function (e) {
                console.log(e);
            });
        }

        function setUpBarStruct(stats, isFatturato) {
            var labels = [];
            var datasets = [];
            var cIndex = 0;
            angular.forEach(stats, function (row) {
                if (row.label) labels.push(row.label);
                else labels.push(row.month + '/' + row.year);
                angular.forEach(row.values, function (value) {
                    if ((isFatturato && value.key == 'Fatturato') || (!isFatturato && value.key != 'Fatturato')){
                        var index = inData(value.key, datasets)
                        if (index == -1) {
                            datasets.push({
                                label: value.key,
                                backgroundColor: DashboardsService.getDefaultColor(cIndex),
                                borderColor: "red",
                                borderWidth: 1,
                                data: [value.key == 'Fatturato' ? value.val / 100 : value.val ]
                            });
                            cIndex++;
                        }
                        else {
                            datasets[index].data.push(value.key == 'Fatturato' ? value.val / 100 : value.val );
                        }
                    }
                });
            });

            var barCharData = {
                labels: labels,
                datasets: datasets
            }

            return barCharData;

        }


        function inData(key, datas) {
            for (var i = 0; i < datas.length; i++) {
                if (datas[i].label == key)
                    return i;
            }
            return -1;
        }

        function drawBar(chartStruct, tag, title) {

            var chartOptions = {
                responsive: true,
                title: {
                    display: true,
                    text: title
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },
                legend: {
                    display: true,
                    position: 'bottom'
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var label = data.datasets[tooltipItem.datasetIndex].label + ": "
                            var value = '' + ((data.datasets[tooltipItem.datasetIndex].label == 'Fatturato') ? tooltipItem.yLabel.toFixed(2) : tooltipItem.yLabel);
                            value = value.replace('.', ',');
                            value = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                            if (data.datasets[tooltipItem.datasetIndex].label == 'Fatturato') value += ' €'
                            return (label + value);
                        }
                    }
                }
            }

            var ctx = document.getElementById(tag).getContext('2d');
            $rootScope.charjsmy = {
                type: "bar",
                data: chartStruct,
                options: chartOptions
            };
            return new Chart(ctx, {
                type: "bar",
                data: chartStruct,
                options: chartOptions
            });


        }

        function drawBarAndComulative(chartStruct, tag, title) {

            var chartOptions = {
                responsive: true,
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var label = data.datasets[tooltipItem.datasetIndex].label + ": "
                            var value = '' + ((data.datasets[tooltipItem.datasetIndex].label.indexOf('Fatturato') >= 0) ? tooltipItem.yLabel.toFixed(2) : tooltipItem.yLabel);
                            value = value.replace('.', ',');
                            value = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                            if (data.datasets[tooltipItem.datasetIndex].label == 'Fatturato') value += ' €'
                            return (label + value);
                        }
                    }
                },
                elements: {
                    line: {
                        fill: false
                    }
                },
                legend: {
                    display: true,
                    position: 'bottom'
                },
                scales: {
                    xAxes: [{
                        display: true,
                        gridLines: {
                            display: false
                        },
                        labels: {
                            show: true,
                        }
                    }],
                    yAxes: [{
                        type: "linear",
                        display: true,
                        position: "left",
                        id: "y-axis-1",
                        gridLines: {
                            display: false
                        },
                        labels: {
                            show: true,

                        }
                    }, {
                        type: "linear",
                        display: true,
                        position: "right",
                        id: "y-axis-2",
                        gridLines: {
                            display: false
                        },
                        labels: {
                            show: true,

                        }
                    }]
                }
            }

            var ctx = document.getElementById(tag).getContext('2d');

            chartStruct.datasets.push({
                label: "Comulativo",
                type: 'line',
                data: getComulativeData(chartStruct.datasets),
                fill: false,
                backgroundColor: '#71B37C',
                borderColor: '#71B37C',
                hoverBackgroundColor: '#71B37C',
                hoverBorderColor: '#71B37C',
                yAxisID: 'y-axis-1'
            })

            console.log('dd', chartStruct);

            return new Chart(ctx, {
                type: 'bar',
                data: chartStruct,
                options: chartOptions
            });


        }

        function getComulativeData (array){
            console.log('array',array);
            var comulative = [getStackedSum(array, 0)];
            for(var i = 1; i<array[0].data.length; i++){
                comulative.push(comulative[i - 1] + getStackedSum(array, i));
            }
            return comulative;
        }

        function getStackedSum(stack, index) {
            var sum = 0;
            for(var i = 0; i<stack.length; i++) {
                sum += stack[i].data[index];
            }
            return sum;
        }

        $scope.refresh = function () {

            eventbarFatturato.destroy();
            eventbarNotFatturato.destroy();
            loadEventBar();
        }

        $scope.refreshEvent = function () {

            singleEventbar.destroy();
            loadSingleEventBar($scope.selected.event.id);
        }

        $scope.$watch("eventType", function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                $scope.eventVenue = ($scope.eventType == 'wes') ? { value: 'all' } : { value: 'fi1' };
            }
        });

        $scope.$watch("selected.event", function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                if (singleEventbar) singleEventbar.destroy();
                loadPrices(newValue.id);
                loadSingleEventBar(newValue.id);
            }  
        });

        

        function loadPrices(eid) {
            var search = {
                table : 'product',
                simple: [{field: 'eid', filter: eid}],
                sortfield: 'id',
                direction: 'desc'
            }

            ProductService.advancedSearch(search, 0, 1).$promise.then(function (data) {
                $scope.productPrices = [];

                if (data[0].promoprice) $scope.productPrices.push({ key: 'Primo prezzo', value: data[0].promoprice });
                if (data[0].secpromo) $scope.productPrices.push({ key: 'Secondo prezzo', value: data[0].secpromo });
                if (data[0].price) $scope.productPrices.push({key: 'Terzo prezzo', value: data[0].price});
                console.log('price',$scope.productPrices);
            }, function (e) {
                Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
            });

            
        }

        $scope.loadEventTopStats = function (event) {
        	console.log('event', event);
        	$scope.loadingAdditional = true;
        	DashboardsService.getEventTops(event.id).$promise.then(function(data) {
        		$scope.additionalEventData = data;
        		$scope.loadingAdditional = false;
        	}, function(e) {
                Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
            });
        };

        $scope.searchEvents = function(searchterm) {
			EventiService.searchEvents(searchterm).$promise.then(function(response) {
				$scope.events = response;
			});
		};

    }

})();
(function () {
    'use strict';

    angular.module('AmwayAdmin.pages.dashboards')
        .controller('DashboardRangeCtrl', DashboardRangeCtrl);

    /** @ngInject */
    function DashboardRangeCtrl($scope, ProductService, DashboardsService, baConfig, colorHelper, $anchorScroll, $location) {

        $scope.transparent = baConfig.theme.blur;
        $scope.years = [];
        var today = new Date();
        var thisYear = today.getFullYear();
        for(var year = thisYear; year>=thisYear - 10; year --){
            $scope.years.push(year);
        }
        $scope.months = [1,2,3,4,5,6,7,8,9,10,11,12];
        $scope.maxRowsCollapse = 14;

        var maxToClusterProd = $scope.maxRowsCollapse;
        var maxToClusterType = $scope.maxRowsCollapse;

        $scope.typeCollapsed = true;
        $scope.prodCollapsed = true;

        var productPie, typePie, productBar;

        var defaultDate = new Date();
        defaultDate.setMonth(today.getMonth() - 1);
        $scope.prodPieDate = {
            year: defaultDate.getFullYear(),
            month: defaultDate.getMonth() + 1
        }

        $scope.typePieDate = {
            year: defaultDate.getFullYear(),
            month: defaultDate.getMonth() + 1
        }

        var prodData;
        var typeData;
        $scope.productTotal = 0;
        $scope.typeTotal = 0;
        $scope.loadingProd = true;
        $scope.loadingType = true;

        $scope.allProduct = [];
        $scope.selected = {
            product : { name: 'Tutti', id : 0}
        }

        var selldatefrom = new Date();
        selldatefrom.setMonth(defaultDate.getMonth());
        selldatefrom.setDate(1);
        var selldateto = new Date();
        selldateto.setMonth(defaultDate.getMonth() + 1);
        selldateto.setDate(0);
        $scope.dates = {
            from: Math.floor(selldatefrom.getTime() / 1000),
            to: Math.ceil(selldateto.getTime() / 1000),
        }
        $scope.topsellTablePageSize = 10;
        var datesUpdated = true;

        loadProductsPie();
        loadTypesPie();
        getLastUpdate('sales');

        var coll = document.getElementsByClassName("collapsible");
        var i;

        for (i = 0; i < coll.length; i++) {
            coll[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var content = this.nextElementSibling;
                if (content.style.display === "block") {
                    content.style.display = "none";
                } else {
                    content.style.display = "block";
                }
            });
        }

        function getLastUpdate (current){
            DashboardsService.getLastUpdate().$promise.then(function (result) {
                $scope.lastUpdate = result.filter(function(item){
                    return item.statype == current;
                })[0].lastupdate;

            }, function (e) {
                console.log(e);
            });
        }
        
        function loadProductsPie(){
            $scope.loadingProd = true;
            DashboardsService.getProductsDetailRange($scope.dates.from, $scope.dates.to).$promise.then(function (result) {
                prodData = result;
                $scope.prodDataLenght = prodData.length;
                $scope.prodChartStruct = setUpPieStructs(prodData, maxToClusterProd);
                productPie = drawPie($scope.prodChartStruct, 'prod-pie');
                $scope.loadingProd = false;
            }, function (e) {
                console.log(e);
                    $scope.loadingProd = false;
            });
        }

        function loadTypesPie() {
            $scope.loadingType = true;
            DashboardsService.getTypesDetailRange($scope.dates.from, $scope.dates.to).$promise.then(function (result) {
                typeData = result;
                $scope.typeDataLenght = typeData.length;
                $scope.typeChartStruct = setUpPieStructs(typeData, maxToClusterType);
                typePie = drawPie($scope.typeChartStruct, 'type-pie');
                $scope.loadingType = false;
            }, function (e) {
                console.log(e);
                $scope.loadingType = false;
            });
        }

       


        function getTopSellRange(start, stop) {
            $scope.loadingtable = true;
            DashboardsService.getTopSellRange($scope.dates.from, $scope.dates.to, start, stop).$promise.then(function (result) {
                $scope.bestSeller = result;

                $scope.loadingtable = false;
               // console.log('result', $scope.typeBarChartStruct);
            }, function (e) {
                console.log(e);
            });
        }

      

        

        function setUpPieStructs(stats, maxToCluster){
            var labels = [];
            var datas = [];
            var bgColors = [];
            var hvBgColors = [];
            var percentages = [];
            var total = 0;
            angular.forEach(stats, function (row) {
                total += row.revenue;
            });
            var i = 0;
            angular.forEach(stats, function(row){
                if (i < maxToCluster){
                    (row.name) ? labels.push(row.name) : labels.push(row.type);
                    datas.push(row.revenue/100);
                    var bgcolor = DashboardsService.getColor(i);
                    bgColors.push(bgcolor);
                    hvBgColors.push(colorHelper.shade(bgcolor, 15));
                    percentages.push(((row.revenue / total) * 100).toFixed(2));
                }
                else if (i == maxToCluster){
                    labels.push('Altro');
                    datas.push(row.revenue / 100);
                    var bgcolor = DashboardsService.getColor(i);
                    bgColors.push(bgcolor);
                    hvBgColors.push(colorHelper.shade(bgcolor, 15));
                    percentages.push(((row.revenue / total) * 100));
                }
                else {
                    datas[maxToCluster] += row.revenue / 100;
                    percentages[maxToCluster] += ((row.revenue / total) * 100);
                    percentages[maxToCluster] = Math.round(percentages[maxToCluster] * 100) / 100;
                }
                i++;
            });
            var struct = {
                labels: labels,
                datasets: [
                    {
                        data: datas,
                        backgroundColor: bgColors,
                        hoverBackgroundColor: hvBgColors,
                        percentage: percentages
                    }],
                total: total
                
            }
            return struct;
        }


        

        function drawPie(chartStruct, tag){
            var ctx = document.getElementById(tag).getContext('2d');
            return new Chart(ctx, {
                type: 'doughnut',
                data: chartStruct,
                options: {
                    cutoutPercentage: 64,
                    responsive: true,
                    elements: {
                        arc: {
                            borderWidth: 0
                        }
                    },
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItem, data) {
                                var label = data.labels[tooltipItem.index] + ': '
                                var value = 0;
                                var value = data.datasets[0].data[tooltipItem.index].toFixed(2).replace('.', ',');
                                value = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' €';
                                return (label + value);
                            }
                        },
                        responsive: true
                    }
                }
            });
        }

        

        

        $scope.onDatesUpdate = function () {
            datesUpdated = true;
            $scope.tableState.pagination.start = 0;
            $scope.getSellersData($scope.tableState);
            $scope.refresh(0);
            $scope.refresh(1);
        }

        function getTotalBestCount(){
            return DashboardsService.countSellers($scope.dates.from, $scope.dates.to).$promise.then(function (result) {
                $scope.totalBestSellers = result.ct;
            }, function (e) {
                console.log(e);
                $scope.loading = false;
            });
        }

        $scope.getSellersData = function (tableState) {
            $scope.tableState = tableState;


            var pagination = tableState.pagination;

            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.
            var stop = start + number;
            var sort = { sortfield: tableState.sort.predicate, direction: tableState.sort.reverse ? 'desc' : 'asc' };
            tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalItems / number));//set the number of pages so the pagination can update


                getTopSellRange(start, stop);
                //getCount($scope.searchObj);
            if (datesUpdated) {
                datesUpdated = false;
                getTotalBestCount().then(function () {
                    console.log('best', $scope.totalBestSellers);
                    tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalBestSellers / number));//set the number of pages so the pagination can update
                });
            }
            else {
                tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalBestSellers / number));
            }
           

        }

        $scope.refresh = function (index){

            $scope.loading = true;
            switch(index) {
                case 0 : productPie.destroy();
                         loadProductsPie(); 
                         break;
                case 1 : typePie.destroy();
                         loadTypesPie(); 
                         break;
            }
        }

        $scope.collapseExpandPie = function (index) {
            switch (index) {
                case 0:
                    $scope.prodCollapsed = !$scope.prodCollapsed;
                    maxToClusterProd = ($scope.prodCollapsed) ? $scope.maxRowsCollapse : prodData.length;
                    productPie.destroy();
                    $scope.prodChartStruct = setUpPieStructs(prodData, maxToClusterProd);
                    productPie = drawPie($scope.prodChartStruct, 'prod-pie');
                    if ($scope.prodCollapsed) {
                        $location.hash('prodPie');
                        $anchorScroll();
                    }
                    break;
                case 1: 
                    $scope.typeCollapsed = !$scope.typeCollapsed;
                    maxToClusterType = ($scope.typeCollapsed) ? $scope.maxRowsCollapse : typeData.length;
                    typePie.destroy();
                    $scope.typeChartStruct = setUpPieStructs(typeData, maxToClusterType);
                    typePie = drawPie($scope.typeChartStruct, 'type-pie');
                    if ($scope.prodCollapsed) {
                        $location.hash('typePie');
                        $anchorScroll();
                    }
                    break;
            }
            
            //$scope.refresh(0);

        }
        
    }

})();

(function () {
    'use strict';

    angular.module('AmwayAdmin.pages.dashboards')
        .controller('ProvaCtrl', ProvaCtrl);

    /** @ngInject */
    function ProvaCtrl($scope, baConfig, DashboardsService, $rootScope) {

        $scope.eventType = 'wes';
        $scope.eventVenue = { value: 'all' };

        

        loadEventBar();

        function loadEventBar() {
            $scope.loading = true;
            DashboardsService.getEventsBarchart($scope.eventType, $scope.eventVenue.value).$promise.then(function (result) {
                $scope.eventBarFatturatoStruct = setUpBarStruct(result, true);
                //$scope.eventBarNotFatturatoStruct = setUpBarStruct(result, false);
                $scope.loading = false;
                var eventbarFatturato = drawBarAndCumulative($scope.eventBarFatturatoStruct, 'mixed-chart', 'Fatturato / Eventi');
                // eventbarNotFatturato = drawBar($scope.eventBarNotFatturatoStruct, 'canvas', 'Presenze / Eventi');

            }, function (e) {
                console.log(e);
            });
        }


        /* var barChartData = {
            labels: ["January", "February", "March", "April", "May", "June", "July"],
            datasets: [{
                type: 'bar',
                label: "Visitor",
                data: [200, 185, 590, 621, 250, 400, 95],
                fill: false,
                backgroundColor: '#71B37C',
                borderColor: '#71B37C',
                hoverBackgroundColor: '#71B37C',
                hoverBorderColor: '#71B37C',
                yAxisID: 'y-axis-1'
            }, {
                label: "Sales",
                type: 'line',
                data: [51, 65, 40, 49, 60, 37, 40],
                fill: false,
                borderColor: '#EC932F',
                backgroundColor: '#EC932F',
                pointBorderColor: '#EC932F',
                pointBackgroundColor: '#EC932F',
                pointHoverBackgroundColor: '#EC932F',
                pointHoverBorderColor: '#EC932F',
                yAxisID: 'y-axis-2'
            }]
        };*/

        function setUpBarStruct(stats, isFatturato) {
            var labels = [];
            var datasets = [];
            var cIndex = 0;
            angular.forEach(stats, function (row) {
                labels.push('' + row.month + '/' + row.year);
                angular.forEach(row.values, function (value) {
                    if ((isFatturato && value.key == 'Fatturato')) {
                        var index = inData(value.key, datasets)
                        if (index == -1) {
                            datasets.push({
                                label: value.key,
                                backgroundColor: DashboardsService.getDefaultColor(cIndex),
                                borderColor: "red",
                                borderWidth: 1,
                                data: [value.val]
                            });
                            cIndex++;
                        }
                        else {
                            datasets[index].data.push(value.val);
                        }
                    }
                });
            });

            
            var barCharData = {
                labels: labels,
                datasets: datasets
            }

            return barCharData;

        }

        function getComulativeData(datas){
            var cumulative = [];
            cumulative.push(datas[0]);
            for(var i = 1; i<datas.length; i++){
                cumulative.push(datas[i]+cumulative[i-1]);
            }
            return cumulative;
        }


        function inData(key, datas) {
            for (var i = 0; i < datas.length; i++) {
                if (datas[i].label == key)
                    return i;
            }
            return -1;
        }

        function drawBarAndCumulative(chartStruct, tag, title) {

            var chartOptions = {
                responsive: true,
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var label = data.datasets[tooltipItem.datasetIndex].label + ": "
                            var value = '' + ((data.datasets[tooltipItem.datasetIndex].label.indexOf('Fatturato') >=0) ? tooltipItem.yLabel.toFixed(2) : tooltipItem.yLabel);
                            value = value.replace('.', ',');
                            value = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                            if (data.datasets[tooltipItem.datasetIndex].label == 'Fatturato') value += ' €'
                            return (label + value);
                        }
                    }
                },
                elements: {
                    line: {
                        fill: false
                    }
                },
                legend: {
                    display: true,
                    position: 'bottom'
                },
                scales: {
                    xAxes: [{
                        display: true,
                        gridLines: {
                            display: false
                        },
                        labels: {
                            show: true,
                        }
                    }],
                    yAxes: [{
                        type: "linear",
                        display: true,
                        position: "left",
                        id: "y-axis-1",
                        gridLines: {
                            display: false
                        },
                        labels: {
                            show: true,

                        }
                    }, {
                        type: "linear",
                        display: true,
                        position: "right",
                        id: "y-axis-2",
                        gridLines: {
                            display: false
                        },
                        labels: {
                            show: true,

                        }
                    }]
                }
            }

            var ctx = document.getElementById(tag).getContext('2d');

            console.log('chart', chartStruct)
            
            chartStruct.datasets.push({
                label: chartStruct.datasets[0].label + " comulativo",
                type : 'line',
                data: getComulativeData(chartStruct.datasets[0].data),
                fill: false,
                backgroundColor: '#71B37C',
                borderColor: '#71B37C',
                hoverBackgroundColor: '#71B37C',
                hoverBorderColor: '#71B37C',
                yAxisID: 'y-axis-1'
            })

            console.log('dd', chartStruct);

            return new Chart(ctx, {
                type: 'bar',
                data: chartStruct,
                options: chartOptions
            });


        }

       /* var barChartData = {
            labels: ["January", "February", "March", "April", "May", "June", "July"],
            datasets: [{
                type: 'bar',
                label: "Visitor",
                data: [200, 185, 590, 621, 250, 400, 95],
                fill: false,
                backgroundColor: '#71B37C',
                borderColor: '#71B37C',
                hoverBackgroundColor: '#71B37C',
                hoverBorderColor: '#71B37C',
                yAxisID: 'y-axis-1'
            }, {
                label: "Sales",
                type: 'line',
                data: [51, 65, 40, 49, 60, 37, 40],
                fill: false,
                borderColor: '#EC932F',
                backgroundColor: '#EC932F',
                pointBorderColor: '#EC932F',
                pointBackgroundColor: '#EC932F',
                pointHoverBackgroundColor: '#EC932F',
                pointHoverBorderColor: '#EC932F',
                yAxisID: 'y-axis-2'
            }]
        };


        
    


    $scope.$on('$viewContentLoaded', function () {
        var ctx = document.getElementById("canvas").getContext("2d");
        window.myBar = new Chart(ctx, {
            type: 'bar',
            data: barChartData,
            options: {
                responsive: true,
                tooltips: {
                    mode: 'label'
                },
                elements: {
                    line: {
                        fill: false
                    }
                },
                scales: {
                    xAxes: [{
                        display: true,
                        gridLines: {
                            display: false
                        },
                        labels: {
                            show: true,
                        }
                    }],
                    yAxes: [{
                        type: "linear",
                        display: true,
                        position: "left",
                        id: "y-axis-1",
                        gridLines: {
                            display: false
                        },
                        labels: {
                            show: true,

                        }
                    }, {
                        type: "linear",
                        display: true,
                        position: "right",
                        id: "y-axis-2",
                        gridLines: {
                            display: false
                        },
                        labels: {
                            show: true,

                        }
                    }]
                }
            }
        });
    
    }
        
)*/
}
    

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
	'use strict';

	angular.module('AmwayAdmin.pages.dashboards')
		.controller('DashboardNewUsersCtrl', DashboardNewUsersCtrl);

	/** @ngInject */
	function DashboardNewUsersCtrl($scope, $state, $stateParams, UtentiService, DataConnectorService, Notification) {

		$scope.users = [];

		var today = Math.round((new Date()).getTime() / 1000);
		var threedaysago = today - (72 * 3600);

		$scope.searchObj = {
			table: "user",
			sortfield: "insdate",
			direction: "desc",
			like: [],
			simple: [{
				field: 'status',
				filter: 'ok'
			}],
			range: [{
				field: "insdate",
				start: threedaysago,
				stop: today
			}]
		}

		var start = 0;
		var stop = 15;
		$scope.itemsPerPage = 15;
		$scope.utentiTablePageSize = 15;
		getCount($scope.searchObj);

		function getRange(start, stop, sort) {
			if (sort) {
				$scope.searchObj.sortfield = sort.sortfield;
				$scope.searchObj.direction = sort.direction;
			}
			$scope.loadingpage = true;
			UtentiService.advancedSearch($scope.searchObj, start, stop).$promise.then(function(r) {
				$scope.displayedUsers = r;
				$scope.loadingpage = false;
			}, function(e) {
                Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
            });
		}

		function getCount(search) {
			return UtentiService.getCount(search, start, stop).$promise.then(function(r) {
				$scope.totalItems = r.ct;
			}, function(e) {
                Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
            });
		}

		$scope.getData = function(tableState) {
			$scope.tableState = tableState;
			var pagination = tableState.pagination;
			var start = pagination.start || 0; // This is NOT the page number, but the index of item in the list that you want to use to display the table.
			var number = pagination.number || 10; // Number of entries showed per page.
			var stop = start + number;
			var sort = {
				sortfield: tableState.sort.predicate,
				direction: tableState.sort.reverse ? 'desc' : 'asc'
			};
			tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalItems / number)); //set the number of pages so the pagination can update

			getRange(start, stop, sort);
			getCount($scope.searchObj).then(function() {
				tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalItems / number)); //set the number of pages so the pagination can update
			});

		}

	}

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
	'use strict';

	angular.module('AmwayAdmin.pages.dashboards')
		.controller('DashboardTracksCtrl', DashboardTracksCtrl);

	/** @ngInject */
	function DashboardTracksCtrl($scope, $state, $stateParams, DashboardsService, Notification) {

		$scope.tracks = [];
		$scope.tracksTablePageSize = 30;
        $scope.loading = true;


        getLastUpdate('track');
        loadTracks();
        
        function getLastUpdate(current) {
            DashboardsService.getLastUpdate().$promise.then(function (result) {
                $scope.lastUpdate = result.filter(function (item) {
                    return item.statype == current;
                })[0].lastupdate;

            }, function (e) {
                console.log(e);
            });
        }

		function loadTracks() {

			DashboardsService.getTracks().$promise.then(function(data) {
				$scope.tracks = data;
				$scope.loading = false;
			}, function(e) {
                Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
            });
		}

	}

})();
(function () {
    'use strict';

    angular.module('AmwayAdmin.pages.dashboards')
        .controller('DashboardUtentiCtrl', DashboardUtentiCtrl);

    /** @ngInject */
    function DashboardUtentiCtrl($scope, DashboardsService, baConfig, colorHelper, $location, $anchorScroll, $document, $timeout) {

        var userMap, revenueMap, userHeatmap, revenueHeatmap;
        var start = new Date();
        start.setFullYear(2020, 0,1);
        $scope.heatmapRange = {
            start: Math.floor(start.getTime() / 1000),
            stop: Math.ceil(new Date().getTime() / 1000)
        }

        $scope.currentTab = 0;


        /* Data points defined as an array of LatLng objects */
        $scope.refreshHeatmaps = function () {
           /* $scope.currentTab = tab;
            switch(tab) {
                case 0: loadUserHeatmap(); break;
                case 1: loadRevenueHeatmap(); break;
            }*/

            loadUserHeatmap();
            loadRevenueHeatmap();

        }

        $scope.refreshBounds = function (tab) {
            $scope.currentTab = tab;
            switch (tab) {
                case 0: $scope.fitBounds(userMap, $scope.userbounds); break;
                case 1: $scope.fitBounds(revenueMap, $scope.revenuebounds); break;
            }
        }


        $scope.refreshHeatmaps();

        function loadUserHeatmap() {
            DashboardsService.getUserHeatmapData($scope.heatmapRange.start, $scope.heatmapRange.stop).$promise.then(function (result) {
                var struct = getHeatmapStruct(result);
                $scope.userbounds = struct.bounds;

                console.log('struct', struct);

                if (!userMap) {
                    userMap = drawMap(struct, 'userMap');
                    if (struct.data.length > 0)
                        userHeatmap = setValues(struct.data, userMap, userHeatmap);
                        $scope.fitBounds(userMap, $scope.userbounds);
                }
                else {
                   userHeatmap = setValues(struct.data, userMap, userHeatmap);
                    $scope.fitBounds(userMap, $scope.userbounds);
                }

            }, function (e) {
                console.log(e);
                Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
            });
        }

        function loadRevenueHeatmap() {
            DashboardsService.getRevenueHeatmapData($scope.heatmapRange.start, $scope.heatmapRange.stop).$promise.then(function (result) {
                var struct = getHeatmapStruct(result);
                $scope.revenuebounds = struct.bounds;

                if (!revenueMap) {
                    revenueMap = drawMap(struct, 'revenueMap');
                    if(struct.data.length > 0)
                        revenueHeatmap = setValues(struct.data, revenueMap, revenueHeatmap);
                }
                else {
                    revenueHeatmap = setValues(struct.data, revenueMap, revenueHeatmap);
                    $scope.fitBounds(revenueMap, $scope.revenuebounds);
                }

            }, function (e) {
                console.log(e);
                Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
            });
        }

        function getHeatmapStruct(data) {
            var struct = {
                data: []
            };

            if (data.length > 0) {
                struct.bounds = new google.maps.LatLngBounds();
                angular.forEach(data, function (item) {
                    var loc = new google.maps.LatLng(item.lat, item.lng);
                    struct.data.push({ location: loc, weight: item.weight });
                    struct.bounds.extend(loc);
                });
            }
            else {
                var rome = { lat: 41.90, lng: 12.49 };
                struct.center = rome;
            }
            return struct;
        }

        function drawMap(struct, mapID) {

            var map = new google.maps.Map($document[0].getElementById(mapID), {
                mapTypeId: 'satellite',
            });

            if (struct.data.length <= 0) {
                map.setCenter(new google.maps.LatLng(struct.center.lat, struct.center.lng));
                map.setZoom(6);
            }

            return map;
        }


        function setValues(data, map, heatmap) {
            if (!!heatmap && !!heatmap.setMap)
                heatmap.setMap(null);
            heatmap = new google.maps.visualization.HeatmapLayer({
                data: data
            });
            heatmap.setMap(map); 
            return heatmap;
            
        }

        $scope.fitBounds = function (map, bounds) {
            $timeout(function () {
                if (bounds){
                    map.fitBounds(bounds);
                }
                else {
                    var rome = { lat: 41.90, lng: 12.49 };
                    map.setCenter(new google.maps.LatLng(rome.lat, rome.lng));
                    map.setZoom(6);
                }
            }, 100);
        }

        

        
       
    }

})();

(function () {
    'use strict';

    angular.module('AmwayAdmin.pages.dashboards')
        .controller('DashboardVenditeCtrl', DashboardVenditeCtrl);

    /** @ngInject */
        function DashboardVenditeCtrl($scope, ProductService, DashboardsService, baConfig, colorHelper, $location, $anchorScroll) {

        $scope.transparent = baConfig.theme.blur;
        $scope.years = [];
        var today = new Date();
        var thisYear = today.getFullYear();
        for(var year = thisYear; year>=thisYear - 10; year --){
            $scope.years.push(year);
        }
        $scope.months = [1,2,3,4,5,6,7,8,9,10,11,12];
        $scope.maxRowsCollapse = 14;

        var maxToClusterProd = $scope.maxRowsCollapse;
        var maxToClusterType = $scope.maxRowsCollapse;

        $scope.typeCollapsed = true;
        $scope.prodCollapsed = true;

        var productPie, typePie, productBar;

        var defaultDate = new Date();
        defaultDate.setMonth(today.getMonth() - 1);
        $scope.prodPieDate = {
            year: defaultDate.getFullYear(),
            month: defaultDate.getMonth() + 1
        }

        $scope.typePieDate = {
            year: defaultDate.getFullYear(),
            month: defaultDate.getMonth() + 1
        }

        var prodData;
        var typeData;
        $scope.productTotal = 0;
        $scope.typeTotal = 0;
        $scope.loadingProd = true;
        $scope.loadingType = true;

        $scope.allProduct = [];
        $scope.selected = {
            product : { name: 'Tutti', id : 0}
        }

        var selldatefrom = new Date();
        selldatefrom.setMonth(defaultDate.getMonth());
        selldatefrom.setDate(1);
        var selldateto = new Date();
        selldateto.setMonth(defaultDate.getMonth() + 1);
        selldateto.setDate(0);
        $scope.sellersDates = {
            from: Math.floor(selldatefrom.getTime() / 1000),
            to: Math.ceil(selldateto.getTime() / 1000),
        }
        $scope.topsellTablePageSize = 10;
        var datesUpdated = true;

        loadProductsPie();
        loadTypesPie();
        loadProductsBar(0);
        loadTypesBar();
        //loadTopSell();
        loadAllProducts();
        getLastUpdate('sales');

        var coll = document.getElementsByClassName("collapsible");
        var i;

        for (i = 0; i < coll.length; i++) {
            coll[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var content = this.nextElementSibling;
                if (content.style.display === "block") {
                    content.style.display = "none";
                } else {
                    content.style.display = "block";
                }
            });
        }

        function getLastUpdate (current){
            DashboardsService.getLastUpdate().$promise.then(function (result) {
                $scope.lastUpdate = result.filter(function(item){
                    return item.statype == current;
                })[0].lastupdate;

            }, function (e) {
                console.log(e);
            });
        }
        
        function loadProductsPie(){
            $scope.loadingProd = true;
            DashboardsService.getProductsDetail($scope.prodPieDate.month, $scope.prodPieDate.year).$promise.then(function (result) {
                prodData = result;
                $scope.prodDataLenght = prodData.length;
                $scope.prodChartStruct = setUpPieStructs(prodData, maxToClusterProd);
                productPie = drawPie($scope.prodChartStruct, 'prod-pie');
                $scope.loadingProd = false;
            }, function (e) {
                console.log(e);
                $scope.loadingProd = false;
            });
        }

        function loadTypesPie() {
            $scope.loadingType = true;
            DashboardsService.getTypesDetail($scope.typePieDate.month, $scope.typePieDate.year).$promise.then(function (result) {
                typeData = result;
                $scope.typeDataLenght = typeData.length;
                $scope.typeChartStruct = setUpPieStructs(typeData, maxToClusterType);
                typePie = drawPie($scope.typeChartStruct, 'type-pie'); 
                $scope.loadingType = false;
            }, function (e) {
                console.log(e);
                $scope.loadingType = false;
            });
        }

        function loadProductsBar(id) {
            $scope.loading = true;
            DashboardsService.getProductBarchart(id).$promise.then(function (result) {
                $scope.productBarChartStruct = setUpBarStruct(result);
                productBar = drawBar($scope.productBarChartStruct, 'product-bar', 'Fatturato / Unità');
                $scope.loading = false;
            }, function (e) {
                console.log(e);
                $scope.loading = false;
            });
        }

        $scope.loadProductBar = function (selected) {
            if (productBar)
                productBar.destroy();
            loadProductsBar(selected.description.id);
        }

        function loadTypesBar() {
            $scope.loading = true;
            DashboardsService.getTypeBarchart().$promise.then(function (result) {
                $scope.typeBarChartStruct = setUpBarStruct(result);
                drawStacked($scope.typeBarChartStruct, 'type-bar', 'Fatturato / Tipo');
            }, function (e) {
                console.log(e);
                $scope.loading = false;
            });
        }

        function getTopSellRange(start, stop) {
            $scope.loadingtable = true;
            DashboardsService.getTopSellRange($scope.sellersDates.from, $scope.sellersDates.to, start, stop).$promise.then(function (result) {
                $scope.bestSeller = result;

                $scope.loadingtable = false;
               // console.log('result', $scope.typeBarChartStruct);
            }, function (e) {
                console.log(e);
            });
        }

        function loadAllProducts() {
            $scope.loading = true;
            ProductService.getAll().$promise.then(function (result) {
                result.push({ id: 0, name: 'Tutti' })
                result.map(function(item){
                    item.searchfield = item.name + ' - ' + item.sku;
                })
                $scope.allProducts = result;

            }, function (e) {
                console.log(e);
                $scope.loading = false;
            });
        }

        

        function setUpPieStructs(stats, maxToCluster){
            var labels = [];
            var datas = [];
            var bgColors = [];
            var hvBgColors = [];
            var percentages = [];
            var total = 0;
            angular.forEach(stats, function (row) {
                total += row.revenue;
            });
            var i = 0;
            angular.forEach(stats, function(row){
                if (i < maxToCluster){
                    (row.name) ? labels.push(row.name) : labels.push(row.type);
                    datas.push(row.revenue/100);
                    var bgcolor = DashboardsService.getColor(i);
                    bgColors.push(bgcolor);
                    hvBgColors.push(colorHelper.shade(bgcolor, 15));
                    percentages.push(((row.revenue / total) * 100).toFixed(2));
                }
                else if (i == maxToCluster){
                    labels.push('Altro');
                    datas.push(row.revenue / 100);
                    var bgcolor = DashboardsService.getColor(i);
                    bgColors.push(bgcolor);
                    hvBgColors.push(colorHelper.shade(bgcolor, 15));
                    percentages.push(((row.revenue / total) * 100));
                }
                else {
                    datas[maxToCluster] += row.revenue / 100;
                    percentages[maxToCluster] += ((row.revenue / total) * 100);
                    percentages[maxToCluster] = Math.round(percentages[maxToCluster] * 100) / 100;
                }
                i++;
            });
            var struct = {
                labels: labels,
                datasets: [
                    {
                        data: datas,
                        backgroundColor: bgColors,
                        hoverBackgroundColor: hvBgColors,
                        percentage: percentages
                    }],
                total: total
                
            }
            return struct;
        }

        function setUpBarStruct(stats) {
            var labels = [];
            var datasets = [];
            var cIndex = 0;
            angular.forEach(stats, function (row) {
                labels.push('' + row.month + '/' + row.year);
                angular.forEach(row.values, function (value) {
                    var index = inData(value.key, datasets)
                    if(index == -1){
                        datasets.push({
                            label: value.key,
                            backgroundColor: DashboardsService.getDefaultColor(cIndex),
                            borderColor: "red",
                            borderWidth: 1,
                            data: [value.key == 'Unità' ? value.val : value.val / 100]
                        });
                        cIndex ++;
                    }
                    else{
                        datasets[index].data.push(value.key == 'Unità' ? value.val : value.val / 100);
                    }
                });
            });

            var barCharData = {
                labels : labels,
                datasets: datasets
            }

            console.log('dataaaaa', barCharData);

            return barCharData;

        }


        function inData(key, datas) {
            for (var i = 0; i < datas.length; i++) {
                if (datas[i].label == key)
                    return i;
            }
            return -1;
        }

        

        function drawPie(chartStruct, tag){
            var ctx = document.getElementById(tag).getContext('2d');
            return new Chart(ctx, {
                type: 'doughnut',
                data: chartStruct,
                options: {
                    cutoutPercentage: 64,
                    responsive: true,
                    elements: {
                        arc: {
                            borderWidth: 0
                        }
                    },
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItem, data) {
                                var label = data.labels[tooltipItem.index] + ': '
                                var value = 0;
                                var value = data.datasets[0].data[tooltipItem.index].toFixed(2).replace('.', ',');
                                value = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' €';
                                return (label + value);
                            }
                        },
                        responsive: true
                    }
                }
            });
        }

        function drawBar(chartStruct, tag, title) {

            var chartOptions = {
                responsive: true,
                title: {
                    display: true,
                    text: title
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },
                legend: {
                    display: true,
                    position: 'bottom'
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var label = (tooltipItem.datasetIndex == 0) ? 'Fatturato: ' : 'Unità: ';
                            var value = '' + ((tooltipItem.datasetIndex == 0) ? tooltipItem.yLabel.toFixed(2) : tooltipItem.yLabel);
                            value = value.replace('.',',');
                            value = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                            if ( tooltipItem.datasetIndex == 0 ) value += ' €'
                            return (label + value);
                        }
                    }
                }
            }


            var ctx = document.getElementById(tag).getContext('2d');

            

            return new Chart(ctx, {
                type: "bar",
                data: chartStruct,
                options: chartOptions
            });

            


        }

        function drawStacked(chartStruct, tag, title) {

            var chartOptions = {
                responsive: true,
                title: {
                    display: true,
                    text: title
                },
                scales: {
                    xAxes: [{ stacked: true }],
                    yAxes: [{ stacked: true }]
                },
                legend: {
                    display: true,
                    position: 'bottom'
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var label = data.datasets[tooltipItem.datasetIndex].label + ': '
                            var value = tooltipItem.yLabel.toFixed(2).replace('.', ',');
                            value = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' €';
                            return (label + value);
                        }
                    }
                }
            }


            var ctx = document.getElementById(tag).getContext('2d');
            window.myStacked = new Chart(ctx, {
                type: "bar",
                data: chartStruct,
                options: chartOptions
            });


        }

        $scope.onSellersDatesUpdate = function () {
            datesUpdated = true;
            $scope.tableState.pagination.start = 0;
            $scope.getSellersData($scope.tableState);
        }

        function getTotalBestCount(){
            return DashboardsService.countSellers($scope.sellersDates.from, $scope.sellersDates.to).$promise.then(function (result) {
                $scope.totalBestSellers = result.ct;
            }, function (e) {
                console.log(e);
                $scope.loading = false;
            });
        }

        $scope.getSellersData = function (tableState) {
            $scope.tableState = tableState;


            var pagination = tableState.pagination;

            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.
            var stop = start + number;
            var sort = { sortfield: tableState.sort.predicate, direction: tableState.sort.reverse ? 'desc' : 'asc' };
            tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalItems / number));//set the number of pages so the pagination can update


                getTopSellRange(start, stop);
                //getCount($scope.searchObj);
            if (datesUpdated) {
                datesUpdated = false;
                getTotalBestCount().then(function () {
                    console.log('best', $scope.totalBestSellers);
                    tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalBestSellers / number));//set the number of pages so the pagination can update
                });
            }
            else {
                tableState.pagination.numberOfPages = parseInt(Math.ceil($scope.totalBestSellers / number));
            }
           

        }

        $scope.refresh = function (index){

            $scope.loading = true;
            switch(index) {
                case 0 : productPie.destroy();
                         loadProductsPie(); 
                         break;
                case 1 : typePie.destroy();
                         loadTypesPie(); 
                         break;
            }
        }

        $scope.collapseExpandPie = function (index) {
            switch (index) {
                case 0:
                    $scope.prodCollapsed = !$scope.prodCollapsed;
                    maxToClusterProd = ($scope.prodCollapsed) ? $scope.maxRowsCollapse : prodData.length;
                    productPie.destroy();
                    $scope.prodChartStruct = setUpPieStructs(prodData, maxToClusterProd);
                    productPie = drawPie($scope.prodChartStruct, 'prod-pie');
                    if ($scope.prodCollapsed) {
                        $location.hash('prodPie');
                        $anchorScroll();
                    }
                    break;
                case 1: 
                    $scope.typeCollapsed = !$scope.typeCollapsed;
                    maxToClusterType = ($scope.typeCollapsed) ? $scope.maxRowsCollapse : typeData.length;
                    typePie.destroy();
                    $scope.typeChartStruct = setUpPieStructs(typeData, maxToClusterType);
                    typePie = drawPie($scope.typeChartStruct, 'type-pie');
                    if ($scope.typeCollapsed) {
                        $location.hash('typePie');
                        $anchorScroll();
                    }
                    break;
            }
            
            //$scope.refresh(0);

        }
        
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
	'use strict';

	angular.module('AmwayAdmin.pages.dashboards')
		.controller('DashboardSharesCtrl', DashboardSharesCtrl);

	/** @ngInject */
	function DashboardSharesCtrl($scope, $state, $stateParams, DashboardsService, Notification, baConfig, colorHelper) {

		$scope.topstats = [];
		$scope.tracksList = [];
		$scope.selectedTrack = 'all';

        var chart;
        
        loadTopStats();
        loadTracksList();
        getLastUpdate('share');

		$scope.searchTrack = function(event) {
			var postObj = { title: event ? event : $scope.selectedTrack };
			DashboardsService.postShareBarChart(postObj).$promise.then(function(data) {
				console.log('postShareBarChart', data);
				if (chart) { chart.destroy(); }
                drawBar(setUpBarStruct(data), 'product-bar');
			}, function(e) {
                Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
            });
        };
        
        function getLastUpdate(current) {
            DashboardsService.getLastUpdate().$promise.then(function (result) {
                $scope.lastUpdate = result.filter(function (item) {
                    return item.statype == current;
                })[0].lastupdate;

            }, function (e) {
                console.log(e);
            });
        }

		function loadTopStats() {
			DashboardsService.getShareTops().$promise.then(function(data) {
				$scope.topstats = data;
			}, function(e) {
                Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
            });
		}
		function loadTracksList() {
			DashboardsService.getShareTracks().$promise.then(function(data) {
				$scope.tracksList = data.titles;
				$scope.searchTrack();
			}, function(e) {
                Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
            });
		}

		

		function inData(key, datas) {
            for (var i = 0; i < datas.length; i++) {
                if (datas[i].label == key)
                    return i;
            }
            return -1;
        }

		function setUpBarStruct(stats) {
                var labels = [];
                var datasets = [];
                var cIndex = 0;
                angular.forEach(stats, function (row) {
                    labels.push('' + row.month + '/' + row.year);
                    angular.forEach(row.values, function (value) {
                        var index = inData(value.key, datasets);
                        if(index == -1){
                            datasets.push({
                                label: value.key,
                                backgroundColor: DashboardsService.getDefaultColor(cIndex),
                                borderColor: "red",
                                borderWidth: 1,
                                data: [value.val]
                            });
                            cIndex ++;
                        }
                        else{
                            datasets[index].data.push(value.val);
                        }
                    });
                });
            


            var barCharData = {
                labels : labels,
                datasets: datasets
            }

            return barCharData;

        }

		function drawBar(chartStruct, tag) {

            var chartOptions = {
                responsive: true,
                title: {
                    display: true,
                    text: ''
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },
                legend: {
                    display: true,
                    position: 'bottom'
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                        	var label = data.datasets[tooltipItem.datasetIndex].label + ': ';
                            var value = '' + tooltipItem.yLabel;
                            return (label + value);
                        }
                    }
                }
            }

            console.log('tag', tag);
            var ctx = document.getElementById(tag).getContext('2d');
            chart = new Chart(ctx, {
                type: "bar",
                data: chartStruct,
                options: chartOptions
            });


        }

	}

})();
(function () {
    'use strict';

    angular.module('AmwayAdmin.pages.faq')
        .controller('FaqTypeListCtrl', FaqTypeListCtrl)
        .controller('FaqtypeNewEditCtrl', FaqtypeNewEditCtrl);

    /** @ngInject */
    function FaqTypeListCtrl($scope, $ngConfirm, FaqService, Notification, DataConnectorService, $uibModal) {


        $scope.baseurl = DataConnectorService.getPreviewBaseUrl();
        $scope.types = [];
        $scope.faqspagesize = 10;
        loadFaqTypes();

        function loadFaqTypes () {
            FaqService.getTypes().$promise.then(function (r) {
                    $scope.types = r;
                    console.log('r', r);
            }, function (e) {
                console.log(e);
                Notification.error('Si è verificato un errore');
            });
        }

        $scope.neweditFaqtype = function (type) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/pages/faqtype/faqtype-newedit-modal/faqtype-newedit-modal.html',
                controller: 'FaqtypeNewEditCtrl',
                size: 'lg',// a controller for modal instance
                resolve: {
                    faqtype: function () {
                        return type;
                    }
                } // data passed to the controller
            }).result.then(function (type) {
                if(!type.id) {
                    FaqService.newType(type).$promise.then(function (r) {
                       loadFaqTypes();
                        Notification.success('Nuovo tipo FAQ creato');
                    }, function (e) {
                        console.log(e);
                        Notification.error('Si è verificato un errore');
                    });
                }
                else {
                    FaqService.updateType(type).$promise.then(function (r) {
                        Notification.success('Tipo FAQ aggiornato');
                        loadFaqTypes();
                    }, function (e) {
                        console.log(e);
                            Notification.error('Tipo FAQ aggiornato');
                    });
                }
            }, function () {
                // action on popup dismissal.
            });
        }

        $scope.delete = function (row) {
            $ngConfirm({
                title: 'Elimina',
                content: "Sei sicuro?",
                scope: $scope,
                closeIcon: true,
                buttons: {
                    // long hand button definition
                    ok: {
                        text: "Conferma",
                        btnClass: 'btn-primary',
                        keys: ['enter'], // will trigger when enter is pressed
                        action: function (scope) {
                            FaqService.deleteType(row).$promise.then(function (r) {
                                Notification.success('Tipo FAQ eliminata');
                                loadFaqTypes();
                            }, function (e) {
                                console.log(e);
                                Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
                            });
                        }
                    },
                    cancel: {
                        text: "Annulla",
                        btnClass: 'btn-default',
                        action: function (scope) {
                            return true;
                        }
                    }
                },
            });
        }
    }
    function FaqtypeNewEditCtrl($scope, $uibModalInstance, faqtype) {
        

        $scope.faqtype = angular.copy(faqtype);


        $scope.submit = function() {
            $scope.close($scope.faqtype);
        }

        $scope.dismiss = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.close = function (item) {
            $uibModalInstance.close(item);
        };
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.venue')
      .controller('VenueListCtrl', VenueListCtrl);

  /** @ngInject */
  function VenueListCtrl($scope, VenueService, $ngConfirm) {
    $scope.loading = true;
  	function loadItems (){
	  	VenueService.getAll().$promise.then(function(r) {
	  		$scope.venues = r;
	          console.log(r);
            $scope.loading = false;

	        }, function(e) {
	          console.log(e);
	          Notification.error('Si è verificato un errore');
	          //TODO gestire errore
	        });
  	}

  	$scope.venueTablePageSize = 10;

  	loadItems();

  	$scope.delete = function (id){
  		$ngConfirm({
        title: 'Elimina Prodotto',
        content: 'Sei sicuro di eliminare questo elemento?',
        scope: $scope,
        closeIcon: true,
        buttons: {
          // long hand button definition
          ok: {
            text: "Elimina",
            btnClass: 'btn-primary',
            keys: ['enter'], // will trigger when enter is pressed
            action: function (scope) {
              console.log('elimina');
              //DataConnectorService.delete('product/:id', { id: pr.id }).then(function (r) {
              VenueService.deleteItem(id).$promise.then(function(r) {
                Notification.success('Elemento eliminato'); 
			  		   loadItems();
			          console.log(r);

		        }, function(e) {
			          console.log(e);
			          Notification.error('Si è verificato un errore');
			          //TODO gestire errore
		        });

            }
          },
          cancel: {
            text: "Annulla",
            btnClass: 'btn-default',
            action: function (scope) {
              return true;
            }
          }
        },
      });

		
  	}
}


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.pages.venue')
      .controller('VenueCtrl', VenueCtrl);

  /** @ngInject */
  function VenueCtrl($scope, $state, $stateParams, VenueService, Notification, ConstantsService, $document, $timeout) {

      var venueID = $stateParams.id;
      var map, heatmap;

  	if(venueID){
  		VenueService.getItem(venueID).$promise.then(function(r) {
            $scope.venue = r;
            
            var start = new Date();
            start.setMonth(0, 1);
            $scope.heatmapRange = {
                start: Math.floor(start.getTime()/1000),
                stop: Math.ceil(new Date().getTime()/1000)
            }
            loadVenueHeatmap();

        }, function(e) {
          console.log(e);
          Notification.error('Si è verificato un errore');
          //TODO gestire errore
        });
  	}
  	else{
  		$scope.venue = {};
      }
      
      $scope.refreshHeatmap = function () {
          loadVenueHeatmap();
      }

      function loadVenueHeatmap() {
          VenueService.getHeatmapData($scope.venue.id, $scope.heatmapRange.start, $scope.heatmapRange.stop).$promise.then(function (result) {
              var struct = getHeatmapStruct(result);
              $scope.bounds = struct.bounds;

              if (!map) {
                  drawMap(struct);
              }
              else {
                  setValues(struct.data);

                  $scope.fitBounds();
              }

          }, function (e) {
              console.log(e);
              Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
          });
      }

      function getHeatmapStruct(data) {
          var struct = {
              data: []
          };

          if(data.length){
            struct.bounds = new google.maps.LatLngBounds();
            angular.forEach(data, function (item) {
                var loc = new google.maps.LatLng(item.lat, item.lng);
                struct.data.push({ location: loc, weight: item.weight });
                struct.bounds.extend(loc);
            });
          }
          else {
              var rome = { lat: 41.90, lng: 12.49};
              struct.center = rome;
          }
          return struct;
      }

      function drawMap(struct) {
          var center = new google.maps.LatLng(struct.center.lat, struct.center.lng);

          map = new google.maps.Map($document[0].getElementById('map'), {
              center: center,
              mapTypeId: 'satellite',

          });

          if(struct.data.length > 0)
            setValues(struct.data);
          else
              map.setZoom(6);
      }

      function setValues(data) {
          if (!!heatmap && !!heatmap.setMap)
              heatmap.setMap(null);
          heatmap = new google.maps.visualization.HeatmapLayer({
              data: data
          });
          heatmap.setMap(map);
      }

      $scope.fitBounds = function () {
          $timeout(function () {
              if ($scope.bounds)
                  map.fitBounds($scope.bounds);
              else {
                  var rome = { lat: 41.90, lng: 12.49 };
                  map.setCenter(new google.maps.LatLng(rome.lat, rome.lng));
                  map.setZoom(6);
              }
          }, 100);
      }

    function getProvincia() {
      if ($scope.utente.province) {
        ConstantsService.getProvinciaDaDescr($scope.utente.province).$promise.then(function (r) {
          if (r && r.length)
            $scope.utente.selectedProvince = r[0];
        }, function (e) {
          console.log(e);
          //TODO gestire errore
        });
      }
    }


    function getComune() {
      if ($scope.utente.city) {
        ConstantsService.getComuneDaDescr($scope.utente.city).$promise.then(function (r) {
          if (r && r.length)
            $scope.utente.selectedCity = r[0];
        }, function (e) {
          console.log(e);
          //TODO gestire errore
        });
      }
    }

    function getProvince() {
      ConstantsService.getProvince().$promise.then(function (r) {
        $scope.province = r;
      }, function (e) {
        console.log(e);
        //TODO gestire errore
      });
    }

    getProvince();

    function getComuni(provincia) {
      ConstantsService.getComuni(provincia).$promise.then(function (r) {
        $scope.comuni = r;
      }, function (e) {
        console.log(e);
        //TODO gestire errore
      });
    }

    $scope.$watch("venue.selectedProvince", function (newValue, oldValue) {

      if (newValue && newValue != oldValue) {
        $scope.venue.province = $scope.venue.selectedProvince.descrizione;
        getComuni($scope.venue.selectedProvince.id);
      }
    });

    $scope.salva = function (){
      if ($scope.venue.selectedCity)
      { $scope.venue.city = $scope.venue.selectedCity.descrizione; }
    	if($scope.venue.id){
    		VenueService.updateItem($scope.venue).$promise.then(function(r) {
				$scope.venue = r;
          		              Notification.success('Sede salvata');

			}, function(e) {
	          console.log(e);
	          Notification.error('Si è verificato un errore');
	          //TODO gestire errore
	        });
    	}
    	else{
    		VenueService.createItem($scope.venue).$promise.then(function(r) {
				$scope.venue = r;
                                    Notification.success('Sede creata');

          		          $state.go('modifica-sede',{id:r.id});

			}, function(e) {
	          console.log(e);
	          Notification.error('Si è verificato un errore');
	          //TODO gestire errore
	        });
    	}
    }
}


})();
(function () {
    'use strict';

    angular.module('AmwayAdmin.pages.videotaxonomy')
        .controller('VideotaxonomyListCtrl', VideotaxonomyListCtrl)
        .controller('VideotaxonomyNewEditCtrl', VideotaxonomyNewEditCtrl);

    /** @ngInject */
    function VideotaxonomyListCtrl($scope, $ngConfirm, VideotaxonomyService, Notification, DataConnectorService, $uibModal) {


        $scope.baseurl = DataConnectorService.getPreviewBaseUrl();
        $scope.videotaxonomies = [];
        $scope.videotaxonomypagesize = 10;
        loadvideotaxonomys();

        function loadvideotaxonomys () {
            VideotaxonomyService.getAll().$promise.then(function (r) {
                    $scope.videotaxonomies = r;
                    console.log('r', r);
            }, function (e) {
                console.log(e);
                Notification.error('Si è verificato un errore');
            });
        }

        $scope.neweditvideotaxonomy = function (videotaxonomy) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/pages/videotaxonomy/videotaxonomy-newedit-modal/videotaxonomy-newedit-modal.html',
                controller: 'VideotaxonomyNewEditCtrl',
                size: 'lg',// a controller for modal instance
                resolve: {
                    videotaxonomy: function () {
                        return videotaxonomy;
                    }
                } // data passed to the controller
            }).result.then(function (videotaxonomy) {
                if(!videotaxonomy.id) {
                    VideotaxonomyService.post(videotaxonomy).$promise.then(function (r) {
                       loadvideotaxonomys();
                        Notification.success('Nuova categoria video creata');
                    }, function (e) {
                        console.log(e);
                        Notification.error('Si è verificato un errore');
                    });
                }
                else {
                    VideotaxonomyService.put(videotaxonomy).$promise.then(function (r) {
                        Notification.success('Categoria video aggiornata');
                        loadvideotaxonomys();
                    }, function (e) {
                        console.log(e);
                            Notification.error('Categoria video aggiornata');
                    });
                }
            }, function () {
                // action on popup dismissal.
            });
        }

        $scope.delete = function (row) {
            $ngConfirm({
                title: 'Elimina',
                content: "Sei sicuro?",
                scope: $scope,
                closeIcon: true,
                buttons: {
                    // long hand button definition
                    ok: {
                        text: "Conferma",
                        btnClass: 'btn-primary',
                        keys: ['enter'], // will trigger when enter is pressed
                        action: function (scope) {
                            VideotaxonomyService.delete(row).$promise.then(function (r) {
                                Notification.success('Categoria video eliminata');
                                loadvideotaxonomys();
                            }, function (e) {
                                console.log(e);
                                Notification.error(e.data && e.data.msg ? e.data.msg : 'Si è verificato un errore, riprova più tardi');
                            });
                        }
                    },
                    cancel: {
                        text: "Annulla",
                        btnClass: 'btn-default',
                        action: function (scope) {
                            return true;
                        }
                    }
                },
            });
        }
    }
    function VideotaxonomyNewEditCtrl($scope, $uibModalInstance, videotaxonomy) {
        

        $scope.videotaxonomy = angular.copy(videotaxonomy);


        $scope.submit = function() {
            $scope.close($scope.videotaxonomy);
        }

        $scope.dismiss = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.close = function (item) {
            $uibModalInstance.close(item);
        };
    }
})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService, $cookies) {

  	if ($cookies.getObject("AMWAYuserLogged")) {
  	    $scope.userLogged =  $cookies.getObject("AMWAYuserLogged");
  	}

    var menuItems = baSidebarService.getMenuItems();
    
    $scope.menuItems = menuItems.filter(function(item, key) {
    	return item.authRoles.indexOf($scope.userLogged.ntsrole) >= 0;
    });

    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('AmwayAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                var params = s.params ? s.params : {authRoles: []};
                params.authRoles.unshift('amministratore');
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                  authRoles: params.authRoles
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('AmwayAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('AmwayAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

(function() {
  'use strict';

  angular.module('AmwayAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('AmwayAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('AmwayAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: function($scope, ENV) {
      	if (ENV.type == 'dev') $scope.dev = true;
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('AmwayAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AmwayAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('AmwayAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/contabilita/causali/causali.html','<uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Causali Magazzino"><div eltable="" entity="causalemagazzino" edit="false"></div></uib-tab><uib-tab heading="Causali Contabili"><div eltable="" entity="causalecontabile" edit="false"></div></uib-tab></uib-tabset>');
$templateCache.put('app/contabilita/bilancio/bilancio-conti-contrapposto.html','<div><h4 ng-if="!loading && attivita && attivita.length && passivita && passivita.length"><strong>STATO PATRIMONIALE</strong></h4><table ng-if="!loading && attivita && attivita.length && passivita && passivita.length"><tbody><td style="vertical-align:top;"><table class="table table-striped border-table table-bilancio table-bilancio-contrapposto"><thead><tr><th></th><th><b>SALDO</b></th></tr></thead><tbody><tr ng-repeat-start="row in attivita track by $index" ng-if="$index==0 || row.gruppo!=attivita[$index-1].gruppo"><td colspan="2"><strong>{{label[row.gruppo]}}</strong> <span style="float:right;"><strong>EUR</strong></span></td></tr><tr ng-repeat-end="" ng-if="row.saldo != 0"><td><strong ng-if="row.level == 0"><u><span class="bilancio-conto">{{ row.conto }}</span> &nbsp;{{ row.descrizione }}</u></strong> <i ng-if="row.level == 1">&nbsp;&nbsp; <strong><span class="bilancio-conto">{{ row.conto }}</span> &nbsp;{{ row.descrizione }}</strong></i> <span ng-if="row.level == 2">&nbsp;&nbsp;&nbsp;&nbsp; <span class="bilancio-conto">{{ row.conto }}</span> &nbsp;{{ row.descrizione }}</span></td><td class="saldo"><strong ng-if="row.level == 0"><u>{{ row.saldo/100 | currency:\'\' }}</u></strong> <strong ng-if="row.level == 1">{{ row.saldo/100 | currency:\'\' }}</strong> <span ng-if="row.level != 0 && row.level != 1">{{ row.saldo/100 | currency:\'\' }}</span></td></tr></tbody></table></td><td style="vertical-align:top;"><table class="table table-striped border-table table-bilancio table-bilancio-contrapposto"><thead><tr><th></th><th><b>SALDO</b></th></tr></thead><tbody><tr ng-repeat-start="row in passivita track by $index" ng-if="$index==0 || row.gruppo!=passivita[$index-1].gruppo"><td colspan="2"><strong>{{label[row.gruppo]}}</strong> <span style="float:right;"><strong>EUR</strong></span></td></tr><tr ng-repeat-end="" ng-if="row.saldo != 0"><td><strong ng-if="row.level == 0"><u><span class="bilancio-conto">{{ row.conto }}</span> &nbsp;{{ row.descrizione }}</u></strong> <i ng-if="row.level == 1">&nbsp;&nbsp; <strong><span class="bilancio-conto">{{ row.conto }}</span> &nbsp;{{ row.descrizione }}</strong></i> <span ng-if="row.level == 2">&nbsp;&nbsp;&nbsp;&nbsp; <span class="bilancio-conto">{{ row.conto }}</span> &nbsp;{{ row.descrizione }}</span></td><td class="saldo"><strong ng-if="row.level == 0"><u>{{ row.saldo/100 | abs | currency:\'\' }}</u></strong> <strong ng-if="row.level == 1">{{ row.saldo/100 | abs | currency:\'\' }}</strong> <span ng-if="row.level != 0 && row.level != 1">{{ row.saldo/100 | abs | currency:\'\' }}</span></td></tr></tbody></table></td></tbody><tfoot><tr><td><table class="table-bilancio table-bilancio-contrapposto border-table table"><td width="80%"><strong>{{ totalA.descrizione }}</strong></td><td class="saldo"><strong>{{ totalA.saldo/100 | currency:\'\' }}</strong></td></table></td><td><table class="table-bilancio table-bilancio-contrapposto border-table table"><td width="80%"><strong>{{ utilePerdita.descrizione }}</strong></td><td class="saldo" ng-class="{\'bg-danger\': (totalR.saldo - totalC.saldo) !== utilePerdita.saldo }"><strong>{{ utilePerdita.saldo/100 | currency:\'\' }}</strong></td></table></td></tr><tr><td><table class="table-bilancio table-bilancio-contrapposto border-table table"><td width="80%"><strong>{{ totalA.descrizione }}</strong></td><td class="saldo"><strong>{{ totalA.saldo/100 | currency:\'\' }}</strong></td></table></td><td><table class="table-bilancio table-bilancio-contrapposto border-table table"><td width="80%"><strong>{{ totalP.descrizione }}</strong></td><td class="saldo"><strong>{{ totalP.saldo/100 | currency:\'\' }}</strong></td></table></td></tr></tfoot></table><br><div class="break-print"></div><h4 ng-if="!loading && costi && costi.length && passivita && passivita.length"><strong>CONTO ECONOMICO</strong></h4><table ng-if="!loading && costi && costi.length && passivita && passivita.length"><tbody><td style="vertical-align:top;"><table class="table table-striped border-table table-bilancio table-bilancio-contrapposto"><thead><tr><th></th><th><b>SALDO</b></th></tr></thead><tbody><tr ng-repeat-start="row in costi" ng-if="$index==0 || row.gruppo!=costi[$index-1].gruppo"><td colspan="2"><strong>{{label[row.gruppo]}}</strong> <span style="float:right;"><strong>EUR</strong></span></td></tr><tr ng-repeat-end="" ng-show="row.conto != 800000 && row.conto != 900000"><td><strong ng-if="row.level == 0"><u><span class="bilancio-conto">{{ row.conto }}</span> &nbsp;{{ row.descrizione }}</u></strong> <i ng-if="row.level == 1">&nbsp;&nbsp; <strong><span class="bilancio-conto">{{ row.conto }}</span> &nbsp;{{ row.descrizione }}</strong></i> <span ng-if="row.level == 2">&nbsp;&nbsp;&nbsp;&nbsp; <span class="bilancio-conto">{{ row.conto }}</span> &nbsp;{{ row.descrizione }}</span></td><td class="saldo"><strong ng-if="row.level == 0"><u>{{ row.saldo/100 | currency:\'\' }}</u></strong> <strong ng-if="row.level == 1">{{ row.saldo/100 | currency:\'\' }}</strong> <span ng-if="row.level != 0 && row.level != 1">{{ row.saldo/100 | currency:\'\' }}</span></td></tr></tbody></table></td><td style="vertical-align:top;"><table class="table table-striped border-table table-bilancio table-bilancio-contrapposto"><thead><tr><th></th><th><b>SALDO</b></th></tr></thead><tbody><tr ng-repeat-start="row in ricavi" ng-if="$index==0 || row.gruppo!=ricavi[$index-1].gruppo"><td colspan="2"><strong>{{label[row.gruppo]}}</strong> <span style="float:right;"><strong>EUR</strong></span></td></tr><tr ng-repeat-end=""><td><strong ng-if="row.level == 0"><u><span class="bilancio-conto">{{ row.conto }}</span> &nbsp;{{ row.descrizione }}</u></strong> <i ng-if="row.level == 1">&nbsp;&nbsp; <strong><span class="bilancio-conto">{{ row.conto }}</span> &nbsp;{{ row.descrizione }}</strong></i> <span ng-if="row.level == 2">&nbsp;&nbsp;&nbsp;&nbsp; <span class="bilancio-conto">{{ row.conto }}</span> &nbsp;{{ row.descrizione }}</span></td><td class="saldo"><strong ng-if="row.level == 0"><u>{{ row.saldo/100 | abs | currency:\'\' }}</u></strong> <strong ng-if="row.level == 1">{{ row.saldo/100 | abs | currency:\'\' }}</strong> <span ng-if="row.level != 0 && row.level != 1">{{ row.saldo/100 | abs | currency:\'\' }}</span></td></tr></tbody></table></td></tbody><tfoot><td><table class="table-bilancio table-bilancio-contrapposto border-table table"><td width="80%"><strong>{{ totalC.descrizione }}</strong></td><td class="saldo"><strong>{{ totalC.saldo/100 | currency:\'\' }}</strong></td></table></td><td><table class="table-bilancio table-bilancio-contrapposto border-table table"><td width="80%"><strong>{{ totalR.descrizione }}</strong></td><td class="saldo"><strong>{{ totalR.saldo/100 | currency:\'\' }}</strong></td></table></td><tr><td><table class="table-bilancio table-bilancio-contrapposto border-table table"><td width="80%"><strong>{{ utilePerdita.descrizione }}</strong></td><td class="saldo" ng-class="{\'bg-danger\': (totalR.saldo - totalC.saldo) !== utilePerdita.saldo }"><strong>{{ (totalR.saldo - totalC.saldo)/100 | currency:\'\' }}</strong></td></table></td></tr><tr><td><table class="table-bilancio table-bilancio-contrapposto border-table table"><td width="80%"><strong>TOTALE A PAREGGIO</strong></td><td class="saldo"><strong>{{ ((totalR.saldo - totalC.saldo) + totalC.saldo) /100 | currency:\'\' }}</strong></td></table></td></tr></tfoot></table><br><div class="break-print" ng-if="!loading && altro && altro.length"></div><h4 ng-if="!loading && altro && altro.length"><strong>ALTRO</strong></h4><table ng-if="!loading && altro && altro.length" class="table table-striped border-table table-bilancio table-bilancio-contrapposto"><thead><tr><th></th><th><b>SALDO</b></th></tr></thead><tbody><tr ng-repeat-start="row in altro" ng-if="$index==0 || row.gruppo!=altro[$index-1].gruppo"><td colspan="5"><strong>{{label[row.gruppo]}}</strong> <span style="float:right;"><strong>EUR</strong></span></td></tr><tr ng-repeat-end=""><td><strong ng-if="row.level == 0"><u><span class="bilancio-conto">{{ row.conto }}</span> &nbsp;{{ row.descrizione }}</u></strong> <i ng-if="row.level == 1">&nbsp;&nbsp; <strong><span class="bilancio-conto">{{ row.conto }}</span> &nbsp;{{ row.descrizione }}</strong></i> <span ng-if="row.level == 2">&nbsp;&nbsp;&nbsp;&nbsp; <span class="bilancio-conto">{{ row.conto }}</span> &nbsp;{{ row.descrizione }}</span></td><td class="saldo"><strong ng-if="row.level == 0"><u>{{ row.saldo/100 | currency:\'\' }}</u></strong> <strong ng-if="row.level == 1">{{ row.saldo/100 | currency:\'\' }}</strong> <span ng-if="row.level != 0 && row.level != 1">{{ row.saldo/100 | currency:\'\' }}</span></td></tr><tr><td><strong>{{ totalOther.descrizione }}</strong></td><td><strong>{{ totalOther.saldo/100 | currency:\'\' }}</strong></td></tr></tbody></table></div>');
$templateCache.put('app/contabilita/bilancio/bilancio-conti.html','<div><table ng-if="!loading" class="table table-striped border-table table-bilancio"><thead><tr><th></th><th><b>Apertura</b></th><th><b>Prog. DARE</b></th><th><b>Prog. AVERE</b></th><th><b>SALDO</b></th></tr></thead><tbody><tr ng-repeat-start="row in bilancioRows" ng-if="$index==0 || row.gruppo!=bilancioRows[$index-1].gruppo"><td colspan="5"><strong>{{label[row.gruppo]}}</strong></td></tr><tr ng-repeat-end=""><td><strong ng-if="row.level == 0"><span class="bilancio-conto">{{ row.conto }}</span>&nbsp;{{ row.descrizione }}</strong> <i ng-if="row.level == 1">&nbsp;&nbsp;<span class="bilancio-conto">{{ row.conto }}</span>&nbsp;{{ row.descrizione }}</i> <span ng-if="row.level == 2">&nbsp;&nbsp;&nbsp;&nbsp;<span class="bilancio-conto">{{ row.conto }}</span>&nbsp;{{ row.descrizione }}</span></td><td>{{ row.apertura/100 | currency }}</td><td>{{ row.dare/100 | currency }}</td><td>{{ row.avere/100 | currency }}</td><td>{{ row.saldo/100 | currency }}</td></tr></tbody></table></div>');
$templateCache.put('app/contabilita/bilancio/stampa-bilancio.html','<div class="horizontal-scroll"><div ba-panel=""><form ng-submit="adSearch()"><h3>Ricerca</h3><div class="row ricerca_movimenti"><div class="col-xs-12"><div class="col-xs-3"><label>Data inizio</label><div class="input-group"><input type="text" date2str="" forcetime="down" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="searchObj.datefrom" is-open="popUpDate1" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate1 = !popUpDate1"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3"><label>Data fine</label><div class="input-group"><input type="text" date2str="" forcetime="up" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="searchObj.dateto" is-open="popUpDate2" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate2 = !popUpDate2"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-true-value="0" ng-false-value="1" id="featured" ng-model="searchObj.removezero"> <span>Includi non movimentati</span></label></div></div><div class="col-xs-3"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-true-value="1" ng-false-value="0" id="featured" ng-model="searchObj.removesaldozero"> <span>Escludi saldo zero</span></label></div></div><div class="col-xs-3" ng-if="showSideToSide"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-true-value="1" ng-false-value="0" id="featured" ng-model="searchObj.sidetoside"> <span>Contrapposto</span></label></div></div></div></div><br><div class="col-xs-9"><p class="text-danger">{{ error }}</p></div><div class="col-xs-2 text-right"><button type="button" class="btn btn-danger" ng-click="reset();">Svuota ricerca</button></div><div class="col-xs-1 text-right"><button type="submit" class="btn btn-primary">Cerca</button></div></form></div><div class="row spinner-cont" style="margin-left:0;margin-right:0;" ng-show="loading"><span class="spinner"></span></div><a class="btn btn-primary hide-print" ng-show="enablePrint" style="float:right;margin-right:50px;margin-top:-10px;" ng-click="print();">STAMPA <i class="fa fa-print fa-lg" aria-hidden="true"></i></a><h4><strong>BILANCIO DI VERIFICA - Dal {{ searchObj.datefrom*1000 | date:\'dd/MM/yyyy\' }} al {{ searchObj.dateto*1000 | date:\'dd/MM/yyyy\' }}</strong></h4></div><br><div class="safe-print"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="activeTab"><uib-tab heading="Conti" index="\'conti\'" select="onChangeTab($event)"><div ng-if="searchObj.sidetoside" ng-include="" src="\'app/contabilita/bilancio/bilancio-conti-contrapposto.html\'"></div><div ng-if="!searchObj.sidetoside" ng-include="" src="\'app/contabilita/bilancio/bilancio-conti.html\'"></div></uib-tab><uib-tab heading="Clienti" index="\'clienti\'" select="onChangeTab($event)"><div ng-include="" src="\'app/contabilita/bilancio/bilancio-conti.html\'"></div></uib-tab><uib-tab heading="Fornitori" index="\'fornitori\'" select="onChangeTab($event)"><div ng-include="" src="\'app/contabilita/bilancio/bilancio-conti.html\'"></div></uib-tab></uib-tabset></div></div>');
$templateCache.put('app/contabilita/autofatture/autofatture.html','<div class="well"><div class="row"><form ng-submit="cercaBonus()"><div class="col-md-4"><div class="form-group"><select name="anno" ng-model="ricerca.year" id="inputCoe" class="form-control" required="required"><option ng-repeat="(k,y) in years" value="{{k}}">{{k}}</option></select></div></div><div class="col-md-4"><div class="form-group"><select name="anno" ng-disabled="!ricerca.year" ng-model="ricerca.month" id="inputCoe" class="form-control" required="required"><option ng-repeat="m in years[ricerca.year]" value="{{m.num}}">{{m.month}}</option></select></div></div><button type="submit" class="btn btn-primary">Cerca</button></form></div></div><amway-pagination-size page-size="itemsPerPage" elements="bonus"></amway-pagination-size><table ng-show="bonus.length" class="table table-striped" st-table="displayedBonus" st-safe-src="bonus"><thead><tr><td>Nome</td><td>Codice NTS</td><td>Rebate</td><td>Extra Fee</td><td>Note</td><td><div class="input-group"><input date2str="" model-view-value="true" ui-mask="99/99/9999" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="contdate" is-open="contopen" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="contopen=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></td></tr></thead><tbody><tr ng-repeat="b in displayedBonus"><td>{{b.fname}} {{b.lname}}</td><td>{{b.ntscode}}</td><td>{{b.rebatedue/100 | number:2}}</td><td>{{b.extrafee/100 | number:2}}</td><td>{{b.note}}</td><td><a href="{{apiurl}}generate/invoice/bonus/{{b.id}}" ng-show="b.idmov && (b.rebatedue>0 || b.extrafee>0)" class="btn btn-default btn-xs">Scarica Fattura</a> <a ng-click="gestisciBonus(b)" ng-show="!b.idmov" class="btn btn-default btn-xs">Gestisci</a> <a ng-show="!b.idmov && (b.rebatedue + b.extrafee>0)" target="blank" href="#!/new-movimento?bonus={{b.id}}&date={{contdate}}" class="btn btn-default btn-xs">Contabilizza</a> <a target="blank" href="#!/edit-movimento/{{id}}" ng-repeat="id in getMovimentiAssociati(b.selfinvoice);">Movimento {{$index+1}}</a> <a class="btn btn-default btn-xs" ng-if="!b.idsdi && getMovimentiAssociati(b.selfinvoice).length && !loadingSDI[$index]" ng-click="sendToSDI(b, $index)">Invia SDI</a><div style="position:relative;top:-5px;left:20px;display:inline-block;"><span class="spinner" ng-if="loadingSDI[$index]"></span></div><span ng-if="b.idsdi">ID SDI: {{ b.idsdi }}</span></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="itemsPerPage" st-displayed-pages="10" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table>');
$templateCache.put('app/contabilita/autofatture/gestiscibonus-dialog.html','<div class="modal-content"><form name="lang" ng-submit="salva()"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Gestisci dati di {{bonus.fname}} {{bonus.lname}}</h4></div><div class="modal-body"><div class="row"><div class="col-sm-4"><div class="form-group"><label for="fname">Fee aggiuntive (imponibile)</label> <input required="" ng-model="bonus.extrafee" float2int="" type="text" class="form-control" id="fname" placeholder="Extra Fee"></div></div><div class="col-sm-8"><div class="form-group"><label for="fname">Note</label> <input required="" ng-model="bonus.extrafeenote" type="text" class="form-control" id="fname" placeholder="Note"></div></div></div></div><div class="modal-footer"><a ng-click="cancel()" class="btn btn-default">Annulla</a> <button type="submit" class="btn btn-primary">Conferma</button></div></form></div>');
$templateCache.put('app/contabilita/chiusuraAnnuale/chiusuraAnnuale.html','<div ba-panel=""><div class="row"><div class="col-md-4"><h4><b>Chiusura conti patrimoniale anno:</b></h4></div><div class="col-md-2"><select class="form-control" ng-model="selectedYears.patrimoniale"><option ng-repeat="year in years" ng-value="year">{{year}}</option></select></div><div class="col-md-2"><div ng-show="loading.patrimoniale" class="row spinner-cont" style="margin-left:0;margin-right:0;"><span class="spinner"></span></div><button ng-show="!loading.patrimoniale" class="btn btn-warning" ng-click="chiudi(chiudiPatrimoniale, selectedYears.patrimoniale)">Chiudi</button></div></div><br><div class="row"><div class="col-md-4"><h4><b>Chiusura conti economici anno:</b></h4></div><div class="col-md-2"><select class="form-control" ng-model="selectedYears.economici"><option ng-repeat="year in years" ng-value="year">{{year}}</option></select></div><div class="col-md-2"><div ng-show="loading.economici" class="row spinner-cont" style="margin-left:0;margin-right:0;"><span class="spinner"></span></div><button ng-show="!loading.economici" class="btn btn-warning" ng-click="chiudi(chiudiEconomici, selectedYears.economici)">Chiudi</button></div></div><br><div class="row"><div class="col-md-4"><h4><b>Chiusura conti fornitori anno:</b></h4></div><div class="col-md-2"><select class="form-control" ng-model="selectedYears.fornitori"><option ng-repeat="year in years" ng-value="year">{{year}}</option></select></div><div class="col-md-2"><div ng-show="loading.fornitori" class="row spinner-cont" style="margin-left:0;margin-right:0;"><span class="spinner"></span></div><button ng-show="!loading.fornitori" class="btn btn-warning" ng-click="chiudi(chiudiFornitori, selectedYears.fornitori)">Chiudi</button></div></div><br><div class="row"><div class="col-md-4"><h4><b>Chiusura conti clienti anno:</b></h4></div><div class="col-md-2"><select class="form-control" ng-model="selectedYears.clienti"><option ng-repeat="year in years" ng-value="year">{{year}}</option></select></div><div class="col-md-2"><div ng-show="loading.clienti" class="row spinner-cont" style="margin-left:0;margin-right:0;"><span class="spinner"></span></div><button ng-show="!loading.clienti" class="btn btn-warning" ng-click="chiudi(chiudiClienti, selectedYears.clienti)">Chiudi</button></div></div><br><div class="row"><div class="col-md-4"><h4><b>Bonus di apertura provvisorio anno:</b></h4></div><div class="col-md-2"><select class="form-control" ng-model="selectedYears.bonus"><option ng-repeat="year in years" ng-value="year">{{year}}</option></select></div><div class="col-md-2"><div ng-show="loading.bonus" class="row spinner-cont" style="margin-left:0;margin-right:0;"><span class="spinner"></span></div><button ng-show="!loading.bonus" class="btn btn-warning" ng-click="chiudi(aperturaProvvisorio, selectedYears.bonus)">Chiudi</button></div></div></div>');
$templateCache.put('app/contabilita/certificazioneUnica/certificazioneUnica.html','<div class="row"><div ba-panel=""><form ng-submit="applyFilter()"><div class="input-group"><div class="col-md-4"><label>Seleziona anno</label><select class="form-control" ng-model="formFilter.year"><option ng-repeat="year in years" ng-value="year">{{year}}</option></select></div><div class="col-md-1" style="margin-top:20px"><button type="submit" class="btn btn-primary pull-right">Filtra</button></div><div class="col-md-1"></div><div class="col-md-2"><label>Seleziona anno</label><select class="form-control" ng-model="formFilter.yearGen"><option ng-repeat="year in yearsGen" ng-value="year">{{year}}</option></select></div><div class="col-md-1" style="margin-top:20px"><button type="button" ng-click="generaCertificazione()" class="btn btn-warning pull-right">Genera</button></div><div class="col-md-2 pull-right" style="margin-top:20px; margin-right : 20px"><a class="btn btn-primary d-inline" target="_blank" href="{{apiurl + \'certificazioneunica/pdf/\' + formFilter.year +\'/entratel\'}}">Scarica Entratel</a></div></div></form></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><amway-pagination-server-side page-size="itemsTablePageSize" elements="rows"></amway-pagination-server-side><table class="table" ng-if="!loading" st-table="rows" st-pipe="getRows"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="fname">Nome</th><th st-sort="cf">CF</th><th st-sort="piva">P. IVA</th><th st-sort="usertype">Tipo</th><th st-sort="imponibile">Imponibile</th><th st-sort="aliquota">Aliquota</th><th st-sort="irpef">IRPEF</th><th st-sort="inps">INPS</th><th></th><th>Azioni</th><th></th></tr></thead><tbody><tr ng-repeat="item in rows"><td><b>{{item.id}}</b></td><td>{{ item.fname + " " + item.lname }}</td><td>{{ item.cf}}</td><td>{{ item.piva}}</td><td>{{ item.usertype }}</td><td>{{ item.imponibile / 100 | currency }}</td><td>{{ item.aliquota / 100 | number : 2 }} %</td><td>{{ item.irpef / 100 | currency }}</td><td>{{ item.inps / 100 | currency }}</td><td><a target="blank" href="{{apiurl + \'certificazioneunica/pdf/\' + item.id}}" class="btn btn-success btn-xs d-inline">PDF</a></td><td><a class="btn btn-primary btn-xs d-inline" ng-click="edit($event,item)">Modifica</a></td><td><a class="btn btn-danger btn-xs" ng-click="delete(item)">Elimina</a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="itemsTablePageSize" st-displayed-pages="pagesToDisplay" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/contabilita/certificazioneUnica/modifica-certificazione-dialog.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Modifica Certificazione {{item.fname + " " + item.lname}}</h4></div><div class="modal-body"><form name="formutente" ng-submit="salva()"><div class="row"><div class="col-sm-4"><div class="form-group"><label for="fname">Compensi</label> <input ng-model="item.compensi" type="text" class="form-control" id="compensi" placeholder="compensi" float2int=""></div></div><div class="col-sm-4"><div class="form-group"><label for="lname">Imponibile</label> <input ng-model="item.imponibile" type="text" class="form-control" id="imponibile" placeholder="imponibile" float2int=""></div></div><div class="col-sm-4" ng-show="item.usertype!=\'occasionale\'"><div class="form-group"><label for="lname">IVA 22%</label> <input ng-model="item.imponibile22" type="text" class="form-control" id="imponibile22" placeholder="imponibile22" float2int=""></div></div><div class="col-sm-4"><div class="form-group"><label for="lname">Imponibile IRPEF</label> <input ng-model="item.imponibile78" type="text" class="form-control" id="imponibile78" placeholder="imponibile78" float2int=""></div></div><div class="col-sm-4"><div class="form-group"><label for="lname">IRPEF</label> <input ng-model="item.irpef" type="text" class="form-control" id="Irpef" placeholder="Irpef" float2int=""></div></div><div class="col-sm-4" ng-show="item.usertype==\'incaricato\'"><div class="form-group"><label for="lname">INPS 13</label> <input ng-model="item.irpef13" type="text" class="form-control" id="Irpef13" placeholder="Irpef13" float2int=""></div></div><div class="col-sm-4" ng-show="item.usertype==\'incaricato\'"><div class="form-group"><label for="lname">INPS 23</label> <input ng-model="item.irpef23" type="text" class="form-control" id="Irpef23" placeholder="Irpef23" float2int=""></div></div><div class="col-sm-4"><div class="form-group"><label for="lname">Non sogg</label> <input ng-model="item.nonsogg" type="text" class="form-control" id="nonsogg" placeholder="Non sogg" float2int=""></div></div><div class="col-sm-4"><div class="form-group"><label for="lname">Spese anticipate</label> <input ng-model="item.speseant" type="text" class="form-control" id="speseant" placeholder="Spese anticipate" float2int=""></div></div><div class="col-sm-4" ng-show="item.usertype==\'incaricato\'"><div class="form-group"><label for="lname">Aliquota</label> <input ng-model="item.aliquota" type="text" class="form-control" id="aliquota" placeholder="Aliquota" float2int=""></div></div></div><div class="modal-footer"><a ng-click="cancel()" class="btn btn-default">Annulla</a> <button type="submit" class="btn btn-primary">Conferma</button></div></form></div></div>');
$templateCache.put('app/contabilita/codiciiva/codiciiva.html','<a class="btn btn-primary" style="float:right;" href="#!/nuovo-codiceiva/">Crea Codice IVA</a><div eltable="" entity="codiceiva" edit="true" remove="true"></div>');
$templateCache.put('app/contabilita/codiciiva/edit-codiceiva.html','<div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><form name="formCodiceIva" ng-submit="salva()"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dati Generali"><div class="row"><div class="col-sm-2"><div class="form-group"><label>Codice</label> <input class="form-control" type="text" ng-model="codiceiva.codice"></div></div><div class="col-sm-2"><div class="form-group"><label>Codice SDI</label> <input class="form-control" type="text" ng-model="codiceiva.codivasdi"></div></div><div class="col-sm-2"><div class="form-group"><label>Descrizione</label> <input class="form-control" type="text" ng-model="codiceiva.descrizione"></div></div><div class="col-sm-2"><div class="form-group"><label>Aliquota</label> <input class="form-control" type="text" ng-model="codiceiva.aliquota"></div></div><div class="col-sm-2"><div class="form-group"><label>Aliquota Dec.</label> <input class="form-control" type="text" ng-model="codiceiva.aliquotadec"></div></div><div class="col-sm-2"><div class="form-group"><label>Indetraibile Dec.</label> <input class="form-control" type="text" ng-model="codiceiva.indetraibiledec"></div></div></div><div class="row"><div class="col-sm-2"><div class="form-group"><label>Cod. Detr.</label> <input class="form-control" type="text" ng-model="codiceiva.coddetr"></div></div><div class="col-sm-2"><div class="form-group"><label>Cod. Indetr.</label> <input class="form-control" type="text" ng-model="codiceiva.codindetr"></div></div><div class="col-sm-2"><div class="form-group"><label>QE</label> <input class="form-control" type="text" ng-model="codiceiva.qe"></div></div><div class="col-sm-2"><div class="form-group"><label>QF</label> <input class="form-control" type="text" ng-model="codiceiva.qf"></div></div><div class="col-sm-2"><div class="form-group"><label>Natura IVA</label> <input class="form-control" type="text" ng-model="codiceiva.naturaiva"></div></div></div></uib-tab></uib-tabset><div align="center"><button ng-disabled="!codiceiva.codice || !codiceiva.codivasdi" class="btn btn-primary" type="submit">Salva Codice IVA</button><br><br></div></form></div>');
$templateCache.put('app/contabilita/fattDaControllare/fattDaControllare.html','<div class="row"><div ba-panel=""><form ng-submit="applyFilter()"><div class="input-group"><div class="col-md-4"><input date-range-picker="" class="form-control date-picker" type="text" placeholder="Ricerca range date..." ng-model="dateFilter.range"></div><div class="col-md-3"><input type="checkbox" class="form-check-input" ng-model="filter.showarning" ng-true-value="1" ng-false-value="0"> <label class="form-check-label">Filtra per warning</label></div><div class="col-md-3"><input type="checkbox" class="form-check-input" ng-model="filter.showfail" ng-true-value="1" ng-false-value="0"> <label class="form-check-label">Filtra per fail</label></div><div class="col-md-2"><button type="submit" class="btn btn-primary pull-right">Filtra</button></div></div></form></div></div><div class="input-group col-md-12"><div class="form-group col-md-offset-3 col-md-7"></div></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><amway-pagination-server-side page-size="invoicesTablePageSize" elements="invoices"></amway-pagination-server-side><table class="table" ng-if="!loading" st-table="invoices" st-pipe="getInvoicedPag"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="datadoc">Data</th><th st-sort="codicedocumento">Tipo</th><th st-sort="cliente">Cliente</th><th st-sort="anno">Anno</th><th st-sort="numdoc">Num Doc</th><th st-sort="statosdi">Stato sdi</th><th st-sort="statosdi">Esito sdi</th><th st-sort="statosdi">Tx data sdi</th><th st-sort="totalemerce">Imponibile</th><th st-sort="totiva">Imposta</th><th st-sort="totdocumento">Totale</th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in invoices"><td><b>{{item.id}}</b></td><td>{{ item.datadoc*1000 | date:\'dd/MM/yy\' }}</td><td>{{ item.codicedocumento.startsWith(\'NOT\') ? \'Nota di Credito\' : \'Fattura\' }}</td><td>{{ item.cliente}}</td><td>{{ item.anno }}</td><td>{{ item.numdoc }}</td><td><span style="color : {{(item.statosdi == \'fail\')?(\'red\'):(\'\')}}">{{ item.statosdi }}</span></td><td><span style="color : {{(item.esitosdi == \'NOT_DELIVERED\')?(\'orange\'):(\'\')}}">{{ item.esitosdi }}</span></td><td>{{ (item.txdatesdi)?(item.txdatesdi*1000 | date : "dd/MM/yyyy"):(\'N/A\') }}</td><td>{{ item.totalemerce/100 | currency }}</td><td>{{ item.totiva/100 | currency }}</td><td>{{ item.totdocumento/100 | currency }}</td><td><i ng-if="item.msgsdi" class="glyphicon glyphicon-info-sign" tooltips="" tooltip-template="{{item.msgsdi}}" tooltip-size="small"></i></td><td><a ng-href="#!/fatture/dettaglio/{{item.ntsid}}"><i class="glyphicon glyphicon-zoom-in" tooltips="" tooltip-template="Dettagli" tooltip-size="small"></i></a></td><td><a ng-if="item.idmovcont" href="#!/edit-movimento/{{item.ntsid}}"><i class="glyphicon glyphicon-list" tooltips="" tooltip-template="Movimenti contabili" tooltip-size="small"></i></a></td><td><a ng-href="{{apiurl}}fattura/download/{{item.id}}" target="_blank"><i class="glyphicon glyphicon-download-alt" tooltips="" tooltip-template="Download fattura" tooltip-size="small"></i></a></td><td ng-hide="item.statosdi==\'ok\' && item.esitosdi==\'NOT_DELIVERED\'"><a ng-click="rigenera(item, $index)" target="_blank"><i class="ion-refresh" tooltips="" tooltip-template="Rigenera fattura" tooltip-size="small"></i></a></td><td ng-show="item.statosdi==\'ok\' && item.esitosdi==\'NOT_DELIVERED\'"><a ng-click="notify(item, $index)" target="_blank"><i class="glyphicon glyphicon-ok" tooltips="" tooltip-template="Conferma notifica utente" tooltip-size="small"></i></a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="invoicesTablePageSize" st-displayed-pages="pagesToDisplay" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table>');
$templateCache.put('app/contabilita/conti/conti.html','<div eltable="" entity="conto"></div>');
$templateCache.put('app/contabilita/fattDaControllareEE/fattDaControllareEE.html','<div class="row"><div ba-panel=""><form ng-submit="applyFilter()"><div class="input-group"><div class="col-md-4"><input date-range-picker="" class="form-control date-picker" type="text" placeholder="Ricerca range date..." ng-model="dateFilter.range"></div><div class="col-md-3"><input type="checkbox" class="form-check-input" ng-model="filter.showfail" ng-true-value="1" ng-false-value="0"> <label class="form-check-label">Filtra per fail</label></div><div class="col-md-2"><button type="submit" class="btn btn-primary pull-right">Filtra</button></div></div></form></div></div><div class="input-group col-md-12"><div class="form-group col-md-offset-3 col-md-7"></div></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><amway-pagination-server-side page-size="invoicesTablePageSize" elements="invoices"></amway-pagination-server-side><table class="table" ng-if="!loading" st-table="invoices" st-pipe="getInvoicedPag"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="datadoc">Data</th><th st-sort="codicedocumento">Tipo</th><th st-sort="cliente">Cliente</th><th st-sort="anno">Anno</th><th st-sort="numdoc">Num Doc</th><th st-sort="statosdi">Stato sdi</th><th st-sort="statosdi">Esito sdi</th><th st-sort="statosdi">Tx data sdi</th><th st-sort="totalemerce">Imponibile</th><th st-sort="totiva">Imposta</th><th st-sort="totdocumento">Totale</th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in invoices"><td><b>{{item.id}}</b></td><td>{{ item.datadoc*1000 | date:\'dd/MM/yy\' }}</td><td>{{ item.codicedocumento.startsWith(\'NOT\') ? \'Nota di Credito\' : \'Fattura\' }}</td><td>{{ item.cliente}}</td><td>{{ item.anno }}</td><td>{{ item.numdoc }}</td><td><span style="color : {{(item.statosdi == \'fail\')?(\'red\'):(\'\')}}">{{ item.statosdi }}</span></td><td><span style="color : {{(item.esitosdi == \'NOT_DELIVERED\')?(\'orange\'):(\'\')}}">{{ item.esitosdi }}</span></td><td>{{ (item.txdatesdi)?(item.txdatesdi*1000 | date : "dd/MM/yyyy"):(\'N/A\') }}</td><td>{{ item.totalemerce/100 | currency }}</td><td>{{ item.totiva/100 | currency }}</td><td>{{ item.totdocumento/100 | currency }}</td><td><i ng-if="item.msgsdi" class="glyphicon glyphicon-info-sign" tooltips="" tooltip-template="{{item.msgsdi}}" tooltip-size="small"></i></td><td><a ng-if="item.idmovcont" href="#!/edit-movimento/{{item.ntsid}}"><i class="glyphicon glyphicon-list" tooltips="" tooltip-template="Movimenti contabili" tooltip-size="small"></i></a></td><td ng-hide="item.statosdi==\'ok\' && item.esitosdi==\'NOT_DELIVERED\'"><a ng-click="rigenera(item, $index)" target="_blank"><i class="ion-refresh" tooltips="" tooltip-template="Rigenera fattura" tooltip-size="small"></i></a></td></tr></tbody><tfoot><tr><td colspan="15" class="text-center"><div st-pagination="" st-items-by-page="invoicesTablePageSize" st-displayed-pages="pagesToDisplay" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table>');
$templateCache.put('app/contabilita/fattElettr/fattElettr.html','<div class="row"><div ba-panel=""><form ng-submit="applyFilter()"><div class="input-group"><div class="col-md-4"><input date-range-picker="" class="form-control date-picker" type="text" placeholder="Ricerca range date..." ng-model="dateFilter.range"></div><div class="col-md-2"><button type="submit" class="btn btn-primary pull-right">Filtra</button></div></div></form></div></div><div class="input-group col-md-12"><div class="form-group col-md-offset-3 col-md-7"></div></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><amway-pagination-server-side page-size="invoicesTablePageSize" elements="invoices"></amway-pagination-server-side><table class="table" ng-if="!loading" st-table="invoices" st-pipe="getInvoicedPag"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="datadoc">Fornitore</th><th st-sort="partitaiva">P. IVA</th><th st-sort="numero">Numero</th><th st-sort="idsdi">Stato esito</th><th st-sort="datafattura">Data</th><th st-sort="importocent">Totale documento</th><th st-sort="insdate">Data registrazione</th><th></th><th>Azioni</th><th></th></tr></thead><tbody><tr ng-repeat="item in invoices"><td><b>{{item.id}}</b></td><td>{{ item.mittente }}</td><td>{{ item.pivamittente }}</td><td>{{ item.numero}}</td><td>{{ item.idsdi}}</td><td>{{ item.datafattura*1000 | date:\'dd/MM/yyyy\' }}</td><td>{{ (item.totaldoc && item.totaldoc != item.importocent ? item.totaldoc : item.importocent) / 100 | currency }}</td><td><input ng-if="!item.idfatturants" type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="item.dataregistrazione" date2str="" is-open="item.datepicking" ng-click="item.datepicking=!item.datepicking" ng-required="true" close-text="Chiudi" show-button-bar="false"></td><td><a class="btn btn-primary btn-xs d-inline" ng-click="creaFornitore(item.id)" ng-show="item.needsfornitore==1">Crea fornitore</a></td><td><a ng-if="!item.idfatturants" target="blank" href="#!/new-movimento?iddel={{item.id}}&date={{item.datafattura}}&datedraft={{item.dataregistrazione}}" class="btn btn-success btn-xs d-inline">Contabilizza</a> <a ng-if="item.idfatturants" href="#!/edit-movimento/{{item.idfatturants}}"><i ng-if="item.idfatturants" class="glyphicon glyphicon-zoom-in" tooltips="" tooltip-template="Dettagli" tooltip-size="small"></i></a></td><td><a class="btn btn-danger btn-xs" ng-click="delete(item)">Nascondi</a></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-items-by-page="invoicesTablePageSize" st-displayed-pages="pagesToDisplay" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table>');
$templateCache.put('app/contabilita/fatture2/fatture2.html','<div class="row"><div ba-panel=""><form ng-submit="applyFilter()"><div class="input-group"><div class="col-md-4"><label>Data</label> <input date-range-picker="" class="form-control date-picker" type="text" placeholder="Ricerca range date..." ng-model="filter.date"></div><div class="col-md-3"><label>Cliente</label><ui-select ng-model="filter.customer" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca cliente...">{{ $select.selected.denominazione }}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchCustomers($select.search)" refresh-delay="0" repeat="c in customers | filter: $select.search"><span ng-bind-html="c.denominazione+\' \'+c.conto"></span></ui-select-choices></ui-select></div><div class="col-md-3"><label>ID fattura</label> <input type="text" class="form-control" ng-model="filter.id"></div><br><div class="col-md-1"><button type="submit" class="btn btn-primary pull-right">Filtra</button></div><div class="col-md-1"><button type="button" class="btn btn-danger pull-right" ng-click="resetFilters()">Reset</button></div></div></form></div></div><div class="input-group col-md-12"><div class="form-group col-md-offset-3 col-md-7"></div></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><amway-pagination-server-side page-size="invoicesTablePageSize" elements="invoices"></amway-pagination-server-side><table class="table" ng-if="!loading" st-table="invoices" st-pipe="getInvoicedPag"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="reverse">#</th><th st-sort="datadoc">Data</th><th st-sort="codicedocumento">Tipo</th><th st-sort="cliente">Cliente</th><th st-sort="anno">Anno</th><th st-sort="numdoc">Numero Documento</th><th st-sort="statosdi">Stato sdi</th><th st-sort="statosdi">Esito sdi</th><th st-sort="statosdi">Tx data sdi</th><th st-sort="totalemerce">Imponibile</th><th st-sort="totiva">Imposta</th><th st-sort="totdocumento">Totale</th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in invoices"><td><b>{{item.id}}</b></td><td>{{ item.datadoc*1000 | date:\'dd/MM/yyyy\' }}</td><td>{{ item.codicedocumento.startsWith(\'NOT\') ? \'Nota di Credito\' : \'Fattura\' }}</td><td><a ng-click="goToUser(item.cliente)">{{ item.cliente }}</a></td><td>{{ item.anno }}</td><td>{{ item.numdoc }}</td><td><span style="color : {{(item.statosdi == \'fail\')?(\'red\'):(\'\')}}">{{ item.statosdi }}</span></td><td><span style="color : {{getEsitoColor(item.esitosdi)}}">{{ item.esitosdi }}</span></td><td>{{ (item.txdatesdi)?(item.txdatesdi*1000 | date : "dd/MM/yyyy"):(\'N/A\') }}</td><td>{{ item.totalemerce/100 | currency }}</td><td>{{ item.totiva/100 | currency }}</td><td>{{ item.totdocumento/100 | currency }}</td><td><i ng-show="item.msgsdi" class="glyphicon glyphicon-info-sign" tooltips="" tooltip-template="{{item.msgsdi}}" tooltip-size="small"></i></td><td><a ng-href="#!/fatture/dettaglio/{{item.ntsid}}"><i class="glyphicon glyphicon-zoom-in" tooltips="" tooltip-template="Dettagli" tooltip-size="small"></i></a></td><td><a ng-if="item.idmovcont" href="#!/edit-movimento/{{item.ntsid}}"><i class="glyphicon glyphicon-list" tooltips="" tooltip-template="Movimenti contabili" tooltip-size="small"></i></a></td><td><a ng-href="{{apiurl}}fattura/download/{{item.id}}" target="_blank"><i class="glyphicon glyphicon-download-alt" tooltips="" tooltip-template="Download fattura" tooltip-size="small"></i></a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="invoicesTablePageSize" st-displayed-pages="pagesToDisplay" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table>');
$templateCache.put('app/contabilita/fatture/fatture.html','<div eltable="" entity="fattura"></div>');
$templateCache.put('app/contabilita/fatture/view-fattura.html','<div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dettaglio fattura"><div class="row"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedInvoiceRowsList" st-safe-src="invoiceRows"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="tipo">Tipo</th><th st-sort="numriga"># Riga</th><th st-sort="numdec">NumDec</th><th st-sort="prezzo">Prezzo</th><th st-sort="sconto">Sconto</th><th st-sort="codiceiva">Codice IVA</th><th st-sort="importo">Importo</th><th st-sort="contovendita">Conto Vendita</th></tr></thead><tbody><tr ng-repeat="row in displayedInvoiceRowsList"><td><b>{{ row.idfattura }}</b></td><td>{{ row.tipo }}</td><td>{{ row.numriga }}</td><td>{{ row.numdec}}</td><td>{{ row.prezzo/100 | currency }}</td><td>{{ row.sconto }}%</td><td>{{ row.codiceiva }}%</td><td>{{ row.importo/100 | currency }}</td><td><a href="#!/ricercamovimenti?contofrom={{row.contovendita}}&contoto={{row.contovendita}}">{{ row.contovendita }}</a></td></tr></tbody></table></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/contabilita/liquidazioneIVA/liquidazioneIVA.html','<div class="horizontal-scroll"><div ba-panel=""><form ng-submit="search()"><h3>Ricerca</h3><div class="row ricerca_movimenti"><div class="col-xs-12"><div class="col-xs-3"><label>Data inizio</label><div class="input-group"><input type="text" date2str="" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dates.start" is-open="popUpDate1" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate1 = !popUpDate1"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3"><label>Data fine</label><div class="input-group"><input type="text" date2str="" forcetime="up" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dates.stop" is-open="popUpDate2" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate2 = !popUpDate2"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><br><br><div class="col-xs-9"><p class="text-danger">{{ error }}</p></div><div class="col-xs-1 text-right"><button type="button" class="btn btn-danger" ng-click="reset();">Svuota ricerca</button></div><div class="col-xs-1 text-right"><a class="btn btn-success" ng-href="{{baseurl}}generate/liquidazione/{{dates.start}}/{{stopDatePDF}}">Scarica PDF</a></div><div class="col-xs-1 text-right"><button type="submit" class="btn btn-primary">Cerca</button></div><hr></form><h3 style="border-width: 1px; border-top: solid; padding-top: 20px;">IVA Pagata in acconto: {{monthMap[selectedmonth - 1] + \' \' + selectedyear}}</h3><div class="row"><form ng-submit="saveliqiva()"><div class="col-xs-12"><div class="col-xs-3"><label>Importo</label><div class="input-group"><input type="text" float2int="" class="form-control" ng-disabled="liqiva.stato !== \'draft\'" ng-model="liqiva.acconto"></div></div><div class="col-xs-3"><label>Data</label><div class="input-group"><input ng-disabled="liqiva.stato !== \'draft\'" type="text" date2str="" forcetime="up" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="liqiva.dataacconto" is-open="popUpDate3" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button ng-disabled="liqiva.stato !== \'draft\'" type="button" class="btn btn-default" ng-click="popUpDate3 = !popUpDate3"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><br><br><div class="col-xs-6 text-right"><button ng-show="!disableform" type="submit" class="btn btn-primary">Salva</button></div></div></form></div></div><div class="row spinner-cont" style="margin-left:0;margin-right:0;" ng-show="loading"><span class="spinner"></span></div><a class="btn btn-primary hide-print" ng-show="enablePrint" style="float:right;margin-right:50px;" ng-click="print();">STAMPA <i class="fa fa-print fa-lg" aria-hidden="true"></i></a><div><div><h4><strong>C - PER LA VENDITA PER ACQUISTI CEE</strong></h4><table class="table border-table"><thead><tr><th></th><th><b>Codice Iva</b></th><th><b>Descrizione</b></th><th><b>Imponibile</b></th><th><b>Imposta</b></th></tr></thead><tbody><tr ng-repeat="row in sectionsList.c"><td></td><td>{{ row.codIva }}</td><td>{{ row.descrizione }}</td><td>{{ row.imponibile/100 }}</td><td>{{ row.imposta/100 }}</td></tr></tbody></table></div><div><h4><strong>H - Per la Vendita per Acquisti EXTRA CEE</strong></h4><table class="table border-table"><thead><tr><th></th><th><b>Codice Iva</b></th><th><b>Descrizione</b></th><th><b>Imponibile</b></th><th><b>Imposta</b></th></tr></thead><tbody><tr ng-repeat="row in sectionsList.h"><td></td><td>{{ row.codIva }}</td><td>{{ row.descrizione }}</td><td>{{ row.imponibile/100 }}</td><td>{{ row.imposta/100 }}</td></tr></tbody></table></div><div><h4><strong>T - VENDITE REVERSE CHARGE</strong></h4><table class="table border-table"><thead><tr><th></th><th><b>Codice Iva</b></th><th><b>Descrizione</b></th><th><b>Imponibile</b></th><th><b>Imposta</b></th></tr></thead><tbody><tr ng-repeat="row in sectionsList.t"><td></td><td>{{ row.codIva }}</td><td>{{ row.descrizione }}</td><td>{{ row.imponibile/100 }}</td><td>{{ row.imposta/100 }}</td></tr></tbody></table></div><div><h4><strong>V - FATTURE EMESSE</strong></h4><table class="table border-table"><thead><tr><th></th><th><b>Codice Iva</b></th><th><b>Descrizione</b></th><th><b>Imponibile</b></th><th><b>Imposta</b></th></tr></thead><tbody><tr ng-repeat="row in sectionsList.v"><td></td><td>{{ row.codIva }}</td><td>{{ row.descrizione }}</td><td>{{ row.imponibile/100 }}</td><td>{{ row.imposta/100 }}</td></tr></tbody></table></div><div><h4><strong>A - FATTURE RICEVUTE</strong></h4><table class="table border-table"><thead><tr><th></th><th><b>Codice Iva</b></th><th><b>Descrizione</b></th><th><b>Imponibile</b></th><th><b>Imposta</b></th></tr></thead><tbody><tr ng-repeat="row in sectionsList.a"><td></td><td>{{ row.codIva }}</td><td>{{ row.descrizione }}</td><td>{{ row.imponibile/100 }}</td><td>{{ row.imposta/100 }}</td></tr></tbody></table></div><div><h4><strong>B - FATTURE ACQUISTO CEE</strong></h4><table class="table border-table"><thead><tr><th></th><th><b>Codice Iva</b></th><th><b>Descrizione</b></th><th><b>Imponibile</b></th><th><b>Imposta</b></th></tr></thead><tbody><tr ng-repeat="row in sectionsList.b"><td></td><td>{{ row.codIva }}</td><td>{{ row.descrizione }}</td><td>{{ row.imponibile/100 }}</td><td>{{ row.imposta/100 }}</td></tr></tbody></table></div><div><h4><strong>D - Fatture Acquisto EXTRA CEE</strong></h4><table class="table border-table"><thead><tr><th></th><th><b>Codice Iva</b></th><th><b>Descrizione</b></th><th><b>Imponibile</b></th><th><b>Imposta</b></th></tr></thead><tbody><tr ng-repeat="row in sectionsList.d"><td></td><td>{{ row.codIva }}</td><td>{{ row.descrizione }}</td><td>{{ row.imponibile/100 }}</td><td>{{ row.imposta/100 }}</td></tr></tbody></table></div><div><h4><strong>Z - ACQUISTI REVERSE CHARGE</strong></h4><table class="table border-table"><thead><tr><th></th><th><b>Codice Iva</b></th><th><b>Descrizione</b></th><th><b>Imponibile</b></th><th><b>Imposta</b></th></tr></thead><tbody><tr ng-repeat="row in sectionsList.z"><td></td><td>{{ row.codIva }}</td><td>{{ row.descrizione }}</td><td>{{ row.imponibile/100 }}</td><td>{{ row.imposta/100 }}</td></tr></tbody></table></div><div><h4><strong>F - CORRISPETTIVI</strong></h4><table class="table border-table"><thead><tr><th></th><th><b>Codice Iva</b></th><th><b>Descrizione</b></th><th><b>Imponibile</b></th><th><b>Imposta</b></th></tr></thead><tbody><tr ng-repeat="row in sectionsList.f"><td></td><td>{{ row.codIva }}</td><td>{{ row.descrizione }}</td><td>{{ row.imponibile/100 }}</td><td>{{ row.imposta/100 }}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/contabilita/liquidazioneIVAmensile/liquidazioneIVAmensile.html','<div class="horizontal-scroll"><div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><amway-pagination-server-side page-size="tablePageSize" elements="list"></amway-pagination-server-side><table class="table" ng-if="!loading" st-table="list" st-pipe="getListPag"><thead><tr><th st-sort="id">#</th><th st-sort="year"><b>Anno</b></th><th st-sort="month"><b>Mese</b></th><th st-sort="insdate"><b>Data inserimento</b></th><th st-sort="savedate"><b>Data salvataggio</b></th><th st-sort="stato"><b>Stato</b></th><th st-sort="ivacquisti"><b>IVA Acquisti</b></th><th st-sort="ivavendite"><b>IVA Vendite</b></th><th st-sort="ivasaldo"><b>IVA Saldo</b></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="row in list"><td>{{ row.id }}</td><td>{{ row.year }}</td><td>{{ row.month }}</td><td>{{ row.insdate*1000 | date: \'dd/MM/yyyy\' }}</td><td>{{ row.savedate*1000 | date: \'dd/MM/yyyy\' }}</td><td>{{ row.stato }}</td><td>{{ row.ivacquisti/100 | number }}</td><td>{{ row.ivavendite/100 | number }}</td><td>{{ row.ivasaldo/100 | number }}</td><td ng-show="row.stato != \'closed\'"><a href="" class="btn btn-default btn-xs" ng-click="sendMov(row);">CONTABILIZZA</a></td><td ng-show="row.idmov1 && row.idmov1 != null && row.idmov1 > 0"><a ng-href="/#!/edit-movimento/{{row.idmov1}}">1 <i class="glyphicon glyphicon-zoom-in" tooltips="" tooltip-template="Dettagli Mov 1" tooltip-size="small"></i></a> <a ng-href="/#!/edit-movimento/{{row.idmov2}}">2 <i class="glyphicon glyphicon-zoom-in" tooltips="" tooltip-template="Dettagli Mov 2" tooltip-size="small"></i></a> <a ng-href="/#!/edit-movimento/{{row.idmov3}}">3 <i class="glyphicon glyphicon-zoom-in" tooltips="" tooltip-template="Dettagli Mov 3" tooltip-size="small"></i></a></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-items-by-page="tablePageSize" st-displayed-pages="pagesToDisplay" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div></div>');
$templateCache.put('app/contabilita/liste/liste.html','<uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Anagrafica"><div eltable="" entity="tipoanagrafica" edit="false"></div></uib-tab><uib-tab heading="Documento"><div eltable="" entity="tipodocumento" edit="false"></div></uib-tab><uib-tab heading="Pagamento"><div eltable="" entity="tipopagamento" edit="false"></div></uib-tab></uib-tabset>');
$templateCache.put('app/contabilita/movimenti/edit-movimento.html','<form name="formmovimento" ng-submit="salva()"><div ba-panel=""><div class="row"><div class="col-sm-3"><div class="form-group"><label>Num. Registrazione</label> <input ng-disabled="true" class="form-control" type="text" ng-model="movimento.header.nummov"></div></div><div class="col-sm-3"><div class="form-group"><label for="author">Data registrazione</label><div class="input-group"><input ng-disabled="movimento.header.ntsid && !editable" date2str="" forcetime="midday" model-view-value="true" ui-mask="99/99/9999" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="movimento.header.datamov" is-open="open" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-sm-2"><div class="form-group"><label for="author">Data documento</label><div class="input-group"><input ng-disabled="movimento.header.ntsid && !editable" date2str="" forcetime="midday" model-view-value="true" ui-mask="99/99/9999" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="movimento.header.datadoc" is-open="open2" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-sm-2"><div class="form-group"><label for="author">Data competenza da</label><div class="input-group"><input ng-disabled="movimento.header.ntsid && !editable" date2str="" forcetime="midday" model-view-value="true" ui-mask="99/99/9999" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="movimento.header.datacompda" is-open="open3" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open3=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-sm-2"><div class="form-group"><label for="author">a</label><div class="input-group"><input ng-disabled="movimento.header.ntsid && !editable" date2str="" forcetime="midday" model-view-value="true" ui-mask="99/99/9999" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="movimento.header.datacompa" is-open="open4" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open4=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-sm-3">Causale Contabile <a class="btn btn-primary btn-xs" ng-show="!movimento.header.ntsid && !editable && generazioneAutomaticaBtn" ng-click="generazioneAutomatica()">Generazione automatica</a><ui-select ng-disabled="movimento.header.ntsid && !editable" ng-model="dati.selectedCausale" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="{{movimento.header.causale || \'Causale Contabile\'}}">{{ $select.selected.codice }} - {{ $select.selected.descrizione }}</ui-select-match><ui-select-choices repeat="sp in causali | filter: $select.search"><span ng-bind-html="sp.codice"></span> - <span ng-bind-html="sp.descrizione"></span></ui-select-choices></ui-select></div><div class="col-sm-3">Protocollo<ui-select ng-disabled="movimento.header.ntsid && !editable" ng-model="dati.selectedProtocollo" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="{{movimento.movdett[0].protocollo || \'Protocollo\'}}">{{ $select.selected.protocollo}}</ui-select-match><ui-select-choices repeat="sp in protocolli | filter: $select.search"><span ng-bind-html="sp.protocollo"></span></ui-select-choices></ui-select></div><div class="col-sm-3" ng-if="movimento.header.causale==\'FTV\' || movimento.header.causale ==\'FTA\' || movimento.header.causale ==\'NCA\' || movimento.header.causale ==\'FAV\' || movimento.header.causale==\'NCA\' || movimento.header.causale==\'NCV\' || movimento.header.causale==\'FAV\' || movimento.header.causale==\'FAE\' || movimento.header.causale==\'FARC\' || movimento.header.causale==\'BOD\' || movimento.header.causale==\'NCE\'"><label>Tipo Pagamento</label><ui-select ng-disabled="movimento.header.ntsid && !editable" ng-model="dati.selectedTipopag" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="{{movimento.header.codicepag || \'Tipo Pagamento\'}}">{{ $select.selected.codice }}</ui-select-match><ui-select-choices repeat="sp in tipipagamento | filter: $select.search"><span ng-bind-html="sp.codice"></span> - <span ng-bind-html="sp.descrizione"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><div class="form-group"><label>Num. Documento</label> <input ng-disabled="movimento.header.ntsid && !editable" class="form-control" type="text" ng-model="movimento.header.numdoc"></div></div></div><div class="row"><div ng-if="movimento.header.id" class="col-sm-6"><label for="shortdesc">Riepilogo</label><div style="background-color:#e2e2e2;border-radius:5px;padding:15px;"><h3>Numero registrazione: {{ movimento.header.nummov }}</h3><h3 ng-if="movimento.header.causale == \'FTA\' || movimento.header.causale == \'FTV\' || movimento.header.causale == \'FARC\' || movimento.header.causale == \'FAV\' || movimento.header.causale == \'FAE\' || movimento.header.causale == \'NCV\' || movimento.header.causale == \'NCA\'">Numero protocollo: {{ movimento.header.ordinamento.substr(2, movimento.header.ordinamento.length) }}</h3></div></div><div ng-class="{\'col-sm-12\':!movimento.header.id,\'col-sm-6\':movimento.header.id}"><div class="form-group"><label for="note">Note</label> <textarea ng-model="headerNote.value" type="text" class="form-control" id="note"></textarea></div></div></div></div><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dettagli"><div class="well"><div class="row"><div class="col-md-4">Totale dare: {{movimento.totaledare/100 | number:2}} \u20AC<br>Totale avere: {{movimento.totaleavere/100 | number:2}} \u20AC</div><div class="col-md-4">Scostamento dare: {{(movimento.totaledare-movimento.totaleavere)/100 | number:2}} \u20AC<br>Scostamento avere: {{(movimento.totaleavere-movimento.totaledare)/100 | number:2}} \u20AC</div><div ng-if="movimento.moviva.length > 0" class="col-md-4">Imponibile: {{(movimento.ngimponibile)/100 | number:2}} \u20AC<br>Imposta: {{(movimento.ngimposta)/100 | number:2}} \u20AC</div></div></div><div style="width: 100%; overflow-x:scroll"><table class="table table-dettagli-movimento"><thead><tr><td ng-show="!movimento.header.id || editable">Filtra</td><td>Conto</td><td>Nome Conto</td><td>Protocollo</td><td>Partita</td><td>Dare</td><td>Avere</td><td>Data valuta</td><td>Note</td><td>Valuta</td><td ng-show="movimento.header.causale == \'FAV\' || movimento.header.causale == \'FVV\' || movimento.header.causale == \'PVAL\' || movimento.header.causale == \'VAL\'">Cambio</td><td ng-show="movimento.header.causale == \'FAV\' || movimento.header.causale == \'FVV\' || movimento.header.causale == \'PVAL\' || movimento.header.causale == \'VAL\'">Importo Valuta</td><td colspan="2">Data Competenza</td><td>Contropartita</td><td></td></tr></thead><tbody><tr ng-init="initImporto(r)" ng-repeat="r in movimento.movdett"><td ng-if="(!movimento.header.id || editable)"><select ng-if="!r.movblocked" ng-change="filtraConti(r.filtra)" class="form-control" ng-model="r.filtra"><option value="">Filtra conti...</option><option value="clienti">Clienti</option><option value="fornitori">Fornitori</option><option value="conti">Conti</option></select></td><td><span ng-if="!r.movblocked"><ui-select ng-change="aggiornaConto(r)" ng-if="(!r.filtra || r.filtra==\'conti\') && (!movimento.header.id || editable)" ng-model="r.selectedconto" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="{{r.conto || \'Cerca conto...\'}}">{{ $select.selected.codice }}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchAccounts($select.search)" refresh-delay="0" repeat="a in accounts | filter: $select.search"><span ng-bind-html="a.descrizione"></span> <span ng-bind-html="a.codice"></span></ui-select-choices></ui-select><ui-select ng-change="aggiornaConto(r)" ng-if="r.filtra==\'fornitori\' && (!movimento.header.id || editable)" ng-model="r.selectedconto" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca fornitore...">{{ $select.selected.codice }}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchSuppliers($select.search)" refresh-delay="0" repeat="s in suppliers | filter: $select.search"><span ng-bind-html="s.nome"></span> <span ng-bind-html="s.codice"></span></ui-select-choices></ui-select><ui-select ng-change="aggiornaConto(r)" ng-if="r.filtra==\'clienti\' && (!movimento.header.id || editable)" ng-model="r.selectedconto" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca cliente...">{{ $select.selected.conto }}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchCustomers($select.search)" refresh-delay="0" repeat="s in customers | filter: $select.search"><span ng-bind-html="s.fname"></span> <span ng-bind-html="s.lname"></span> <span ng-bind-html="s.conto"></span></ui-select-choices></ui-select></span> <span ng-show="movimento.header.id && (!editable || r.movblocked)">{{r.conto}}</span></td><td><span ng-if="!r.movblocked"><input ng-if="(!movimento.header.id || editable)" class="form-control" type="text" ng-model="r.selectedconto.descrizione" placeholder="{{r.selectedconto.descrizione || r.selectedconto.denominazione || r.selectedconto.nome}}"></span> <span ng-show="movimento.header.id && (!editable || r.movblocked)">{{r.selectedconto.descrizione || r.selectedconto.denominazione || r.selectedconto.nome}}</span></td><td><span ng-if="!r.movblocked"><input placeholder="Protocollo" ng-if="(!movimento.header.id || editable)" class="form-control" type="text" ng-model="r.protocollo"></span> <span ng-show="movimento.header.id && (!editable || r.movblocked)">{{r.protocollo}}</span></td><td><span ng-if="!r.movblocked"><input placeholder="Partita" ng-if="(!movimento.header.id || editable) && (!r.partite || !r.partite.length)" class="form-control" type="text" ng-model="r.partita"></span> <span ng-show="movimento.header.id && (!editable || r.movblocked)">{{r.partita}}</span> <span ng-if="!r.movblocked"><ui-select ng-if="(!movimento.header.id || editable) && r.partite && r.partite.length" ng-model="r.selectedpartita" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" ng-change="aggiornaRigaPartita(r)"><ui-select-match placeholder="Partita">{{ $select.selected.partita }}</ui-select-match><ui-select-choices repeat="sp in r.partite | filter: $select.search" style="min-width:280px;"><span ng-bind-html="sp.partita"></span> <span ng-show="sp.partdate">{{sp.partdate*1000 | date:\'dd/MM/yy\'}} -</span><span>{{(sp.dare || sp.avere)/100 | number:2}} euro</span></ui-select-choices></ui-select></span></td><td><span ng-if="!r.movblocked"><input ng-if="!movimento.header.id || editable" ng-change="setDare(r)" float2int="" class="form-control" type="text" ng-model="r.dare"></span> <span ng-show="movimento.header.id && (!editable || r.movblocked)">{{r.dare/100 | number:2}}</span></td><td><span ng-if="!r.movblocked"><input ng-if="!movimento.header.id || editable" ng-change="setAvere(r)" float2int="" class="form-control" type="text" ng-model="r.avere"></span> <span ng-show="movimento.header.id && (!editable || r.movblocked)">{{r.avere/100 | number:2}}</span></td><td><div ng-if="!r.movblocked"><div ng-if="!movimento.header.id || editable" class="form-group"><div class="input-group"><input datepicker-append-to-body="true" date2str="" model-view-value="true" ui-mask="99/99/9999" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="r.datavaluta" is-open="open[$index]" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open[$index]=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><span ng-show="movimento.header.id && (!editable || r.movblocked)">{{(r.datavaluta*1000 || \'\') | date}}</span></td><td><span ng-if="!r.movblocked"><input placeholder="Note" ng-if="!movimento.header.id || editable" class="form-control" type="text" ng-model="r.note"></span> <span ng-show="movimento.header.id && (!editable || r.movblocked)">{{r.note}}</span></td><td><span ng-if="!r.movblocked"><input placeholder="Valuta" ng-if="!movimento.header.id || editable" class="form-control" type="text" ng-model="r.valuta"></span> <span ng-show="movimento.header.id && (!editable || r.movblocked)">{{r.codvaluta}}</span></td><td ng-show="(movimento.header.causale == \'FAV\' || movimento.header.causale == \'FVV\' || movimento.header.causale == \'PVAL\' || movimento.header.causale == \'VAL\') && (!movimento.header.id || editable)"><input ng-if="!r.movblocked" class="form-control col-md-1" type="text" ng-model="r.cambio" ng-change="r.dare!=0 ? (r.impvaluta = (r.dare*r.cambio).toFixed(0)) : (r.avere!=0 ? (r.impvaluta=(r.avere*r.cambio).toFixed(0)) : r.impvaluta=0)"></td><td ng-show="(movimento.header.causale == \'FAV\' || movimento.header.causale == \'FVV\' || movimento.header.causale == \'PVAL\' || movimento.header.causale == \'VAL\') && (movimento.header.id && !editable)"><span ng-if="!r.movblocked">{{r.cambio}}</span></td><td ng-show="(movimento.header.causale == \'FAV\' || movimento.header.causale == \'FVV\' || movimento.header.causale == \'PVAL\' || movimento.header.causale == \'VAL\') && (!movimento.header.id || editable)"><input ng-if="!r.movblocked" float2int="" ng-model="r.impvaluta" class="form-control" type="text" placeholder="{{r.impvaluta/100 | number:2}}"></td><td ng-show="(movimento.header.causale == \'FAV\' || movimento.header.causale == \'FVV\' || movimento.header.causale == \'PVAL\' || movimento.header.causale == \'VAL\') && (movimento.header.id && !editable)"><span ng-if="!r.movblocked">{{r.impvaluta/100 | number:2}}</span></td><td ng-show="!movimento.header.id || editable"><div class="input-group" ng-if="!r.movblocked"><input ng-if="!movimento.header.id || editable" datepicker-append-to-body="true" date2str="" model-view-value="true" ui-mask="99/99/9999" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="r.datacompda" is-open="openc[$index]" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openc[$index]=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></td><td ng-show="!movimento.header.id || editable"><div class="input-group" ng-if="!r.movblocked"><input ng-if="!movimento.header.id || editable" datepicker-append-to-body="true" date2str="" model-view-value="true" ui-mask="99/99/9999" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="r.datacompa" is-open="openc2[$index]" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openc2[$index]=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></td><td colspan="2" ng-show="movimento.header.id && !editable"><span ng-show="r.datacompda">Da {{(r.datacompda*1000 || \'\') | date}}</span> <span ng-show="r.datacompa">a {{(r.datacompa*1000 || \'\') | date}}</span></td><td><span ng-if="!r.movblocked"><input ng-if="!movimento.header.id || editable" class="form-control" type="text" ng-model="r.contropartita"></span> <span placeholder="Contropartita" ng-show="movimento.header.id && (!editable || r.movblocked)">{{r.contropartita}}</span></td><td><a ng-if="!r.movblocked" ng-show="!movimento.header.id || editable" ng-click="eliminaRecord($index)"><i class="ion-trash-a"></i></a></td></tr></tbody></table></div><a ng-show="!movimento.header.id || editable" class="btn btn-default" ng-click="nuovoRecord()">Aggiungi Riga</a></uib-tab><uib-tab heading="Movimento Collegato" ng-if="movimento.connected"><div class="well"><div class="row"><div class="col-md-6">Totale dare: {{movimento.connected.totaledare/100 | number:2}} \u20AC<br>Totale avere: {{movimento.connected.totaleavere/100 | number:2}} \u20AC</div><div class="col-md-6">Scostamento dare: {{(movimento.connected.totaledare-movimento.connected.totaleavere)/100 | number:2}} \u20AC<br>Scostamento avere: {{(movimento.connected.totaleavere-movimento.connected.totaledare)/100 | number:2}} \u20AC</div></div></div><div style="width: 100%; overflow-x:scroll"><table class="table table-dettagli-movimento"><thead><tr><td ng-show="false && !movimento.connected.header.id">Filtra</td><td>Conto</td><td>Nome Conto</td><td>Protocollo</td><td>Partita</td><td>Dare</td><td>Avere</td><td>Data valuta</td><td>Note</td><td>Valuta</td><td>Cambio</td><td>Importo Valuta</td><td colspan="{{movimento.connected.header.id ? \'1\': \'2\'}}">Data Competenza</td><td>Contropartita</td><td></td></tr></thead><tbody><tr ng-init="initImporto(r)" ng-repeat="r in movimento.movdett"><td ng-if="true || !movimento.connected.header.id"><select ng-change="filtraConti(r.filtra)" class="form-control" ng-model="r.filtra"><option value="">Filtra conti...</option><option value="clienti">Clienti</option><option value="fornitori">Fornitori</option><option value="conti">Conti</option></select></td><td><ui-select ng-change="aggiornaConto(r)" ng-if="(!r.filtra || r.filtra==\'conti\') && false && !movimento.connected.header.id" ng-model="r.selectedconto" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="{{r.conto || \'Cerca conto...\'}}">{{ $select.selected.codice }}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchAccounts($select.search)" refresh-delay="0" repeat="a in accounts | filter: $select.search"><span ng-bind-html="a.descrizione"></span> <span ng-bind-html="a.codice"></span></ui-select-choices></ui-select><ui-select ng-change="aggiornaConto(r)" ng-if="r.filtra==\'fornitori\' && false && !movimento.connected.header.id" ng-model="r.selectedconto" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca fornitore...">{{ $select.selected.codice }}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchSuppliers($select.search)" refresh-delay="0" repeat="s in suppliers | filter: $select.search"><span ng-bind-html="s.nome"></span> <span ng-bind-html="s.codice"></span></ui-select-choices></ui-select><ui-select ng-change="aggiornaConto(r)" ng-if="r.filtra==\'clienti\' && false && !movimento.connected.header.id" ng-model="r.selectedconto" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca cliente...">{{ $select.selected.conto }}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchCustomers($select.search)" refresh-delay="0" repeat="s in customers | filter: $select.search"><span ng-bind-html="s.fname"></span> <span ng-bind-html="s.lname"></span> <span ng-bind-html="s.conto"></span></ui-select-choices></ui-select><span ng-show="true || movimento.connected.header.id">{{r.conto}}</span></td><td><input ng-if="false && !movimento.connected.header.id" class="form-control" type="text" ng-model="r.selectedconto.descrizione" placeholder="{{r.selectedconto.descrizione || r.selectedconto.denominazione || r.selectedconto.nome}}"> <span ng-show="true || movimento.connected.header.id">{{r.selectedconto.descrizione || r.selectedconto.denominazione || r.selectedconto.nome}}</span></td><td><input placeholder="Protocollo" ng-if="false && !movimento.connected.header.id" class="form-control" type="text" ng-model="r.protocollo"> <span ng-show="true || movimento.connected.header.id">{{r.protocollo}}</span></td><td><input placeholder="Partita" ng-if="false && !movimento.connected.header.id && (!r.partite || !r.partite.length)" class="form-control" type="text" ng-model="r.partita"> <span ng-show="true || movimento.connected.header.id">{{r.partita}}</span><ui-select ng-if="!movimento.connected.header.ntsid && r.partite && r.partite.length" ng-model="r.selectedpartita" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" ng-change="aggiornaRigaPartita(r)"><ui-select-match placeholder="Partita">{{ $select.selected.partita }}</ui-select-match><ui-select-choices repeat="sp in r.partite | filter: $select.search"><span ng-bind-html="sp.partita"></span> <span>{{sp.dare}}</span></ui-select-choices></ui-select></td><td><input ng-if="false && !movimento.connected.header.id" ng-change="setDare(r)" float2int="" class="form-control" type="text" ng-model="r.dare"> <span ng-show="true || movimento.connected.header.id">{{r.dare/100 | number:2}}</span></td><td><input ng-if="false && !movimento.connected.header.id" ng-change="setAvere(r)" float2int="" class="form-control" type="text" ng-model="r.avere"> <span ng-show="true || movimento.connected.header.id">{{r.avere/100 | number:2}}</span></td><td><div ng-if="false && !movimento.connected.header.id" class="form-group"><div class="input-group"><input datepicker-append-to-body="true" date2str="" model-view-value="true" ui-mask="99/99/9999" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="r.datavaluta" is-open="open[$index]" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open[$index]=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><span ng-show="true || movimento.connected.header.id">{{(r.datavaluta*1000 || \'\') | date}}</span></td><td><input placeholder="Note" ng-if="false && !movimento.connected.header.id" class="form-control" type="text" ng-model="r.note"> <span ng-show="true || movimento.connected.header.id">{{r.note}}</span></td><td><input placeholder="Valuta" ng-if="false && !movimento.connected.header.id" class="form-control" type="text" ng-model="r.valuta"> <span ng-show="true || movimento.connected.header.id">{{r.codvaluta}}</span></td><td><input ng-if="false && !movimento.connected.header.id" class="form-control" type="text" ng-model="r.cambio"> <span ng-show="true || movimento.connected.header.id">{{r.cambio}}</span></td><td><input ng-disabled="true" ng-if="false && !movimento.connected.header.id" class="form-control" type="text" placeholder="{{r.dare ? (r.dare/100 | number:2) : (r.avere/100 | number:2)}}"> <span ng-show="true || movimento.connected.header.id">{{r.impvaluta/100 | number:2}}</span></td><td ng-show="false && !movimento.connected.header.id"><div ng-if="false && true || !movimento.connected.header.id" class="input-group"><input ng-if="false && true || !movimento.connected.header.id" datepicker-append-to-body="true" date2str="" model-view-value="true" ui-mask="99/99/9999" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="r.datacompda" is-open="openc[$index]" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openc[$index]=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></td><td><div ng-if="false && !movimento.connected.header.id" class="input-group"><input datepicker-append-to-body="true" date2str="" model-view-value="true" ui-mask="99/99/9999" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="r.datacompa" is-open="openc2[$index]" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openc2[$index]=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div><span ng-show="true || movimento.connected.header.id"><span ng-show="r.datacompda">Da {{(r.datacompda*1000 || \'\') | date}}</span> <span ng-show="r.datacompa">Da {{(r.datacompa*1000 || \'\') | date}}</span></span></td><td><input ng-if="false && !movimento.connected.header.id" class="form-control" type="text" ng-model="r.contropartita"> <span placeholder="Contropartita" ng-show="true || movimento.connected.header.id">{{r.contropartita}}</span></td><td><a ng-show="false && !movimento.connected.header.id" ng-click="eliminaRecord($index)"><i class="ion-trash-a"></i></a></td></tr></tbody></table></div><a ng-show="false && !movimento.connected.header.id" class="btn btn-default" ng-click="nuovoRecord()">Aggiungi Riga</a></uib-tab><uib-tab heading="Movimenti Iva"><div style="width: 100%; overflow-x:scroll"><table class="table table-dettagli-movimento" ng-class="{\'table-striped\': !editable}"><thead><tr><td>Anno</td><td>Codice</td><td>Codice Iva</td><td>Codice Valuta</td><td>Imponibile</td><td>Imponibile Valuta</td><td>Imposta</td><td>Impostanovent</td><td>Imposta Valuta</td><td>Protocollo</td><td>Tipo</td></tr></thead><tbody><tr ng-repeat="i in movimento.moviva"><td ng-style="editable ? { \'padding-bottom\': \'10px\' } : \'\'"><input placeholder="Anno" ng-if="!movimento.header.id || (editable && !i.paginaregistro)" class="form-control" type="text" ng-model="i.anno"> <span ng-if="movimento.header.id" ng-hide="(editable && !i.paginaregistro)">{{i.anno}}</span></td><td><input placeholder="Codice" ng-if="!movimento.header.id || (editable && !i.paginaregistro)" class="form-control" type="text" ng-model="i.codice"> <span ng-if="movimento.header.id" ng-hide="(editable && !i.paginaregistro)">{{i.codice}}</span></td><td><input placeholder="Codice Iva" ng-if="!movimento.header.id || (editable && !i.paginaregistro)" class="form-control" type="text" ng-model="i.codiceiva"> <span ng-if="movimento.header.id" ng-hide="(editable && !i.paginaregistro)">{{i.codiceiva}}</span></td><td><input placeholder="Codice Valuta" ng-if="!movimento.header.id || (editable && !i.paginaregistro)" class="form-control" type="text" ng-model="i.codvaluta"> <span ng-if="movimento.header.id" ng-hide="(editable && !i.paginaregistro)">{{i.codvaluta}}</span></td><td><input placeholder="Imponibile" float2int="" ng-if="!movimento.header.id || (editable && !i.paginaregistro)" class="form-control" type="text" ng-model="i.imponibile" ng-change="calcolaTotali(movimento)"> <span ng-if="movimento.header.id" ng-hide="(editable && !i.paginaregistro)">{{i.imponibile/100 | number:2}}</span></td><td><input placeholder="Imponibile Valuta" float2int="" ng-if="!movimento.header.id || (editable && !i.paginaregistro)" class="form-control" type="text" ng-model="i.imponibilevaluta" ng-change="calcolaTotali(movimento)"> <span ng-if="movimento.header.id" ng-hide="(editable && !i.paginaregistro)">{{i.imponibilevaluta/100 | number:2}}</span></td><td><input placeholder="Imposta" float2int="" ng-if="!movimento.header.id || (editable && !i.paginaregistro)" class="form-control" type="text" ng-model="i.imposta" ng-change="calcolaTotali(movimento)"> <span ng-if="movimento.header.id" ng-hide="(editable && !i.paginaregistro)">{{i.imposta/100 | number:2}}</span></td><td><input placeholder="Impostanovent" float2int="" ng-if="!movimento.header.id || (editable && !i.paginaregistro)" class="form-control" type="text" ng-model="i.impostanovent" ng-change="calcolaTotali(movimento)"> <span ng-if="movimento.header.id" ng-hide="(editable && !i.paginaregistro)">{{i.impostanovent/100 | number:2}}</span></td><td><input placeholder="Imposta Valuta" float2int="" ng-if="!movimento.header.id || (editable && !i.paginaregistro)" class="form-control" type="text" ng-model="i.impostavaluta" ng-change="calcolaTotali(movimento)"> <span ng-if="movimento.header.id" ng-hide="(editable && !i.paginaregistro)">{{i.impostavaluta/100 | number:2}}</span></td><td><input placeholder="Protocollo" ng-if="!movimento.header.id || (editable && !i.paginaregistro)" class="form-control" type="text" ng-model="i.protocollo"> <span ng-if="movimento.header.id" ng-hide="(editable && !i.paginaregistro)">{{i.protocollo}}</span></td><td><input placeholder="Tipo" ng-if="!movimento.header.id || (editable && !i.paginaregistro)" class="form-control" type="text" ng-model="i.tipo"> <span ng-if="movimento.header.id" ng-hide="(editable && !i.paginaregistro)">{{i.tipo}}</span></td></tr></tbody></table></div><a ng-if="(!movimento.header.id || editable) && !newMov" class="btn btn-default" ng-click="nuovoRecordIva()">Aggiungi Riga</a></uib-tab><uib-tab heading="Gestione Ritenuta"><div style="width: 100%; overflow-x:scroll"><table ng-show="movimento.movra && movimento.movra.length" class="table table-dettagli-movimento" ng-class="{\'table-striped\': !editable}"><thead><tr><td>Codice</td><td>Codice Imposta</td><td>Compenso</td><td>Iva</td><td>Imponibile RA</td><td>Data Documento</td><td>Non soggetto</td><td>Protocollo</td><td>Anno</td><td>Partita</td><td>Ritenuta</td><td>Spese Anticipate</td><td>Cassa</td></tr></thead><tbody><tr ng-repeat="r in movimento.movra"><td ng-style="editable ? { \'padding-bottom\': \'10px\' } : \'\'"><input placeholder="Codice" ng-if="!movimento.header.id || editable" class="form-control" type="text" ng-model="r.codice"> <span ng-if="movimento.header.id" ng-hide="editable">{{r.codice}}</span></td><td><input placeholder="Codice Imposta" ng-if="!movimento.header.id || editable" class="form-control" type="text" ng-model="r.codimposta"> <span ng-if="movimento.header.id" ng-hide="editable">{{r.codimposta}}</span></td><td><input placeholder="Compenso" float2int="" ng-if="!movimento.header.id || editable" class="form-control" type="text" ng-model="r.compenso"> <span ng-if="movimento.header.id" ng-hide="editable">{{r.compenso/100 | number:2}}</span></td><td><input placeholder="Iva" float2int="" ng-if="!movimento.header.id || editable" class="form-control" type="text" ng-model="r.iva"> <span ng-if="movimento.header.id" ng-hide="editable">{{r.iva/100 | number:2}}</span></td><td><input placeholder="Imponibile" float2int="" ng-if="!movimento.header.id || editable" class="form-control" type="text" ng-model="r.imponibile"> <span ng-if="movimento.header.id" ng-hide="editable">{{r.imponibile/100 | number:2}}</span></td><td><div ng-if="!movimento.header.id || editable" class="form-group"><div class="input-group"><input placeholder="Data Documento" datepicker-append-to-body="true" date2str="" model-view-value="true" ui-mask="99/99/9999" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="r.datadoc" is-open="openra[$index]" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openra[$index]=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></td><td><input placeholder="Non soggetto" ng-if="!movimento.header.id || editable" class="form-control" type="text" ng-model="r.nonosggetto"> <span ng-if="movimento.header.id" ng-hide="editable">{{(r.nonsoggetto/100).toFixed(2)}}</span></td><td><input placeholder="Protocollo" ng-if="!movimento.header.id || editable" class="form-control" type="text" ng-model="r.numprotocollo"> <span ng-if="movimento.header.id" ng-hide="editable">{{r.numprotocollo}}</span></td><td><input placeholder="Anno" ng-if="!movimento.header.id || editable" class="form-control" type="text" ng-model="r.paranno"> <span ng-if="movimento.header.id" ng-hide="editable">{{r.paranno}}</span></td><td><input placeholder="Partita" ng-if="!movimento.header.id || editable" class="form-control" type="text" ng-model="r.partita"> <span ng-if="movimento.header.id" ng-hide="editable">{{r.partita}}</span></td><td><input placeholder="Ritenuta" float2int="" ng-if="!movimento.header.id || editable" class="form-control" type="text" ng-model="r.ritenuta"> <span ng-if="movimento.header.id" ng-hide="editable">{{r.ritenuta/100 | number:2}}</span></td><td><input placeholder="Spese Anticipate" float2int="" ng-if="!movimento.header.id || editable" class="form-control" type="text" ng-model="r.speseanticipate"> <span ng-if="movimento.header.id" ng-hide="editable">{{r.speseanticipate/100 | number:2}}</span></td><td><input placeholder="Cassa Prev." float2int="" ng-if="!movimento.header.id || editable" class="form-control" type="text" ng-model="r.cassaprev"> <span ng-if="movimento.header.id" ng-hide="editable">{{r.cassaprev/100 | number:2}}</span></td></tr></tbody></table></div><a ng-if="(!movimento.header.id || editable) && !newMov" class="btn btn-default" ng-click="nuovoRecordRa()">Aggiungi Riga</a></uib-tab></uib-tabset><div align="center" style="margin-top: 20px;"><div ng-if="editable && movBloccati > 0" class="mov-bloccati">Mov. IVA bloccati</div><button ng-hide="movimento.header.id && !editable" ng-disabled="checkSalvaMovimento()" class="btn btn-primary" type="submit">Salva Movimento</button> <a ng-show="!movimento.header.id" ng-click="resetMovimento()" class="btn btn-warning" type="submit">Reset</a> <a ng-hide="!movimento.header.id || editable" ui-sref="contabilita.new-movimento" class="btn btn-primary" type="submit">Nuovo movimento</a> <a ng-disabled="editable" ng-hide="!movimento.header.id" ng-click="editable || makeEditable();" class="btn btn-success" type="submit">Modifica Movimento</a> <a ng-hide="!movimento.header.id" ng-click="deleteMovimento()" class="btn btn-danger" type="submit">Elimina Movimento</a> <button ng-if="enableBackToSearchBtn" type="button" class="btn btn-warning" ng-click="backToSearch();">TORNA ALLA RICERCA MOVIMENTI</button><br><br></div></div></form>');
$templateCache.put('app/contabilita/movimenti/generazioneautomatica-dialog.html','<div class="modal-content generazione-automatica"><form name="lang" ng-submit="salva()"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Generazione automatica</h4></div><div class="modal-body"><div class="row"><div ng-if="movimento.header.causale==\'FTA\' || movimento.header.causale==\'NCA\' || movimento.header.causale==\'FAV\' || movimento.header.causale==\'PAGA\' || movimento.header.causale==\'PAGB\' || movimento.header.causale==\'FARC\' || movimento.header.causale==\'FAE\' || movimento.header.causale==\'FAEX\' || movimento.header.causale == \'NCE\' || movimento.header.causale == \'NCEX\' || movimento.header.causale == \'NCRC\'" class="col-sm-4"><label>Fornitore</label><ui-select ng-model="datirequest.selectedFornitore" ng-change="setTdsdi()" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca...">{{ $select.selected.nome }} {{ $select.selected.codice }}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchFornitore($select.search)" refresh-delay="0" repeat="sp in fornitori | filter: $select.search"><span ng-bind-html="sp.nome"></span> <span ng-bind-html="sp.codice"></span></ui-select-choices></ui-select></div><div class="col-sm-4" ng-if="datirequest.selectedFornitore && showTDSDISelect"><div class="form-group"><label for="tdsdi">TD SDI *</label><select name="tdsdi" required="" class="form-control" ng-model="request.tdsdi"><option value="">-- Seleziona --</option><option value="TD17">TD17</option><option value="TD18">TD18</option><option value="TD19">TD19</option></select></div></div><div ng-if="(movimento.header.causale==\'FTA\' || movimento.header.causale==\'NCA\' || movimento.header.causale==\'FAV\') && datirequest.selectedFornitore && datirequest.selectedFornitore.percipiente" class="form-group col-sm-4"><label for="fname">Importo non soggetto a ritenuta</label> <input required="" ng-model="request.nonsoggra" float2int="" type="text" class="form-control" id="fname" placeholder="Non soggetto a RA"></div><div ng-if="(movimento.header.causale==\'FTA\' || movimento.header.causale==\'NCA\' || movimento.header.causale==\'FAV\') && datirequest.selectedFornitore && datirequest.selectedFornitore.percipiente" class="form-group col-sm-4"><label for="fname">Spese anticipate</label> <input required="" ng-model="request.speseanticipate" float2int="" type="text" class="form-control" id="fname" placeholder="Spese anticipate"></div><div ng-if="movimento.header.causale==\'FTV\' || movimento.header.causale==\'NCV\' || movimento.header.causale==\'INCA\'" class="col-sm-6"><label>Cliente</label><ui-select ng-model="datirequest.selectedCliente" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca...">{{ $select.selected.fname }} {{ $select.selected.lname }} {{ $select.selected.denominazione!=($select.selected.lname+\' \'+$select.selected.fname) ? $select.selected.denominazione : \'\' }} {{movimento.header.causale==\'INCA\' ? $select.selected.conto : \'\'}}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchCliente($select.search)" refresh-delay="0" repeat="sp in clienti | filter: $select.search"><span ng-bind-html="sp.fname"></span> <span ng-bind-html="sp.lname"></span> <span ng-show="sp.denominazione!=sp.lname+\' \'+sp.fname" ng-bind-html="sp.denominazione"></span> <span ng-bind-html="sp.conto"></span></ui-select-choices></ui-select></div><div ng-if="movimento.header.causale==\'PAGA\' || movimento.header.causale==\'PAGB\'" class="col-sm-4"><label>Conto Banca</label><ui-select ng-required="true" ng-model="datirequest.selectedConto" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" ng-change="aggiornaRighePaga()"><ui-select-match placeholder="Cerca conto...">{{ $select.selected.codice }}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchAccounts($select.search)" refresh-delay="0" repeat="a in accounts | filter: $select.search"><span ng-bind-html="a.descrizione"></span> <span ng-bind-html="a.codice"></span></ui-select-choices></ui-select></div><div ng-if="movimento.header.causale==\'PAGA\' || movimento.header.causale==\'PAGB\'" class="form-group col-sm-4"><label for="fname">Spese Pagamento</label> <input required="" ng-model="request.spesepagamento" float2int="" type="text" class="form-control" id="fname" placeholder="Spese Pagamento"></div><div ng-if="movimento.header.causale==\'NCV\'" class="form-group col-sm-4"><label for="fname">Spese Bancarie</label> <input required="" ng-model="request.ncvspese" float2int="" type="text" class="form-control" id="fname" placeholder="Spese Bancarie"></div><div ng-if="movimento.header.causale==\'INCA\'" class="form-group col-sm-4"><label for="fname">Importo</label> <input required="" ng-model="request.importo" float2int="" type="text" class="form-control" id="fname" placeholder="Importo"></div><div ng-if="movimento.header.causale==\'INCA\'" class="col-sm-12"><label>Partite Aperte</label><ui-select ng-disabled="!partite || !partite.length" multiple="" ng-model="request.partite" class="btn-group bootstrap-select form-control"><ui-select-match placeholder="Cerca partite..."><span>{{$item.partita}}<span></span></span></ui-select-match><ui-select-choices repeat="p in partite | filter: $select.search"><span class="fix-gray" ng-bind-html="p.partita"></span> <span class="fix-gray" ng-bind-html="p.conto"></span> <span class="fix-gray" ng-show="p.partdate">{{p.partdate*1000 | date:\'dd/MM/yy\'}} -</span><span class="fix-gray">{{(p.dare || p.avere)/100 | number:2}} euro</span></ui-select-choices></ui-select></div><div class="col-sm-12" ng-if="movimento.header.causale==\'FTV\' || movimento.header.causale==\'NCV\' || movimento.header.causale==\'FTA\' || movimento.header.causale==\'NCA\' || movimento.header.causale==\'FAV\' || movimento.header.causale==\'FARC\' || movimento.header.causale==\'FAE\' || movimento.header.causale==\'FAEX\' || movimento.header.causale==\'PAGA\' || movimento.header.causale==\'PAGB\' || movimento.header.causale == \'NCE\' || movimento.header.causale == \'NCEX\' || movimento.header.causale == \'NCRC\'"><table class="table table-dettagli-movimento"><thead></thead><td ng-if="movimento.header.causale==\'FTV\' || movimento.header.causale==\'NCV\' || movimento.header.causale==\'FTA\' || movimento.header.causale==\'NCA\' || movimento.header.causale==\'FAV\' || movimento.header.causale==\'FARC\' || movimento.header.causale==\'FAE\' || movimento.header.causale==\'FAEX\' || movimento.header.causale == \'NCE\' || movimento.header.causale == \'NCEX\' || movimento.header.causale == \'NCRC\'">Codice iva</td><td ng-if="movimento.header.causale==\'PAGA\' || movimento.header.causale==\'PAGB\'">Partita</td><td>Note</td><td>Importo</td><td ng-if="movimento.header.causale==\'FAV\'">Valuta</td><td ng-if="movimento.header.causale==\'FAV\'">Importo Valuta</td><td ng-if="movimento.header.causale==\'FAV\'">Tasso di cambio</td><td ng-show="!movimento.header.id"></td><tbody><tr ng-repeat="l in request.lines"><td ng-if="movimento.header.causale==\'FTV\' || movimento.header.causale==\'NCV\' || movimento.header.causale==\'FTA\' || movimento.header.causale==\'NCA\'|| movimento.header.causale==\'FAV\' || movimento.header.causale==\'FARC\' || movimento.header.causale==\'FAE\' || movimento.header.causale==\'FAEX\' || movimento.header.causale == \'NCE\' || movimento.header.causale == \'NCEX\' || movimento.header.causale == \'NCRC\'"><div class="form-group"><select ng-model="l.codiceiva" class="form-control" title="Codice IVA"><option ng-repeat="tipo in codiciiva" ng-value="tipo.codice">{{tipo.codice}} - {{tipo.descrizione}}</option></select></div></td><td ng-if="movimento.header.causale==\'PAGA\' || movimento.header.causale==\'PAGB\'"><ui-select class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-disabled="!partite || !partite.length" ng-model="l.selectedpartita" ng-change="aggiornaRighePaga(l)" close-on-select="true" title="Partite Aperte"><ui-select-match placeholder="Cerca partite...">{{$select.selected.partita}}</ui-select-match><ui-select-choices repeat="p in partite | filter: $select.search"><span ng-bind-html="p.partita"></span> - <span ng-bind-html="p.conto"></span> <span ng-show="p.partdate">{{p.partdate*1000 | date:\'dd/MM/yy\'}} -</span> <span>{{(p.importo)/100 | number:2}} euro</span></ui-select-choices></ui-select></td><td><input class="form-control" type="text" ng-model="l.note"></td><td><input float2int="" class="form-control" type="text" ng-model="l.importo"></td><td ng-if="movimento.header.causale==\'FAV\'"><select class="form-control" type="text" ng-model="l.valuta"><option value="USD">USD</option><option value="USD">GBP</option><option value="USD">EUR</option></select></td><td ng-if="movimento.header.causale==\'FAV\'"><input float2int="" class="form-control" type="text" ng-model="l.importoval"></td><td ng-if="movimento.header.causale==\'FAV\'"><input float2int="" decimals="4" class="form-control" type="text" ng-model="l.tasso"></td><td><a ng-show="!movimento.header.id" ng-click="eliminaLine($index)"><i class="ion-trash-a"></i></a></td></tr></tbody><tfoot><td><a class="btn btn-default btn-xs" ng-click="nuovaLine()">Aggiungi riga</a></td></tfoot></table></div></div></div><div class="modal-footer"><a ng-click="cancel()" class="btn btn-default">Annulla</a> <button type="submit" ng-disabled="(movimento.header.causale===\'PAGA\' || movimento.header.causale===\'PAGB\') && request.contobanca===undefined" class="btn btn-primary">Procedi</button></div></form></div>');
$templateCache.put('app/contabilita/movimenti/pagination.html','<div class="pagination" ng-if="pages.length >= 2"><ul class="pagination"><li><a ng-click="selectPage(1)" aria-label="First"><span aria-hidden="true">first</span></a></li><li><a ng-click="selectPage(currentPage-1)" aria-label="Previous"><span aria-hidden="true">&larr;</span></a></li><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a ng-click="selectPage(page)">{{page}}</a></li><li><a ng-click="selectPage(currentPage+1)" aria-label="Next"><span aria-hidden="true">&rarr;</span></a></li><li><a href="" ng-click="selectPage(numPages)" aria-label="Last"><span aria-hidden="true">last</span></a></li></ul></div>');
$templateCache.put('app/contabilita/movimenti/ricerca.html','<div class="row"><div ba-panel=""><form ng-submit="applyDateTo(); cerca()"><h3>Ricerca</h3><div class="row ricerca_movimenti"><div class="col-xs-12"><div class="col-xs-3"><label>Cliente</label><ui-select ng-model="dati.selectedCustomer" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca cliente...">{{ $select.selected.denominazione }}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchCustomers($select.search)" refresh-delay="0" repeat="c in customers | filter: $select.search"><span ng-bind-html="c.denominazione+\' \'+c.conto"></span></ui-select-choices></ui-select></div><div class="col-xs-3"><label>Fornitore</label><ui-select ng-model="dati.selectedSupplier" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca fornitore...">{{ $select.selected.nome }}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchSuppliers($select.search)" refresh-delay="0" repeat="s in suppliers | filter: $select.search"><span ng-bind-html="s.nome+\' \'+s.codice"></span></ui-select-choices></ui-select></div><div class="col-xs-3"><label>Conto da</label><ui-select ng-model="dati.selectedAccountFrom" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca conto...">{{ $select.selected.descrizione }} - {{ $select.selected.codice }}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchAccounts($select.search)" refresh-delay="0" repeat="a in accounts | filter: $select.search"><span ng-bind-html="a.descrizione"></span> - <span ng-bind-html="a.codice"></span></ui-select-choices></ui-select></div><div class="col-xs-3"><label>Conto a</label><ui-select ng-model="dati.selectedAccountTo" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca conto...">{{ $select.selected.descrizione }} - {{ $select.selected.codice }}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchAccounts($select.search)" refresh-delay="0" repeat="a in accounts | filter: $select.search"><span ng-bind-html="a.descrizione"></span> - <span ng-bind-html="a.codice"></span></ui-select-choices></ui-select></div></div></div><br><div class="row"><div class="col-xs-12"><div class="col-xs-3"><label>Dal</label><div class="input-group"><input type="text" date2str="" forcetime="down" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="ricerca.datefrom" is-open="popUpDate1" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate1 = !popUpDate1"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3"><label>Al</label><div class="input-group"><input type="text" date2str="" forcetime="up" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="ricerca.dateto" is-open="popUpDate2" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate2 = !popUpDate2"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-2"><label>Partita</label> <input type="text" class="form-control" ng-model="ricerca.partita"></div><div class="col-xs-2"><label>Numero Registrazione</label> <input type="text" class="form-control" ng-model="ricerca.nummov"></div><div class="col-xs-2"><label>Causale</label><select class="form-control" ng-model="ricerca.causale"><option value="ACC">ACC</option><option value="ACCR">ACCR</option><option value="ADD">ADD</option><option value="AMM">AMM</option><option value="AMM1">AMM1</option><option value="AMMO">AMMO</option><option value="ASS">ASS</option><option value="BAC">BAC</option><option value="BAD">BAD</option><option value="BAF">BAF</option><option value="BAP">BAP</option><option value="BCH">BCH</option><option value="BOD">BOD</option><option value="CO1">CO1</option><option value="CO2">CO2</option><option value="CO3">CO3</option><option value="CO4">CO4</option><option value="CO5">CO5</option><option value="CO6">CO6</option><option value="COBA">COBA</option><option value="COR">COR</option><option value="DICH">DICH</option><option value="EMRB">EMRB</option><option value="FAE">FAE</option><option value="FAEX">FAEX</option><option value="FARC">FARC</option><option value="FAV">FAV</option><option value="FTA">FTA</option><option value="FTV">FTV</option><option value="FVC">FVC</option><option value="FVRC">FVRC</option><option value="FVS">FVS</option><option value="FVV">FVV</option><option value="GIRO">GIRO</option><option value="IFM">IFM</option><option value="INCA">INCA</option><option value="INCB">INCB</option><option value="INS">INS</option><option value="ISO">ISO</option><option value="MPS">MPS</option><option value="NCA">NCA</option><option value="NCE">NCE</option><option value="NCEX">NCEX</option><option value="NCRC">NCRC</option><option value="NCS">NCS</option><option value="NCV">NCV</option><option value="PAGA">PAGA</option><option value="PAGB">PAGB</option><option value="PCOL">PCOL</option><option value="PREL">PREL</option><option value="PVAL">PVAL</option><option value="RAT">RAT</option><option value="RETT">RETT</option><option value="RIS">RIS</option><option value="RIT">RIT</option><option value="RL">RL</option><option value="RTS">RTS</option><option value="SAL">SAL</option><option value="SCO">SCO</option><option value="STIP">STIP</option><option value="VAL">VAL</option><option value="VEN">VEN</option><option value="VERS">VERS</option></select></div></div></div><div class="row"><div class="col-xs-12"><div class="col-xs-3"></div><div class="col-xs-3"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-checked="ricerca.resetprog == 1" ng-true-value="1" ng-false-value="0" id="featured" ng-model="ricerca.resetprog"> <span>Resetta progressivo</span></label></div></div><div class="col-xs-3"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-checked="ricerca.noinca == 1" ng-true-value="1" ng-false-value="0" id="featured" ng-model="ricerca.noinca"> <span>Escludi INCA</span></label></div></div></div></div><div class="col-xs-9"><p class="text-danger">{{ error }}</p></div><div class="col-xs-1 text-right"><button type="button" class="btn btn-danger" ng-click="emptySearch();">Svuota ricerca</button></div><div class="col-xs-1 text-right"><button type="button" class="btn btn-default" ng-click="advancedExport();">Esporta</button></div><div class="col-xs-1 text-right"><button type="submit" class="btn btn-primary">Cerca</button></div></form></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><a class="btn btn-primary" ng-show="enablePrint" style="float:right;" ng-click="print();">STAMPA <i class="fa fa-print fa-lg" aria-hidden="true"></i></a><table ng-show="fairicerca" class="table" st-table="items" st-pipe="loadMovimenti"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th>Data reg.</th><th>Num. reg.</th><th>Data doc.</th><th ng-if="((ricerca.fornitore || ricerca.cliente) && (!ricerca.contofrom && !ricerca.contoto))">Num. fatt.</th><th ng-if="((ricerca.fornitore || ricerca.cliente) && (!ricerca.contofrom && !ricerca.contoto))" width="5%">Protocollo</th><th ng-if="((ricerca.fornitore || ricerca.cliente) && (!ricerca.contofrom && !ricerca.contoto))">Partita</th><th>Causale</th><th>Note</th><th>Dare</th><th>Avere</th><th>Saldo</th><th></th></tr><tr><th></th><th></th><th></th><th></th><th ng-if="((ricerca.fornitore || ricerca.cliente) && (!ricerca.contofrom && !ricerca.contoto))"></th><th ng-if="((ricerca.fornitore || ricerca.cliente) && (!ricerca.contofrom && !ricerca.contoto))"></th><th ng-if="((ricerca.fornitore || ricerca.cliente) && (!ricerca.contofrom && !ricerca.contoto))"></th><th></th><th></th><th></th><th></th><th>Saldo pagina precedente: {{items.saldoprec/100 | number:2}}</th></tr></thead><tbody><tr ng-repeat="item in items.data"><td>{{item.id}}</td><td><b>{{item.datamov*1000 | date:\'dd/MM/yy\'}}</b></td><td><b>{{item.nummov}}</b></td><td><b>{{item.datadoc*1000 | date:\'dd/MM/yy\'}}</b></td><td ng-if="((ricerca.fornitore || ricerca.cliente) && (!ricerca.contofrom && !ricerca.contoto))"><b>{{item.numdoc}}</b></td><td ng-if="((ricerca.fornitore || ricerca.cliente) && (!ricerca.contofrom && !ricerca.contoto))" class="text-center">{{item.protocollo}}</td><td ng-if="((ricerca.fornitore || ricerca.cliente) && (!ricerca.contofrom && !ricerca.contoto))">{{ item.partita }}</td><td class="text-center">{{item.causale}}</td><td><span tooltips="" tooltip-template="{{(item.note || item.detnote)}}">{{(item.note || item.detnote) | limitTo: 20 }} {{ (item.note.length || item.detnote.length) > 20 ? \'...\' : \'\' }}</span></td><td>{{item.segno == \'D\' ? (item.importo/100 | number : 2) : \'\' }}</td><td>{{item.segno == \'A\' ? (item.importo/100 | number : 2) : \'\' }}</td><td>{{ item.saldo/100 | number : 2 }}</td><td><a ng-click="editMovimento(item.ntsid);" href=""><i class="glyphicon glyphicon-zoom-in" tooltips="" tooltip-template="Dettagli" tooltip-size="small"></i></a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5" st-template="app/contabilita/movimenti/pagination.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/contabilita/movimenti/ricercaiva.html','<div class="row"><div ba-panel=""><form ng-submit="applyDateTo(); cerca();"><h3>Ricerca</h3><div class="row ricerca_movimenti"><div class="col-xs-12"><div class="col-xs-3"><label>Dal</label><div class="input-group"><input type="text" date2str="" forcetime="down" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="ricerca.datefrom" is-open="popUpDate1" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate1 = !popUpDate1"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3"><label>Al</label><div class="input-group"><input type="text" date2str="" forcetime="up" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="ricerca.dateto" is-open="popUpDate2" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate2 = !popUpDate2"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-2"><label>Causale</label><select class="form-control" ng-model="ricerca.causale"><option value="ACC">ACC</option><option value="ACCR">ACCR</option><option value="ADD">ADD</option><option value="AMM">AMM</option><option value="AMM1">AMM1</option><option value="AMMO">AMMO</option><option value="ASS">ASS</option><option value="BAC">BAC</option><option value="BAD">BAD</option><option value="BAF">BAF</option><option value="BAP">BAP</option><option value="BCH">BCH</option><option value="BOD">BOD</option><option value="CO1">CO1</option><option value="CO2">CO2</option><option value="CO3">CO3</option><option value="CO4">CO4</option><option value="CO5">CO5</option><option value="CO6">CO6</option><option value="COBA">COBA</option><option value="COR">COR</option><option value="DICH">DICH</option><option value="EMRB">EMRB</option><option value="FAE">FAE</option><option value="FAEX">FAEX</option><option value="FARC">FARC</option><option value="FAV">FAV</option><option value="FTA">FTA</option><option value="FTV">FTV</option><option value="FVC">FVC</option><option value="FVRC">FVRC</option><option value="FVS">FVS</option><option value="FVV">FVV</option><option value="GIRO">GIRO</option><option value="IFM">IFM</option><option value="INCA">INCA</option><option value="INCB">INCB</option><option value="INS">INS</option><option value="ISO">ISO</option><option value="MPS">MPS</option><option value="NCA">NCA</option><option value="NCE">NCE</option><option value="NCEX">NCEX</option><option value="NCRC">NCRC</option><option value="NCS">NCS</option><option value="NCV">NCV</option><option value="PAGA">PAGA</option><option value="PAGB">PAGB</option><option value="PCOL">PCOL</option><option value="PREL">PREL</option><option value="PVAL">PVAL</option><option value="RAT">RAT</option><option value="RETT">RETT</option><option value="RIS">RIS</option><option value="RIT">RIT</option><option value="RL">RL</option><option value="RTS">RTS</option><option value="SAL">SAL</option><option value="SCO">SCO</option><option value="STIP">STIP</option><option value="VAL">VAL</option><option value="VEN">VEN</option><option value="VERS">VERS</option></select></div><div class="col-xs-3"><label>Codice Iva</label><select class="form-control" ng-model="ricerca.codiceiva"><option ng-repeat="codiceiva in codiciiva" value="{{codiceiva.codice}}">{{codiceiva.descrizione}}</option></select></div></div></div></form></div><div class="col-xs-9"><p class="text-danger">{{ error }}</p></div><div class="col-xs-1 text-right"><button type="button" class="btn btn-default" ng-click="advancedExport();">Esporta</button></div><div class="col-xs-1 text-right"><button type="button" class="btn btn-primary" ng-click="applyDateTo(); cerca();">Cerca</button></div><div class="col-xs-1 text-right"><button type="button" class="btn btn-danger" ng-click="emptySearch();">Reset</button></div></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table ng-show="fairicerca" class="table" st-table="items" st-pipe="loadMovimenti"><thead><tr class="sortable"><th class="table-id">#</th><th>Data reg.</th><th>Num. reg.</th><th>Data doc.</th><th>Num. fatt.</th><th width="5%">Protocollo</th><th>Partita</th><th>Causale</th><th>Note</th><th>Num. riga</th><th>Imponibile</th><th>Imposta</th><th>Protocollo</th><th>Anno</th><th>Cod. Valuta</th><th></th></tr><tr><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in items.data"><td>{{item.id}}</td><td><b>{{item.datamov*1000 | date:\'dd/MM/yy\'}}</b></td><td><b>{{item.nummov}}</b></td><td><b>{{item.datadoc*1000 | date:\'dd/MM/yy\'}}</b></td><td><b>{{item.numdoc}}</b></td><td class="text-center">{{item.protocollo}}</td><td>{{ item.partita }}</td><td class="text-center">{{item.causale}}</td><td><span tooltips="" tooltip-template="{{(item.note || item.detnote)}}">{{(item.note || item.detnote) | limitTo: 20 }} {{ (item.note.length || item.detnote.length) > 20 ? \'...\' : \'\' }}</span></td><td>{{item.numriga}}</td><td>{{(item.imponibile/100 | number : 2)}}</td><td>{{(item.imposta/100 | number : 2)}}</td><td>{{item.protocollo}}</td><td>{{item.anno}}</td><td>{{item.codvaluta}}</td><td><a ng-click="editMovimento(item.ntsid);" href=""><i class="glyphicon glyphicon-zoom-in" tooltips="" tooltip-template="Dettagli" tooltip-size="small"></i></a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5" st-template="app/contabilita/movimenti/pagination.html"></div></td></tr></tfoot></table>');
$templateCache.put('app/contabilita/ratei-risconti/ratei-risconti.html','<div><h4><strong>ESPORTAZIONI RATEI / RISCONTI</strong></h4><div ba-panel=""><div class="row"><div class="col-md-3"><label>Seleziona anno</label><select class="form-control" ng-model="periods.export"><option value=""></option><option ng-value="years[0]+1">{{years[0]+1}}</option><option ng-repeat="year in years" ng-value="year">{{year}}</option></select></div></div><div class="row" style="margin-top: 30px; margin-bottom: 30px;"><div class="col-md-4 text-center"><button ng-disabled="!periods.export || loading.riscontiticket" type="button" class="btn btn-primary" ng-click="export(\'riscontiticket\')">Esporta ratei/risconti WES/BBS</button><br><br><div class="row spinner-cont" ng-if="loading.riscontiticket"><span class="spinner"></span></div></div><div class="col-md-4 text-center"><button ng-disabled="!periods.export || loading.risconti" type="button" class="btn btn-primary" ng-click="export(\'risconti\')">Esporta altri risconti</button><br><br><div class="row spinner-cont" ng-if="loading.risconti"><span class="spinner"></span></div></div><div class="col-md-4 text-center"><button ng-disabled="!periods.export || loading.ratei" type="button" class="btn btn-primary" ng-click="export(\'ratei\')">Esporta altri ratei</button><br><br><div class="row spinner-cont" ng-if="loading.ratei"><span class="spinner"></span></div></div></div></div><br><br><br><h4><strong>GENERAZIONE MOVIMENTI RATEI / RISCONTI</strong></h4><div class="row"><div class="col-md-7"><div ba-panel=""><div class="row"><div class="col-md-6"><label>Seleziona anno</label><select class="form-control" ng-model="periods.create"><option value=""></option><option ng-repeat="year in years" ng-value="year">{{year}}</option></select></div><div class="col-md-6"><label>Data competenza per risconti ticket</label><div class="input-group"><input type="text" date2str="" forcetime="down" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-append-to-body="true" ng-model="periods.date" is-open="popUpDate1" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate1 = !popUpDate1"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="row" style="margin-top: 30px; margin-bottom: 30px;"><div class="col-md-12 text-center"><button ng-disabled="!periods.create || !periods.date || loading.crrisc" type="button" class="btn btn-primary" ng-click="genRisconti()">Genera risconti ticket</button><br><br><div class="row spinner-cont" style="position:absolute; left:52%;" ng-if="loading.crrisc"><span class="spinner"></span></div></div></div></div></div><div class="col-md-5"><div ba-panel=""><div class="row"><div class="col-md-12" style="margin-bottom: 15px;"><label>Seleziona anno</label><select class="form-control" ng-model="periods.createOthers"><option value=""></option><option ng-repeat="year in years" ng-value="year">{{year}}</option></select></div></div><div class="row" style="margin-top: 30px; margin-bottom: 30px;"><div class="col-md-12 text-center"><button ng-disabled="!periods.createOthers || loading.crratrisc" type="button" class="btn btn-primary" ng-click="genRateiRisconti()">Genera altri ratei e risconti</button><br><br><div class="row spinner-cont" style="position:absolute; left:52%;" ng-if="loading.crratrisc"><span class="spinner"></span></div></div></div></div></div></div></div>');
$templateCache.put('app/contabilita/stampa-registri/stampa-registri.html','<div class="horizontal-scroll"><h4><strong>REGISTRI IVA</strong></h4><div ba-panel=""><form ng-submit="stampaRegistri()"><div class="row"><div class="col-md-12"><table class="table" cellpadding="0" cellspacing="0"><thead><tr><th></th><th><strong>Sezionale</strong></th><th><strong>Data inizio</strong></th><th><strong>Data fine</strong></th><th><strong>Pagina inizio periodo</strong></th><th><strong>Pagina fine periodo</strong></th></tr></thead><tbody><tr ng-repeat="sezionale in sezionali"><td><input type="radio" name="registro" ng-value="sezionale.sezionale" ng-model="registro.sezionale" ng-change="checkStampaProvvisoria()"></td><td>{{ sezionale.nome }}</td><td><input type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="sezionale.datainizio" date2str="" is-open="sezionale.datepicking" ng-click="sezionale.datepicking=!sezionale.datepicking" close-text="Chiudi" datepicker-append-to-body="true" show-button-bar="false" style="width:65%"></td><td><input type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="sezionale.datafine" date2str="" is-open="sezionale.datepicking2" datepicker-append-to-body="true" ng-click="sezionale.datepicking2=!sezionale.datepicking2" close-text="Chiudi" show-button-bar="false" style="width:65%"></td><td>{{ sezionale.paginizio }}</td><td>{{ sezionale.pagfine }}</td></tr></tbody></table></div></div><div class="row" style="margin-top: 50px;"><div class="col-xs-3"><label>Data stampa</label><div class="input-group"><input type="text" date2str="" forcetime="down" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-append-to-body="true" ng-model="registro.printenddate" is-open="popUpDate1" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate1 = !popUpDate1"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3" style="padding-top: 2%;"><div class="form-group"><label class="custom-checkbox"><input type="checkbox" ng-checked="registro.prospettoliquidazione == 1" ng-true-value="1" ng-false-value="0" id="featured" ng-model="registro.prospettoliquidazione" ng-disabled="registro.sezionale !== \'V\'"> <span>Stampa prospetto liquidazione</span></label></div></div><div class="col-xs-3" style="padding-top: 2%;"><div class="radio-inline"><label style="font-weight: 400;"><input type="radio" name="type" ng-value="1" ng-model="registro.prova"> Stampa di prova</label></div><div class="radio-inline"><label style="font-weight: 400;"><input type="radio" name="type" ng-value="0" ng-model="registro.prova"> Stampa definitiva</label></div></div><div class="col-xs-3 text-right" style="padding-top: 2%;"><button ng-show="!loadingRegistro" type="submit" class="btn btn-primary">Stampa</button><div ng-show="loadingRegistro" class="row spinner-cont" style="float: right;margin-right: 50px;"><span class="spinner"></span></div></div></div></form></div><br><br><br><h4><strong>GIORNALE BOLLATO</strong></h4><div ba-panel=""><form ng-submit="stampaGiornale()"><div class="row"><div class="col-xs-3"><label>Dal</label><div class="input-group"><input type="text" date2str="" forcetime="down" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-append-to-body="true" ng-model="giornale.startdate" is-open="popUpDate1" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate1 = !popUpDate1"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3"><label>Al</label><div class="input-group"><input type="text" date2str="" forcetime="up" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-append-to-body="true" ng-model="giornale.stopdate" is-open="popUpDate2" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate2 = !popUpDate2"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-2"><label>Pagina inizio</label> <input type="number" class="form-control" ng-model="giornale.pagefrom" disabled=""></div><div class="col-xs-2"><label>Pagina fine</label> <input type="number" class="form-control" ng-model="giornale.pageto" disabled=""></div></div><div class="row" style="margin-top: 25px;"><div class="col-xs-3"><div class="form-group"><label class="custom-checkbox"><input type="checkbox" ng-checked="giornale.codiceconto == 1" ng-true-value="1" ng-false-value="0" id="codiceconto" ng-model="giornale.codiceconto"> <span>Stampa codice conto</span></label></div></div><div class="col-xs-3"><div class="radio-inline"><label style="font-weight: 400;"><input type="radio" name="giornaletype" ng-value="1" ng-model="giornale.prova"> Stampa di prova</label></div><div class="radio-inline"><label style="font-weight: 400;"><input type="radio" name="giornaletype" ng-value="0" ng-model="giornale.prova"> Stampa definitiva</label></div></div><div class="col-xs-3"></div><div class="col-xs-3 text-right"><button ng-if="!loadinggiornale" type="submit" class="btn btn-primary">Stampa</button><div ng-show="loadinggiornale" class="row spinner-cont" style="float: right;margin-right: 50px;"><span class="spinner"></span></div></div></div></form></div></div>');
$templateCache.put('app/pages/autori/autore.html','<div ba-panel="" ba-panel-title="{{autore.id ? \'Modifica autore \'+autore.fname+\' \'+autore.lname : \'Crea nuovo autore\'}}" ba-panel-class="with-scroll"><uib-tabset><uib-tab heading="Dati"><form ng-submit="salva()"><div class="row"><div class="col-sm-6"><div class="form-group"><label for="fname">Nome</label> <input required="" ng-model="autore.fname" type="text" class="form-control" id="fname" placeholder="Nome"></div></div><div class="col-sm-6"><div class="form-group"><label for="lname">Cognome</label> <input required="" ng-model="autore.lname" type="text" class="form-control" id="lname" placeholder="Cognome"></div></div><div class="col-sm-6"><div class="form-group"><label for="country">Paese</label> <input ng-model="autore.country" type="text" class="form-control" id="country" placeholder="Paese"></div></div><div class="col-sm-6"><div class="form-group"><label for="amwaylevel">Livello</label> <input ng-model="autore.amwaylevel" type="text" class="form-control" id="amwaylevel" placeholder="Livello"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="bio">Biografia</label><trix-editor angular-trix="" ng-model="autore.bio"></trix-editor></div></div><div class="col-sm-6"><div class="form-group"><label for="shortdesc">Descrizione breve</label> <textarea ng-model="autore.shortdesc" type="text" class="form-control" id="shortdesc"></textarea></div></div></div><button class="btn btn-default">Salva</button> <button class="btn btn-danger" type="button" ng-click="elimina()" ng-if="!!autore.id">Elimina</button></form></uib-tab><uib-tab heading="Immagine profilo"><p>Per una miglior resa caricare un\'immagine quadrata</p><form id="imageform" name="imageform"><img height="100" ng-show="!immagine.file && autore.profilepic" ng-src="{{baseurl}}{{autore.profilepic}}" alt="image"> <img height="100" ngf-thumbnail="immagine.file"><div ng-required="true" class="button" ngf-select="" ng-model="immagine.file" name="image" ngf-pattern="\'image/*\'" ngf-accept="\'image/*\'" ngf-max-size="20MB" ngf-min-height="100">Seleziona un\'immagine <i style="font-size: 200%; cursor: pointer" class="ion-ios-upload"></i></div><button class="btn btn-default" ng-click="uploadImmagine()">Carica immagine</button></form></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/autori/autori.html','<a class="btn btn-primary" href="#!/nuovo-autore">Crea Autore</a><br><amway-pagination-size page-size="autoriTablePageSize" elements="autori"></amway-pagination-size><div class="horizontal-scroll"><div ng-show="false" class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control show-tick" title="Rows on page" selectpicker="" ng-model="autoriTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedAutori" st-safe-src="autori"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="fname">Nome</th><th st-sort="lname">Cognome</th><th st-sort="shortdesc">Descrizione</th><th st-sort="country">Paese</th><th>Azioni</th></tr><tr><th></th><th><input st-search="fname" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lname" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="shortdesc" placeholder="Search Descrizione" class="input-sm form-control search-input" type="search"></th><th><input st-search="country" placeholder="Search Paese" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in displayedAutori"><td class="table-id">{{item.id}}</td><td>{{item.fname}}</td><td>{{item.lname}}</td><td>{{item.shortdesc}}</td><td>{{item.country}}</td><td><a class="btn btn-primary btn-xs" href="#!/modifica-autore/{{item.id}}">Modifica</a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="autoriTablePageSize" st-displayed-pages="10" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/categorie/categoria.html','<div ng-include="" src="\'app/pages/categorie/form-categoria.html\'"></div>');
$templateCache.put('app/pages/categorie/categorie.html','<a class="btn btn-primary" href="#!/nuova-categoria">Crea Categoria</a> <button class="btn btn-success" ng-click="resetCache()">Reset Cache</button><amway-pagination-size page-size="categorieTablePageSize" elements="categorie"></amway-pagination-size><div class="horizontal-scroll"><div ng-show="false" class="form-group select-page-size-wrap"></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedCategorie" st-safe-src="categorie"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th>Immagine</th><th st-sort="name">Nome</th><th st-sort="shortname">Nome Breve</th></tr><tr><th></th><th></th><th><input st-search="name" placeholder="Cerca per nome" class="input-sm form-control search-input" type="search"></th><th></th><th ng-show="false"></th></tr></thead><tbody><tr ng-repeat="item in displayedCategorie"><td><b>{{item.id}}</b></td><td><a href="#!/modifica-categoria/{{item.id}}"><img style="width: 100px; margin: 10px;" ng-src="{{baseurl}}/{{item.img}}"></a></td><td><b>{{item.name}}</b></td><td><b>{{item.shortname}}</b></td><td><a class="btn btn-primary btn-xs" href="#!/modifica-categoria/{{item.id}}">Modifica</a> <a class="btn btn-danger btn-xs" ng-if="userLogged.id == 1" ng-click="eliminaCategoria(item)">Elimina</a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="categorieTablePageSize" st-displayed-pages="5" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/categorie/form-categoria.html','<div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dati Generali"><form ng-submit="salva()"><div class="row"><div class="col-sm-12"><div class="form-group"><label for="fname">Nome</label> <input required="" ng-model="categoria.name" type="text" class="form-control" id="name" placeholder="Nome"></div></div><div class="col-sm-12"><div class="form-group"><label for="fname">Nome Abbreviato</label> <input required="" ng-model="categoria.shortname" type="text" class="form-control" id="name" placeholder="Nome Abbreviato"></div></div><div class="col-sm-12"><div class="form-group"><label for="abstract">Descrizione</label> <textarea required="" ng-model="categoria.descr" type="text" class="form-control" id="abstract" placeholder="Descrizione">\n\t</textarea></div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-true-value="1" ng-false-value="0" id="featured" ng-model="categoria.menu"> <span>Presente nel menu</span></label></div></div><div class="col-md-2"><div class="form-group"><label for="sort">Ordine vis.</label> <input required="" ng-model="categoria.sort" type="text" class="form-control" id="sort" placeholder="Ordine Vis."></div></div><div class="col-sm-6"><div class="form-group"><label for="section">Sezione</label><select name="sectionstr" id="inputSection" class="form-control" required="required" ng-model="categoria.sectionstr"><option value="bsm">BSM</option><option value="cep">CEP</option><option value="ticket">TICKET</option></select></div></div></div><button class="btn btn-default" type="submit">Salva</button></form></uib-tab><uib-tab disable="!categoria.id" heading="Immagine"><div ng-include="" src="\'app/pages/categorie/upload-image.html\'"></div></uib-tab><uib-tab heading="Prodotti"><br><br><br><table class="table table-striped" st-table="displayedProducts" st-safe-src="taxonomyproducts"><thead><tr><th st-sort="id">#</th><th>Nome</th><th>Sort</th></tr></thead><tbody><tr ng-repeat="item in displayedProducts"><td>{{item.id}}</td><td>{{item.product.name}}</td><td><span ng-if="!item.editing">{{item.sort}}</span> <span ng-if="item.editing"><input type="text" class="form-control" ng-model="item.sort"></span></td><td><button ng-show="!item.editing" class="btn btn-info btn-sm" ng-click="item.editing = true"><i class="fa fa-pencil"></i></button> <button ng-show="item.editing" class="btn btn-success btn-sm" ng-click="item.editing = false"><i class="fa fa-check" aria-hidden="true"></i></button></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="50" colspan="9" st-template=""></td></tr></tfoot></table><button class="btn btn-primary pull-right" ng-click="saveSort()">Salva</button><br><br></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/categorie/nuova-categoria.html','<div ng-include="" src="\'app/pages/categorie/form-categoria.html\'"></div>');
$templateCache.put('app/pages/categorie/upload-image.html','<p>Per una miglior resa caricare un\'immagine quadrata</p><form id="imageform" name="imageform"><img height="100" ng-show="!immagine.file && categoria.img" ng-src="{{baseurl}}{{categoria.img}}" alt="image"> <img height="100" ngf-thumbnail="immagine.file"><div ng-required="true" class="button" ngf-select="" ng-model="immagine.file" name="image" ngf-pattern="\'image/*\'" ngf-accept="\'image/*\'" ngf-max-size="20MB" ngf-min-height="100">Seleziona un\'immagine <i style="font-size: 200%; cursor: pointer" class="ion-ios-upload"></i></div><button class="btn btn-default" ng-click="uploadImmagine()">Salva</button></form>');
$templateCache.put('app/pages/chart/chart.html','<button class="collapsible">Open Collapsible</button><div class="content"><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p></div><button class="collapsible">Open Section 1</button><div class="content"><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p></div><button class="collapsible">Open Section 2</button><div class="content"><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p></div><button class="collapsible">Open Section 3</button><div class="content"><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p></div>');
$templateCache.put('app/pages/configurazione/configurazione.html','<table class="table" st-table="configItemsST" st-safe-src="configItems"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="ckey">Chiave</th><th st-sort="cval">Valore</th><th st-sort="descr">Descrizione</th><th>Azioni</th></tr><tr><th></th><th><input st-search="ckey" placeholder="Cerca per chiave" class="input-sm form-control search-input"></th><th><input st-search="cval" placeholder="Cerca per valore" class="input-sm form-control search-input"></th><th><input st-search="descr" placeholder="Cerca per descrizione" class="input-sm form-control search-input"></th><th></th></tr></thead><tbody><tr ng-repeat="item in configItemsST"><td class="table-id">{{ item.id }}</td><td>{{ item.ckey }}</td><td>{{ item.cval }}</td><td>{{ item.descr }}</td><td><a class="btn btn-primary btn-xs" href="#!/configurazione/modifica/{{ item.id }}">Modifica</a></td></tr></tbody></table>');
$templateCache.put('app/pages/configurazione/form-configurazione.html','<div ba-panel="" ba-panel-class="" ba-panel-title="Modifica configurazione"><form ng-submit="saveConfig()" ng-if="!!item"><div class="row"><div class="col-sm-4"><div class="form-group"><label for="ckey">Chiave</label> <input required="" ng-model="item.ckey" type="text" class="form-control" id="ckey" placeholder="Chiave"></div></div><div class="col-sm-4"><div class="form-group"><label for="cval">Valore</label> <input required="" ng-model="item.cval" type="text" class="form-control" id="cval" placeholder="Valore"></div></div><div class="col-sm-4"><div class="form-group"><label for="descr">Descrizione</label> <input required="" ng-model="item.descr" type="text" class="form-control" id="descr" placeholder="Descrizione"></div></div></div><button class="btn btn-primary" type="submit">Salva</button> <a class="btn btn-secondary" href="#!/configurazione">Annulla</a></form></div>');
$templateCache.put('app/pages/eventi/event-access-modal.html','<div class="modal-header"><h2 class="modal-title" id="modal-title">Event access</h2></div><div class="modal-body" id="modal-body"><table class="table table-striped" st-table="displayedAccesses" st-safe-src="eventAccesses"><thead><tr><th st-sort="agentid">Id Agente</th><th st-sort="insdate">Data</th></tr></thead><tbody><tr ng-repeat="item in displayedAccesses"><td><a target="_blank" href="{{\'#!/modifica-utente/\'+item.agentid}}">{{item.agentid}}</a></td><td>{{item.insdate * 1000 | date : \'dd/MM/yyyy HH:mm\'}}</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="5" colspan="9" st-template=""></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/eventi/eventi.html','<a class="btn btn-primary" href="#!/nuovo-evento">Crea Evento</a><amway-pagination-size page-size="eventiTablePageSize" elements="eventi"></amway-pagination-size><div class="horizontal-scroll"><div ng-show="false" class="form-group select-page-size-wrap"></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="eventi" st-pipe="getEvents"><thead><tr class="sortable"><th class="table-id" st-sort="id">#</th><th>Immagine</th><th st-sort="product">Evento</th><th st-sort="venue.name">Location</th><th st-sort="province">Provincia</th><th st-sort="status">Stato</th><th st-sort="startdate" st-sort-default="reverse">Data</th><th>Azioni</th></tr><tr><th></th><th></th><th><input st-search="name" placeholder="Cerca per nome evento" class="input-sm form-control search-input" type="search"></th><th><input st-search="venue.name" placeholder="Cerca per location" class="input-sm form-control search-input" type="search"></th><th><input st-search="province" placeholder="Cerca per provincia" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in eventi"><td><b>{{item.id}}</b></td><td><a href="#!/modifica-evento/{{item.id}}"><img ng-show="item.img" style="width: 100px; margin: 10px;" ng-src="{{baseurl}}{{item.img}}"></a></td><td><b>{{item.name}}</b></td><td>{{item.venue.name}}</td><td>{{item.province}}</td><td><span ng-if="item.status === \'open\'">Aperto</span> <span ng-if="item.status === \'closed\'">Chiuso</span></td><td>{{item.startdate*1000 | date:\'dd/MM/yyyy\'}}</td><td><a class="btn btn-primary btn-xs" href="#!/modifica-evento/{{item.id}}">Modifica</a> <a class="btn btn-primary btn-xs" href="#!/duplica-evento/{{item.id}}">Duplica</a> <a ng-if="item.status === \'open\'" class="btn btn-warning btn-xs pointer" ng-click="bloccaSblocca(item, true)">Blocca</a> <a ng-if="item.status === \'closed\'" class="btn btn-success btn-xs pointer" ng-click="bloccaSblocca(item, false)">Sblocca</a> <a class="btn btn-danger btn-xs" ng-if="userLogged.id == 1" ng-click="eliminaEvento(item)">Elimina</a></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="eventiTablePageSize" st-displayed-pages="5" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/eventi/evento.html','<div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dati Generali"><form ng-submit="salva()"><div class="row"><div class="{{ evento.id ? \'col-sm-11\' : \'col-sm-12\' }}"><div class="form-group"><label for="fname">Nome</label> <input required="" ng-model="evento.name" type="text" class="form-control" id="name" placeholder="Nome"></div></div><div class="col-sm-1" ng-if="evento.id"><div class="form-group"><label for="status">Stato: <strong>{{ evento.status === \'open\' ? \'Aperto\' : \'Chiuso\' }}</strong></label> <a ng-if="evento.status === \'open\'" class="btn btn-warning pointer" ng-click="bloccaSblocca(true)">Blocca</a> <a ng-if="evento.status === \'closed\'" class="btn btn-success pointer" ng-click="bloccaSblocca(false)">Sblocca</a></div></div><div class="col-sm-6"><div class="form-group"><label for="location">Centro congressi</label><angucomplete-alt id="ex2" placeholder="{{evento.venue.name}}" pause="300" selected-object="selectedVenue.r" local-data="venues" search-fields="name" title-field="name" minlength="1" input-class="form-control form-control-small" match-class="highlight"></angucomplete-alt></div></div><div class="col-sm-8" ng-if="prodotto.type==\'ticket\'"><div class="form-group"><label for="parent">Evento</label><ui-select required="" ng-model="prodotto.selectedEvent" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-disabled="!eventi.length"><ui-select-match placeholder="Evento"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="p in eventi | filter: $select.search"><span ng-bind-html="p.name"></span></ui-select-choices></ui-select></div></div><div class="col-sm-12"><div class="form-group"><label for="abstract">Descrizione Breve</label> <textarea required="" ng-model="evento.shortdesc" type="text" class="form-control" id="abstract" placeholder="Descrizione Breve">\n\t\t\t\t\t</textarea></div></div><div class="col-sm-12"><div class="form-group"><label for="description">Descrizione</label><trix-editor angular-trix="" ng-model="evento.description"></trix-editor></div></div><div class="col-sm-12"><div class="form-group"><label for="description">Come partecipare</label><trix-editor angular-trix="" ng-model="evento.eventrules"></trix-editor></div></div><div class="col-sm-12"><div class="form-group"><label for="abstract">Disclaimer nella App</label> <textarea ng-model="evento.disclaimer" type="text" class="form-control" id="abstract" placeholder="Disclaimer"></textarea></div></div><div ng-if="false" class="col-sm-2"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input ng-true-value="1" ng-false-value="0" type="checkbox" id="featured" ng-model="evento.guestallowed"> <span>Accompagnatori</span></label></div></div><div class="col-sm-2"><div class="form-group"><label for="maxtickets">N. Biglietti</label> <input required="" ng-model="evento.maxtickets" type="number" class="form-control" id="maxtickets" placeholder="Numero Massimo Biglietti"></div></div><div class="col-sm-3"><div class="form-group"><label for="maxincaricato">Numero Massimo per Incaricato</label> <input required="" ng-model="evento.maxincaricato" type="number" class="form-control" id="maxincaricato" placeholder="Numero Massimo Biglietti per Incaricato"></div></div><div class="col-sm-3"><div class="form-group"><label for="maxcliente">Numero Massimo per Cliente</label> <input required="" ng-model="evento.maxcliente" type="number" class="form-control" id="maxcliente" placeholder="Numero Massimo Biglietti per Cliente"></div></div><div class="col-md-12"><div class="col-sm-3"><div class="form-group"><label for="author">Inzio Evento</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="evento.iniziodate" is-open="open" ng-required="true" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open=true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-sm-3" style="margin-top:-14px"><div uib-timepicker="" ng-model="evento.iniziotime" show-meridian="false"></div></div><div class="col-sm-3"><div class="form-group {{(evento.finedate<evento.iniziodate)?\'has-error has-feedback\':\'\'}}"><label for="author">Fine evento</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="evento.finedate" is-open="open2" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2=true"><i class="glyphicon glyphicon-calendar"></i></button></span></p><span ng-if="evento.finedate<evento.iniziodate" class="text-danger">La fine dell\'evento non pu\xF2 precedere il suo inizio</span></div></div><div class="col-sm-3" style="margin-top:-14px"><div uib-timepicker="" ng-model="evento.finetime" show-meridian="false"></div></div><div class="col-sm-1"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input ng-true-value="1" ng-false-value="0" type="checkbox" id="featured" ng-model="evento.digital"> <span>Digitale</span></label></div></div><div ng-if="evento.digital"><div class="col-sm-3"><div class="form-group"><label for="author">Abilita accesso Streaming da</label><p class="input-group"><input required="" date2str="" type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="evento.showlinkfrom" is-open="open3" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open3=true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-sm-6"><div class="form-group"><label for="videoprovider">Video Vimeo URL</label> <input required="" pattern="^https:\\/\\/(.*)" ng-model="evento.videoprovider" type="url" class="form-control" id="maxcliente" placeholder="Video Vimeo URL"></div></div></div></div></div><br><button ng-disabled="evento.finedate<evento.iniziodate" class="btn btn-default" type="submit">Salva</button></form></uib-tab><uib-tab disable="!evento.id" heading="Immagine"><div ng-include="" src="\'app/pages/eventi/upload-image.html\'"></div></uib-tab><uib-tab disable="!evento.id" heading="Flyer"><div ng-include="" src="\'app/pages/eventi/upload-file.html\'"></div></uib-tab><uib-tab disable="!evento.id" heading="Speaker"><div class="row"><div class="col-sm-10"><ui-select ng-model="speakers.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca...">{{ $select.selected.fname }} {{ $select.selected.lname }}</ui-select-match><ui-select-choices repeat="sp in speakers | filter: $select.search"><span ng-bind-html="sp.fname"></span> <span ng-bind-html="sp.lname"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><button class="btn btn-default" ng-click="aggiungiSpeakerEvento(speakers.selected)">Aggiungi</button></div></div><div class="row"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedEventSpeakers" st-safe-src="eventspeakers"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th>Immagine</th><th st-sort="fname">Nome</th><th st-sort="lname">Cognome</th><th st-sort="country">Paese</th><th>Azioni</th></tr></thead><tbody><tr ng-repeat="item in displayedEventSpeakers"><td><b>{{item.speaker.id}}</b></td><td><img ng-show="item.profilepic" style="width: 100px; margin: 10px;" ng-src="{{baseurl}}{{item.profilepic}}"></td><td>{{item.speaker.fname}}</td><td>{{item.speaker.lname}}</td><td>{{item.speaker.country}}</td><td><a class="btn btn-danger btn-xs" ng-click="eliminaSpeakerEvento(item)">Elimina</a></td></tr></tbody></table></div></uib-tab><uib-tab disable="!evento.id" heading="Partecipanti"><br><div class="row"><div class="col-sm-2 text-left"><p><b>Biglietti venduti: {{ stats.tot }}</b></p></div><div class="col-sm-2 text-right"><p><b>% Riempimento sala: {{ (stats.tot/evento.maxtickets * 100).toFixed(2)}}%</b></p></div><div class="col-sm-2 text-center"><p><b>Ingressi registrati: {{ stats.used}}</b></p></div><div class="col-sm-2 text-right"><p><b>% Partecipazione: {{ (stats.usedperc).toFixed(2)}}%</b></p></div><div class="col-sm-2 text-right"><p><b>Biglietti multipli: {{ stats.multiple}}</b></p></div><div class="col-sm-2 text-right"><p><b>% Biglietti multipli: {{ (stats.multipleperc).toFixed(2)}}%</b></p></div></div><hr style="width: 100%; height: 1px; background-color: #999999;"><table st-table="dispart" st-safe-src="partecipanti" class="table table-striped"><thead><tr><td>Pnr</td><td>Nome</td><td>Ruolo</td><td>Invitato da</td><td>Presente</td><td st-sort="firstaccess">Ingresso</td><td st-sort="seen">Accessi</td><td>Utente</td><td></td></tr><tr><td><input placeholder="Filtra pnr..." class="input-sm form-control search-input" type="search" ng-model="pnrFilter.pnr"></td><td><input placeholder="Filtra nome..." class="input-sm form-control search-input" type="search" ng-model="pnrFilter.name"></td><td></td><td><input placeholder="Invitato da..." class="input-sm form-control search-input" type="search" ng-model="pnrFilter.invitedby"></td><td></td><td></td><td></td></tr></thead><tbody><tr ng-if="!dispart.length"><td colspan="8">Ancora nessun partecipante a questo evento</td></tr><tr dir-paginate="p in dispart|itemsPerPage:itemsPerPage" total-items="totalItems"><td>{{p.pnr}}</td><td><span ng-show="!p.editable">{{p.guestname}}</span> <input ng-hide="!p.editable" name="guestName" class="form-control" type="text" ng-model="p.guestname"></td><td>{{p.guestrole}}</td><td>{{ p.user ? (p.user.fname + \' \' + p.user.lname) : p.invitedby }}</td><td><i ng-show="p.firstaccess!==undefined" class="ion-checkmark-circled"></i></td><td>{{p.firstaccess ? (p.firstaccess*1000 | date:\'dd/MM/yyyy HH:mm:ss\') : \'\'}}</td><td>{{p.seen}}</td><td><a href="#!/modifica-utente/{{p.uid}}"><i class="glyphicon glyphicon-edit" tooltips="" tooltip-template="Dettagli" tooltip-size="small"></i></a></td><td><button ng-if="evento.finedate > oggi" type="button" class="btn btn-xs btn-danger" ng-click="burnPNR(p)">ANNULLA</button> <button ng-if="evento.finedate > oggi && !p.editable" type="button" class="btn btn-xs btn-info" ng-click="p.editable = true">MODIFICA NOME</button> <button ng-if="evento.finedate > oggi && p.editable" type="button" class="btn btn-xs btn-success" ng-click="editGuestName(p); p.editable = false">SALVA NOME</button></td></tr></tbody></table><dir-pagination-controls max-size="10" direction-links="true" boundary-links="true" on-page-change="getPnrData(newPageNumber, oldPageNumber)"></dir-pagination-controls></uib-tab><uib-tab disable="!evento.id" heading="Anomalie"><table class="table table-striped" st-table="displayedAnomalies" st-safe-src="anomalies"><thead><tr><th st-sort="id">#</th><th st-sort="event">Evento</th><th st-sort="guestname">Ospite</th><th st-sort="ticketname">Ticket</th><th st-sort="seen">Visualizzazioni</th><th st-sort="issuedate">Data</th></tr></thead><tbody><tr ng-repeat="item in displayedAnomalies"><td>{{item.id}}</td><td>{{item.event}}</td><td><a href="#!/modifica-utente/{{item.uid}}">{{item.guestname}}</a></td><td>{{item.ticketname}}</td><td class="text-center">{{item.seen}}</td><td>{{item.issuedate * 1000 | date : \'dd/MM/yyyy HH:mm\'}}</td><td><button class="btn btn-sm btn-primary" type="button" ng-click="viewEventAccess(item.id)"><i class="fa fa-search"></i></button></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="20" colspan="9" st-template=""></td></tr></tfoot></table></uib-tab><uib-tab disable="!evento.id" heading="Violazioni"><table class="table table-striped" st-table="displayedViolations" st-safe-src="violations"><thead><tr><th st-sort="id">#</th><th st-sort="event">Utente</th><th st-sort="guestname">PNR</th><th st-sort="ticketname">Motivazione</th><th st-sort="issuedate">Num. Accessi</th><th st-sort="event">Segnalatore</th><th st-sort="guestname">Data violazione</th><th></th></tr></thead><tbody><tr ng-repeat="item in displayedViolations"><td>{{item.id}}</td><td><a href="#!/modifica-utente/{{item.uid}}">{{item.user.fname + " " + item.user.lname}}</a></td><td>{{item.pnrid}}</td><td>{{item.reason}}</td><td>{{item.pnr.seen}}</td><td>{{(item.agent) ? item.agent.fname+ " " + item.agent.lname : \'-\'}}</td><td>{{item.insdate * 1000 | date :\'dd/MM/yyyy HH:mm\'}}</td><td><button class="btn btn-sm btn-primary" type="button" ng-click="viewEventAccess(item.pnrid)"><i class="fa fa-search"></i></button></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="20" colspan="9" st-template=""></td></tr></tfoot></table></uib-tab><uib-tab disable="!evento.id" heading="Notifiche push"><form ng-submit="sendNotification()"><div class="row"><div class="col-sm-7"><div class="form-group" style="margin-top: 12px;"><label for="fname">Messaggio</label> <input required="" ng-model="pushNotification.msg" type="text" class="form-control" id="name" placeholder="Messaggio"></div></div><div class="col-sm-2"><div class="form-group"><label for="author">Invia da</label><br><div class="input-group" style="margin-top: 12px;"><input date2str="" type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="pushNotification.senddate" is-open="open" ng-required="true" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-sm-2"><div class="form-group"><div class="input-group"><div date2str="" uib-timepicker="" ng-model="pushNotification.senddate" hour-step="1" minute-step="1" pad-hours="false" show-meridian="false"></div></div></div></div><div class="col-sm-1"><div class="form-group" style="margin-top: 30px;"><button class="btn btn-default" type="submit">Schedula</button></div></div></div></form><table class="table" st-table="displayedNotifications" st-safe-src="notifications"><thead><tr class="sortable"><th st-sort="id">#</th><th st-sort="msg">Messaggio</th><th st-sort="data">Data</th></tr></thead><tbody><tr ng-repeat="item in displayedNotifications"><td>{{item.id}}</td><td>{{item.msg}}</td><td>{{item.senddate * 1000 | date : "dd/MM/yyyy HH:mm"}}</td><td><button class="btn btn-sm btn-danger" type="button" ng-click="deleteNotification(item.id)">Elimina</button></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="10" colspan="9" st-template=""></td></tr></tfoot></table></uib-tab><uib-tab disable="!evento.id" heading="Distribuzione" ng-click="fitBounds()"><div id="map" style="width:100%; height : 700px"></div></uib-tab><uib-tab disable="!evento.id" heading="Migra ticket" ng-if="userLogged.id == 1"><div style="font-size: large;">Utilizza questa funzionalit\xE0 per sincronizzare i biglietti gi\xE0 emessi con i nuovi dati di evento e prodotto. Prima di procedere assicurati che:<br><br><br><ul><li>il prodotto non sia in vendita</li><br><li>di aver gi\xE0 modificato i dati di evento, prodotto ed eventualmente location con quelli futuri</li></ul><br><br><button ng-if="!migratingTickets" class="btn btn-primary" ng-click="migrateTickets()">Ok, migra {{totalItems}} ticket</button> <i ng-if="migratingTickets" class="fa fa-circle-o-notch fa-spin" style="font-size:24px"></i></div><br><br><br></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/eventi/upload-file.html','<div ba-panel=""><div class="col-md-12"><br><a type="button" class="btn btn-primary" ng-if="evento.flyer" ng-href="{{ baseurl }}{{ evento.flyer }}" target="_blank">Apri il flyer attualmente in uso</a><br><br><h5 ng-show="evento.flyer">Seleziona il nuovo flyer in sostituzione del precedente</h5><h5 ng-hide="evento.flyer">Seleziona il file per l\'upload</h5><span style="font:smaller">{{f.name}} <i ng-show="f.progress==100" class="ion-checkmark-circled"></i></span> <button type="file" ngf-select="uploadFile($file, $invalidFiles)" accept=".pdf" ngf-max-size="20MB">Seleziona <i class="ion-ios-upload"></i></button><div class="progress" ng-show="f.progress>0 && f.progress < 100"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="{{f.progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{f.progress}}%"><span>{{f.progress}}%</span></div></div><br><br></div></div>');
$templateCache.put('app/pages/eventi/upload-image.html','<p>Per una miglior resa caricare un\'immagine quadrata</p><form id="imageform" name="imageform"><img height="100" ng-show="!immagine.file && evento.img" ng-src="{{baseurl}}{{evento.img}}" alt="image"> <img height="100" ngf-thumbnail="immagine.file"><div ng-required="true" class="button" ngf-select="" ng-model="immagine.file" name="image" ngf-pattern="\'image/*\'" ngf-accept="\'image/*\'" ngf-max-size="20MB" ngf-min-height="100">Seleziona un\'immagine <i style="font-size: 200%; cursor: pointer" class="ion-ios-upload"></i></div><br><br></form><button class="btn btn-default" ng-click="uploadImmagine()">Salva</button>');
$templateCache.put('app/pages/dashboard/dashboard.html','<dashboard-pie-chart></dashboard-pie-chart><div class="row"><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Acquisition Channels" ba-panel-class="medium-panel traffic-panel"><traffic-chart></traffic-chart></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Users by Country" ba-panel-class="medium-panel"><dashboard-map></dashboard-map></div></div><div class="row"><div class="col-xlg-9 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="row"><div class="col-xlg-8 col-lg-12 col-md-12 col-sm-7 col-xs-12" ba-panel="" ba-panel-title="Revenue" ba-panel-class="medium-panel"><dashboard-line-chart></dashboard-line-chart></div><div class="col-xlg-4 col-lg-12 col-md-12 col-sm-5 col-xs-12" ba-panel="" ba-panel-class="popular-app medium-panel"><popular-app></popular-app></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-12 col-xs-12" ba-panel="" ba-panel-title="Feed" ba-panel-class="large-panel with-scroll feed-panel"><blur-feed></blur-feed></div></div><div class="row shift-up"><div class="col-xlg-3 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="To Do List" ba-panel-class="xmedium-panel feed-comply-panel with-scroll todo-panel"><dashboard-todo></dashboard-todo></div><div class="col-xlg-6 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="Calendar" ba-panel-class="xmedium-panel feed-comply-panel with-scroll calendar-panel"><dashboard-calendar></dashboard-calendar></div></div>');
$templateCache.put('app/pages/coefficienti/coefficiente.html','<div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dati del gruppo"><form ng-submit="salvaCoefficientSet()"><div class="row"><div class="col-md-6"><div class="form-group"><label for="fname">Nome Gruppo Coefficienti*</label> <input required="" ng-model="coefficientset.name" type="text" class="form-control" id="title" placeholder="Titolo"></div></div><div class="col-md-3"><div class="form-group"><label for="author">Valido da</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="parent.validFrom" is-open="validFromAperto" ng-required="true" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="validFromAperto = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-3 text-center"><div class="form-group"><label for="author">Valido fino a</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="parent.validTo" is-open="validToAperto" ng-required="true" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="validToAperto = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><button class="btn btn-default" type="submit">Salva gruppo coefficienti</button></form><br><br><div class="row"><div class="col-md-12"><p ng-show="coefficientiChildren.length == 0 && !newChildCoefficient">Nessun coefficiente registrato per questo gruppo.</p><button class="btn btn-primary" type="button" ng-click="showAddChildCoefficient(true)" ng-disabled="newChildCoefficient">Aggiungi nuovo coefficiente</button><br><br><div class="row" style="width:80%; margin-left:auto; margin-right: auto;" ng-show="newChildCoefficient"><form ng-submit="salvaChildCoefficient()"><div class="col-md-4"><div class="form-group"><label for="fname">Tipo*</label><select name="coefficientType" ng-model="childCoefficient.type" id="inputCoe" class="form-control" required="required"><option value="">-- Seleziona --</option><option value="cd">CD</option><option value="bbs">BBS</option><option value="wes">WES</option></select></div></div><div class="col-md-3 text-center"><div class="form-group"><label for="min">Minimo punti*</label> <input type="number" min="0" name="min" id="inputMin" class="form-control" ng-model="childCoefficient.min" required="required" ng-init="childCoefficient.min = 0"></div></div><div class="col-md-3 text-center"><div class="form-group"><label for="bonus">Bonus*</label> <input type="number" min="0" name="bonus" id="inputBonus" class="form-control" ng-model="childCoefficient.bonus" required="required" ng-init="childCoefficient.bonus = 0"></div></div><div class="col-md-2 text-center"><div class="form-group"><label for="azioni">Azioni</label><br><button class="btn btn-success" type="submit">Salva</button> <button class="btn btn-danger" type="button" ng-click="showAddChildCoefficient(false)">Chiudi</button></div></div></form></div><table ng-if="coefficientiChildren.length > 0" class="table table-striped table-inverse table-hover" style="width:80%; margin-left:auto; margin-right: auto;"><thead><tr><th class="text-center" width="2%"><b>#</b></th><th class="text-center" width="28%"><b>Tipo</b></th><th class="text-center" width="20%"><b>Minimo punti</b></th><th class="text-center" width="20%"><b>Bonus</b></th><th class="text-center" width="30%"><b>Azioni</b></th></tr></thead><tbody><tr ng-repeat="single in coefficientiChildren | orderBy:\'-id\'"><td class="text-center">{{ single.id }}</td><td class="text-center">{{ single.type | uppercase }}</td><td class="text-center">{{ single.min }}</td><td class="text-center">{{ single.bonus }}</td><td class="text-center"><button class="btn btn-primary btn-xs" type="submit" ng-click="editChildCoefficient(single)">Modifica</button> <button class="btn btn-danger btn-xs" type="submit" ng-click="deleteChildCoefficient(single.id)">Elimina</button></td></tr></tbody></table></div></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/coefficienti/coefficienti.html','<a class="btn btn-primary" href="#!/nuovo-coefficientset">Crea Gruppo Coefficienti</a><amway-pagination-size page-size="coefficientiTablePageSize" elements="coefficienti"></amway-pagination-size><div class="horizontal-scroll"><div ng-show="coefficienti.length == 0" class="alert alert-warning" style="color: #333333; margin-top: 20px; font-size: 12pt;"><strong>ATTENZIONE! Non ci sono set di coefficienti in corso di validit\xE0, il calcolo dei coefficienti non sta funzionando.</strong></div><div ng-show="overlapCounter > 1" class="alert alert-danger" style="color: #333333; margin-top: 20px; font-size: 12pt;"><strong>ATTENZIONE! Ci sono pi\xF9 set di coefficienti validi, il sistema utilizzer\xE0 quello con scadenza pi\xF9 vicina (il primo della lista sotto).</strong></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" st-table="displayedCoefficientSet" st-safe-src="coefficienti"><thead><tr class="sortable"><th class="table-id" st-sort="id">#</th><th st-sort="name">Nome</th><th class="text-center" st-sort="validfrom">Valido da</th><th class="text-center" st-sort="validto">Valido fino a</th><th>Azioni</th></tr><tr><th></th><th><input st-search="name" placeholder="Cerca per nome" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="set in displayedCoefficientSet"><td><b>{{ set.id }}</b></td><td><b>{{ set.name }}</b></td><td class="text-center">{{ set.validfrom*1000 | date:\'dd/MM/yyyy\' }}</td><td class="text-center">{{ set.validto*1000 | date:\'dd/MM/yyyy\' }}</td><td><a class="btn btn-primary btn-xs" href="#!/modifica-coefficientset/{{set.id}}">Modifica / Visualizza</a> <a class="btn btn-danger btn-xs" ng-click="eliminaCoefficienti(set)">Elimina</a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="coefficientiTablePageSize" st-displayed-pages="5" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/leaders/leader.html','<div ba-panel="" ba-panel-title="{{leader.id ? \'Modifica leader \'+leader.fname+\' \'+leader.lname : \'Crea nuovo leader\'}}" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><uib-tabset><uib-tab heading="Dati"><form><div class="row"><div class="col-sm-2"><div class="form-group"><label for="sort">Ordine</label> <input ng-model="leader.sort" type="number" class="form-control" id="sort" placeholder="Ordine"></div></div><div class="col-sm-5"><div class="form-group"><label for="fname">Nome</label> <input required="" ng-model="leader.fname" type="text" class="form-control" id="fname" placeholder="Nome"></div></div><div class="col-sm-5"><div class="form-group"><label for="lname">Cognome</label> <input required="" ng-model="leader.lname" type="text" class="form-control" id="lname" placeholder="Cognome"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="country">Paese</label> <input ng-model="leader.country" type="text" class="form-control" id="country" placeholder="Paese"></div></div><div class="col-sm-6"><div class="form-group"><label for="amwaylevel">Livello</label><select name="amwaylevel" id="inputAmwaylevel" class="form-control" required="required" ng-model="leader.amwaylevel"><option value="Corona Ambasciatore Fondatori">Corona Ambasciatore Fondatori</option><option value="Corona Ambasciatore">Corona Ambasciatore</option><option value="Corona Fondatori">Corona Fondatori</option><option value="Corona">Corona</option><option value="Triplo Diamante Fondatori">Triplo Diamante Fondatori</option><option value="Triplo Diamante">Triplo Diamante</option><option value="Doppio Diamante Fondatori">Doppio Diamante Fondatori</option><option value="Doppio Diamante">Doppio Diamante</option><option value="Diamante Esecutivo Fondatori">Diamante Esecutivo Fondatori</option><option value="Diamante Esecutivo">Diamante Esecutivo</option><option value="Diamante Fondatori">Diamante Fondatori</option><option value="Diamante">Diamante</option><option value="Smeraldo Fondatori">Smeraldo Fondatori</option><option value="Smeraldo">Smeraldo</option><option value="Zaffiro Fondatori">Zaffiro Fondatori</option><option value="Zaffiro">Zaffiro</option><option value="Perla">Perla</option><option value="Rubino Fondatori">Rubino Fondatori</option><option value="Rubino">Rubino</option><option value="Platino Fondatori">Platino Fondatori</option><option value="Platino">Platino</option></select></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="bio">Biografia</label><trix-editor angular-trix="" ng-model="leader.bio"></trix-editor></div></div><div class="col-sm-6"><div class="form-group"><label for="shortbio">Biografia breve</label> <textarea ng-model="leader.shortbio" type="text" class="form-control" id="shortbio"></textarea></div></div></div><button class="btn btn-default" ng-click="salva()">Salva</button> <button ng-show="{{leader.id}}" class="btn btn-danger" ng-click="elimina()">Elimina</button></form></uib-tab><uib-tab heading="Immagini leader" ng-disabled="!leader.fname"><p>Per una miglior resa caricare un\'immagine quadrata</p><form id="imageform" name="imageform"><img height="100" ng-show="!immagine[\'profilepic\'].file && leader.profilepic" ng-src="{{baseurl}}{{leader.profilepic}}" alt="image"> <img height="100" ngf-thumbnail="immagine[\'profilepic\'].file"><div ng-required="true" class="button" ngf-select="" ng-model="immagine[\'profilepic\'].file" name="image" ngf-pattern="\'image/*\'" ngf-accept="\'image/*\'" ngf-max-size="20MB" ngf-min-height="100">Seleziona un\'immagine profilo<i style="font-size: 200%; cursor: pointer" class="ion-ios-upload"></i></div><div class="progress" ng-show="immagine[\'profilepic\'].progress > 0 && immagine[\'profilepic\'].progress < 100"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="{{ immagine[\'profilepic\'].progress }}" aria-valuemin="0" aria-valuemax="100" style="width: {{ immagine[\'profilepic\'].progress }}%"><span>{{ immagine[\'profilepic\'].progress }}%</span></div></div><button ng-disabled="!immagine[\'profilepic\'].file" class="btn btn-default" ng-click="uploadImmagine(\'profilepic\')">Carica immagine profilo</button></form><form id="imageform" name="imageform"><img height="100" ng-show="!immagine[\'familypic\'].file && leader.familypic" ng-src="{{baseurl}}{{leader.familypic}}" alt="image"> <img height="100" ngf-thumbnail="immagine[\'familypic\'].file"><div ng-required="true" class="button" ngf-select="" ng-model="immagine[\'familypic\'].file" name="image" ngf-pattern="\'image/*\'" ngf-accept="\'image/*\'" ngf-max-size="20MB" ngf-min-height="100">Seleziona un\'immagine della famiglia<i style="font-size: 200%; cursor: pointer" class="ion-ios-upload"></i></div><div class="progress" ng-show="immagine[\'familypic\'].progress > 0 && immagine[\'familypic\'].progress < 100"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="{{ immagine[\'familypic\'].progress }}" aria-valuemin="0" aria-valuemax="100" style="width: {{ immagine[\'familypic\'].progress }}%"><span>{{ immagine[\'familypic\'].progress }}%</span></div></div><button ng-disabled="!immagine[\'familypic\'].file" class="btn btn-default" ng-click="uploadImmagine( \'familypic\')">Carica immagine famiglia</button></form><form id="imageform" name="imageform"><img height="100" ng-show="!immagine[\'lifestyle\'].file && leader.lifestyle" ng-src="{{baseurl}}{{leader.lifestyle}}" alt="image"> <img height="100" ngf-thumbnail="immagine[\'lifestyle\'].file"><div ng-required="true" class="button" ngf-select="" ng-model="immagine[\'lifestyle\'].file" name="image" ngf-pattern="\'image/*\'" ngf-accept="\'image/*\'" ngf-max-size="20MB" ngf-min-height="100">Seleziona un\'immagine "lifestyle"<i style="font-size: 200%; cursor: pointer" class="ion-ios-upload"></i></div><div class="progress" ng-show="immagine[\'lifestyle\'].progress > 0 && immagine[\'lifestyle\'].progress < 100"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="{{ immagine[\'lifestyle\'].progress }}" aria-valuemin="0" aria-valuemax="100" style="width: {{ immagine[\'lifestyle\'].progress }}%"><span>{{ immagine[\'lifestyle\'].progress }}%</span></div></div><button ng-disabled="!immagine[\'lifestyle\'].file" class="btn btn-default" ng-click="uploadImmagine(\'lifestyle\')">Carica immagine life style</button></form><form id="imageform" name="imageform"><img height="100" ng-show="!immagine[\'otherpic\'].file && leader.otherpic" ng-src="{{baseurl}}{{leader.otherpic}}" alt="image"> <img height="100" ngf-thumbnail="immagine[\'otherpic\'].file"><div ng-required="true" class="button" ngf-select="" ng-model="immagine[\'otherpic\'].file" name="image" ngf-pattern="\'image/*\'" ngf-accept="\'image/*\'" ngf-max-size="20MB" ngf-min-height="100">Seleziona un\'immagine "altra immagine"<i style="font-size: 200%; cursor: pointer" class="ion-ios-upload"></i></div><div class="progress" ng-show="immagine[\'otherpic\'].progress > 0 && immagine[\'otherpic\'].progress < 100"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="{{ immagine[\'otherpic\'].progress }}" aria-valuemin="0" aria-valuemax="100" style="width: {{ immagine[\'otherpic\'].progress }}%"><span>{{ immagine[\'otherpic\'].progress }}%</span></div></div><button ng-disabled="!immagine[\'otherpic\'].file" class="btn btn-default" ng-click="uploadImmagine(\'otherpic\')">Carica immagine altro</button></form></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/leaders/leaders.html','<a class="btn btn-primary" href="#!/nuovo-leader">Crea Leader</a><br><amway-pagination-size page-size="leadersTablePageSize" elements="leaders"></amway-pagination-size><div class="horizontal-scroll"><div ng-show="false" class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control show-tick" title="Rows on page" selectpicker="" ng-model="leadersTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedLeaders" st-safe-src="leaders"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="fname">First Name</th><th st-sort="lname">Last Name</th><th st-sort="amwaylevel">Livello</th><th st-sort="shortdesc">Biografia breve</th><th st-sort="country">Paese</th><th>Azioni</th></tr><tr><th></th><th><input st-search="fname" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lname" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="amwaylevel" placeholder="Search Livello" class="input-sm form-control search-input" type="search"></th><th><input st-search="shortdesc" placeholder="Search Descrizione" class="input-sm form-control search-input" type="search"></th><th><input st-search="country" placeholder="Search Paese" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in displayedLeaders"><td class="table-id">{{item.id}}</td><td>{{item.fname}}</td><td>{{item.lname}}</td><td>{{item.amwaylevel}}</td><td>{{item.shortbio}}</td><td>{{item.country}}</td><td><a class="btn btn-primary btn-xs" href="#!/modifica-leader/{{item.id}}">Modifica</a></td><td><button class="btn btn-danger btn-xs" ng-click="elimina(item.id)">Elimina</button></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="leadersTablePageSize" st-displayed-pages="10" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/listini/listini.html','<a class="btn btn-primary" href="#!/nuovo-listino">Crea Listino</a><amway-pagination-size page-size="moduliTablePageSize" elements="listini"></amway-pagination-size><div class="horizontal-scroll"><div ng-show="false" class="form-group select-page-size-wrap"></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedListini" st-safe-src="listini"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Listino</th><th st-sort="insdate">Data Inserimento</th><th st-sort="startdate">Data Inizio</th><th st-sort="stopdate">Data Fine</th><th>Azioni</th></tr><tr><th></th><th><input st-search="name" placeholder="Cerca per nome" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in displayedListini"><td><b>{{ item.id }}</b></td><td>{{ item.name }}</td><td>{{ item.insdate ? (item.insdate*1000 | date:\'dd/MM/yyyy\') : \'-\' }}</td><td>{{ item.startdate*1000 | date:\'dd/MM/yyyy\' }}</td><td>{{ item.stopdate*1000 | date:\'dd/MM/yyyy\' }}</td><td><a class="btn btn-primary btn-xs" ui-sref="modifica-listino({id: item.id})">Modifica</a> <a class="btn btn-danger btn-xs" ng-click="eliminaListino(item)">Elimina</a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="listiniTablePageSize" st-displayed-pages="5" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/listini/listino.html','<div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dati Generali"><form ng-submit="salva()"><div class="row"><div class="col-md-12"><div class="form-group"><label for="fname">Nome*</label> <input required="" ng-model="listino.name" type="text" class="form-control" id="name" placeholder="Nome"></div></div><div class="col-sm-6"><div class="form-group"><label for="author">Valido dal</label><br><div class="input-group" style="margin-top: 12px;"><input date2str="" model-view-value="true" ui-mask="99/99/9999" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="listino.startdate" is-open="open" ng-required="true" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-sm-6"><div class="form-group"><label for="author">Valido fino al</label><br><div class="input-group" style="margin-top: 12px;"><input date2str="" model-view-value="true" ui-mask="99/99/9999" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="listino.stopdate" is-open="open2" ng-required="true" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-sm-6"><div class="form-group"><label for="parent">Incaricato<span ng-show="date.selectedIncaricato" class="label label-info">{{date.selectedIncaricato.lname}} {{date.selectedIncaricato.fname}} <a ng-click="rimuoviIncaricato()"><i class="ion-close"></i></a></span></label><ui-select object2id="" ng-model="listino.root" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-disabled="!incaricati.length"><ui-select-match placeholder="{{date.selectedIncaricato.lname}} {{date.selectedIncaricato.fname}}"><span>{{$select.selected.lname}} {{$select.selected.fname}}</span></ui-select-match><ui-select-choices repeat="p in incaricati | filter: $select.search | orderBy: \'lname\'"><span ng-bind-html="p.lname+\' \'+p.fname"></span></ui-select-choices></ui-select></div></div><div class="col-sm-6"><div class="form-group"><label for="parent">Limita a partecipanti evento <span ng-show="date.selectedEvent" class="label label-info">{{date.selectedEvent.name}} <a ng-click="rimuoviEvento()"><i class="ion-close"></i></a></span></label><ui-select object2id="" required="" ng-model="listino.eid" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-disabled="!eventi.length"><ui-select-match placeholder="{{date.selectedEvent.name}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="p in eventi | filter: $select.search"><span ng-bind-html="p.name"></span></ui-select-choices></ui-select></div></div><div class="col-md-12"><div class="form-group"><label for="fname">Note</label> <textarea name="description" ng-model="listino.note" id="inputDescription" class="form-control" rows="3">\n\t\t\t\t\t\tInserire note (opzionale)\n\t\t\t\t\t</textarea></div></div></div><button class="btn btn-primary" type="submit">Salva</button></form></uib-tab><uib-tab disable="!listino.id" heading="Prodotti"><form ng-submit="salva()"><div class="row"><div class="col-sm-12"><table class="table table-striped" st-table="displayedProdotti" st-safe-src="prodotti"><thead><tr><th></th><th st-sort="product">Prodotto</th><th st-sort="type">Tipo</th><th st-sort="sku">SKU</th><th st-sort="lprice">Prezzo Listino</th></tr><tr><th></th><th><input st-search="name" placeholder="Cerca per nome" class="input-sm form-control search-input" type="search"></th><th><input st-search="type" placeholder="Cerca per tipo" class="input-sm form-control search-input" type="search"></th><th><input st-search="sku" placeholder="Cerca per SKU" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in displayedProdotti" class="form-group"><td><input type="checkbox" ng-checked="prodottiAssociati[item.id]" id="featured" ng-click="date.prodottichanged=true" ng-model="item.checked"></td><td>{{item.name}}</td><td>{{item.type}}</td><td>{{item.sku}}</td><td><input float2int="" class="form-control input-sm" placeholder="{{prodottiAssociati[item.id].price/100 | number:2}}" ng-model="item.lprice" ng-disabled="!item.checked && !prodottiAssociati[item.id]" ng-required="item.checked"></td></tr></tbody></table></div></div><br><br><button class="btn btn-primary" type="submit">Salva</button></form></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/moduli/moduli.html','<a class="btn btn-primary" href="#!/nuovo-modulo">Crea Modulo</a><amway-pagination-size page-size="moduliTablePageSize" elements="moduli"></amway-pagination-size><div class="horizontal-scroll"><div ng-show="false" class="form-group select-page-size-wrap"></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedModuli" st-safe-src="moduli"><thead><tr class="sortable"><th width="1%" class="table-id" st-sort="id" st-sort-default="true">#</th><th width="34%" st-sort="filename">Modulo</th><th width="10%" class="text-center" st-sort="insdate">Data Inserimento</th><th width="35%">Descrizione</th><th width="20%">Azioni</th></tr><tr><th></th><th><input st-search="filename" placeholder="Cerca per nome" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in displayedModuli track by item.id"><td><b>{{ item.id }}</b></td><td><a ng-href="{{ item.awsurl }}" target="_blank"><b>{{ item.filename }}</b></a></td><td class="text-center">{{ item.insdate*1000 | date:\'dd/MM/yyyy\' }}</td><td ng-mouseenter="showDescription = true" ng-mouseleave="showDescription = false"><i ng-if="item.description" class="ion-eye" ng-hide="showDescription" style="font-size:28px;"></i> <span ng-show="showDescription">{{ item.description }}</span></td><td><a ng-if="item.awsurl" class="btn btn-success btn-xs" ng-href="{{ item.awsurl }}" target="_blank">Download</a> <a class="btn btn-danger btn-xs" ng-click="eliminaModulo(item)">Elimina</a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="moduliTablePageSize" st-displayed-pages="5" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/moduli/modulo.html','<div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dati Generali"><form ng-submit="salva()"><div class="row"><div class="col-md-6"><div class="form-group"><label for="fname">Nome documento*</label> <input required="" ng-model="modulo.filename" type="text" class="form-control" id="name" placeholder="Nome"></div></div><div class="col-md-6"><div class="form-group"><label for="fname">Descrizione</label> <textarea name="description" ng-model="modulo.description" id="inputDescription" class="form-control" rows="3">\n\t\t\t\t\t\tInserire descrizione (opzionale)\n\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-12"><a type="button" class="btn btn-primary" ng-if="modulo.awsurl" ng-href="{{ modulo.awsurl }}" target="_blank">Apri il documento caricato</a><br><br><h5 ng-show="evento.flyer">Seleziona il nuovo documento in sostituzione del precedente</h5><h5 ng-hide="evento.flyer">Seleziona il documento per l\'upload</h5><span style="font:smaller">{{f.name}} <i ng-show="f.progress==100" class="ion-checkmark-circled"></i></span> <button type="file" ngf-select="uploadFile($file, $invalidFiles)" accept=".pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .zip, .pages, .key, .rar, .numbers" ngf-max-size="20MB">Seleziona <i class="ion-ios-upload"></i></button><div class="progress" ng-show="f.progress>0 && f.progress < 100"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="{{f.progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{f.progress}}%"><span>{{f.progress}}%</span></div></div><br><br></div></div><button class="btn btn-default" type="submit">Salva</button></form></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/moduli/upload-file.html','<p>Per una miglior resa caricare un\'immagine quadrata</p><form id="imageform" name="imageform"><img height="100" ng-show="!immagine.file && evento.img" ng-src="{{baseurl}}{{evento.img}}" alt="image"> <img height="100" ngf-thumbnail="immagine.file"><div ng-required="true" class="button" ngf-select="" ng-model="immagine.file" name="image" ngf-pattern="\'image/*\'" ngf-accept="\'image/*\'" ngf-max-size="20MB" ngf-min-height="100">Seleziona un\'immagine <i style="font-size: 200%; cursor: pointer" class="ion-ios-upload"></i></div><br><br></form><button class="btn btn-default" ng-click="uploadImmagine()">Salva</button>');
$templateCache.put('app/pages/magazzino/magazzino.html','<div class="row tabs-enlarge"><div style="padding: 20px; color: #666666; background-color: #ffffff; border: none; border-radius: 5px; position: relative; margin-bottom: 24px; box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.25);"><div class="row ricerca_movimenti"><div class="col-xs-6 text-center"><button style="width: 60%;" ng-show="!inputLoad" class="btn btn-lg" ng-class="{\'btn-success\': !inputLoad, \'btn-warning\': inputLoad }" ng-click="startLoad();">INIZIO CARICO</button> <button style="width: 60%;" class="btn btn-lg" ng-show="inputLoad" ng-class="{\'btn-success\': !inputLoad, \'btn-warning\': inputLoad }" ng-click="endLoad();">FINE CARICO</button></div><div class="col-xs-6"><div class="input-group input-group-lg"><input type="text" ng-disabled="!inputLoad" class="form-control load-border" ng-class="{ active: inputLoad }" ng-model="sku" ng-change="open();" focus-if="inputLoad" placeholder="Leggi il barcode..." ng-model-options="{debounce: 500}"></div></div></div></div><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Ordini da GESTIRE ({{tasksP.length}})" class="text-center tab_color-red" style="width: 33%;font-size:15pt;"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" ng-show="!loading" st-table="items" st-pipe="loadMovimenti"><thead><tr class="sortable"><th><strong>Ordine</strong></th><th><strong>Utente</strong></th><th><strong>Indirizzo</strong></th><th><strong>Stato</strong></th><th><strong>Inserito</strong></th><th></th></tr></thead><tbody><tr ng-repeat="task in tasksP" class="row-space"><td><a href="#!/ordine/{{task.order.id}}">{{task.order.id}}</a></td><td>{{task.order.user.denominazione != null ? task.order.user.denominazione : task.order.user.lname + \' \' + task.order.user.fname }}</td><td>{{ task.glsaddress ? task.glsaddress : task.order.address }}, {{ task.glsloc ? task.glsloc : task.order.city }} ({{ task.glssigla ? task.glssigla : task.order.province }})</td><td>Da gestire</td><td>{{task.insdate*1000 | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-center" ng-show="!task.order.digitalonly"><button type="button" class="btn btn-lg btn-info" ng-click="editAddress(task);"><i class="fa fa-map-marker fa-lg" aria-hidden="true"></i> MODIFICA</button> <button ng-show="!task.enableManage" type="button" class="btn btn-lg btn-danger" ng-click="checkAddress(task);"><i class="fa fa-map-marker fa-lg" aria-hidden="true"></i> CONTROLLA</button> <button ng-show="task.enableManage" type="button" class="btn btn-lg btn-primary" ng-click="manageOrder(task);">GESTISCI</button> <button type="button" class="btn btn-lg" ng-click="deleteShipTask(task.id, $event)"><i class="fa fa-trash" aria-hidden="true"></i></button></td><td class="text-center" ng-show="task.order.digitalonly">Ordine solo digitale</td></tr></tbody></table></uib-tab><uib-tab heading="Ordini da RITIRARE ({{tasksA.length}})" class="text-center tab_color-blue" style="width: 33%;font-size:15pt;"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><button ng-disabled="!tasksA.length" type="button" class="btn btn-success btn-lg pull-right" ng-click="closeShipments();">CHIUDI SPEDIZIONI</button><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" ng-show="!loading" st-table="items" st-pipe="loadMovimenti"><thead><tr class="sortable"><th><strong>Ordine</strong></th><th><strong>Utente</strong></th><th><strong>Indirizzo</strong></th><th><strong>Stato</strong></th><th><strong>Inserito</strong></th><th></th></tr></thead><tbody><tr ng-repeat="task in tasksA" class="row-space"><td>{{task.order.id}}</td><td>{{task.order.user.denominazione != null ? task.order.user.denominazione : task.order.user.lname + \' \' + task.order.user.fname }}</td><td>{{ task.glsaddress ? task.glsaddress : task.order.address }}, {{ task.glsloc ? task.glsloc : task.order.city }} ({{ task.glssigla ? task.glssigla : task.order.province }})</td><td>Da gestire</td><td>{{task.insdate*1000 | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-center"><button type="button" class="btn btn-lg btn-danger" ng-click="deleteParcel(task);"><i class="fa fa-times fa-lg" aria-hidden="true"></i> ANNULLA</button> <a ng-href="{{ previewBaseUrl }}gls/{{task.numsped}}.pdf" target="_blank" class="btn btn-primary btn-lg">STAMPA <i class="fa fa-barcode fa-lg" aria-hidden="true"></i></a></td></tr></tbody></table></uib-tab><uib-tab heading="Ordini spediti a GLS ({{tasksG.length}})" class="text-center" style="width: 33%;font-size:15pt;"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" ng-show="!loading" st-table="items" st-pipe="loadMovimenti"><thead><tr class="sortable"><th><strong>Ordine</strong></th><th><strong>Utente</strong></th><th><strong>Indirizzo</strong></th><th><strong>Stato</strong></th><th><strong>Inserito</strong></th></tr></thead><tbody><tr ng-repeat="task in tasksG" class="row-space"><td>{{task.order.id}}</td><td>{{task.order.user.denominazione != null ? task.order.user.denominazione : task.order.user.lname + \' \' + task.order.user.fname }}</td><td>{{ task.glsaddress ? task.glsaddress : task.order.address }}, {{ task.glsloc ? task.glsloc : task.order.city }} ({{ task.glssigla ? task.glssigla : task.order.province }})</td><td>Da gestire</td><td>{{task.insdate*1000 | date:\'dd/MM/yy HH:mm\'}}</td></tr></tbody></table></uib-tab></uib-tabset></div></div>');
$templateCache.put('app/pages/magazzino/modalAddress.html','<div class="modal-header"><h2 class="modal-title" id="modal-title"><strong>CONTROLLO INDIRIZZO</strong></h2></div><div class="row modal-body"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading"><thead><th>Provincia</th><th>Comune</th><th>Frazione</th><th>CAP</th><th>Indirizzo</th><th><i class="fa fa-check fa-lg" aria-hidden="true"></i></th></thead><tbody><tr ng-repeat="address in $ctrl.addressList"><td class="modal_table-valign">{{ address.siglaProvincia }}</td><td class="modal_table-valign"><h3>{{ address.comune }}</h3></td><td class="modal_table-valign"><h3>{{ address.frazione }}</h3></td><td class="modal_table-valign"><h3>{{ address.cap }}</h3></td><td class="modal_table-valign"><h3>{{ address.indirizzo }}</h3></td><td width="80px" class="modal_table-valign"><button ng-if="!task.enableManage" type="button" class="btn btn-primary" ng-click="$ctrl.ok(address)">SELEZIONA</button></td></tr></tbody></table></div><div class="row modal-footer"></div>');
$templateCache.put('app/pages/magazzino/modalEditAddress.html','<div class="modal-content"><form ng-submit="$ctrl.save();" name="addressEditFrom"><div class="modal-header"><h2 class="modal-title" id="modal-title"><strong>MODIFICA MANUALE INDIRIZZO</strong></h2></div><div class="row modal-body edit-address"><div class="row"><div class="col-xs-12"><div class="form-group"><label>c/o</label> <input type="text" class="form-control" id="" placeholder="c/o..." ng-model="$ctrl.address.glsshipto"></div></div></div><div class="row"><div class="col-xs-12"><div class="form-group"><label>Indirizzo</label> <input type="text" class="form-control" id="" placeholder="Indirizzo..." ng-model="$ctrl.address.glsaddress"></div></div></div><div class="row"><div class="col-xs-12"><div class="form-group"><label>Provincia</label><ui-select ng-model="$ctrl.dati.selectedProvince" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true"><ui-select-match placeholder="Cerca provincia..."><span>{{$select.selected.descrizione}}</span></ui-select-match><ui-select-choices repeat="prov in $ctrl.provinces | filter: $select.search"><span ng-bind-html="prov.descrizione"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xs-4"><div class="form-group"><label>CAP</label> <input type="text" class="form-control" id="" placeholder="CAP..." ng-model="$ctrl.address.glszip"></div></div><div class="col-xs-8"><div class="form-group"><label>Comune</label> <input type="text" class="form-control" id="" placeholder="Comune..." ng-model="$ctrl.address.glsloc"></div></div></div></div><div class="row modal-footer"><div class="col-xs-6 text-right"><button class="btn btn-danger btn-lg" style="width:80%;" type="button" ng-click="$ctrl.cancel()">Annulla</button></div><div class="col-xs-6 text-left"><button type="submit" class="btn btn-primary btn-lg">CONFERMA</button></div></div></form></div>');
$templateCache.put('app/pages/magazzino/modalProduct.html','<div class="modal-header"><h2 class="modal-title" id="modal-title">{{ $ctrl.product.sku }}</h2></div><div class="modal-body" id="modal-body"><h2>{{ $ctrl.product.name }}</h2><h3>Quantit\xE0: <strong>{{ $ctrl.product.stock }}</strong></h3><h3>Tipo prodotto: {{ $ctrl.product.type }}</h3></div><div class="row modal-body"><div class="col-xs-6"><ui-select ng-model="$ctrl.selectedCausale" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true"><ui-select-match placeholder="Cerca causale..."><span>{{$select.selected.descrizione}}</span></ui-select-match><ui-select-choices repeat="c in $ctrl.causali | filter: $select.search"><span ng-bind-html="c.descrizione"></span></ui-select-choices></ui-select></div><div class="col-xs-6 text-center"><input style="width:30%;" type="number" min="0" name="" id="input" class="form-control" value="" pattern="" title="" ng-model="$ctrl.newLoad.invchange"></div></div><div class="row modal-body"><div class="col-xs-12"><textarea name="note" id="inputNote" class="form-control" rows="3" ng-model="$ctrl.newLoad.note"></textarea></div></div><div class="row modal-footer"><div class="col-xs-6 text-center"><button ng-disabled="$ctrl.disableButton();" class="btn btn-success btn-lg" style="width:80%;" type="button" ng-click="$ctrl.ok()">OK</button></div><div class="col-xs-6 text-center"><button class="btn btn-danger btn-lg" style="width:80%;" type="button" ng-click="$ctrl.cancel()">Annulla</button></div></div>');
$templateCache.put('app/pages/magazzino/modalShipment.html','<div class="modal-header"><h2 class="modal-title" id="modal-title"><strong>ORDINE #{{ $ctrl.task.order.id }} DEL {{ $ctrl.task.order.purchasedate*1000 | date:\'dd/MM/yy\' }}</strong></h2></div><div class="row modal-body"><div class="input-group input-group-lg" style="padding: 0 15px;"><input type="text" class="form-control" ng-disabled="$ctrl.enableSave == 0" style="border: 2px solid #999999;" ng-model="$ctrl.sku" ng-change="$ctrl.detectInput();" focus-if="$ctrl.focusLoad" placeholder="Leggi il barcode..." ng-model-options="{debounce: 500}"></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading"><thead><th>Prodotto</th><th>SKU</th><th>Stock</th><th>Quantit\xE0</th><th><i class="fa fa-check fa-lg" aria-hidden="true"></i></th></thead><tbody><tr ng-repeat="item in $ctrl.items"><td><img style="width: 60px; margin: 10px;" ng-src="{{$ctrl.baseurl}}{{item.img}}"></td><td class="modal_table-valign"><h3>{{ item.product.sku }}</h3></td><td class="modal_table-valign"><h3>{{ item.product.stock }}</h3></td><td class="modal_table-valign"><h3>{{ item.x }} / {{ item.qty }}</h3></td><td width="80px" class="modal_table-valign"><span ng-show="item.x == item.qty"><i class="fa fa-check-circle fa-2x text-success" aria-hidden="true"></i></span></td></tr></tbody></table></div><div class="row modal-footer"><div class="col-xs-6 text-center"><button class="btn btn-danger btn-lg" style="width:80%;" type="button" ng-click="$ctrl.cancel()">Annulla</button></div><div class="col-xs-6 text-center"><button class="btn btn-lg" style="width:80%;" type="button" ng-class="{ \'btn-success\': $ctrl.enableSave == 0, \'btn-default\': $ctrl.enableSave > 0 }" ng-disabled="$ctrl.enableSave > 0" ng-click="$ctrl.ok()">CONFERMA</button></div></div>');
$templateCache.put('app/pages/news/news.html','<div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dati Generali"><form ng-submit="salva()"><div class="row"><div class="col-md-6"><div class="form-group"><label for="fname">Titolo News*</label> <input required="" ng-model="news.title" maxlength="256" type="text" class="form-control" id="title" placeholder="Titolo"></div></div><div class="col-md-3"><div class="form-group"><label for="author">Data</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="parent.newsDate" is-open="aperto" ng-required="true" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="aperto = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-3 text-center"><div class="form-group"><label for="author">Ora</label><p class="input-group"><div uib-timepicker="" ng-model="parent.newsDate" hour-step="1" minute-step="1" pad-hours="false" show-meridian="false"></div></p></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="body">Corpo della news</label> <textarea maxlength="4096" name="description" ng-model="news.body" id="inputDescription" class="form-control" rows="6">\n\t\t\t\t\t\tInserire il corpo della news\n\t\t\t\t\t</textarea></div></div></div><button class="btn btn-default" type="submit">Salva</button></form></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/news/newsList.html','<a class="btn btn-primary" href="#!/nuova-news">Crea News</a><amway-pagination-size page-size="newsTablePageSize" elements="news"></amway-pagination-size><div class="horizontal-scroll"><div ng-show="false" class="form-group select-page-size-wrap"></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedNews" st-safe-src="news"><thead><tr class="sortable"><th width="1%" class="table-id" st-sort="id" st-sort-default="true">#</th><th width="40%" st-sort="title">Titolo</th><th width="10%" class="text-center" st-sort="insdate">Data Inserimento</th><th width="10%" class="text-center" st-sort="insdate">Data/Ora News</th><th width="19%" class="text-center">Corpo della news</th><th width="20%">Azioni</th></tr><tr><th></th><th><input st-search="title" placeholder="Cerca per titolo" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in displayedNews"><td><b>{{ item.id }}</b></td><td><b>{{ item.title }}</b></td><td class="text-center">{{ item.insdate*1000 | date:\'dd/MM/yyyy\' }}</td><td class="text-center">{{ item.newsdate*1000 | date:\'dd/MM/yyyy HH:mm\' }}</td><td class="text-center"><a class="btn btn-success btn-xs" ng-click="showNewsBody(item)">Anteprima</a></td><td><a class="btn btn-primary btn-xs" href="#!/modifica-news/{{item.id}}">Modifica</a> <a class="btn btn-warning btn-xs" href="#!/duplica-news/{{item.id}}">Duplica</a> <a class="btn btn-danger btn-xs" ng-click="eliminaNews(item)">Elimina</a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="newsTablePageSize" st-displayed-pages="5" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/ordini-wes/ordini-wes.html','<div class="row"><div ba-panel=""><form ng-submit="cerca()"><div class="row ricerca_movimenti"><div class="col-xs-1" style="padding-top: 10px"><h4>Cliente</h4></div><div class="col-xs-5"><ui-select ng-model="dati.selectedCustomer" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca cliente...">{{ $select.selected.denominazione }} {{$select.selected.visible!==0 ? \'\' : \'Vecchio Profilo\'}}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchCustomers($select.search)" refresh-delay="0" repeat="c in customers | filter: $select.search"><span ng-bind-html="c.denominazione"></span> <span ng-show="c.visible==0">(Vecchio Profilo)</span></ui-select-choices></ui-select></div><div class="col-xs-1 text-right"><button type="submit" class="btn btn-primary">Cerca</button></div><div class="col-xs-1 text-left"><button type="button" class="btn btn-danger" ng-click="emptySearch();">Svuota ricerca</button></div></div><div class="container-fluid user-detail-wes" ng-show="cliente.id"><div class="row"><div class="col-xs-12"><h4><strong>Dettagli cliente</strong></h4></div></div><div class="row" style="margin-top: 20px;"><div class="col-xs-4">Nome e Cognome: <strong>{{ cliente.fname }} {{ cliente.lname }}</strong></div><div class="col-xs-2">Email: <strong>{{ cliente.email }}</strong></div><div class="col-xs-2">Codice NTS: <strong>{{ cliente.code }}</strong></div><div class="col-xs-2">Data di nascita: <strong>{{ cliente.bdate*1000 | date: \'dd/MM/yyyy\' }}</strong></div></div><div class="row" style="margin-top: 20px;"><div class="col-xs-12">Indirizzo: <strong>{{ cliente.address }}, {{ cliente.streetno }} - {{ cliente.city }} ({{ cliente.province }})</strong></div></div><div class="row" ng-show="!creditCards.length && showMessageCC" style="margin-top: 20px;"><div class="col-xs-12"><h3><span class="label label-danger">Attenzione! Il cliente non ha carte di credito registrate.</span> <a ng-href="/#!/modifica-utente/{{cliente.id}}" target="_blank" class="btn btn-primary">Vai alla scheda dell\'utente</a></h3></div></div></div></form></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><div class="row" ng-show="confirmedOrder && !loading" style="padding: 30px 15px; color: #666666; background-color: #ffffff; border: none; border-radius: 5px; position: relative; margin: 0 0 24px 0; box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.25);"><div class="row"><div class="col-xs-12 text-center"><h1>Ordine inoltrato con successo</h1><h2>numero #{{confirmedOrder.id}}</h2></div></div><div class="row" style="margin-top: 20px;"><div class="col-xs-6 text-right"><a ng-href="/#!/ordine/{{confirmedOrder.id}}" target="_blank" class="btn btn-success btn-lg">Visualizza l\'ordine</a></div><div class="col-xs-6 text-left"><a class="btn btn-primary btn-lg" ng-click="emptySearch();">Nuovo Ordine</a></div></div></div><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel" ng-if="cliente.id && !confirmedOrder" ng-hide="loading"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Ordine" class="text-center tab_color-red" style="width: 50%;font-size:15pt;"><div class="input-group input-group-lg"><input type="text" class="form-control load-border" ng-class="{ active: inputLoad }" ng-model="sku.entity" ng-focus="inputLoad = true" ng-change="addProductToOrder();" focus-if="inputLoad" placeholder="Leggi il barcode..." ng-model-options="{debounce: 500}"></div><div class="row"><div class="col-lg-12 text-right"><h1><span class="label label-primary" style="border-radius:5px; padding-top:10px;">Totale: {{ totalWesOrder / 100 | currency:\'&euro; \' }}</span></h1></div></div><table class="table" ng-show="order.length" st-table="order"><thead><tr class="sortable"><th><strong>SKU</strong></th><th><strong>Nome</strong></th><th class="text-center"><strong>Tipo</strong></th><th class="text-right"><strong>Prezzo</strong></th><th class="text-center"><strong>Quantit\xE0</strong></th><th class="text-center"><strong>Azioni</strong></th></tr></thead><tbody><tr ng-repeat="row in order" class="row-space"><td class="text-center">{{ row.sku }}</td><td>{{ row.name }}</td><td class="text-center">{{ row.type }}</td><td class="text-right">{{ row.wesprice / 100 | currency:\'&euro; \' }}</td><td class="text-center"><h2><span style="padding-top: 10px;border-radius: 5px;" class="label label-primary">{{ row.qty }}</span></h2></td><td class="text-center"><button type="button" class="btn btn-warning" ng-click="row.qty = row.qty-1; checkQty(row); updateTotal();"><i class="fa fa-minus fa-lg" aria-hidden="true"></i></button> <button type="button" class="btn btn-info" ng-click="row.qty = row.qty+1; updateTotal();"><i class="fa fa-plus fa-lg" aria-hidden="true"></i></button> <button type="button" class="btn btn-danger" ng-click="removeFromOrder(row);"><i class="fa fa-trash fa-lg" aria-hidden="true"></i></button></td></tr></tbody></table><div class="row" style="margin-top: 30px;"><div class="col-xs-12 text-center"><button type="button" class="btn btn-danger btn-lg" ng-click="emptySearch();">Annulla</button> <button type="button" class="btn btn-success btn-lg" ng-disabled="!order.length || !creditCards.length" ng-click="confirmOrder();">Conferma Ordine</button></div></div></uib-tab><uib-tab heading="Carte" class="text-center" style="width: 50%;font-size:15pt;"><table class="table" ng-if="creditCards.length" st-table="displayedCreditCardsList" st-safe-src="creditCards"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="brand">Marca</th><th st-sort="exp">Scadenza</th><th st-sort="num">Numero</th><th></th></tr></thead><tbody><tr ng-repeat="item in displayedCreditCardsList"><td><b>#</b></td><td>{{ item.brand }}</td><td>{{ item.expmonth + "/" + item.expyear}}</td><td>{{ "****" + item.lastdigit }}</td><td></td></tr></tbody></table><div class="row" style="margin: 50px 0;"><div class="col-xs-12 text-center"><h2 ng-if="!creditCards.length">Non ci sono carte di credito registrate per questo cliente.</h2><br><br><a ng-href="/#!/modifica-utente/{{cliente.id}}" target="_blank" class="btn btn-primary btn-lg">Vai alla scheda dell\'utente</a></div></div></uib-tab></uib-tabset></div></div>');
$templateCache.put('app/pages/ordini-wes-onsite/ordini-wes.html','<div class="row"><div ba-panel=""><form ng-submit="cerca()"><div class="row ricerca_movimenti"><div class="col-xs-1" style="padding-top: 10px"><h4>Cliente</h4></div><div class="col-xs-5"><ui-select ng-model="dati.selectedCustomer" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca cliente...">{{ $select.selected.denominazione }} {{$select.selected.visible!==0 ? \'\' : \'Vecchio Profilo\'}}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchCustomers($select.search)" refresh-delay="0" repeat="c in customers | filter: $select.search"><span ng-bind-html="c.denominazione"></span> <span ng-show="c.visible==0">(Vecchio Profilo)</span></ui-select-choices></ui-select></div><div class="col-xs-1 text-right"><button type="submit" class="btn btn-primary">Cerca</button></div><div class="col-xs-1 text-left"><button type="button" class="btn btn-danger" ng-click="emptySearch();">Svuota ricerca</button></div></div><div class="container-fluid user-detail-wes" ng-show="cliente.id"><div class="row"><div class="col-xs-12"><h4><strong>Dettagli cliente</strong></h4></div></div><div class="row" style="margin-top: 20px;"><div class="col-xs-4">Nome e Cognome: <strong>{{ cliente.fname }} {{ cliente.lname }}</strong></div><div class="col-xs-2">Email: <strong>{{ cliente.email }}</strong></div><div class="col-xs-2">Codice NTS: <strong>{{ cliente.code }}</strong></div><div class="col-xs-2">Data di nascita: <strong>{{ cliente.bdate*1000 | date: \'dd/MM/yyyy\' }}</strong></div></div><div class="row" style="margin-top: 20px;"><div class="col-xs-12">Indirizzo: <strong>{{ cliente.address }}, {{ cliente.streetno }} - {{ cliente.city }} ({{ cliente.province }})</strong></div></div><div class="row" ng-show="!creditCards.length && showMessageCC" style="margin-top: 20px;"><div class="col-xs-12"><h3><span class="label label-danger">Attenzione! Il cliente non ha carte di credito registrate.</span> <a ng-href="/#!/modifica-utente/{{cliente.id}}" target="_blank" class="btn btn-primary">Vai alla scheda dell\'utente</a></h3></div></div></div></form></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><div class="row" ng-show="confirmedOrderid && !loading" style="padding: 30px 15px; color: #666666; background-color: #ffffff; border: none; border-radius: 5px; position: relative; margin: 0 0 24px 0; box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.25);"><div class="row"><div class="col-xs-12 text-center"><h1>Ordine inoltrato con successo</h1><h2>numero #{{confirmedOrderid}}</h2></div></div><div class="row" style="margin-top: 20px;"><div class="col-xs-6 text-right"><a ng-href="/#!/ordine/{{confirmedOrderid}}" target="_blank" class="btn btn-success btn-lg">Visualizza l\'ordine</a></div><div class="col-xs-6 text-left"><a class="btn btn-primary btn-lg" ng-click="emptySearch();">Nuovo Ordine</a></div></div></div><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel" ng-if="cliente.id && !confirmedOrderid" ng-hide="loading"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Ordine" class="text-center tab_color-red" style="width: 50%;font-size:15pt;"><div class="input-group input-group-lg"><input type="text" class="form-control load-border" ng-class="{ active: inputLoad }" ng-model="sku.entity" ng-focus="inputLoad = true" ng-change="addProductToOrder();" focus-if="inputLoad" placeholder="Leggi il barcode..." ng-model-options="{debounce: 500}"></div><div class="row"><div class="col-lg-12 text-right"><h1><span class="label label-primary" style="border-radius:5px; padding-top:10px;">Totale: {{ totalWesOrder / 100 | currency:\'&euro; \' }}</span></h1></div></div><table class="table" ng-show="order.length" st-table="order"><thead><tr class="sortable"><th><strong>SKU</strong></th><th><strong>Nome</strong></th><th class="text-center"><strong>Tipo</strong></th><th class="text-right"><strong>Prezzo</strong></th><th class="text-center"><strong>Quantit\xE0</strong></th><th class="text-center"><strong>Azioni</strong></th></tr></thead><tbody><tr ng-repeat="row in order" class="row-space"><td class="text-center">{{ row.sku }}</td><td>{{ row.name }}</td><td class="text-center">{{ row.type }}</td><td class="text-right">{{ row.wesprice / 100 | currency:\'&euro; \' }}</td><td class="text-center"><h2><span style="padding-top: 10px;border-radius: 5px;" class="label label-primary">{{ row.qty }}</span></h2></td><td class="text-center"><button type="button" class="btn btn-warning" ng-click="row.qty = row.qty-1; checkQty(row); updateTotal();"><i class="fa fa-minus fa-lg" aria-hidden="true"></i></button> <button type="button" class="btn btn-info" ng-click="row.qty = row.qty+1; updateTotal();"><i class="fa fa-plus fa-lg" aria-hidden="true"></i></button> <button type="button" class="btn btn-danger" ng-click="removeFromOrder(row);"><i class="fa fa-trash fa-lg" aria-hidden="true"></i></button></td></tr></tbody></table><div class="row" style="margin-top: 30px;"><div class="col-xs-12 text-center"><button type="button" class="btn btn-danger btn-lg" ng-click="emptySearch();">Annulla</button> <button type="button" class="btn btn-success btn-lg" ng-disabled="!order.length || !creditCards.length" ng-click="confirmOrder();">Conferma Ordine</button></div></div></uib-tab><uib-tab heading="Carte" class="text-center" style="width: 50%;font-size:15pt;"><table class="table" ng-if="creditCards.length" st-table="displayedCreditCardsList" st-safe-src="creditCards"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="brand">Marca</th><th st-sort="exp">Scadenza</th><th st-sort="num">Numero</th><th></th></tr></thead><tbody><tr ng-repeat="item in displayedCreditCardsList"><td><b>#</b></td><td>{{ item.brand }}</td><td>{{ item.expmonth + "/" + item.expyear}}</td><td>{{ "****" + item.lastdigit }}</td><td></td></tr></tbody></table><div class="row" style="margin: 50px 0;"><div class="col-xs-12 text-center"><h2 ng-if="!creditCards.length">Non ci sono carte di credito registrate per questo cliente.</h2><br><br><a ng-href="/#!/modifica-utente/{{cliente.id}}" target="_blank" class="btn btn-primary btn-lg">Vai alla scheda dell\'utente</a></div></div></uib-tab></uib-tabset></div></div>');
$templateCache.put('app/pages/opens/open.html','<div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dati Generali"><form ng-submit="salva()"><div class="row"><div class="col-sm-12"><div class="form-group"><label for="fname">Sigla</label> <input required="" ng-model="open.name" type="text" class="form-control" id="name" placeholder="Nome"></div></div><div class="col-sm-3"><div class="form-group"><label for="location">Modalit\xE0</label><select name="type" ng-model="open.opentype" id="inputCoe" class="form-control" required="required"><option ng-repeat="m in opentypes" ng-value="m.value">{{m.label}}</option></select></div></div><div class="col-sm-4"><div class="form-group"><label for="location">Centro congressi</label><angucomplete-alt id="ex2" placeholder="{{open.venue.name}}" pause="300" selected-object="selectedVenue.r" local-data="venues" search-fields="name" title-field="name" disable-input="open.opentype !== \'live\'" minlength="1" input-class="form-control form-control-small" match-class="highlight"></angucomplete-alt></div></div><div class="col-sm-3"><div class="form-group"><label for="opdate">Data</label><p class="input-group"><input id="opdate" type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="parent.openDate" is-open="aperto" ng-required="true" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="aperto = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-sm-2 text-center"><div class="form-group"><p class="input-group" style="margin-top:-30px;"></p><div id="optime" uib-timepicker="" ng-model="parent.openDate" hour-step="1" minute-step="1" pad-hours="false" show-meridian="false"></div></div></div><div class="col-sm-3"><div class="form-group"><label for="fname">Tipo incontro {{ open.opentype == \'online\' ? \'*\' : \'\' }}</label> <input ng-model="open.incontro" type="text" class="form-control" id="incontro" ng-required="open.opentype == \'online\'" placeholder="incontro"></div></div><div class="col-sm-3"><div class="form-group"><label for="minamwaylevel">Livello Amway Minimo <a class="pointer small-delete-label-btn btn btn-xs btn-danger" ng-if="prodotto.minawaylevel" ng-click="prodotto.minawaylevel = undefined">Cancella</a></label><select ng-model="open.minlevel" class="form-control" title="Livello Amway"><option value="diamante">Diamante</option><option value="smeraldo">Smeraldo</option><option value="platino fondatori">Platino fondatori</option><option value="platino">Platino</option><option value="argento">Argento</option><option value="leaders">Leaders Club</option><option value="nq">Tutti</option></select></div></div><div class="col-sm-3"></div><div class="col-sm-12"><div class="form-group"><label for="fname">Link</label> <input ng-model="open.link" type="text" class="form-control" id="link" placeholder="link"></div></div><div class="col-sm-12"><div class="form-group"><label for="fname">Descrizione</label> <textarea rows="3" ng-model="open.descr" type="text" class="form-control" id="descr" placeholder="Descrizione"></textarea></div></div><div class="col-sm-12"><div class="form-group"><label for="fname">Messaggio</label> <textarea rows="3" ng-model="open.disclaimer" type="text" class="form-control" id="disclaimer" placeholder="Messaggio"></textarea></div></div><div class="col-sm-12"><button class="btn btn-default pull-right" type="submit">Salva</button></div></div></form></uib-tab><uib-tab disable="!open.id" heading="Volantino"><div ng-include="" src="\'app/pages/opens/upload-image.html\'"></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/opens/opens.html','<a class="btn btn-primary" href="#!/nuovo-open">Crea Open</a><amway-pagination-size page-size="opensTablePageSize" elements="opens"></amway-pagination-size><div class="horizontal-scroll"><div ng-show="false" class="form-group select-page-size-wrap"></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedOpens" st-safe-src="opens"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Sigla</th><th st-sort="opendate">Data e Ora</th><th st-sort="venue.province">Provincia</th><th st-sort="venue.city">Citt\xE0</th><th st-sort="venue.opentype">Tipo</th><th st-sort="venue.name">Location</th><th>Naviga</th><th>Azioni</th></tr><tr><th></th><th><input st-search="name" placeholder="Cerca per sigla" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="venue.province" placeholder="Cerca per provincia" class="input-sm form-control search-input" type="search"></th><th><input st-search="venue.city" placeholder="Cerca per citt\xE0" class="input-sm form-control search-input" type="search"></th><th><select st-search="opentype" placeholder="Cerca per citt\xE0" class="input-sm form-control search-input" type="search"><option value=""></option><option value="online">Online</option><option value="live">Dal vivo</option></select></th><th><input st-search="venue.name" placeholder="Cerca per location" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in displayedOpens"><td><b>{{item.id}}</b></td><td><b>{{item.name}}</b></td><td>{{item.opendate*1000 | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{ item.venue.province }}</td><td>{{ item.venue.city }}</td><td>{{ (item.opentype) ? ((item.opentype === \'live\') ? \'Dal vivo\' : \'Online\') : \'\' }}</td><td>{{item.venue.name}}</td><td><a class="btn btn-success btn-xs" target="_blank" ng-href="https://www.google.it/maps?q={{item.venue.name}}+{{item.venue.address}}+{{item.venue.streetnum}}+{{item.venue.comune}}">Naviga</a></td><td><a class="btn btn-primary btn-xs" href="#!/modifica-open/{{item.id}}">Modifica</a> <a class="btn btn-primary btn-xs" href="#!/duplica-open/{{item.id}}">Duplica</a> <a class="btn btn-danger btn-xs" ng-click="eliminaOpen(item)">Elimina</a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="opensTablePageSize" st-displayed-pages="5" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/opens/upload-image.html','<form id="imageform" name="imageform"><span style="font:smaller">{{immagine.file.name || open.flyer}}</span><div ng-required="true" class="button" ngf-select="" ng-model="immagine.file" name="image" ngf-pattern="\'.jpg,.jpeg,.png,.pdf\'" ngf-accept="\'.jpg,.jpeg,.png,.pdf\'" ngf-max-size="20MB" ngf-min-height="100">Seleziona un\'immagine o un PDF <i style="font-size: 200%; cursor: pointer" class="ion-ios-upload"></i></div><br><br><div class="progress" ng-show="progressPercentage>0 && progressPercentage < 100"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="{{progressPercentage}}" aria-valuemin="0" aria-valuemax="100" style="width: {{progressPercentage}}%"><span>{{progressPercentage}}%</span></div></div></form><button class="btn btn-default" ng-click="uploadImmagine()">Salva</button>');
$templateCache.put('app/pages/ordini/guestsTemplate.html','<div class="form-group"><table class="table table-striped"><thead><th>Nome</th><th>Ruolo</th></thead><tbody><tr ng-repeat="item in guests" "=""><td>{{ item.nome }}</td><td>{{ item.role }}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ordini/ordine.html','<div ba-panel="" ba-panel-class="panel-primary"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-right"><a class="btn btn-primary" ng-if="order.chargestatus == \'captured\'" ng-href="https://dashboard.stripe.com/payments/{{ order.charge }}" target="_blank">Pagamento <i class="fa fa-cc-stripe fa-lg" aria-hidden="true"></i></a></div></div><button class="btn btn-warning" ng-if="order.status != \'refunded\'" ng-click="partialRefund()">{{(isPartialRefund)?(\'Rimborsa\'):(\'Rimborso parziale\')}}</button><div class="form-group"><table class="table table-striped"><thead><th>#</th><th>Nome</th><th>Quantit&agrave;</th><th>Prezzo unitario</th><th>IVA</th><th></th></thead><tbody><tr ng-repeat="item in order.items" ng-if="item.qty > 0"><td>{{ item.id }}</td><td>{{ item.name }}</td><td>{{ item.qty }}</td><td>{{ item.unitprice / 100 | currency:\'&euro; \' }}</td><td>{{ item.vat }}</td><td ng-show="item.guests"><a ng-click="viewGuests(item.guests)">Ospiti</a></td><td ng-show="isPartialRefund"><input type="checkbox" ng-click="checkUncheck(item)"></td></tr></tbody></table></div><table class="table table-striped table-label-value"><tbody><tr><td># Ordine</td><td>{{ order.id }}</td></tr><tr><td>Data ordine</td><td>{{ order.purchasedate * 1000 | date }}</td></tr><tr><td>Totale</td><td>{{ order.total / 100 | currency:\'&euro; \' }}</td></tr><tr><td>Utente</td><td><a href="#!/modifica-utente/{{ order.user.id }}">{{ order.user.fname }} {{ order.user.lname }}</a></td></tr><tr ng-if="order.giftforuser"><td>Acquistato per</td><td><a href="#!/modifica-utente/{{ order.giftforuser.id }}">{{ order.giftforuser.fname }} {{ order.giftforuser.lname }}</a></td></tr><tr><td>Spese di spedizione</td><td>{{ order.shipment / 100 | currency:\'&euro; \' }}</td></tr><tr><td>Stato</td><td>{{ order.status }}</td></tr><tr ng-if="!!order.shipto"><td>Spedizione a</td><td>{{ order.shipto }}</td></tr><tr ng-if="order.items[0].type!=\'ebook\' && order.items[0].type!=\'audio\' && order.items[0].type!=\'video\' && order.items[0].type!=\'ticket\' && order.items[0].type!=\'dpack\'"><td>Indirizzo</td><td>{{ order.address || order.user.address }}</td></tr><tr><td>CAP</td><td>{{ order.zipcode || order.user.zipcode }}</td></tr><tr><td>Citt\xE0</td><td>{{ order.city || order.user.city }}</td></tr><tr><td>Provincia</td><td>{{ order.province || order.user.province }}</td></tr><tr><td>Numero di telefono</td><td>{{ order.mobile || order.user.mobile }}</td></tr><tr><td>Note</td><td>{{ order.note }}</td></tr></tbody></table><br><br><div class="form-group"><a class="btn btn-warning" ng-if="order.status != \'refunded\'" ng-click="refund()">Rimborso e Nota di Credito</a> <a class="btn btn-info" href="#!/ordini">Reinvia fattura</a> <a class="btn btn-danger" href="#!/ordini">Cancella</a> <a ng-if="!isOrdineUtente" class="btn btn-default" href="#!/ordini">Torna agli ordini</a> <a ng-if="isOrdineUtente" class="btn btn-default" href="#!/modifica-utente/{{ order.uid }}#ordini">Torna agli ordini utente</a><div style="margin-left: 10px" ng-if="order.status == \'payment_ok\' || order.status == \'shipped\' || order.status == \'delivered\'" class="well pull-right"><form class="form-inline" ng-submit="refund(\'stripe\')"><input float2int="" required="" ng-model="order.partialrefund" type="text" class="form-control" id="name" placeholder="Importo"> <button ng-disabled="!order.partialrefund || order.partialrefund>order.total+order.shipment" type="submit" class="btn btn-primary">Rimborso Stripe</button></form></div><a class="btn btn-primary pull-right" style="margin-left:5px;" ng-if="order.status == \'payment_ok\' || order.status == \'shipped\' || order.status == \'delivered\'" ng-click="refund(\'magazzino\')">Reintegra magazzino</a></div></div>');
$templateCache.put('app/pages/ordini/ordini.html','<div ba-panel=""><form ng-if="!isShipment" ng-submit="cerca()"><h3>Ricerca</h3><div class="row"><div class="col-xs-3"><label>Data</label><div class="input-group"><input type="text" date2str="" forcetime="down" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="filter.dateStart" is-open="popUpDate1" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate1 = !popUpDate1"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3"><label>Data fine</label><div class="input-group"><input type="text" date2str="" forcetime="up" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="filter.dateEnd" is-open="popUpDate2" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate2 = !popUpDate2"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3"><label>Prezzo minimo</label> <input type="number" class="form-control" ng-model="filter.totalMin"></div><div class="col-xs-3"><label>Prezzo massimo</label> <input type="number" class="form-control" ng-model="filter.totalMax"></div></div><br><div class="row"><div class="col-xs-4"><label>Nome utente</label> <input type="text" class="form-control" ng-model="filter.userName"></div><div class="col-xs-4"><label>Stato</label><select class="form-control" ng-model="filter.status"><option value="">---</option><option value="cart">Carrello</option><option value="payment_ok">Pagamento completato</option><option value="payment_failed">Pagamento fallito</option><option value="shipped">Spedito</option><option value="delivered">Consegnato</option><option value="canceled">Cancellato</option><option value="refunded">Rimborsato</option></select></div><div class="col-xs-4"><label>&nbsp;</label> <button type="submit" class="btn btn-primary form-control">Ricerca</button></div></div></form><form ng-if="isShipment" ng-submit="cerca()"><h3>Ricerca</h3><div class="row"><div class="col-xs-3"><label>Data</label><div class="input-group"><input type="text" date2str="" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="filter.dateStart" is-open="popUpDate1" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate1 = !popUpDate1"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3"><label>Data fine</label><div class="input-group"><input type="text" date2str="" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="filter.dateEnd" is-open="popUpDate2" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate2 = !popUpDate2"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-6"><label>Numero spedizione o Indirizzo di spedizione</label> <input type="text" class="form-control" ng-model="filter.term"></div></div><div class="row"><div class="col-xs-4 col-xs-offset-8"><label>&nbsp;</label> <button type="submit" class="btn btn-primary form-control">Ricerca</button></div></div></form></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><div ng-show="!loading" class="white-bg md-whiteframe-4dp"><amway-pagination-server-side page-size="ordiniTablePageSize" elements="orders"></amway-pagination-server-side><table ng-show="!loading" class="table" st-table="orders" st-pipe="loadMovimenti"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th>Data inserimento</th><th>Data acquisto</th><th>Nome utente</th><th>Totale</th><th>Note</th><th>Stato</th><th></th></tr></thead><tbody><tr ng-repeat="order in orders"><td class="table-id"><a href="#!/ordine/{{ order.id }}">{{ order.id }}</a></td><td>{{ 1000 * order.insdate | date }}</td><td>{{ (order.purchasedate)? (1000 * order.purchasedate | date) : "N/A" }}</td><td><a href="#!/modifica-utente/{{ order.user.id }}">{{ order.user.fname }} {{ order.user.lname }}</a></td><td>{{ order.total / 100 | currency:"EUR" }}</td><td>{{ order.note }}</td><td>{{ order.status }}</td><td><a ng-show="isShipment" ng-href="https://www.gls-italy.com/?option=com_gls&view=track_e_trace&mode=search&numero_spedizione=T1{{order.numsped}}&tipo_codice=nazionale" class="btn btn-primary" target="_blank">Tracking</a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="ordiniTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/prodotti/autori.html','<div class="row"><div class="col-sm-10"><ui-select ng-model="authors.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca...">{{ $select.selected.lname }} {{ $select.selected.fname }}</ui-select-match><ui-select-choices repeat="sp in authors | filter: $select.search"><span ng-bind-html="sp.lname"></span> <span ng-bind-html="sp.fname"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><button class="btn btn-default" ng-click="aggiungiAutoreProdotto(authors.selected)">Aggiungi</button></div></div><div class="row"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedAuthorProduct" st-safe-src="authorproduct"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="fname">Nome</th><th st-sort="lname">Cognome</th><th st-sort="country">Paese</th><th>Azioni</th></tr></thead><tbody><tr ng-repeat="item in displayedAuthorProduct"><td><b>{{item.author.id}}</b></td><td>{{item.author.fname}}</td><td>{{item.author.lname}}</td><td>{{item.author.country}}</td><td><a class="btn btn-danger btn-xs" ng-click="eliminaAutoreProdotto(item)">Elimina</a></td></tr></tbody></table></div>');
$templateCache.put('app/pages/prodotti/correlati.html','<div class="row"><div class="col-sm-10"><ui-select ng-model="selectedRelated.product" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca prodotto...">{{ $select.selected.name }} ({{ $select.selected.type }})</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchProductRelatedPool($select.search)" refresh-delay="0" repeat="sp in productsrelatedpool | filter: $select.search"><span ng-bind-html="sp.name"></span> (<span ng-bind-html="sp.type"></span>)</ui-select-choices></ui-select></div><div class="col-sm-2"><button class="btn btn-default" ng-click="aggiungiProdottoRelated(selectedRelated.product)">Aggiungi</button></div></div><div class="row"><div class="row spinner-cont" ng-if="loadingrelated"><span class="spinner"></span></div><table class="table" ng-if="!loadingrelated" st-table="displayedProductRelated" st-safe-src="relatedproducts"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="fname">Nome</th><th st-sort="lname">Tipo</th><th st-sort="country">Prezzo</th><th>Azioni</th></tr></thead><tbody><tr ng-repeat="item in displayedProductRelated"><td><b>{{item.related.id}}</b></td><td><b>{{item.related.name}}</b></td><td><b>{{item.related.type}}</b></td><td><b>{{item.related.price/100 | number:2}}\u20AC</b></td><td><a class="btn btn-danger btn-xs" ng-click="eliminaProdottoRelated(item)">Elimina</a></td></tr></tbody></table></div>');
$templateCache.put('app/pages/prodotti/form-prodotto.html','<div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dati Generali"><form ng-submit="salva()"><div class="row"><div class="col-sm-8"><div class="form-group"><label for="fname">Nome</label> <input required="" ng-model="prodotto.name" type="text" class="form-control" id="name" placeholder="Nome"></div></div><div class="col-sm-4"><div class="form-group"><label for="ruolo">Tipo Bonus</label><select required="" ng-model="prodotto.btype" class="form-control" title="Tipo Bonus"><option value="bbs">BBS</option><option value="wes">WES</option><option value="sp">Starter Pack</option><option value="cep">CEP</option><option value="punti">Punti</option></select></div></div><div class="col-sm-4"><div class="form-group"><label for="ruolo">Tipo</label><select required="" ng-model="prodotto.type" class="form-control" title="Tipo"><option value="book">Libro</option><option value="cd">CD</option><option value="dvd">DVD</option><option value="ebook">Ebook</option><option value="audio">Traccia Audio</option><option value="video">Traccia Video</option><option value="file">File Digitale</option><option value="ticket">Biglietto</option><option value="dpack">Pack Digitale</option><option value="mpack">Pack Fisico</option><option value="xpack">Pack Misto</option><option value="credit">Crediti</option><option value="item">Altro</option></select></div></div><div ng-if="prodotto.type==\'credit\'" class="col-sm-2"><div class="form-group"><label for="pts">Durata Crediti(giorni)</label> <input required="" ng-model="prodotto.creditdays" type="number" class="form-control" id="pts" placeholder="Durata crediti"></div></div><div ng-if="prodotto.type==\'credit\'" class="col-sm-2"><div class="form-group"><label for="pts">Numero Crediti</label> <input required="" ng-model="prodotto.creditvalue" type="number" class="form-control" id="pts" placeholder="Numero crediti"></div></div><div ng-if="prodotto.type==\'dpack\'" class="col-sm-2"><div class="form-group"><label for="pts">Numero File</label> <input ng-disabled="prodotto.id" required="" ng-model="prodotto.files" type="number" class="form-control" id="pts" placeholder="Numero di Files"></div></div><div class="{{prodotto.type==\'dpack\' ? \'col-sm-3\' : \'col-sm-5\'}}"><div class="form-group"><label for="author">SKU</label> <input required="" ng-model="prodotto.sku" type="text" class="form-control" id="sku" placeholder="SKU"></div></div><div class="col-sm-2"><div class="form-group"><label for="minstock">Giacenza minima</label> <input required="" ng-model="prodotto.minstock" type="text" class="form-control" id="minstock" placeholder="Giacenza minima"></div></div><div class="col-sm-1"><div ng-show="prodotto.type!=\'ticket\'" class="form-group"><label for="stock">Giacenza</label><h4 style="margin-top:12px;" ng-class="{\'text-danger\': prodotto.stock < minStock }">{{ prodotto.stock }} <span ng-show="loadRefill">{{(prodotto.stock > minStock) ? \'\' : \' (integr. magazzino)\' }}</span></h4></div></div><div class="col-sm-8" ng-if="prodotto.type==\'ticket\'"><div class="form-group"><label for="parent">Evento</label><ui-select required="" ng-model="prodotto.selectedEvent" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-disabled="!eventi.length"><ui-select-match placeholder="Evento"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="p in eventi | filter: $select.search"><span ng-bind-html="p.name"></span></ui-select-choices></ui-select></div></div><div ng-if="prodotto.type != \'ticket\'" class="col-sm-12"><div class="form-group"><label for="author">Numero autorizzazione Amway</label> <input ng-disabled="prodotto.type==\'ticket\'" required="" ng-model="prodotto.title" type="text" class="form-control" id="author" placeholder="Numero autorizzazione Amway"></div></div><div class="col-sm-12"><div class="form-group"><label for="abstract">Descrizione Breve</label><trix-editor angular-trix="" ng-model="prodotto.abstract1" type="text" class="form-control" id="abstract" placeholder="Descrizione Breve"></trix-editor></div></div><div ng-if="prodotto.type != \'ticket\'" class="col-sm-12"><div class="form-group"><label for="description">Descrizione</label><trix-editor angular-trix="" ng-model="prodotto.description"></trix-editor></div></div><div class="col-sm-8"><div class="form-group"><label for="ean">EAN</label> <input ng-model="prodotto.ean" type="text" class="form-control" id="ean" placeholder="EAN"></div></div><div class="col-sm-4"><div class="form-group"><label for="pts">Punti</label> <input ng-model="prodotto.pts" type="number" class="form-control" id="pts" placeholder="Numero di Punti"></div></div><div class="col-sm-2"><div class="form-group"><label for="author">Stato</label><select ng-model="prodotto.status" class="form-control" title="Stato" style="margin-top: 12px;"><option value="ok">Attivo</option><option value="ko">Non Attivo</option></select></div></div><div class="col-sm-3"><div class="form-group"><label for="author">In vendita da</label><br><div class="input-group" style="margin-top: 12px;"><input type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="prodotto.sellfromdateS" is-open="open" ng-required="true" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-sm-2"><div class="form-group"><div class="input-group"><div style="width: 50%;" uib-timepicker="" ng-model="prodotto.sellfromdateS" hour-step="1" minute-step="1" pad-hours="false" show-meridian="false"></div></div></div></div><div class="col-sm-3"><div class="form-group"><label for="author">In vendita fino a</label><div class="input-group" style="margin-top: 12px;"><input type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="prodotto.selltodateS" is-open="open2" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-sm-2"><div class="form-group"><div class="input-group"><div style="width: 50%;" uib-timepicker="" ng-model="prodotto.selltodateS" hour-step="1" minute-step="1" pad-hours="false" show-meridian="false"></div></div></div></div><div class="col-sm-3"><div class="form-group"><label for="price">Tipo di Pagamento</label><select required="" ng-disabled="prodotto.id" ng-model="prodotto.paytype" class="form-control" title="Tipo Pagamento"><option value="onetime">Singolo</option><option value="recurrent">Ricorrente</option></select></div></div><div ng-if="prodotto.paytype==\'recurrent\'" class="col-sm-3"><div class="form-group"><label for="price">Modalit\xE0 di Pagamento</label><select ng-disabled="prodotto.id" ng-model="prodotto.payperiod" class="form-control" title="Modalit\xE0 Pagamento"><option value="7">Settimanale</option><option value="30">Mensile</option><option value="365">Annuale</option></select></div></div><div class="col-sm-3"><div class="form-group"><label for="price">Prezzo <span ng-show="prodotto.paytype==\'recurrent\' && prodotto.payperiod==\'30\'">al mese</span> <span ng-show="prodotto.paytype==\'recurrent\' && prodotto.payperiod==\'7\'">alla settimana</span> <span ng-show="prodotto.paytype==\'recurrent\' && prodotto.payperiod==\'365\'">all\'anno</span></label> <input float2int="" required="" ng-model="prodotto.price" type="text" class="form-control" id="price" placeholder="Prezzo"></div></div><div class="col-sm-3"><div class="form-group"><input ng-true-value="1" ng-false-value="0" type="checkbox" id="promo" ng-model="prodotto.newuser"> <label for="price">Prezzo Nuovi iscritti</label> <input ng-disabled="!prodotto.newuser" float2int="" ng-required="prodotto.newuser" ng-model="prodotto.newuserprice" type="text" class="form-control" id="price" placeholder="Prezzo"></div></div><div ng-if="prodotto.paytype==\'recurrent\'" class="col-sm-3"><div class="form-group"><label for="periods">Durata <span ng-show="prodotto.paytype==\'recurrent\' && prodotto.payperiod==\'30\'">in mesi</span> <span ng-show="prodotto.paytype==\'recurrent\' && prodotto.payperiod==\'7\'">in settimane</span> <span ng-show="prodotto.paytype==\'recurrent\' && prodotto.payperiod==\'365\'">in anni</span></label> <input required="" ng-model="prodotto.periods" type="number" class="form-control" id="periods" placeholder="Durata"></div></div></div><div class="row"><div class="col-sm-2"><div class="form-group"><input ng-true-value="1" ng-false-value="0" type="checkbox" id="promo" ng-model="prodotto.promo"> <label for="price">Prezzo Promozionale</label> <input style="margin-top: 11px;" ng-disabled="!prodotto.promo" float2int="" required="" ng-model="prodotto.promoprice" type="text" class="form-control" id="price" placeholder="Prezzo"></div></div><div class="col-sm-2"><div class="form-group"><label for="author">In promozione da</label><p class="input-group" style="margin-top: 12px;"><input ng-disabled="!prodotto.promo" type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="prodotto.promofromdateS" is-open="open3" ng-required="true" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button ng-disabled="!prodotto.promo" type="button" class="btn btn-default" ng-click="open3=true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-sm-1"><div class="form-group"><div class="input-group"><div ng-disabled="!prodotto.promo" style="width: 50%;" uib-timepicker="" ng-model="prodotto.promofromdateS" hour-step="1" minute-step="30" pad-hours="false" show-meridian="false"></div></div></div></div><div class="col-sm-2"><div class="form-group"><label for="author">In promozione fino a</label><p class="input-group" style="margin-top: 12px;"><input ng-disabled="!prodotto.promo" type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="prodotto.promotodateS" is-open="open4" ng-required="true" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button ng-disabled="!prodotto.promo" type="button" class="btn btn-default" ng-click="open4=true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-sm-1"><div class="form-group"><div class="input-group"><div ng-disabled="!prodotto.promo" style="width: 50%;" uib-timepicker="" ng-model="prodotto.promotodateS" hour-step="1" minute-step="30" pad-hours="false" show-meridian="false"></div></div></div></div></div><div class="row"><div class="col-sm-2"><div class="form-group"><input ng-true-value="1" ng-false-value="0" ng-click="deletePromo2()" type="checkbox" id="promo2" ng-model="prodotto.promo2" ng-disabled="!prodotto.promo || !prodotto.promoprice || !prodotto.promofromdateS || !prodotto.promotodateS"> <label for="price2">Prezzo Promozionale 2</label> <input style="margin-top: 11px;" ng-disabled="!prodotto.promo2" float2int="" required="" ng-model="prodotto.secpromo" type="text" class="form-control" id="price2" placeholder="Prezzo"></div></div><div class="col-sm-2"><div class="form-group"><label for="author">In promozione fino a</label><p class="input-group" style="margin-top: 12px;"><input ng-disabled="!prodotto.promo2" type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="prodotto.secpromotodate" is-open="open5" ng-required="true" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button ng-disabled="!prodotto.promo2" type="button" class="btn btn-default" ng-click="open5=true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-sm-1"><div class="form-group"><div class="input-group"><div ng-disabled="!prodotto.promo2" style="width: 50%;" uib-timepicker="" ng-model="prodotto.secpromotodate" hour-step="1" minute-step="30" pad-hours="false" show-meridian="false"></div></div></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input ng-true-value="1" ng-false-value="0" type="checkbox" id="featured" ng-model="prodotto.featured"> <span>Prodotto in Evidenza</span></label></div></div><div class="col-md-3"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input ng-true-value="1" ng-false-value="0" type="checkbox" id="disclaimer" ng-model="prodotto.needdisclaimer"> <span>Disclaimer necessario</span></label></div></div><div class="col-md-3"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input ng-true-value="1" ng-false-value="0" type="checkbox" id="needdisclaimerapp" ng-model="prodotto.needdisclaimerapp" ng-disabled="prodotto.type==\'book\' || prodotto.type==\'cd\' || prodotto.type==\'dvd\' || prodotto.type==\'mpack\' || prodotto.type==\'item\'"> <span>Acquistabile in APP</span></label></div></div><div class="col-md-3"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input ng-true-value="1" ng-false-value="0" type="checkbox" id="availableforgift" ng-model="prodotto.availableforgift" ng-disabled="!(prodotto.type==\'file\' || prodotto.type==\'audio\' || prodotto.type==\'dpack\' || prodotto.type==\'credit\' || prodotto.type==\'xpack\')"> <span>Disponibile per omaggio</span></label></div></div><div class="col-md-3" ng-if="prodotto.type==\'xpack\'"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input ng-true-value="1" ng-false-value="0" type="checkbox" id="forcedigital" ng-model="prodotto.forcedigital"> <span>Solo prodotti digitali</span></label></div></div></div><div ng-if="prodotto.needdisclaimer" class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><label>Disclaimer</label><trix-editor angular-trix="" ng-model="prodotto.disclaimer"></trix-editor></div></div><br><div ng-if="prodotto.needdisclaimerapp" class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><label>Disclaimer App</label> <textarea ng-model="prodotto.disclaimerapp" style="width:100%;height:56px;"></textarea></div></div><br><button class="btn btn-default" type="submit">Salva</button></form></uib-tab><uib-tab disable="!prodotto.id" heading="Categorie"><form ng-submit="salvaCategorie()"><div class="row"><div class="col-sm-12"><div ng-repeat="c in categorie" class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="featured" ng-model="c.checked"> <span ng-style="c.menu ? {\'font-weight\': \'bold\'} : \'\'">{{c.name}}</span></label></div></div></div><button class="btn btn-default" type="submit">Salva</button></form></uib-tab><uib-tab disable="!prodotto.id" ng-hide="prodotto.type==\'ticket\'" heading="Immagine"><div ng-include="" src="\'app/pages/prodotti/upload-image.html\'"></div></uib-tab><uib-tab disable="!prodotto.id" ng-if="prodotto.type==\'audio\' || prodotto.type==\'video\' || prodotto.type==\'ebook\' || prodotto.type==\'dpack\'" heading="File"><div ng-include="" src="\'app/pages/prodotti/upload-file.html\'"></div></uib-tab><uib-tab disable="!prodotto.id" ng-if="prodotto.type==\'file\'" heading="File Digitale"><div ng-include="" src="\'app/pages/prodotti/upload-file-digitale.html\'"></div></uib-tab><uib-tab disable="!prodotto.id" ng-if="prodotto.type==\'book\' || (prodotto.type==\'xpack\' && prodotto.forcedigital == 0) || prodotto.type==\'cd\' || prodotto.type==\'dvd\' || prodotto.type==\'ebook\' || prodotto.type==\'audio\' || prodotto.type==\'video\' || prodotto.type==\'dpack\'" heading="Autori"><div ng-include="" src="\'app/pages/prodotti/autori.html\'"></div></uib-tab><uib-tab disable="!prodotto.id" ng-if="prodotto.type==\'mpack\' || prodotto.type==\'xpack\'" heading="Pack"><div ng-include="" src="\'app/pages/prodotti/pack.html\'"></div></uib-tab><uib-tab disable="!prodotto.id" heading="Dati Contabili"><form ng-submit="salva()"><div class="row"><div class="col-sm-4"><div class="form-group"><label for="ruolo">Codice IVA</label><select ng-model="prodotto.codiceiva" class="form-control" title="Codice IVA"><option ng-repeat="tipo in codiciiva" ng-value="tipo.codice">{{tipo.codice}} - {{tipo.descrizione}}</option></select></div></div><div class="col-sm-4"><div class="form-group"><label for="ruolo">Conto Ricavo</label><select ng-model="prodotto.contoricavo" class="form-control" title="Conto Ricavo"><option ng-repeat="tipo in conti" ng-value="tipo.codice">{{tipo.codice}} - {{tipo.descrizione}}</option></select></div></div></div><button class="btn btn-default" type="submit">Salva</button></form></uib-tab><uib-tab disable="!prodotto.id" heading="Barcode"><img id="barcode"></uib-tab><uib-tab heading="Movimenti di magazzino"><table class="table" ng-if="!loading" st-table="displayedmmagazzino" st-safe-src="mmagazzino"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th>Id utente</th><th>Id prodotto</th><th>Data inserimento</th><th>Stock Precedente</th><th>Stock aggiornato + corrente</th><th>Variazione stock</th></tr><tr><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in displayedmmagazzino"><td class="table-id">{{item.id}}</td><td><a href="/#!/modifica-utente/{{item.uid}}">{{item.uid}}</a></td><td><a href="/#!/modifica-prodotto/{{item.pid}}">{{item.pid}}</a></td><td>{{item.insdate * 1000 | date : "dd/MM/yyyy"}}</td><td>{{item.previous}}</td><td>{{item.invcurrent}}</td><td>{{item.invchange}}</td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="10"></div></td></tr></tfoot></table></uib-tab><uib-tab heading="WES"><div class="row"><div class="col-sm-3"><div class="form-group"><label for="price">Prezzo WES</label> <input float2int="" ng-model="prodotto.wesprice" type="text" class="form-control" id="price" placeholder="Prezzo WES"></div></div><div class="col-sm-3"><div class="form-group"><label for="minstock">Disponibilit\xE0 WES</label> <input ng-model="prodotto.wesstock" type="text" class="form-control" placeholder="Disponibilit\xE0 WES"></div></div><div class="col-sm-3"><div class="form-group"><label for="wesstock">Giacenza online</label> <input ng-disabled="true" type="text" class="form-control" placeholder="{{prodotto.stock-prodotto.wesstock}}"></div></div></div><div class="row"><div class="col-xs-12"><button type="button" class="btn btn-primary" ng-click="prodotto.wesprice = 0; prodotto.wesstock = 0;">Reset</button> <button class="btn btn-default" type="button" ng-click="salva();">Salva</button></div></div></uib-tab><uib-tab heading="Omaggio"><div class="row"><div class="col-sm-2"><div class="form-group"><label for="author">Dal</label><p class="input-group" style="margin-top: 12px;"><input type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="prodotto.giftfromS" is-open="open10" ng-required="true" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open10=true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-sm-2 text-left"><div class="form-group"><div class="input-group"><div style="width: 50%;" uib-timepicker="" ng-model="prodotto.giftfromS" hour-step="1" minute-step="30" pad-hours="false" show-meridian="false"></div></div></div></div><div class="col-sm-2"><div class="form-group"><label for="author">Al</label><p class="input-group" style="margin-top: 12px;"><input type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="prodotto.gifttoS" is-open="open11" ng-required="true" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open11=true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-sm-2 text-left"><div class="form-group"><div class="input-group"><div style="width: 50%;" uib-timepicker="" ng-model="prodotto.gifttoS" hour-step="1" minute-step="30" pad-hours="false" show-meridian="false"></div></div></div></div><div class="col-sm-4"><div class="form-group"><label for="parent" style="margin-top: 12px;">Prodotto</label><ui-select required="" ng-disabled="!prodotto.gifttoS || !prodotto.giftfromS" ng-model="prodotto.selectedGiftProduct" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Prodotto"><span>{{$select.selected.name}} ({{$select.selected.type | uppercase }})</span></ui-select-match><ui-select-choices repeat="p in prodottiOmaggio | filter: $select.search"><span ng-bind-html="p.name"></span> ( <span class="text-uppercase" ng-bind-html="p.type"></span> )</ui-select-choices></ui-select></div></div></div><br><br><div class="row"><div class="col-md-6 text-left"><button type="button" class="btn btn-danger" ng-click="resetOmaggio()">Cancella</button> <button ng-disabled="!prodotto.selectedGiftProduct" class="btn btn-default" type="button" ng-click="salva()">Salva</button></div></div></uib-tab><uib-tab heading="Visibilit\xE0"><div class="row"><div class="col-sm-3"><div class="form-group"><label for="minamwaylevel">Livello Amway Minimo <a class="pointer small-delete-label-btn btn btn-xs btn-danger" ng-if="prodotto.minawaylevel" ng-click="prodotto.minawaylevel = undefined">Cancella</a></label><select ng-model="prodotto.minawaylevel" class="form-control" title="Livello Amway"><option value="distribuzione selettiva">Distribuzione selettiva</option><option value="diamante">Diamante</option><option value="smeraldo">Smeraldo</option><option value="platino fondatori">Platino fondatori</option><option value="platino">Platino</option><option value="argento">Argento</option><option value="leaders">Leaders Club</option><option value="nq">Non qualificato</option></select></div></div><div class="col-sm-3"><div class="form-group"><label for="parent">Downline <a class="pointer small-delete-label-btn btn btn-xs btn-danger" ng-if="prodotto.selectedDownline" ng-click="prodotto.selectedDownline = undefined">Cancella</a></label><ui-select ng-model="prodotto.selectedDownline" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="{{prodotto.selectedDownline.fname ? (prodotto.selectedDownline.fname+\' \'+prodotto.selectedDownline.lname) : \'Cerca utente...\'}}">{{prodotto.selectedDownline.fname ? (prodotto.selectedDownline.fname+\' \'+prodotto.selectedDownline.lname) : \'Cerca sponsor...\'}}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchIncaricato($select.search)" refresh-delay="0" repeat="sp in incaricati"><span ng-bind-html="sp.fname"></span> <span ng-bind-html="sp.lname"></span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group"><label for="parent">Prodotto prerequisito <a class="pointer small-delete-label-btn btn btn-xs btn-danger" ng-if="prodotto.selectedPrerequisite" ng-click="prodotto.selectedPrerequisite = undefined">Cancella</a></label><ui-select required="" ng-model="prodotto.selectedPrerequisite" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-disabled="!prodottiOmaggio.length"><ui-select-match placeholder="Prodotto prerequisito"><span>{{$select.selected.name}} ({{$select.selected.type | uppercase }})</span></ui-select-match><ui-select-choices repeat="p in prodottiOmaggio | filter: $select.search"><span ng-bind-html="p.name"></span> ( <span class="text-uppercase" ng-bind-html="p.type"></span> )</ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="prereqdisclaimer">Disclaimer prerequisito <a class="pointer small-delete-label-btn btn btn-xs btn-danger" ng-if="prodotto.prerequisitedisclaimer" ng-click="prodotto.prerequisitedisclaimer = undefined">Cancella</a></label> <textarea ng-model="prodotto.prerequisitedisclaimer" class="form-control" id="prereqdisclaimer" style="height: inherit;" rows="5" maxlength="512">\n\t\t\t\t\t\t</textarea></div></div><div class="col-md-6"><div class="form-group"><label for="minstock">Et\xE0 minima</label> <input ng-model="prodotto.minage" type="number" class="form-control" style="max-width: 150px;" id="minage" placeholder="Et\xE0 minima" min="0" max="100" step="1"></div><div class="form-group"><label for="minstock">Et\xE0 massima</label> <input ng-model="prodotto.maxage" type="number" class="form-control" style="max-width: 150px;" id="maxage" placeholder="Et\xE0 massima" min="0" max="100" step="1"></div></div></div><div class="row"><div class="col-md-6 text-left"><button class="btn btn-default" type="button" ng-click="salva()">Salva</button></div></div></uib-tab><uib-tab disable="!prodotto.id" heading="Prodotti correlati"><div ng-include="" src="\'app/pages/prodotti/correlati.html\'"></div></uib-tab><uib-tab disable="!prodotto.id" heading="Distribuzione" ng-click="fitBounds()"><div class="row spinner-cont" ng-if="loadingProd"><span class="spinner"></span></div><div class="row" ng-if="!loadingProd"><div class="col-xs-3"><label>Venduti dal</label><div class="input-group"><input type="text" date2str="" forcetime="down" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="heatmapRange.start" is-open="popUpDate1" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate1 = !popUpDate1"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3"><label>Venduti al</label><div class="input-group"><input type="text" date2str="" forcetime="up" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="heatmapRange.stop" is-open="popUpDate2" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate2 = !popUpDate2"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div style="margin-top: 5px"><br><button type="button" class="btn btn-primary" ng-click="refreshHeatmap()">Ricarica</button></div></div><div id="map" style="width:100%; height : 700px"></div></uib-tab><uib-tab disable="!prodotto.id" heading="Invii omaggio"><div class="row"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><amway-pagination-server-side page-size="giftTablePageSize" elements="gifts"></amway-pagination-server-side><table class="table" ng-if="!loading" st-table="gifts" st-pipe="getGift"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th>Destinatario</th><th>Data omaggio</th><th>Dettagli</th></tr></thead><tbody><tr ng-repeat="item in gifts"><td><b>{{item.id}}</b></td><td><a href="#!/modifica-utente/{{ item.userid }}">{{item.user.fname + \' \' + item.user.lname}}</a></td><td>{{item.giftdate * 1000 | date : \'dd/MM/yyyy\'}}</td><td>{{item.reason}} <span ng-if="item.sender">- <a href="#!/modifica-utente/{{ item.sender }}">Vedi utente</a></span></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="giftTablePageSize" st-displayed-pages="tableStateGift.pagination.numberOfPages" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/prodotti/modifica-prodotto.html','<div ng-include="" src="\'app/pages/prodotti/form-prodotto.html\'"></div>');
$templateCache.put('app/pages/prodotti/nuovo-prodotto.html','<div ng-include="" src="\'app/pages/prodotti/form-prodotto.html\'"></div>');
$templateCache.put('app/pages/prodotti/pack.html','<small class="text-danger" ng-if="prodotto.type == \'xpack\'"><i>puoi aggiungere sia prodotti fisici che digitali</i></small> <small class="text-danger" ng-if="prodotto.type == \'mpack\'"><i>puoi aggiungere solo prodotti fisici</i></small><div class="row"><div class="col-sm-10"><ui-select ng-model="pack.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca...">{{ $select.selected.name }} ({{ $select.selected.type }})</ui-select-match><ui-select-choices repeat="sp in products | filter: $select.search"><span ng-bind-html="sp.name"></span> ( <span ng-bind-html="sp.type"></span> )</ui-select-choices></ui-select></div><div class="col-sm-2"><button class="btn btn-default" ng-click="aggiungiProdottoPack(pack.selected)">Aggiungi</button></div></div><div class="row"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedProductPack" st-safe-src="packproducts"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="fname">Nome</th><th st-sort="lname">Tipo</th><th st-sort="country">Prezzo</th><th>Azioni</th></tr></thead><tbody><tr ng-repeat="item in displayedProductPack"><td><b>{{item.product.id}}</b></td><td><b>{{item.product.name}}</b></td><td><b>{{item.product.type}}</b></td><td><b>{{item.product.price/100 | number:2}}\u20AC</b></td><td><a class="btn btn-danger btn-xs" ng-click="eliminaProdottoPack(item)">Elimina</a></td></tr></tbody></table></div>');
$templateCache.put('app/pages/prodotti/printMagazzino.html','<a class="btn btn-primary hide-print" ng-show="!loading" style="float:right;" ng-click="print();">STAMPA <i class="fa fa-print fa-lg" aria-hidden="true"></i></a><table class="table table-striped table-bordered border-table"><thead><tr><th><strong>SKU</strong></th><th><strong>Prodotto</strong></th><th><strong>Giacenza minima</strong></th><th><strong>Giacenza</strong></th></tr></thead><tbody><tr class="hide-print"><span ng-if="loading" class="spinner"></span></tr><tr ng-repeat="p in printProducts | orderBy: \'sku\'"><td>{{ p.sku }}</td><td>{{ p.name }}</td><td>{{ p.minstock }}</td><td>{{ p.stock }}</td></tr></tbody></table>');
$templateCache.put('app/pages/prodotti/prodotti.html','<a class="btn btn-primary" href="#!/nuovo-prodotto">Crea Prodotto</a> <a class="btn btn-warning" target="_blank" href="#!/stampa-magazzino">Lista stampabile</a><br><div class="row"><div ba-panel=""><h3>Ricerca</h3><div class="row"><div class="col-xs-3"><label>Nome</label> <input type="text" class="form-control" ng-model="filter.name" my-enter="applySearch();"></div><div class="col-xs-2"><label>Tipo</label><select required="" ng-model="filter.type" class="form-control" title="Tipo"><option value="book">Libro</option><option value="cd">CD</option><option value="dvd">DVD</option><option value="ebook">Ebook</option><option value="audio">Traccia Audio</option><option value="video">Traccia Video</option><option value="file">File Digitale</option><option value="ticket">Biglietto</option><option value="dpack">Pack Digitale</option><option value="mpack">Pack Fisico</option><option value="xpack">Pack Misto</option><option value="item">Altro</option></select></div><div class="col-xs-2"><label>SKU</label> <input type="text" class="form-control" ng-model="filter.sku" my-enter="applySearch();"></div><div class="col-xs-3"><label>Autore</label> <input type="text" class="form-control" ng-model="filter.author" my-enter="applySearch();"></div><div class="col-xs-2"><label for="author">Stato</label><select ng-model="filter.status" class="form-control" title="Stato" ng-init="filter.status = \'ok\'"><option value="ok">Attivi</option><option value="ko">Non Attivi</option><option value="all">Tutti</option></select></div></div><div class="col-xs-4 pull-right"><label>&nbsp;</label> <button class="btn btn-primary form-control pull-right" ng-click="applySearch()">Ricerca</button></div></div><amway-pagination-server-side page-size="itemsPerPage" elements="products"></amway-pagination-server-side><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" ng-show="!loading" st-table="products" st-pipe="getData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th>Prodotto</th><th st-sort="name">Nome</th><th st-sort="type">Tipo</th><th st-sort="sku">SKU</th><th st-sort="author">Autore</th><th st-sort="price">Prezzo</th><th st-sort="pts">Punti</th><th>Azioni</th></tr></thead><tbody ng-show="loadingpage"><tr><td colspan="9" class="text-center"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div></td></tr></tbody><tbody><tr ng-repeat="item in products"><td class="table-id">{{item.id}}</td><td><a ng-show="item.type!=\'ticket\'" href="#!/modifica-prodotto/{{item.id}}"><img style="width: 100px; margin: 10px;" ng-src="{{baseurl}}{{item.img}}"></a></td><td><b>{{item.name}}</b></td><td>{{item.type}}</td><td>{{item.sku}}</td><td><spam ng-repeat="author in item.authors">{{author.fname + " " + author.lname}}</spam></td><td>{{item.price / 100 | currency:\'&euro; \'}}</td><td>{{item.pts}}</td><td><a class="btn btn-primary btn-xs" href="#!/modifica-prodotto/{{item.id}}">Modifica</a> <a class="btn btn-primary btn-xs" href="#!/duplica-prodotto/{{item.id}}">Duplica</a> <a class="btn btn-danger btn-xs" ng-if="userLogged.id == 1" ng-click="eliminaProdotto(item)">Elimina</a></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="itemsPerPage" colspan="9"></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/prodotti/upload-file-digitale.html','<div ng-if="prodotto.type != \'dpack\'"><table class="table" ng-if="!loading" st-table="displayedallegati" st-safe-src="allegati"><thead><tr class="sortable"><th>#</th><th>Nome</th><th>Dimensione MB</th><th style="text-align:center">File</th><th style="text-align:center">Upload File</th><th style="text-align:center">Cover</th><th style="text-align:center">Upload Cover</th><th style="text-align:center" ng-show="prodotto.type==\'file\'">Condivisibile</th><th></th><th></th></tr></thead><tbody><tr ng-repeat="allegato in displayedallegati"><td class="table-id">{{allegato.id}}</td><td>{{allegato.name}}</td><td><input type="text" style="width : 150px" class="form-control" ng-model="allegato.lunghezza" placeholder="mb"></td><td style="text-align:center"><a ng-show="allegato.awsurl" href="{{allegato.awsurl}}"><i class="ion-ios-download" tooltips="" tooltip-template="{{allegato.filename}}" tooltip-size="small"></i></a></td><td style="text-align:center"><button type="button" class="btn btn-default btn-xs" ng-hide="f[allegato.id] && f[allegato.id].progress != 100" ngf-select="uploadFile( $file, allegato.id)">Seleziona <i class="ion-ios-upload"></i></button></td><td style="text-align:center"><a ng-show="allegato.coverimg" target="_blank" href="{{allegato.coverimg}}"><i class="ion-ios-download" tooltips="" tooltip-template="{{allegato.coverimg}}" tooltip-size="small"></i></a></td><td style="text-align:center"><button type="button" class="btn btn-default btn-xs" ng-hide="f[allegato.id] && f[allegato.id].progress != 100" ngf-select="uploadCover($file,allegato.id, allegato)" ngf-pattern=".jpeg,.png,.jpg" accept=".png,.jpeg,.jpg" ngf-max-size="200KB">Seleziona <i class="ion-ios-upload"></i></button></td><td><button type="button" class="btn btn-success" ng-click="updateAttach(allegato)">Salva</button> &nbsp;&nbsp; <button type="button" class="btn btn-warning" ng-click="updateAttachRetroattivo(allegato)">Update Retroattivo</button></td><td style="text-align:center"><input ng-if="prodotto.type==\'audio\'" type="checkbox" ng-model="allegato.sharable" ng-true-value="1" ng-false-value="0"></td><td ng-if="allegato.sharable"><button type="button" ng-if="!loadUnshare" class="btn btn-danger" ng-click="unshareAttach(allegato)">Unshare</button><div ng-if="loadUnshare" style="position:relative;top:-5px;left:20px;display:inline-block;"><span class="spinner"></span></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/prodotti/upload-file-dpack-all.html','<div ng-if="prodotto.type == \'dpack\'" class="well" ng-repeat="allegato in allegati track by $index"><div class="row"><div class="col-md-2"><div class="form-group"><label for="parent">Autore</label><ui-select required="" ng-model="fileData[allegato.id].selectedAuthor" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="{{allegato.author || \'Autore\'}}"><span>{{$select.selected.fname}} {{$select.selected.lname}}</span></ui-select-match><ui-select-choices repeat="p in authors | filter: $select.search"><span ng-bind-html="p.fname +\' \'+ p.lname"></span></ui-select-choices></ui-select></div></div><div class="col-md-3"><div class="form-group"><label for="input" class="col-sm-2 control-label">Titolo</label> <input type="text" name="titolo" id="input" class="form-control" value="" required="required" placeholder="{{allegato.title || \'Titolo\'}}" ng-model="allegato.title"></div></div><div class="col-md-2"><div class="form-group"><label for="amway" class="control-label">Autor. Amway</label> <input type="text" name="titolo" id="amway" class="form-control" value="" required="required" placeholder="{{allegato.amwayauth || \'Autor. Amway\'}}" ng-model="allegato.amwayauth"></div></div><div class="col-md-2"><div class="col-md-12"><br><h5><a ng-show="allegato.awsurl" href="{{allegato.awsurl}}">{{allegato.name}} <i class="ion-ios-download"></i></a> <span ng-show="!allegato.awsurl">{{allegato.name}} (da caricare)</span></h5><span style="font:smaller">{{f[allegato.id].name}} <i ng-show="f[allegato.id].progress==100" class="ion-checkmark-circled"></i></span> <button ng-disabled="!allegato.title || (!fileData[allegato.id].selectedAuthor.id && !allegato.author)" type="button" class="btn btn-default btn-xs" ng-hide="f[allegato.id] && f[allegato.id].progress != 100" ngf-select="uploadFile($file, allegato.id, true)">Seleziona <i class="ion-ios-upload"></i></button><div class="progress" ng-show="f[allegato.id].progress>0 && f[allegato.id].progress < 100"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="{{f[allegato.id].progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{f[allegato.id].progress}}%"><span>{{f[allegato.id].progress}}%</span></div></div><br><br></div></div><div class="col-md-1" style="text-align:center"><div class="form-group"><label for="amway" class="control-label">Condivisibile</label> <input type="checkbox" ng-model="allegato.sharable" ng-true-value="1" ng-false-value="0"><br><br><button type="button" ng-if="allegato.sharable && !loadUnshare" class="btn btn-danger btn-xs" ng-click="unshareAttach(allegato)">Unshare</button><div ng-if="allegato.sharable && loadUnshare" style="position:relative;top:-5px;left:20px;display:inline-block;"><span class="spinner"></span></div><button type="button" ng-if="allegato.sharable && !loadRetroshare" class="btn btn-primary btn-xs" ng-click="retroshareAttach(allegato)">Retroshare</button><div ng-if="allegato.sharable && loadRetroshare" style="position:relative;top:-5px;left:20px;display:inline-block;"><span class="spinner"></span></div></div></div><div class="col-md-1" style="text-align:center"><div class="form-group"><label for="lunghezza" class="control-label">Lunghezza</label> <input type="text" size="8" ng-model="allegato.lunghezza"></div></div><div class="col-md-1 text-center"><div class="form-group text-center"><label for="parent">Azioni</label><br><button type="button" class="btn btn-primary btn-xs" ng-click="addDpackAuthorTitle(allegato);">Salva</button><br><br><button type="button" class="btn btn-danger btn-xs" ng-click="allegato.author = allegato.title = allegato.amwayauth = f[allegato.id] = fileData[allegato.id] = allegato.awsurl = undefined">Cancella</button></div></div></div></div>');
$templateCache.put('app/pages/prodotti/upload-file-dpack-future.html','<div ng-if="prodotto.type == \'dpack\'" class="well" ng-repeat="allegato in allegatiFuture track by $index"><div class="row"><div class="col-md-2"><div class="form-group"><label for="parent">Autore</label><ui-select required="" ng-model="fileData[allegato.id].selectedAuthor" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="{{allegato.author || \'Autore\'}}"><span>{{$select.selected.fname}} {{$select.selected.lname}}</span></ui-select-match><ui-select-choices repeat="p in authors | filter: $select.search"><span ng-bind-html="p.fname +\' \'+ p.lname"></span></ui-select-choices></ui-select></div></div><div class="col-md-3"><div class="form-group"><label for="input" class="col-sm-2 control-label">Titolo</label> <input type="text" name="titolo" id="input" class="form-control" value="" required="required" placeholder="{{allegato.title || \'Titolo\'}}" ng-model="allegato.title"></div></div><div class="col-md-2"><div class="form-group"><label for="amway" class="control-label">Autor. Amway</label> <input type="text" name="titolo" id="amway" class="form-control" value="" required="required" placeholder="{{allegato.amwayauth || \'Autor. Amway\'}}" ng-model="allegato.amwayauth"></div></div><div class="col-md-2"><div class="col-md-12"><br><h5><a ng-show="allegato.awsurl" href="{{allegato.awsurl}}">{{allegato.name}} <i class="ion-ios-download"></i></a> <span ng-show="!allegato.awsurl">{{allegato.name}} (da caricare)</span></h5><span style="font:smaller">{{f[allegato.id].name}} <i ng-show="f[allegato.id].progress==100" class="ion-checkmark-circled"></i></span> <button ng-disabled="!allegato.title || (!fileData[allegato.id].selectedAuthor.id && !allegato.author)" type="button" class="btn btn-default btn-xs" ng-hide="f[allegato.id] && f[allegato.id].progress != 100" ngf-select="uploadFile($file, allegato.id, true)">Seleziona <i class="ion-ios-upload"></i></button><div class="progress" ng-show="f[allegato.id].progress>0 && f[allegato.id].progress < 100"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="{{f[allegato.id].progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{f[allegato.id].progress}}%"><span>{{f[allegato.id].progress}}%</span></div></div><br><br></div></div><div class="col-md-1" style="text-align:center"><div class="form-group"><label for="amway" class="control-label">Condivisibile</label> <input type="checkbox" ng-model="allegato.sharable" ng-true-value="1" ng-false-value="0"><br><br><button type="button" ng-if="allegato.sharable && !loadUnshare" class="btn btn-danger btn-xs" ng-click="unshareAttach(allegato)">Unshare</button><div ng-if="allegato.sharable && loadUnshare" style="position:relative;top:-5px;left:20px;display:inline-block;"><span class="spinner"></span></div><button type="button" ng-if="allegato.sharable && !loadRetroshare" class="btn btn-primary btn-xs" ng-click="retroshareAttach(allegato)">Retroshare</button><div ng-if="allegato.sharable && loadRetroshare" style="position:relative;top:-5px;left:20px;display:inline-block;"><span class="spinner"></span></div></div></div><div class="col-md-1" style="text-align:center"><div class="form-group"><label for="lunghezza" class="control-label">Lunghezza</label> <input type="text" size="8" ng-model="allegato.lunghezza"></div></div><div class="col-md-1 text-center"><div class="form-group text-center"><label for="parent">Azioni</label><br><button type="button" class="btn btn-primary btn-xs" ng-click="addDpackAuthorTitle(allegato);">Salva</button><br><br><button type="button" class="btn btn-danger btn-xs" ng-click="allegato.author = allegato.title = allegato.amwayauth = f[allegato.id] = fileData[allegato.id] = allegato.awsurl = undefined">Cancella</button></div></div></div></div>');
$templateCache.put('app/pages/prodotti/upload-file-dpack-past.html','<div ng-if="prodotto.type == \'dpack\'" class="well" ng-repeat="allegato in allegatiPast track by $index"><div class="row"><div class="col-md-2"><div class="form-group"><label for="parent">Autore</label><ui-select required="" ng-model="fileData[allegato.id].selectedAuthor" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="{{allegato.author || \'Autore\'}}"><span>{{$select.selected.fname}} {{$select.selected.lname}}</span></ui-select-match><ui-select-choices repeat="p in authors | filter: $select.search"><span ng-bind-html="p.fname +\' \'+ p.lname"></span></ui-select-choices></ui-select></div></div><div class="col-md-3"><div class="form-group"><label for="input" class="col-sm-2 control-label">Titolo</label> <input type="text" name="titolo" id="input" class="form-control" value="" required="required" placeholder="{{allegato.title || \'Titolo\'}}" ng-model="allegato.title"></div></div><div class="col-md-2"><div class="form-group"><label for="amway" class="control-label">Autor. Amway</label> <input type="text" name="titolo" id="amway" class="form-control" value="" required="required" placeholder="{{allegato.amwayauth || \'Autor. Amway\'}}" ng-model="allegato.amwayauth"></div></div><div class="col-md-2"><div class="col-md-12"><br><h5><a ng-show="allegato.awsurl" href="{{allegato.awsurl}}">{{allegato.name}} <i class="ion-ios-download"></i></a> <span ng-show="!allegato.awsurl">{{allegato.name}} (da caricare)</span></h5><span style="font:smaller">{{f[allegato.id].name}} <i ng-show="f[allegato.id].progress==100" class="ion-checkmark-circled"></i></span> <button ng-disabled="!allegato.title || (!fileData[allegato.id].selectedAuthor.id && !allegato.author)" type="button" class="btn btn-default btn-xs" ng-hide="f[allegato.id] && f[allegato.id].progress != 100" ngf-select="uploadFile($file, allegato.id, true)">Seleziona <i class="ion-ios-upload"></i></button><div class="progress" ng-show="f[allegato.id].progress>0 && f[allegato.id].progress < 100"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="{{f[allegato.id].progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{f[allegato.id].progress}}%"><span>{{f[allegato.id].progress}}%</span></div></div><br><br></div></div><div class="col-md-1" style="text-align:center"><div class="form-group"><label for="amway" class="control-label">Condivisibile</label> <input type="checkbox" ng-model="allegato.sharable" ng-true-value="1" ng-false-value="0"><br><br><button type="button" ng-if="allegato.sharable && !loadUnshare" class="btn btn-danger btn-xs" ng-click="unshareAttach(allegato)">Unshare</button><div ng-if="allegato.sharable && loadUnshare" style="position:relative;top:-5px;left:20px;display:inline-block;"><span class="spinner"></span></div><button type="button" ng-if="allegato.sharable && !loadRetroshare" class="btn btn-primary btn-xs" ng-click="retroshareAttach(allegato)">Retroshare</button><div ng-if="allegato.sharable && loadRetroshare" style="position:relative;top:-5px;left:20px;display:inline-block;"><span class="spinner"></span></div></div></div><div class="col-md-1" style="text-align:center"><div class="form-group"><label for="lunghezza" class="control-label">Lunghezza</label> <input type="text" size="8" ng-model="allegato.lunghezza"></div></div><div class="col-md-1 text-center"><div class="form-group text-center"><label for="parent">Azioni</label><br><button type="button" class="btn btn-primary btn-xs" ng-click="addDpackAuthorTitle(allegato);">Salva</button><br><br><button type="button" class="btn btn-danger btn-xs" ng-click="allegato.author = allegato.title = allegato.amwayauth = f[allegato.id] = fileData[allegato.id] = allegato.awsurl = undefined">Cancella</button></div></div></div></div>');
$templateCache.put('app/pages/prodotti/upload-file.html','<div ng-if="prodotto.type != \'dpack\'" class="well" ng-repeat="allegato in allegati track by $index"><div class="row product-upload-file"><div class="col-md-4 block"><div class="border border-dark block row"><div class="col-md-3"><label>Titolo:</label></div><div class="col-md-9">{{ (allegato.title) ? allegato.title : \'-\' }}</div><br><br><div class="col-md-3"><label>Lunghezza:</label></div><div class="col-md-9"><input type="text" class="form-control" ng-model="allegato.lunghezza" placeholder="mm:ss"></div><br><br><div class="text-right col-md-12"><br><button type="button" class="btn btn-primary btn-xs" ng-click="updateAttach(allegato)">Salva</button></div></div></div><div class="col-md-4 block"><div class="border border-dark block"><div class="row"><div class="col-md-6"><i class="glyphicon glyphicon-info-sign" tooltips="" tooltip-template="Selezionando aggiorna retroattivamente la modifica della traccia e della cover avr\xE0 effetto anche sulle tracce gi\xE0 acquistate dai clienti." tooltip-size="small"></i> <label>Aggiorna retroattivamente</label></div><div class="col-md-6"><input type="checkbox" name="retro" ng-model="retroshare.checked" ng-true-value="1" ng-false-value="0"></div></div><br><div class="row"><div class="col-md-4"><label>File:</label></div><div class="col-md-4"><button type="button" class="btn btn-default btn-xs" ngf-select="uploadFile($file, allegato.id, allegato)">Seleziona <i class="ion-ios-upload"></i></button></div><div class="col-md-4"><a ng-show="allegato.awsurl" href="{{allegato.awsurl}}">Download</a></div></div><div class="row" ng-show="f[allegato.id].progress>0 && f[allegato.id].progress < 100"><div class="col-md-12"><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="{{f[allegato.id].progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{f[allegato.id].progress}}%"><span>{{f[allegato.id].progress}}%</span></div></div></div></div><br><div class="row"><div class="col-md-4"><label>Cover:</label></div><div class="col-md-4"><button type="button" class="btn btn-default btn-xs" ngf-select="uploadCover($file,allegato.id, allegato)">Seleziona <i class="ion-ios-upload"></i></button><div class="progress" ng-show="f[allegato.id].progressCover>0 && f[allegato.id].progressCover < 100"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="{{f[allegato.id].progressCover}}" aria-valuemin="0" aria-valuemax="100" style="width: {{f[allegato.id].progressCover}}%"><span>{{f[allegato.id].progressCover}}%</span></div></div></div><div class="col-md-4"><a ng-show="allegato.coverimg" href="{{allegato.coverimg}}">Download</a></div></div></div></div><div class="col-md-4 block"><div class="border border-dark block row"><div class="col-md-6"><label>Condivisibile</label></div><div class="col-md-4"><input type="checkbox" ng-model="allegato.sharable" ng-true-value="1" ng-false-value="0" ng-change="updateAttach(allegato)"></div><br><br><button type="button" ng-if="!allegato.sharable && !loadUnshare" class="col-md-6 btn btn-danger btn-sm" ng-click="unshareAttach(allegato)">Unshare</button><div class="col-md-2"><i style="margin-top:8px" ng-if="!allegato.sharable && !loadUnshare" class="glyphicon glyphicon-info-sign" tooltips="" tooltip-template="Cliccando su UNSHARE rimuovi il flag sharable anche dalle tracce gi\xE0 acquistate dai clienti." tooltip-size="small"></i></div><div ng-if="!allegato.sharable && loadUnshare" style="position:relative;top:-5px;left:20px;display:inline-block;"><span class="spinner"></span></div><br><br><br><button type="button" ng-if="allegato.sharable && !loadRetroshare" class="col-md-6 btn btn-primary btn-sm" ng-click="retroshareAttach(allegato)">Retroshare</button><div class="col-md-2"><i style="margin-top:8px" ng-if="allegato.sharable && !loadRetroshare" class="glyphicon glyphicon-info-sign" tooltips="" tooltip-template="Cliccando su RETROSHARE setti il flag sharable e rendi convidisibili anche le tracce gi\xE0 acquistate dai clienti" tooltip-size="small"></i><div ng-if="loadRetroshare"><span class="spinner"></span></div></div></div></div></div></div><div ng-if="!hasUploadFileTabs" ng-include="" src="\'app/pages/prodotti/upload-file-dpack-all.html\'"></div><uib-tabset ng-if="hasUploadFileTabs" active="0"><uib-tab heading="Da caricare" index="0"><div ng-include="" src="\'app/pages/prodotti/upload-file-dpack-future.html\'"></div></uib-tab><uib-tab heading="Caricati" index="1"><div ng-include="" src="\'app/pages/prodotti/upload-file-dpack-past.html\'"></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/prodotti/upload-image.html','<p>Per una miglior resa caricare un\'immagine quadrata</p><form id="imageform" name="imageform"><img height="100" ng-show="!immagine.file && prodotto.img" ng-src="{{baseurl}}{{prodotto.img}}" alt="image"> <img height="100" ngf-thumbnail="immagine.file"><div ng-required="true" class="button" ngf-select="" ng-model="immagine.file" name="image" ngf-pattern="\'image/*\'" ngf-accept="\'image/*\'" ngf-max-size="20MB" ngf-min-height="100">Seleziona un\'immagine <i style="font-size: 200%; cursor: pointer" class="ion-ios-upload"></i></div><br><br></form><form><div class="form-group"><label for="abstract">Note</label> <textarea ng-model="prodotto.mediainfo" type="text" class="form-control" id="note" placeholder="Note">\n\t</textarea></div><button class="btn btn-default" ng-click="uploadImmagine()">Salva</button></form>');
$templateCache.put('app/pages/spedizioni/spedizioni.html','spedizioni.html');
$templateCache.put('app/pages/utenti/bonus.html','<div class="row"><p>Segni vitali e bonus mese {{ curDate.month }}/{{ curDate.year }} - <strong>{{ bonus[0].name }}</strong></p><div class="form-group" style="max-width: 200px;"><div class="input-group" style="margin-top: 12px;"><input type="text" class="form-control" uib-datepicker-popup="MMMM-yyyy" ng-model="datePicker" is-open="open" ng-required="true" close-text="Chiudi" show-button-bar="false" datepicker-options="options"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table cards-table bonus-table" ng-hide="loading"><thead><th colspan="2"><span ng-show="bonus[0].id==loggedUser.id">Personale</span> <span ng-show="bonus[0].id!=loggedUser.id">Personale di {{ bonus[0].name }}</span></th><th colspan="2">Gruppo</th><th><span ng-show="bonus[0].id==loggedUser.id">Bonus</span> <span ng-show="bonus[0].id!=loggedUser.id">I bonus di {{ bonus[0].name }}</span></th><th>Obiettivo</th><th>Differenza</th></thead><tbody><tr><td class="amway-bonus-label">Punti</td><td>{{ bonus[0].cdpts }}</td><td id="greysection" class="amway-bonus-label">Punti</td><td id="greysection">{{ bonus[0].groupcdpts }}</td><td>{{ bonus[0].cdbonus / 100 | currency:\'&euro; \' }}</td><td>{{bonus[0].thresholdcd}}</td><td>{{bonus[0].deltacd}}</td></tr><tr><td class="amway-bonus-label">BBS</td><td>{{ bonus[0].bbspts }}</td><td id="greysection" class="amway-bonus-label">BBS</td><td id="greysection">{{ bonus[0].groupbbspts }}</td><td>{{ bonus[0].bbsbonus / 100 | currency:\'&euro; \' }}</td><td>{{bonus[0].thresholdbbs}}</td><td>{{bonus[0].deltabbs}}</td></tr><tr><td class="amway-bonus-label">WES</td><td>{{ bonus[0].wespts }}</td><td id="greysection" class="amway-bonus-label">WES</td><td id="greysection">{{ bonus[0].groupwespts }}</td><td>{{ bonus[0].wesbonus / 100 | currency:\'&euro; \' }}</td><td>{{bonus[0].thresholdwes}}</td><td>{{bonus[0].deltawes}}</td></tr><tr><td colspan="4"></td><td><strong>{{ rebateDue(bonus[0]) / 100 | currency:\'&euro; \' }}</strong></td><td colspan="2"></td></tr></tbody></table><table class="table cards-table bonus-table bonus-list"><thead><tr><th rowspan="2">Level</th><th rowspan="2">Nome</th><th colspan="5" id="column-title">Personale</th><th colspan="5" id="column-title">Gruppo</th><th class="last" colspan="2" id="column-title">Bonus</th></tr><tr><th>SP</th><th>CEP</th><th>Punti</th><th>BBS</th><th>WES</th><th>SP</th><th>CEP</th><th>Punti</th><th>BBS</th><th>WES</th><th></th></tr></thead><tbody><tr ng-repeat="b in bonus.slice(1)" ng-click="goToBonus(b, curDate.month, curDate.year)" class="bonus-link" style="cursor: pointer;"><td>{{ b.level - bonus[0].level +1}}</td><td>{{ b.name }}</td><td id="whitesection">{{ b.sppts }}</td><td id="whitesection">{{ b.ceppts }}</td><td id="whitesection">{{ b.cdpts }}</td><td id="whitesection">{{ b.bbspts }}</td><td id="whitesection">{{ b.wespts }}</td><td id="greysection">{{ b.groupsppts }}</td><td id="greysection">{{ b.groupceppts }}</td><td id="greysection">{{ b.groupcdpts }}</td><td id="greysection">{{ b.groupbbspts }}</td><td id="greysection">{{ b.groupwespts }}</td><td id="whitesection">{{ rebateDue(b) / 100 | currency:\'&euro; \' }}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/utenti/closeVarDialog.html','<div class="modal-content"><form name="lang" ng-submit="salva()"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Chiudi partita iva</h4></div><div class="modal-body"><div class="input-group"><label>Data</label> <input date2str="" model-view-value="true" ui-mask="99/99/9999" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="date" is-open="contopen" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button style="margin-top:20px" type="button" class="btn btn-default" ng-click="contopen=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="modal-footer"><a ng-click="cancel()" class="btn btn-default">Annulla</a> <button type="submit" class="btn btn-primary">Conferma</button></div></form></div>');
$templateCache.put('app/pages/utenti/credit-dialog.html','<div class="modal-content"><form name="lang" ng-submit="salva()"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Regala crediti</h4></div><div class="modal-body"><table class="table"><thead><tr><th style="text-align : center">Descrizione</th><th style="text-align : center">Delta</th><th style="text-align : center">Scadenza</th></tr></thead><tbody><tr><td><div class="form-group"><input required="" ng-model="gift.descr" type="text" class="form-control" id="fname"></div></td><td><div class="form-group"><input required="" ng-model="gift.delta" type="text" class="form-control" id="lname"></div></td><td><div class="form-group"><p class="input-group"><input type="text" class="form-control" date2str="" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="gift.expiry" is-open="validFromAperto" ng-required="true" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="validFromAperto = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></td></tr></tbody></table></div><div class="modal-footer"><a ng-click="cancel()" class="btn btn-default">Annulla</a> <button type="submit" class="btn btn-primary">Conferma</button></div></form></div>');
$templateCache.put('app/pages/utenti/edit-fornitore.html','<div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel fornitori-view"><form name="formFornitore" ng-submit="salva()"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dati Aziendali"><div class="row"><div class="col-sm-2"><div class="checkbox"><label><input type="checkbox" class="checkboxFix" ng-model="fornitore.personafisica" ng-true-value="1" ng-false-value="0"> &nbsp;&nbsp;Persona fisica</label></div></div><div class="col-sm-2"><div class="checkbox"><label><input type="checkbox" class="checkboxFix" ng-model="fornitore.percipiente" ng-true-value="1" ng-false-value="0"> &nbsp;&nbsp;Percipiente</label></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label>Ragione Sociale</label> <input class="form-control" type="text" ng-model="fornitore.nome"></div></div><div class="col-sm-3"><div class="form-group"><label>Codice Fiscale</label> <input class="form-control" style="width:85%;display:inline-block;" type="text" id="cf" ng-model="fornitore.cf" ng-blur="checkCFValidity();"> <span class="text-success" style="position:relative; top:5px; left:3px;" ng-if="invalidCF === false"><i class="fa fa-check-circle fa-2x" style="line-height:0;" aria-hidden="true"></i></span> <span class="text-danger" style="position:relative; top:5px; left:3px;" ng-if="invalidCF === true"><i class="fa fa-times-circle fa-2x" style="line-height:0;" aria-hidden="true"></i></span></div></div><div class="col-sm-3"><div class="form-group"><label>Partita IVA</label> <input class="form-control" type="text" ng-model="fornitore.partitaiva"></div></div></div><div class="row"><div class="col-sm-3"><div class="form-group"><label>Indirizzo</label> <input class="form-control" type="text" ng-model="fornitore.indirizzo"></div></div><div class="col-sm-3"><div class="form-group"><label>Nazione</label><ui-select ng-model="dati.selectedNazione" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nazione"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="c in countries | filter: $select.search"><span ng-bind-html="c.name"></span></ui-select-choices></ui-select></div></div><div class="col-sm-2"><div class="form-group"><label for="province">Provincia</label><ui-select ng-model="dati.selectedProvince" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-disabled="dati.selectedNazione.name != \'Italia\'"><ui-select-match placeholder="Provincia"><span>{{$select.selected.descrizione}}</span></ui-select-match><ui-select-choices repeat="p in province | filter: $select.search"><span ng-bind-html="p.descrizione"></span></ui-select-choices></ui-select></div></div><div class="col-sm-3"><div class="form-group" ng-if="dati.selectedNazione.name == \'Italia\'"><label for="city">Comune</label><ui-select ng-model="dati.selectedCity" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-disabled="!comuni.length"><ui-select-match placeholder="Comune"><span>{{$select.selected.descrizione}}</span></ui-select-match><ui-select-choices repeat="c in comuni | filter: $select.search"><span ng-bind-html="c.descrizione"></span></ui-select-choices></ui-select></div><div class="form-group" ng-if="dati.selectedNazione.name != \'Italia\'"><label>Localit\xE0</label> <input class="form-control" type="text" ng-model="fornitore.localita"></div></div><div class="col-sm-1"><div class="form-group"><label for="city">CAP</label> <input class="form-control" type="text" ng-model="fornitore.cap"></div></div></div><div class="row" ng-show="fornitore.percipiente"><div class="col-sm-3"><div class="form-group"><label>Indirizzo residenza fiscale</label> <input ng-required="fornitore.percipiente" class="form-control" type="text" ng-model="fornitore.resfisadd"></div></div><div class="col-sm-2"><div class="form-group"><label for="province">Provincia residenza fiscale</label><ui-select ng-model="dati.selectedProvinceResfis" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-disabled="dati.selectedNazione.name != \'Italia\'"><ui-select-match placeholder="Provincia"><span>{{$select.selected.descrizione}}</span></ui-select-match><ui-select-choices repeat="p in province | filter: $select.search"><span ng-bind-html="p.descrizione"></span></ui-select-choices></ui-select></div></div><div class="col-sm-3"><div class="form-group" ng-disabled="dati.selectedNazione.name != \'Italia\'"><label for="city">Comune residenza fiscale</label><ui-select ng-model="dati.selectedCityResfis" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-disabled="!comuniResfis.length"><ui-select-match placeholder="Comune"><span>{{$select.selected.descrizione}}</span></ui-select-match><ui-select-choices repeat="c in comuniResfis | filter: $select.search"><span ng-bind-html="c.descrizione"></span></ui-select-choices></ui-select></div></div><div class="col-sm-1"><div class="form-group"><label for="city">CAP</label> <input class="form-control" type="text" ng-model="fornitore.resfiscap"></div></div><div class="col-sm-3"><label for="codicetributo">Codice Tributo</label><select ng-required="fornitore.percipiente" name="codicetributo" class="form-control" ng-model="fornitore.codicetributo"><option value="">-- Seleziona --</option><option value="1038">1038</option><option value="1040">1040</option></select></div></div><div class="row"><div class="col-sm-3"><div class="form-group"><label>Tel</label> <input class="form-control" type="text" ng-model="fornitore.tel"></div></div><div class="col-sm-3"><div class="form-group"><label>Fax</label> <input class="form-control" type="text" ng-model="fornitore.fax"></div></div><div class="col-sm-3"><div class="form-group"><label>Email</label> <input class="form-control" type="text" ng-model="fornitore.email"></div></div><div class="col-sm-3"><div class="form-group"><label for="tdsdi">TD SDI</label><select name="tdsdi" class="form-control" ng-model="fornitore.tdsdi"><option value="">-- Seleziona --</option><option value="TD17">TD17</option><option value="TD18">TD18</option><option value="TD19">TD19</option></select></div></div></div><div class="row"><div class="col-sm-12"><div class="form-group"><label for="comment">Note</label> <textarea class="form-control" rows="3" id="note" ng-model="fornitore.note"></textarea></div></div></div></uib-tab><uib-tab heading="Dati Legale Rappresentate"><div class="row"><div class="col-sm-2"><div class="form-group"><label>Titolo</label> <input class="form-control" type="text" ng-model="fornitore.titolo"></div></div><div class="col-sm-4"><div class="form-group"><label>Nome</label> <input class="form-control" type="text" ng-model="fornitore.fname"></div></div><div class="col-sm-4"><div class="form-group"><label>Cognome</label> <input class="form-control" type="text" ng-model="fornitore.lname"></div></div><div class="col-sm-2"><div class="form-group"><label>Sesso</label><select name="gender" id="inputGender" class="form-control" ng-model="fornitore.gender"><option value="">-- Seleziona --</option><option value="M">Maschio</option><option value="F">Femmina</option></select></div></div></div><div class="row"><div class="col-sm-3"><div class="form-group"><label>Data di nascita</label><div class="input-group"><input type="text" date2str="" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="fornitore.datanascita" is-open="popUpDate1" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate1 = !popUpDate1"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-sm-4"><div class="form-group"><label for="province">Provincia di nascita</label><ui-select ng-model="dati.selectedProvinceNascita" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Provincia di nascita"><span>{{$select.selected.descrizione}}</span></ui-select-match><ui-select-choices repeat="p in province | filter: $select.search"><span ng-bind-html="p.descrizione"></span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group"><label>Luogo di nascita</label> <input class="form-control" type="text" ng-model="fornitore.luogonascita"></div></div></div></uib-tab><uib-tab heading="Dati Contabili"><div class="row"><div class="col-sm-2"><div class="form-group"><label>Codice</label> <input ng-disabled="true" class="form-control" type="text" ng-model="fornitore.codice" style="background-color:#e2e2e2;"></div></div><div class="col-sm-3"><div class="form-group"><label>Tipo</label><ui-select ng-model="dati.selectedTipo" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Tipo fornitore..."><span>{{$select.selected.descrizione}}</span></ui-select-match><ui-select-choices repeat="f in tipiAnagrafica | filter: $select.search"><span ng-bind-html="f.descrizione"></span></ui-select-choices></ui-select></div></div><div class="col-sm-2"><div class="form-group"><label>Tipo Str.</label> <input class="form-control" type="text" ng-model="fornitore.tipostr"></div></div><div class="col-sm-2"><div class="form-group"><label>Codice IVA</label><ui-select ng-model="dati.selectedCodIva" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Codice IVA..."><span>{{$select.selected.descrizione}}</span></ui-select-match><ui-select-choices repeat="c in codiciIva | filter: $select.search"><span ng-bind-html="c.descrizione"></span></ui-select-choices></ui-select></div></div><div class="col-sm-2"><div class="form-group"><label>Codice SET</label> <input class="form-control" type="text" ng-model="fornitore.codiceset"></div></div></div><div class="row"><div class="col-sm-3"><div class="form-group"><label>Codice Pagamento</label><ui-select ng-model="dati.selectedCodicePagamento" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Codice Pagamento..."><span>{{$select.selected.descrizione}}</span></ui-select-match><ui-select-choices repeat="p in codiciPag | filter: $select.search"><span ng-bind-html="p.descrizione"></span></ui-select-choices></ui-select></div></div><div class="col-sm-3"><div class="form-group"><label>Codice Banca</label> <input class="form-control" type="text" ng-model="fornitore.codicebanca"></div></div><div class="col-sm-3"><div class="form-group"><label>Conto Costo</label><ui-select ng-model="dati.selectedContoCosto" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca conto di costo...">{{ $select.selected.descrizione }}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchAccounts($select.search)" refresh-delay="0" repeat="a in accounts | filter: $select.search"><span ng-bind-html="a.descrizione"></span></ui-select-choices></ui-select></div></div><div class="col-sm-3"><div class="form-group"><label>Conto Coll</label><ui-select ng-model="dati.selectedContoColl" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca conto coll...">{{ $select.selected.descrizione }}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchAccounts($select.search)" refresh-delay="0" repeat="a in accounts | filter: $select.search"><span ng-bind-html="a.descrizione"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-sm-3"><div class="form-group"><label>Valuta</label><select name="valuta" id="inputGender" class="form-control" ng-model="fornitore.codvaluta"><option value="">-- Seleziona --</option><option value="0">EURO</option><option value="1">USD Dollar</option></select></div></div><div class="col-sm-6" style="margin-top:25px"><div class="form-group"><input type="checkbox" ng-model="fornitore.nofattelett" ng-true-value="1" ng-false-value="0"> <label>Non soggetto a fatt. elettronica</label></div></div></div></uib-tab></uib-tabset><div align="center"><button ng-disabled="" class="btn btn-primary" type="submit">Salva FORNITORE</button><br><br></div></form></div>');
$templateCache.put('app/pages/utenti/form-utente.html','<div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="activeTab"><uib-tab heading="Dati Generali" index="0"><form name="formutente" ng-submit="salva()"><div class="row"><div class="col-sm-4"><div class="form-group"><label for="fname">Nome</label> <input required="" ng-model="utente.fname" type="text" class="form-control" id="fname" placeholder="Nome"></div></div><div class="col-sm-4"><div class="form-group"><label for="lname">Cognome</label> <input required="" ng-model="utente.lname" type="text" class="form-control" id="lname" placeholder="Cognome"></div></div><div class="col-sm-4"><div class="form-group"><label for="lname">Ragione Sociale</label> <input ng-model="utente.denominazione" type="text" class="form-control" id="lname" placeholder="Ragione Sociale"></div></div><div class="col-sm-4"><div class="form-group"><label for="ruolo">Ruolo</label><select ng-disabled="!enableAdmin();" ng-model="utente.ntsrole" class="form-control" title="Ruolo"><option value="amministratore">Amministatore</option><option value="incaricato">Incaricato</option><option value="magazziniere">Magazziniere</option><option value="contabilita">Contabilit\xE0</option><option value="web">Web</option><option value="cliente">Cliente</option><option value="sicurezza">Sicurezza</option><option value="wes">Wes</option></select></div></div><div class="col-sm-4"><div class="form-group"><label for="lname">Nazione</label><select required="" ng-model="utente.country" class="form-control" title="Nazione"><option ng-repeat="country in countries" ng-value="country.name">{{country.name}}</option></select></div></div><div class="col-sm-3"><div class="form-group"><label for="pass">Password</label> <input ng-required="!utente.id" ng-model="utente.passwordC" type="password" class="form-control" id="pass" placeholder="Password"></div></div><div class="col-sm-4"><div class="form-group"><label for="rpass">Ripeti Password</label> <input ng-required="!utente.id" ng-model="utente.ripetiPassword" type="password" class="form-control" id="rpass" placeholder="Ripeti Password"> <span ng-show="utente.passwordC!=utente.ripetiPassword" class="error">Le due password non coincidono</span></div></div><div ng-if="(utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\') && utente.country==\'Italia\'" class="col-sm-3"><div class="form-group"><label for="cf">Codice Fiscale</label> <input name="cf" ng-blur="checkCFValidity(formutente.cf.$dirty);" required="" cf="" ng-model="utente.cf" ng-required="utente.ntsrole==\'incaricato\'" type="text" class="form-control" id="cf" style="width:90%;display:inline-block;" placeholder="Codice Fiscale"> <span class="text-success" style="position:relative; top:5px; left:3px;" ng-if="invalidCF === false"><i class="fa fa-check-circle fa-2x" aria-hidden="true"></i></span> <span class="text-danger" style="position:relative; top:5px; left:3px;" ng-if="invalidCF === true"><i class="fa fa-times-circle fa-2x" aria-hidden="true"></i></span></div></div><div ng-if="utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\'" class="col-sm-3"><div class="form-group"><label for="vat">P.IVA</label> <input ng-model="utente.vat" ng-readonly="utente.vatcloseddate" type="text" class="form-control" id="vat" placeholder="P.IVA comprensiva del codice nazione"></div></div><div ng-if="utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\'" class="col-sm-2"><div class="form-group"><button type="button" style="margin-top:20px" class="btn btn-sm btn-danger" ng-click="closeVat($event)" ng-show="utente.vat && !utente.vatcloseddate">Chiudi</button> <label ng-show="utente.vatcloseddate" style="margin-top:30px">Cessata il {{utente.vatcloseddate*1000 | date : \'dd/MM/yyyy\'}}</label></div></div><div class="col-sm-12" ng-show="utente.vat"><div ng-if="utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\'" class="col-sm-6"><div class="form-group"><label for="pec">Pec</label> <input ng-required="utente.vat && !utente.codiceunico" ng-model="utente.pec" type="text" class="form-control" id="pec" placeholder="Pec"></div></div><div ng-if="utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\'" class="col-sm-6"><div class="form-group"><label for="codiceunico">Codice unico</label> <input ng-model="utente.codiceunico" ng-required="utente.vat && !utente.pec" type="text" class="form-control" id="codiceunico" placeholder="Codice unico"></div></div></div><div ng-if="utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\'" class="col-sm-8"><div class="form-group"><label for="address">Indirizzo</label> <input required="" ng-model="utente.address" type="text" class="form-control" id="address" placeholder="Indirizzo"></div></div><div ng-if="utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\'" class="col-sm-1"><div class="form-group"><label for="streetno">Num.</label> <input required="" ng-model="utente.streetno" type="text" class="form-control" id="streetno" placeholder="Num."></div></div><div ng-if="utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\'" class="col-sm-3"><div class="form-group"><label for="zipcode">Cap</label> <input required="" ng-model="utente.zipcode" type="text" class="form-control" id="zipcode" placeholder="Cap"></div></div><div ng-if="utente.ntsrole==\'incaricato\'" class="col-sm-12"><div class="form-group"><label for="iban">IBAN</label> <input name="iban" ng-model="utente.iban" type="text" class="form-control" id="iban" placeholder="IBAN" ng-iban=""> <small class="error" ng-show="formutente.iban.$dirty && !formutente.iban.$valid">IBAN non valido</small></div></div><div ng-if="utente.country==\'Italia\' && (utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\')" class="col-sm-6"><div class="form-group"><label for="province">Provincia</label><ui-select ng-model="utente.selectedProvince" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Provincia"><span>{{$select.selected.sigla}}</span></ui-select-match><ui-select-choices repeat="p in province | filter: $select.search"><span ng-bind-html="p.sigla"></span></ui-select-choices></ui-select></div></div><div ng-if="utente.country==\'Italia\' && (utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\')" class="col-sm-6"><div class="form-group"><label for="city">Comune</label><ui-select ng-model="utente.selectedCity" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-disabled="!comuni.length"><ui-select-match placeholder="Comune"><span>{{$select.selected.descrizione}}</span></ui-select-match><ui-select-choices repeat="c in comuni | filter: $select.search"><span ng-bind-html="c.descrizione"></span></ui-select-choices></ui-select></div></div><div ng-if="utente.country!=\'Italia\' && (utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\')" class="col-sm-6"><div class="form-group"><label for="city">Citt\xE0</label> <input required="" ng-model="utente.city" type="text" class="form-control" id="city" placeholder="Citt\xE0"></div></div><div class="col-sm-6"><div class="form-group"><label for="mobile">Cellulare</label> <input required="" ng-model="utente.mobile" type="text" class="form-control" id="mobile" placeholder="Cellulare"></div></div><div class="col-sm-6"><div class="form-group"><label for="email">Email</label> <input required="" ng-model="utente.email" type="email" class="form-control" id="email" placeholder="Email"></div></div></div><div class="row"><div ng-if="utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\'" class="col-sm-6"><div class="form-group"><label for="author">Data di nascita</label><div class="input-group" style="margin-top: 12px;"><input date2str="" model-view-value="true" ui-mask="99/99/9999" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="utente.bdate" is-open="open" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div ng-if="utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\'" class="col-sm-6"><div class="form-group"><label for="province">Paese di Nascita</label><ui-select ng-model="utente.selectedPaeseNascita" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Paese di Nascita"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="c in countries | filter: $select.search"><span ng-bind-html="c.name"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div ng-if="utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\'" class="col-sm-6"><div class="form-group"><label for="province">Provincia di Nascita</label><ui-select ng-model="utente.selectedProvinciaNascita" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-disabled="utente.selectedPaeseNascita.name != \'Italia\'"><ui-select-match placeholder="Provincia di Nascita"><span>{{$select.selected.descrizione}}</span></ui-select-match><ui-select-choices repeat="p in province | filter: $select.search"><span ng-bind-html="p.descrizione"></span></ui-select-choices></ui-select></div></div><div ng-if="utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\'" class="col-sm-6"><div class="form-group"><label for="city">Luogo di nascita</label> <input ng-model="utente.luogonascita" type="text" class="form-control" id="city" placeholder="Luogo di nascita"></div></div></div><div class="row"><div class="col-sm-6" ng-show="utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\'"><div class="form-group"><label for="parent">Sponsor</label><ui-select ng-model="utente.selectedParent" class="btn-group bootstrap-select form-control" ng-disabled="!enableAdmin();" append-to-body="true" search-enabled="true"><ui-select-match placeholder="{{utente.selectedParent.fname ? (utente.selectedParent.fname+\' \'+utente.selectedParent.lname) : \'Cerca sponsor...\'}}">{{utente.selectedParent.fname ? (utente.selectedParent.fname+\' \'+utente.selectedParent.lname) : \'Cerca sponsor...\'}}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchIncaricato($select.search)" refresh-delay="0" repeat="sp in incaricati"><span ng-bind-html="sp.fname"></span> <span ng-bind-html="sp.lname"></span></ui-select-choices></ui-select></div></div><div ng-if="utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\'" class="col-sm-6"><div class="form-group"><div class="form-group"><label for="level">Livello</label> <input ng-disabled="true" ng-model="utente.level" type="text" class="form-control" id="level" placeholder="Livello"></div></div></div><div class="col-sm-6"><div class="form-group"><div class="form-group"><label for="level">Codice NTS</label> <input ng-disabled="true" ng-model="utente.code" type="text" class="form-control" id="codicents" placeholder="Codice NTS"></div></div></div><div ng-if="utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\'" class="col-sm-6"><div class="form-group"><div class="form-group"><label for="level">Codice Amway Italia</label> <input required="" ng-model="utente.amwayref" type="text" class="form-control" id="codiceamway" placeholder="Codice Amway Italia"></div></div></div><div ng-if="utente.ntsrole==\'incaricato\' || utente.ntsrole==\'cliente\'" class="col-sm-4"><div class="form-group"><div class="form-group"><label for="amwaylevel">Livello Amway</label><select ng-model="utente.amwaylevel" class="form-control" title="Livello Amway"><option value="distribuzione selettiva">Distribuzione selettiva</option><option value="diamante">Diamante</option><option value="smeraldo">Smeraldo</option><option value="platino fondatori">Platino fondatori</option><option value="platino">Platino</option><option value="argento">Argento</option><option value="leaders">Leaders Club</option><option value="nq">Non qualificato</option></select></div></div></div><div class="col-sm-4"><div class="form-group"><div class="form-group"><label for="level">Nome Collaboratore Amway</label> <input ng-model="utente.partnerfname" type="text" class="form-control" id="partnerfname" placeholder="Nome Collaboratore Amway"></div></div></div><div class="col-sm-4"><div class="form-group"><div class="form-group"><label for="level">Cognome Collaboratore Amway</label> <input ng-model="utente.partnerlname" type="text" class="form-control" id="partnerlname" placeholder="Cognome Collaboratore Amway"></div></div></div></div><div class="row" style="margin-bottom: 20px"><div class="col-md-4"><div ng-if="utente.tcaccepted"><i class="glyphicon glyphicon-ok text-success"></i> <span>Termini e condizioni accettati il {{ utente.tcacceptedate*1000 | date:\'dd/MM/yyyy\' }}</span></div><div ng-if="!utente.tcaccepted"><i class="glyphicon glyphicon-remove text-danger"></i> <span>Termini e condizioni NON ancora accettati</span></div></div></div><button ng-disabled="utente.passwordC!=utente.ripetiPassword || (utente.ntsrole==\'incaricato\' && !formutente.iban.$valid) || invalidCF || (utente.ntsrole == \'cliente\' && !utente.selectedParent) || (utente.ntsrole == \'incaricato\' && !utente.selectedParent) || utente.cf.length==0 || (utente.codiceunico && utente.codiceunico.length !=7)" class="btn btn-primary" type="submit">Salva</button> <a ng-if=\'utente.status !== "ok"\' ng-show="utente.id" class="btn btn-default" ng-click="okUtente()">Ripristina stato</a> <a ng-if="enableAdmin() && utente.parent" ng-show="utente.id" class="btn btn-default" ng-click="promuoviUtente()">Promuovi</a> <a ng-if=\'enableAdmin() && utente.status === "ok"\' ng-show="utente.id" class="btn btn-warning" ng-click="sospendiUtente()">Sospendi</a> <a ng-if=\'utente.status === "ok"\' ng-show="utente.id" class="btn btn-danger" ng-click="eliminaUtente()">Elimina</a> <a ng-if=\'utente.status === "ok" && userLogged.fname=="Massimo" && userLogged.lname=="Bini"\' ng-show="utente.id" class="btn btn-danger" ng-click="bursUtente()">BURN</a> <a ng-show="utente.id" class="btn btn-info" ng-click="resendActivationLink()">Invia link</a> <a ng-show="utente.blacklist != 1" class="btn btn-dark" ng-click="addToBlacklist()">Aggiungi Blacklist</a> <a ng-show="utente.blacklist == 1" class="btn btn-success" ng-click="removeFromBlacklist()">Rimuovi Blacklist</a> <a ng-show="utente.status == \'deleted\'" ng-if="enableAdmin()" class="btn btn-success" ng-click="allowResignup()">Permetti Re-iscrizione</a> <a ng-show="utente.id" class="btn btn-info pull-right" href="/#!/ricercamovimenti?cliente={{utente.conto}}" target="_blank">Mastrino</a></form></uib-tab><uib-tab heading="Immagine profilo" index="1"><p>Per una miglior resa caricare un\'immagine quadrata</p><p><i>Dimensione minima immagine 100px X 100px</i></p><br><form id="imageform" name="imageform"><img height="100" ng-show="!immagine.file && utente.profilepic" ng-src="{{baseurl}}{{utente.profilepic}}" alt="image"> <img height="100" ngf-thumbnail="immagine.file"><div ng-required="true" class="button" ngf-select="" ng-model="immagine.file" name="image" ngf-pattern="\'image/*\'" ngf-accept="\'image/*\'" ngf-max-size="20MB" ngf-min-height="100">Seleziona un\'immagine <i style="font-size: 200%; cursor: pointer" class="ion-ios-upload"></i></div><button class="btn btn-default" ng-click="uploadImmagine()">Carica immagine</button></form></uib-tab><uib-tab disable="!utente.id" heading="Indirizzi" index="2" ng-show="utente.ntsrole!=\'sicurezza\'"><div class="row"><div ng-show="addressFormShow" class="col-md-10 col-md-offset-1 well"><form ng-submit="addAddress()"><div class="row"><div class="col-sm-12"><div class="form-group"><label for="fname">c/o</label> <input required="" ng-model="newAddress.shipto" type="text" class="form-control" id="shipto" placeholder="c/o"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="lname">Indirizzo</label> <input required="" ng-model="newAddress.address" type="text" class="form-control" id="address" placeholder="Indirizzo"></div></div><div class="col-sm-3"><div class="form-group"><label for="lname">N. Civico</label> <input required="" ng-model="newAddress.streetno" type="text" class="form-control" id="address" placeholder="N. Civico"></div></div><div class="col-sm-3"><div class="form-group"><label for="lname">Cap</label> <input required="" ng-model="newAddress.zipcode" type="text" class="form-control" id="address" placeholder="Cap"></div></div></div><div class="row"><div class="col-sm-4"><div class="form-group"><label for="fname">Localit\xE0</label> <input ng-model="newAddress.location" type="text" class="form-control" id="location" placeholder="Localit\xE0"></div></div><div class="col-sm-4"><div class="form-group"><label for="province">Provincia</label><ui-select ng-model="newAddress.selectedProvince" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Provincia"><span>{{$select.selected.descrizione}}</span></ui-select-match><ui-select-choices repeat="p in province | filter: $select.search"><span ng-bind-html="p.descrizione"></span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group"><label for="city">Comune</label><ui-select ng-model="newAddress.selectedCity" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-disabled="!comuni.length"><ui-select-match placeholder="Comune"><span>{{$select.selected.descrizione}}</span></ui-select-match><ui-select-choices repeat="c in comuni | filter: $select.search"><span ng-bind-html="c.descrizione"></span></ui-select-choices></ui-select></div></div></div><button class="btn btn-danger" type="button" ng-click="addressFormShow=false">Annulla</button> <button class="btn btn-primary push-right" type="submit">Salva</button></form></div><button ng-hide="addressFormShow" class="btn btn-primary col-md-offset-10" type="button" ng-click="addressFormShow = true">Aggiungi indirizzo</button><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedAddressList" st-safe-src="addressList"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th>Indirizzo</th><th st-sort="city">Comune</th><th st-sort="province">Provincia</th><th st-sort="location">Localit\xE0</th><th st-sort="cap">CAP</th><th st-sort="cap">c/o</th><th st-sort="note">Note</th><th>Azioni</th></tr></thead><tbody><tr ng-repeat="item in displayedAddressList"><td><b>{{item.id}}</b></td><td><span ng-if="editingAddress.id != item.id">{{ item.address }}, {{ item.streetno }}</span><p ng-if="editingAddress.id == item.id"><input type="text" ng-model="editingAddress.address" style="width : 110px"> <input type="text" ng-model="editingAddress.streetno" style="width : 30px"></p></td><td><span ng-if="editingAddress.id != item.id">{{ item.city}}</span> <span ng-if="editingAddress.id == item.id"><input type="text" ng-model="editingAddress.city"></span></td><td><span ng-if="editingAddress.id != item.id">{{ item.province}}</span> <span ng-if="editingAddress.id == item.id"><input type="text" ng-model="editingAddress.province"></span></td><td><span ng-if="editingAddress.id != item.id">{{ item.location}}</span> <span ng-if="editingAddress.id == item.id"><input type="text" ng-model="editingAddress.location"></span></td><td><span ng-if="editingAddress.id != item.id">{{ item.zipcode}}</span> <span ng-if="editingAddress.id == item.id"><input type="text" ng-model="editingAddress.zipcode"></span></td><td><span ng-if="editingAddress.id != item.id">{{ item.shipto}}</span> <span ng-if="editingAddress.id == item.id"><input type="text" ng-model="editingAddress.shipto"></span></td><td><button ng-if="item.note" ng-click="leggiNote(item, $index)" type="button" class="btn btn-warning btn-xs">Leggi note</button></td><td><span ng-if="editingAddress.id != item.id"><a class="btn btn-warning btn-xs" ng-click="modificaIndirizzo(item)">Modifica</a> <a class="btn btn-danger btn-xs" ng-click="eliminaIndirizzo(item)">Elimina</a></span> <span ng-if="editingAddress.id == item.id"><a class="btn btn-info btn-xs" ng-click="salvaIndirizzo()">Salva</a></span></td></tr></tbody></table></div></uib-tab><uib-tab disable="!utente.id" heading="Ordini" index="3" ng-show="utente.ntsrole!=\'sicurezza\'"><div class="row"><div class="col-md-9 text-left"><amway-pagination-server-side page-size="orderTablePageSize" elements="orders"></amway-pagination-server-side></div><div class="col-md-3 text-right"><select style="margin:20px 0;" class="form-control" ng-model="filters.orderStatusFilter" ng-change="onChangeOrderStatusFilter(filters.orderStatusFilter)"><option value=""></option><option value="cart">Carrello</option><option value="payment_ok">Pagamento completato</option><option value="payment_failed">Pagamento fallito</option><option value="shipped">Spedito</option><option value="delivered">Consegnato</option><option value="canceled">Cancellato</option><option value="refunded">Rimborsato</option></select></div></div><table ng-if="!loading" class="table" st-table="orders" st-pipe="getOrders"><thead><tr class="sortable"><th class="table-id" st-sort="id">#</th><th>Data ordine</th><th>Totale</th><th>Note</th><th>Stato</th><th></th></tr></thead><tbody><tr ng-repeat="order in orders"><td class="table-id"><a href="#!/ordine/{{ order.id }}/utente">{{ order.id }}</a></td><td>{{ 1000 * order.purchasedate | date }}</td><td>{{ order.total / 100 | currency:\'EUR\' }}</td><td>{{ order.note }}</td><td>{{ order.status }}</td><td><a ng-show="isShipment" ng-href="https://www.gls-italy.com/?option=com_gls&view=track_e_trace&mode=search&numero_spedizione={{ordine.numsped}}&tipo_codice=nazionale" class="btn btn-primary" target="_blank">Tracking</a></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="orderTablePageSize" st-displayed-pages="10" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></uib-tab><uib-tab disable="!utente.id" heading="Invia Omaggio" index="4" ng-show="utente.ntsrole!=\'sicurezza\'"><div class="row"><div class="col-sm-10"><ui-select ng-model="selectedomaggio.product" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca prodotto...">{{ $select.selected.name }} ({{ $select.selected.type }})</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchProductPool($select.search)" refresh-delay="0" repeat="sp in productspool | filter: $select.search"><span ng-bind-html="sp.name"></span> (<span ng-bind-html="sp.type"></span>)</ui-select-choices></ui-select></div><div class="col-sm-2"><button class="btn btn-default" ng-click="inviaomaggio(selectedomaggio.product)">Invia</button></div></div></uib-tab><uib-tab disable="!utente.id" heading="Dati Contabili" index="5" ng-show="utente.ntsrole!=\'sicurezza\'"><form name="formutentecontabili" ng-submit="salva()"><div class="row"><div class="col-sm-3"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-true-value="1" ng-false-value="0" id="personafisica" ng-model="utente.personafisica"> <span>Persona Fisica</span></label></div></div><div class="col-sm-3"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-true-value="1" ng-false-value="0" id="valuta" ng-model="utente.valuta"> <span>Valuta</span></label></div></div><div class="col-sm-3"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-true-value="1" ng-false-value="0" id="personafisica" ng-model="utente.scorporoiva"> <span>Scorporo Iva</span></label></div></div><div class="col-sm-3"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-true-value="1" ng-false-value="0" id="privateuser" ng-model="utente.privateuser" ng-click="showPrivatoDialog($event)"> <span>Emetti FE come utente privato</span></label></div><small style="font-size:10px">FLAG cliente privato = Emette PDF senza partita IVA // Emette XML B2C senza partita IVA (conservando se presente PEC o Codice Destinatario) {{(utente.privateuserdate)?(\' - Data attivazione: \'+(utente.privateuserdate*1000 | date : \'dd/MM/yyyy\')):(\'\')}}</small></div></div><div class="row"><div class="col-sm-4"><div class="form-group"><label for="ruolo">Tipo</label><select ng-model="utente.tipoanag" class="form-control" title="Tipo"><option ng-repeat="tipo in tipianagrafica" ng-value="tipo.codice">{{tipo.codice}} - {{tipo.descrizione}}</option></select></div></div><div class="col-sm-4"><div class="form-group"><label for="fname">ISO NAZIONE</label> <input ng-disabled="true" ng-model="utente.isocode" type="text" class="form-control" id="fname" placeholder="ISO NAZIONE"></div></div><div class="col-sm-4"><div class="form-group"><label for="ruolo">Codice IVA</label><select ng-model="utente.codiceiva" class="form-control" title="Codice IVA"><option ng-repeat="tipo in codiciiva" ng-value="tipo.codice">{{tipo.codice}} - {{tipo.descrizione}}</option></select></div></div><div class="col-sm-4"><div class="form-group"><label for="fname">Ultima Auto Fattura</label> <input ng-disabled="true" ng-model="utente.ultimafattura" type="text" class="form-control" id="fname" placeholder="N.D."></div></div><div class="col-sm-4"><div class="form-group"><label for="ruolo">Tipo Pagamento</label><select ng-model="utente.codpag" class="form-control" title="Tipo Pagamento"><option ng-repeat="tipo in tipipagamento" ng-value="tipo.codice">{{tipo.codice}} - {{tipo.descrizione}}</option></select></div></div><div class="col-sm-4"><div class="form-group"><label for="fname">Conto</label> <input ng-disabled="true" ng-model="utente.conto" type="text" class="form-control" id="fname" placeholder="Conto"></div></div><div class="col-sm-4"><div class="form-group"><label for="ruolo">Conto Collegato</label><select ng-model="utente.contocoll" class="form-control" title="Conto Collegato"><option ng-repeat="tipo in conti" ng-value="tipo.codice">{{tipo.codice}} - {{tipo.descrizione}}</option></select></div></div><div class="col-sm-4"><div class="form-group"><label for="ruolo">Conto Contropartita</label><select ng-model="utente.contocontropartita" class="form-control" title="Conto Contropartita"><option ng-repeat="tipo in conti" ng-value="tipo.codice">{{tipo.codice}} - {{tipo.descrizione}}</option></select></div></div><div class="col-sm-4"><div class="form-group"><label for="aliquota">Aliquota</label><select float2int="" class="form-control" ng-model="utente.aliquota" title="Aliquota"><option value="33.72" ng-selected="utente.aliquota == 3372">33,72%</option><option value="24.00" ng-selected="utente.aliquota == 2400">24,00 %</option></select></div></div></div><div class="row"><div class="col-sm-4"><div class="form-group"><label for="ruolo">Documento Emesso</label><select ng-model="utente.documentoemesso" class="form-control" title="Documento Emesso"><option>Nessuno</option><option value="P">P</option><option value="F">F</option></select></div></div></div><button class="btn btn-primary" type="submit">Salva</button></form></uib-tab><uib-tab disable="!utente.id" heading="Carte" index="6" ng-show="utente.ntsrole!=\'sicurezza\'"><div ng-controller="CardCtrl"><button ng-hide="addNewcard" class="btn btn-primary col-md-offset-10" type="button" ng-click="addNewcard = true">Aggiungi carta</button><div class="row" ng-if="addNewcard"><div class="stripe" stripe-form="card" stripe-user="utente.id" stripe-instance="stripe" stripe-token-callback="processToken(token)"></div></div><div class="row"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedCreditCardsList" st-safe-src="creditCards"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="brand">Marca</th><th st-sort="exp">Scadenza</th><th st-sort="num">Numero</th><th></th><th>Azioni</th></tr></thead><tbody><tr ng-repeat="item in displayedCreditCardsList"><td><b>#</b></td><td>{{ item.brand }}</td><td>{{ item.expmonth + "/" + item.expyear}}</td><td>{{ "****" + item.lastdigit }}</td><td><span ng-if="item.preferred === 1">Default</span></td><td><a class="btn btn-danger btn-xs" ng-click="deleteCard(item)">Elimina</a> <a ng-if="item.preferred !== 1" class="btn btn-default btn-xs" ng-click="makeDefault(item)">Rendi default</a></td></tr></tbody></table></div></div></uib-tab><uib-tab disable="!utente.id" heading="Dispositivi" index="7"><div class="row"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedDevicesList" st-safe-src="devices"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="device">Dispositivo</th><th st-sort="imei">Imei</th><th st-sort="vos">Vos</th><th st-sort="loginctr">Numero login</th><th st-sort="vos">Last login</th><th></th></tr></thead><tbody><tr ng-repeat="item in displayedDevicesList"><td><b>{{item.id}}</b></td><td>{{ item.device }}</td><td>{{ item.imei}}</td><td>{{ item.vos }}</td><td>{{ item.loginctr }}</td><td>{{ item.lastlogindate * 1000 | date : "dd/MM/yyyy" }}</td><td></td></tr></tbody></table></div></uib-tab><uib-tab disable="!utente.id" ng-if="utente.conto" index="8" heading="Fatture" ng-show="utente.ntsrole!=\'sicurezza\'"><div class="row"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><amway-pagination-server-side page-size="invoicesTablePageSize" elements="invoices"></amway-pagination-server-side><table class="table" ng-if="!loading" st-table="invoices" st-pipe="getInvoicedPag"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="cliente">Cliente</th><th st-sort="numdoc">Ordid</th><th st-sort="codicedocumento">Tipo</th><th st-sort="numdoc">Numero Documento</th><th st-sort="datadoc">Data</th><th st-sort="statosdi">Stato sdi</th><th st-sort="statosdi">Esito sdi</th><th st-sort="statosdi">Tx data sdi</th><th st-sort="totalemerce">Imponibile</th><th st-sort="totiva">Imposta</th><th st-sort="totdocumento">Totale</th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in invoices"><td><b>{{item.id}}</b></td><td>{{ item.cliente}}</td><td><a href="#!/ordine/{{item.ordid}}">{{ item.ordid }}</a></td><td>{{ item.codicedocumento.startsWith(\'NOT\') ? \'Nota di Credito\' : \'Fattura\' }}</td><td>{{ item.numdoc }}</td><td>{{ item.datadoc*1000 | date:\'dd/MM/yyyy\' }}</td><td><span style="color : {{(item.statosdi == \'fail\')?(\'red\'):(\'\')}}">{{ item.statosdi }}</span></td><td><span style="color : {{getEsitoColor(item.esitosdi)}}">{{ item.esitosdi }}</span></td><td>{{ (item.txdatesdi)?(item.txdatesdi*1000 | date : "dd/MM/yyyy"):(\'N/A\') }}</td><td>{{ item.totalemerce/100 | currency }}</td><td>{{ item.totiva/100 | currency }}</td><td>{{ item.totdocumento/100 | currency }}</td><td><a ng-href="#!/fatture/dettaglio/{{item.ntsid}}"><i class="glyphicon glyphicon-zoom-in" tooltips="" tooltip-template="Dettagli" tooltip-size="small"></i></a></td><td><a ng-if="item.idmovcont" href="#!/edit-movimento/{{item.ntsid}}"><i class="glyphicon glyphicon-list" tooltips="" tooltip-template="Movimenti contabili" tooltip-size="small"></i></a></td><td><a ng-href="{{apiurl}}fattura/download/{{item.id}}" target="_blank"><i class="glyphicon glyphicon-download-alt" tooltips="" tooltip-template="Download fattura" tooltip-size="small"></i></a></td><td><a ng-href="{{apiurl}}fattura/regen/{{item.id}}" target="_blank"><i class="ion-refresh" tooltips="" tooltip-template="Rigenera fattura" tooltip-size="small"></i></a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="invoicesTablePageSize" st-displayed-pages="10" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div></uib-tab><uib-tab disable="!utente.id && !utente.conto" index="9" ng-if="utente.ntsrole == \'incaricato\' && utente.conto" heading="Autofatture"><div class="row"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedSelfInvoicessList" st-safe-src="selfInvoices"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="datadoc">Data</th><th st-sort="cliente">Cliente</th><th st-sort="anno">Anno</th><th st-sort="numdoc">Numero Documento</th><th st-sort="totalemerce">Imponibile</th><th st-sort="totiva">Imposta</th><th st-sort="totdocumento">Totale</th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in displayedSelfInvoicessList"><td><b>{{item.id}}</b></td><td>{{ item.datadoc*1000 | date:\'dd/MM/yyyy\' }}</td><td>{{ item.cliente}}</td><td>{{ item.anno }}</td><td>{{ item.numdoc }}</td><td>{{ item.totalemerce/100 | currency }}</td><td>{{ item.totiva/100 | currency }}</td><td>{{ item.totdocumento/100 | currency }}</td><td><a ng-href="#!/fatture/dettaglio/{{item.ntsid}}"><i class="glyphicon glyphicon-zoom-in" tooltips="" tooltip-template="Dettagli" tooltip-size="small"></i></a></td><td><a ng-if="item.idmovcont" href="#!/edit-movimento/{{item.ntsid}}"><i class="glyphicon glyphicon-list" tooltips="" tooltip-template="Movimenti contabili" tooltip-size="small"></i></a></td><td><a ng-href="/#!/fattura/download/{{item.id}}" target="_blank"><i class="glyphicon glyphicon-download-alt" tooltips="" tooltip-template="Download fattura" tooltip-size="small"></i></a></td></tr></tbody></table></div></uib-tab><uib-tab heading="CEP" ng-show="utente.ntsrole!=\'sicurezza\'" index="10"><div class="row cep"><div class="row spinner-cont" ng-if="loadingcep"><span class="spinner"></span></div><div ng-show="!showcep && !loadingcep" class="text-center">Nessun abbonamento attivo</div><div ng-show="showcep && !loadingcep" ng-repeat="c in activeceps" ng-if="$index==0" class="single-cep {{$index==0 ? \'first\' : \'not-first\'}}"><div class="row main-cep"><div class="col-md-4"><img class="img-responsive" src="{{baseurl}}/{{c.img}}" alt="cepimage"></div><div class="col-md-4"><div class="col-md-12"><ul><li><span class="label">Tipo Abbonamento:</span>{{c.ceptype}}</li><li><span class="label">Data Iscrizione:</span>{{c.insdate*1000 | date}}</li><li ng-if="c.canceldate"><span class="label">Data disdetta:</span>12-5-2019</li></ul><a ng-if="!c.canceldate" class="btn btn-primary" ng-click="disdettaCep(c)">Disdetta</a><br><br><a ng-if="manualRenew();" class="btn btn-danger btn-orange button-spinner {{retryPaymentLoading ? \'spinning\' : \'\'}}" ng-click="!retryPaymentLoading && retryPayment(c);">Ritenta pagamento {{ date.full | date: \'MMMM\' }} <span class="spinner-cont button" ng-show="retryPaymentLoading"><span class="spinner"></span></span></a></div></div></div><div class="row"><br><table class="table" st-table="logs" st-safe-src="cepLogs"><thead><tr class="sortable"><th></th><th st-sort="ceptype">Tipo</th><th st-sort="status">Stato</th><th st-sort="canceldate">Data Cancellazione</th><th st-sort="insdate">Data Sottoscrizione</th><th st-sort="quota">Prezzo</th></tr></thead><tbody><tr ng-repeat="item in logs"><td><img class="table-img" src="{{baseurl}}/{{item.img}}" alt="cepimage"></td><td>{{item.ceptype}}</td><td>{{item.status}}</td><td>{{(item.canceldate)?(item.canceldate * 1000 | date: \'dd/MM/yyyy\'):(\'\')}}</td><td>{{item.insdate * 1000 | date: \'dd/MM/yyyy\'}}</td><td>{{item.quota/100 | number: \'2\'}} \u20AC</td></tr></tbody></table></div></div></div></uib-tab><uib-tab heading="Rinnovi CEP" ng-show="utente.ntsrole!=\'sicurezza\'" index="11"><table class="table" st-table="displayedRenewals" st-safe-src="renewals"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="charge">Charge</th><th st-sort="data">Data</th><th st-sort="mesi">Mesi</th><th st-sort="anno">Anno</th><th st-sort="tentativi">Tentativi</th><th st-sort="status">Stato</th></tr></thead><tbody><tr ng-repeat="item in displayedRenewals"><td><b>{{item.id}}</b></td><td>{{ item.charge }}</td><td>{{ item.renewaldate * 1000 | date:"dd/MM/yyyy"}}</td><td>{{ item.month }}</td><td>{{ item.year }}</td><td>{{ item.attempt }}</td><td>{{ item.status }}</td><td>{{ item.totdocumento/100 | currency }}</td></tr></tbody></table></uib-tab><uib-tab heading="Eventi associabili" ng-show="utente.ntsrole==\'sicurezza\'" index="12"><table class="table" st-table="displayedEvents" st-safe-src="futureEvents"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="charge">Evento</th><th st-sort="data">Location</th><th st-sort="mesi">Provincia</th><th st-sort="anno">Data</th></tr></thead><tbody><tr ng-repeat="item in displayedEvents"><td><b>{{item.id}}</b></td><td>{{ item.name }}</td><td>{{ item.location }}</td><td>{{ item.province }}</td><td>{{ item.startdate * 1000 | date:"dd/MM/yyyy"}}</td><td><button type="button" ng-show="item.removeID" class="btn btn-sm btn-danger" ng-click="dissocia(item)">Dissocia</button> <button type="button" ng-show="!item.removeID" class="btn btn-sm btn-success" ng-click="associa(item)">Associa</button></td></tr></tbody></table></uib-tab><uib-tab heading="Crediti" index="13"><div><button type="button" class="btn btn-primary" ng-click="openCreditGiftDialog($Event)"><i class="glyphicon glyphicon-gift"></i> Regala crediti</button></div><table class="table" st-table="displayedCredits" st-safe-src="credits"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="descr">Descrizione</th><th st-sort="delta">Delta</th><th st-sort="creditleft">Crediti residui</th><th st-sort="expiry">Scadenza</th><th st-sort="transactiondate">Data transazione</th></tr></thead><tbody><tr ng-repeat="item in displayedCredits"><td><b>{{item.id}}</b></td><td>{{ item.descr }}</td><td>{{ item.delta | number }}</td><td>{{ item.creditleft }}</td><td>{{ item.expiry * 1000 | date : "dd/MM/yyyy" }}</td><td>{{ item.transactiondate ? (item.transactiondate * 1000 | date : "dd/MM/yyyy") : \'\' }}</td></tr></tbody></table></uib-tab><uib-tab heading="Condivisi" index="14"><table class="table" st-table="displayedShares" st-safe-src="shares"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="fname">Nome</th><th st-sort="lname">Cognome</th><th st-sort="email">Email</th><th style="text-align : center" st-sort="numtracks">N. Tracce</th><th st-sort="sharecode">Codice</th><th st-sort="status">Stato</th><th st-sort="sharedate">Condiviso il</th><th style="text-align : center" st-sort="redeemdate">Usato il</th><th st-sort="validuntil">Scadenza</th><th>OS</th><th style="text-align : center">Tracce</th><th style="text-align : center">Reset</th></tr></thead><tbody><tr ng-repeat="item in displayedShares"><td><b>{{item.id}}</b></td><td>{{ item.fname }}</td><td>{{ item.lname }}</td><td>{{ item.email }}</td><td style="text-align : center">{{ item.numtracks }}</td><td>{{ item.sharecode }}</td><td>{{ item.status }}</td><td>{{ item.sharedate * 1000 | date : "dd/MM/yyyy" }}</td><td style="text-align : center">{{ (item.redeemdate) ? (item.redeemdate* 1000 | date : "dd/MM/yyyy") : ("-") }}</td><td>{{ item.validuntil * 1000 | date : "dd/MM/yyyy" }}</td><td><i ng-if="item.imei" tooltips="" class="fa fa-{{ deviceCheck(item.imei) }} fa-lg" aria-hidden="true" tooltip-template="{{ \'DEVICE: \' + item.device }}<br>{{ \'IMEI: \' + item.imei }}" tooltip-size="small"></i></td><td style="text-align : center"><i style="cursor : pointer" ng-click="openTracksDialog($Event,item.id)" class="glyphicon glyphicon-cd"></i></td><td style="text-align : center"><i ng-if="item.imei" style="cursor : pointer" ng-click="resetImei(item)" class="glyphicon glyphicon-remove-circle"></i></td></tr></tbody></table></uib-tab><uib-tab heading="Violazioni" index="15"><table class="table table-striped" st-table="displayedViolations" st-safe-src="violations"><thead><tr><th st-sort="id">#</th><th st-sort="event">Utente</th><th st-sort="guestname">PNR</th><th st-sort="ticketname">Motivazione</th><th st-sort="issuedate">Num. Accessi</th><th st-sort="event">Segnalatore</th><th st-sort="guestname">Data violazione</th><th></th></tr></thead><tbody><tr ng-repeat="item in displayedViolations"><td>{{item.id}}</td><td><a href="#!/modifica-utente/{{item.uid}}">{{item.user.fname + " " + item.user.lname}}</a></td><td>{{item.pnrid}}</td><td>{{item.reason}}</td><td>{{item.pnr.seen}}</td><td>{{(item.agent) ? item.agent.fname+ " " + item.agent.lname : \'-\'}}</td><td>{{item.insdate * 1000 | date :\'dd/MM/yyyy HH:mm\'}}</td><td><button class="btn btn-sm btn-primary" type="button" ng-click="viewEventAccess(item.pnrid)"><i class="fa fa-search"></i></button></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="20" colspan="9" st-template=""></td></tr></tfoot></table></uib-tab><uib-tab disable="!utente.id" heading="Notifiche" index="16" ng-show="utente.ntsrole!=\'sicurezza\'"><div class="row"><div class="col-md-12"><form ng-submit="pushNotification()"><div class="row"><div class="col-sm-12"><div class="form-group"><label for="notification">Notifica</label> <input required="" ng-model="notification.msg" type="text" class="form-control" id="shipto" placeholder="Notifica"></div><div class="radio"><label><input type="radio" name="now" value="now" ng-model="notification.choice" ng-click="removeScheduleDate()"> Subito</label></div><div class="radio"><label><input type="radio" name="chickenEgg" value="date" ng-model="notification.choice"> Scegli data</label></div><div ng-show="notification.choice==\'date\'"><div class="col-sm-2"><label for="author">Invia da</label><br><div class="input-group" style="margin-top: 12px;"><input date2str="" type="text" class="form-control" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="notification.scheduldate" is-open="open" ng-required="notification.choice==\'date\'" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-sm-2"><div class="form-group"><div class="input-group"><div date2str="" uib-timepicker="" ng-model="notification.scheduldate" hour-step="1" minute-step="1" pad-hours="false" show-meridian="false"></div></div></div></div></div><div class="col-sm-12"><button class="btn btn-success pull-right" type="submit" ng-click="cardFormShow = true">Push</button></div></div></div></form></div></div></uib-tab><uib-tab heading="Push inviate" index="17"><div class="row"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><amway-pagination-server-side page-size="pushTablePageSize" elements="pushNotifications"></amway-pagination-server-side><table class="table" ng-if="!loading" st-table="pushNotifications" st-pipe="getPushPag"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="msg">Messaggio</th><th st-sort="sentdate">Data invio</th><th st-sort="sent">Inviata</th></tr></thead><tbody><tr ng-repeat="item in pushNotifications"><td><b>{{item.id}}</b></td><td>{{item.msg}}</td><td>{{item.sentdate * 1000 | date : \'dd/MM/yyyy\'}}</td><td>{{(item.sent == 1) ? (\'S\xEC\') : (\'No\')}}</td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="pushTablePageSize" st-displayed-pages="" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div></uib-tab><uib-tab heading="Migrazione" index="18"><form ng-submit="migrate()"><div><label>Scegli un utente sul quale effettuare la migrazione</label><ui-select ng-model="migrateToUser.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca cliente...">{{ $select.selected.denominazione }}</ui-select-match><ui-select-choices minimum-input-length="3" refresh="searchCustomers($select.search)" refresh-delay="0" repeat="c in customers | filter: $select.search"><span ng-bind-html="c.denominazione+\' \'+c.conto"></span></ui-select-choices></ui-select></div><br><div><button type="button" class="btn btn-danger" ng-click="deleteOffline()">Cancella contenuti offline</button> <button class="btn btn-primary pull-right">Effettua migrazione</button><br></div><br></form></uib-tab><uib-tab heading="Posizione" index="19"><div ng-init="drawMap(0)"><div id="map" style="width:100%; height : 700px"></div></div></uib-tab><uib-tab heading="Note" index="20"><button class="btn btn-primary" ng-click="openNoteDialog()">Nuova nota</button><div class="row"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><amway-pagination-server-side page-size="noteTablePageSize" elements="notes"></amway-pagination-server-side><table class="table" ng-if="!loading" st-table="notes" st-pipe="getNotePag"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="note">Testo</th><th st-sort="insdate">Data</th><th></th></tr></thead><tbody><tr ng-repeat="item in notes"><td><b>{{item.id}}</b></td><td>{{item.note}}</td><td>{{item.insdate * 1000 | date : \'dd/MM/yyyy\'}}</td><td><button class="btn btn-danger btn-sm pull-right" ng-click="deleteNote(item)"><i class="fa fa-trash"></i></button> <button class="btn btn-info btn-sm pull-right" ng-click="openNoteDialog(item)"><i class="fa fa-pencil"></i></button></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="noteTablePageSize" st-displayed-pages="" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div></uib-tab><uib-tab heading="Gift" index="21"><div class="row"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><amway-pagination-server-side page-size="giftTablePageSize" elements="gifts"></amway-pagination-server-side><table class="table" ng-if="!loading" st-table="gifts" st-pipe="getGift"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th>Prodotto</th><th></th><th>Data omaggio</th><th>Dettagli</th><th class="text-center">Regalo NTS</th></tr></thead><tbody><tr ng-repeat="item in gifts"><td><b>{{item.id}}</b></td><td><a href="#!/modifica-prodotto/{{ item.productid }}">{{item.product.name}}</a></td><td><img style="width: 100px; margin: 10px;" ng-src="{{baseurl}}{{item.product.img}}"></td><td>{{item.giftdate * 1000 | date : \'dd/MM/yyyy\'}}</td><td>{{item.reason}} <span ng-if="item.sender">- <a href="#!/modifica-utente/{{ item.sender }}">Vedi utente</a></span></td><td class="text-center"><span ng-show="item.fromnts"><i class="fa fa-check-circle fa-lg text-success" aria-hidden="true"></i></span></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="giftTablePageSize" st-displayed-pages="" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/utenti/fornitori.html','<a class="btn btn-primary" style="float:right;" href="#!/nuovo-fornitore/">Crea FORNITORE</a><div eltable="" entity="fornitore" extralinks="[{url:\'#!/ricercamovimenti?fornitore=\', label: \'mastrino\'}]" edit="true" remove="true"></div>');
$templateCache.put('app/pages/utenti/livelli.html','<div class="container well"><div ng-if="chart" d3-hierarchy="chart" depth="3"></div></div>');
$templateCache.put('app/pages/utenti/modifica-utente.html','<div ng-include="" src="\'app/pages/utenti/form-utente.html\'"></div>');
$templateCache.put('app/pages/utenti/note-dialog.html','<div class="modal-content"><form name="lang" ng-submit="salva()"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">{{(note.id)?\'Modifica\':\'Nuova\'}} nota</h4></div><div class="modal-body"><div class="form-group"><label>Testo</label> <textarea ng-model="note.note" type="text" class="form-control" id="notes" required=""></textarea></div></div><div class="modal-footer"><a ng-click="cancel()" class="btn btn-default">Annulla</a> <button type="submit" class="btn btn-primary">Conferma</button></div></form></div>');
$templateCache.put('app/pages/utenti/notification.html','<div class="row"><div class="col-md-12"><form ng-submit="pushNotification()"><div class="row"><div class="col-sm-12"><div class="form-group"><label for="notification">Notifica</label> <input required="" ng-model="notification.msg" type="text" class="form-control" id="shipto" placeholder="Notifica"></div><div class="radio"><label><input type="radio" name="chickenEgg" value="now" ng-model="notification.choice" ng-click="notification.dateformat = undefined"> Subito</label></div><div class="radio"><label><input type="radio" name="chickenEgg" value="date" ng-model="notification.choice"> Scegli data</label></div><date-picker ng-show="notification.choice==\'date\'" ng-model="notification.dateformat"></date-picker><button class="btn btn-success pull-right" type="submit">Push</button></div></div></form></div><p>&nbsp * Le notifiche verranno inviate agli utenti presenti nella tabella.</p></div>');
$templateCache.put('app/pages/utenti/nuovo-utente.html','<div ng-include="" src="\'app/pages/utenti/form-utente.html\'"></div>');
$templateCache.put('app/pages/utenti/promuovi-dialog.html','<div class="modal-content"><form name="lang" ng-submit="salva()"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Promuovi {{utente.fname}} {{utente.lname}}</h4></div><div class="modal-body"><table class="table table-striped" st-table="displayedSiblings" st-safe-src="siblings"><thead><tr><th></th><th st-sort="fname">Nome</th><th st-sort="lname">Cognome</th><th st-sort="code">Codice NTS</th></tr><tr><th></th><th><input st-search="fname" placeholder="Cerca Nome" class="input-sm form-control search-input" type="search"></th><th><input st-search="lname" placeholder="Cerca Cognome" class="input-sm form-control search-input" type="search"></th><th><input st-search="code" placeholder="Cerca Codice NTS" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="s in displayedSiblings" ng-if="s.id!=utente.id"><td><input type="checkbox" ng-model="s.checked"></td><td>{{s.fname}}</td><td>{{s.lname}}</td><td>{{s.code}}</td></tr></tbody></table><strong>Attenzione: confermando questa operazione verr\xE0 apportata la modifica all\'albero degli incaricati.</strong></div><div class="modal-footer"><a ng-click="cancel()" class="btn btn-default">Annulla</a> <button type="submit" class="btn btn-primary">Conferma</button></div></form></div>');
$templateCache.put('app/pages/utenti/tracks-dialog.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Tracce</h4></div><div class="modal-body"><table class="table table-striped" st-table="displayedTracks" st-safe-src="tracks"><thead><tr><th st-sort="id">#</th><th st-sort="aid">Album</th><th st-sort="title">Titolo</th><th st-sort="author">Autori</th><th st-sort="lunghezza">Lungezza</th><th st-sort="percent">Ascolto %</th><th st-sort="lastlistened">Ultimo ascolto</th></tr></thead><tbody><tr ng-repeat="track in displayedTracks"><td>{{track.id}}</td><td>{{track.aid}}</td><td>{{track.titolo}}</td><td>{{track.autori}}</td><td>{{track.lunghezza}}</td><td><div class="progress" style="margin-top : 10px"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="{{track.percent}}" aria-valuemin="0" aria-valuemax="100" style="width: {{track.percent}}%"><span>{{track.percent}}%</span></div></div></td><td>{{track.lastlistened * 1000 | date : "dd/MM/yyyy"}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/utenti/utentePrivatoDialog.html','<div class="modal-content"><form name="lang" ng-submit="salva()"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Utente privato</h4></div><div class="modal-body"><div class="input-group"><label>Data</label> <input date2str="" model-view-value="true" ui-mask="99/99/9999" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="date" is-open="contopen" close-text="Chiudi" show-button-bar="false"> <span class="input-group-btn"><button style="margin-top:20px" type="button" class="btn btn-default" ng-click="contopen=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="modal-footer"><a ng-click="cancel()" class="btn btn-default">Annulla</a> <button type="submit" class="btn btn-primary">Conferma</button></div></form></div>');
$templateCache.put('app/pages/utenti/utenti.html','<a class="btn btn-primary" href="#!/nuovo-utente">Crea Utente</a> <button class="btn btn-success" ng-click="openModal()">Invia notifica</button> <button class="btn btn-default" ng-click="advancedExport()">Export</button><br><br><div ba-panel="" ng-show="type == \'utenti\'"><div class="input-group" id="adv-search"><input type="text" class="form-control" ng-model="genericObj.term" placeholder="Ricerca generica" my-enter="search(); isGenericSearch.bool = true"><div class="input-group-btn"><div class="btn-group" role="group"><div class="advancedsearch dropdown dropdown-lg"><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown"><span class="caret"></span></button><div class="dropdown-menu dropdown-menu-right"><form class="form-horizontal col-md-12" role="form" ng-submit="applySearch()"><br><h3>Ricerca Avanzata</h3><div class="form-group col-md-4"><label>Nome</label> <input type="text" class="form-control" ng-model="filter.fname"></div><div class="form-group col-md-4"><label>Cognome</label> <input type="text" class="form-control" ng-model="filter.lname"></div><div class="form-group col-md-4"><label>Email</label> <input type="text" class="form-control" ng-model="filter.email"></div><div class="form-group col-md-4"><label>PEC</label> <input type="text" class="form-control" ng-model="filter.pec"></div><div class="form-group col-md-4"><label>Codice fiscale</label> <input type="text" class="form-control" ng-model="filter.cf"></div><div class="form-group col-md-4"><label>Codice Amway Italia</label> <input type="text" class="form-control" ng-model="filter.amwayref"></div><div class="form-group col-md-4"><label for="lname">Nazione</label><select required="" ng-model="filter.country" class="form-control" title="Nazione"><option ng-repeat="country in countries" ng-value="country.name">{{country.name}}</option></select></div><div class="form-group col-md-4"><label for="lname">Provincia</label><select required="" ng-model="filter.province" class="form-control" title="Provincia" ng-disabled="filter.country != \'Italia\'"><option ng-repeat="province in provinces" ng-value="province.descrizione">{{province.descrizione}}</option></select></div><div class="form-group col-md-4"><label for="parent">Sponsor</label><ui-select class="hide-nochoice" style="width : 100%" ng-model="sponsor.selectedParent" append-to-body="false" search-enabled="true" close-on-select="false" aria-hidden="false"><ui-select-match style="width : 100%" placeholder="{{sponsor.selectedParent.fname ? (sponsor.selectedParent.fname+\' \'+sponsor.selectedParent.lname) : \'Cerca sponsor...\'}}">{{sponsor.selectedParent.fname ? (sponsor.selectedParent.fname+\' \'+sponsor.selectedParent.lname) : \'Cerca sponsor...\'}}</ui-select-match><ui-select-choices style="min-width: 150px;" minimum-input-length="3" refresh="searchIncaricato($select.search)" refresh-delay="0" repeat="sp in incaricati"><span ng-bind-html="sp.fname"></span> <span ng-bind-html="sp.lname"></span></ui-select-choices></ui-select></div><div class="form-group col-md-3"><label>Codice unico</label> <input type="text" class="form-control" ng-model="filter.code"></div><div class="form-group col-md-3"><label>Partita iva</label> <input type="text" class="form-control" ng-model="filter.vat"></div><div class="form-group col-md-3"><label>Ruolo</label><select class="form-control" ng-model="filter.ntsrole"><option value="cliente">Cliente</option><option value="incaricato">Incaricato</option><option value="amministratore">Amministratore</option><option value="magazziniere">Magazziniere</option><option value="web">Web</option><option value="contabilita">Contabilit\xE0</option><option value="sicurezza">Sicurezza</option><option value="wes">Wes</option></select></div><div class="form-group col-md-3"><label for="amwaylevel">Livello Amway</label><select ng-model="filter.amwaylevel" class="form-control" title="Livello Amway"><option value="distribuzione selettiva">Distribuzione selettiva</option><option value="diamante">Diamante</option><option value="smeraldo">Smeraldo</option><option value="platino fondatori">Platino fondatori</option><option value="platino">Platino</option><option value="argento">Argento</option><option value="nq">Non qualificato</option></select></div><div class="col-md-3"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-true-value="1" ng-false-value="0" id="tcacceptedfilter" ng-model="filter.tcaccepted"> <span>Termini e condizioni accettati</span></label></div></div><button type="submit" class="btn btn-primary col-md-1 pull-right"><span class="glyphicon glyphicon-search" aria-hidden="true" ng-click="isGenericSearch.bool = false"></span></button></form></div></div><button type="button" class="btn btn-primary" ng-click="isGenericSearch.bool = true; search();"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button></div></div></div><br><div class="input-group z-index0" id="adv-search"><input date-range-picker="" class="form-control date-picker" type="text" placeholder="Ricerca range date..." ng-model="datePicker.range"><div class="input-group-btn"><div class="btn-group" role="group"><button type="submit" class="btn btn-primary"><span class="glyphicon glyphicon-search" aria-hidden="true" ng-click="applySearch(); isGenericSearch.bool = false"></span></button></div></div></div><div class="input-group col-md-12"><div class="form-group col-md-offset-3 col-md-7"></div></div></div><amway-pagination-server-side page-size="utentiTablePageSize" elements="displayedUsers"></amway-pagination-server-side><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" ng-show="!loading" st-table="displayedUsers" st-pipe="getData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">Code</th><th st-sort="fname">Nome</th><th st-sort="lname">Cognome</th><th st-sort="denominazione">Ragione Sociale</th><th st-sort="email">Email</th><th st-sort="ntsrole">Ruolo</th><th st-sort="insdate">Inserimento</th><th st-sort="tcacceptedate" class="text-center">TC accettati</th><th st-sort="prnt.lname">Sponsor</th><th></th></tr></thead><tbody ng-show="loadingpage"><tr><td colspan="9" class="text-center"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div></td></tr></tbody><tbody><tr ng-repeat="item in displayedUsers" ng-class="(item.blacklist == 1) ? \'blacklist-row\' : \'\'"><td class="table-id"><a href="#!/modifica-utente/{{item.id}}">{{item.code}}</a></td><td bgcolor="{{getRowColor(item.status)}}" class="start_case">{{item.fname.toLowerCase()}}</td><td bgcolor="{{getRowColor(item.status)}}" class="start_case">{{item.lname.toLowerCase()}}</td><td>{{item.denominazione}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.ntsrole}}</td><td>{{item.insdate*1000 | date:\'dd/MM/yyyy\'}}</td><td class="text-center"><i ng-if="item.tcaccepted" style="z-index: -1;" class="glyphicon glyphicon-ok" tooltips="" tooltip-template="{{ item.tcacceptedate*1000 | date:\'dd/MM/yyyy\' }}" tooltip-size="small"></i></td><td class="table-id"><a href="#!/modifica-utente/{{item.parent}}">{{item.prnt.lname}}</a></td><td><a href="#!/ricercamovimenti?cliente={{item.conto}}">mastrino</a></td><td><a href="#!/modifica-utente/{{item.id}}"><i class="glyphicon glyphicon-edit" tooltips="" tooltip-template="Modifica" tooltip-size="small"></i></a></td><td><a ng-if="item.ntsrole==\'incaricato\'" href="#!/livelli-utente/{{item.id}}"><i class="glyphicon glyphicon-stats" tooltips="" tooltip-template="Livelli" tooltip-size="small"></i></a></td><td><a ng-if="item.ntsrole==\'incaricato\'" href="#!/bonus-utente/{{item.id}}"><i class="glyphicon glyphicon-heart" tooltips="" tooltip-template="Segni vitali" tooltip-size="small"></i></a></td><td><a ng-click="delete(item.id)"><i class="glyphicon glyphicon-remove" tooltips="" tooltip-template="Elimina" tooltip-size="small"></i></a></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="utentiTablePageSize" colspan="9" st-template="app/utils/pagination/pagination.template.html"></td></tr></tfoot></table>');
$templateCache.put('app/pages/speakers/speaker.html','<div ba-panel="" ba-panel-title="{{speaker.id ? \'Modifica speaker \'+speaker.fname+\' \'+speaker.lname : \'Crea nuovo speaker\'}}" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><uib-tabset><uib-tab heading="Dati"><form><div class="row"><div class="col-sm-6"><div class="form-group"><label for="fname">Nome</label> <input required="" ng-model="speaker.fname" type="text" class="form-control" id="fname" placeholder="Nome"></div></div><div class="col-sm-6"><div class="form-group"><label for="lname">Cognome</label> <input required="" ng-model="speaker.lname" type="text" class="form-control" id="lname" placeholder="Cognome"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="country">Paese</label> <input ng-model="speaker.country" type="text" class="form-control" id="country" placeholder="Paese"></div></div><div class="col-sm-6"><div class="form-group"><label for="amwaylevel">Livello</label> <input ng-model="speaker.amwaylevel" type="text" class="form-control" id="amwaylevel" placeholder="Livello"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="bio">Biografia</label><trix-editor angular-trix="" ng-model="speaker.bio"></trix-editor></div></div><div class="col-sm-6"><div class="form-group"><label for="shortbio">Biografia breve</label> <textarea ng-model="speaker.shortbio" type="text" class="form-control" id="shortbio"></textarea></div></div></div><button class="btn btn-default" ng-click="salva()">Salva</button> <button ng-show="{{speaker.id}}" class="btn btn-danger" ng-click="elimina()">Elimina</button></form></uib-tab><uib-tab heading="Immagine profilo"><p>Per una miglior resa caricare un\'immagine quadrata</p><form id="imageform" name="imageform"><img height="100" ng-show="!immagine.file && speaker.profilepic" ng-src="{{baseurl}}{{speaker.profilepic}}" alt="image"> <img height="100" ngf-thumbnail="immagine.file"><div ng-required="true" class="button" ngf-select="" ng-model="immagine.file" name="image" ngf-pattern="\'image/*\'" ngf-accept="\'image/*\'" ngf-max-size="20MB" ngf-min-height="100">Seleziona un\'immagine <i style="font-size: 200%; cursor: pointer" class="ion-ios-upload"></i></div><button class="btn btn-default" ng-click="uploadImmagine()">Carica immagine</button></form></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/speakers/speakers.html','<a class="btn btn-primary" href="#!/nuovo-speaker">Crea Speaker</a><br><amway-pagination-size page-size="speakersTablePageSize" elements="speakers"></amway-pagination-size><div class="horizontal-scroll"><div ng-show="false" class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control show-tick" title="Rows on page" selectpicker="" ng-model="speakersTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedSpeakers" st-safe-src="speakers"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="fname">First Name</th><th st-sort="lname">Last Name</th><th st-sort="amwaylevel">Livello</th><th st-sort="shortdesc">Biografia breve</th><th st-sort="country">Paese</th><th>Azioni</th></tr><tr><th></th><th><input st-search="fname" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lname" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="amwaylevel" placeholder="Search Livello" class="input-sm form-control search-input" type="search"></th><th><input st-search="shortdesc" placeholder="Search Descrizione" class="input-sm form-control search-input" type="search"></th><th><input st-search="country" placeholder="Search Paese" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in displayedSpeakers"><td class="table-id">{{item.id}}</td><td>{{item.fname}}</td><td>{{item.lname}}</td><td>{{item.amwaylevel}}</td><td>{{item.shortbio}}</td><td>{{item.country}}</td><td><a class="btn btn-primary btn-xs" href="#!/modifica-speaker/{{item.id}}">Modifica</a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="speakersTablePageSize" st-displayed-pages="10" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/video/video.html','<div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dati Generali"><form ng-submit="salva()"><div class="row"><div class="col-md-6"><div class="form-group"><label for="title">Titolo</label> <input required="" ng-model="video.title" type="text" class="form-control" id="title" placeholder="Titolo"></div></div><div class="col-md-6"><div class="form-group"><label for="thumb">Thumb <small>(dimensioni consigliate 600x450 px)</small></label> <input ng-model="video.thumb" type="text" class="form-control" id="thumb" placeholder="Thumb"></div></div><div class="col-md-4"><div class="form-group"><label for="minamwaylevel">Livello Amway Minimo</label><select ng-model="video.minlevel" class="form-control" title="Livello Amway"><option value="diamante">Diamante</option><option value="smeraldo">Smeraldo</option><option value="platino fondatori">Platino fondatori</option><option value="platino">Platino</option><option value="argento">Argento</option><option value="leaders">Leaders Club</option><option ng-value="undefined">Tutti</option></select></div></div><div class="col-md-4"><div class="form-group"><label for="minamwaylevel">Categoria</label><select ng-model="video.taxonomy" class="form-control" required="" title="Categoria"><option ng-repeat="tax in taxonomies">{{tax.taxonomy}}</option></select></div></div><div class="col-md-3"><div class="form-group"><label for="thumb">Ordinamento</label> <input ng-model="video.sort" type="text" class="form-control" id="sort" placeholder="0"></div></div><div class="col-md-3"><div class="form-group"><br><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-true-value="1" ng-false-value="0" id="featured" ng-model="video.sharable"> <span>Condivisibile</span></label></div></div><div class="col-md-12"><div class="form-group"><label for="fname">Descrizione</label> <textarea rows="3" ng-model="video.descr" type="text" class="form-control" id="descr" placeholder="Descrizione"></textarea></div></div><div class="col-md-12"><div class="form-group"><label for="fname">Video</label> <textarea rows="3" ng-model="video.vimeoembed" type="text" class="form-control" id="video" placeholder="Video"></textarea></div></div><div class="col-md-12"><button class="btn btn-default pull-right" type="submit">Salva</button></div></div></form></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/video/videos.html','<a class="btn btn-primary" href="#!/nuovo-video">Crea Video</a><amway-pagination-size page-size="videosTablePageSize" elements="videos"></amway-pagination-size><div class="horizontal-scroll"><div ng-show="false" class="form-group select-page-size-wrap"></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedVideos" st-safe-src="videos"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="title">Titolo</th><th st-sort="minlevel">Livello minimo</th><th st-sort="taxonomy">Categoria</th><th st-sort="sharable">Condivisibile</th><th>Azioni</th></tr><tr><th></th><th><input st-search="title" placeholder="Cerca per titolo" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in displayedVideos"><td><b>{{item.id}}</b></td><td><b>{{item.title}}</b></td><td><b>{{item.minlevel}}</b></td><td><b>{{item.taxonomy}}</b></td><td><b ng-if="item.sharable === 1"><i class="fa fa-check"></i></b> <b ng-if="item.sharable === 0"><i class="fa fa-times"></i></b></td><td><a class="btn btn-primary btn-xs" href="#!/modifica-video/{{item.id}}">Modifica</a> <a class="btn btn-danger btn-xs" ng-click="eliminaVideo(item)">Elimina</a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="videosTablePageSize" st-displayed-pages="5" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/utils/elprint/elprint.template.html','<div class="row"><div class="col-xs-9"><h2><b>STAMPA {{ subject }}</b></h2><p><b>{{ title.extra.customerName ? \'Cliente: \' + title.extra.customerName + \' (\' + title.cliente + \') | \' : \'\' }} {{ title.extra.supplierName ? \'Fornitore: \' + title.extra.supplierName + \'(\' + title.fornitore + \') | \' : \'\' }} {{ title.extra.contoFromName ? \'Da Conto: \' + title.extra.contoFromName + contofrom + \' | \' : \'\' }} {{ title.extra.contoToName ? \'A Conto: \' + title.extra.contoToName + contoto + \' | \' : \'\' }} {{ title.partita ? \'Partita: \' + title.partita + \' | \' : \'\' }} <span ng-if="title.datefrom">Da: {{ title.datefrom*1000 | date:\'dd/MM/yy\' }} - A: {{ title.dateto*1000 | date:\'dd/MM/yy\' }}</span></b></p></div><div class="col-xs-3"><button type="button" class="btn btn-lg btn-primary hide-print" style="float:right;" ng-click="doPrint();">STAMPA <i class="fa fa-print fa-lg" aria-hidden="true"></i></button></div></div><br><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table ng-if="!loading" class="table table-striped border-table"><thead><tr><th ng-repeat="title in tableHeaders" class="text-{{ align[$index] }}"><b>{{ title | uppercase }}</b></th></tr></thead><tbody><tr><div class="pull-right" ng-if="saldoIniziale > 0"><b>Saldo Iniziale:</b> {{saldoIniziale / 100 | number : 2}}</div><br></tr><tr ng-repeat="row in dataset track by $index"><td class="text-{{ align && align.length && align[$parent.$index] ? align[$parent.$index] : \'center\' }}" ng-if="onlyPrint && value !== \'detnote\'" ng-repeat="value in onlyPrint">{{ displayValue(row[value], $index) }}</td></tr></tbody></table>');
$templateCache.put('app/utils/eltable/eltable.template.html','<div><amway-pagination-server-side page-size="utentiTablePageSize" elements="collection"></amway-pagination-server-side><table class="table" st-table="collection" st-pipe="loadCollection"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">Id</th><th st-sort="{{head.sortable ? head.header : \'\'}}" ng-repeat="head in headers">{{head.header}}</th><th ng-if="edit"></th><th ng-repeat="s in extralinks"></th></tr><tr><th></th><th ng-repeat="head in headers"><input ng-if="head.filtrable" st-search="{{head.header}}" placeholder="Filtra {{head.header}}..." class="input-sm form-control search-input" type="search"></th><th ng-if="edit"></th><th ng-repeat="s in extralinks"></th></tr></thead><tbody><tr ng-repeat="item in collection"><td class="table-id">{{item.id}}</td><td ng-repeat="head in headers" ng-init="createUivalue(item, head, $parent.$index)"><span ng-if="head.type==\'text\'"><span ng-repeat="k in head.keys">{{item[k]}}</span></span> <span ng-if="head.type==\'timestamp\'"><span ng-repeat="k in head.keys">{{item[k]*1000 | date}}</span></span> <span ng-if="head.type==\'int\'"><span ng-repeat="k in head.keys">{{item[k]}}</span></span> <span ng-if="head.type==\'double\'"><span ng-repeat="k in head.keys">{{item[k] | number:2}}</span></span> <span ng-if="head.type==\'flag\'"><span ng-repeat="k in head.keys"><i ng-show="item[k]" class="ion-checkmark-circled"></i></span></span> <span ng-if="head.type==\'object\'"><a href="{{head.link ? \'#!/edit-\'+head.entity+\'/\'+item[\'ui\'+head.key].id : \'\'}}"><span ng-repeat="k in item[\'ui\'+head.key].uivalue">{{k}}</span></a></span> <span ng-if="head.type==\'cent\'"><span ng-repeat="k in head.keys">{{item[k]/100 | number:2}}</span></span> <span ng-if="head.type==\'img\'"><span ng-repeat="k in head.keys"><img ng-if="item[k]" style="width: 100px; margin: 10px;" ng-src="{{baseurl}}{{item[k]}}"></span></span></td><td ng-if="edit"><a href="#!/edit-{{entity}}/{{item.id}}"><i class="glyphicon glyphicon-edit" tooltips="" tooltip-template="Modifica" tooltip-size="small"></i></a></td><td ng-if="remove"><a href="" ng-click="deleteEntity(entity, item.id)"><i class="glyphicon glyphicon-remove" tooltips="" tooltip-template="Elimina" tooltip-size="small"></i></a></td><td ng-repeat="s in extralinks"><a href="{{s.url}}{{item.id}}">{{s.label}}</a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="utentiTablePageSize" st-displayed-pages="10" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/utils/stripe/stripe-form.html','<div class="row" ng-show="!loading"><div class="col-md-10 col-md-offset-1 well"><div class="stripe-add-card"><form class="form-gap"><div class="card-element"></div><div class="card-errors" role="alert">{{ errormessage }}</div></form></div><div class="col-md-12 text-center"><a class="btn btn-primary" ng-click="cancelStripeForm()">Annulla</a> <button class="btn btn-primary" ng-click="submitStripeForm()">Salva</button></div></div></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div>');
$templateCache.put('app/utils/pagination/pagination.template.html','<ul class="pagination" amway-pagination=""><li ng-if="pages[0] !== 1"><a ng-click="selectPage(1)">1</a></li><li ng-if="pages[0] > 5"><a ng-click="selectPage(pages[0] - 5)">&laquo;</a></li></ul><ul class="pagination" amway-pagination=""><li ng-repeat="page in pages" ng-class="{ active: currentPage === page }"><a ng-click="selectPage(page)">{{ page }}</a></li></ul><ul class="pagination" amway-pagination=""><li ng-if="pages[lastPagesIndex()] < numPages - 5"><a ng-click="selectPage(pages[lastPagesIndex()] + 5)">&raquo;</a></li><li ng-if="pages[lastPagesIndex()] < numPages"><a ng-click="selectPage(numPages)">{{ numPages }}</a></li></ul>');
$templateCache.put('app/utils/pagination/paginationSize.template.html','<ul class="pagination"><li><a>Mostra</a></li><li ng-repeat="size in sizes track by $index" ng-class="{ active: pageSize === size}"><a ng-click="setPagination(size)">{{ strSize(size) }}</a></li></ul>');
$templateCache.put('app/contabilita/partiteaperte/list/partiteapertelist.html','<div class="horizontal-scroll"><div ba-panel=""><form ng-submit="adSearch()"><h3>Ricerca</h3><div class="row ricerca_movimenti"><div class="col-xs-12"><div class="form-group col-xs-2"><label for="ruolo">Tipo</label><select ng-model="searchObj.tipo" class="form-control" title="Tipo"><option value="F">Fornitore</option><option value="C">Cliente</option></select></div><div class="col-xs-4"><label>Date</label> <input date-range-picker="" class="form-control date-picker" type="text" placeholder="Ricerca range date..." ng-model="datePicker.range"></div></div></div><br><div class="col-xs-9"><p class="text-danger">{{ error }}</p></div><div class="col-xs-2 text-right"><button type="button" class="btn btn-danger" ng-click="reset();">Svuota ricerca</button></div><div class="col-xs-1 text-right"><button type="submit" class="btn btn-primary">Cerca</button></div></form></div><amway-pagination-size page-size="itemsPerPage" elements="partiteaperte"></amway-pagination-size><div class="row spinner-cont" style="margin-left:0;margin-right:0;" ng-show="loading"><span class="spinner"></span></div><a class="btn btn-primary" ng-show="enablePrint" style="float:right;margin-right:50px;" ng-click="print();">STAMPA <i class="fa fa-print fa-lg" aria-hidden="true"></i></a><table class="table" ng-show="!loading" st-table="displayedPartite" st-safe-src="partiteaperte"><thead><tr class="sortable"><th class="table-id">#</th><th st-sort="conto">Codice</th><th>Partita</th><th>Num. fatt.</th><th st-sort="datafatt">Data fatt.</th><th st-sort="partnome">Nome</th><th>Data</th><th>Dare</th><th>Avere</th></tr><tr><th></th><th><input st-search="conto" placeholder="Cerca per conto" class="input-sm form-control search-input" type="search"></th><th><input st-search="partita" placeholder="Cerca per partita" class="input-sm form-control search-input" type="search"></th><th><input st-search="numfatt" placeholder="Cerca per num. fatt." class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="partnome" placeholder="Cerca per nome" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="partita in displayedPartite"><td>{{}}</td><td><a target="\u201D_blank\u201D" href="{{((partita.conto.charAt(0)==\'C\')?(\'#!/ricercamovimenti?cliente=\'):(\'#!/ricercamovimenti?fornitore=\')) + partita.conto }}">{{partita.conto}}</a></td><td>{{partita.partita}}</td><td>{{partita.numfatt}}</td><td>{{ partita.datafatt ? (partita.datafatt*1000 | date:\'dd/MM/yyyy\') : \'\' }}</td><td>{{partita.partnome}}</td><td>{{partita.partdate*1000 | date:\'dd/MM/yyyy\'}}</td><td>{{partita.dare/100.0 | number:2}}</td><td>{{partita.avere/100.0 | number:2}}</td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="itemsPerPage" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/contabilita/pianoconti/new-edit/form-pianoconti.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><small class="text-danger">* campi obbligatori</small></div></div><br><form name="form" ng-submit="form.$valid && salva()" novalidate=""><div class="row"><div class="col-sm-3"><div class="form-group"><label for="fname">Mastro *</label> <input required="" ng-model="conto.mastro" type="text" class="form-control" id="fname" placeholder="Mastro" ng-disabled="conto.id"></div></div><div class="col-sm-3"><div class="form-group"><label for="lname">Conto *</label> <input required="" ng-model="conto.conto" type="text" class="form-control" id="lname" placeholder="Conto" ng-disabled="conto.id"></div></div><div class="col-sm-3"><div class="form-group"><label for="country">Sottoconto</label> <input ng-model="conto.sottoconto" type="text" class="form-control" id="country" placeholder="Sottoconto" ng-disabled="conto.id"></div></div><div class="col-sm-3"><div class="form-group"><label for="country">Codice</label> <input ng-model="conto.codice" type="text" class="form-control" id="country" placeholder="Codice" ng-disabled="conto.id"></div></div><div class="col-sm-3"><div class="form-group"><label for="country">Gruppo *</label><select ng-model="conto.gruppo" ng-change="setTipo()" name="gruppo" id="inputGruppo" class="form-control" required=""><option value="" selected="">-- Seleziona il gruppo --</option><option value="A">Attivit\xE0</option><option value="P">Passivit\xE0</option><option value="R">Ricavo</option><option value="C">Costo</option><option value="O">Ordine</option></select></div></div><div class="col-sm-3"><div class="form-group"><label for="country">CEE</label> <input ng-model="conto.ivadirettivacee" type="text" class="form-control" id="country" placeholder="CEE"></div></div><div class="col-sm-6"><div class="form-group"><label for="country">Descrizione</label> <input ng-model="conto.descrizione" type="text" class="form-control" id="country" placeholder="Descrizione"></div></div></div><button type="submit" class="btn btn-default">Salva</button></form></div>');
$templateCache.put('app/contabilita/pianoconti/list/pianoconti.html','<a class="btn btn-primary" href="#!/pianoconti/edit/">Crea Conto</a> <a class="btn btn-primary" ng-show="enablePrint" style="float:right;" ng-click="print();">STAMPA <i class="fa fa-print fa-lg" aria-hidden="true"></i></a><br><div class="horizontal-scroll"><div ng-show="false" class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control show-tick" title="Rows on page" selectpicker="" ng-model="autoriTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedConti" st-safe-src="conti" st-sentinel="applyChange(tableState)"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="codice.substring(0,1)">Mastro</th><th st-sort="codice.substring(1,3)">Conto</th><th st-sort="codice.substring(3)">Sottoconto</th><th>Codice</th><th>Descrizione</th><th>Tipo</th><th>CEE</th><th>Ricerca</th><th>Azioni</th></tr><tr><th></th><th><input st-search="mastrosrc" placeholder="Mastro" class="input-sm form-control search-input" type="search"></th><th><input st-search="contosrc" placeholder="Conto" class="input-sm form-control search-input" type="search"></th><th><input st-search="sottocontosrc" placeholder="Sottoconto" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="descrizione" placeholder="Descrizione" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th><button class="btn btn-danger" st-reset-search=""><i class="fa fa-times" aria-hidden="true"></i>&nbsp;Filtri</button></th></tr></thead><tbody><tr ng-repeat="item in displayedConti"><td class="table-id">{{item.id}}</td><td><span>{{item.codice.substring(0,1)}}</span></td><td><span>{{item.codice.substring(1,3)}}</span></td><td><span>{{item.codice.substring(3)}}</span></td><td>{{item.codice}}</td><td>{{item.descrizione}}</td><td>{{item.gruppo}}</td><td>{{item.ivadirettivacee}}</td><td><a href="#!/ricercamovimenti?contofrom={{item.codice}}&contoto={{item.codice}}">mastrino</a></td><td><a href="#!/pianoconti/edit/{{item.id}}"><i class="glyphicon glyphicon-edit" tooltips="" tooltip-template="Modifica" tooltip-size="small"></i></a> <a ng-click="delete(item.id)"><i class="glyphicon glyphicon-remove" tooltips="" tooltip-template="Elimina" tooltip-size="small"></i></a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="contiTablePageSize" st-displayed-pages="10" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div><amway-pagination-size page-size="contiTablePageSize" elements="conti"></amway-pagination-size>');
$templateCache.put('app/pages/dashboards/events/dashboardEvents.html','<p></p><h3 class="text-center"><b>Ultimo aggiornamento: {{lastUpdate * 1000 | date :\'dd/MM/yyyy HH:mm\'}}</b></h3><p></p><button class="collapsible">Eventi</button><div class="dashcontent"><div class="row"><div class="form-group col-md-3 push-right"><label>Tipo</label><select name="type" ng-model="eventType" id="type" class="form-control"><option value="wes">WES</option><option value="bbs">BBS</option></select></div><div class="form-group col-md-3 push-right" ng-if="eventType==\'bbs\'"><label>Sede</label><select name="type" ng-model="eventVenue.value" id="venute" class="form-control"><option value="fi1">FI1</option><option value="fi2">FI2</option><option value="ge">GE</option><option value="me">ME</option><option value="mi">MI</option><option value="mi1">MI1</option><option value="mi2">MI2</option><option value="pd">PD</option><option value="rm">RM</option></select></div><div style="margin-top: 5px"><br><button type="button" class="btn btn-primary" ng-click="refresh()">Ricarica</button></div></div><hr><canvas width="1000" height="600" id="event-bar-fatturato"></canvas><br><canvas width="1000" height="600" id="event-bar-notfatturto"></canvas></div><button class="collapsible">Singolo evento</button><div class="dashcontent"><form ng-submit="applyFilter()"><div class="input-group"><div class="col-md-3"><label>Scegli un evento</label><ui-select ng-model="selected.event" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Cerca...">{{ $select.selected.name }}</ui-select-match><ui-select-choices minimum-input-length="2" refresh="searchEvents($select.search)" refresh-delay="0" repeat="c in events | filter: $select.search"><span ng-bind-html="c.name"></span></ui-select-choices></ui-select></div><div class="col-md-3"><label>Prices</label><select class="form-control" ng-model="selected.price" ng-disabled="!productPrices"><option ng-value="0">Tutti</option><option ng-repeat="item in productPrices" ng-value="item.value">{{item.key}} ({{item.value/100 | currency: \'\u20AC\'}})</option></select></div><div class="col-xs-2"><label>Data inizio</label><div class="input-group"><input type="text" date2str="" forcetime="down" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="selected.startdate" is-open="popUpDate1" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats" ng-disabled="!selected.event"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate1 = !popUpDate1" ng-disabled="!selected.event"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-2"><label>Data fine</label><div class="input-group"><input type="text" date2str="" forcetime="up" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="selected.stopdate" is-open="popUpDate2" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats" ng-disabled="!selected.event"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate2 = !popUpDate2" ng-disabled="!selected.event"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-2"><div style="margin-top: 5px"><br><button type="button" class="btn btn-primary" ng-click="refreshEvent()">Ricarica</button></div></div></div></form><canvas width="1000" height="600" id="single-event-comulative"></canvas></div><br>');
$templateCache.put('app/pages/dashboards/nuovi-utenti/dashboardNewUsers.html','<div ba-panel=""><table class="table" st-table="displayedUsers" st-pipe="getData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true"><strong>Code</strong></th><th st-sort="fname"><strong>Nome</strong></th><th st-sort="lname"><strong>Cognome</strong></th><th st-sort="denominazione"><strong>Ragione Sociale</strong></th><th st-sort="email"><strong>Email</strong></th><th st-sort="ntsrole"><strong>Ruolo</strong></th><th st-sort="insdate"><strong>Inserimento</strong></th><th width="10%" st-sort="prnt.lname"><strong>Sponsor</strong></th></tr><tr></tr></thead><tbody ng-show="loadingpage"><tr><td colspan="9" class="text-center"><div class="row spinner-cont"><span class="spinner"></span></div></td></tr></tbody><tbody ng-hide="loadingpage"><tr ng-repeat="item in displayedUsers"><td class="table-id"><a href="#!/modifica-utente/{{item.id}}" target="_blank">{{item.code}}</a></td><td bgcolor="{{getRowColor(item.status)}}" class="start_case">{{item.fname.toLowerCase()}}</td><td bgcolor="{{getRowColor(item.status)}}" class="start_case">{{item.lname.toLowerCase()}}</td><td>{{item.denominazione}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.ntsrole}}</td><td>{{item.insdate*1000 | date:\'dd/MM/yyyy\'}}</td><td class="table-id"><a href="#!/modifica-utente/{{item.parent}}">{{item.prnt.lname}}</a></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="utentiTablePageSize" colspan="9" st-template="app/utils/pagination/pagination.template.html"></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/dashboards/prova/prova.html','<div class="dashcontent"><canvas width="1000" height="600" id="mixed-chart"></canvas></div>');
$templateCache.put('app/pages/dashboards/cep/dashboardCep.html','<p></p><h3 class="text-center"><b>Ultimo aggiornamento: {{lastUpdate * 1000 | date :\'dd/MM/yyyy HH:mm\'}}</b></h3><p></p><button class="collapsible">Abbonamenti CEP</button><div class="dashcontent"><div class="row"><div class="form-group col-md-3 push-right"><label>Tipo</label><select name="type" ng-model="cepType" id="ceptype" class="form-control"><option value="pro">CEP Pro</option><option value="base">CEP Base</option><option value="all">Tutti</option></select></div></div><hr><canvas width="1000" height="600" id="cep-bar"></canvas></div><button class="collapsible">Ascolti Tracce</button><div class="dashcontent"><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><div class="row"><div class="form-group col-md-3 push-right"><label>Tipo</label><select name="type" ng-model="cepPieConf.type" id="ceptype" class="form-control"><option value="pro">CEP Pro</option><option value="base">CEP Base</option></select></div><div class="form-group col-md-3"><label>Mese</label><select name="anno" ng-model="cepPieConf.month" id="inputCoe" class="form-control"><option ng-repeat="m in months" ng-value="m">{{m}}</option></select></div><div class="form-group col-md-3 push-right"><label>Anno</label><select name="anno" ng-model="cepPieConf.year" id="inputCoe" class="form-control"><option ng-repeat="y in years" ng-value="y">{{y}}</option></select></div><div style="margin-top: 5px"><br><button type="button" class="btn btn-primary" ng-click="refresh(0)">Ricarica</button></div></div><br><div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="row"><div class="col-md-4"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="cep-pie" width="280" height="280"></canvas><div class="traffic-text">{{ total | number : 0 }} <span>Tracce totali</span></div></div></div></div><div class="col-md-2"></div><div class="col-md-6 center"><div ng-if="!loading"><div><div class="channels-info-item"><div class="legend-color" style="background-color: white"></div><p>Abbonamenti<span class="channel-number">{{signup}}</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="12" aria-valuemin="0" aria-valuemax="100" style="width: 0%"></div></div><div class="legend-color" style="background-color: white"></div><p>Totali ascoltate:<span class="channel-number">{{totPercentListened | number : 2}} %</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="12" aria-valuemin="0" aria-valuemax="100" style="width: 0%"></div></div></div><div class="channels-info-item" ng-repeat="label in cepPieStruct.labels" ng-init="i = $index; data = cepPieStruct.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">{{data.percentage[i]}}%</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" ng-style="{\'width\': \'\'+data.percentage[i]+ \'%\'}"></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboards/range/dashboardRange.html','<p></p><h3 class="text-center"><b>Ultimo aggiornamento: {{lastUpdate * 1000 | date :\'dd/MM/yyyy HH:mm\'}}</b></h3><p></p><div class="row"><div class="col-xs-3"><label>Data inizio</label><div class="input-group"><input type="text" date2str="" forcetime="down" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dates.from" is-open="popUpDate1" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate1 = !popUpDate1"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3"><label>Data fine</label><div class="input-group"><input type="text" date2str="" forcetime="up" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dates.to" is-open="popUpDate2" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate2 = !popUpDate2"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3"><button class="btn btn-primary" ng-click="onDatesUpdate()" style="margin-top: 20px">Ricarica</button></div></div><button id="prodPie" class="collapsible">Prodotti Mese/Anno</button><div class="dashcontent"><div class="row spinner-cont" ng-if="loadingProd"><span class="spinner"></span></div><br><div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="row"><div class="col-md-6 text-center"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="prod-pie" width="280" height="280"></canvas><div class="traffic-text">{{ prodChartStruct.total / 100 | currency : \'\u20AC\' }} <span>Totale fatturato</span></div></div></div></div><div class="col-md-6 pie-legend"><div ng-if="!loadingProd"><div><div class="channels-info-item" ng-repeat="label in prodChartStruct.labels" ng-init="i = $index; data = prodChartStruct.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}} <span class="channel-number"><span style="color: black; font-weight: bold">{{data.data[i] | currency: \'\u20AC\'}}</span> - <span>{{data.percentage[i]}}%</span></span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" ng-style="{\'width\': \'\'+data.percentage[i]+ \'%\'}"></div></div><br><button ng-click="collapseExpandPie(0)" ng-show="i == data.data.length -1 && prodDataLenght>maxRowsCollapse" class="btn btn-info btn-sm pull-right">{{(prodCollapsed ? \'Vedi tutto\' : \'Comprimi\')}}</button><br></div></div></div></div></div></div></div><button id="typePie" class="collapsible">Tipi Mese/Anno</button><div class="dashcontent"><div class="row spinner-cont" ng-if="loadingType"><span class="spinner"></span></div><br><div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="row"><div class="col-md-6"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="type-pie" width="280" height="280"></canvas><div class="traffic-text">{{ typeChartStruct.total / 100 | currency : \'\u20AC\' }} <span>Totale fatturato</span></div></div></div></div><div class="col-md-6 pie-legend"><div ng-if="!loadingType"><div><div class="channels-info-item" ng-repeat="label in typeChartStruct.labels" ng-init="i = $index; data = typeChartStruct.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number"><span style="color: black; font-weight: bold">{{data.data[i] | currency: \'\u20AC\'}}</span> - <span>{{data.percentage[i]}}%</span></span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" ng-style="{\'width\': \'\'+data.percentage[i]+ \'%\'}"></div></div><button ng-click="collapseExpandPie(1)" ng-show="i == data.data.length -1 && typeDataLenght>maxRowsCollapse" class="btn btn-info btn-sm pull-right">{{(typeCollapsed ? \'Vedi tutto\' : \'Comprimi\')}}</button><br></div></div></div></div></div></div></div><button class="collapsible">Pi\xF9 venduti</button><div class="dashcontent"><amway-pagination-server-side page-size="topsellTablePageSize" elements="bestSeller"></amway-pagination-server-side><div class="row spinner-cont" ng-if="loadingtable"><span class="spinner"></span></div><table class="table" st-table="bestSeller" st-pipe="getSellersData"><thead><tr class="sortable"><th class="table-id" st-sort="pid">#</th><th st-sort="name">Nome</th><th st-sort="sku">SKU</th><th st-sort="qty">Quantit\xE0</th><th st-sort="revenue">Fatturato</th></tr><tr><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in bestSeller"><td class="table-id"><a target="_blank" href="/#!/modifica-prodotto/{{item.pid}}">{{item.pid}}</a></td><td>{{item.name}}</td><td>{{item.sku}}</td><td>{{item.qty}}</td><td>{{item.revenue / 100 | currency : "\u20AC"}}</td></tr></tbody><tr></tr><tr><td class="text-center" st-pagination="" st-items-by-page="topsellTablePageSize" colspan="9" st-template="app/utils/pagination/pagination.template.html"></td></tr></table></div><br><br><br><br><br><br><br>');
$templateCache.put('app/pages/dashboards/shares/dashboardShares.html','<p></p><h3 class="text-center"><b>Ultimo aggiornamento: {{lastUpdate * 1000 | date :\'dd/MM/yyyy HH:mm\'}}</b></h3><p></p><div ng-if="topstats"><div class="row pie-charts"><div class="pie-chart-item-container"><div ba-panel=""><div class="pie-chart-item"><div class="description"><div class="topstat-title">Crediti</div><div class="description-stats">{{ topstats.credits }}</div></div></div></div></div><div class="pie-chart-item-container"><div ba-panel=""><div class="pie-chart-item"><div class="description"><div class="topstat-title">Condivisioni</div><div class="description-stats">{{ topstats.share }}</div></div></div></div></div><div class="pie-chart-item-container"><div ba-panel=""><div class="pie-chart-item"><div class="description"><div class="topstat-title">Tracce condivise</div><div class="description-stats">{{ topstats.tracks }}</div></div></div></div></div><div class="pie-chart-item-container"><div ba-panel=""><div class="pie-chart-item"><div class="description"><div class="topstat-title">Tracce attive</div><div class="description-stats">{{ topstats.redeemed }}</div></div></div></div></div></div><div class="row pie-charts"><div class="pie-chart-item-container"><div ba-panel=""><div class="pie-chart-item"><div class="description"><div class="topstat-title">Ascolti</div><div class="description-stats">{{ topstats.listened }}</div></div></div></div></div><div class="pie-chart-item-container"><div ba-panel=""><div class="pie-chart-item"><div class="description"><div class="topstat-title">Ascolti +25%</div><div class="description-stats">{{ topstats.over25 }}</div></div></div></div></div><div class="pie-chart-item-container"><div ba-panel=""><div class="pie-chart-item"><div class="description"><div class="topstat-title">Ascolti +50%</div><div class="description-stats">{{ topstats.over50 }}</div></div></div></div></div><div class="pie-chart-item-container"><div ba-panel=""><div class="pie-chart-item"><div class="description"><div class="topstat-title">Ascolti +75%</div><div class="description-stats">{{ topstats.over75 }}</div></div></div></div></div></div></div><div class="row spinner-cont" style="margin-top: 100px;" ng-if="!tracksList.length"><span class="spinner"></span></div><div ba-panel="" ng-if="tracksList.length"><div class="d-inline-block" style="margin-right: 20px;"><strong>Traccia</strong></div><select ng-model="selectedTrack" class="form-control d-inline-block" style="width: 40%;" title="Traccia" ng-change="searchTrack(selectedTrack)"><option ng-value="\'all\'">Tutte</option><option ng-repeat="title in tracksList" ng-value="title">{{title}}</option></select><canvas width="1000" height="600" id="product-bar"></canvas></div>');
$templateCache.put('app/pages/dashboards/tracks/dashboardTracks.html','<p></p><h3 class="text-center"><b>Ultimo aggiornamento: {{lastUpdate * 1000 | date :\'dd/MM/yyyy HH:mm\'}}</b></h3><p></p><div ba-panel=""><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayTracks" st-safe-src="tracks"><thead><tr class="sortable"><th class="tracks-id" st-sort="track" st-sort-default="true"><strong>Traccia</strong></th><th class="text-center" st-sort="author"><strong>Autore</strong></th><th class="text-center" st-sort="listener"><strong>Ascolti</strong></th><th class="text-center" st-sort="purchase"><strong>Acquisti</strong></th><th class="text-center" st-sort="over25"><strong>Ascolti +25%</strong></th><th class="text-center" st-sort="over50"><strong>Ascolti +50%</strong></th><th class="text-center" st-sort="over75"><strong>Ascolti +75%</strong></th></tr><tr><th><input st-search="track" placeholder="Cerca per nome traccia" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in displayTracks"><td class="tracks-id">{{item.track}}</td><td class="text-center">{{item.author}}</td><td class="text-center">{{item.listener}}</td><td class="text-center">{{item.purchase}}</td><td class="text-center">{{item.over25}}</td><td class="text-center">{{item.over50}}</td><td class="text-center">{{item.over75}}</td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="tracksTablePageSize" st-displayed-pages="5" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/dashboards/vendite/dashboardVendite.html','<p></p><h3 class="text-center"><b>Ultimo aggiornamento: {{lastUpdate * 1000 | date :\'dd/MM/yyyy HH:mm\'}}</b></h3><p></p><button id="prodPie" class="collapsible">Prodotti Mese/Anno</button><div class="dashcontent"><div class="row spinner-cont" ng-if="loadingProd"><span class="spinner"></span></div><div class="row" ng-if="!loadingProd"><div style="float : right; margin-right: 10px"><br><button type="button" class="btn btn-primary" ng-click="refresh(0)">Ricarica</button></div><div class="form-group col-md-3 push-right" style="float : right"><label>Anno</label><select name="anno" ng-model="prodPieDate.year" id="inputCoe" class="form-control"><option ng-repeat="y in years" ng-value="y">{{y}}</option></select></div><div class="form-group col-md-3" style="float : right"><label>Mese</label><select name="anno" ng-model="prodPieDate.month" id="inputCoe" class="form-control"><option ng-repeat="m in months" ng-value="m">{{m}}</option></select></div></div><br><div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="row"><div class="col-md-5 text-center"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="prod-pie" width="280" height="280"></canvas><div class="traffic-text">{{ prodChartStruct.total / 100 | currency : \'\u20AC\' }} <span>Totale fatturato</span></div></div></div></div><div class="col-md-7 pie-legend"><div ng-if="!loadingProd"><div class="channels-info-item" ng-repeat="label in prodChartStruct.labels" ng-init="i = $index; data = prodChartStruct.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}} <span class="channel-number"><span style="color: black; font-weight: bold">{{data.data[i] | currency: \'\u20AC\'}}</span> - <span>{{data.percentage[i]}}%</span></span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" ng-style="{\'width\': \'\'+data.percentage[i]+ \'%\'}"></div></div><br><button ng-click="collapseExpandPie(0)" ng-show="i == data.data.length -1 && prodDataLenght>maxRowsCollapse" class="btn btn-info btn-sm pull-right">{{(prodCollapsed ? \'Vedi tutto\' : \'Comprimi\')}}</button><br></div></div></div></div></div></div><button class="collapsible">Tipi Mese/Anno</button><div class="dashcontent"><div class="row spinner-cont" ng-if="loadingType"><span class="spinner"></span></div><div class="row" ng-if="!loadingType"><div style="float : right; margin-right: 10px"><br><button type="button" class="btn btn-primary" ng-click="refresh(1)">Ricarica</button></div><div class="form-group col-md-3 push-right" style="float : right"><label>Anno</label><select name="anno" ng-model="typePieDate.year" id="inputCoe" class="form-control"><option ng-repeat="y in years" ng-value="y">{{y}}</option></select></div><div class="form-group col-md-3" style="float : right"><label>Mese</label><select name="anno" ng-model="typePieDate.month" id="inputCoe" class="form-control"><option ng-repeat="m in months" ng-value="m">{{m}}</option></select></div></div><br><div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="row"><div class="col-md-6"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="type-pie" width="280" height="280"></canvas><div class="traffic-text">{{ typeChartStruct.total / 100 | currency : \'\u20AC\' }} <span>Totale fatturato</span></div></div></div></div><div class="col-md-6 pie-legend"><div ng-if="!loadingType"><div><div class="channels-info-item" ng-repeat="label in typeChartStruct.labels" ng-init="i = $index; data = typeChartStruct.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number"><span style="color: black; font-weight: bold">{{data.data[i] | currency: \'\u20AC\'}}</span> - <span>{{data.percentage[i]}}%</span></span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" ng-style="{\'width\': \'\'+data.percentage[i]+ \'%\'}"></div></div><button ng-click="collapseExpandPie(1)" ng-show="i == data.data.length -1 && typeDataLenght>maxRowsCollapse" class="btn btn-info btn-sm pull-right">{{(typeCollapsed ? \'Vedi tutto\' : \'Comprimi\')}}</button><br></div></div></div></div></div></div></div><button id="typePie" class="collapsible">Fatturato / Unit\xE0</button><div class="dashcontent"><div class="row"><div class="form-group col-md-7"><div class="form-group"><label for="location">Prodotto</label><angucomplete-alt id="ex2" placeholder="{{selected.product.name}}" pause="300" selected-object="loadProductBar" local-data="allProducts" search-fields="searchfield" title-field="searchfield" minlength="1" input-class="form-control form-control-small" match-class="highlight"></angucomplete-alt></div></div></div><canvas width="1000" height="600" id="product-bar"></canvas></div><button class="collapsible">Fatturato / Tipo</button><div class="dashcontent"><canvas width="1000" height="600" id="type-bar"></canvas></div><button class="collapsible">Pi\xF9 venduti</button><div class="dashcontent"><div class="row"><div class="col-xs-3"><label>Data inizio</label><div class="input-group"><input type="text" date2str="" forcetime="down" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="sellersDates.from" is-open="popUpDate1" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate1 = !popUpDate1"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3"><label>Data fine</label><div class="input-group"><input type="text" date2str="" forcetime="up" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="sellersDates.to" is-open="popUpDate2" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate2 = !popUpDate2"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3"><button class="btn btn-primary" ng-click="onSellersDatesUpdate()" style="margin-top: 20px">Ricarica</button></div></div><amway-pagination-server-side page-size="topsellTablePageSize" elements="bestSeller"></amway-pagination-server-side><div class="row spinner-cont" ng-if="loadingtable"><span class="spinner"></span></div><table class="table" st-table="bestSeller" st-pipe="getSellersData"><thead><tr class="sortable"><th class="table-id" st-sort="pid">#</th><th st-sort="name">Nome</th><th st-sort="sku">SKU</th><th st-sort="qty">Quantit\xE0</th><th st-sort="revenue">Fatturato</th></tr><tr><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in bestSeller"><td class="table-id"><a target="_blank" href="/#!/modifica-prodotto/{{item.pid}}">{{item.pid}}</a></td><td>{{item.name}}</td><td>{{item.sku}}</td><td>{{item.qty}}</td><td>{{item.revenue / 100 | currency : "\u20AC"}}</td></tr></tbody><tr></tr><tr><td class="text-center" st-pagination="" st-items-by-page="topsellTablePageSize" colspan="9" st-template="app/utils/pagination/pagination.template.html"></td></tr></table></div><br><br><br><br><br><br><br>');
$templateCache.put('app/pages/dashboards/utenti/dashboardUtenti.html','<div class="row spinner-cont" ng-if="loadingProd"><span class="spinner"></span></div><div class="row" ng-if="!loadingProd"><div class="col-xs-3"><label>Data inizio</label><div class="input-group"><input type="text" date2str="" forcetime="down" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="heatmapRange.start" is-open="popUpDate1" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate1 = !popUpDate1"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3"><label>Data fine</label><div class="input-group"><input type="text" date2str="" forcetime="up" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="heatmapRange.stop" is-open="popUpDate2" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate2 = !popUpDate2"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div style="margin-top: 5px"><br><button type="button" class="btn btn-primary" ng-click="refreshHeatmaps()">Ricarica</button></div></div><div><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Distribuzione" ng-click="refreshBounds(0)"><div><div id="userMap" style="width:100%; height : 700px"></div></div></uib-tab><uib-tab heading="Fatturato" ng-click="refreshBounds(1)"><div><div id="revenueMap" style="width:100%; height : 700px"></div></div></uib-tab></uib-tabset></div></div>');
$templateCache.put('app/pages/dashboard/blurFeed/blurFeed.html','<div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message" ng-repeat="message in feed" ng-click="expandMessage(message)"><div class="message-icon" ng-if="message.type == \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"></div><div class="message-icon" ng-if="message.type != \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"> <span class="sub-photo-icon" ng-class="::message.type"></span></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::message.author }} {{ ::message.surname}}</span></div><div class="message-content line-clamp" ng-class="{\'line-clamp-2\' : !message.expanded}"><span ng-if="message.preview">{{message.header}}</span>{{::message.text}}</div><div class="preview" ng-show="message.expanded" ng-if="message.preview"><a href="{{::message.link}}" target="_blank"><img ng-src="{{ ::( message.preview | appImage )}}"></a></div><div ng-show="message.expanded" class="message-time"><div class="post-time">{{::message.time}}</div><div class="ago-time">{{::message.ago}}</div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardCalendar/dashboardCalendar.html','<div id="calendar" class="blurCalendar"></div>');
$templateCache.put('app/pages/dashboard/dashboardMap/dashboardMap.html','<div id="amChartMap"></div>');
$templateCache.put('app/pages/dashboard/dashboardTodo/dashboardTodo.html','<div class="task-todo-container" ng-class="{\'transparent\': transparent}"><input type="text" value="" class="form-control task-todo" placeholder="Task to do.." ng-keyup="addToDoItem($event)" ng-model="newTodoText"> <i ng-click="addToDoItem(\'\',true)" class="add-item-icon ion-plus-round"></i><div class="box-shadow-border"></div><ul class="todo-list" ui-sortable="" ng-model="todoList"><li ng-repeat="item in todoList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false"><div class="blur-container"><div class="blur-box"></div></div><i class="mark" style="background-color: {{::item.color}}"></i> <label class="todo-checkbox custom-checkbox custom-input-success"><input type="checkbox" ng-model="isChecked"> <span class="cut-with-dots">{{ item.text }}</span></label> <i class="remove-todo ion-ios-close-empty" ng-click="item.deleted = true"></i></li></ul></div>');
$templateCache.put('app/pages/dashboard/dashboardPieChart/dashboardPieChart.html','<div class="row pie-charts"><div class="pie-chart-item-container" ng-repeat="chart in charts"><div ba-panel=""><div class="pie-chart-item"><div class="chart" rel="{{ ::chart.color }}" data-percent="60"><span class="percent"></span></div><div class="description"><div>{{ ::chart.description }}</div><div class="description-stats">{{ ::chart.stats }}</div></div><i class="chart-icon i-{{ ::chart.icon }}"></i></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardLineChart/dashboardLineChart.html','<div id="amchart"></div>');
$templateCache.put('app/pages/dashboard/popularApp/popularApp.html','<div class="popular-app-img-container"><div class="popular-app-img"><img ng-src="{{::( \'app/my-app-logo.png\' | appImage )}}"> <span class="logo-text">Super&nbspApp</span></div></div><div class="popular-app-cost row"><div class="col-xs-9">Most Popular App</div><div class="col-xs-3 text-right">175$</div></div><div class="popular-app-info row"><div class="col-xs-4 text-left"><div class="info-label">Total Visits</div><div>47,512</div></div><div class="col-xs-4 text-center"><div class="info-label">New Visits</div><div>9,217</div></div><div class="col-xs-4 text-right"><div class="info-label">Sales</div><div>2,928</div></div></div>');
$templateCache.put('app/pages/dashboard/trafficChart/trafficChart.html','<div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="chart-area" width="280" height="280"></canvas><div class="traffic-text">1,900,128 <span>Views Total</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in doughnutData.labels" ng-init="i = $index; data = doughnutData.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">+{{data.percentage[i]}}%</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width: {{item.percentage}}%"></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/weather/weather.html','<div class="weather-wrapper"><div class="weather-main-info"><h5 class="city-date font-x1dot5"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class="weather-description font-x1dot5"><i class="font-x3 {{weatherIcons[weather.days[weather.current].icon]}}"></i><div class="weather-info">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class="weather-temp font-x1dot5"><i class="font-x2 ion-thermometer"></i><div class="weather-info" ng-switch="" on="units"><span ng-switch-when="metric">{{weather.days[weather.current].temp}} \xB0C | <a ng-click="switchUnits(\'imperial\')" href="">\xB0F</a></span> <span ng-switch-when="imperial">{{weather.days[weather.current].temp}} \xB0F | <a ng-click="switchUnits(\'metric\')" href="">\xB0C</a></span></div></div></div><div id="tempChart" class="temp-by-time"></div><div class="select-day"><div class="day" ng-repeat="day in weather.days" ng-click="switchDay($index)"><div><span class="font-x1dot25">{{day.temp}}</span></div><div><i class="weatherIcon font-x2 {{weatherIcons[day.icon]}}"></i> <span class="select-day-info">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>');
$templateCache.put('app/pages/faq/list/faq-list.html','<a class="btn btn-primary" href="#!/new-edit-faq/">Crea Faq</a><br><amway-pagination-size page-size="faqTablePageSize" elements="faqs"></amway-pagination-size><div class="horizontal-scroll"><div ng-show="false" class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control show-tick" title="Rows on page" selectpicker="" ng-model="faqTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedItems" st-safe-src="faqs"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="mtype">Tipo</th><th st-sort="question">Domanda</th><th st-sort="answer">Risposta</th><th>Azioni</th></tr><tr><th></th><th><select class="form-control" st-search="mtype" placeholder="Cerca tipo" type="search"><option></option><option ng-repeat="item in types" ng-value="item">{{item}}</option></select></th><th><input st-search="question" placeholder="Cerca domanda" class="input-sm form-control search-input" type="search"></th><th><input st-search="answer" placeholder="Cerca risposta" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in displayedItems"><td class="table-id">{{item.id}}</td><td>{{item.mtype}}</td><td><div class="cut-text">{{item.question}}</div></td><td><div class="cut-text">{{item.answer}}</div></td><td><a class="btn btn-primary btn-xs" href="#!/new-edit-faq/{{item.id}}">Modifica</a></td><td><button class="btn btn-danger btn-xs" ng-click="delete(item)">Elimina</button></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="faqTablePageSize" st-displayed-pages="" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/faq/new-edit/new-edit-faq.html','<h3>{{(faq.id) ? \'Modifica\' : \'Nuova\'}}</h3><hr><form ng-submit="submit()"><div class="row"><div class="col-sm-4"><div class="form-group"><label for="sort">Tipo</label><select class="form-control" ng-model="faq.mtype"><option ng-repeat="item in types" ng-value="item.ftype">{{item.ftype}}</option></select></div></div><div class="col-sm-12"><div class="form-group"><label for="fname">Domanda</label> <input required="" ng-model="faq.question" type="text" class="form-control" id="question" placeholder="Domanda"></div></div><div class="col-sm-12"><div class="form-group"><label for="answer">Risposta</label> <textarea required="" ng-model="faq.answer" class="form-control" id="answer" placeholder="Risposta"></textarea></div></div><button class="btn btn-primary pull-right">Salva</button></div></form>');
$templateCache.put('app/pages/faqtype/faqtype-list/faqtype-list.html','<button class="btn btn-primary" ng-click="neweditFaqtype()">Crea tipo FAQ</button><br><amway-pagination-size page-size="faqspagesize" elements="types"></amway-pagination-size><div class="horizontal-scroll"><div ng-show="false" class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control show-tick" title="Rows on page" selectpicker="" ng-model="faqspagesize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedItems" st-safe-src="types"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="ftype">Nome</th><th st-sort="sort">Ordinamento</th><th>Azioni</th></tr><tr><th></th><th><input st-search="ftype" placeholder="Cerca per nome" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in displayedItems"><td class="table-id">{{item.id}}</td><td>{{item.ftype}}</td><td>{{item.sort}}</td><td><button class="btn btn-primary btn-xs" ng-click="neweditFaqtype(item)">Modifica</button> <button class="btn btn-danger btn-xs" ng-click="delete(item)">Elimina</button></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="faqspagesize" st-displayed-pages="10" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/faqtype/faqtype-newedit-modal/faqtype-newedit-modal.html','<div class="modal-header"><h2 class="modal-title" id="modal-title">{{(!faqtype.id)?\'Nuovo\':\'Modifica\'}} tipo Faq</h2></div><div class="modal-body" id="modal-body"><form ng-submit="submit()"><div class="row"><div class="form-group col-md-6"><label>Nome</label> <input type="text" class="form-control" ng-model="faqtype.ftype" required=""></div><div class="form-group col-md-6"><label>Sort</label> <input type="number" class="form-control" ng-model="faqtype.sort" required=""></div></div><hr><div class="modal-footer"><button class="btn btn-primary pull-right">Salva</button></div></form></div>');
$templateCache.put('app/pages/venue/list/venueList.html','<a class="btn btn-primary" href="#!/nuova-sede">Crea Sede</a><amway-pagination-size page-size="venueTablePageSize" elements="venues"></amway-pagination-size><div class="horizontal-scroll"><div ng-show="false" class="form-group select-page-size-wrap"></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedVenues" st-safe-src="venues"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Nome</th><th>Citt\xE0</th><th>Comune</th><th>Provincia</th><th>Telefono</th></tr><tr><th></th><th></th><th><input st-search="name" placeholder="Cerca per nome" class="input-sm form-control search-input" type="search"></th><th></th><th ng-show="false"></th></tr></thead><tbody><tr ng-repeat="item in displayedVenues"><td><b>{{item.id}}</b></td><td><b>{{item.name}}</b></td><td><b>{{item.city}}</b></td><td><b>{{item.comune}}</b></td><td><b>{{item.province}}</b></td><td><b>{{item.phone}}</b></td><td><a class="btn btn-primary btn-xs" href="#!/modifica-sede/{{item.id}}">Modifica</a> <a class="btn btn-danger btn-xs" ng-click="delete(item.id)">Elimina</a></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="venueTablePageSize" st-displayed-pages="5" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/venue/new-edit/venue-form.html','<div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dati Generali"><form ng-submit="salva()"><div class="row"><div class="col-sm-4"><div class="form-group"><label for="fname">Nome</label> <input required="" ng-model="venue.name" type="text" class="form-control" id="fname" placeholder="Nome"></div></div><div class="col-sm-4"><div class="form-group"><label for="lname">Indirizzo</label> <input ng-model="venue.address" type="text" class="form-control" id="lname" placeholder="Indirizzo"></div></div><div class="col-sm-4"><div class="form-group"><label for="lname">Numero civico</label> <input ng-model="venue.streetnum" type="text" class="form-control" id="lname" placeholder="Numero civico"></div></div><div class="col-sm-4"><div class="form-group"><label for="province">Provincia</label><ui-select ng-model="venue.selectedProvince" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="{{(venue.province)?venue.province:\'Provincia\'}}"><span>{{$select.selected.descrizione}}</span></ui-select-match><ui-select-choices repeat="p in province | filter: $select.search"><span ng-bind-html="p.descrizione"></span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group"><label for="city">Comune</label><ui-select ng-model="venue.selectedCity" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-disabled="!comuni.length"><ui-select-match placeholder="{{(venue.city)?venue.city:\'Comune\'}}"><span>{{$select.selected.descrizione}}</span></ui-select-match><ui-select-choices repeat="c in comuni | filter: $select.search"><span ng-bind-html="c.descrizione"></span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group"><label for="lname">CAP</label> <input ng-model="venue.zipcode" type="text" class="form-control" id="lname" placeholder="CAP"></div></div><div class="col-sm-4"><div class="form-group"><label for="lname">Latitudine</label> <input ng-model="venue.lat" type="text" class="form-control" id="lname" placeholder="Latitudine"></div></div><div class="col-sm-4"><div class="form-group"><label for="lname">Longitudine</label> <input ng-model="venue.lng" type="text" class="form-control" id="lname" placeholder="Longitudine"></div></div><div class="col-sm-4"><div class="form-group"><label for="lname">Telefono</label> <input ng-model="venue.phone" type="text" class="form-control" id="lname" placeholder="Telefono"></div></div><div class="col-sm-4"><div class="form-group"><label for="lname">Sito web</label> <input ng-model="venue.web" type="text" class="form-control" id="lname" placeholder="Telefono"></div></div><div class="col-sm-12"><div class="form-group"><label for="abstract">Descrizione</label> <textarea ng-model="venue.descr" type="text" class="form-control" id="abstract" placeholder="Descrizione">\n                            </textarea></div></div></div><button ng-disabled="utente.passwordC!=utente.ripetiPassword" class="btn btn-default" type="submit">Salva</button></form></uib-tab><uib-tab disable="!venue.id" heading="Distribuzione" ng-click="fitBounds()"><div class="row spinner-cont" ng-if="loadingProd"><span class="spinner"></span></div><div class="row" ng-if="!loadingProd"><div class="col-xs-3"><label>Emissione ticket dal</label><div class="input-group"><input type="text" date2str="" forcetime="down" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="heatmapRange.start" is-open="popUpDate1" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate1 = !popUpDate1"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3"><label>Emissione ticket al</label><div class="input-group"><input type="text" date2str="" forcetime="up" model-view-value="true" ui-mask="99/99/9999" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="heatmapRange.stop" is-open="popUpDate2" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="popUpDate2 = !popUpDate2"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div style="margin-top: 5px"><br><button type="button" class="btn btn-primary" ng-click="refreshHeatmap()">Ricarica</button></div></div><div id="map" style="width:100%; height : 700px"></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/videotaxonomy/videotaxonomy-list/videotaxonomy-list.html','<button class="btn btn-primary" ng-click="neweditvideotaxonomy()">Crea categoria video</button><br><amway-pagination-size page-size="videotaxonomypagesize" elements="videotaxonomies"></amway-pagination-size><div class="horizontal-scroll"><div ng-show="false" class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control show-tick" title="Rows on page" selectpicker="" ng-model="videotaxonomypagesize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><div class="row spinner-cont" ng-if="loading"><span class="spinner"></span></div><table class="table" ng-if="!loading" st-table="displayedItems" st-safe-src="videotaxonomies"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="taxonomy">Nome</th><th st-sort="sort">Ordinamento</th><th>Azioni</th></tr><tr><th></th><th><input st-search="taxonomy" placeholder="Cerca per nome" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in displayedItems"><td class="table-id">{{item.id}}</td><td>{{item.taxonomy}}</td><td>{{item.sort}}</td><td><button class="btn btn-primary btn-xs" ng-click="neweditvideotaxonomy(item)">Modifica</button> <button class="btn btn-danger btn-xs" ng-click="delete(item)">Elimina</button></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="videotaxonomypagesize" st-displayed-pages="10" st-template="app/utils/pagination/pagination.template.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/videotaxonomy/videotaxonomy-newedit-modal/videotaxonomy-newedit-modal.html','<div class="modal-header"><h2 class="modal-title" id="modal-title">{{(!videotaxonomy.id)?\'Nuova\':\'Modifica\'}} categoria video</h2></div><div class="modal-body" id="modal-body"><form ng-submit="submit()"><div class="row"><div class="form-group col-md-6"><label>Nome</label> <input type="text" class="form-control" ng-model="videotaxonomy.taxonomy" required=""></div><div class="form-group col-md-6"><label>Sort</label> <input type="number" class="form-control" ng-model="videotaxonomy.sort" required=""></div></div><hr><div class="modal-footer"><button class="btn btn-primary pull-right">Salva</button></div></form></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul ng-show="false" class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix"><span>NTS</span>Admin</a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="search"><i class="ion-ios-search-strong" ng-click="startSearch()"></i> <input id="searchInput" type="text" placeholder="Search for..."></div><div class="user-profile clearfix"><h2 ng-if="dev" style="display: inline;"><span class="label label-danger" style="padding:10px 5px 5px 5px;border-radius:5px;">VERSIONE DEV</span></h2><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><div class="kameleon-icon with-round-bg white"><img ng-src="{{:: (\'Hacker\' | kameleonImg )}}"></div></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a href="#/profile"><i class="fa fa-user"></i>Profile</a></li><li><a href=""><i class="fa fa-cog"></i>Settings</a></li><li><a href="http://network21.it">Shop</a></li><li><a ui-sref="logout" class="signout"><i class="fa fa-power-off"></i>Sign out</a></li></ul></div><msg-center></msg-center></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');}]);